/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, callbacks = [];
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId])
/******/ 				callbacks.push.apply(callbacks, installedChunks[chunkId]);
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			var _m = moreModules[moduleId];
/******/
/******/ 			// Check if module is deduplicated
/******/ 			switch(typeof _m) {
/******/ 			case "object":
/******/ 				// Module can be created from a template
/******/ 				modules[moduleId] = (function(_m) {
/******/ 					var args = _m.slice(1), templateId = _m[0];
/******/ 					return function (a,b,c) {
/******/ 						modules[templateId].apply(this, [a,b,c].concat(args));
/******/ 					};
/******/ 				}(_m));
/******/ 				break;
/******/ 			case "function":
/******/ 				// Normal module
/******/ 				modules[moduleId] = _m;
/******/ 				break;
/******/ 			default:
/******/ 				// Module is a copy of another module
/******/ 				modules[moduleId] = modules[_m];
/******/ 				break;
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules);
/******/ 		while(callbacks.length)
/******/ 			callbacks.shift().call(null, __webpack_require__);
/******/ 		if(moreModules[0]) {
/******/ 			installedModules[0] = 0;
/******/ 			return __webpack_require__(0);
/******/ 		}
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// object to store loaded and loading chunks
/******/ 	// "0" means "already loaded"
/******/ 	// Array means "loading", array contains callbacks
/******/ 	var installedChunks = {
/******/ 		46:0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId, callback) {
/******/ 		// "0" is the signal for "already loaded"
/******/ 		if(installedChunks[chunkId] === 0)
/******/ 			return callback.call(null, __webpack_require__);
/******/
/******/ 		// an array means "currently loading".
/******/ 		if(installedChunks[chunkId] !== undefined) {
/******/ 			installedChunks[chunkId].push(callback);
/******/ 		} else {
/******/ 			// start chunk loading
/******/ 			installedChunks[chunkId] = [callback];
/******/ 			var head = document.getElementsByTagName('head')[0];
/******/ 			var script = document.createElement('script');
/******/ 			script.type = 'text/javascript';
/******/ 			script.charset = 'utf-8';
/******/ 			script.async = true;
/******/
/******/ 			script.src = __webpack_require__.p + "" + chunkId + "." + ({"12":"apps/bookings/admin","13":"apps/bookings/checkout/details","14":"apps/bookings/checkout/membership","15":"apps/bookings/checkout/payment","16":"apps/bookings/checkout/summary","17":"apps/bookings/prestay/arrival","18":"apps/bookings/prestay/departure","19":"apps/bookings/prestay/details","20":"apps/bookings/prestay/guests","21":"apps/bookings/prestay/stay-details","22":"apps/core","23":"apps/corporate/contact-us","24":"apps/corporate/team","25":"apps/folios/detail","26":"apps/geo/area","27":"apps/geo/region","28":"apps/homepage","29":"apps/homes/admin/media","30":"apps/homes/detail","31":"apps/jobs/overview","32":"apps/legacy/property/availability","33":"apps/legacy/property/default","34":"apps/legacy/property/local-area","35":"apps/legacy/property/rooms","36":"apps/legacy/property/summary","37":"apps/misc/international","38":"apps/misc/partners","39":"apps/onboarding/introduction","40":"apps/onboarding/questionnaire","41":"apps/onboarding/thank_you","42":"apps/search/list","43":"apps/search/map","44":"apps/styleguide"}[chunkId]||chunkId) + ".js";
/******/ 			head.appendChild(script);
/******/ 		}
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */,
/* 1 */
/***/ function(module, exports) {

	"use strict";
	
	exports["default"] = function (obj) {
	  return obj && obj.__esModule ? obj : {
	    "default": obj
	  };
	};
	
	exports.__esModule = true;

/***/ },
/* 2 */,
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _Object$getOwnPropertyDescriptor = __webpack_require__(4)["default"];
	
	exports["default"] = function get(_x, _x2, _x3) {
	  var _again = true;
	
	  _function: while (_again) {
	    var object = _x,
	        property = _x2,
	        receiver = _x3;
	    desc = parent = getter = undefined;
	    _again = false;
	    if (object === null) object = Function.prototype;
	
	    var desc = _Object$getOwnPropertyDescriptor(object, property);
	
	    if (desc === undefined) {
	      var parent = Object.getPrototypeOf(object);
	
	      if (parent === null) {
	        return undefined;
	      } else {
	        _x = parent;
	        _x2 = property;
	        _x3 = receiver;
	        _again = true;
	        continue _function;
	      }
	    } else if ("value" in desc) {
	      return desc.value;
	    } else {
	      var getter = desc.get;
	
	      if (getter === undefined) {
	        return undefined;
	      }
	
	      return getter.call(receiver);
	    }
	  }
	};
	
	exports.__esModule = true;

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(5), __esModule: true };

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(6);
	__webpack_require__(7);
	module.exports = function getOwnPropertyDescriptor(it, key){
	  return $.getDesc(it, key);
	};

/***/ },
/* 6 */
/***/ function(module, exports) {

	var $Object = Object;
	module.exports = {
	  create:     $Object.create,
	  getProto:   $Object.getPrototypeOf,
	  isEnum:     {}.propertyIsEnumerable,
	  getDesc:    $Object.getOwnPropertyDescriptor,
	  setDesc:    $Object.defineProperty,
	  setDescs:   $Object.defineProperties,
	  getKeys:    $Object.keys,
	  getNames:   $Object.getOwnPropertyNames,
	  getSymbols: $Object.getOwnPropertySymbols,
	  each:       [].forEach
	};

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject = __webpack_require__(8);
	
	__webpack_require__(12)('getOwnPropertyDescriptor', function($getOwnPropertyDescriptor){
	  return function getOwnPropertyDescriptor(it, key){
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(9)
	  , defined = __webpack_require__(11);
	module.exports = function(it){
	  return IObject(defined(it));
	};

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	// indexed object, fallback for non-array-like ES3 strings
	var cof = __webpack_require__(10);
	module.exports = 0 in Object('z') ? Object : function(it){
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};

/***/ },
/* 10 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function(it){
	  return toString.call(it).slice(8, -1);
	};

/***/ },
/* 11 */
/***/ function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function(it){
	  if(it == undefined)throw TypeError("Can't call method on  " + it);
	  return it;
	};

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	module.exports = function(KEY, exec){
	  var $def = __webpack_require__(13)
	    , fn   = (__webpack_require__(15).Object || {})[KEY] || Object[KEY]
	    , exp  = {};
	  exp[KEY] = exec(fn);
	  $def($def.S + $def.F * __webpack_require__(16)(function(){ fn(1); }), 'Object', exp);
	};

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(14)
	  , core      = __webpack_require__(15)
	  , PROTOTYPE = 'prototype';
	var ctx = function(fn, that){
	  return function(){
	    return fn.apply(that, arguments);
	  };
	};
	var $def = function(type, name, source){
	  var key, own, out, exp
	    , isGlobal = type & $def.G
	    , isProto  = type & $def.P
	    , target   = isGlobal ? global : type & $def.S
	        ? global[name] : (global[name] || {})[PROTOTYPE]
	    , exports  = isGlobal ? core : core[name] || (core[name] = {});
	  if(isGlobal)source = name;
	  for(key in source){
	    // contains in native
	    own = !(type & $def.F) && target && key in target;
	    if(own && key in exports)continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    if(isGlobal && typeof target[key] != 'function')exp = source[key];
	    // bind timers to global for call from export context
	    else if(type & $def.B && own)exp = ctx(out, global);
	    // wrap global constructors for prevent change them in library
	    else if(type & $def.W && target[key] == out)!function(C){
	      exp = function(param){
	        return this instanceof C ? new C(param) : C(param);
	      };
	      exp[PROTOTYPE] = C[PROTOTYPE];
	    }(out);
	    else exp = isProto && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export
	    exports[key] = exp;
	    if(isProto)(exports[PROTOTYPE] || (exports[PROTOTYPE] = {}))[key] = out;
	  }
	};
	// type bitmap
	$def.F = 1;  // forced
	$def.G = 2;  // global
	$def.S = 4;  // static
	$def.P = 8;  // proto
	$def.B = 16; // bind
	$def.W = 32; // wrap
	module.exports = $def;

/***/ },
/* 14 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var UNDEFINED = 'undefined';
	var global = module.exports = typeof window != UNDEFINED && window.Math == Math
	  ? window : typeof self != UNDEFINED && self.Math == Math ? self : Function('return this')();
	if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ },
/* 15 */
/***/ function(module, exports) {

	var core = module.exports = {version: '1.2.0'};
	if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ },
/* 16 */
/***/ function(module, exports) {

	module.exports = function(exec){
	  try {
	    return !!exec();
	  } catch(e){
	    return true;
	  }
	};

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _Object$create = __webpack_require__(18)["default"];
	
	var _Object$setPrototypeOf = __webpack_require__(20)["default"];
	
	exports["default"] = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = _Object$create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _Object$setPrototypeOf ? _Object$setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	exports.__esModule = true;

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(19), __esModule: true };

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(6);
	module.exports = function create(P, D){
	  return $.create(P, D);
	};

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(21), __esModule: true };

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(22);
	module.exports = __webpack_require__(15).Object.setPrototypeOf;

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $def = __webpack_require__(13);
	$def($def.S, 'Object', {setPrototypeOf: __webpack_require__(23).set});

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var getDesc  = __webpack_require__(6).getDesc
	  , isObject = __webpack_require__(24)
	  , anObject = __webpack_require__(25);
	var check = function(O, proto){
	  anObject(O);
	  if(!isObject(proto) && proto !== null)throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line no-proto
	    function(test, buggy, set){
	      try {
	        set = __webpack_require__(26)(Function.call, getDesc(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch(e){ buggy = true; }
	      return function setPrototypeOf(O, proto){
	        check(O, proto);
	        if(buggy)O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};

/***/ },
/* 24 */
/***/ function(module, exports) {

	module.exports = function(it){
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(24);
	module.exports = function(it){
	  if(!isObject(it))throw TypeError(it + ' is not an object!');
	  return it;
	};

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(27);
	module.exports = function(fn, that, length){
	  aFunction(fn);
	  if(that === undefined)return fn;
	  switch(length){
	    case 1: return function(a){
	      return fn.call(that, a);
	    };
	    case 2: return function(a, b){
	      return fn.call(that, a, b);
	    };
	    case 3: return function(a, b, c){
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function(/* ...args */){
	    return fn.apply(that, arguments);
	  };
	};

/***/ },
/* 27 */
/***/ function(module, exports) {

	module.exports = function(it){
	  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
	  return it;
	};

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _Object$defineProperty = __webpack_require__(29)["default"];
	
	exports["default"] = (function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	
	      _Object$defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	})();
	
	exports.__esModule = true;

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(30), __esModule: true };

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(6);
	module.exports = function defineProperty(it, key, desc){
	  return $.setDesc(it, key, desc);
	};

/***/ },
/* 31 */
/***/ function(module, exports) {

	"use strict";
	
	exports["default"] = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	exports.__esModule = true;

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(33), __esModule: true };

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(34);
	module.exports = __webpack_require__(15).Object.assign;

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $def = __webpack_require__(13);
	
	$def($def.S + $def.F, 'Object', {assign: __webpack_require__(35)});

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.1 Object.assign(target, source, ...)
	var toObject = __webpack_require__(36)
	  , IObject  = __webpack_require__(9)
	  , enumKeys = __webpack_require__(37)
	  , has      = __webpack_require__(38);
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = __webpack_require__(16)(function(){
	  var a = Object.assign
	    , A = {}
	    , B = {}
	    , S = Symbol()
	    , K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function(k){ B[k] = k; });
	  return a({}, A)[S] != 7 || Object.keys(a({}, B)).join('') != K;
	}) ? function assign(target, source){   // eslint-disable-line no-unused-vars
	  var T = toObject(target)
	    , l = arguments.length
	    , i = 1;
	  while(l > i){
	    var S      = IObject(arguments[i++])
	      , keys   = enumKeys(S)
	      , length = keys.length
	      , j      = 0
	      , key;
	    while(length > j)if(has(S, key = keys[j++]))T[key] = S[key];
	  }
	  return T;
	} : Object.assign;

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(11);
	module.exports = function(it){
	  return Object(defined(it));
	};

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var $ = __webpack_require__(6);
	module.exports = function(it){
	  var keys       = $.getKeys(it)
	    , getSymbols = $.getSymbols;
	  if(getSymbols){
	    var symbols = getSymbols(it)
	      , isEnum  = $.isEnum
	      , i       = 0
	      , key;
	    while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))keys.push(key);
	  }
	  return keys;
	};

/***/ },
/* 38 */
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function(it, key){
	  return hasOwnProperty.call(it, key);
	};

/***/ },
/* 39 */
/***/ function(module, exports) {

	module.exports = jQuery;

/***/ },
/* 40 */
/***/ function(module, exports) {

	module.exports = React;

/***/ },
/* 41 */,
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(43), __esModule: true };

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(44);
	module.exports = __webpack_require__(15).Object.freeze;

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.5 Object.freeze(O)
	var isObject = __webpack_require__(24);
	
	__webpack_require__(12)('freeze', function($freeze){
	  return function freeze(it){
	    return $freeze && isObject(it) ? $freeze(it) : it;
	  };
	});

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	/* global Pikaday */
	"use strict";
	
	var _ofsAppsCoreUtilsTrackingOptimizely = __webpack_require__(46);
	
	var _ofsComponentsSimpleChoiceSimpleChoice = __webpack_require__(47);
	
	var moment = __webpack_require__(57);
	var $ = __webpack_require__(39);
	var _ = __webpack_require__(66);
	
	var React = __webpack_require__(40);
	
	var UnitContactForm = __webpack_require__(67);
	var GenericContactForm = __webpack_require__(311);
	var BookingContactForm = __webpack_require__(318);
	var SearchContactForm = __webpack_require__(321);
	var tracker = __webpack_require__(166);
	
	var pikadayI18n = __webpack_require__(324);
	
	var valueToBool = function valueToBool(value) {
	    if (_.isBoolean(value)) {
	        return value;
	    }
	    var boolMapper = {
	        'true': true,
	        'false': false,
	        'yes': true,
	        'no': false,
	        't': true,
	        'f': false,
	        'y': true,
	        'n': false,
	        '1': true,
	        '0': false
	    };
	    return boolMapper[value.toLowerCase()];
	};
	
	var simpleMapDefaults = {
	    latitude: undefined,
	    longitude: undefined,
	    zoom: 12,
	    hideControls: true
	};
	
	var initSimpleMap = function initSimpleMap($el, opts) {
	    var options = $.extend({}, simpleMapDefaults, opts);
	
	    var lat = options.latitude;
	    var lng = options.longitude;
	    var zoom = options.zoom;
	    var hideControls = valueToBool(options.hideControls);
	    var scrollWheel = typeof options.scrollWheel !== 'undefined' ? valueToBool(options.scrollWheel) : true;
	
	    var latlng = new google.maps.LatLng(lat, lng);
	
	    var map = new google.maps.Map($el[0], {
	        zoom: zoom,
	        center: latlng,
	        mapTypeId: google.maps.MapTypeId.ROADMAP,
	        disableDefaultUI: hideControls,
	        scrollwheel: scrollWheel
	    });
	
	    new google.maps.Marker({
	        position: latlng,
	        map: map
	    });
	
	    if (opts.polygon && _.isArray(opts.polygon)) {
	
	        var bounds = new google.maps.LatLngBounds();
	
	        var boundary = _.map(opts.polygon, function (coords) {
	            return new google.maps.LatLng(coords[0], coords[1]);
	        });
	
	        _.each(boundary, function (point) {
	            bounds.extend(point);
	        });
	
	        map.fitBounds(bounds);
	
	        var polygon = new google.maps.Polygon({
	            paths: boundary,
	            strokeColor: "#EC1748",
	            strokeOpacity: 0.75,
	            strokeWeight: 3,
	            fillColor: "#000",
	            fillOpacity: 0.125
	        });
	        polygon.setMap(map);
	    }
	};
	
	var initGoogleMap = function initGoogleMap($el, opts) {
	    var options = $.extend({}, simpleMapDefaults, opts);
	    var scaleFactor = 0.5;
	    var spriteWidth = 412;
	    var spriteHeight = 226;
	
	    var lat = options.latitude;
	    var lng = options.longitude;
	    var latlng = new google.maps.LatLng(lat, lng);
	    var zoom = options.zoom;
	    var hideControls = valueToBool(options.hideControls);
	    var useHomeMarker = valueToBool(options.useHomeMarker);
	
	    var mapCanvas = $el[0];
	
	    var mapOptions = {
	        center: latlng,
	        zoom: zoom,
	        mapTypeId: google.maps.MapTypeId.ROADMAP,
	        clickableLabels: false,
	        disableDefaultUI: hideControls,
	        styles: [{
	            featureType: 'poi',
	            elementType: 'labels',
	            stylers: [{
	                visibility: 'off'
	            }]
	        }]
	    };
	
	    var map = new google.maps.Map(mapCanvas, mapOptions);
	
	    var homeMarkerImage = '';
	    if (useHomeMarker) {
	        homeMarkerImage = new google.maps.MarkerImage(ofs['static']('images/maps/markers.png'), new google.maps.Size(52 * scaleFactor, 46 * scaleFactor), // desired size
	        new google.maps.Point(360 * scaleFactor, 0 * scaleFactor), // offset within the scaled sprite
	        null, new google.maps.Size(spriteWidth * scaleFactor, spriteHeight * scaleFactor) // scaled size of the entire sprite
	        );
	    }
	    new google.maps.Marker({
	        position: latlng,
	        map: map,
	        icon: homeMarkerImage
	    });
	};
	
	var pikaDayDefaults = {
	    format: 'DD MMMM YYYY',
	    fillWeeks: true,
	    firstDay: 1,
	    handle: true
	};
	
	var initPikaDay = function initPikaDay($el, opts) {
	    $el.wrap('<div class="datepicker-wrapper" />');
	
	    $el.attr('autocomplete', 'off');
	    $el.attr('readonly', 'true');
	    var icon = $el.after('<span class="icon-calendar"></span');
	
	    var options = $.extend({}, pikaDayDefaults, opts);
	    var minDate;
	
	    if (options.minDate) {
	        minDate = moment(options.minDate, options.format).toDate();
	    } else {
	        minDate = moment().toDate();
	    }
	
	    var picker = new Pikaday({
	        field: $el.get(0),
	        minDate: minDate,
	        icon: icon.get(0),
	        format: options.format,
	        fillWeeks: valueToBool(options.fillWeeks),
	        firstDay: options.firstDay,
	        handle: options.handle,
	        i18n: pikadayI18n
	    });
	    ofs.components.pikadayElements.push(picker);
	    $el.data('picker', picker);
	};
	
	var select2Defaults = {
	    allowClear: true,
	    minimumResultsForSearch: 11,
	    escape: false
	};
	
	var select2Formatters = {
	    region: {
	        result: function result(data) {
	            if (!data.id) {
	                return data.text; // optgroup
	            }
	
	            if (data.text.split(' ')[0] === '--') {
	                return '&nbsp;&nbsp;&nbsp;&nbsp;' + data.text.replace('-- ', '');
	            } else if (data.text.split(' ')[0] === '##') {
	                return '<span class="my-region-heading">' + data.text.replace('## ', '') + '</span>';
	            }
	        },
	        selection: function selection(data) {
	            if (!data.id) {
	                return data.text; // optgroup
	            }
	
	            if (data.text.split(' ')[0] === '--') {
	                return data.text.replace('-- ', '');
	            } else if (data.text.split(' ')[0] === '##') {
	                return data.text.replace('## ', '');
	            }
	        }
	    },
	    allRegions: {
	        result: function result(data) {
	            if (!data.id) {
	                return data.text; // optgroup
	            }
	
	            if (data.text.split(' ')[0] === '--') {
	                return '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' + data.text.replace('-- ', '');
	            } else if (data.text.split(' ')[0] === '##') {
	                return '<span class="my-region-heading">' + data.text.replace('## ', '&nbsp;&nbsp;&nbsp;&nbsp;') + '</span>';
	            } else if (data.text.split(' ')[0] === '$$') {
	                return '<span class="my-region-heading">' + data.text.replace('$$ ', '') + '</span>';
	            }
	        },
	        selection: function selection(data) {
	            if (!data.id) {
	                return data.text; // optgroup
	            }
	
	            if (data.text.split(' ')[0] === '--') {
	                return data.text.replace('-- ', '');
	            } else if (data.text.split(' ')[0] === '##') {
	                return data.text.replace('## ', '');
	            } else if (data.text.split(' ')[0] === '$$') {
	                return data.text.replace('$$ ', '');
	            }
	        }
	    },
	    sleeps: {
	        result: function result(data) {
	            return data.text;
	        },
	        selection: function selection(data) {
	            // <select> default value ("Bedrooms") has id = 0
	            if (data.id == '0') {
	                return data.text;
	            } else {
	                return data.text + '<span class="icon-inline icon-sleeps-nocircle"></span>';
	            }
	        }
	    },
	    bedrooms: {
	        result: function result(data) {
	            return data.text;
	        },
	        selection: function selection(data) {
	            // <select> default value ("Sleeps") has id = 0
	            if (data.id == '0') {
	                return data.text;
	            } else {
	                return data.text + '<span class="icon-inline icon-bedrooms-nocircle"></span>';
	            }
	        }
	    }
	};
	
	var escapeMarkup = function escapeMarkup(m) {
	    return m;
	};
	
	var initSelect2 = function initSelect2($el, opts) {
	    var options = $.extend({}, select2Defaults, opts);
	    $el.css({
	        'width': $el.outerWidth() + 'px'
	    });
	
	    var initOpts = {
	        allowClear: valueToBool(options.allowClear),
	        minimumResultsForSearch: parseInt(options.minimumResultsForSearch, 10)
	    };
	
	    if (valueToBool(options.escape)) {
	        initOpts.escapeMarkup = escapeMarkup;
	    }
	
	    if (options.formatter) {
	        var formatter = select2Formatters[opts.formatter];
	        if (formatter && formatter.result) {
	            initOpts.formatResult = formatter.result;
	        }
	        if (formatter && formatter.selection) {
	            initOpts.formatSelection = formatter.selection;
	        }
	    }
	
	    if (options.placeholder) {
	        initOpts.placeholder = options.placeholder;
	    }
	
	    $el.select2(initOpts);
	};
	
	var initLocationPicker = function initLocationPicker($el) {
	
	    var $lng = $el.find('[data-ofs-subcomponent=longitude]');
	    var $lat = $el.find('[data-ofs-subcomponent=latitude]');
	    var height = $el.height();
	
	    var lat = parseFloat($lat.val());
	    var lng = parseFloat($lng.val());
	    var location = null;
	
	    if (lat && lng) {
	        location = new google.maps.LatLng(lat, lng);
	    }
	
	    $lat.hide();
	    $lng.hide();
	
	    var $searchInput = $('<input type="search" />');
	    $searchInput.css('margin-bottom', '0');
	    $el.append($searchInput);
	
	    var $map = $('<div />');
	    $map.height(height - $searchInput.outerHeight());
	    $el.append($map);
	
	    var autocomplete = new google.maps.places.Autocomplete($searchInput.get(0));
	
	    var center, zoom;
	
	    if (location) {
	        center = location;
	        zoom = 13;
	    } else {
	        center = new google.maps.LatLng(0, 0);
	        zoom = 1;
	    }
	
	    var mapOptions = {
	        center: center,
	        zoom: zoom,
	        disableDefaultUI: true,
	        mapTypeId: google.maps.MapTypeId.ROADMAP
	    };
	    var map = new google.maps.Map($map.get(0), mapOptions);
	
	    autocomplete.setTypes(['geocode']);
	    autocomplete.bindTo('bounds', map);
	
	    var marker = new google.maps.Marker({
	        position: location,
	        map: map,
	        draggable: true
	    });
	
	    google.maps.event.addDomListener($searchInput.get(0), 'keydown', function (e) {
	        // Make sure we don't submit the form when selecting an auto-complete option
	        if (e.keyCode === 13) {
	            e.preventDefault();
	        }
	    });
	
	    var updatePosition = function updatePosition(position) {
	        $lng.val(position.lng().toString());
	        $lat.val(position.lat().toString());
	    };
	
	    google.maps.event.addListener(autocomplete, 'place_changed', function () {
	        var place = autocomplete.getPlace();
	
	        if (place.geometry) {
	            if (place.geometry.viewport) {
	                map.fitBounds(place.geometry.viewport);
	            } else {
	                map.setCenter(place.geometry.location);
	                map.setZoom(17);
	            }
	            marker.setPosition(place.geometry.location);
	            updatePosition(place.geometry.location);
	        }
	    });
	
	    google.maps.event.addListener(marker, 'drag', function (event) {
	        updatePosition(event.latLng);
	    });
	};
	
	var initPicture = function initPicture($el) {
	    if (!$el.data('defer')) {
	        var $spans = $el.find('span');
	        var matches = [];
	
	        $spans.each(function (index, elem) {
	            var $span = $(elem);
	            var media = $span.data('media');
	
	            if (!media || window.matchMedia && window.matchMedia(media).matches) {
	                matches.push($span);
	            }
	        });
	
	        // Find any existing img element in the picture element
	        var $img = $el.find('img').eq(0);
	
	        if (matches.length) {
	            var matchedEl = matches.pop();
	            if (!$img.length || $img.parent()[0].nodeName === 'NOSCRIPT') {
	                $img = $('<img />');
	                $img.attr('alt', $el.data('alt'));
	            }
	            $img.attr('src', matchedEl.data('src'));
	            if (matchedEl.data('width') && matchedEl.data('height')) {
	                $img.attr('width', matchedEl.data('width'));
	                $img.attr('height', matchedEl.data('height'));
	            }
	            matchedEl.append($img);
	        } else if ($img) {
	            $img.remove();
	        }
	    }
	};
	
	var initResponsive = function initResponsive($el, opts) {
	    var $children = $el.children();
	
	    $children.each(function (index, elem) {
	        var $child = $(elem);
	        var media = $child.data('media');
	
	        if (!media || window.matchMedia(media).matches) {
	            $child.find('[data-ofs-component]').data('defer', false);
	        } else {
	            $child.find('[data-ofs-component]').data('defer', true);
	            $child.hide();
	        }
	    });
	
	    $(window).on('resize', function () {
	        $children.each(function (index, elem) {
	            var $child = $(elem);
	
	            var media = $child.data('media');
	
	            if (!media || window.matchMedia(media).matches) {
	                $child.show();
	                $child.find('[data-ofs-component]').data('defer', false);
	                initComponents($child);
	            } else {
	                $child.hide();
	            }
	        });
	    });
	};
	
	var initEnquire = function initEnquire($el, opts) {
	    $el.off('click.enquire');
	    $el.on('click.enquire', function (event) {
	        event.preventDefault();
	        var source = $(event.currentTarget).data('ofs-source') || 'unknown';
	        (0, _ofsAppsCoreUtilsTrackingOptimizely.trackOptimizelyOpen)(source);
	        tracker.openEnquiry(source);
	        window.ofsFlux.actions.layers.addModal(React.createElement(GenericContactForm, { source: source }));
	    });
	};
	
	var initBookingEnquire = function initBookingEnquire($el, opts) {
	    $el.off('click.booking-enquire');
	    $el.on('click.booking-enquire', function (event) {
	        event.preventDefault();
	        var source = $(event.currentTarget).data('ofs-source') || 'unknown';
	        (0, _ofsAppsCoreUtilsTrackingOptimizely.trackOptimizelyOpen)(source);
	        tracker.openEnquiry(source);
	        window.ofsFlux.actions.layers.addModal(React.createElement(BookingContactForm, { source: source }));
	    });
	};
	
	var initSearchEnquire = function initSearchEnquire($el, opts) {
	    $el.off('click.search-enquire');
	    $el.on('click.search-enquire', function (event) {
	        event.preventDefault();
	        var source = $(event.currentTarget).data('ofs-source') || 'unknown';
	        (0, _ofsAppsCoreUtilsTrackingOptimizely.trackOptimizelyOpen)(source);
	        tracker.openEnquiry(source);
	        window.ofsFlux.actions.layers.addModal(React.createElement(SearchContactForm, { source: source }));
	    });
	};
	
	var initUnitEnquire = function initUnitEnquire($el, opts) {
	    $el.off('click.unit-enquire');
	    $el.on('click.unit-enquire', function (event) {
	        event.preventDefault();
	        var source = $(event.currentTarget).data('ofs-source') || 'unknown';
	
	        var initial = {
	            first_name: opts['firstName'] || null,
	            last_name: opts['lastName'] || null,
	            start_date: opts['start-date'] || null,
	            end_date: opts['end-date'] || null
	        };
	
	        var config = {
	            city: opts.city,
	            unit: opts.unit,
	            unitShortCode: opts.unitShortCode,
	            initial: initial,
	            source: source
	        };
	        (0, _ofsAppsCoreUtilsTrackingOptimizely.trackOptimizelyOpen)(source);
	        tracker.openEnquiry(source);
	        window.ofsFlux.actions.layers.addModal(React.createElement(UnitContactForm, config));
	    });
	};
	
	$.fn.changeElementType = function (newType) {
	    var newElements = [];
	
	    $(this).each(function () {
	        var attrs = {};
	
	        $.each(this.attributes, function (idx, attr) {
	            attrs[attr.nodeName] = attr.nodeValue;
	        });
	
	        var newElement = $("<" + newType + "/>", attrs).append($(this).contents());
	
	        $(this).replaceWith(newElement);
	
	        newElements.push(newElement);
	    });
	
	    return $(newElements);
	};
	
	var mediafieldDefaults = {};
	
	var initMediafield = function initMediafield($el, opts) {
	    $el.mediaLibrary();
	};
	
	var unitPickerDefaults = {
	    minimumResultsForSearch: 10
	};
	
	var initUnitPicker = function initUnitPicker($el, opts) {
	    var options = $.extend({}, unitPickerDefaults, opts);
	    $el.css({
	        'width': $el.width() + 'px'
	    });
	
	    var initOpts = {
	        allowClear: true,
	        minimumResultsForSearch: parseInt(options.minimumResultsForSearch, 10),
	        ajax: {
	            url: ofs.publicAPI("units"),
	            dataType: 'json',
	            quietMillis: 100,
	            data: function data(term, page) {
	                return {
	                    q: term,
	                    limit: 10,
	                    offset: (page - 1) * 10,
	                    format: 'json'
	                };
	            },
	            results: function results(data, page) {
	                var more = false; // whether or not there are more results available
	                var results = data.results;
	
	                var choices = [];
	
	                for (var i = 0; i < results.length; i++) {
	                    var obj = results[i];
	                    choices.push({
	                        id: obj.id,
	                        text: obj.name,
	                        library_path: obj.library_path
	                    });
	                }
	
	                // notice we return the value of more so Select2 knows if more results can be loaded
	                return {
	                    results: choices,
	                    more: more
	                };
	            }
	        },
	        initSelection: function initSelection(element, callback) {
	            // the input tag has a value attribute preloaded that points to a preselected movie's id
	            // this function resolves that id attribute to an object that select2 can render
	            // using its formatResult renderer - that way the movie name is shown preselected
	            var id = $(element).val();
	            if (id !== "") {
	                $.ajax(ofs.publicAPI("units") + id + "/", {
	                    data: {
	                        format: 'json'
	                    },
	                    dataType: "json"
	                }).done(function (data) {
	                    callback({
	                        id: data.id,
	                        text: data.name,
	                        library_path: data.library_path
	                    });
	                });
	            }
	        },
	        formatSelection: function formatSelection(data) {
	            $el.data('libraryPath', data.library_path);
	            return data.text;
	        }
	    };
	
	    $el.select2(initOpts);
	};
	
	var initUnitPicker2 = function initUnitPicker2($el, opts) {
	    var choices = [];
	
	    if ($el.val() && $el.data('label')) {
	        choices.push({ "id": parseInt($el.val(), 10), "name": $el.data('label') });
	    }
	
	    $el.selectize({
	        maxItems: 1,
	        //dropdownParent: "body",
	        valueField: 'id',
	        labelField: 'name',
	        searchField: 'name',
	        options: choices,
	        create: false,
	        load: function load(query, callback) {
	            if (!query.length) return callback();
	            $.ajax({
	                url: ofs.publicAPI("units"),
	                type: 'GET',
	                dataType: 'json',
	                data: {
	                    q: query,
	                    limit: 10,
	                    format: 'json'
	                },
	                error: function error() {
	                    callback();
	                },
	                success: function success(res) {
	                    callback(res.results);
	                }
	            });
	        }
	    });
	};
	
	var initAutogrowTextarea = function initAutogrowTextarea($el, opts) {
	    $el.autogrow();
	};
	
	var initContributorPicker = function initContributorPicker($el, opts) {
	    var choices = [];
	
	    if ($el.val() && $el.data('label')) {
	        choices.push({ "id": parseInt($el.val(), 10), "name": $el.data('label') });
	    }
	
	    $el.selectize({
	        maxItems: 1,
	        //dropdownParent: "body",
	        valueField: 'id',
	        labelField: 'name',
	        searchField: 'name',
	        options: choices,
	        create: false,
	        load: function load(query, callback) {
	            if (!query.length) return callback();
	            $.ajax({
	                url: ofs.privateAPI("contributors"),
	                type: 'GET',
	                dataType: 'json',
	                data: {
	                    q: query,
	                    limit: 10,
	                    format: 'json'
	                },
	                error: function error() {
	                    callback();
	                },
	                success: function success(res) {
	                    callback(res.objects);
	                }
	            });
	        }
	    });
	};
	
	var formatRegionResult = function formatRegionResult(data) {
	    if (!data.id) return data.text; // optgroup
	
	    if (data.text.split(' ')[0] === '--') {
	        return '&nbsp;&nbsp;&nbsp;&nbsp;' + data.text.replace('-- ', '');
	    } else if (data.text.split(' ')[0] === '##') {
	        return '<span class="my-region-heading">' + data.text.replace('## ', '') + '</span>';
	    }
	};
	
	var formatRegionSelection = function formatRegionSelection(data) {
	    if (!data.id) return data.text; // optgroup
	
	    if (data.text.split(' ')[0] === '--') {
	        return data.text.replace('-- ', '');
	    } else if (data.text.split(' ')[0] === '##') {
	        return data.text.replace('## ', '');
	    }
	};
	
	var buildSelectChoices = function buildSelectChoices($el, cityCode, minDepth) {
	    var url = ofs.privateAPI("regions") + '?limit=0&city=' + cityCode + '&depth__gte=' + minDepth;
	
	    $.get(url, function (data) {
	        var regions = data.objects;
	        var cityRegion = _.findWhere(regions, { depth: 1 });
	
	        var choices = [];
	
	        var tempNode = $('<div/>');
	
	        $el.empty();
	
	        if (cityRegion) {
	            var cityOption = $('<option />');
	            cityOption.text('## All regions');
	            cityOption.attr('value', cityRegion.id);
	            cityOption.prop('selected', true);
	
	            tempNode.append(cityOption);
	        }
	
	        var groups = _.where(regions, { depth: 2 });
	        _.each(groups, function (group) {
	            var groupOption = $('<option />');
	            groupOption.text('## ' + group.name);
	            groupOption.attr('value', group.id);
	
	            tempNode.append(groupOption);
	
	            _.each(_.where(regions, { depth: 3, parent: group.resource_uri }), function (region) {
	                var option = $('<option />');
	                option.attr('value', region.id);
	                option.text('-- ' + region.name);
	                tempNode.append(option);
	            });
	        });
	        $el.html(tempNode.html());
	
	        if (cityRegion) {
	            $el.select2('val', cityRegion.id);
	        } else {
	            $el.select2('data', {
	                id: null,
	                text: 'No region selected'
	            });
	        }
	    });
	};
	
	var initRegionPicker = function initRegionPicker($el, opts) {
	    var city = opts.city;
	
	    var defaultOpts = {
	        formatResult: formatRegionResult,
	        formatSelection: formatRegionSelection
	    };
	
	    var currentVal = $el.val();
	
	    if (opts.forCitypicker) {
	        var $cityPicker = $el.closest('form').find('[name=' + opts.forCitypicker + ']');
	        $cityPicker.on('change', function () {
	            var val = $cityPicker.val();
	            if (val) {
	                $el.prop('disabled', false);
	                $el.select2('enable');
	                buildSelectChoices($el, val, opts.minDepth || 1);
	            } else {
	                $el.empty();
	                $el.select2('data', {
	                    id: null,
	                    text: ''
	                });
	                $el.prop('disabled', true);
	                $el.select2('disable');
	            }
	        });
	        if (!currentVal) {
	            $el.prop('disabled', true);
	            $el.select2('disable');
	        }
	    }
	
	    $el.width($el.width());
	    $el.select2(defaultOpts);
	
	    if (!$el.find('option[selected]').length) {
	        $el.select2('data', {
	            id: null,
	            text: ''
	        });
	    }
	};
	
	var initCityPicker = function initCityPicker($el, opts) {
	    $el.width($el.width());
	    $el.select2({
	        minimumResultsForSearch: 10
	    });
	};
	
	var initCityPicker2 = function initCityPicker2($el) {
	    $el.selectize();
	};
	
	var buildRegionChoices = function buildRegionChoices(picker, xhr, city, region, minDepth) {
	    picker.disable();
	    picker.clearOptions();
	    picker.load(function (callback) {
	        xhr && xhr.abort();
	        xhr = $.ajax({
	            url: ofs.privateAPI("regions"),
	            type: 'GET',
	            dataType: 'json',
	            data: {
	                limit: 0,
	                city: city,
	                depth__gte: minDepth,
	                format: 'json'
	            },
	            error: function error() {
	                callback();
	            },
	            success: function success(res) {
	                picker.enable();
	                var regions = res.objects;
	                var cityRegion = _.findWhere(regions, { depth: 1 });
	                var choices = [];
	                var index = 0;
	
	                if (cityRegion) {
	                    cityRegion.order = index;
	                    index++;
	                    choices.push(cityRegion);
	                }
	                var groups = _.where(regions, { depth: 2 });
	                _.each(groups, function (group) {
	                    group.order = index;
	                    index++;
	                    choices.push(group);
	
	                    _.each(_.where(regions, { depth: 3, parent: group.resource_uri }), function (region) {
	                        region.order = index;
	                        index++;
	                        choices.push(region);
	                    });
	                });
	                callback(choices);
	
	                if (!region) {
	                    picker.setValue(cityRegion.id);
	                } else {
	                    picker.setValue(parseInt(region, 10));
	                }
	            }
	        });
	    });
	};
	
	var initRegionPicker2 = function initRegionPicker2($el, opts) {
	    var $cityPicker = $el.closest('form').find('[name=' + opts.forCitypicker + ']');
	    var $regionPicker;
	    var regionPicker;
	    var xhr;
	    var city = $cityPicker.val();
	    var region = $el.val();
	    $el.val(null);
	
	    $cityPicker.on('change', function () {
	        var val = $cityPicker.val();
	        buildRegionChoices(regionPicker, xhr, val, null, 1);
	    });
	
	    $regionPicker = $el.selectize({
	        valueField: 'id',
	        labelField: 'name',
	        searchField: ['name'],
	        maxItems: 1,
	        sortField: [{ field: "$score", direction: "desc" }, { field: "order", direction: "asc" }],
	        render: {
	            item: function item(_item, escape) {
	                if (_item.depth === 1) {
	                    _item.name = 'All Regions';
	                }
	                return '<div>' + escape(_item.name) + '</div>';
	            },
	            option: function option(item, escape) {
	                if (item.depth === 1) {
	                    item.name = 'All Regions';
	                }
	                return '<div class="depth-' + item.depth + '">' + escape(item.name) + '</div>';
	            }
	        }
	    });
	
	    regionPicker = $regionPicker[0].selectize;
	
	    if (city) {
	        buildRegionChoices(regionPicker, xhr, city, region, 1);
	    }
	};
	
	var initTooltip = function initTooltip($el, opts) {
	    var tooltipInit = __webpack_require__(326);
	
	    var label = $el.data('label');
	    var orientation = $el.data('orientation');
	
	    var $container = $("<div></div>");
	    $el.append($container);
	
	    tooltipInit($container[0], { tetherTo: $el[0], label: label, orientation: orientation });
	};
	
	var DatePicker = __webpack_require__(329);
	var DatePickerComponent = React.createClass({
	    displayName: 'DatePickerComponent',
	
	    getInitialState: function getInitialState() {
	        return {
	            value: null
	        };
	    },
	
	    handleSelect: function handleSelect(value) {
	        this.setState({ value: value });
	    },
	
	    render: function render() {
	        return React.createElement(DatePicker, { name: this.props.name, placeholder: this.props.placeholder, flux: window.ofsFlux, onSelect: this.handleSelect, value: this.state.value });
	    }
	});
	
	var initNewDatepicker = function initNewDatepicker($el, opts) {
	    React.render(React.createElement(DatePickerComponent, { name: opts.name, placeholder: opts.placeholder }), $el[0]);
	};
	
	var initSimpleChoice = function initSimpleChoice($el, opts) {
	    (0, _ofsComponentsSimpleChoiceSimpleChoice.init)($el);
	};
	
	var components = {
	    'enquire': initEnquire,
	    'booking-enquire': initBookingEnquire,
	    'search-enquire': initSearchEnquire,
	    'unit-enquire': initUnitEnquire,
	    'simple-map': initSimpleMap,
	    'google-map': initGoogleMap,
	    'datepicker': initPikaDay,
	    'select': initSelect2,
	    'picture': initPicture,
	    'locationpicker': initLocationPicker,
	    'responsive': initResponsive,
	    'regionpicker2': initRegionPicker2,
	    'unitpicker': initUnitPicker,
	    'unitpicker2': initUnitPicker2,
	    'autogrow': initAutogrowTextarea,
	    'contributorpicker': initContributorPicker,
	    'regionpicker': initRegionPicker,
	    'citypicker': initCityPicker,
	    'citypicker2': initCityPicker2,
	    'pikadayElements': [],
	    'tooltip': initTooltip,
	    'newDatepicker': initNewDatepicker,
	    'simpleChoice': initSimpleChoice
	};
	
	var initComponent = function initComponent($el) {
	    var component = $el.data('ofs-component');
	    components[component]($el, $el.data());
	};
	
	var initComponents = function initComponents($node) {
	    $node.find('.mediacat-mediainput-widget').each(function (index, elem) {
	        $(elem).mediacat();
	    });
	    $node.find('[data-ofs-component]').each(function (index, elem) {
	        initComponent($(elem));
	    });
	};
	
	module.exports = {
	    initComponents: initComponents,
	    initComponent: initComponent,
	    components: components
	};

/***/ },
/* 46 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = trackOptimizelySubmit;
	exports.trackOptimizelyOpen = trackOptimizelyOpen;
	
	function trackOptimizelySubmit(source) {
	  window.optimizely = window.optimizely || [];
	  window.optimizely.push(["trackEvent", "submit:" + source]);
	}
	
	function trackOptimizelyOpen(source) {
	  window.optimizely = window.optimizely || [];
	  window.optimizely.push(["trackEvent", "open:" + source]);
	}

/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.init = init;
	
	var _reactAddons = __webpack_require__(40);
	
	var _reactAddons2 = _interopRequireDefault(_reactAddons);
	
	var _jquery = __webpack_require__(39);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactOnclickoutside = __webpack_require__(48);
	
	var _reactOnclickoutside2 = _interopRequireDefault(_reactOnclickoutside);
	
	var _classnames = __webpack_require__(49);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ofsUtilsClassNameMixin = __webpack_require__(50);
	
	var _ofsUtilsClassNameMixin2 = _interopRequireDefault(_ofsUtilsClassNameMixin);
	
	var _ofsComponentsCommonIcon = __webpack_require__(51);
	
	var _ofsComponentsCommonIcon2 = _interopRequireDefault(_ofsComponentsCommonIcon);
	
	var _Options = __webpack_require__(55);
	
	var _Options2 = _interopRequireDefault(_Options);
	
	var _OptionWrapper = __webpack_require__(56);
	
	var _OptionWrapper2 = _interopRequireDefault(_OptionWrapper);
	
	function noop() {}
	
	function isDefined(value) {
	  return typeof value !== 'undefined';
	}
	
	// initialise SimpleChoice component on an existing element
	
	function init($select) {
	  var styles = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	  var onChange = arguments.length <= 2 || arguments[2] === undefined ? noop : arguments[2];
	
	  // create div after select box
	  var div = document.createElement('div');
	
	  for (var rule in styles) {
	    div.style[rule] = styles[rule];
	  }
	
	  $select.after(div);
	
	  // get all options in select box
	  var options = [];
	  $select.find('option').each(function (index, el) {
	    options.push(_reactAddons2['default'].createElement(
	      'div',
	      { value: (0, _jquery2['default'])(el).val(), key: (0, _jquery2['default'])(el).val() },
	      (0, _jquery2['default'])(el).text()
	    ));
	  });
	
	  // get selected value
	  var value = $select.find(':selected').val();
	
	  // get name of select box
	  var name = $select.attr('name');
	
	  // render react component
	  _reactAddons2['default'].render(_reactAddons2['default'].createElement(
	    SimpleChoice,
	    { name: name, defaultValue: value, onChange: onChange },
	    options
	  ), div);
	
	  // remove select box
	  $select.remove();
	
	  return div;
	}
	
	var SimpleChoice = _reactAddons2['default'].createClass({
	  displayName: 'SimpleChoice',
	
	  mixins: [_ofsUtilsClassNameMixin2['default'], _reactOnclickoutside2['default']],
	
	  propTypes: {
	    children: _reactAddons2['default'].PropTypes.array.isRequired,
	    value: _reactAddons2['default'].PropTypes.oneOfType([_reactAddons2['default'].PropTypes.string, _reactAddons2['default'].PropTypes.number]),
	    defaultValue: _reactAddons2['default'].PropTypes.oneOfType([_reactAddons2['default'].PropTypes.string, _reactAddons2['default'].PropTypes.number]),
	
	    name: _reactAddons2['default'].PropTypes.string,
	    placeholder: _reactAddons2['default'].PropTypes.string,
	    disabled: _reactAddons2['default'].PropTypes.bool,
	    required: _reactAddons2['default'].PropTypes.bool,
	    inverse: _reactAddons2['default'].PropTypes.bool,
	
	    onChange: _reactAddons2['default'].PropTypes.func
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onChange: noop,
	      onInvalid: noop
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      focus: false,
	      hoverValue: null,
	      chosenValue: null,
	
	      optionPosition: null
	    };
	  },
	
	  isActive: function isActive() {
	    return !this.props.disabled && this.state.focus;
	  },
	
	  getSelectedValue: function getSelectedValue() {
	    var _props = this.props;
	    var value = _props.value;
	    var defaultValue = _props.defaultValue;
	    var chosenValue = this.state.chosenValue;
	
	    // value trumps everything
	    if (typeof value !== 'undefined' && value !== null) {
	      return value;
	    }
	
	    if (typeof chosenValue !== 'undefined' && chosenValue !== null) {
	      return chosenValue;
	    }
	
	    return defaultValue;
	  },
	
	  getOption: function getOption(value) {
	    return this.props.children.find(function (child) {
	      return child.props.value === value;
	    });
	  },
	
	  handleClick: function handleClick(event) {
	    event.preventDefault();
	
	    this.setState({
	      focus: !this.state.focus,
	      hoverValue: null
	    });
	  },
	
	  handleClickOutside: function handleClickOutside() {
	    if (this.isMounted()) {
	      this.setState({
	        focus: false,
	        hoverValue: null
	      });
	    }
	  },
	
	  handleOptionHover: function handleOptionHover(option) {
	    this.setState({
	      hoverValue: option.props.value
	    });
	  },
	
	  handleOptionClick: function handleOptionClick(option, event) {
	    var _this = this;
	
	    event.preventDefault();
	    event.stopPropagation();
	    this.optionsMouseDown = false;
	
	    this.setState({
	      chosenValue: option.props.value,
	      focus: false,
	      hoverValue: null
	    }, function () {
	      // Try and replicate normal dom event
	      var node = _reactAddons2['default'].findDOMNode(_this.refs.input);
	      var fakeEvent = {
	        target: {
	          value: option.props.value,
	          getAttribute: node.getAttribute.bind(node)
	        },
	        option: option
	      };
	      _this.props.onChange(fakeEvent);
	    });
	  },
	
	  componentDidMount: function componentDidMount() {
	    var onInvalid = this.props.onInvalid;
	
	    if (false) {
	      /* eslint-disable no-console */
	      if (this.props.value && this.props.defaultValue) {
	        console.warn('Both "value" and "defaultValue" cannot be defined at the same time. "value" will be ignored.');
	      }
	
	      if (this.props.value && this.props.onChange === noop) {
	        console.warn('"value" is defined without an "onChange" handler. Define an "onChange" handler or use "defaultValue" for an uncontrolled input.');
	      }
	      /* eslint-enable no-console */
	    }
	    _reactAddons2['default'].findDOMNode(this.refs.input).addEventListener('invalid', onInvalid);
	  },
	
	  render: function render() {
	    var _this2 = this;
	
	    var _props2 = this.props;
	    var defaultValue = _props2.defaultValue;
	    var value = _props2.value;
	    var name = _props2.name;
	    var placeholder = _props2.placeholder;
	    var inverse = _props2.inverse;
	    var children = _props2.children;
	    var required = _props2.required;
	    var hoverValue = this.state.hoverValue;
	
	    var selectedValue = this.getSelectedValue();
	    var selectedOption = selectedValue !== null ? this.getOption(selectedValue) : null;
	
	    var options = children.map(function (child, index) {
	      var highlightedValue = isDefined(hoverValue) && hoverValue !== null ? hoverValue : selectedValue;
	
	      var key = index + '-' + child.props.value;
	
	      return _reactAddons2['default'].createElement(
	        _OptionWrapper2['default'],
	        {
	          selected: child.props.value === highlightedValue,
	          key: key,
	          onHover: _this2.handleOptionHover,
	          onClick: _this2.handleOptionClick },
	        child
	      );
	    });
	
	    var label;
	
	    if (selectedOption) {
	      label = selectedOption.props.children;
	    } else if (placeholder) {
	      label = placeholder;
	    } else {
	      label = children.length > 0 ? children[0].props.children : null;
	    }
	
	    var classes = {
	      'ofs-SimpleChoice': true,
	      'ofs-SimpleChoice--is-open': this.isActive(),
	      '-theme--dark': inverse
	    };
	
	    var valueClasses = {
	      'ofs-SimpleChoice__Value': true,
	      'ofs-SimpleChoice__Value--placeholder': !isDefined(defaultValue) && !isDefined(value)
	    };
	
	    return _reactAddons2['default'].createElement(
	      'div',
	      null,
	      _reactAddons2['default'].createElement('input', {
	        name: name,
	        type: 'text',
	        value: selectedValue,
	        ref: 'input',
	        style: { position: 'absolute', width: 0 },
	        tabIndex: '-1',
	        required: required }),
	      _reactAddons2['default'].createElement(
	        'div',
	        {
	          className: this.getClassSet(classes),
	          role: 'listbox',
	          'aria-haspopup': 'true',
	          'aria-activedescendant': this.isActive(),
	          tabIndex: '0',
	          onClick: this.handleClick },
	        _reactAddons2['default'].createElement(
	          'div',
	          { className: (0, _classnames2['default'])(valueClasses) },
	          label
	        ),
	        _reactAddons2['default'].createElement(
	          'div',
	          { className: 'ofs-SimpleChoice__Arrow' },
	          this.isActive() ? _reactAddons2['default'].createElement(_ofsComponentsCommonIcon2['default'], { glyph: 'arrow', size: 'small', variant: 'up' }) : _reactAddons2['default'].createElement(_ofsComponentsCommonIcon2['default'], { glyph: 'arrow', size: 'small', variant: 'down' })
	        ),
	        this.isActive() ? _reactAddons2['default'].createElement(
	          _Options2['default'],
	          null,
	          options
	        ) : null
	      )
	    );
	  }
	});
	
	exports['default'] = SimpleChoice;
	/* note react throws warning to make this field `readOnly` - but that
	   retults in the `required` validation not being respected :( */

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * A mixin for handling (effectively) onClickOutside for React components.
	 * Note that we're not intercepting any events in this approach, and we're
	 * not using double events for capturing and discarding in layers or wrappers.
	 *
	 * The idea is that components define function
	 *
	 *   handleClickOutside: function() { ... }
	 *
	 * If no such function is defined, an error will be thrown, as this means
	 * either it still needs to be written, or the component should not be using
	 * this mixing since it will not exhibit onClickOutside behaviour.
	 *
	 */
	(function (root, factory) {
	  if (true) {
	    // AMD. Register as an anonymous module.
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(40)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    // Node. Note that this does not work with strict
	    // CommonJS, but only CommonJS-like environments
	    // that support module.exports
	    module.exports = factory(require('react'));
	  } else {
	    // Browser globals (root is window)
	    root.OnClickOutside = factory(React);
	  }
	}(this, function (React) {
	  "use strict";
	
	  // Use a parallel array because we can't use
	  // objects as keys, they get toString-coerced
	  var registeredComponents = [];
	  var handlers = [];
	
	  var IGNORE_CLASS = 'ignore-react-onclickoutside';
	
	  var isSourceFound = function(source, localNode) {
	    if (source === localNode) {
	      return true;
	    }
	    // SVG <use/> elements do not technically reside in the rendered DOM, so
	    // they do not have classList directly, but they offer a link to their
	    // corresponding element, which can have classList. This extra check is for
	    // that case.
	    // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
	    // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17
	    if (source.correspondingElement) {
	      var corrElClassStr = source.correspondingElement.getAttribute('class');
	      if(!corrElClassStr){
	        return false;
	      } else {
	        return (corrElClassStr.split(/\s+/).indexOf(IGNORE_CLASS) > -1);
	      }
	    }
	
	    var elClassStr = source.getAttribute('class');
	    if(!elClassStr){
	      return false;
	    } else {
	      return (elClassStr.split(/\s+/).indexOf(IGNORE_CLASS) > -1);
	    }
	  };
	
	  return {
	    componentDidMount: function() {
	      if(typeof this.handleClickOutside !== "function")
	        throw new Error("Component lacks a handleClickOutside(event) function for processing outside click events.");
	
	      var fn = this.__outsideClickHandler = (function(localNode, eventHandler) {
	        return function(evt) {
	          evt.stopPropagation();
	          var source = evt.target;
	          var found = false;
	          // If source=local then this event came from "somewhere"
	          // inside and should be ignored. We could handle this with
	          // a layered approach, too, but that requires going back to
	          // thinking in terms of Dom node nesting, running counter
	          // to React's "you shouldn't care about the DOM" philosophy.
	          while(source.parentNode) {
	            found = isSourceFound(source, localNode);
	            if(found) return;
	            source = source.parentNode;
	          }
	          eventHandler(evt);
	        }
	      }(React.findDOMNode(this), this.handleClickOutside));
	
	      var pos = registeredComponents.length;
	      registeredComponents.push(this);
	      handlers[pos] = fn;
	
	      // If there is a truthy disableOnClickOutside property for this
	      // component, don't immediately start listening for outside events.
	      if (!this.props.disableOnClickOutside) {
	        this.enableOnClickOutside();
	      }
	    },
	
	    componentWillUnmount: function() {
	      this.disableOnClickOutside();
	      this.__outsideClickHandler = false;
	      var pos = registeredComponents.indexOf(this);
	      if( pos>-1) {
	        if (handlers[pos]) {
	          // clean up so we don't leak memory
	          handlers.splice(pos, 1);
	          registeredComponents.splice(pos, 1);
	        }
	      }
	    },
	
	    /**
	     * Can be called to explicitly enable event listening
	     * for clicks and touches outside of this element.
	     */
	    enableOnClickOutside: function() {
	      var fn = this.__outsideClickHandler;
	      document.addEventListener("mousedown", fn);
	      document.addEventListener("touchstart", fn);
	    },
	
	    /**
	     * Can be called to explicitly disable event listening
	     * for clicks and touches outside of this element.
	     */
	    disableOnClickOutside: function() {
	      var fn = this.__outsideClickHandler;
	      document.removeEventListener("mousedown", fn);
	      document.removeEventListener("touchstart", fn);
	    }
	  };
	
	}));


/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	
	(function () {
		'use strict';
	
		function classNames () {
	
			var classes = '';
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if ('string' === argType || 'number' === argType) {
					classes += ' ' + arg;
	
				} else if (Array.isArray(arg)) {
					classes += ' ' + classNames.apply(null, arg);
	
				} else if ('object' === argType) {
					for (var key in arg) {
						if (arg.hasOwnProperty(key) && arg[key]) {
							classes += ' ' + key;
						}
					}
				}
			}
	
			return classes.substr(1);
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true){
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	
	}());


/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _reactAddons = __webpack_require__(40);
	
	var _reactAddons2 = _interopRequireDefault(_reactAddons);
	
	var _classnames = __webpack_require__(49);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var ClassNameMixin = {
	  propTypes: {
	    className: _reactAddons2['default'].PropTypes.string
	  },
	
	  getClassSet: function getClassSet(classes) {
	    classes = classes || {};
	
	    if (this.props.className) {
	      classes[this.props.className] = true;
	    }
	    return (0, _classnames2['default'])(classes);
	  }
	};
	
	exports['default'] = ClassNameMixin;
	module.exports = exports['default'];

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _defineProperty = __webpack_require__(52)['default'];
	
	var _objectWithoutProperties = __webpack_require__(53)['default'];
	
	var _extends = __webpack_require__(54)['default'];
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(40);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(49);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var PureRenderMixin = _react2['default'].addons.PureRenderMixin;
	
	var sizeMap = {
	  'xx-small': 12,
	  'x-small': 14,
	  'small': 20,
	  'medium': 28,
	  'large': 36,
	  'x-large': 44
	};
	
	var Icon = _react2['default'].createClass({
	  displayName: 'Icon',
	
	  mixins: [PureRenderMixin],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      size: 'medium',
	      pack: 'ofs-icons',
	      variant: null
	    };
	  },
	
	  render: function render() {
	    var _cx;
	
	    var _props = this.props;
	    var glyph = _props.glyph;
	    var pack = _props.pack;
	    var size = _props.size;
	    var variant = _props.variant;
	
	    var props = _objectWithoutProperties(_props, ['glyph', 'pack', 'size', 'variant']);
	
	    var classes = (0, _classnames2['default'])((_cx = {
	      'ofs-Icon': true
	    }, _defineProperty(_cx, 'ofs-Icon--' + glyph, true), _defineProperty(_cx, 'ofs-Icon--' + glyph + '-' + variant, variant), _defineProperty(_cx, 'ofs-Icon--' + size, true), _cx));
	
	    return _react2['default'].createElement(
	      'div',
	      _extends({ className: classes }, props),
	      _react2['default'].createElement('svg', { className: 'ofs-Icon__Container', dangerouslySetInnerHTML: { __html: '<use xlink:href="#' + pack + '--' + glyph + '-' + sizeMap[size] + '"></use>'
	        } })
	    );
	  }
	});
	
	exports['default'] = Icon;
	module.exports = exports['default'];

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _Object$defineProperty = __webpack_require__(29)["default"];
	
	exports["default"] = function (obj, key, value) {
	  if (key in obj) {
	    _Object$defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};
	
	exports.__esModule = true;

/***/ },
/* 53 */
/***/ function(module, exports) {

	"use strict";
	
	exports["default"] = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};
	
	exports.__esModule = true;

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _Object$assign = __webpack_require__(32)["default"];
	
	exports["default"] = _Object$assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	exports.__esModule = true;

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _reactAddons = __webpack_require__(40);
	
	var _reactAddons2 = _interopRequireDefault(_reactAddons);
	
	var _classnames = __webpack_require__(49);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var Options = _reactAddons2['default'].createClass({
	  displayName: 'Options',
	
	  propTypes: {
	    children: _reactAddons2['default'].PropTypes.array.isRequired,
	    onMouseDown: _reactAddons2['default'].PropTypes.func.isRequired
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onMouseDown: function onMouseDown() {}
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      orientation: 'below'
	    };
	  },
	
	  checkPosition: function checkPosition() {
	    // measure height and offset
	    var $options = this.getDOMNode();
	    var height = $options.offsetHeight;
	    var viewportHeight = window.innerHeight;
	
	    var $parent = $options.offsetParent;
	
	    var _$parent$getBoundingClientRect = $parent.getBoundingClientRect();
	
	    var bottom = _$parent$getBoundingClientRect.bottom;
	
	    if (height + bottom > viewportHeight) {
	      // set top to be above input
	      height += 2;
	      this.setState({
	        orientation: 'above',
	        topOffset: height * -1
	      });
	    } else {
	      this.setState({
	        orientation: 'below',
	        topOffset: null
	      });
	    }
	  },
	
	  /**
	  * I think it hijacks fastclick and enables default browser behavior. 
	  * It may be bug with fastclick that I'd like Jon or Andy to take a 
	  * look at. KNOWN ISSUE: Using Chrome's Android
	  * emulator, the user will have to tap 2x to make a selection.
	  * Tested it on Luis's Android and it worked fine.
	  **/
	
	  handleTouch: function handleTouch(event) {
	    event.stopPropagation();
	  },
	
	  handleMouseDown: function handleMouseDown() {
	    this.props.onMouseDown(event);
	  },
	
	  componentDidMount: function componentDidMount() {
	    var _this = this;
	
	    this.checkPosition();
	
	    this.events = ['resize', 'scroll', 'touchmove'];
	
	    this.events.forEach(function (event) {
	      window.addEventListener(event, _this.checkPosition);
	    });
	
	    // see comment block above
	    this.getDOMNode().addEventListener('touchstart', this.handleTouch);
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    var _this2 = this;
	
	    this.events.forEach(function (event) {
	      window.removeEventListener(event, _this2.checkPosition);
	    });
	    // see comment block above
	    this.getDOMNode().addEventListener('touchstart', this.handleTouch);
	  },
	
	  render: function render() {
	    var _state = this.state;
	    var orientation = _state.orientation;
	    var topOffset = _state.topOffset;
	
	    var optionClasses = {
	      'ofs-List': true,
	      'ofs-SimpleChoice__Options': true,
	      'ofs-SimpleChoice__Options--is-above': orientation === 'above',
	      'ofs-SimpleChoice__Options--is-below': orientation === 'below'
	    };
	
	    var style = {
	      'top': topOffset
	    };
	
	    return _reactAddons2['default'].createElement(
	      'ul',
	      { className: (0, _classnames2['default'])(optionClasses), style: style,
	        onMouseDown: this.handleMouseDown, ref: 'options' },
	      this.props.children
	    );
	  }
	});
	
	exports['default'] = Options;
	module.exports = exports['default'];

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _reactAddons = __webpack_require__(40);
	
	var _reactAddons2 = _interopRequireDefault(_reactAddons);
	
	var _classnames = __webpack_require__(49);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function noop() {}
	
	var OptionWrapper = _reactAddons2['default'].createClass({
	  displayName: 'OptionWrapper',
	
	  propTypes: {
	    selected: _reactAddons2['default'].PropTypes.bool.isRequired,
	
	    onHover: _reactAddons2['default'].PropTypes.func,
	    onClick: _reactAddons2['default'].PropTypes.func
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onHover: noop,
	      onClick: noop
	    };
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var children = _props.children;
	    var onHover = _props.onHover;
	    var onClick = _props.onClick;
	
	    var classes = {
	      "ofs-SimpleChoice__Option": true,
	      "ofs-SimpleChoice__Option--is-selected": this.props.selected
	    };
	
	    return _reactAddons2['default'].createElement(
	      'li',
	      { className: (0, _classnames2['default'])(classes),
	        onMouseEnter: onHover.bind(null, children),
	        onMouseDown: onClick.bind(null, children) },
	      children
	    );
	  }
	});
	
	exports['default'] = OptionWrapper;
	module.exports = exports['default'];

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var moment = __webpack_require__(58);
	__webpack_require__(60);
	var i18n = __webpack_require__(61);
	var settings = __webpack_require__(62);
	
	// Import all the moment languages we support
	__webpack_require__(64);
	__webpack_require__(65); // English goes last because it's the default
	
	moment.locale(settings.LANGUAGE);
	
	var strftimeFormats = {};
	var phpFormats = {};
	
	var translateStrftimeToMoment = function translateStrftimeToMoment(item) {
	  if (item.substring(0, 2) === "%%") {
	    return item.replace("%%", "%");
	  }
	
	  switch (item) {
	    case "%a":
	      return "ddd";
	    case "%A":
	      return "dddd";
	    case "%h":
	    case "%b":
	      return "MMM";
	    case "%B":
	      return "MMMM";
	    case "%c":
	      return "LLLL";
	    case "%d":
	      return "D";
	    case "%j":
	      return "DDDD";
	    case "%e":
	      return "Do";
	    case "%m":
	      return "MM";
	    case "%p":
	      return "A";
	    case "%P":
	      return "a";
	    case "%S":
	      return "ss";
	    case "%M":
	      return "mm";
	    case "%H":
	      return "HH";
	    case "%I":
	      return "hh";
	    case "%w":
	      return "d";
	    case "%W":
	    case "%U":
	      return "ww";
	    case "%x":
	      return "LL";
	    case "%X":
	      return "LT";
	    case "%g":
	    case "%y":
	      return "YY";
	    case "%G":
	    case "%Y":
	      return "YYYY";
	    case "%z":
	      return "ZZ";
	    case "%Z":
	      return "z";
	    case "%f":
	      return "SSS";
	    default:
	      return item;
	  }
	};
	
	var translatePhpFormat = function translatePhpFormat(item) {
	  if (item.charAt(0) === "\\") {
	    return item.replace("\\", "");
	  }
	
	  switch (item) {
	    case "D":
	      return "ddd";
	    case "l":
	      return "dddd";
	    case "M":
	      return "MMM";
	    case "F":
	      return "MMMM";
	    case "j":
	      return "D";
	    case "m":
	      return "MM";
	    case "A":
	      return "A";
	    case "a":
	      return "a";
	    case "s":
	      return "ss";
	    case "i":
	      return "mm";
	    case "H":
	      return "HH";
	    case "g":
	      return "h";
	    case "h":
	      return "hh";
	    case "w":
	      return "d";
	    case "W":
	      return "ww";
	    case "y":
	      return "YY";
	    case "o":
	    case "Y":
	      return "YYYY";
	    case "O":
	      return "ZZ";
	    case "z":
	      return "DDD";
	    case "d":
	      return "DD";
	    case "n":
	      return "M";
	    case "G":
	      return "H";
	    case "e":
	      return "zz";
	    case "N":
	      return "MMMM";
	    default:
	      return item;
	  }
	};
	
	moment.fn.strftime = function (format) {
	  if (!strftimeFormats[format]) {
	    strftimeFormats[format] = format.replace(/%?.|%%/g, translateStrftimeToMoment);
	  }
	  return this.format(strftimeFormats[format]);
	};
	
	moment.fn.phpFormat = function (format) {
	  if (!phpFormats[format]) {
	    phpFormats[format] = format.replace(/\\?./g, translatePhpFormat);
	  }
	  return this.format(phpFormats[format]);
	};
	
	moment.fn.shortDateFormat = function () {
	  return this.phpFormat(i18n.get_format('SHORT_DATE_FORMAT'));
	};
	
	moment.fn.longDateFormat = function () {
	  return this.phpFormat(i18n.get_format('DATE_FORMAT'));
	};
	
	moment.fn.isoDateFormat = function () {
	  return this.format('YYYY-MM-DD');
	};
	
	module.exports = moment;

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.10.6
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, function () { 'use strict';
	
	    var hookCallback;
	
	    function utils_hooks__hooks () {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback (callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return Object.prototype.toString.call(input) === '[object Array]';
	    }
	
	    function isDate(input) {
	        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	    }
	
	    function map(arr, fn) {
	        var res = [], i;
	        for (i = 0; i < arr.length; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function create_utc__createUTC (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty           : false,
	            unusedTokens    : [],
	            unusedInput     : [],
	            overflow        : -2,
	            charsLeftOver   : 0,
	            nullInput       : false,
	            invalidMonth    : null,
	            invalidFormat   : false,
	            userInvalidated : false,
	            iso             : false
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    function valid__isValid(m) {
	        if (m._isValid == null) {
	            var flags = getParsingFlags(m);
	            m._isValid = !isNaN(m._d.getTime()) &&
	                flags.overflow < 0 &&
	                !flags.empty &&
	                !flags.invalidMonth &&
	                !flags.invalidWeekday &&
	                !flags.nullInput &&
	                !flags.invalidFormat &&
	                !flags.userInvalidated;
	
	            if (m._strict) {
	                m._isValid = m._isValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	        }
	        return m._isValid;
	    }
	
	    function valid__createInvalid (flags) {
	        var m = create_utc__createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        }
	        else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    var momentProperties = utils_hooks__hooks.momentProperties = [];
	
	    function copyConfig(to, from) {
	        var i, prop, val;
	
	        if (typeof from._isAMomentObject !== 'undefined') {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (typeof from._i !== 'undefined') {
	            to._i = from._i;
	        }
	        if (typeof from._f !== 'undefined') {
	            to._f = from._f;
	        }
	        if (typeof from._l !== 'undefined') {
	            to._l = from._l;
	        }
	        if (typeof from._strict !== 'undefined') {
	            to._strict = from._strict;
	        }
	        if (typeof from._tzm !== 'undefined') {
	            to._tzm = from._tzm;
	        }
	        if (typeof from._isUTC !== 'undefined') {
	            to._isUTC = from._isUTC;
	        }
	        if (typeof from._offset !== 'undefined') {
	            to._offset = from._offset;
	        }
	        if (typeof from._pf !== 'undefined') {
	            to._pf = getParsingFlags(from);
	        }
	        if (typeof from._locale !== 'undefined') {
	            to._locale = from._locale;
	        }
	
	        if (momentProperties.length > 0) {
	            for (i in momentProperties) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (typeof val !== 'undefined') {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    var updateInProgress = false;
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            utils_hooks__hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment (obj) {
	        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	    }
	
	    function absFloor (number) {
	        if (number < 0) {
	            return Math.ceil(number);
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if ((dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    function Locale() {
	    }
	
	    var locales = {};
	    var globalLocale;
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0, j, next, locale, split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return null;
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (!locales[name] && typeof module !== 'undefined' &&
	                module && module.exports) {
	            try {
	                oldLocale = globalLocale._abbr;
	                !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
	                // because defineLocale currently also sets the global locale, we
	                // want to undo that for lazy loaded locales
	                locale_locales__getSetGlobalLocale(oldLocale);
	            } catch (e) { }
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function locale_locales__getSetGlobalLocale (key, values) {
	        var data;
	        if (key) {
	            if (typeof values === 'undefined') {
	                data = locale_locales__getLocale(key);
	            }
	            else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale (name, values) {
	        if (values !== null) {
	            values.abbr = name;
	            locales[name] = locales[name] || new Locale();
	            locales[name].set(values);
	
	            // backwards compat for now: also set the locale
	            locale_locales__getSetGlobalLocale(name);
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    // returns locale data
	    function locale_locales__getLocale (key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    var aliases = {};
	
	    function addUnitAlias (unit, shorthand) {
	        var lowerCase = unit.toLowerCase();
	        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	    }
	
	    function normalizeUnits(units) {
	        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    function makeGetSet (unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                get_set__set(this, unit, value);
	                utils_hooks__hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get_set__get(this, unit);
	            }
	        };
	    }
	
	    function get_set__get (mom, unit) {
	        return mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]();
	    }
	
	    function get_set__set (mom, unit, value) {
	        return mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	    }
	
	    // MOMENTS
	
	    function getSet (units, value) {
	        var unit;
	        if (typeof units === 'object') {
	            for (unit in units) {
	                this.set(unit, units[unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (typeof this[units] === 'function') {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	    }
	
	    var formattingTokens = /(\[[^\[]*\])|(\\)?(Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Q|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	    var formatFunctions = {};
	
	    var formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken (token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(func.apply(this, arguments), token);
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens), i, length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '';
	            for (i = 0; i < length; i++) {
	                output += array[i] instanceof Function ? array[i].call(mom, format) : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var match1         = /\d/;            //       0 - 9
	    var match2         = /\d\d/;          //      00 - 99
	    var match3         = /\d{3}/;         //     000 - 999
	    var match4         = /\d{4}/;         //    0000 - 9999
	    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	    var match1to2      = /\d\d?/;         //       0 - 99
	    var match1to3      = /\d{1,3}/;       //       0 - 999
	    var match1to4      = /\d{1,4}/;       //       0 - 9999
	    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	    var matchUnsigned  = /\d+/;           //       0 - inf
	    var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	
	    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	    // any word (or two) characters or numbers including two/three word month in arabic.
	    var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;
	
	    var regexes = {};
	
	    function isFunction (sth) {
	        // https://github.com/moment/moment/issues/2325
	        return typeof sth === 'function' &&
	            Object.prototype.toString.call(sth) === '[object Function]';
	    }
	
	
	    function addRegexToken (token, regex, strictRegex) {
	        regexes[token] = isFunction(regex) ? regex : function (isStrict) {
	            return (isStrict && strictRegex) ? strictRegex : regex;
	        };
	    }
	
	    function getParseRegexForToken (token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	            return p1 || p2 || p3 || p4;
	        }).replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    var tokens = {};
	
	    function addParseToken (token, callback) {
	        var i, func = callback;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (typeof callback === 'number') {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        for (i = 0; i < token.length; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken (token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    var YEAR = 0;
	    var MONTH = 1;
	    var DATE = 2;
	    var HOUR = 3;
	    var MINUTE = 4;
	    var SECOND = 5;
	    var MILLISECOND = 6;
	
	    function daysInMonth(year, month) {
	        return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // ALIASES
	
	    addUnitAlias('month', 'M');
	
	    // PARSING
	
	    addRegexToken('M',    match1to2);
	    addRegexToken('MM',   match1to2, match2);
	    addRegexToken('MMM',  matchWord);
	    addRegexToken('MMMM', matchWord);
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	    function localeMonths (m) {
	        return this._months[m.month()];
	    }
	
	    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	    function localeMonthsShort (m) {
	        return this._monthsShort[m.month()];
	    }
	
	    function localeMonthsParse (monthName, format, strict) {
	        var i, mom, regex;
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = create_utc__createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth (mom, value) {
	        var dayOfMonth;
	
	        // TODO: Move this out of here!
	        if (typeof value === 'string') {
	            value = mom.localeData().monthsParse(value);
	            // TODO: Another silent failure?
	            if (typeof value !== 'number') {
	                return mom;
	            }
	        }
	
	        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	        return mom;
	    }
	
	    function getSetMonth (value) {
	        if (value != null) {
	            setMonth(this, value);
	            utils_hooks__hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get_set__get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth () {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    function checkOverflow (m) {
	        var overflow;
	        var a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	                -1;
	
	            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	                overflow = DATE;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    function warn(msg) {
	        if (utils_hooks__hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (firstTime) {
	                warn(msg + '\n' + (new Error()).stack);
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    utils_hooks__hooks.suppressDeprecationWarnings = false;
	
	    var from_string__isoRegex = /^\s*(?:[+-]\d{6}|\d{4})-(?:(\d\d-\d\d)|(W\d\d$)|(W\d\d-\d)|(\d\d\d))((T| )(\d\d(:\d\d(:\d\d(\.\d+)?)?)?)?([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	
	    var isoDates = [
	        ['YYYYYY-MM-DD', /[+-]\d{6}-\d{2}-\d{2}/],
	        ['YYYY-MM-DD', /\d{4}-\d{2}-\d{2}/],
	        ['GGGG-[W]WW-E', /\d{4}-W\d{2}-\d/],
	        ['GGGG-[W]WW', /\d{4}-W\d{2}/],
	        ['YYYY-DDD', /\d{4}-\d{3}/]
	    ];
	
	    // iso time formats and regexes
	    var isoTimes = [
	        ['HH:mm:ss.SSSS', /(T| )\d\d:\d\d:\d\d\.\d+/],
	        ['HH:mm:ss', /(T| )\d\d:\d\d:\d\d/],
	        ['HH:mm', /(T| )\d\d:\d\d/],
	        ['HH', /(T| )\d\d/]
	    ];
	
	    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	    // date from iso format
	    function configFromISO(config) {
	        var i, l,
	            string = config._i,
	            match = from_string__isoRegex.exec(string);
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	            for (i = 0, l = isoDates.length; i < l; i++) {
	                if (isoDates[i][1].exec(string)) {
	                    config._f = isoDates[i][0];
	                    break;
	                }
	            }
	            for (i = 0, l = isoTimes.length; i < l; i++) {
	                if (isoTimes[i][1].exec(string)) {
	                    // match[6] should be 'T' or space
	                    config._f += (match[6] || ' ') + isoTimes[i][0];
	                    break;
	                }
	            }
	            if (string.match(matchOffset)) {
	                config._f += 'Z';
	            }
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from iso format or fallback
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	            utils_hooks__hooks.createFromInputFallback(config);
	        }
	    }
	
	    utils_hooks__hooks.createFromInputFallback = deprecate(
	        'moment construction falls back to js Date. This is ' +
	        'discouraged and will be removed in upcoming major ' +
	        'release. Please refer to ' +
	        'https://github.com/moment/moment/issues/1407 for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    function createDate (y, m, d, h, M, s, ms) {
	        //can't just apply() to create a date:
	        //http://stackoverflow.com/questions/181348/instantiating-a-javascript-object-by-calling-prototype-constructor-apply
	        var date = new Date(y, m, d, h, M, s, ms);
	
	        //the date constructor doesn't accept years < 1970
	        if (y < 1970) {
	            date.setFullYear(y);
	        }
	        return date;
	    }
	
	    function createUTCDate (y) {
	        var date = new Date(Date.UTC.apply(null, arguments));
	        if (y < 1970) {
	            date.setUTCFullYear(y);
	        }
	        return date;
	    }
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY',   4],       0, 'year');
	    addFormatToken(0, ['YYYYY',  5],       0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // ALIASES
	
	    addUnitAlias('year', 'y');
	
	    // PARSING
	
	    addRegexToken('Y',      matchSigned);
	    addRegexToken('YY',     match1to2, match2);
	    addRegexToken('YYYY',   match1to4, match4);
	    addRegexToken('YYYYY',  match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] = input.length === 2 ? utils_hooks__hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = utils_hooks__hooks.parseTwoDigitYear(input);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    // HOOKS
	
	    utils_hooks__hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', false);
	
	    function getIsLeapYear () {
	        return isLeapYear(this.year());
	    }
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // ALIASES
	
	    addUnitAlias('week', 'w');
	    addUnitAlias('isoWeek', 'W');
	
	    // PARSING
	
	    addRegexToken('w',  match1to2);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W',  match1to2);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	        week[token.substr(0, 1)] = toInt(input);
	    });
	
	    // HELPERS
	
	    // firstDayOfWeek       0 = sun, 6 = sat
	    //                      the day of the week that starts the week
	    //                      (usually sunday or monday)
	    // firstDayOfWeekOfYear 0 = sun, 6 = sat
	    //                      the first week is the week that contains the first
	    //                      of this day of the week
	    //                      (eg. ISO weeks use thursday (4))
	    function weekOfYear(mom, firstDayOfWeek, firstDayOfWeekOfYear) {
	        var end = firstDayOfWeekOfYear - firstDayOfWeek,
	            daysToDayOfWeek = firstDayOfWeekOfYear - mom.day(),
	            adjustedMoment;
	
	
	        if (daysToDayOfWeek > end) {
	            daysToDayOfWeek -= 7;
	        }
	
	        if (daysToDayOfWeek < end - 7) {
	            daysToDayOfWeek += 7;
	        }
	
	        adjustedMoment = local__createLocal(mom).add(daysToDayOfWeek, 'd');
	        return {
	            week: Math.ceil(adjustedMoment.dayOfYear() / 7),
	            year: adjustedMoment.year()
	        };
	    }
	
	    // LOCALES
	
	    function localeWeek (mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek () {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear () {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek (input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek (input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // ALIASES
	
	    addUnitAlias('dayOfYear', 'DDD');
	
	    // PARSING
	
	    addRegexToken('DDD',  match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    //http://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, firstDayOfWeekOfYear, firstDayOfWeek) {
	        var week1Jan = 6 + firstDayOfWeek - firstDayOfWeekOfYear, janX = createUTCDate(year, 0, 1 + week1Jan), d = janX.getUTCDay(), dayOfYear;
	        if (d < firstDayOfWeek) {
	            d += 7;
	        }
	
	        weekday = weekday != null ? 1 * weekday : firstDayOfWeek;
	
	        dayOfYear = 1 + week1Jan + 7 * (week - 1) - d + weekday;
	
	        return {
	            year: dayOfYear > 0 ? year : year - 1,
	            dayOfYear: dayOfYear > 0 ?  dayOfYear : daysInYear(year - 1) + dayOfYear
	        };
	    }
	
	    // MOMENTS
	
	    function getSetDayOfYear (input) {
	        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	    }
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        var now = new Date();
	        if (config._useUTC) {
	            return [now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()];
	        }
	        return [now.getFullYear(), now.getMonth(), now.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray (config) {
	        var i, date, input = [], currentDate, yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (config._dayOfYear > daysInYear(yearToUse)) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (config._a[HOUR] === 24 &&
	                config._a[MINUTE] === 0 &&
	                config._a[SECOND] === 0 &&
	                config._a[MILLISECOND] === 0) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(local__createLocal(), 1, 4).year);
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            weekYear = defaults(w.gg, config._a[YEAR], weekOfYear(local__createLocal(), dow, doy).year);
	            week = defaults(w.w, 1);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < dow) {
	                    ++week;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from begining of week
	                weekday = w.e + dow;
	            } else {
	                // default to begining of week
	                weekday = dow;
	            }
	        }
	        temp = dayOfYearFromWeeks(weekYear, week, weekday, doy, dow);
	
	        config._a[YEAR] = temp.year;
	        config._dayOfYear = temp.dayOfYear;
	    }
	
	    utils_hooks__hooks.ISO_8601 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === utils_hooks__hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i, parsedInput, tokens, token, skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0;
	
	        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	        for (i = 0; i < tokens.length; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                }
	                else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            }
	            else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (getParsingFlags(config).bigHour === true &&
	                config._a[HOUR] <= 12 &&
	                config._a[HOUR] > 0) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	
	    function meridiemFixWrap (locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	
	            scoreToBeat,
	            i,
	            currentScore;
	
	        if (config._f.length === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < config._f.length; i++) {
	            currentScore = 0;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (!valid__isValid(tempConfig)) {
	                continue;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (scoreToBeat == null || currentScore < scoreToBeat) {
	                scoreToBeat = currentScore;
	                bestMoment = tempConfig;
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i);
	        config._a = [i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond];
	
	        configFromArray(config);
	    }
	
	    function createFromConfig (config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig (config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || locale_locales__getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return valid__createInvalid({nullInput: true});
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        } else if (isDate(input)) {
	            config._d = input;
	        } else {
	            configFromInput(config);
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (input === undefined) {
	            config._d = new Date();
	        } else if (isDate(input)) {
	            config._d = new Date(+input);
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (typeof(input) === 'object') {
	            configFromObject(config);
	        } else if (typeof(input) === 'number') {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            utils_hooks__hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC (input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (typeof(locale) === 'boolean') {
	            strict = locale;
	            locale = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function local__createLocal (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	         'moment().min is deprecated, use moment.min instead. https://github.com/moment/moment/issues/1548',
	         function () {
	             var other = local__createLocal.apply(null, arguments);
	             return other < this ? this : other;
	         }
	     );
	
	    var prototypeMax = deprecate(
	        'moment().max is deprecated, use moment.max instead. https://github.com/moment/moment/issues/1548',
	        function () {
	            var other = local__createLocal.apply(null, arguments);
	            return other > this ? this : other;
	        }
	    );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return local__createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    function Duration (duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        // representation for dateAddRemove
	        this._milliseconds = +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 36e5; // 1000 * 60 * 60
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days +
	            weeks * 7;
	        // It is impossible translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months +
	            quarters * 3 +
	            years * 12;
	
	        this._data = {};
	
	        this._locale = locale_locales__getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration (obj) {
	        return obj instanceof Duration;
	    }
	
	    function offset (token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset();
	            var sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z',  matchOffset);
	    addRegexToken('ZZ', matchOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(string) {
	        var matches = ((string || '').match(matchOffset) || []);
	        var chunk   = matches[matches.length - 1] || [];
	        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff = (isMoment(input) || isDate(input) ? +input : +local__createLocal(input)) - (+res);
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(+res._d + diff);
	            utils_hooks__hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return local__createLocal(input).local();
	        }
	    }
	
	    function getDateOffset (m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    utils_hooks__hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset (input, keepLocalTime) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(input);
	            }
	            if (Math.abs(input) < 16) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    add_subtract__addSubtract(this, create__createDuration(input - offset, 'm'), 1, false);
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    utils_hooks__hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone (input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC (keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal (keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset () {
	        if (this._tzm) {
	            this.utcOffset(this._tzm);
	        } else if (typeof this._i === 'string') {
	            this.utcOffset(offsetFromString(this._i));
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset (input) {
	        input = input ? local__createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime () {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted () {
	        if (typeof this._isDSTShifted !== 'undefined') {
	            return this._isDSTShifted;
	        }
	
	        var c = {};
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            var other = c._isUTC ? create_utc__createUTC(c._a) : local__createLocal(c._a);
	            this._isDSTShifted = this.isValid() &&
	                compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal () {
	        return !this._isUTC;
	    }
	
	    function isUtcOffset () {
	        return this._isUTC;
	    }
	
	    function isUtc () {
	        return this._isUTC && this._offset === 0;
	    }
	
	    var aspNetRegex = /(\-)?(?:(\d*)\.)?(\d+)\:(\d+)(?:\:(\d+)\.?(\d{3})?)?/;
	
	    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	    var create__isoRegex = /^(-)?P(?:(?:([0-9,.]*)Y)?(?:([0-9,.]*)M)?(?:([0-9,.]*)D)?(?:T(?:([0-9,.]*)H)?(?:([0-9,.]*)M)?(?:([0-9,.]*)S)?)?|([0-9,.]*)W)$/;
	
	    function create__createDuration (input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms : input._milliseconds,
	                d  : input._days,
	                M  : input._months
	            };
	        } else if (typeof input === 'number') {
	            duration = {};
	            if (key) {
	                duration[key] = input;
	            } else {
	                duration.milliseconds = input;
	            }
	        } else if (!!(match = aspNetRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y  : 0,
	                d  : toInt(match[DATE])        * sign,
	                h  : toInt(match[HOUR])        * sign,
	                m  : toInt(match[MINUTE])      * sign,
	                s  : toInt(match[SECOND])      * sign,
	                ms : toInt(match[MILLISECOND]) * sign
	            };
	        } else if (!!(match = create__isoRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y : parseIso(match[2], sign),
	                M : parseIso(match[3], sign),
	                d : parseIso(match[4], sign),
	                h : parseIso(match[5], sign),
	                m : parseIso(match[6], sign),
	                s : parseIso(match[7], sign),
	                w : parseIso(match[8], sign)
	            };
	        } else if (duration == null) {// checks for null or undefined
	            duration = {};
	        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	            diffRes = momentsDifference(local__createLocal(duration.from), local__createLocal(duration.to));
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        return ret;
	    }
	
	    create__createDuration.fn = Duration.prototype;
	
	    function parseIso (inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {milliseconds: 0, months: 0};
	
	        res.months = other.month() - base.month() +
	            (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period).');
	                tmp = val; val = period; period = tmp;
	            }
	
	            val = typeof val === 'string' ? +val : val;
	            dur = create__createDuration(val, period);
	            add_subtract__addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function add_subtract__addSubtract (mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = duration._days,
	            months = duration._months;
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (milliseconds) {
	            mom._d.setTime(+mom._d + milliseconds * isAdding);
	        }
	        if (days) {
	            get_set__set(mom, 'Date', get_set__get(mom, 'Date') + days * isAdding);
	        }
	        if (months) {
	            setMonth(mom, get_set__get(mom, 'Month') + months * isAdding);
	        }
	        if (updateOffset) {
	            utils_hooks__hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add_subtract__add      = createAdder(1, 'add');
	    var add_subtract__subtract = createAdder(-1, 'subtract');
	
	    function moment_calendar__calendar (time, formats) {
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || local__createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            diff = this.diff(sod, 'days', true),
	            format = diff < -6 ? 'sameElse' :
	                diff < -1 ? 'lastWeek' :
	                diff < 0 ? 'lastDay' :
	                diff < 1 ? 'sameDay' :
	                diff < 2 ? 'nextDay' :
	                diff < 7 ? 'nextWeek' : 'sameElse';
	        return this.format(formats && formats[format] || this.localeData().calendar(format, this, local__createLocal(now)));
	    }
	
	    function clone () {
	        return new Moment(this);
	    }
	
	    function isAfter (input, units) {
	        var inputMs;
	        units = normalizeUnits(typeof units !== 'undefined' ? units : 'millisecond');
	        if (units === 'millisecond') {
	            input = isMoment(input) ? input : local__createLocal(input);
	            return +this > +input;
	        } else {
	            inputMs = isMoment(input) ? +input : +local__createLocal(input);
	            return inputMs < +this.clone().startOf(units);
	        }
	    }
	
	    function isBefore (input, units) {
	        var inputMs;
	        units = normalizeUnits(typeof units !== 'undefined' ? units : 'millisecond');
	        if (units === 'millisecond') {
	            input = isMoment(input) ? input : local__createLocal(input);
	            return +this < +input;
	        } else {
	            inputMs = isMoment(input) ? +input : +local__createLocal(input);
	            return +this.clone().endOf(units) < inputMs;
	        }
	    }
	
	    function isBetween (from, to, units) {
	        return this.isAfter(from, units) && this.isBefore(to, units);
	    }
	
	    function isSame (input, units) {
	        var inputMs;
	        units = normalizeUnits(units || 'millisecond');
	        if (units === 'millisecond') {
	            input = isMoment(input) ? input : local__createLocal(input);
	            return +this === +input;
	        } else {
	            inputMs = +local__createLocal(input);
	            return +(this.clone().startOf(units)) <= inputMs && inputMs <= +(this.clone().endOf(units));
	        }
	    }
	
	    function diff (input, units, asFloat) {
	        var that = cloneWithOffset(input, this),
	            zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4,
	            delta, output;
	
	        units = normalizeUnits(units);
	
	        if (units === 'year' || units === 'month' || units === 'quarter') {
	            output = monthDiff(this, that);
	            if (units === 'quarter') {
	                output = output / 3;
	            } else if (units === 'year') {
	                output = output / 12;
	            }
	        } else {
	            delta = this - that;
	            output = units === 'second' ? delta / 1e3 : // 1000
	                units === 'minute' ? delta / 6e4 : // 1000 * 60
	                units === 'hour' ? delta / 36e5 : // 1000 * 60 * 60
	                units === 'day' ? (delta - zoneDelta) / 864e5 : // 1000 * 60 * 60 * 24, negate dst
	                units === 'week' ? (delta - zoneDelta) / 6048e5 : // 1000 * 60 * 60 * 24 * 7, negate dst
	                delta;
	        }
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff (a, b) {
	        // difference in months
	        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2, adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        return -(wholeMonthDiff + adjust);
	    }
	
	    utils_hooks__hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	
	    function toString () {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function moment_format__toISOString () {
	        var m = this.clone().utc();
	        if (0 < m.year() && m.year() <= 9999) {
	            if ('function' === typeof Date.prototype.toISOString) {
	                // native implementation is ~50x faster, use it when we can
	                return this.toDate().toISOString();
	            } else {
	                return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	            }
	        } else {
	            return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	        }
	    }
	
	    function format (inputString) {
	        var output = formatMoment(this, inputString || utils_hooks__hooks.defaultFormat);
	        return this.localeData().postformat(output);
	    }
	
	    function from (time, withoutSuffix) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	        return create__createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	    }
	
	    function fromNow (withoutSuffix) {
	        return this.from(local__createLocal(), withoutSuffix);
	    }
	
	    function to (time, withoutSuffix) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	        return create__createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	    }
	
	    function toNow (withoutSuffix) {
	        return this.to(local__createLocal(), withoutSuffix);
	    }
	
	    function locale (key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = locale_locales__getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData () {
	        return this._locale;
	    }
	
	    function startOf (units) {
	        units = normalizeUnits(units);
	        // the following switch intentionally omits break keywords
	        // to utilize falling through the cases.
	        switch (units) {
	        case 'year':
	            this.month(0);
	            /* falls through */
	        case 'quarter':
	        case 'month':
	            this.date(1);
	            /* falls through */
	        case 'week':
	        case 'isoWeek':
	        case 'day':
	            this.hours(0);
	            /* falls through */
	        case 'hour':
	            this.minutes(0);
	            /* falls through */
	        case 'minute':
	            this.seconds(0);
	            /* falls through */
	        case 'second':
	            this.milliseconds(0);
	        }
	
	        // weeks are a special case
	        if (units === 'week') {
	            this.weekday(0);
	        }
	        if (units === 'isoWeek') {
	            this.isoWeekday(1);
	        }
	
	        // quarters are also special
	        if (units === 'quarter') {
	            this.month(Math.floor(this.month() / 3) * 3);
	        }
	
	        return this;
	    }
	
	    function endOf (units) {
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond') {
	            return this;
	        }
	        return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
	    }
	
	    function to_type__valueOf () {
	        return +this._d - ((this._offset || 0) * 60000);
	    }
	
	    function unix () {
	        return Math.floor(+this / 1000);
	    }
	
	    function toDate () {
	        return this._offset ? new Date(+this) : this._d;
	    }
	
	    function toArray () {
	        var m = this;
	        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	    }
	
	    function toObject () {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds()
	        };
	    }
	
	    function moment_valid__isValid () {
	        return valid__isValid(this);
	    }
	
	    function parsingFlags () {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt () {
	        return getParsingFlags(this).overflow;
	    }
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken (token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg',     'weekYear');
	    addWeekYearFormatToken('ggggg',    'weekYear');
	    addWeekYearFormatToken('GGGG',  'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    addUnitAlias('weekYear', 'gg');
	    addUnitAlias('isoWeekYear', 'GG');
	
	    // PARSING
	
	    addRegexToken('G',      matchSigned);
	    addRegexToken('g',      matchSigned);
	    addRegexToken('GG',     match1to2, match2);
	    addRegexToken('gg',     match1to2, match2);
	    addRegexToken('GGGG',   match1to4, match4);
	    addRegexToken('gggg',   match1to4, match4);
	    addRegexToken('GGGGG',  match1to6, match6);
	    addRegexToken('ggggg',  match1to6, match6);
	
	    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	        week[token.substr(0, 2)] = toInt(input);
	    });
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = utils_hooks__hooks.parseTwoDigitYear(input);
	    });
	
	    // HELPERS
	
	    function weeksInYear(year, dow, doy) {
	        return weekOfYear(local__createLocal([year, 11, 31 + dow - doy]), dow, doy).week;
	    }
	
	    // MOMENTS
	
	    function getSetWeekYear (input) {
	        var year = weekOfYear(this, this.localeData()._week.dow, this.localeData()._week.doy).year;
	        return input == null ? year : this.add((input - year), 'y');
	    }
	
	    function getSetISOWeekYear (input) {
	        var year = weekOfYear(this, 1, 4).year;
	        return input == null ? year : this.add((input - year), 'y');
	    }
	
	    function getISOWeeksInYear () {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getWeeksInYear () {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    addFormatToken('Q', 0, 0, 'quarter');
	
	    // ALIASES
	
	    addUnitAlias('quarter', 'Q');
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter (input) {
	        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	    }
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // ALIASES
	
	    addUnitAlias('date', 'D');
	
	    // PARSING
	
	    addRegexToken('D',  match1to2);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        return isStrict ? locale._ordinalParse : locale._ordinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0], 10);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // ALIASES
	
	    addUnitAlias('day', 'd');
	    addUnitAlias('weekday', 'e');
	    addUnitAlias('isoWeekday', 'E');
	
	    // PARSING
	
	    addRegexToken('d',    match1to2);
	    addRegexToken('e',    match1to2);
	    addRegexToken('E',    match1to2);
	    addRegexToken('dd',   matchWord);
	    addRegexToken('ddd',  matchWord);
	    addRegexToken('dddd', matchWord);
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config) {
	        var weekday = config._locale.weekdaysParse(input);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    // LOCALES
	
	    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	    function localeWeekdays (m) {
	        return this._weekdays[m.day()];
	    }
	
	    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	    function localeWeekdaysShort (m) {
	        return this._weekdaysShort[m.day()];
	    }
	
	    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	    function localeWeekdaysMin (m) {
	        return this._weekdaysMin[m.day()];
	    }
	
	    function localeWeekdaysParse (weekdayName) {
	        var i, mom, regex;
	
	        this._weekdaysParse = this._weekdaysParse || [];
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            if (!this._weekdaysParse[i]) {
	                mom = local__createLocal([2000, 1]).day(i);
	                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek (input) {
	        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek (input) {
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek (input) {
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	        return input == null ? this.day() || 7 : this.day(this.day() % 7 ? input : input - 7);
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, function () {
	        return this.hours() % 12 || 12;
	    });
	
	    function meridiem (token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // ALIASES
	
	    addUnitAlias('hour', 'h');
	
	    // PARSING
	
	    function matchMeridiem (isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a',  matchMeridiem);
	    addRegexToken('A',  matchMeridiem);
	    addRegexToken('H',  match1to2);
	    addRegexToken('h',  match1to2);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	
	    // LOCALES
	
	    function localeIsPM (input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return ((input + '').toLowerCase().charAt(0) === 'p');
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	    function localeMeridiem (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	
	    // MOMENTS
	
	    // Setting the hour should keep the time, because the user explicitly
	    // specified which hour he wants. So trying to maintain the same hour (in
	    // a new timezone) makes sense. Adding/subtracting hours does not follow
	    // this rule.
	    var getSetHour = makeGetSet('Hours', true);
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // ALIASES
	
	    addUnitAlias('minute', 'm');
	
	    // PARSING
	
	    addRegexToken('m',  match1to2);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // ALIASES
	
	    addUnitAlias('second', 's');
	
	    // PARSING
	
	    addRegexToken('s',  match1to2);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	
	    // ALIASES
	
	    addUnitAlias('millisecond', 'ms');
	
	    // PARSING
	
	    addRegexToken('S',    match1to3, match1);
	    addRegexToken('SS',   match1to3, match2);
	    addRegexToken('SSS',  match1to3, match3);
	
	    var token;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	    // MOMENTS
	
	    var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    addFormatToken('z',  0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr () {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName () {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var momentPrototype__proto = Moment.prototype;
	
	    momentPrototype__proto.add          = add_subtract__add;
	    momentPrototype__proto.calendar     = moment_calendar__calendar;
	    momentPrototype__proto.clone        = clone;
	    momentPrototype__proto.diff         = diff;
	    momentPrototype__proto.endOf        = endOf;
	    momentPrototype__proto.format       = format;
	    momentPrototype__proto.from         = from;
	    momentPrototype__proto.fromNow      = fromNow;
	    momentPrototype__proto.to           = to;
	    momentPrototype__proto.toNow        = toNow;
	    momentPrototype__proto.get          = getSet;
	    momentPrototype__proto.invalidAt    = invalidAt;
	    momentPrototype__proto.isAfter      = isAfter;
	    momentPrototype__proto.isBefore     = isBefore;
	    momentPrototype__proto.isBetween    = isBetween;
	    momentPrototype__proto.isSame       = isSame;
	    momentPrototype__proto.isValid      = moment_valid__isValid;
	    momentPrototype__proto.lang         = lang;
	    momentPrototype__proto.locale       = locale;
	    momentPrototype__proto.localeData   = localeData;
	    momentPrototype__proto.max          = prototypeMax;
	    momentPrototype__proto.min          = prototypeMin;
	    momentPrototype__proto.parsingFlags = parsingFlags;
	    momentPrototype__proto.set          = getSet;
	    momentPrototype__proto.startOf      = startOf;
	    momentPrototype__proto.subtract     = add_subtract__subtract;
	    momentPrototype__proto.toArray      = toArray;
	    momentPrototype__proto.toObject     = toObject;
	    momentPrototype__proto.toDate       = toDate;
	    momentPrototype__proto.toISOString  = moment_format__toISOString;
	    momentPrototype__proto.toJSON       = moment_format__toISOString;
	    momentPrototype__proto.toString     = toString;
	    momentPrototype__proto.unix         = unix;
	    momentPrototype__proto.valueOf      = to_type__valueOf;
	
	    // Year
	    momentPrototype__proto.year       = getSetYear;
	    momentPrototype__proto.isLeapYear = getIsLeapYear;
	
	    // Week Year
	    momentPrototype__proto.weekYear    = getSetWeekYear;
	    momentPrototype__proto.isoWeekYear = getSetISOWeekYear;
	
	    // Quarter
	    momentPrototype__proto.quarter = momentPrototype__proto.quarters = getSetQuarter;
	
	    // Month
	    momentPrototype__proto.month       = getSetMonth;
	    momentPrototype__proto.daysInMonth = getDaysInMonth;
	
	    // Week
	    momentPrototype__proto.week           = momentPrototype__proto.weeks        = getSetWeek;
	    momentPrototype__proto.isoWeek        = momentPrototype__proto.isoWeeks     = getSetISOWeek;
	    momentPrototype__proto.weeksInYear    = getWeeksInYear;
	    momentPrototype__proto.isoWeeksInYear = getISOWeeksInYear;
	
	    // Day
	    momentPrototype__proto.date       = getSetDayOfMonth;
	    momentPrototype__proto.day        = momentPrototype__proto.days             = getSetDayOfWeek;
	    momentPrototype__proto.weekday    = getSetLocaleDayOfWeek;
	    momentPrototype__proto.isoWeekday = getSetISODayOfWeek;
	    momentPrototype__proto.dayOfYear  = getSetDayOfYear;
	
	    // Hour
	    momentPrototype__proto.hour = momentPrototype__proto.hours = getSetHour;
	
	    // Minute
	    momentPrototype__proto.minute = momentPrototype__proto.minutes = getSetMinute;
	
	    // Second
	    momentPrototype__proto.second = momentPrototype__proto.seconds = getSetSecond;
	
	    // Millisecond
	    momentPrototype__proto.millisecond = momentPrototype__proto.milliseconds = getSetMillisecond;
	
	    // Offset
	    momentPrototype__proto.utcOffset            = getSetOffset;
	    momentPrototype__proto.utc                  = setOffsetToUTC;
	    momentPrototype__proto.local                = setOffsetToLocal;
	    momentPrototype__proto.parseZone            = setOffsetToParsedOffset;
	    momentPrototype__proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    momentPrototype__proto.isDST                = isDaylightSavingTime;
	    momentPrototype__proto.isDSTShifted         = isDaylightSavingTimeShifted;
	    momentPrototype__proto.isLocal              = isLocal;
	    momentPrototype__proto.isUtcOffset          = isUtcOffset;
	    momentPrototype__proto.isUtc                = isUtc;
	    momentPrototype__proto.isUTC                = isUtc;
	
	    // Timezone
	    momentPrototype__proto.zoneAbbr = getZoneAbbr;
	    momentPrototype__proto.zoneName = getZoneName;
	
	    // Deprecations
	    momentPrototype__proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	    momentPrototype__proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	    momentPrototype__proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	    momentPrototype__proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. https://github.com/moment/moment/issues/1779', getSetZone);
	
	    var momentPrototype = momentPrototype__proto;
	
	    function moment__createUnix (input) {
	        return local__createLocal(input * 1000);
	    }
	
	    function moment__createInZone () {
	        return local__createLocal.apply(null, arguments).parseZone();
	    }
	
	    var defaultCalendar = {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    };
	
	    function locale_calendar__calendar (key, mom, now) {
	        var output = this._calendar[key];
	        return typeof output === 'function' ? output.call(mom, now) : output;
	    }
	
	    var defaultLongDateFormat = {
	        LTS  : 'h:mm:ss A',
	        LT   : 'h:mm A',
	        L    : 'MM/DD/YYYY',
	        LL   : 'MMMM D, YYYY',
	        LLL  : 'MMMM D, YYYY h:mm A',
	        LLLL : 'dddd, MMMM D, YYYY h:mm A'
	    };
	
	    function longDateFormat (key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	            return val.slice(1);
	        });
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate () {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d';
	    var defaultOrdinalParse = /\d{1,2}/;
	
	    function ordinal (number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    function preParsePostFormat (string) {
	        return string;
	    }
	
	    var defaultRelativeTime = {
	        future : 'in %s',
	        past   : '%s ago',
	        s  : 'a few seconds',
	        m  : 'a minute',
	        mm : '%d minutes',
	        h  : 'an hour',
	        hh : '%d hours',
	        d  : 'a day',
	        dd : '%d days',
	        M  : 'a month',
	        MM : '%d months',
	        y  : 'a year',
	        yy : '%d years'
	    };
	
	    function relative__relativeTime (number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return (typeof output === 'function') ?
	            output(number, withoutSuffix, string, isFuture) :
	            output.replace(/%d/i, number);
	    }
	
	    function pastFuture (diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return typeof format === 'function' ? format(output) : format.replace(/%s/i, output);
	    }
	
	    function locale_set__set (config) {
	        var prop, i;
	        for (i in config) {
	            prop = config[i];
	            if (typeof prop === 'function') {
	                this[i] = prop;
	            } else {
	                this['_' + i] = prop;
	            }
	        }
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _ordinalParseLenient.
	        this._ordinalParseLenient = new RegExp(this._ordinalParse.source + '|' + (/\d{1,2}/).source);
	    }
	
	    var prototype__proto = Locale.prototype;
	
	    prototype__proto._calendar       = defaultCalendar;
	    prototype__proto.calendar        = locale_calendar__calendar;
	    prototype__proto._longDateFormat = defaultLongDateFormat;
	    prototype__proto.longDateFormat  = longDateFormat;
	    prototype__proto._invalidDate    = defaultInvalidDate;
	    prototype__proto.invalidDate     = invalidDate;
	    prototype__proto._ordinal        = defaultOrdinal;
	    prototype__proto.ordinal         = ordinal;
	    prototype__proto._ordinalParse   = defaultOrdinalParse;
	    prototype__proto.preparse        = preParsePostFormat;
	    prototype__proto.postformat      = preParsePostFormat;
	    prototype__proto._relativeTime   = defaultRelativeTime;
	    prototype__proto.relativeTime    = relative__relativeTime;
	    prototype__proto.pastFuture      = pastFuture;
	    prototype__proto.set             = locale_set__set;
	
	    // Month
	    prototype__proto.months       =        localeMonths;
	    prototype__proto._months      = defaultLocaleMonths;
	    prototype__proto.monthsShort  =        localeMonthsShort;
	    prototype__proto._monthsShort = defaultLocaleMonthsShort;
	    prototype__proto.monthsParse  =        localeMonthsParse;
	
	    // Week
	    prototype__proto.week = localeWeek;
	    prototype__proto._week = defaultLocaleWeek;
	    prototype__proto.firstDayOfYear = localeFirstDayOfYear;
	    prototype__proto.firstDayOfWeek = localeFirstDayOfWeek;
	
	    // Day of Week
	    prototype__proto.weekdays       =        localeWeekdays;
	    prototype__proto._weekdays      = defaultLocaleWeekdays;
	    prototype__proto.weekdaysMin    =        localeWeekdaysMin;
	    prototype__proto._weekdaysMin   = defaultLocaleWeekdaysMin;
	    prototype__proto.weekdaysShort  =        localeWeekdaysShort;
	    prototype__proto._weekdaysShort = defaultLocaleWeekdaysShort;
	    prototype__proto.weekdaysParse  =        localeWeekdaysParse;
	
	    // Hours
	    prototype__proto.isPM = localeIsPM;
	    prototype__proto._meridiemParse = defaultLocaleMeridiemParse;
	    prototype__proto.meridiem = localeMeridiem;
	
	    function lists__get (format, index, field, setter) {
	        var locale = locale_locales__getLocale();
	        var utc = create_utc__createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function list (format, index, field, count, setter) {
	        if (typeof format === 'number') {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return lists__get(format, index, field, setter);
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < count; i++) {
	            out[i] = lists__get(format, i, field, setter);
	        }
	        return out;
	    }
	
	    function lists__listMonths (format, index) {
	        return list(format, index, 'months', 12, 'month');
	    }
	
	    function lists__listMonthsShort (format, index) {
	        return list(format, index, 'monthsShort', 12, 'month');
	    }
	
	    function lists__listWeekdays (format, index) {
	        return list(format, index, 'weekdays', 7, 'day');
	    }
	
	    function lists__listWeekdaysShort (format, index) {
	        return list(format, index, 'weekdaysShort', 7, 'day');
	    }
	
	    function lists__listWeekdaysMin (format, index) {
	        return list(format, index, 'weekdaysMin', 7, 'day');
	    }
	
	    locale_locales__getSetGlobalLocale('en', {
	        ordinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (toInt(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    // Side effect imports
	    utils_hooks__hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', locale_locales__getSetGlobalLocale);
	    utils_hooks__hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', locale_locales__getLocale);
	
	    var mathAbs = Math.abs;
	
	    function duration_abs__abs () {
	        var data           = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days         = mathAbs(this._days);
	        this._months       = mathAbs(this._months);
	
	        data.milliseconds  = mathAbs(data.milliseconds);
	        data.seconds       = mathAbs(data.seconds);
	        data.minutes       = mathAbs(data.minutes);
	        data.hours         = mathAbs(data.hours);
	        data.months        = mathAbs(data.months);
	        data.years         = mathAbs(data.years);
	
	        return this;
	    }
	
	    function duration_add_subtract__addSubtract (duration, input, value, direction) {
	        var other = create__createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days         += direction * other._days;
	        duration._months       += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function duration_add_subtract__add (input, value) {
	        return duration_add_subtract__addSubtract(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function duration_add_subtract__subtract (input, value) {
	        return duration_add_subtract__addSubtract(this, input, value, -1);
	    }
	
	    function absCeil (number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble () {
	        var milliseconds = this._milliseconds;
	        var days         = this._days;
	        var months       = this._months;
	        var data         = this._data;
	        var seconds, minutes, hours, years, monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0))) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds           = absFloor(milliseconds / 1000);
	        data.seconds      = seconds % 60;
	
	        minutes           = absFloor(seconds / 60);
	        data.minutes      = minutes % 60;
	
	        hours             = absFloor(minutes / 60);
	        data.hours        = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days   = days;
	        data.months = months;
	        data.years  = years;
	
	        return this;
	    }
	
	    function daysToMonths (days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return days * 4800 / 146097;
	    }
	
	    function monthsToDays (months) {
	        // the reverse of daysToMonths
	        return months * 146097 / 4800;
	    }
	
	    function as (units) {
	        var days;
	        var months;
	        var milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'year') {
	            days   = this._days   + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            return units === 'month' ? months : months / 12;
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week'   : return days / 7     + milliseconds / 6048e5;
	                case 'day'    : return days         + milliseconds / 864e5;
	                case 'hour'   : return days * 24    + milliseconds / 36e5;
	                case 'minute' : return days * 1440  + milliseconds / 6e4;
	                case 'second' : return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	                default: throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    // TODO: Use this.as('ms')?
	    function duration_as__valueOf () {
	        return (
	            this._milliseconds +
	            this._days * 864e5 +
	            (this._months % 12) * 2592e6 +
	            toInt(this._months / 12) * 31536e6
	        );
	    }
	
	    function makeAs (alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms');
	    var asSeconds      = makeAs('s');
	    var asMinutes      = makeAs('m');
	    var asHours        = makeAs('h');
	    var asDays         = makeAs('d');
	    var asWeeks        = makeAs('w');
	    var asMonths       = makeAs('M');
	    var asYears        = makeAs('y');
	
	    function duration_get__get (units) {
	        units = normalizeUnits(units);
	        return this[units + 's']();
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this._data[name];
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds');
	    var seconds      = makeGetter('seconds');
	    var minutes      = makeGetter('minutes');
	    var hours        = makeGetter('hours');
	    var days         = makeGetter('days');
	    var months       = makeGetter('months');
	    var years        = makeGetter('years');
	
	    function weeks () {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round;
	    var thresholds = {
	        s: 45,  // seconds to minute
	        m: 45,  // minutes to hour
	        h: 22,  // hours to day
	        d: 26,  // days to month
	        M: 11   // months to year
	    };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function duration_humanize__relativeTime (posNegDuration, withoutSuffix, locale) {
	        var duration = create__createDuration(posNegDuration).abs();
	        var seconds  = round(duration.as('s'));
	        var minutes  = round(duration.as('m'));
	        var hours    = round(duration.as('h'));
	        var days     = round(duration.as('d'));
	        var months   = round(duration.as('M'));
	        var years    = round(duration.as('y'));
	
	        var a = seconds < thresholds.s && ['s', seconds]  ||
	                minutes === 1          && ['m']           ||
	                minutes < thresholds.m && ['mm', minutes] ||
	                hours   === 1          && ['h']           ||
	                hours   < thresholds.h && ['hh', hours]   ||
	                days    === 1          && ['d']           ||
	                days    < thresholds.d && ['dd', days]    ||
	                months  === 1          && ['M']           ||
	                months  < thresholds.M && ['MM', months]  ||
	                years   === 1          && ['y']           || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function duration_humanize__getSetRelativeTimeThreshold (threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        return true;
	    }
	
	    function humanize (withSuffix) {
	        var locale = this.localeData();
	        var output = duration_humanize__relativeTime(this, !withSuffix, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var iso_string__abs = Math.abs;
	
	    function iso_string__toISOString() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        var seconds = iso_string__abs(this._milliseconds) / 1000;
	        var days         = iso_string__abs(this._days);
	        var months       = iso_string__abs(this._months);
	        var minutes, hours, years;
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes           = absFloor(seconds / 60);
	        hours             = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years  = absFloor(months / 12);
	        months %= 12;
	
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        var Y = years;
	        var M = months;
	        var D = days;
	        var h = hours;
	        var m = minutes;
	        var s = seconds;
	        var total = this.asSeconds();
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        return (total < 0 ? '-' : '') +
	            'P' +
	            (Y ? Y + 'Y' : '') +
	            (M ? M + 'M' : '') +
	            (D ? D + 'D' : '') +
	            ((h || m || s) ? 'T' : '') +
	            (h ? h + 'H' : '') +
	            (m ? m + 'M' : '') +
	            (s ? s + 'S' : '');
	    }
	
	    var duration_prototype__proto = Duration.prototype;
	
	    duration_prototype__proto.abs            = duration_abs__abs;
	    duration_prototype__proto.add            = duration_add_subtract__add;
	    duration_prototype__proto.subtract       = duration_add_subtract__subtract;
	    duration_prototype__proto.as             = as;
	    duration_prototype__proto.asMilliseconds = asMilliseconds;
	    duration_prototype__proto.asSeconds      = asSeconds;
	    duration_prototype__proto.asMinutes      = asMinutes;
	    duration_prototype__proto.asHours        = asHours;
	    duration_prototype__proto.asDays         = asDays;
	    duration_prototype__proto.asWeeks        = asWeeks;
	    duration_prototype__proto.asMonths       = asMonths;
	    duration_prototype__proto.asYears        = asYears;
	    duration_prototype__proto.valueOf        = duration_as__valueOf;
	    duration_prototype__proto._bubble        = bubble;
	    duration_prototype__proto.get            = duration_get__get;
	    duration_prototype__proto.milliseconds   = milliseconds;
	    duration_prototype__proto.seconds        = seconds;
	    duration_prototype__proto.minutes        = minutes;
	    duration_prototype__proto.hours          = hours;
	    duration_prototype__proto.days           = days;
	    duration_prototype__proto.weeks          = weeks;
	    duration_prototype__proto.months         = months;
	    duration_prototype__proto.years          = years;
	    duration_prototype__proto.humanize       = humanize;
	    duration_prototype__proto.toISOString    = iso_string__toISOString;
	    duration_prototype__proto.toString       = iso_string__toISOString;
	    duration_prototype__proto.toJSON         = iso_string__toISOString;
	    duration_prototype__proto.locale         = locale;
	    duration_prototype__proto.localeData     = localeData;
	
	    // Deprecations
	    duration_prototype__proto.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', iso_string__toISOString);
	    duration_prototype__proto.lang = lang;
	
	    // Side effect imports
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input, 10) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    // Side effect imports
	
	
	    utils_hooks__hooks.version = '2.10.6';
	
	    setHookCallback(local__createLocal);
	
	    utils_hooks__hooks.fn                    = momentPrototype;
	    utils_hooks__hooks.min                   = min;
	    utils_hooks__hooks.max                   = max;
	    utils_hooks__hooks.utc                   = create_utc__createUTC;
	    utils_hooks__hooks.unix                  = moment__createUnix;
	    utils_hooks__hooks.months                = lists__listMonths;
	    utils_hooks__hooks.isDate                = isDate;
	    utils_hooks__hooks.locale                = locale_locales__getSetGlobalLocale;
	    utils_hooks__hooks.invalid               = valid__createInvalid;
	    utils_hooks__hooks.duration              = create__createDuration;
	    utils_hooks__hooks.isMoment              = isMoment;
	    utils_hooks__hooks.weekdays              = lists__listWeekdays;
	    utils_hooks__hooks.parseZone             = moment__createInZone;
	    utils_hooks__hooks.localeData            = locale_locales__getLocale;
	    utils_hooks__hooks.isDuration            = isDuration;
	    utils_hooks__hooks.monthsShort           = lists__listMonthsShort;
	    utils_hooks__hooks.weekdaysMin           = lists__listWeekdaysMin;
	    utils_hooks__hooks.defineLocale          = defineLocale;
	    utils_hooks__hooks.weekdaysShort         = lists__listWeekdaysShort;
	    utils_hooks__hooks.normalizeUnits        = normalizeUnits;
	    utils_hooks__hooks.relativeTimeThreshold = duration_humanize__getSetRelativeTimeThreshold;
	
	    var _moment = utils_hooks__hooks;
	
	    return _moment;
	
	}));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59)(module)))

/***/ },
/* 59 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root, factory) {
	  if (true) {
	    // AMD. Register as an anonymous module unless amdModuleId is set
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(58)], __WEBPACK_AMD_DEFINE_RESULT__ = function (a0) {
	      return (root['DateRange'] = factory(a0));
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    // Node. Does not work with strict CommonJS, but
	    // only CommonJS-like environments that support module.exports,
	    // like Node.
	    module.exports = factory(require("moment"));
	  } else {
	    root['DateRange'] = factory(moment);
	  }
	}(this, function (moment) {
	
	//-----------------------------------------------------------------------------
	// Contstants
	//-----------------------------------------------------------------------------
	
	
	
	var INTERVALS = {
	  year:   true,
	  month:  true,
	  week:   true,
	  day:    true,
	  hour:   true,
	  minute: true,
	  second: true
	};
	
	
	//-----------------------------------------------------------------------------
	// Date Ranges
	//-----------------------------------------------------------------------------
	
	/**
	 * DateRange class to store ranges and query dates.
	 *
	 * @constructor
	 * @param {(Moment|Date)} start Start of interval
	 * @param {(Moment|Date)} end End of interval
	 *//**
	 * DateRange class to store ranges and query dates.
	 *
	 * @constructor
	 * @param {!Array} range Array containing start and end dates.
	 *//**
	 * DateRange class to store ranges and query dates.
	 *
	 * @constructor
	 * @param {!String} range String formatted as an IS0 8601 time interval
	 */
	function DateRange(start, end) {
	  var parts;
	  var s = start;
	  var e = end;
	
	  if (arguments.length === 1 || end === undefined) {
	    if (typeof start === 'object' && start.length === 2) {
	      s = start[0];
	      e = start[1];
	    }
	    else if (typeof start === 'string') {
	      parts = start.split('/');
	      s = parts[0];
	      e = parts[1];
	    }
	  }
	
	  this.start = moment(s);
	  this.end   = moment(e);
	}
	
	/**
	 * Constructor for prototype.
	 *
	 * @type {DateRange}
	 */
	DateRange.prototype.constructor = DateRange;
	
	/**
	 * Deep clone range.
	 *
	 * @return {!DateRange}
	 */
	DateRange.prototype.clone = function() {
	  return moment().range(this.start, this.end);
	};
	
	/**
	 * Determine if the current interval contains a given moment/date/range.
	 *
	 * @param {(Moment|Date|DateRange)} other Date to check
	 * @param {!boolean} exclusive True if the to value is exclusive
	 *
	 * @return {!boolean}
	 */
	DateRange.prototype.contains = function(other, exclusive) {
	  var start = this.start;
	  var end   = this.end;
	
	  if (other instanceof DateRange) {
	    return start <= other.start && (end > other.end || (end.isSame(other.end) && !exclusive));
	  }
	  else {
	    return start <= other && (end > other || (end.isSame(other) && !exclusive));
	  }
	};
	
	/**
	 * Determine if the current date range overlaps a given date range.
	 *
	 * @param {!DateRange} range Date range to check
	 *
	 * @return {!boolean}
	 */
	DateRange.prototype.overlaps = function(range) {
	  return this.intersect(range) !== null;
	};
	
	/**
	 * Determine the intersecting periods from one or more date ranges.
	 *
	 * @param {!DateRange} other A date range to intersect with this one
	 *
	 * @return {DateRange} Returns the intersecting date or `null` if the ranges do
	 *                     not intersect
	 */
	DateRange.prototype.intersect = function(other) {
	  var start = this.start;
	  var end   = this.end;
	
	  if ((start <= other.start) && (other.start < end) && (end < other.end)) {
	    return new DateRange(other.start, end);
	  }
	  else if ((other.start < start) && (start < other.end) && (other.end <= end)) {
	    return new DateRange(start, other.end);
	  }
	  else if ((other.start < start) && (start <= end) && (end < other.end)) {
	    return this;
	  }
	  else if ((start <= other.start) && (other.start <= other.end) && (other.end <= end)) {
	    return other;
	  }
	
	  return null;
	};
	
	/**
	 * Merge date ranges if they intersect.
	 *
	 * @param {!DateRange} other A date range to add to this one
	 *
	 * @return {DateRange} Returns the new `DateRange` or `null` if they do not
	 *                     overlap
	 */
	DateRange.prototype.add = function(other) {
	  if (this.overlaps(other)) {
	    return new DateRange(moment.min(this.start, other.start), moment.max(this.end, other.end));
	  }
	
	  return null;
	};
	
	/**
	 * Subtract one range from another.
	 *
	 * @param {!DateRange} other A date range to substract from this one
	 *
	 * @return {!Array<DateRange>}
	 */
	DateRange.prototype.subtract = function(other) {
	  var start = this.start;
	  var end   = this.end;
	
	  if (this.intersect(other) === null) {
	    return [this];
	  }
	  else if ((other.start <= start) && (start < end) && (end <= other.end)) {
	    return [];
	  }
	  else if ((other.start <= start) && (start < other.end) && (other.end < end)) {
	    return [new DateRange(other.end, end)];
	  }
	  else if ((start < other.start) && (other.start < end) && (end <= other.end)) {
	    return [new DateRange(start, other.start)];
	  }
	  else if ((start < other.start) && (other.start < other.end) && (other.end < end)) {
	    return [new DateRange(start, other.start), new DateRange(other.end, end)];
	  }
	  else if ((start < other.start) && (other.start < end) && (other.end < end)) {
	    return [new DateRange(start, other.start), new DateRange(other.start, end)];
	  }
	};
	
	/**
	 * Iterate over the date range by a given date range, executing a function
	 * for each sub-range.
	 *
	 * @param {(!DateRange|String)} range Date range to be used for iteration or
	 *                                    shorthand string (shorthands:
	 *                                    http://momentjs.com/docs/#/manipulating/add/)
	 * @param {!DateRange~by} hollaback Callback
	 * @param {!boolean} exclusive Indicate that the end of the range should not
	 *                             be included in the iter.
	 *
	 * @return {DateRange} `this`
	 */
	DateRange.prototype.by = function(range, hollaback, exclusive) {
	  if (typeof range === 'string') {
	    _byString.call(this, range, hollaback, exclusive);
	  }
	  else {
	    _byRange.call(this, range, hollaback, exclusive);
	  }
	  return this;
	};
	
	
	/**
	 * Callback executed for each sub-range.
	 *
	 * @callback DateRange~by
	 *
	 * @param {!Moment} current Current moment object for iteration
	 */
	
	/**
	 * @private
	 */
	function _byString(interval, hollaback, exclusive) {
	  var current = moment(this.start);
	
	  while (this.contains(current, exclusive)) {
	    hollaback.call(this, current.clone());
	    current.add(1, interval);
	  }
	}
	
	/**
	 * @private
	 */
	function _byRange(interval, hollaback, exclusive) {
	  var div = this / interval;
	  var l = Math.floor(div);
	
	  if (l === Infinity) { return; }
	  if (l === div && exclusive) {
	    l--;
	  }
	
	  for (var i = 0; i <= l; i++) {
	    hollaback.call(this, moment(this.start.valueOf() + interval.valueOf() * i));
	  }
	}
	
	/**
	 * Date range formatted as an [ISO8601 Time
	 * Interval](http://en.wikipedia.org/wiki/ISO_8601#Time_intervals).
	 *
	 * @return {!String}
	 */
	DateRange.prototype.toString = function() {
	  return this.start.format() + '/' + this.end.format();
	};
	
	/**
	 * Date range in milliseconds. Allows basic coercion math of date ranges.
	 *
	 * @return {!number}
	 */
	DateRange.prototype.valueOf = function() {
	  return this.end - this.start;
	};
	
	/**
	 * Center date of the range.
	 *
	 * @return {!Moment}
	 */
	DateRange.prototype.center = function() {
	  var center = this.start + this.diff() / 2;
	  return moment(center);
	};
	
	/**
	 * Date range toDate
	 *
	 * @return {!Array<Date>}
	 */
	DateRange.prototype.toDate = function() {
	  return [this.start.toDate(), this.end.toDate()];
	};
	
	/**
	 * Determine if this date range is the same as another.
	 *
	 * @param {!DateRange} other Another date range to compare to
	 *
	 * @return {!boolean}
	 */
	DateRange.prototype.isSame = function(other) {
	  return this.start.isSame(other.start) && this.end.isSame(other.end);
	};
	
	/**
	 * The difference of the end vs start.
	 *
	 * @param {number} unit Unit of difference, if no unit is passed in
	 *                      milliseconds are returned. E.g.: `"days"`, `"months"`,
	 *                      etc...
	 *
	 * @return {!number}
	 */
	DateRange.prototype.diff = function(unit) {
	  return this.end.diff(this.start, unit);
	};
	
	
	//-----------------------------------------------------------------------------
	// Moment Extensions
	//-----------------------------------------------------------------------------
	
	/**
	 * Build a date range.
	 *
	 * @param {(Moment|Date)} start Start of range
	 * @param {(Moment|Date)} end End of range
	 *
	 * @this {Moment}
	 *
	 * @return {!DateRange}
	 */
	moment.range = function(start, end) {
	  if (start in INTERVALS) {
	    return new DateRange(moment(this).startOf(start), moment(this).endOf(start));
	  }
	  else {
	    return new DateRange(start, end);
	  }
	};
	
	/**
	 * Expose constructor
	 *
	 * @const
	 */
	moment.range.constructor = DateRange;
	
	/**
	 * @deprecated
	 */
	moment.fn.range = moment.range;
	
	/**
	 * Check if the current moment is within a given date range.
	 *
	 * @param {!DateRange} range Date range to check
	 *
	 * @this {Moment}
	 *
	 * @return {!boolean}
	 */
	moment.fn.within = function(range) {
	  return range.contains(this._d);
	};
	
	
	//-----------------------------------------------------------------------------
	// Export
	//-----------------------------------------------------------------------------
	
	
	
	return DateRange;
	
	}));


/***/ },
/* 61 */
/***/ function(module, exports) {

	/* global OFS_I18N */
	"use strict";
	
	module.exports = OFS_I18N || {};

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _utilsGetSettings = __webpack_require__(63);
	
	var _utilsGetSettings2 = _interopRequireDefault(_utilsGetSettings);
	
	exports['default'] = (0, _utilsGetSettings2['default'])();
	module.exports = exports['default'];

/***/ },
/* 63 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = getSettings;
	
	function getSettings() {
	  if (typeof global.OFS_SETTINGS === 'undefined') {
	    throw new Error('JS settings not defined');
	  }
	
	  return global.OFS_SETTINGS;
	}
	
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : french (fr)
	//! author : John Fischer : https://github.com/jfroffice
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(58)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var fr = moment.defineLocale('fr', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Aujourd\'hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        ordinalParse: /\d{1,2}(er|)/,
	        ordinal : function (number) {
	            return number + (number === 1 ? 'er' : '');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fr;
	
	}));

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : great britain english (en-gb)
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	(function (global, factory) {
	    true ? factory(__webpack_require__(58)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var en_gb = moment.defineLocale('en-gb', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return en_gb;
	
	}));

/***/ },
/* 66 */
/***/ function(module, exports) {

	module.exports = _;

/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _objectWithoutProperties = __webpack_require__(53)['default'];
	
	var i18n = __webpack_require__(61);
	var gettext = i18n.gettext;
	var interpolate = i18n.interpolate;
	
	var React = __webpack_require__(40);
	var Immutable = __webpack_require__(68);
	var PureRenderMixin = __webpack_require__(40).addons.PureRenderMixin;
	var Fluxxor = __webpack_require__(69);
	var FluxMixin = Fluxxor.FluxMixin(React);
	var StoreWatchMixin = Fluxxor.StoreWatchMixin;
	var tracker = __webpack_require__(166);
	var ReactForms = __webpack_require__(169);
	var Form = ReactForms.Form;
	
	var buildSchema = __webpack_require__(193);
	var Footer = __webpack_require__(274).Footer;
	
	var http = __webpack_require__(275);
	http.post = __webpack_require__(307);
	
	var messages = {
	  HEADING: gettext('Enquire about %(home)s, %(city)s'),
	  SUBMITTING: gettext('Submitting…'),
	  SUCCESS_HEADING: gettext('Thank you for your enquiry'),
	  SUCCESS_MESSAGE: gettext('We\'ll get back to you soon.'),
	  ERROR_HEADING: gettext('Something went wrong'),
	  ERROR_DEFAULT_MESSAGE: gettext('There was a problem with your submission.'),
	  ENQUIRE_ABOUT_UNIT: gettext('Enquire about %(home_name)s, %(city_name)s'),
	  FOOTER_PHONE_SEARCH: gettext('Call reservations on %(phone_number)s'),
	  FOOTER_PHONE_CITY: gettext('Call our %(city)s team on %(phone_number)s'),
	  FOOTER_PHONE_GLOBAL: gettext('Call our team on %(phone_number)s'),
	  FOOTER_EMAIL: gettext('Email <a href="%(email_url)s">%(email)s</a>'),
	  SUBMIT_BUTTON: gettext('Send enquiry'),
	  REQUIRED_FIELD: gettext('* indicates a required field')
	};
	
	var settings = __webpack_require__(62);
	var cities = settings.cities;
	
	var OFSForm = React.createClass({
	  displayName: 'OFSForm',
	
	  mixins: [PureRenderMixin],
	
	  render: function render() {
	    var _props = this.props;
	    var children = _props.children;
	
	    var props = _objectWithoutProperties(_props, ['children']);
	
	    return React.createElement(
	      'form',
	      props,
	      children,
	      React.createElement(
	        'div',
	        { className: 'ofs-EnquiryForm__Actions' },
	        React.createElement(
	          'button',
	          { className: 'ofs-Button' },
	          messages.SUBMIT_BUTTON
	        ),
	        React.createElement(
	          'div',
	          { className: 'ofs-Form__HelpText rf-Required' },
	          messages.REQUIRED_FIELD
	        )
	      )
	    );
	  }
	});
	
	var ContactForm = React.createClass({
	  displayName: 'ContactForm',
	
	  mixins: [PureRenderMixin, FluxMixin, StoreWatchMixin("EnquiryStore", "GuestStore")],
	
	  getInitialState: function getInitialState() {
	    return {
	      status: 'default',
	      contactPreference: 'email'
	    };
	  },
	
	  getStateFromFlux: function getStateFromFlux() {
	    var flux = this.getFlux();
	    var enquiryStoreState = flux.store('EnquiryStore').state;
	    var guestStoreState = flux.store('GuestStore').state;
	    var defaultValues = enquiryStoreState.merge(guestStoreState);
	
	    var contactPreference = 'email';
	
	    if (this.state) {
	      contactPreference = this.state.contactPreference;
	    }
	    var schema = buildSchema(contactPreference, defaultValues);
	
	    return { defaultValues: defaultValues, schema: schema };
	  },
	
	  onUpdate: function onUpdate(value, validation, update) {
	    var field = Immutable.List(update).last();
	    var changedValue = value.getIn(update);
	    var newState = {};
	
	    if (field === 'contact_preference') {
	      newState['contactPreference'] = changedValue;
	      newState['schema'] = buildSchema(changedValue, this.state.defaultValues);
	    } else if (field === 'location') {
	      newState['cityCode'] = changedValue;
	    }
	
	    this.setState(newState);
	  },
	
	  onSubmit: function onSubmit(event) {
	    var data;
	    event.preventDefault();
	    this.refs.form.makeDirty();
	
	    if (!this.refs.form.isValid()) {
	      return;
	    }
	
	    data = this.refs.form.getValue().toJSON();
	    data.enquiry_option = 'home_enquiry';
	    data.location = cities[this.props.city].name;
	    data.unit = this.props.unitShortCode;
	
	    if (this.props.enquireAvailability) {
	      data.enquire_availability = true;
	    }
	
	    var source = this.props.source;
	    tracker.submitEnquiry(source, data);
	    http.post(settings.urls.enquiry, data, (function (response) {
	      if (response.statusCode !== 200) {
	        this.setState({
	          status: 'error',
	          error: null
	        });
	      } else {
	        tracker.confirmedEnquiry(source);
	        this.getFlux().actions.tracking.sendEnquiryEvent({ source: source, eventType: 'home-enquiry' });
	        this.setState({ status: 'success' });
	      }
	    }).bind(this)).on('error', (function (e) {
	      this.setState({
	        status: 'error',
	        error: e.message
	      });
	    }).bind(this));
	
	    this.setState({ status: 'submitting' });
	  },
	
	  render: function render() {
	    var status = this.state.status;
	    var cityCode = this.props.city;
	    var cityName = null;
	
	    if (cityCode !== "" && cityCode !== null && cityCode !== undefined) {
	      cityName = cities[cityCode].name;
	    }
	    var heading = interpolate(messages.HEADING, { home: this.props.unit, city: cityName }, true);
	
	    return React.createElement(
	      'section',
	      { className: 'ofs-EnquiryForm' },
	      React.createElement(
	        'div',
	        { className: 'ofs-EnquiryForm__Content' },
	        React.createElement(
	          'h2',
	          { className: 'ofs-EnquiryForm__Title' },
	          heading
	        ),
	        status === 'default' && React.createElement(Form, { component: OFSForm,
	          className: 'ofs-Form -form--condensed',
	          ref: 'form',
	          method: 'post',
	          action: '.',
	          onUpdate: this.onUpdate,
	          schema: this.state.schema,
	          onSubmit: this.onSubmit }),
	        status === 'submitting' && React.createElement(
	          'div',
	          { className: 'ofs-EnquiryForm__Message' },
	          React.createElement(
	            'h3',
	            null,
	            messages.SUBMITTING
	          )
	        ),
	        status === 'success' && React.createElement(
	          'div',
	          { className: 'ofs-EnquiryForm__Message' },
	          React.createElement(
	            'h3',
	            null,
	            messages.SUCCESS_HEADING
	          ),
	          React.createElement(
	            'p',
	            null,
	            messages.SUCCESS_MESSAGE
	          )
	        ),
	        status === 'error' && React.createElement(
	          'div',
	          { className: 'ofs-EnquiryForm__Message' },
	          React.createElement(
	            'h3',
	            null,
	            messages.ERROR_HEADING
	          ),
	          React.createElement(
	            'p',
	            null,
	            this.state.message
	          )
	        )
	      ),
	      React.createElement(Footer, { cityCode: cityCode, cityName: cityName })
	    );
	  }
	});
	
	module.exports = ContactForm;

/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 *  Copyright (c) 2014-2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  global.Immutable = factory()
	}(this, function () { 'use strict';var SLICE$0 = Array.prototype.slice;
	
	  function createClass(ctor, superClass) {
	    if (superClass) {
	      ctor.prototype = Object.create(superClass.prototype);
	    }
	    ctor.prototype.constructor = ctor;
	  }
	
	  // Used for setting prototype methods that IE8 chokes on.
	  var DELETE = 'delete';
	
	  // Constants describing the size of trie nodes.
	  var SHIFT = 5; // Resulted in best performance after ______?
	  var SIZE = 1 << SHIFT;
	  var MASK = SIZE - 1;
	
	  // A consistent shared value representing "not set" which equals nothing other
	  // than itself, and nothing that could be provided externally.
	  var NOT_SET = {};
	
	  // Boolean references, Rough equivalent of `bool &`.
	  var CHANGE_LENGTH = { value: false };
	  var DID_ALTER = { value: false };
	
	  function MakeRef(ref) {
	    ref.value = false;
	    return ref;
	  }
	
	  function SetRef(ref) {
	    ref && (ref.value = true);
	  }
	
	  // A function which returns a value representing an "owner" for transient writes
	  // to tries. The return value will only ever equal itself, and will not equal
	  // the return of any subsequent call of this function.
	  function OwnerID() {}
	
	  // http://jsperf.com/copy-array-inline
	  function arrCopy(arr, offset) {
	    offset = offset || 0;
	    var len = Math.max(0, arr.length - offset);
	    var newArr = new Array(len);
	    for (var ii = 0; ii < len; ii++) {
	      newArr[ii] = arr[ii + offset];
	    }
	    return newArr;
	  }
	
	  function ensureSize(iter) {
	    if (iter.size === undefined) {
	      iter.size = iter.__iterate(returnTrue);
	    }
	    return iter.size;
	  }
	
	  function wrapIndex(iter, index) {
	    // This implements "is array index" which the ECMAString spec defines as:
	    //     A String property name P is an array index if and only if
	    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
	    //     to 2^32−1.
	    // However note that we're currently calling ToNumber() instead of ToUint32()
	    // which should be improved in the future, as floating point numbers should
	    // not be accepted as an array index.
	    if (typeof index !== 'number') {
	      var numIndex = +index;
	      if ('' + numIndex !== index) {
	        return NaN;
	      }
	      index = numIndex;
	    }
	    return index < 0 ? ensureSize(iter) + index : index;
	  }
	
	  function returnTrue() {
	    return true;
	  }
	
	  function wholeSlice(begin, end, size) {
	    return (begin === 0 || (size !== undefined && begin <= -size)) &&
	      (end === undefined || (size !== undefined && end >= size));
	  }
	
	  function resolveBegin(begin, size) {
	    return resolveIndex(begin, size, 0);
	  }
	
	  function resolveEnd(end, size) {
	    return resolveIndex(end, size, size);
	  }
	
	  function resolveIndex(index, size, defaultIndex) {
	    return index === undefined ?
	      defaultIndex :
	      index < 0 ?
	        Math.max(0, size + index) :
	        size === undefined ?
	          index :
	          Math.min(size, index);
	  }
	
	  function Iterable(value) {
	      return isIterable(value) ? value : Seq(value);
	    }
	
	
	  createClass(KeyedIterable, Iterable);
	    function KeyedIterable(value) {
	      return isKeyed(value) ? value : KeyedSeq(value);
	    }
	
	
	  createClass(IndexedIterable, Iterable);
	    function IndexedIterable(value) {
	      return isIndexed(value) ? value : IndexedSeq(value);
	    }
	
	
	  createClass(SetIterable, Iterable);
	    function SetIterable(value) {
	      return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
	    }
	
	
	
	  function isIterable(maybeIterable) {
	    return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
	  }
	
	  function isKeyed(maybeKeyed) {
	    return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
	  }
	
	  function isIndexed(maybeIndexed) {
	    return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
	  }
	
	  function isAssociative(maybeAssociative) {
	    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
	  }
	
	  function isOrdered(maybeOrdered) {
	    return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
	  }
	
	  Iterable.isIterable = isIterable;
	  Iterable.isKeyed = isKeyed;
	  Iterable.isIndexed = isIndexed;
	  Iterable.isAssociative = isAssociative;
	  Iterable.isOrdered = isOrdered;
	
	  Iterable.Keyed = KeyedIterable;
	  Iterable.Indexed = IndexedIterable;
	  Iterable.Set = SetIterable;
	
	
	  var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
	  var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
	  var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
	  var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
	  /* global Symbol */
	
	  var ITERATE_KEYS = 0;
	  var ITERATE_VALUES = 1;
	  var ITERATE_ENTRIES = 2;
	
	  var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator';
	
	  var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;
	
	
	  function src_Iterator__Iterator(next) {
	      this.next = next;
	    }
	
	    src_Iterator__Iterator.prototype.toString = function() {
	      return '[Iterator]';
	    };
	
	
	  src_Iterator__Iterator.KEYS = ITERATE_KEYS;
	  src_Iterator__Iterator.VALUES = ITERATE_VALUES;
	  src_Iterator__Iterator.ENTRIES = ITERATE_ENTRIES;
	
	  src_Iterator__Iterator.prototype.inspect =
	  src_Iterator__Iterator.prototype.toSource = function () { return this.toString(); }
	  src_Iterator__Iterator.prototype[ITERATOR_SYMBOL] = function () {
	    return this;
	  };
	
	
	  function iteratorValue(type, k, v, iteratorResult) {
	    var value = type === 0 ? k : type === 1 ? v : [k, v];
	    iteratorResult ? (iteratorResult.value = value) : (iteratorResult = {
	      value: value, done: false
	    });
	    return iteratorResult;
	  }
	
	  function iteratorDone() {
	    return { value: undefined, done: true };
	  }
	
	  function hasIterator(maybeIterable) {
	    return !!getIteratorFn(maybeIterable);
	  }
	
	  function isIterator(maybeIterator) {
	    return maybeIterator && typeof maybeIterator.next === 'function';
	  }
	
	  function getIterator(iterable) {
	    var iteratorFn = getIteratorFn(iterable);
	    return iteratorFn && iteratorFn.call(iterable);
	  }
	
	  function getIteratorFn(iterable) {
	    var iteratorFn = iterable && (
	      (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL]) ||
	      iterable[FAUX_ITERATOR_SYMBOL]
	    );
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  function isArrayLike(value) {
	    return value && typeof value.length === 'number';
	  }
	
	  createClass(Seq, Iterable);
	    function Seq(value) {
	      return value === null || value === undefined ? emptySequence() :
	        isIterable(value) ? value.toSeq() : seqFromValue(value);
	    }
	
	    Seq.of = function(/*...values*/) {
	      return Seq(arguments);
	    };
	
	    Seq.prototype.toSeq = function() {
	      return this;
	    };
	
	    Seq.prototype.toString = function() {
	      return this.__toString('Seq {', '}');
	    };
	
	    Seq.prototype.cacheResult = function() {
	      if (!this._cache && this.__iterateUncached) {
	        this._cache = this.entrySeq().toArray();
	        this.size = this._cache.length;
	      }
	      return this;
	    };
	
	    // abstract __iterateUncached(fn, reverse)
	
	    Seq.prototype.__iterate = function(fn, reverse) {
	      return seqIterate(this, fn, reverse, true);
	    };
	
	    // abstract __iteratorUncached(type, reverse)
	
	    Seq.prototype.__iterator = function(type, reverse) {
	      return seqIterator(this, type, reverse, true);
	    };
	
	
	
	  createClass(KeyedSeq, Seq);
	    function KeyedSeq(value) {
	      return value === null || value === undefined ?
	        emptySequence().toKeyedSeq() :
	        isIterable(value) ?
	          (isKeyed(value) ? value.toSeq() : value.fromEntrySeq()) :
	          keyedSeqFromValue(value);
	    }
	
	    KeyedSeq.prototype.toKeyedSeq = function() {
	      return this;
	    };
	
	
	
	  createClass(IndexedSeq, Seq);
	    function IndexedSeq(value) {
	      return value === null || value === undefined ? emptySequence() :
	        !isIterable(value) ? indexedSeqFromValue(value) :
	        isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
	    }
	
	    IndexedSeq.of = function(/*...values*/) {
	      return IndexedSeq(arguments);
	    };
	
	    IndexedSeq.prototype.toIndexedSeq = function() {
	      return this;
	    };
	
	    IndexedSeq.prototype.toString = function() {
	      return this.__toString('Seq [', ']');
	    };
	
	    IndexedSeq.prototype.__iterate = function(fn, reverse) {
	      return seqIterate(this, fn, reverse, false);
	    };
	
	    IndexedSeq.prototype.__iterator = function(type, reverse) {
	      return seqIterator(this, type, reverse, false);
	    };
	
	
	
	  createClass(SetSeq, Seq);
	    function SetSeq(value) {
	      return (
	        value === null || value === undefined ? emptySequence() :
	        !isIterable(value) ? indexedSeqFromValue(value) :
	        isKeyed(value) ? value.entrySeq() : value
	      ).toSetSeq();
	    }
	
	    SetSeq.of = function(/*...values*/) {
	      return SetSeq(arguments);
	    };
	
	    SetSeq.prototype.toSetSeq = function() {
	      return this;
	    };
	
	
	
	  Seq.isSeq = isSeq;
	  Seq.Keyed = KeyedSeq;
	  Seq.Set = SetSeq;
	  Seq.Indexed = IndexedSeq;
	
	  var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';
	
	  Seq.prototype[IS_SEQ_SENTINEL] = true;
	
	
	
	  // #pragma Root Sequences
	
	  createClass(ArraySeq, IndexedSeq);
	    function ArraySeq(array) {
	      this._array = array;
	      this.size = array.length;
	    }
	
	    ArraySeq.prototype.get = function(index, notSetValue) {
	      return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
	    };
	
	    ArraySeq.prototype.__iterate = function(fn, reverse) {
	      var array = this._array;
	      var maxIndex = array.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    ArraySeq.prototype.__iterator = function(type, reverse) {
	      var array = this._array;
	      var maxIndex = array.length - 1;
	      var ii = 0;
	      return new src_Iterator__Iterator(function() 
	        {return ii > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++])}
	      );
	    };
	
	
	
	  createClass(ObjectSeq, KeyedSeq);
	    function ObjectSeq(object) {
	      var keys = Object.keys(object);
	      this._object = object;
	      this._keys = keys;
	      this.size = keys.length;
	    }
	
	    ObjectSeq.prototype.get = function(key, notSetValue) {
	      if (notSetValue !== undefined && !this.has(key)) {
	        return notSetValue;
	      }
	      return this._object[key];
	    };
	
	    ObjectSeq.prototype.has = function(key) {
	      return this._object.hasOwnProperty(key);
	    };
	
	    ObjectSeq.prototype.__iterate = function(fn, reverse) {
	      var object = this._object;
	      var keys = this._keys;
	      var maxIndex = keys.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        var key = keys[reverse ? maxIndex - ii : ii];
	        if (fn(object[key], key, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    ObjectSeq.prototype.__iterator = function(type, reverse) {
	      var object = this._object;
	      var keys = this._keys;
	      var maxIndex = keys.length - 1;
	      var ii = 0;
	      return new src_Iterator__Iterator(function()  {
	        var key = keys[reverse ? maxIndex - ii : ii];
	        return ii++ > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, key, object[key]);
	      });
	    };
	
	  ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	  createClass(IterableSeq, IndexedSeq);
	    function IterableSeq(iterable) {
	      this._iterable = iterable;
	      this.size = iterable.length || iterable.size;
	    }
	
	    IterableSeq.prototype.__iterateUncached = function(fn, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterable = this._iterable;
	      var iterator = getIterator(iterable);
	      var iterations = 0;
	      if (isIterator(iterator)) {
	        var step;
	        while (!(step = iterator.next()).done) {
	          if (fn(step.value, iterations++, this) === false) {
	            break;
	          }
	        }
	      }
	      return iterations;
	    };
	
	    IterableSeq.prototype.__iteratorUncached = function(type, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterable = this._iterable;
	      var iterator = getIterator(iterable);
	      if (!isIterator(iterator)) {
	        return new src_Iterator__Iterator(iteratorDone);
	      }
	      var iterations = 0;
	      return new src_Iterator__Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step : iteratorValue(type, iterations++, step.value);
	      });
	    };
	
	
	
	  createClass(IteratorSeq, IndexedSeq);
	    function IteratorSeq(iterator) {
	      this._iterator = iterator;
	      this._iteratorCache = [];
	    }
	
	    IteratorSeq.prototype.__iterateUncached = function(fn, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterator = this._iterator;
	      var cache = this._iteratorCache;
	      var iterations = 0;
	      while (iterations < cache.length) {
	        if (fn(cache[iterations], iterations++, this) === false) {
	          return iterations;
	        }
	      }
	      var step;
	      while (!(step = iterator.next()).done) {
	        var val = step.value;
	        cache[iterations] = val;
	        if (fn(val, iterations++, this) === false) {
	          break;
	        }
	      }
	      return iterations;
	    };
	
	    IteratorSeq.prototype.__iteratorUncached = function(type, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = this._iterator;
	      var cache = this._iteratorCache;
	      var iterations = 0;
	      return new src_Iterator__Iterator(function()  {
	        if (iterations >= cache.length) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          cache[iterations] = step.value;
	        }
	        return iteratorValue(type, iterations, cache[iterations++]);
	      });
	    };
	
	
	
	
	  // # pragma Helper functions
	
	  function isSeq(maybeSeq) {
	    return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
	  }
	
	  var EMPTY_SEQ;
	
	  function emptySequence() {
	    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
	  }
	
	  function keyedSeqFromValue(value) {
	    var seq =
	      Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() :
	      isIterator(value) ? new IteratorSeq(value).fromEntrySeq() :
	      hasIterator(value) ? new IterableSeq(value).fromEntrySeq() :
	      typeof value === 'object' ? new ObjectSeq(value) :
	      undefined;
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of [k, v] entries, '+
	        'or keyed object: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function indexedSeqFromValue(value) {
	    var seq = maybeIndexedSeqFromValue(value);
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of values: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function seqFromValue(value) {
	    var seq = maybeIndexedSeqFromValue(value) ||
	      (typeof value === 'object' && new ObjectSeq(value));
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of values, or keyed object: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function maybeIndexedSeqFromValue(value) {
	    return (
	      isArrayLike(value) ? new ArraySeq(value) :
	      isIterator(value) ? new IteratorSeq(value) :
	      hasIterator(value) ? new IterableSeq(value) :
	      undefined
	    );
	  }
	
	  function seqIterate(seq, fn, reverse, useKeys) {
	    var cache = seq._cache;
	    if (cache) {
	      var maxIndex = cache.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        var entry = cache[reverse ? maxIndex - ii : ii];
	        if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    }
	    return seq.__iterateUncached(fn, reverse);
	  }
	
	  function seqIterator(seq, type, reverse, useKeys) {
	    var cache = seq._cache;
	    if (cache) {
	      var maxIndex = cache.length - 1;
	      var ii = 0;
	      return new src_Iterator__Iterator(function()  {
	        var entry = cache[reverse ? maxIndex - ii : ii];
	        return ii++ > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
	      });
	    }
	    return seq.__iteratorUncached(type, reverse);
	  }
	
	  createClass(Collection, Iterable);
	    function Collection() {
	      throw TypeError('Abstract');
	    }
	
	
	  createClass(KeyedCollection, Collection);function KeyedCollection() {}
	
	  createClass(IndexedCollection, Collection);function IndexedCollection() {}
	
	  createClass(SetCollection, Collection);function SetCollection() {}
	
	
	  Collection.Keyed = KeyedCollection;
	  Collection.Indexed = IndexedCollection;
	  Collection.Set = SetCollection;
	
	  /**
	   * An extension of the "same-value" algorithm as [described for use by ES6 Map
	   * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
	   *
	   * NaN is considered the same as NaN, however -0 and 0 are considered the same
	   * value, which is different from the algorithm described by
	   * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
	   *
	   * This is extended further to allow Objects to describe the values they
	   * represent, by way of `valueOf` or `equals` (and `hashCode`).
	   *
	   * Note: because of this extension, the key equality of Immutable.Map and the
	   * value equality of Immutable.Set will differ from ES6 Map and Set.
	   *
	   * ### Defining custom values
	   *
	   * The easiest way to describe the value an object represents is by implementing
	   * `valueOf`. For example, `Date` represents a value by returning a unix
	   * timestamp for `valueOf`:
	   *
	   *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
	   *     var date2 = new Date(1234567890000);
	   *     date1.valueOf(); // 1234567890000
	   *     assert( date1 !== date2 );
	   *     assert( Immutable.is( date1, date2 ) );
	   *
	   * Note: overriding `valueOf` may have other implications if you use this object
	   * where JavaScript expects a primitive, such as implicit string coercion.
	   *
	   * For more complex types, especially collections, implementing `valueOf` may
	   * not be performant. An alternative is to implement `equals` and `hashCode`.
	   *
	   * `equals` takes another object, presumably of similar type, and returns true
	   * if the it is equal. Equality is symmetrical, so the same result should be
	   * returned if this and the argument are flipped.
	   *
	   *     assert( a.equals(b) === b.equals(a) );
	   *
	   * `hashCode` returns a 32bit integer number representing the object which will
	   * be used to determine how to store the value object in a Map or Set. You must
	   * provide both or neither methods, one must not exist without the other.
	   *
	   * Also, an important relationship between these methods must be upheld: if two
	   * values are equal, they *must* return the same hashCode. If the values are not
	   * equal, they might have the same hashCode; this is called a hash collision,
	   * and while undesirable for performance reasons, it is acceptable.
	   *
	   *     if (a.equals(b)) {
	   *       assert( a.hashCode() === b.hashCode() );
	   *     }
	   *
	   * All Immutable collections implement `equals` and `hashCode`.
	   *
	   */
	  function is(valueA, valueB) {
	    if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
	      return true;
	    }
	    if (!valueA || !valueB) {
	      return false;
	    }
	    if (typeof valueA.valueOf === 'function' &&
	        typeof valueB.valueOf === 'function') {
	      valueA = valueA.valueOf();
	      valueB = valueB.valueOf();
	      if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
	        return true;
	      }
	      if (!valueA || !valueB) {
	        return false;
	      }
	    }
	    if (typeof valueA.equals === 'function' &&
	        typeof valueB.equals === 'function' &&
	        valueA.equals(valueB)) {
	      return true;
	    }
	    return false;
	  }
	
	  function fromJS(json, converter) {
	    return converter ?
	      fromJSWith(converter, json, '', {'': json}) :
	      fromJSDefault(json);
	  }
	
	  function fromJSWith(converter, json, key, parentJSON) {
	    if (Array.isArray(json)) {
	      return converter.call(parentJSON, key, IndexedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
	    }
	    if (isPlainObj(json)) {
	      return converter.call(parentJSON, key, KeyedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
	    }
	    return json;
	  }
	
	  function fromJSDefault(json) {
	    if (Array.isArray(json)) {
	      return IndexedSeq(json).map(fromJSDefault).toList();
	    }
	    if (isPlainObj(json)) {
	      return KeyedSeq(json).map(fromJSDefault).toMap();
	    }
	    return json;
	  }
	
	  function isPlainObj(value) {
	    return value && (value.constructor === Object || value.constructor === undefined);
	  }
	
	  var src_Math__imul =
	    typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ?
	    Math.imul :
	    function imul(a, b) {
	      a = a | 0; // int
	      b = b | 0; // int
	      var c = a & 0xffff;
	      var d = b & 0xffff;
	      // Shift by 0 fixes the sign on the high part.
	      return (c * d) + ((((a >>> 16) * d + c * (b >>> 16)) << 16) >>> 0) | 0; // int
	    };
	
	  // v8 has an optimization for storing 31-bit signed numbers.
	  // Values which have either 00 or 11 as the high order bits qualify.
	  // This function drops the highest order bit in a signed number, maintaining
	  // the sign bit.
	  function smi(i32) {
	    return ((i32 >>> 1) & 0x40000000) | (i32 & 0xBFFFFFFF);
	  }
	
	  function hash(o) {
	    if (o === false || o === null || o === undefined) {
	      return 0;
	    }
	    if (typeof o.valueOf === 'function') {
	      o = o.valueOf();
	      if (o === false || o === null || o === undefined) {
	        return 0;
	      }
	    }
	    if (o === true) {
	      return 1;
	    }
	    var type = typeof o;
	    if (type === 'number') {
	      var h = o | 0;
	      if (h !== o) {
	        h ^= o * 0xFFFFFFFF;
	      }
	      while (o > 0xFFFFFFFF) {
	        o /= 0xFFFFFFFF;
	        h ^= o;
	      }
	      return smi(h);
	    }
	    if (type === 'string') {
	      return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
	    }
	    if (typeof o.hashCode === 'function') {
	      return o.hashCode();
	    }
	    return hashJSObj(o);
	  }
	
	  function cachedHashString(string) {
	    var hash = stringHashCache[string];
	    if (hash === undefined) {
	      hash = hashString(string);
	      if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
	        STRING_HASH_CACHE_SIZE = 0;
	        stringHashCache = {};
	      }
	      STRING_HASH_CACHE_SIZE++;
	      stringHashCache[string] = hash;
	    }
	    return hash;
	  }
	
	  // http://jsperf.com/hashing-strings
	  function hashString(string) {
	    // This is the hash from JVM
	    // The hash code for a string is computed as
	    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
	    // where s[i] is the ith character of the string and n is the length of
	    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
	    // (exclusive) by dropping high bits.
	    var hash = 0;
	    for (var ii = 0; ii < string.length; ii++) {
	      hash = 31 * hash + string.charCodeAt(ii) | 0;
	    }
	    return smi(hash);
	  }
	
	  function hashJSObj(obj) {
	    var hash;
	    if (usingWeakMap) {
	      hash = weakMap.get(obj);
	      if (hash !== undefined) {
	        return hash;
	      }
	    }
	
	    hash = obj[UID_HASH_KEY];
	    if (hash !== undefined) {
	      return hash;
	    }
	
	    if (!canDefineProperty) {
	      hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
	      if (hash !== undefined) {
	        return hash;
	      }
	
	      hash = getIENodeHash(obj);
	      if (hash !== undefined) {
	        return hash;
	      }
	    }
	
	    hash = ++objHashUID;
	    if (objHashUID & 0x40000000) {
	      objHashUID = 0;
	    }
	
	    if (usingWeakMap) {
	      weakMap.set(obj, hash);
	    } else if (isExtensible !== undefined && isExtensible(obj) === false) {
	      throw new Error('Non-extensible objects are not allowed as keys.');
	    } else if (canDefineProperty) {
	      Object.defineProperty(obj, UID_HASH_KEY, {
	        'enumerable': false,
	        'configurable': false,
	        'writable': false,
	        'value': hash
	      });
	    } else if (obj.propertyIsEnumerable !== undefined &&
	               obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
	      // Since we can't define a non-enumerable property on the object
	      // we'll hijack one of the less-used non-enumerable properties to
	      // save our hash on it. Since this is a function it will not show up in
	      // `JSON.stringify` which is what we want.
	      obj.propertyIsEnumerable = function() {
	        return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
	      };
	      obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
	    } else if (obj.nodeType !== undefined) {
	      // At this point we couldn't get the IE `uniqueID` to use as a hash
	      // and we couldn't use a non-enumerable property to exploit the
	      // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
	      // itself.
	      obj[UID_HASH_KEY] = hash;
	    } else {
	      throw new Error('Unable to set a non-enumerable property on object.');
	    }
	
	    return hash;
	  }
	
	  // Get references to ES5 object methods.
	  var isExtensible = Object.isExtensible;
	
	  // True if Object.defineProperty works as expected. IE8 fails this test.
	  var canDefineProperty = (function() {
	    try {
	      Object.defineProperty({}, '@', {});
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }());
	
	  // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
	  // and avoid memory leaks from the IE cloneNode bug.
	  function getIENodeHash(node) {
	    if (node && node.nodeType > 0) {
	      switch (node.nodeType) {
	        case 1: // Element
	          return node.uniqueID;
	        case 9: // Document
	          return node.documentElement && node.documentElement.uniqueID;
	      }
	    }
	  }
	
	  // If possible, use a WeakMap.
	  var usingWeakMap = typeof WeakMap === 'function';
	  var weakMap;
	  if (usingWeakMap) {
	    weakMap = new WeakMap();
	  }
	
	  var objHashUID = 0;
	
	  var UID_HASH_KEY = '__immutablehash__';
	  if (typeof Symbol === 'function') {
	    UID_HASH_KEY = Symbol(UID_HASH_KEY);
	  }
	
	  var STRING_HASH_CACHE_MIN_STRLEN = 16;
	  var STRING_HASH_CACHE_MAX_SIZE = 255;
	  var STRING_HASH_CACHE_SIZE = 0;
	  var stringHashCache = {};
	
	  function invariant(condition, error) {
	    if (!condition) throw new Error(error);
	  }
	
	  function assertNotInfinite(size) {
	    invariant(
	      size !== Infinity,
	      'Cannot perform this action with an infinite size.'
	    );
	  }
	
	  createClass(ToKeyedSequence, KeyedSeq);
	    function ToKeyedSequence(indexed, useKeys) {
	      this._iter = indexed;
	      this._useKeys = useKeys;
	      this.size = indexed.size;
	    }
	
	    ToKeyedSequence.prototype.get = function(key, notSetValue) {
	      return this._iter.get(key, notSetValue);
	    };
	
	    ToKeyedSequence.prototype.has = function(key) {
	      return this._iter.has(key);
	    };
	
	    ToKeyedSequence.prototype.valueSeq = function() {
	      return this._iter.valueSeq();
	    };
	
	    ToKeyedSequence.prototype.reverse = function() {var this$0 = this;
	      var reversedSequence = reverseFactory(this, true);
	      if (!this._useKeys) {
	        reversedSequence.valueSeq = function()  {return this$0._iter.toSeq().reverse()};
	      }
	      return reversedSequence;
	    };
	
	    ToKeyedSequence.prototype.map = function(mapper, context) {var this$0 = this;
	      var mappedSequence = mapFactory(this, mapper, context);
	      if (!this._useKeys) {
	        mappedSequence.valueSeq = function()  {return this$0._iter.toSeq().map(mapper, context)};
	      }
	      return mappedSequence;
	    };
	
	    ToKeyedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var ii;
	      return this._iter.__iterate(
	        this._useKeys ?
	          function(v, k)  {return fn(v, k, this$0)} :
	          ((ii = reverse ? resolveSize(this) : 0),
	            function(v ) {return fn(v, reverse ? --ii : ii++, this$0)}),
	        reverse
	      );
	    };
	
	    ToKeyedSequence.prototype.__iterator = function(type, reverse) {
	      if (this._useKeys) {
	        return this._iter.__iterator(type, reverse);
	      }
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      var ii = reverse ? resolveSize(this) : 0;
	      return new src_Iterator__Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, reverse ? --ii : ii++, step.value, step);
	      });
	    };
	
	  ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	  createClass(ToIndexedSequence, IndexedSeq);
	    function ToIndexedSequence(iter) {
	      this._iter = iter;
	      this.size = iter.size;
	    }
	
	    ToIndexedSequence.prototype.includes = function(value) {
	      return this._iter.includes(value);
	    };
	
	    ToIndexedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      return this._iter.__iterate(function(v ) {return fn(v, iterations++, this$0)}, reverse);
	    };
	
	    ToIndexedSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      var iterations = 0;
	      return new src_Iterator__Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, iterations++, step.value, step)
	      });
	    };
	
	
	
	  createClass(ToSetSequence, SetSeq);
	    function ToSetSequence(iter) {
	      this._iter = iter;
	      this.size = iter.size;
	    }
	
	    ToSetSequence.prototype.has = function(key) {
	      return this._iter.includes(key);
	    };
	
	    ToSetSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._iter.__iterate(function(v ) {return fn(v, v, this$0)}, reverse);
	    };
	
	    ToSetSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      return new src_Iterator__Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, step.value, step.value, step);
	      });
	    };
	
	
	
	  createClass(FromEntriesSequence, KeyedSeq);
	    function FromEntriesSequence(entries) {
	      this._iter = entries;
	      this.size = entries.size;
	    }
	
	    FromEntriesSequence.prototype.entrySeq = function() {
	      return this._iter.toSeq();
	    };
	
	    FromEntriesSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._iter.__iterate(function(entry ) {
	        // Check if entry exists first so array access doesn't throw for holes
	        // in the parent iteration.
	        if (entry) {
	          validateEntry(entry);
	          var indexedIterable = isIterable(entry);
	          return fn(
	            indexedIterable ? entry.get(1) : entry[1],
	            indexedIterable ? entry.get(0) : entry[0],
	            this$0
	          );
	        }
	      }, reverse);
	    };
	
	    FromEntriesSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      return new src_Iterator__Iterator(function()  {
	        while (true) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          var entry = step.value;
	          // Check if entry exists first so array access doesn't throw for holes
	          // in the parent iteration.
	          if (entry) {
	            validateEntry(entry);
	            var indexedIterable = isIterable(entry);
	            return iteratorValue(
	              type,
	              indexedIterable ? entry.get(0) : entry[0],
	              indexedIterable ? entry.get(1) : entry[1],
	              step
	            );
	          }
	        }
	      });
	    };
	
	
	  ToIndexedSequence.prototype.cacheResult =
	  ToKeyedSequence.prototype.cacheResult =
	  ToSetSequence.prototype.cacheResult =
	  FromEntriesSequence.prototype.cacheResult =
	    cacheResultThrough;
	
	
	  function flipFactory(iterable) {
	    var flipSequence = makeSequence(iterable);
	    flipSequence._iter = iterable;
	    flipSequence.size = iterable.size;
	    flipSequence.flip = function()  {return iterable};
	    flipSequence.reverse = function () {
	      var reversedSequence = iterable.reverse.apply(this); // super.reverse()
	      reversedSequence.flip = function()  {return iterable.reverse()};
	      return reversedSequence;
	    };
	    flipSequence.has = function(key ) {return iterable.includes(key)};
	    flipSequence.includes = function(key ) {return iterable.has(key)};
	    flipSequence.cacheResult = cacheResultThrough;
	    flipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(function(v, k)  {return fn(k, v, this$0) !== false}, reverse);
	    }
	    flipSequence.__iteratorUncached = function(type, reverse) {
	      if (type === ITERATE_ENTRIES) {
	        var iterator = iterable.__iterator(type, reverse);
	        return new src_Iterator__Iterator(function()  {
	          var step = iterator.next();
	          if (!step.done) {
	            var k = step.value[0];
	            step.value[0] = step.value[1];
	            step.value[1] = k;
	          }
	          return step;
	        });
	      }
	      return iterable.__iterator(
	        type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES,
	        reverse
	      );
	    }
	    return flipSequence;
	  }
	
	
	  function mapFactory(iterable, mapper, context) {
	    var mappedSequence = makeSequence(iterable);
	    mappedSequence.size = iterable.size;
	    mappedSequence.has = function(key ) {return iterable.has(key)};
	    mappedSequence.get = function(key, notSetValue)  {
	      var v = iterable.get(key, NOT_SET);
	      return v === NOT_SET ?
	        notSetValue :
	        mapper.call(context, v, key, iterable);
	    };
	    mappedSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(
	        function(v, k, c)  {return fn(mapper.call(context, v, k, c), k, this$0) !== false},
	        reverse
	      );
	    }
	    mappedSequence.__iteratorUncached = function (type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      return new src_Iterator__Iterator(function()  {
	        var step = iterator.next();
	        if (step.done) {
	          return step;
	        }
	        var entry = step.value;
	        var key = entry[0];
	        return iteratorValue(
	          type,
	          key,
	          mapper.call(context, entry[1], key, iterable),
	          step
	        );
	      });
	    }
	    return mappedSequence;
	  }
	
	
	  function reverseFactory(iterable, useKeys) {
	    var reversedSequence = makeSequence(iterable);
	    reversedSequence._iter = iterable;
	    reversedSequence.size = iterable.size;
	    reversedSequence.reverse = function()  {return iterable};
	    if (iterable.flip) {
	      reversedSequence.flip = function () {
	        var flipSequence = flipFactory(iterable);
	        flipSequence.reverse = function()  {return iterable.flip()};
	        return flipSequence;
	      };
	    }
	    reversedSequence.get = function(key, notSetValue) 
	      {return iterable.get(useKeys ? key : -1 - key, notSetValue)};
	    reversedSequence.has = function(key )
	      {return iterable.has(useKeys ? key : -1 - key)};
	    reversedSequence.includes = function(value ) {return iterable.includes(value)};
	    reversedSequence.cacheResult = cacheResultThrough;
	    reversedSequence.__iterate = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(function(v, k)  {return fn(v, k, this$0)}, !reverse);
	    };
	    reversedSequence.__iterator =
	      function(type, reverse)  {return iterable.__iterator(type, !reverse)};
	    return reversedSequence;
	  }
	
	
	  function filterFactory(iterable, predicate, context, useKeys) {
	    var filterSequence = makeSequence(iterable);
	    if (useKeys) {
	      filterSequence.has = function(key ) {
	        var v = iterable.get(key, NOT_SET);
	        return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
	      };
	      filterSequence.get = function(key, notSetValue)  {
	        var v = iterable.get(key, NOT_SET);
	        return v !== NOT_SET && predicate.call(context, v, key, iterable) ?
	          v : notSetValue;
	      };
	    }
	    filterSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c)  {
	        if (predicate.call(context, v, k, c)) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0);
	        }
	      }, reverse);
	      return iterations;
	    };
	    filterSequence.__iteratorUncached = function (type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var iterations = 0;
	      return new src_Iterator__Iterator(function()  {
	        while (true) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          var entry = step.value;
	          var key = entry[0];
	          var value = entry[1];
	          if (predicate.call(context, value, key, iterable)) {
	            return iteratorValue(type, useKeys ? key : iterations++, value, step);
	          }
	        }
	      });
	    }
	    return filterSequence;
	  }
	
	
	  function countByFactory(iterable, grouper, context) {
	    var groups = src_Map__Map().asMutable();
	    iterable.__iterate(function(v, k)  {
	      groups.update(
	        grouper.call(context, v, k, iterable),
	        0,
	        function(a ) {return a + 1}
	      );
	    });
	    return groups.asImmutable();
	  }
	
	
	  function groupByFactory(iterable, grouper, context) {
	    var isKeyedIter = isKeyed(iterable);
	    var groups = (isOrdered(iterable) ? OrderedMap() : src_Map__Map()).asMutable();
	    iterable.__iterate(function(v, k)  {
	      groups.update(
	        grouper.call(context, v, k, iterable),
	        function(a ) {return (a = a || [], a.push(isKeyedIter ? [k, v] : v), a)}
	      );
	    });
	    var coerce = iterableClass(iterable);
	    return groups.map(function(arr ) {return reify(iterable, coerce(arr))});
	  }
	
	
	  function sliceFactory(iterable, begin, end, useKeys) {
	    var originalSize = iterable.size;
	
	    // Sanitize begin & end using this shorthand for ToInt32(argument)
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
	    if (begin !== undefined) {
	      begin = begin | 0;
	    }
	    if (end !== undefined) {
	      end = end | 0;
	    }
	
	    if (wholeSlice(begin, end, originalSize)) {
	      return iterable;
	    }
	
	    var resolvedBegin = resolveBegin(begin, originalSize);
	    var resolvedEnd = resolveEnd(end, originalSize);
	
	    // begin or end will be NaN if they were provided as negative numbers and
	    // this iterable's size is unknown. In that case, cache first so there is
	    // a known size and these do not resolve to NaN.
	    if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
	      return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
	    }
	
	    // Note: resolvedEnd is undefined when the original sequence's length is
	    // unknown and this slice did not supply an end and should contain all
	    // elements after resolvedBegin.
	    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
	    var resolvedSize = resolvedEnd - resolvedBegin;
	    var sliceSize;
	    if (resolvedSize === resolvedSize) {
	      sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
	    }
	
	    var sliceSeq = makeSequence(iterable);
	
	    // If iterable.size is undefined, the size of the realized sliceSeq is
	    // unknown at this point unless the number of items to slice is 0
	    sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;
	
	    if (!useKeys && isSeq(iterable) && sliceSize >= 0) {
	      sliceSeq.get = function (index, notSetValue) {
	        index = wrapIndex(this, index);
	        return index >= 0 && index < sliceSize ?
	          iterable.get(index + resolvedBegin, notSetValue) :
	          notSetValue;
	      }
	    }
	
	    sliceSeq.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      if (sliceSize === 0) {
	        return 0;
	      }
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var skipped = 0;
	      var isSkipping = true;
	      var iterations = 0;
	      iterable.__iterate(function(v, k)  {
	        if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0) !== false &&
	                 iterations !== sliceSize;
	        }
	      });
	      return iterations;
	    };
	
	    sliceSeq.__iteratorUncached = function(type, reverse) {
	      if (sliceSize !== 0 && reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      // Don't bother instantiating parent iterator if taking 0.
	      var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);
	      var skipped = 0;
	      var iterations = 0;
	      return new src_Iterator__Iterator(function()  {
	        while (skipped++ < resolvedBegin) {
	          iterator.next();
	        }
	        if (++iterations > sliceSize) {
	          return iteratorDone();
	        }
	        var step = iterator.next();
	        if (useKeys || type === ITERATE_VALUES) {
	          return step;
	        } else if (type === ITERATE_KEYS) {
	          return iteratorValue(type, iterations - 1, undefined, step);
	        } else {
	          return iteratorValue(type, iterations - 1, step.value[1], step);
	        }
	      });
	    }
	
	    return sliceSeq;
	  }
	
	
	  function takeWhileFactory(iterable, predicate, context) {
	    var takeSequence = makeSequence(iterable);
	    takeSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c) 
	        {return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0)}
	      );
	      return iterations;
	    };
	    takeSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var iterating = true;
	      return new src_Iterator__Iterator(function()  {
	        if (!iterating) {
	          return iteratorDone();
	        }
	        var step = iterator.next();
	        if (step.done) {
	          return step;
	        }
	        var entry = step.value;
	        var k = entry[0];
	        var v = entry[1];
	        if (!predicate.call(context, v, k, this$0)) {
	          iterating = false;
	          return iteratorDone();
	        }
	        return type === ITERATE_ENTRIES ? step :
	          iteratorValue(type, k, v, step);
	      });
	    };
	    return takeSequence;
	  }
	
	
	  function skipWhileFactory(iterable, predicate, context, useKeys) {
	    var skipSequence = makeSequence(iterable);
	    skipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var isSkipping = true;
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c)  {
	        if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0);
	        }
	      });
	      return iterations;
	    };
	    skipSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var skipping = true;
	      var iterations = 0;
	      return new src_Iterator__Iterator(function()  {
	        var step, k, v;
	        do {
	          step = iterator.next();
	          if (step.done) {
	            if (useKeys || type === ITERATE_VALUES) {
	              return step;
	            } else if (type === ITERATE_KEYS) {
	              return iteratorValue(type, iterations++, undefined, step);
	            } else {
	              return iteratorValue(type, iterations++, step.value[1], step);
	            }
	          }
	          var entry = step.value;
	          k = entry[0];
	          v = entry[1];
	          skipping && (skipping = predicate.call(context, v, k, this$0));
	        } while (skipping);
	        return type === ITERATE_ENTRIES ? step :
	          iteratorValue(type, k, v, step);
	      });
	    };
	    return skipSequence;
	  }
	
	
	  function concatFactory(iterable, values) {
	    var isKeyedIterable = isKeyed(iterable);
	    var iters = [iterable].concat(values).map(function(v ) {
	      if (!isIterable(v)) {
	        v = isKeyedIterable ?
	          keyedSeqFromValue(v) :
	          indexedSeqFromValue(Array.isArray(v) ? v : [v]);
	      } else if (isKeyedIterable) {
	        v = KeyedIterable(v);
	      }
	      return v;
	    }).filter(function(v ) {return v.size !== 0});
	
	    if (iters.length === 0) {
	      return iterable;
	    }
	
	    if (iters.length === 1) {
	      var singleton = iters[0];
	      if (singleton === iterable ||
	          isKeyedIterable && isKeyed(singleton) ||
	          isIndexed(iterable) && isIndexed(singleton)) {
	        return singleton;
	      }
	    }
	
	    var concatSeq = new ArraySeq(iters);
	    if (isKeyedIterable) {
	      concatSeq = concatSeq.toKeyedSeq();
	    } else if (!isIndexed(iterable)) {
	      concatSeq = concatSeq.toSetSeq();
	    }
	    concatSeq = concatSeq.flatten(true);
	    concatSeq.size = iters.reduce(
	      function(sum, seq)  {
	        if (sum !== undefined) {
	          var size = seq.size;
	          if (size !== undefined) {
	            return sum + size;
	          }
	        }
	      },
	      0
	    );
	    return concatSeq;
	  }
	
	
	  function flattenFactory(iterable, depth, useKeys) {
	    var flatSequence = makeSequence(iterable);
	    flatSequence.__iterateUncached = function(fn, reverse) {
	      var iterations = 0;
	      var stopped = false;
	      function flatDeep(iter, currentDepth) {var this$0 = this;
	        iter.__iterate(function(v, k)  {
	          if ((!depth || currentDepth < depth) && isIterable(v)) {
	            flatDeep(v, currentDepth + 1);
	          } else if (fn(v, useKeys ? k : iterations++, this$0) === false) {
	            stopped = true;
	          }
	          return !stopped;
	        }, reverse);
	      }
	      flatDeep(iterable, 0);
	      return iterations;
	    }
	    flatSequence.__iteratorUncached = function(type, reverse) {
	      var iterator = iterable.__iterator(type, reverse);
	      var stack = [];
	      var iterations = 0;
	      return new src_Iterator__Iterator(function()  {
	        while (iterator) {
	          var step = iterator.next();
	          if (step.done !== false) {
	            iterator = stack.pop();
	            continue;
	          }
	          var v = step.value;
	          if (type === ITERATE_ENTRIES) {
	            v = v[1];
	          }
	          if ((!depth || stack.length < depth) && isIterable(v)) {
	            stack.push(iterator);
	            iterator = v.__iterator(type, reverse);
	          } else {
	            return useKeys ? step : iteratorValue(type, iterations++, v, step);
	          }
	        }
	        return iteratorDone();
	      });
	    }
	    return flatSequence;
	  }
	
	
	  function flatMapFactory(iterable, mapper, context) {
	    var coerce = iterableClass(iterable);
	    return iterable.toSeq().map(
	      function(v, k)  {return coerce(mapper.call(context, v, k, iterable))}
	    ).flatten(true);
	  }
	
	
	  function interposeFactory(iterable, separator) {
	    var interposedSequence = makeSequence(iterable);
	    interposedSequence.size = iterable.size && iterable.size * 2 -1;
	    interposedSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      iterable.__iterate(function(v, k) 
	        {return (!iterations || fn(separator, iterations++, this$0) !== false) &&
	        fn(v, iterations++, this$0) !== false},
	        reverse
	      );
	      return iterations;
	    };
	    interposedSequence.__iteratorUncached = function(type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_VALUES, reverse);
	      var iterations = 0;
	      var step;
	      return new src_Iterator__Iterator(function()  {
	        if (!step || iterations % 2) {
	          step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	        }
	        return iterations % 2 ?
	          iteratorValue(type, iterations++, separator) :
	          iteratorValue(type, iterations++, step.value, step);
	      });
	    };
	    return interposedSequence;
	  }
	
	
	  function sortFactory(iterable, comparator, mapper) {
	    if (!comparator) {
	      comparator = defaultComparator;
	    }
	    var isKeyedIterable = isKeyed(iterable);
	    var index = 0;
	    var entries = iterable.toSeq().map(
	      function(v, k)  {return [k, v, index++, mapper ? mapper(v, k, iterable) : v]}
	    ).toArray();
	    entries.sort(function(a, b)  {return comparator(a[3], b[3]) || a[2] - b[2]}).forEach(
	      isKeyedIterable ?
	      function(v, i)  { entries[i].length = 2; } :
	      function(v, i)  { entries[i] = v[1]; }
	    );
	    return isKeyedIterable ? KeyedSeq(entries) :
	      isIndexed(iterable) ? IndexedSeq(entries) :
	      SetSeq(entries);
	  }
	
	
	  function maxFactory(iterable, comparator, mapper) {
	    if (!comparator) {
	      comparator = defaultComparator;
	    }
	    if (mapper) {
	      var entry = iterable.toSeq()
	        .map(function(v, k)  {return [v, mapper(v, k, iterable)]})
	        .reduce(function(a, b)  {return maxCompare(comparator, a[1], b[1]) ? b : a});
	      return entry && entry[0];
	    } else {
	      return iterable.reduce(function(a, b)  {return maxCompare(comparator, a, b) ? b : a});
	    }
	  }
	
	  function maxCompare(comparator, a, b) {
	    var comp = comparator(b, a);
	    // b is considered the new max if the comparator declares them equal, but
	    // they are not equal and b is in fact a nullish value.
	    return (comp === 0 && b !== a && (b === undefined || b === null || b !== b)) || comp > 0;
	  }
	
	
	  function zipWithFactory(keyIter, zipper, iters) {
	    var zipSequence = makeSequence(keyIter);
	    zipSequence.size = new ArraySeq(iters).map(function(i ) {return i.size}).min();
	    // Note: this a generic base implementation of __iterate in terms of
	    // __iterator which may be more generically useful in the future.
	    zipSequence.__iterate = function(fn, reverse) {
	      /* generic:
	      var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
	      var step;
	      var iterations = 0;
	      while (!(step = iterator.next()).done) {
	        iterations++;
	        if (fn(step.value[1], step.value[0], this) === false) {
	          break;
	        }
	      }
	      return iterations;
	      */
	      // indexed:
	      var iterator = this.__iterator(ITERATE_VALUES, reverse);
	      var step;
	      var iterations = 0;
	      while (!(step = iterator.next()).done) {
	        if (fn(step.value, iterations++, this) === false) {
	          break;
	        }
	      }
	      return iterations;
	    };
	    zipSequence.__iteratorUncached = function(type, reverse) {
	      var iterators = iters.map(function(i )
	        {return (i = Iterable(i), getIterator(reverse ? i.reverse() : i))}
	      );
	      var iterations = 0;
	      var isDone = false;
	      return new src_Iterator__Iterator(function()  {
	        var steps;
	        if (!isDone) {
	          steps = iterators.map(function(i ) {return i.next()});
	          isDone = steps.some(function(s ) {return s.done});
	        }
	        if (isDone) {
	          return iteratorDone();
	        }
	        return iteratorValue(
	          type,
	          iterations++,
	          zipper.apply(null, steps.map(function(s ) {return s.value}))
	        );
	      });
	    };
	    return zipSequence
	  }
	
	
	  // #pragma Helper Functions
	
	  function reify(iter, seq) {
	    return isSeq(iter) ? seq : iter.constructor(seq);
	  }
	
	  function validateEntry(entry) {
	    if (entry !== Object(entry)) {
	      throw new TypeError('Expected [K, V] tuple: ' + entry);
	    }
	  }
	
	  function resolveSize(iter) {
	    assertNotInfinite(iter.size);
	    return ensureSize(iter);
	  }
	
	  function iterableClass(iterable) {
	    return isKeyed(iterable) ? KeyedIterable :
	      isIndexed(iterable) ? IndexedIterable :
	      SetIterable;
	  }
	
	  function makeSequence(iterable) {
	    return Object.create(
	      (
	        isKeyed(iterable) ? KeyedSeq :
	        isIndexed(iterable) ? IndexedSeq :
	        SetSeq
	      ).prototype
	    );
	  }
	
	  function cacheResultThrough() {
	    if (this._iter.cacheResult) {
	      this._iter.cacheResult();
	      this.size = this._iter.size;
	      return this;
	    } else {
	      return Seq.prototype.cacheResult.call(this);
	    }
	  }
	
	  function defaultComparator(a, b) {
	    return a > b ? 1 : a < b ? -1 : 0;
	  }
	
	  function forceIterator(keyPath) {
	    var iter = getIterator(keyPath);
	    if (!iter) {
	      // Array might not be iterable in this environment, so we need a fallback
	      // to our wrapped type.
	      if (!isArrayLike(keyPath)) {
	        throw new TypeError('Expected iterable or array-like: ' + keyPath);
	      }
	      iter = getIterator(Iterable(keyPath));
	    }
	    return iter;
	  }
	
	  createClass(src_Map__Map, KeyedCollection);
	
	    // @pragma Construction
	
	    function src_Map__Map(value) {
	      return value === null || value === undefined ? emptyMap() :
	        isMap(value) && !isOrdered(value) ? value :
	        emptyMap().withMutations(function(map ) {
	          var iter = KeyedIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v, k)  {return map.set(k, v)});
	        });
	    }
	
	    src_Map__Map.prototype.toString = function() {
	      return this.__toString('Map {', '}');
	    };
	
	    // @pragma Access
	
	    src_Map__Map.prototype.get = function(k, notSetValue) {
	      return this._root ?
	        this._root.get(0, undefined, k, notSetValue) :
	        notSetValue;
	    };
	
	    // @pragma Modification
	
	    src_Map__Map.prototype.set = function(k, v) {
	      return updateMap(this, k, v);
	    };
	
	    src_Map__Map.prototype.setIn = function(keyPath, v) {
	      return this.updateIn(keyPath, NOT_SET, function()  {return v});
	    };
	
	    src_Map__Map.prototype.remove = function(k) {
	      return updateMap(this, k, NOT_SET);
	    };
	
	    src_Map__Map.prototype.deleteIn = function(keyPath) {
	      return this.updateIn(keyPath, function()  {return NOT_SET});
	    };
	
	    src_Map__Map.prototype.update = function(k, notSetValue, updater) {
	      return arguments.length === 1 ?
	        k(this) :
	        this.updateIn([k], notSetValue, updater);
	    };
	
	    src_Map__Map.prototype.updateIn = function(keyPath, notSetValue, updater) {
	      if (!updater) {
	        updater = notSetValue;
	        notSetValue = undefined;
	      }
	      var updatedValue = updateInDeepMap(
	        this,
	        forceIterator(keyPath),
	        notSetValue,
	        updater
	      );
	      return updatedValue === NOT_SET ? undefined : updatedValue;
	    };
	
	    src_Map__Map.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._root = null;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyMap();
	    };
	
	    // @pragma Composition
	
	    src_Map__Map.prototype.merge = function(/*...iters*/) {
	      return mergeIntoMapWith(this, undefined, arguments);
	    };
	
	    src_Map__Map.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoMapWith(this, merger, iters);
	    };
	
	    src_Map__Map.prototype.mergeIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
	      return this.updateIn(
	        keyPath,
	        emptyMap(),
	        function(m ) {return typeof m.merge === 'function' ?
	          m.merge.apply(m, iters) :
	          iters[iters.length - 1]}
	      );
	    };
	
	    src_Map__Map.prototype.mergeDeep = function(/*...iters*/) {
	      return mergeIntoMapWith(this, deepMerger(undefined), arguments);
	    };
	
	    src_Map__Map.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoMapWith(this, deepMerger(merger), iters);
	    };
	
	    src_Map__Map.prototype.mergeDeepIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
	      return this.updateIn(
	        keyPath,
	        emptyMap(),
	        function(m ) {return typeof m.mergeDeep === 'function' ?
	          m.mergeDeep.apply(m, iters) :
	          iters[iters.length - 1]}
	      );
	    };
	
	    src_Map__Map.prototype.sort = function(comparator) {
	      // Late binding
	      return OrderedMap(sortFactory(this, comparator));
	    };
	
	    src_Map__Map.prototype.sortBy = function(mapper, comparator) {
	      // Late binding
	      return OrderedMap(sortFactory(this, comparator, mapper));
	    };
	
	    // @pragma Mutability
	
	    src_Map__Map.prototype.withMutations = function(fn) {
	      var mutable = this.asMutable();
	      fn(mutable);
	      return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
	    };
	
	    src_Map__Map.prototype.asMutable = function() {
	      return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
	    };
	
	    src_Map__Map.prototype.asImmutable = function() {
	      return this.__ensureOwner();
	    };
	
	    src_Map__Map.prototype.wasAltered = function() {
	      return this.__altered;
	    };
	
	    src_Map__Map.prototype.__iterator = function(type, reverse) {
	      return new MapIterator(this, type, reverse);
	    };
	
	    src_Map__Map.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      this._root && this._root.iterate(function(entry ) {
	        iterations++;
	        return fn(entry[1], entry[0], this$0);
	      }, reverse);
	      return iterations;
	    };
	
	    src_Map__Map.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this.__altered = false;
	        return this;
	      }
	      return makeMap(this.size, this._root, ownerID, this.__hash);
	    };
	
	
	  function isMap(maybeMap) {
	    return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
	  }
	
	  src_Map__Map.isMap = isMap;
	
	  var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';
	
	  var MapPrototype = src_Map__Map.prototype;
	  MapPrototype[IS_MAP_SENTINEL] = true;
	  MapPrototype[DELETE] = MapPrototype.remove;
	  MapPrototype.removeIn = MapPrototype.deleteIn;
	
	
	  // #pragma Trie Nodes
	
	
	
	    function ArrayMapNode(ownerID, entries) {
	      this.ownerID = ownerID;
	      this.entries = entries;
	    }
	
	    ArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      var entries = this.entries;
	      for (var ii = 0, len = entries.length; ii < len; ii++) {
	        if (is(key, entries[ii][0])) {
	          return entries[ii][1];
	        }
	      }
	      return notSetValue;
	    };
	
	    ArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      var removed = value === NOT_SET;
	
	      var entries = this.entries;
	      var idx = 0;
	      for (var len = entries.length; idx < len; idx++) {
	        if (is(key, entries[idx][0])) {
	          break;
	        }
	      }
	      var exists = idx < len;
	
	      if (exists ? entries[idx][1] === value : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	      (removed || !exists) && SetRef(didChangeSize);
	
	      if (removed && entries.length === 1) {
	        return; // undefined
	      }
	
	      if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
	        return createNodes(ownerID, entries, key, value);
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newEntries = isEditable ? entries : arrCopy(entries);
	
	      if (exists) {
	        if (removed) {
	          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
	        } else {
	          newEntries[idx] = [key, value];
	        }
	      } else {
	        newEntries.push([key, value]);
	      }
	
	      if (isEditable) {
	        this.entries = newEntries;
	        return this;
	      }
	
	      return new ArrayMapNode(ownerID, newEntries);
	    };
	
	
	
	
	    function BitmapIndexedNode(ownerID, bitmap, nodes) {
	      this.ownerID = ownerID;
	      this.bitmap = bitmap;
	      this.nodes = nodes;
	    }
	
	    BitmapIndexedNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var bit = (1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK));
	      var bitmap = this.bitmap;
	      return (bitmap & bit) === 0 ? notSetValue :
	        this.nodes[popCount(bitmap & (bit - 1))].get(shift + SHIFT, keyHash, key, notSetValue);
	    };
	
	    BitmapIndexedNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var bit = 1 << keyHashFrag;
	      var bitmap = this.bitmap;
	      var exists = (bitmap & bit) !== 0;
	
	      if (!exists && value === NOT_SET) {
	        return this;
	      }
	
	      var idx = popCount(bitmap & (bit - 1));
	      var nodes = this.nodes;
	      var node = exists ? nodes[idx] : undefined;
	      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
	
	      if (newNode === node) {
	        return this;
	      }
	
	      if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
	        return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
	      }
	
	      if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) {
	        return nodes[idx ^ 1];
	      }
	
	      if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
	        return newNode;
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
	      var newNodes = exists ? newNode ?
	        setIn(nodes, idx, newNode, isEditable) :
	        spliceOut(nodes, idx, isEditable) :
	        spliceIn(nodes, idx, newNode, isEditable);
	
	      if (isEditable) {
	        this.bitmap = newBitmap;
	        this.nodes = newNodes;
	        return this;
	      }
	
	      return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
	    };
	
	
	
	
	    function HashArrayMapNode(ownerID, count, nodes) {
	      this.ownerID = ownerID;
	      this.count = count;
	      this.nodes = nodes;
	    }
	
	    HashArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var node = this.nodes[idx];
	      return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
	    };
	
	    HashArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var removed = value === NOT_SET;
	      var nodes = this.nodes;
	      var node = nodes[idx];
	
	      if (removed && !node) {
	        return this;
	      }
	
	      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
	      if (newNode === node) {
	        return this;
	      }
	
	      var newCount = this.count;
	      if (!node) {
	        newCount++;
	      } else if (!newNode) {
	        newCount--;
	        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
	          return packNodes(ownerID, nodes, newCount, idx);
	        }
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newNodes = setIn(nodes, idx, newNode, isEditable);
	
	      if (isEditable) {
	        this.count = newCount;
	        this.nodes = newNodes;
	        return this;
	      }
	
	      return new HashArrayMapNode(ownerID, newCount, newNodes);
	    };
	
	
	
	
	    function HashCollisionNode(ownerID, keyHash, entries) {
	      this.ownerID = ownerID;
	      this.keyHash = keyHash;
	      this.entries = entries;
	    }
	
	    HashCollisionNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      var entries = this.entries;
	      for (var ii = 0, len = entries.length; ii < len; ii++) {
	        if (is(key, entries[ii][0])) {
	          return entries[ii][1];
	        }
	      }
	      return notSetValue;
	    };
	
	    HashCollisionNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	
	      var removed = value === NOT_SET;
	
	      if (keyHash !== this.keyHash) {
	        if (removed) {
	          return this;
	        }
	        SetRef(didAlter);
	        SetRef(didChangeSize);
	        return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
	      }
	
	      var entries = this.entries;
	      var idx = 0;
	      for (var len = entries.length; idx < len; idx++) {
	        if (is(key, entries[idx][0])) {
	          break;
	        }
	      }
	      var exists = idx < len;
	
	      if (exists ? entries[idx][1] === value : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	      (removed || !exists) && SetRef(didChangeSize);
	
	      if (removed && len === 2) {
	        return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newEntries = isEditable ? entries : arrCopy(entries);
	
	      if (exists) {
	        if (removed) {
	          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
	        } else {
	          newEntries[idx] = [key, value];
	        }
	      } else {
	        newEntries.push([key, value]);
	      }
	
	      if (isEditable) {
	        this.entries = newEntries;
	        return this;
	      }
	
	      return new HashCollisionNode(ownerID, this.keyHash, newEntries);
	    };
	
	
	
	
	    function ValueNode(ownerID, keyHash, entry) {
	      this.ownerID = ownerID;
	      this.keyHash = keyHash;
	      this.entry = entry;
	    }
	
	    ValueNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
	    };
	
	    ValueNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      var removed = value === NOT_SET;
	      var keyMatch = is(key, this.entry[0]);
	      if (keyMatch ? value === this.entry[1] : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	
	      if (removed) {
	        SetRef(didChangeSize);
	        return; // undefined
	      }
	
	      if (keyMatch) {
	        if (ownerID && ownerID === this.ownerID) {
	          this.entry[1] = value;
	          return this;
	        }
	        return new ValueNode(ownerID, this.keyHash, [key, value]);
	      }
	
	      SetRef(didChangeSize);
	      return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
	    };
	
	
	
	  // #pragma Iterators
	
	  ArrayMapNode.prototype.iterate =
	  HashCollisionNode.prototype.iterate = function (fn, reverse) {
	    var entries = this.entries;
	    for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
	      if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
	        return false;
	      }
	    }
	  }
	
	  BitmapIndexedNode.prototype.iterate =
	  HashArrayMapNode.prototype.iterate = function (fn, reverse) {
	    var nodes = this.nodes;
	    for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
	      var node = nodes[reverse ? maxIndex - ii : ii];
	      if (node && node.iterate(fn, reverse) === false) {
	        return false;
	      }
	    }
	  }
	
	  ValueNode.prototype.iterate = function (fn, reverse) {
	    return fn(this.entry);
	  }
	
	  createClass(MapIterator, src_Iterator__Iterator);
	
	    function MapIterator(map, type, reverse) {
	      this._type = type;
	      this._reverse = reverse;
	      this._stack = map._root && mapIteratorFrame(map._root);
	    }
	
	    MapIterator.prototype.next = function() {
	      var type = this._type;
	      var stack = this._stack;
	      while (stack) {
	        var node = stack.node;
	        var index = stack.index++;
	        var maxIndex;
	        if (node.entry) {
	          if (index === 0) {
	            return mapIteratorValue(type, node.entry);
	          }
	        } else if (node.entries) {
	          maxIndex = node.entries.length - 1;
	          if (index <= maxIndex) {
	            return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
	          }
	        } else {
	          maxIndex = node.nodes.length - 1;
	          if (index <= maxIndex) {
	            var subNode = node.nodes[this._reverse ? maxIndex - index : index];
	            if (subNode) {
	              if (subNode.entry) {
	                return mapIteratorValue(type, subNode.entry);
	              }
	              stack = this._stack = mapIteratorFrame(subNode, stack);
	            }
	            continue;
	          }
	        }
	        stack = this._stack = this._stack.__prev;
	      }
	      return iteratorDone();
	    };
	
	
	  function mapIteratorValue(type, entry) {
	    return iteratorValue(type, entry[0], entry[1]);
	  }
	
	  function mapIteratorFrame(node, prev) {
	    return {
	      node: node,
	      index: 0,
	      __prev: prev
	    };
	  }
	
	  function makeMap(size, root, ownerID, hash) {
	    var map = Object.create(MapPrototype);
	    map.size = size;
	    map._root = root;
	    map.__ownerID = ownerID;
	    map.__hash = hash;
	    map.__altered = false;
	    return map;
	  }
	
	  var EMPTY_MAP;
	  function emptyMap() {
	    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
	  }
	
	  function updateMap(map, k, v) {
	    var newRoot;
	    var newSize;
	    if (!map._root) {
	      if (v === NOT_SET) {
	        return map;
	      }
	      newSize = 1;
	      newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
	    } else {
	      var didChangeSize = MakeRef(CHANGE_LENGTH);
	      var didAlter = MakeRef(DID_ALTER);
	      newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
	      if (!didAlter.value) {
	        return map;
	      }
	      newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
	    }
	    if (map.__ownerID) {
	      map.size = newSize;
	      map._root = newRoot;
	      map.__hash = undefined;
	      map.__altered = true;
	      return map;
	    }
	    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
	  }
	
	  function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	    if (!node) {
	      if (value === NOT_SET) {
	        return node;
	      }
	      SetRef(didAlter);
	      SetRef(didChangeSize);
	      return new ValueNode(ownerID, keyHash, [key, value]);
	    }
	    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
	  }
	
	  function isLeafNode(node) {
	    return node.constructor === ValueNode || node.constructor === HashCollisionNode;
	  }
	
	  function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
	    if (node.keyHash === keyHash) {
	      return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
	    }
	
	    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
	    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	
	    var newNode;
	    var nodes = idx1 === idx2 ?
	      [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)] :
	      ((newNode = new ValueNode(ownerID, keyHash, entry)), idx1 < idx2 ? [node, newNode] : [newNode, node]);
	
	    return new BitmapIndexedNode(ownerID, (1 << idx1) | (1 << idx2), nodes);
	  }
	
	  function createNodes(ownerID, entries, key, value) {
	    if (!ownerID) {
	      ownerID = new OwnerID();
	    }
	    var node = new ValueNode(ownerID, hash(key), [key, value]);
	    for (var ii = 0; ii < entries.length; ii++) {
	      var entry = entries[ii];
	      node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
	    }
	    return node;
	  }
	
	  function packNodes(ownerID, nodes, count, excluding) {
	    var bitmap = 0;
	    var packedII = 0;
	    var packedNodes = new Array(count);
	    for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
	      var node = nodes[ii];
	      if (node !== undefined && ii !== excluding) {
	        bitmap |= bit;
	        packedNodes[packedII++] = node;
	      }
	    }
	    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
	  }
	
	  function expandNodes(ownerID, nodes, bitmap, including, node) {
	    var count = 0;
	    var expandedNodes = new Array(SIZE);
	    for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
	      expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
	    }
	    expandedNodes[including] = node;
	    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
	  }
	
	  function mergeIntoMapWith(map, merger, iterables) {
	    var iters = [];
	    for (var ii = 0; ii < iterables.length; ii++) {
	      var value = iterables[ii];
	      var iter = KeyedIterable(value);
	      if (!isIterable(value)) {
	        iter = iter.map(function(v ) {return fromJS(v)});
	      }
	      iters.push(iter);
	    }
	    return mergeIntoCollectionWith(map, merger, iters);
	  }
	
	  function deepMerger(merger) {
	    return function(existing, value, key) 
	      {return existing && existing.mergeDeepWith && isIterable(value) ?
	        existing.mergeDeepWith(merger, value) :
	        merger ? merger(existing, value, key) : value};
	  }
	
	  function mergeIntoCollectionWith(collection, merger, iters) {
	    iters = iters.filter(function(x ) {return x.size !== 0});
	    if (iters.length === 0) {
	      return collection;
	    }
	    if (collection.size === 0 && !collection.__ownerID && iters.length === 1) {
	      return collection.constructor(iters[0]);
	    }
	    return collection.withMutations(function(collection ) {
	      var mergeIntoMap = merger ?
	        function(value, key)  {
	          collection.update(key, NOT_SET, function(existing )
	            {return existing === NOT_SET ? value : merger(existing, value, key)}
	          );
	        } :
	        function(value, key)  {
	          collection.set(key, value);
	        }
	      for (var ii = 0; ii < iters.length; ii++) {
	        iters[ii].forEach(mergeIntoMap);
	      }
	    });
	  }
	
	  function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
	    var isNotSet = existing === NOT_SET;
	    var step = keyPathIter.next();
	    if (step.done) {
	      var existingValue = isNotSet ? notSetValue : existing;
	      var newValue = updater(existingValue);
	      return newValue === existingValue ? existing : newValue;
	    }
	    invariant(
	      isNotSet || (existing && existing.set),
	      'invalid keyPath'
	    );
	    var key = step.value;
	    var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
	    var nextUpdated = updateInDeepMap(
	      nextExisting,
	      keyPathIter,
	      notSetValue,
	      updater
	    );
	    return nextUpdated === nextExisting ? existing :
	      nextUpdated === NOT_SET ? existing.remove(key) :
	      (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
	  }
	
	  function popCount(x) {
	    x = x - ((x >> 1) & 0x55555555);
	    x = (x & 0x33333333) + ((x >> 2) & 0x33333333);
	    x = (x + (x >> 4)) & 0x0f0f0f0f;
	    x = x + (x >> 8);
	    x = x + (x >> 16);
	    return x & 0x7f;
	  }
	
	  function setIn(array, idx, val, canEdit) {
	    var newArray = canEdit ? array : arrCopy(array);
	    newArray[idx] = val;
	    return newArray;
	  }
	
	  function spliceIn(array, idx, val, canEdit) {
	    var newLen = array.length + 1;
	    if (canEdit && idx + 1 === newLen) {
	      array[idx] = val;
	      return array;
	    }
	    var newArray = new Array(newLen);
	    var after = 0;
	    for (var ii = 0; ii < newLen; ii++) {
	      if (ii === idx) {
	        newArray[ii] = val;
	        after = -1;
	      } else {
	        newArray[ii] = array[ii + after];
	      }
	    }
	    return newArray;
	  }
	
	  function spliceOut(array, idx, canEdit) {
	    var newLen = array.length - 1;
	    if (canEdit && idx === newLen) {
	      array.pop();
	      return array;
	    }
	    var newArray = new Array(newLen);
	    var after = 0;
	    for (var ii = 0; ii < newLen; ii++) {
	      if (ii === idx) {
	        after = 1;
	      }
	      newArray[ii] = array[ii + after];
	    }
	    return newArray;
	  }
	
	  var MAX_ARRAY_MAP_SIZE = SIZE / 4;
	  var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
	  var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;
	
	  createClass(List, IndexedCollection);
	
	    // @pragma Construction
	
	    function List(value) {
	      var empty = emptyList();
	      if (value === null || value === undefined) {
	        return empty;
	      }
	      if (isList(value)) {
	        return value;
	      }
	      var iter = IndexedIterable(value);
	      var size = iter.size;
	      if (size === 0) {
	        return empty;
	      }
	      assertNotInfinite(size);
	      if (size > 0 && size < SIZE) {
	        return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
	      }
	      return empty.withMutations(function(list ) {
	        list.setSize(size);
	        iter.forEach(function(v, i)  {return list.set(i, v)});
	      });
	    }
	
	    List.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    List.prototype.toString = function() {
	      return this.__toString('List [', ']');
	    };
	
	    // @pragma Access
	
	    List.prototype.get = function(index, notSetValue) {
	      index = wrapIndex(this, index);
	      if (index >= 0 && index < this.size) {
	        index += this._origin;
	        var node = listNodeFor(this, index);
	        return node && node.array[index & MASK];
	      }
	      return notSetValue;
	    };
	
	    // @pragma Modification
	
	    List.prototype.set = function(index, value) {
	      return updateList(this, index, value);
	    };
	
	    List.prototype.remove = function(index) {
	      return !this.has(index) ? this :
	        index === 0 ? this.shift() :
	        index === this.size - 1 ? this.pop() :
	        this.splice(index, 1);
	    };
	
	    List.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = this._origin = this._capacity = 0;
	        this._level = SHIFT;
	        this._root = this._tail = null;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyList();
	    };
	
	    List.prototype.push = function(/*...values*/) {
	      var values = arguments;
	      var oldSize = this.size;
	      return this.withMutations(function(list ) {
	        setListBounds(list, 0, oldSize + values.length);
	        for (var ii = 0; ii < values.length; ii++) {
	          list.set(oldSize + ii, values[ii]);
	        }
	      });
	    };
	
	    List.prototype.pop = function() {
	      return setListBounds(this, 0, -1);
	    };
	
	    List.prototype.unshift = function(/*...values*/) {
	      var values = arguments;
	      return this.withMutations(function(list ) {
	        setListBounds(list, -values.length);
	        for (var ii = 0; ii < values.length; ii++) {
	          list.set(ii, values[ii]);
	        }
	      });
	    };
	
	    List.prototype.shift = function() {
	      return setListBounds(this, 1);
	    };
	
	    // @pragma Composition
	
	    List.prototype.merge = function(/*...iters*/) {
	      return mergeIntoListWith(this, undefined, arguments);
	    };
	
	    List.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoListWith(this, merger, iters);
	    };
	
	    List.prototype.mergeDeep = function(/*...iters*/) {
	      return mergeIntoListWith(this, deepMerger(undefined), arguments);
	    };
	
	    List.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoListWith(this, deepMerger(merger), iters);
	    };
	
	    List.prototype.setSize = function(size) {
	      return setListBounds(this, 0, size);
	    };
	
	    // @pragma Iteration
	
	    List.prototype.slice = function(begin, end) {
	      var size = this.size;
	      if (wholeSlice(begin, end, size)) {
	        return this;
	      }
	      return setListBounds(
	        this,
	        resolveBegin(begin, size),
	        resolveEnd(end, size)
	      );
	    };
	
	    List.prototype.__iterator = function(type, reverse) {
	      var index = 0;
	      var values = iterateList(this, reverse);
	      return new src_Iterator__Iterator(function()  {
	        var value = values();
	        return value === DONE ?
	          iteratorDone() :
	          iteratorValue(type, index++, value);
	      });
	    };
	
	    List.prototype.__iterate = function(fn, reverse) {
	      var index = 0;
	      var values = iterateList(this, reverse);
	      var value;
	      while ((value = values()) !== DONE) {
	        if (fn(value, index++, this) === false) {
	          break;
	        }
	      }
	      return index;
	    };
	
	    List.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        return this;
	      }
	      return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
	    };
	
	
	  function isList(maybeList) {
	    return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
	  }
	
	  List.isList = isList;
	
	  var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';
	
	  var ListPrototype = List.prototype;
	  ListPrototype[IS_LIST_SENTINEL] = true;
	  ListPrototype[DELETE] = ListPrototype.remove;
	  ListPrototype.setIn = MapPrototype.setIn;
	  ListPrototype.deleteIn =
	  ListPrototype.removeIn = MapPrototype.removeIn;
	  ListPrototype.update = MapPrototype.update;
	  ListPrototype.updateIn = MapPrototype.updateIn;
	  ListPrototype.mergeIn = MapPrototype.mergeIn;
	  ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
	  ListPrototype.withMutations = MapPrototype.withMutations;
	  ListPrototype.asMutable = MapPrototype.asMutable;
	  ListPrototype.asImmutable = MapPrototype.asImmutable;
	  ListPrototype.wasAltered = MapPrototype.wasAltered;
	
	
	
	    function VNode(array, ownerID) {
	      this.array = array;
	      this.ownerID = ownerID;
	    }
	
	    // TODO: seems like these methods are very similar
	
	    VNode.prototype.removeBefore = function(ownerID, level, index) {
	      if (index === level ? 1 << level : 0 || this.array.length === 0) {
	        return this;
	      }
	      var originIndex = (index >>> level) & MASK;
	      if (originIndex >= this.array.length) {
	        return new VNode([], ownerID);
	      }
	      var removingFirst = originIndex === 0;
	      var newChild;
	      if (level > 0) {
	        var oldChild = this.array[originIndex];
	        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
	        if (newChild === oldChild && removingFirst) {
	          return this;
	        }
	      }
	      if (removingFirst && !newChild) {
	        return this;
	      }
	      var editable = editableVNode(this, ownerID);
	      if (!removingFirst) {
	        for (var ii = 0; ii < originIndex; ii++) {
	          editable.array[ii] = undefined;
	        }
	      }
	      if (newChild) {
	        editable.array[originIndex] = newChild;
	      }
	      return editable;
	    };
	
	    VNode.prototype.removeAfter = function(ownerID, level, index) {
	      if (index === (level ? 1 << level : 0) || this.array.length === 0) {
	        return this;
	      }
	      var sizeIndex = ((index - 1) >>> level) & MASK;
	      if (sizeIndex >= this.array.length) {
	        return this;
	      }
	
	      var newChild;
	      if (level > 0) {
	        var oldChild = this.array[sizeIndex];
	        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
	        if (newChild === oldChild && sizeIndex === this.array.length - 1) {
	          return this;
	        }
	      }
	
	      var editable = editableVNode(this, ownerID);
	      editable.array.splice(sizeIndex + 1);
	      if (newChild) {
	        editable.array[sizeIndex] = newChild;
	      }
	      return editable;
	    };
	
	
	
	  var DONE = {};
	
	  function iterateList(list, reverse) {
	    var left = list._origin;
	    var right = list._capacity;
	    var tailPos = getTailOffset(right);
	    var tail = list._tail;
	
	    return iterateNodeOrLeaf(list._root, list._level, 0);
	
	    function iterateNodeOrLeaf(node, level, offset) {
	      return level === 0 ?
	        iterateLeaf(node, offset) :
	        iterateNode(node, level, offset);
	    }
	
	    function iterateLeaf(node, offset) {
	      var array = offset === tailPos ? tail && tail.array : node && node.array;
	      var from = offset > left ? 0 : left - offset;
	      var to = right - offset;
	      if (to > SIZE) {
	        to = SIZE;
	      }
	      return function()  {
	        if (from === to) {
	          return DONE;
	        }
	        var idx = reverse ? --to : from++;
	        return array && array[idx];
	      };
	    }
	
	    function iterateNode(node, level, offset) {
	      var values;
	      var array = node && node.array;
	      var from = offset > left ? 0 : (left - offset) >> level;
	      var to = ((right - offset) >> level) + 1;
	      if (to > SIZE) {
	        to = SIZE;
	      }
	      return function()  {
	        do {
	          if (values) {
	            var value = values();
	            if (value !== DONE) {
	              return value;
	            }
	            values = null;
	          }
	          if (from === to) {
	            return DONE;
	          }
	          var idx = reverse ? --to : from++;
	          values = iterateNodeOrLeaf(
	            array && array[idx], level - SHIFT, offset + (idx << level)
	          );
	        } while (true);
	      };
	    }
	  }
	
	  function makeList(origin, capacity, level, root, tail, ownerID, hash) {
	    var list = Object.create(ListPrototype);
	    list.size = capacity - origin;
	    list._origin = origin;
	    list._capacity = capacity;
	    list._level = level;
	    list._root = root;
	    list._tail = tail;
	    list.__ownerID = ownerID;
	    list.__hash = hash;
	    list.__altered = false;
	    return list;
	  }
	
	  var EMPTY_LIST;
	  function emptyList() {
	    return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
	  }
	
	  function updateList(list, index, value) {
	    index = wrapIndex(list, index);
	
	    if (index !== index) {
	      return list;
	    }
	
	    if (index >= list.size || index < 0) {
	      return list.withMutations(function(list ) {
	        index < 0 ?
	          setListBounds(list, index).set(0, value) :
	          setListBounds(list, 0, index + 1).set(index, value)
	      });
	    }
	
	    index += list._origin;
	
	    var newTail = list._tail;
	    var newRoot = list._root;
	    var didAlter = MakeRef(DID_ALTER);
	    if (index >= getTailOffset(list._capacity)) {
	      newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
	    } else {
	      newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
	    }
	
	    if (!didAlter.value) {
	      return list;
	    }
	
	    if (list.__ownerID) {
	      list._root = newRoot;
	      list._tail = newTail;
	      list.__hash = undefined;
	      list.__altered = true;
	      return list;
	    }
	    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
	  }
	
	  function updateVNode(node, ownerID, level, index, value, didAlter) {
	    var idx = (index >>> level) & MASK;
	    var nodeHas = node && idx < node.array.length;
	    if (!nodeHas && value === undefined) {
	      return node;
	    }
	
	    var newNode;
	
	    if (level > 0) {
	      var lowerNode = node && node.array[idx];
	      var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
	      if (newLowerNode === lowerNode) {
	        return node;
	      }
	      newNode = editableVNode(node, ownerID);
	      newNode.array[idx] = newLowerNode;
	      return newNode;
	    }
	
	    if (nodeHas && node.array[idx] === value) {
	      return node;
	    }
	
	    SetRef(didAlter);
	
	    newNode = editableVNode(node, ownerID);
	    if (value === undefined && idx === newNode.array.length - 1) {
	      newNode.array.pop();
	    } else {
	      newNode.array[idx] = value;
	    }
	    return newNode;
	  }
	
	  function editableVNode(node, ownerID) {
	    if (ownerID && node && ownerID === node.ownerID) {
	      return node;
	    }
	    return new VNode(node ? node.array.slice() : [], ownerID);
	  }
	
	  function listNodeFor(list, rawIndex) {
	    if (rawIndex >= getTailOffset(list._capacity)) {
	      return list._tail;
	    }
	    if (rawIndex < 1 << (list._level + SHIFT)) {
	      var node = list._root;
	      var level = list._level;
	      while (node && level > 0) {
	        node = node.array[(rawIndex >>> level) & MASK];
	        level -= SHIFT;
	      }
	      return node;
	    }
	  }
	
	  function setListBounds(list, begin, end) {
	    // Sanitize begin & end using this shorthand for ToInt32(argument)
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
	    if (begin !== undefined) {
	      begin = begin | 0;
	    }
	    if (end !== undefined) {
	      end = end | 0;
	    }
	    var owner = list.__ownerID || new OwnerID();
	    var oldOrigin = list._origin;
	    var oldCapacity = list._capacity;
	    var newOrigin = oldOrigin + begin;
	    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
	    if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
	      return list;
	    }
	
	    // If it's going to end after it starts, it's empty.
	    if (newOrigin >= newCapacity) {
	      return list.clear();
	    }
	
	    var newLevel = list._level;
	    var newRoot = list._root;
	
	    // New origin might need creating a higher root.
	    var offsetShift = 0;
	    while (newOrigin + offsetShift < 0) {
	      newRoot = new VNode(newRoot && newRoot.array.length ? [undefined, newRoot] : [], owner);
	      newLevel += SHIFT;
	      offsetShift += 1 << newLevel;
	    }
	    if (offsetShift) {
	      newOrigin += offsetShift;
	      oldOrigin += offsetShift;
	      newCapacity += offsetShift;
	      oldCapacity += offsetShift;
	    }
	
	    var oldTailOffset = getTailOffset(oldCapacity);
	    var newTailOffset = getTailOffset(newCapacity);
	
	    // New size might need creating a higher root.
	    while (newTailOffset >= 1 << (newLevel + SHIFT)) {
	      newRoot = new VNode(newRoot && newRoot.array.length ? [newRoot] : [], owner);
	      newLevel += SHIFT;
	    }
	
	    // Locate or create the new tail.
	    var oldTail = list._tail;
	    var newTail = newTailOffset < oldTailOffset ?
	      listNodeFor(list, newCapacity - 1) :
	      newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;
	
	    // Merge Tail into tree.
	    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
	      newRoot = editableVNode(newRoot, owner);
	      var node = newRoot;
	      for (var level = newLevel; level > SHIFT; level -= SHIFT) {
	        var idx = (oldTailOffset >>> level) & MASK;
	        node = node.array[idx] = editableVNode(node.array[idx], owner);
	      }
	      node.array[(oldTailOffset >>> SHIFT) & MASK] = oldTail;
	    }
	
	    // If the size has been reduced, there's a chance the tail needs to be trimmed.
	    if (newCapacity < oldCapacity) {
	      newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
	    }
	
	    // If the new origin is within the tail, then we do not need a root.
	    if (newOrigin >= newTailOffset) {
	      newOrigin -= newTailOffset;
	      newCapacity -= newTailOffset;
	      newLevel = SHIFT;
	      newRoot = null;
	      newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);
	
	    // Otherwise, if the root has been trimmed, garbage collect.
	    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
	      offsetShift = 0;
	
	      // Identify the new top root node of the subtree of the old root.
	      while (newRoot) {
	        var beginIndex = (newOrigin >>> newLevel) & MASK;
	        if (beginIndex !== (newTailOffset >>> newLevel) & MASK) {
	          break;
	        }
	        if (beginIndex) {
	          offsetShift += (1 << newLevel) * beginIndex;
	        }
	        newLevel -= SHIFT;
	        newRoot = newRoot.array[beginIndex];
	      }
	
	      // Trim the new sides of the new root.
	      if (newRoot && newOrigin > oldOrigin) {
	        newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
	      }
	      if (newRoot && newTailOffset < oldTailOffset) {
	        newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
	      }
	      if (offsetShift) {
	        newOrigin -= offsetShift;
	        newCapacity -= offsetShift;
	      }
	    }
	
	    if (list.__ownerID) {
	      list.size = newCapacity - newOrigin;
	      list._origin = newOrigin;
	      list._capacity = newCapacity;
	      list._level = newLevel;
	      list._root = newRoot;
	      list._tail = newTail;
	      list.__hash = undefined;
	      list.__altered = true;
	      return list;
	    }
	    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
	  }
	
	  function mergeIntoListWith(list, merger, iterables) {
	    var iters = [];
	    var maxSize = 0;
	    for (var ii = 0; ii < iterables.length; ii++) {
	      var value = iterables[ii];
	      var iter = IndexedIterable(value);
	      if (iter.size > maxSize) {
	        maxSize = iter.size;
	      }
	      if (!isIterable(value)) {
	        iter = iter.map(function(v ) {return fromJS(v)});
	      }
	      iters.push(iter);
	    }
	    if (maxSize > list.size) {
	      list = list.setSize(maxSize);
	    }
	    return mergeIntoCollectionWith(list, merger, iters);
	  }
	
	  function getTailOffset(size) {
	    return size < SIZE ? 0 : (((size - 1) >>> SHIFT) << SHIFT);
	  }
	
	  createClass(OrderedMap, src_Map__Map);
	
	    // @pragma Construction
	
	    function OrderedMap(value) {
	      return value === null || value === undefined ? emptyOrderedMap() :
	        isOrderedMap(value) ? value :
	        emptyOrderedMap().withMutations(function(map ) {
	          var iter = KeyedIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v, k)  {return map.set(k, v)});
	        });
	    }
	
	    OrderedMap.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    OrderedMap.prototype.toString = function() {
	      return this.__toString('OrderedMap {', '}');
	    };
	
	    // @pragma Access
	
	    OrderedMap.prototype.get = function(k, notSetValue) {
	      var index = this._map.get(k);
	      return index !== undefined ? this._list.get(index)[1] : notSetValue;
	    };
	
	    // @pragma Modification
	
	    OrderedMap.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._map.clear();
	        this._list.clear();
	        return this;
	      }
	      return emptyOrderedMap();
	    };
	
	    OrderedMap.prototype.set = function(k, v) {
	      return updateOrderedMap(this, k, v);
	    };
	
	    OrderedMap.prototype.remove = function(k) {
	      return updateOrderedMap(this, k, NOT_SET);
	    };
	
	    OrderedMap.prototype.wasAltered = function() {
	      return this._map.wasAltered() || this._list.wasAltered();
	    };
	
	    OrderedMap.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._list.__iterate(
	        function(entry ) {return entry && fn(entry[1], entry[0], this$0)},
	        reverse
	      );
	    };
	
	    OrderedMap.prototype.__iterator = function(type, reverse) {
	      return this._list.fromEntrySeq().__iterator(type, reverse);
	    };
	
	    OrderedMap.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map.__ensureOwner(ownerID);
	      var newList = this._list.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        this._list = newList;
	        return this;
	      }
	      return makeOrderedMap(newMap, newList, ownerID, this.__hash);
	    };
	
	
	  function isOrderedMap(maybeOrderedMap) {
	    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
	  }
	
	  OrderedMap.isOrderedMap = isOrderedMap;
	
	  OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
	  OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;
	
	
	
	  function makeOrderedMap(map, list, ownerID, hash) {
	    var omap = Object.create(OrderedMap.prototype);
	    omap.size = map ? map.size : 0;
	    omap._map = map;
	    omap._list = list;
	    omap.__ownerID = ownerID;
	    omap.__hash = hash;
	    return omap;
	  }
	
	  var EMPTY_ORDERED_MAP;
	  function emptyOrderedMap() {
	    return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
	  }
	
	  function updateOrderedMap(omap, k, v) {
	    var map = omap._map;
	    var list = omap._list;
	    var i = map.get(k);
	    var has = i !== undefined;
	    var newMap;
	    var newList;
	    if (v === NOT_SET) { // removed
	      if (!has) {
	        return omap;
	      }
	      if (list.size >= SIZE && list.size >= map.size * 2) {
	        newList = list.filter(function(entry, idx)  {return entry !== undefined && i !== idx});
	        newMap = newList.toKeyedSeq().map(function(entry ) {return entry[0]}).flip().toMap();
	        if (omap.__ownerID) {
	          newMap.__ownerID = newList.__ownerID = omap.__ownerID;
	        }
	      } else {
	        newMap = map.remove(k);
	        newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
	      }
	    } else {
	      if (has) {
	        if (v === list.get(i)[1]) {
	          return omap;
	        }
	        newMap = map;
	        newList = list.set(i, [k, v]);
	      } else {
	        newMap = map.set(k, list.size);
	        newList = list.set(list.size, [k, v]);
	      }
	    }
	    if (omap.__ownerID) {
	      omap.size = newMap.size;
	      omap._map = newMap;
	      omap._list = newList;
	      omap.__hash = undefined;
	      return omap;
	    }
	    return makeOrderedMap(newMap, newList);
	  }
	
	  createClass(Stack, IndexedCollection);
	
	    // @pragma Construction
	
	    function Stack(value) {
	      return value === null || value === undefined ? emptyStack() :
	        isStack(value) ? value :
	        emptyStack().unshiftAll(value);
	    }
	
	    Stack.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    Stack.prototype.toString = function() {
	      return this.__toString('Stack [', ']');
	    };
	
	    // @pragma Access
	
	    Stack.prototype.get = function(index, notSetValue) {
	      var head = this._head;
	      index = wrapIndex(this, index);
	      while (head && index--) {
	        head = head.next;
	      }
	      return head ? head.value : notSetValue;
	    };
	
	    Stack.prototype.peek = function() {
	      return this._head && this._head.value;
	    };
	
	    // @pragma Modification
	
	    Stack.prototype.push = function(/*...values*/) {
	      if (arguments.length === 0) {
	        return this;
	      }
	      var newSize = this.size + arguments.length;
	      var head = this._head;
	      for (var ii = arguments.length - 1; ii >= 0; ii--) {
	        head = {
	          value: arguments[ii],
	          next: head
	        };
	      }
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    Stack.prototype.pushAll = function(iter) {
	      iter = IndexedIterable(iter);
	      if (iter.size === 0) {
	        return this;
	      }
	      assertNotInfinite(iter.size);
	      var newSize = this.size;
	      var head = this._head;
	      iter.reverse().forEach(function(value ) {
	        newSize++;
	        head = {
	          value: value,
	          next: head
	        };
	      });
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    Stack.prototype.pop = function() {
	      return this.slice(1);
	    };
	
	    Stack.prototype.unshift = function(/*...values*/) {
	      return this.push.apply(this, arguments);
	    };
	
	    Stack.prototype.unshiftAll = function(iter) {
	      return this.pushAll(iter);
	    };
	
	    Stack.prototype.shift = function() {
	      return this.pop.apply(this, arguments);
	    };
	
	    Stack.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._head = undefined;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyStack();
	    };
	
	    Stack.prototype.slice = function(begin, end) {
	      if (wholeSlice(begin, end, this.size)) {
	        return this;
	      }
	      var resolvedBegin = resolveBegin(begin, this.size);
	      var resolvedEnd = resolveEnd(end, this.size);
	      if (resolvedEnd !== this.size) {
	        // super.slice(begin, end);
	        return IndexedCollection.prototype.slice.call(this, begin, end);
	      }
	      var newSize = this.size - resolvedBegin;
	      var head = this._head;
	      while (resolvedBegin--) {
	        head = head.next;
	      }
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    // @pragma Mutability
	
	    Stack.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this.__altered = false;
	        return this;
	      }
	      return makeStack(this.size, this._head, ownerID, this.__hash);
	    };
	
	    // @pragma Iteration
	
	    Stack.prototype.__iterate = function(fn, reverse) {
	      if (reverse) {
	        return this.reverse().__iterate(fn);
	      }
	      var iterations = 0;
	      var node = this._head;
	      while (node) {
	        if (fn(node.value, iterations++, this) === false) {
	          break;
	        }
	        node = node.next;
	      }
	      return iterations;
	    };
	
	    Stack.prototype.__iterator = function(type, reverse) {
	      if (reverse) {
	        return this.reverse().__iterator(type);
	      }
	      var iterations = 0;
	      var node = this._head;
	      return new src_Iterator__Iterator(function()  {
	        if (node) {
	          var value = node.value;
	          node = node.next;
	          return iteratorValue(type, iterations++, value);
	        }
	        return iteratorDone();
	      });
	    };
	
	
	  function isStack(maybeStack) {
	    return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
	  }
	
	  Stack.isStack = isStack;
	
	  var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';
	
	  var StackPrototype = Stack.prototype;
	  StackPrototype[IS_STACK_SENTINEL] = true;
	  StackPrototype.withMutations = MapPrototype.withMutations;
	  StackPrototype.asMutable = MapPrototype.asMutable;
	  StackPrototype.asImmutable = MapPrototype.asImmutable;
	  StackPrototype.wasAltered = MapPrototype.wasAltered;
	
	
	  function makeStack(size, head, ownerID, hash) {
	    var map = Object.create(StackPrototype);
	    map.size = size;
	    map._head = head;
	    map.__ownerID = ownerID;
	    map.__hash = hash;
	    map.__altered = false;
	    return map;
	  }
	
	  var EMPTY_STACK;
	  function emptyStack() {
	    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
	  }
	
	  createClass(src_Set__Set, SetCollection);
	
	    // @pragma Construction
	
	    function src_Set__Set(value) {
	      return value === null || value === undefined ? emptySet() :
	        isSet(value) && !isOrdered(value) ? value :
	        emptySet().withMutations(function(set ) {
	          var iter = SetIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v ) {return set.add(v)});
	        });
	    }
	
	    src_Set__Set.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    src_Set__Set.fromKeys = function(value) {
	      return this(KeyedIterable(value).keySeq());
	    };
	
	    src_Set__Set.prototype.toString = function() {
	      return this.__toString('Set {', '}');
	    };
	
	    // @pragma Access
	
	    src_Set__Set.prototype.has = function(value) {
	      return this._map.has(value);
	    };
	
	    // @pragma Modification
	
	    src_Set__Set.prototype.add = function(value) {
	      return updateSet(this, this._map.set(value, true));
	    };
	
	    src_Set__Set.prototype.remove = function(value) {
	      return updateSet(this, this._map.remove(value));
	    };
	
	    src_Set__Set.prototype.clear = function() {
	      return updateSet(this, this._map.clear());
	    };
	
	    // @pragma Composition
	
	    src_Set__Set.prototype.union = function() {var iters = SLICE$0.call(arguments, 0);
	      iters = iters.filter(function(x ) {return x.size !== 0});
	      if (iters.length === 0) {
	        return this;
	      }
	      if (this.size === 0 && !this.__ownerID && iters.length === 1) {
	        return this.constructor(iters[0]);
	      }
	      return this.withMutations(function(set ) {
	        for (var ii = 0; ii < iters.length; ii++) {
	          SetIterable(iters[ii]).forEach(function(value ) {return set.add(value)});
	        }
	      });
	    };
	
	    src_Set__Set.prototype.intersect = function() {var iters = SLICE$0.call(arguments, 0);
	      if (iters.length === 0) {
	        return this;
	      }
	      iters = iters.map(function(iter ) {return SetIterable(iter)});
	      var originalSet = this;
	      return this.withMutations(function(set ) {
	        originalSet.forEach(function(value ) {
	          if (!iters.every(function(iter ) {return iter.includes(value)})) {
	            set.remove(value);
	          }
	        });
	      });
	    };
	
	    src_Set__Set.prototype.subtract = function() {var iters = SLICE$0.call(arguments, 0);
	      if (iters.length === 0) {
	        return this;
	      }
	      iters = iters.map(function(iter ) {return SetIterable(iter)});
	      var originalSet = this;
	      return this.withMutations(function(set ) {
	        originalSet.forEach(function(value ) {
	          if (iters.some(function(iter ) {return iter.includes(value)})) {
	            set.remove(value);
	          }
	        });
	      });
	    };
	
	    src_Set__Set.prototype.merge = function() {
	      return this.union.apply(this, arguments);
	    };
	
	    src_Set__Set.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return this.union.apply(this, iters);
	    };
	
	    src_Set__Set.prototype.sort = function(comparator) {
	      // Late binding
	      return OrderedSet(sortFactory(this, comparator));
	    };
	
	    src_Set__Set.prototype.sortBy = function(mapper, comparator) {
	      // Late binding
	      return OrderedSet(sortFactory(this, comparator, mapper));
	    };
	
	    src_Set__Set.prototype.wasAltered = function() {
	      return this._map.wasAltered();
	    };
	
	    src_Set__Set.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._map.__iterate(function(_, k)  {return fn(k, k, this$0)}, reverse);
	    };
	
	    src_Set__Set.prototype.__iterator = function(type, reverse) {
	      return this._map.map(function(_, k)  {return k}).__iterator(type, reverse);
	    };
	
	    src_Set__Set.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        return this;
	      }
	      return this.__make(newMap, ownerID);
	    };
	
	
	  function isSet(maybeSet) {
	    return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
	  }
	
	  src_Set__Set.isSet = isSet;
	
	  var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';
	
	  var SetPrototype = src_Set__Set.prototype;
	  SetPrototype[IS_SET_SENTINEL] = true;
	  SetPrototype[DELETE] = SetPrototype.remove;
	  SetPrototype.mergeDeep = SetPrototype.merge;
	  SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
	  SetPrototype.withMutations = MapPrototype.withMutations;
	  SetPrototype.asMutable = MapPrototype.asMutable;
	  SetPrototype.asImmutable = MapPrototype.asImmutable;
	
	  SetPrototype.__empty = emptySet;
	  SetPrototype.__make = makeSet;
	
	  function updateSet(set, newMap) {
	    if (set.__ownerID) {
	      set.size = newMap.size;
	      set._map = newMap;
	      return set;
	    }
	    return newMap === set._map ? set :
	      newMap.size === 0 ? set.__empty() :
	      set.__make(newMap);
	  }
	
	  function makeSet(map, ownerID) {
	    var set = Object.create(SetPrototype);
	    set.size = map ? map.size : 0;
	    set._map = map;
	    set.__ownerID = ownerID;
	    return set;
	  }
	
	  var EMPTY_SET;
	  function emptySet() {
	    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
	  }
	
	  createClass(OrderedSet, src_Set__Set);
	
	    // @pragma Construction
	
	    function OrderedSet(value) {
	      return value === null || value === undefined ? emptyOrderedSet() :
	        isOrderedSet(value) ? value :
	        emptyOrderedSet().withMutations(function(set ) {
	          var iter = SetIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v ) {return set.add(v)});
	        });
	    }
	
	    OrderedSet.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    OrderedSet.fromKeys = function(value) {
	      return this(KeyedIterable(value).keySeq());
	    };
	
	    OrderedSet.prototype.toString = function() {
	      return this.__toString('OrderedSet {', '}');
	    };
	
	
	  function isOrderedSet(maybeOrderedSet) {
	    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
	  }
	
	  OrderedSet.isOrderedSet = isOrderedSet;
	
	  var OrderedSetPrototype = OrderedSet.prototype;
	  OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;
	
	  OrderedSetPrototype.__empty = emptyOrderedSet;
	  OrderedSetPrototype.__make = makeOrderedSet;
	
	  function makeOrderedSet(map, ownerID) {
	    var set = Object.create(OrderedSetPrototype);
	    set.size = map ? map.size : 0;
	    set._map = map;
	    set.__ownerID = ownerID;
	    return set;
	  }
	
	  var EMPTY_ORDERED_SET;
	  function emptyOrderedSet() {
	    return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
	  }
	
	  createClass(Record, KeyedCollection);
	
	    function Record(defaultValues, name) {
	      var hasInitialized;
	
	      var RecordType = function Record(values) {
	        if (values instanceof RecordType) {
	          return values;
	        }
	        if (!(this instanceof RecordType)) {
	          return new RecordType(values);
	        }
	        if (!hasInitialized) {
	          hasInitialized = true;
	          var keys = Object.keys(defaultValues);
	          setProps(RecordTypePrototype, keys);
	          RecordTypePrototype.size = keys.length;
	          RecordTypePrototype._name = name;
	          RecordTypePrototype._keys = keys;
	          RecordTypePrototype._defaultValues = defaultValues;
	        }
	        this._map = src_Map__Map(values);
	      };
	
	      var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
	      RecordTypePrototype.constructor = RecordType;
	
	      return RecordType;
	    }
	
	    Record.prototype.toString = function() {
	      return this.__toString(recordName(this) + ' {', '}');
	    };
	
	    // @pragma Access
	
	    Record.prototype.has = function(k) {
	      return this._defaultValues.hasOwnProperty(k);
	    };
	
	    Record.prototype.get = function(k, notSetValue) {
	      if (!this.has(k)) {
	        return notSetValue;
	      }
	      var defaultVal = this._defaultValues[k];
	      return this._map ? this._map.get(k, defaultVal) : defaultVal;
	    };
	
	    // @pragma Modification
	
	    Record.prototype.clear = function() {
	      if (this.__ownerID) {
	        this._map && this._map.clear();
	        return this;
	      }
	      var RecordType = this.constructor;
	      return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
	    };
	
	    Record.prototype.set = function(k, v) {
	      if (!this.has(k)) {
	        throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
	      }
	      var newMap = this._map && this._map.set(k, v);
	      if (this.__ownerID || newMap === this._map) {
	        return this;
	      }
	      return makeRecord(this, newMap);
	    };
	
	    Record.prototype.remove = function(k) {
	      if (!this.has(k)) {
	        return this;
	      }
	      var newMap = this._map && this._map.remove(k);
	      if (this.__ownerID || newMap === this._map) {
	        return this;
	      }
	      return makeRecord(this, newMap);
	    };
	
	    Record.prototype.wasAltered = function() {
	      return this._map.wasAltered();
	    };
	
	    Record.prototype.__iterator = function(type, reverse) {var this$0 = this;
	      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterator(type, reverse);
	    };
	
	    Record.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterate(fn, reverse);
	    };
	
	    Record.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map && this._map.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        return this;
	      }
	      return makeRecord(this, newMap, ownerID);
	    };
	
	
	  var RecordPrototype = Record.prototype;
	  RecordPrototype[DELETE] = RecordPrototype.remove;
	  RecordPrototype.deleteIn =
	  RecordPrototype.removeIn = MapPrototype.removeIn;
	  RecordPrototype.merge = MapPrototype.merge;
	  RecordPrototype.mergeWith = MapPrototype.mergeWith;
	  RecordPrototype.mergeIn = MapPrototype.mergeIn;
	  RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
	  RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
	  RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
	  RecordPrototype.setIn = MapPrototype.setIn;
	  RecordPrototype.update = MapPrototype.update;
	  RecordPrototype.updateIn = MapPrototype.updateIn;
	  RecordPrototype.withMutations = MapPrototype.withMutations;
	  RecordPrototype.asMutable = MapPrototype.asMutable;
	  RecordPrototype.asImmutable = MapPrototype.asImmutable;
	
	
	  function makeRecord(likeRecord, map, ownerID) {
	    var record = Object.create(Object.getPrototypeOf(likeRecord));
	    record._map = map;
	    record.__ownerID = ownerID;
	    return record;
	  }
	
	  function recordName(record) {
	    return record._name || record.constructor.name || 'Record';
	  }
	
	  function setProps(prototype, names) {
	    try {
	      names.forEach(setProp.bind(undefined, prototype));
	    } catch (error) {
	      // Object.defineProperty failed. Probably IE8.
	    }
	  }
	
	  function setProp(prototype, name) {
	    Object.defineProperty(prototype, name, {
	      get: function() {
	        return this.get(name);
	      },
	      set: function(value) {
	        invariant(this.__ownerID, 'Cannot set on an immutable record.');
	        this.set(name, value);
	      }
	    });
	  }
	
	  function deepEqual(a, b) {
	    if (a === b) {
	      return true;
	    }
	
	    if (
	      !isIterable(b) ||
	      a.size !== undefined && b.size !== undefined && a.size !== b.size ||
	      a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash ||
	      isKeyed(a) !== isKeyed(b) ||
	      isIndexed(a) !== isIndexed(b) ||
	      isOrdered(a) !== isOrdered(b)
	    ) {
	      return false;
	    }
	
	    if (a.size === 0 && b.size === 0) {
	      return true;
	    }
	
	    var notAssociative = !isAssociative(a);
	
	    if (isOrdered(a)) {
	      var entries = a.entries();
	      return b.every(function(v, k)  {
	        var entry = entries.next().value;
	        return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
	      }) && entries.next().done;
	    }
	
	    var flipped = false;
	
	    if (a.size === undefined) {
	      if (b.size === undefined) {
	        if (typeof a.cacheResult === 'function') {
	          a.cacheResult();
	        }
	      } else {
	        flipped = true;
	        var _ = a;
	        a = b;
	        b = _;
	      }
	    }
	
	    var allEqual = true;
	    var bSize = b.__iterate(function(v, k)  {
	      if (notAssociative ? !a.has(v) :
	          flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
	        allEqual = false;
	        return false;
	      }
	    });
	
	    return allEqual && a.size === bSize;
	  }
	
	  createClass(Range, IndexedSeq);
	
	    function Range(start, end, step) {
	      if (!(this instanceof Range)) {
	        return new Range(start, end, step);
	      }
	      invariant(step !== 0, 'Cannot step a Range by 0');
	      start = start || 0;
	      if (end === undefined) {
	        end = Infinity;
	      }
	      step = step === undefined ? 1 : Math.abs(step);
	      if (end < start) {
	        step = -step;
	      }
	      this._start = start;
	      this._end = end;
	      this._step = step;
	      this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
	      if (this.size === 0) {
	        if (EMPTY_RANGE) {
	          return EMPTY_RANGE;
	        }
	        EMPTY_RANGE = this;
	      }
	    }
	
	    Range.prototype.toString = function() {
	      if (this.size === 0) {
	        return 'Range []';
	      }
	      return 'Range [ ' +
	        this._start + '...' + this._end +
	        (this._step > 1 ? ' by ' + this._step : '') +
	      ' ]';
	    };
	
	    Range.prototype.get = function(index, notSetValue) {
	      return this.has(index) ?
	        this._start + wrapIndex(this, index) * this._step :
	        notSetValue;
	    };
	
	    Range.prototype.includes = function(searchValue) {
	      var possibleIndex = (searchValue - this._start) / this._step;
	      return possibleIndex >= 0 &&
	        possibleIndex < this.size &&
	        possibleIndex === Math.floor(possibleIndex);
	    };
	
	    Range.prototype.slice = function(begin, end) {
	      if (wholeSlice(begin, end, this.size)) {
	        return this;
	      }
	      begin = resolveBegin(begin, this.size);
	      end = resolveEnd(end, this.size);
	      if (end <= begin) {
	        return new Range(0, 0);
	      }
	      return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
	    };
	
	    Range.prototype.indexOf = function(searchValue) {
	      var offsetValue = searchValue - this._start;
	      if (offsetValue % this._step === 0) {
	        var index = offsetValue / this._step;
	        if (index >= 0 && index < this.size) {
	          return index
	        }
	      }
	      return -1;
	    };
	
	    Range.prototype.lastIndexOf = function(searchValue) {
	      return this.indexOf(searchValue);
	    };
	
	    Range.prototype.__iterate = function(fn, reverse) {
	      var maxIndex = this.size - 1;
	      var step = this._step;
	      var value = reverse ? this._start + maxIndex * step : this._start;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        if (fn(value, ii, this) === false) {
	          return ii + 1;
	        }
	        value += reverse ? -step : step;
	      }
	      return ii;
	    };
	
	    Range.prototype.__iterator = function(type, reverse) {
	      var maxIndex = this.size - 1;
	      var step = this._step;
	      var value = reverse ? this._start + maxIndex * step : this._start;
	      var ii = 0;
	      return new src_Iterator__Iterator(function()  {
	        var v = value;
	        value += reverse ? -step : step;
	        return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
	      });
	    };
	
	    Range.prototype.equals = function(other) {
	      return other instanceof Range ?
	        this._start === other._start &&
	        this._end === other._end &&
	        this._step === other._step :
	        deepEqual(this, other);
	    };
	
	
	  var EMPTY_RANGE;
	
	  createClass(Repeat, IndexedSeq);
	
	    function Repeat(value, times) {
	      if (!(this instanceof Repeat)) {
	        return new Repeat(value, times);
	      }
	      this._value = value;
	      this.size = times === undefined ? Infinity : Math.max(0, times);
	      if (this.size === 0) {
	        if (EMPTY_REPEAT) {
	          return EMPTY_REPEAT;
	        }
	        EMPTY_REPEAT = this;
	      }
	    }
	
	    Repeat.prototype.toString = function() {
	      if (this.size === 0) {
	        return 'Repeat []';
	      }
	      return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
	    };
	
	    Repeat.prototype.get = function(index, notSetValue) {
	      return this.has(index) ? this._value : notSetValue;
	    };
	
	    Repeat.prototype.includes = function(searchValue) {
	      return is(this._value, searchValue);
	    };
	
	    Repeat.prototype.slice = function(begin, end) {
	      var size = this.size;
	      return wholeSlice(begin, end, size) ? this :
	        new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
	    };
	
	    Repeat.prototype.reverse = function() {
	      return this;
	    };
	
	    Repeat.prototype.indexOf = function(searchValue) {
	      if (is(this._value, searchValue)) {
	        return 0;
	      }
	      return -1;
	    };
	
	    Repeat.prototype.lastIndexOf = function(searchValue) {
	      if (is(this._value, searchValue)) {
	        return this.size;
	      }
	      return -1;
	    };
	
	    Repeat.prototype.__iterate = function(fn, reverse) {
	      for (var ii = 0; ii < this.size; ii++) {
	        if (fn(this._value, ii, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    Repeat.prototype.__iterator = function(type, reverse) {var this$0 = this;
	      var ii = 0;
	      return new src_Iterator__Iterator(function() 
	        {return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone()}
	      );
	    };
	
	    Repeat.prototype.equals = function(other) {
	      return other instanceof Repeat ?
	        is(this._value, other._value) :
	        deepEqual(other);
	    };
	
	
	  var EMPTY_REPEAT;
	
	  /**
	   * Contributes additional methods to a constructor
	   */
	  function mixin(ctor, methods) {
	    var keyCopier = function(key ) { ctor.prototype[key] = methods[key]; };
	    Object.keys(methods).forEach(keyCopier);
	    Object.getOwnPropertySymbols &&
	      Object.getOwnPropertySymbols(methods).forEach(keyCopier);
	    return ctor;
	  }
	
	  Iterable.Iterator = src_Iterator__Iterator;
	
	  mixin(Iterable, {
	
	    // ### Conversion to other types
	
	    toArray: function() {
	      assertNotInfinite(this.size);
	      var array = new Array(this.size || 0);
	      this.valueSeq().__iterate(function(v, i)  { array[i] = v; });
	      return array;
	    },
	
	    toIndexedSeq: function() {
	      return new ToIndexedSequence(this);
	    },
	
	    toJS: function() {
	      return this.toSeq().map(
	        function(value ) {return value && typeof value.toJS === 'function' ? value.toJS() : value}
	      ).__toJS();
	    },
	
	    toJSON: function() {
	      return this.toSeq().map(
	        function(value ) {return value && typeof value.toJSON === 'function' ? value.toJSON() : value}
	      ).__toJS();
	    },
	
	    toKeyedSeq: function() {
	      return new ToKeyedSequence(this, true);
	    },
	
	    toMap: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return src_Map__Map(this.toKeyedSeq());
	    },
	
	    toObject: function() {
	      assertNotInfinite(this.size);
	      var object = {};
	      this.__iterate(function(v, k)  { object[k] = v; });
	      return object;
	    },
	
	    toOrderedMap: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return OrderedMap(this.toKeyedSeq());
	    },
	
	    toOrderedSet: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toSet: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return src_Set__Set(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toSetSeq: function() {
	      return new ToSetSequence(this);
	    },
	
	    toSeq: function() {
	      return isIndexed(this) ? this.toIndexedSeq() :
	        isKeyed(this) ? this.toKeyedSeq() :
	        this.toSetSeq();
	    },
	
	    toStack: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Stack(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toList: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return List(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	
	    // ### Common JavaScript methods and properties
	
	    toString: function() {
	      return '[Iterable]';
	    },
	
	    __toString: function(head, tail) {
	      if (this.size === 0) {
	        return head + tail;
	      }
	      return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
	    },
	
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    concat: function() {var values = SLICE$0.call(arguments, 0);
	      return reify(this, concatFactory(this, values));
	    },
	
	    includes: function(searchValue) {
	      return this.some(function(value ) {return is(value, searchValue)});
	    },
	
	    entries: function() {
	      return this.__iterator(ITERATE_ENTRIES);
	    },
	
	    every: function(predicate, context) {
	      assertNotInfinite(this.size);
	      var returnValue = true;
	      this.__iterate(function(v, k, c)  {
	        if (!predicate.call(context, v, k, c)) {
	          returnValue = false;
	          return false;
	        }
	      });
	      return returnValue;
	    },
	
	    filter: function(predicate, context) {
	      return reify(this, filterFactory(this, predicate, context, true));
	    },
	
	    find: function(predicate, context, notSetValue) {
	      var entry = this.findEntry(predicate, context);
	      return entry ? entry[1] : notSetValue;
	    },
	
	    findEntry: function(predicate, context) {
	      var found;
	      this.__iterate(function(v, k, c)  {
	        if (predicate.call(context, v, k, c)) {
	          found = [k, v];
	          return false;
	        }
	      });
	      return found;
	    },
	
	    findLastEntry: function(predicate, context) {
	      return this.toSeq().reverse().findEntry(predicate, context);
	    },
	
	    forEach: function(sideEffect, context) {
	      assertNotInfinite(this.size);
	      return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
	    },
	
	    join: function(separator) {
	      assertNotInfinite(this.size);
	      separator = separator !== undefined ? '' + separator : ',';
	      var joined = '';
	      var isFirst = true;
	      this.__iterate(function(v ) {
	        isFirst ? (isFirst = false) : (joined += separator);
	        joined += v !== null && v !== undefined ? v.toString() : '';
	      });
	      return joined;
	    },
	
	    keys: function() {
	      return this.__iterator(ITERATE_KEYS);
	    },
	
	    map: function(mapper, context) {
	      return reify(this, mapFactory(this, mapper, context));
	    },
	
	    reduce: function(reducer, initialReduction, context) {
	      assertNotInfinite(this.size);
	      var reduction;
	      var useFirst;
	      if (arguments.length < 2) {
	        useFirst = true;
	      } else {
	        reduction = initialReduction;
	      }
	      this.__iterate(function(v, k, c)  {
	        if (useFirst) {
	          useFirst = false;
	          reduction = v;
	        } else {
	          reduction = reducer.call(context, reduction, v, k, c);
	        }
	      });
	      return reduction;
	    },
	
	    reduceRight: function(reducer, initialReduction, context) {
	      var reversed = this.toKeyedSeq().reverse();
	      return reversed.reduce.apply(reversed, arguments);
	    },
	
	    reverse: function() {
	      return reify(this, reverseFactory(this, true));
	    },
	
	    slice: function(begin, end) {
	      return reify(this, sliceFactory(this, begin, end, true));
	    },
	
	    some: function(predicate, context) {
	      return !this.every(not(predicate), context);
	    },
	
	    sort: function(comparator) {
	      return reify(this, sortFactory(this, comparator));
	    },
	
	    values: function() {
	      return this.__iterator(ITERATE_VALUES);
	    },
	
	
	    // ### More sequential methods
	
	    butLast: function() {
	      return this.slice(0, -1);
	    },
	
	    isEmpty: function() {
	      return this.size !== undefined ? this.size === 0 : !this.some(function()  {return true});
	    },
	
	    count: function(predicate, context) {
	      return ensureSize(
	        predicate ? this.toSeq().filter(predicate, context) : this
	      );
	    },
	
	    countBy: function(grouper, context) {
	      return countByFactory(this, grouper, context);
	    },
	
	    equals: function(other) {
	      return deepEqual(this, other);
	    },
	
	    entrySeq: function() {
	      var iterable = this;
	      if (iterable._cache) {
	        // We cache as an entries array, so we can just return the cache!
	        return new ArraySeq(iterable._cache);
	      }
	      var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
	      entriesSequence.fromEntrySeq = function()  {return iterable.toSeq()};
	      return entriesSequence;
	    },
	
	    filterNot: function(predicate, context) {
	      return this.filter(not(predicate), context);
	    },
	
	    findLast: function(predicate, context, notSetValue) {
	      return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
	    },
	
	    first: function() {
	      return this.find(returnTrue);
	    },
	
	    flatMap: function(mapper, context) {
	      return reify(this, flatMapFactory(this, mapper, context));
	    },
	
	    flatten: function(depth) {
	      return reify(this, flattenFactory(this, depth, true));
	    },
	
	    fromEntrySeq: function() {
	      return new FromEntriesSequence(this);
	    },
	
	    get: function(searchKey, notSetValue) {
	      return this.find(function(_, key)  {return is(key, searchKey)}, undefined, notSetValue);
	    },
	
	    getIn: function(searchKeyPath, notSetValue) {
	      var nested = this;
	      // Note: in an ES6 environment, we would prefer:
	      // for (var key of searchKeyPath) {
	      var iter = forceIterator(searchKeyPath);
	      var step;
	      while (!(step = iter.next()).done) {
	        var key = step.value;
	        nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;
	        if (nested === NOT_SET) {
	          return notSetValue;
	        }
	      }
	      return nested;
	    },
	
	    groupBy: function(grouper, context) {
	      return groupByFactory(this, grouper, context);
	    },
	
	    has: function(searchKey) {
	      return this.get(searchKey, NOT_SET) !== NOT_SET;
	    },
	
	    hasIn: function(searchKeyPath) {
	      return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
	    },
	
	    isSubset: function(iter) {
	      iter = typeof iter.includes === 'function' ? iter : Iterable(iter);
	      return this.every(function(value ) {return iter.includes(value)});
	    },
	
	    isSuperset: function(iter) {
	      iter = typeof iter.isSubset === 'function' ? iter : Iterable(iter);
	      return iter.isSubset(this);
	    },
	
	    keySeq: function() {
	      return this.toSeq().map(keyMapper).toIndexedSeq();
	    },
	
	    last: function() {
	      return this.toSeq().reverse().first();
	    },
	
	    max: function(comparator) {
	      return maxFactory(this, comparator);
	    },
	
	    maxBy: function(mapper, comparator) {
	      return maxFactory(this, comparator, mapper);
	    },
	
	    min: function(comparator) {
	      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
	    },
	
	    minBy: function(mapper, comparator) {
	      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
	    },
	
	    rest: function() {
	      return this.slice(1);
	    },
	
	    skip: function(amount) {
	      return this.slice(Math.max(0, amount));
	    },
	
	    skipLast: function(amount) {
	      return reify(this, this.toSeq().reverse().skip(amount).reverse());
	    },
	
	    skipWhile: function(predicate, context) {
	      return reify(this, skipWhileFactory(this, predicate, context, true));
	    },
	
	    skipUntil: function(predicate, context) {
	      return this.skipWhile(not(predicate), context);
	    },
	
	    sortBy: function(mapper, comparator) {
	      return reify(this, sortFactory(this, comparator, mapper));
	    },
	
	    take: function(amount) {
	      return this.slice(0, Math.max(0, amount));
	    },
	
	    takeLast: function(amount) {
	      return reify(this, this.toSeq().reverse().take(amount).reverse());
	    },
	
	    takeWhile: function(predicate, context) {
	      return reify(this, takeWhileFactory(this, predicate, context));
	    },
	
	    takeUntil: function(predicate, context) {
	      return this.takeWhile(not(predicate), context);
	    },
	
	    valueSeq: function() {
	      return this.toIndexedSeq();
	    },
	
	
	    // ### Hashable Object
	
	    hashCode: function() {
	      return this.__hash || (this.__hash = hashIterable(this));
	    }
	
	
	    // ### Internal
	
	    // abstract __iterate(fn, reverse)
	
	    // abstract __iterator(type, reverse)
	  });
	
	  // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
	  // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
	  // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
	  // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
	  var IterablePrototype = Iterable.prototype;
	  IterablePrototype[IS_ITERABLE_SENTINEL] = true;
	  IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
	  IterablePrototype.__toJS = IterablePrototype.toArray;
	  IterablePrototype.__toStringMapper = quoteString;
	  IterablePrototype.inspect =
	  IterablePrototype.toSource = function() { return this.toString(); };
	  IterablePrototype.chain = IterablePrototype.flatMap;
	  IterablePrototype.contains = IterablePrototype.includes;
	
	  // Temporary warning about using length
	  (function () {
	    try {
	      Object.defineProperty(IterablePrototype, 'length', {
	        get: function () {
	          if (!Iterable.noLengthWarning) {
	            var stack;
	            try {
	              throw new Error();
	            } catch (error) {
	              stack = error.stack;
	            }
	            if (stack.indexOf('_wrapObject') === -1) {
	              console && console.warn && console.warn(
	                'iterable.length has been deprecated, '+
	                'use iterable.size or iterable.count(). '+
	                'This warning will become a silent error in a future version. ' +
	                stack
	              );
	              return this.size;
	            }
	          }
	        }
	      });
	    } catch (e) {}
	  })();
	
	
	
	  mixin(KeyedIterable, {
	
	    // ### More sequential methods
	
	    flip: function() {
	      return reify(this, flipFactory(this));
	    },
	
	    findKey: function(predicate, context) {
	      var entry = this.findEntry(predicate, context);
	      return entry && entry[0];
	    },
	
	    findLastKey: function(predicate, context) {
	      return this.toSeq().reverse().findKey(predicate, context);
	    },
	
	    keyOf: function(searchValue) {
	      return this.findKey(function(value ) {return is(value, searchValue)});
	    },
	
	    lastKeyOf: function(searchValue) {
	      return this.findLastKey(function(value ) {return is(value, searchValue)});
	    },
	
	    mapEntries: function(mapper, context) {var this$0 = this;
	      var iterations = 0;
	      return reify(this,
	        this.toSeq().map(
	          function(v, k)  {return mapper.call(context, [k, v], iterations++, this$0)}
	        ).fromEntrySeq()
	      );
	    },
	
	    mapKeys: function(mapper, context) {var this$0 = this;
	      return reify(this,
	        this.toSeq().flip().map(
	          function(k, v)  {return mapper.call(context, k, v, this$0)}
	        ).flip()
	      );
	    }
	
	  });
	
	  var KeyedIterablePrototype = KeyedIterable.prototype;
	  KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
	  KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
	  KeyedIterablePrototype.__toJS = IterablePrototype.toObject;
	  KeyedIterablePrototype.__toStringMapper = function(v, k)  {return JSON.stringify(k) + ': ' + quoteString(v)};
	
	
	
	  mixin(IndexedIterable, {
	
	    // ### Conversion to other types
	
	    toKeyedSeq: function() {
	      return new ToKeyedSequence(this, false);
	    },
	
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    filter: function(predicate, context) {
	      return reify(this, filterFactory(this, predicate, context, false));
	    },
	
	    findIndex: function(predicate, context) {
	      var entry = this.findEntry(predicate, context);
	      return entry ? entry[0] : -1;
	    },
	
	    indexOf: function(searchValue) {
	      var key = this.toKeyedSeq().keyOf(searchValue);
	      return key === undefined ? -1 : key;
	    },
	
	    lastIndexOf: function(searchValue) {
	      return this.toSeq().reverse().indexOf(searchValue);
	    },
	
	    reverse: function() {
	      return reify(this, reverseFactory(this, false));
	    },
	
	    slice: function(begin, end) {
	      return reify(this, sliceFactory(this, begin, end, false));
	    },
	
	    splice: function(index, removeNum /*, ...values*/) {
	      var numArgs = arguments.length;
	      removeNum = Math.max(removeNum | 0, 0);
	      if (numArgs === 0 || (numArgs === 2 && !removeNum)) {
	        return this;
	      }
	      // If index is negative, it should resolve relative to the size of the
	      // collection. However size may be expensive to compute if not cached, so
	      // only call count() if the number is in fact negative.
	      index = resolveBegin(index, index < 0 ? this.count() : this.size);
	      var spliced = this.slice(0, index);
	      return reify(
	        this,
	        numArgs === 1 ?
	          spliced :
	          spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum))
	      );
	    },
	
	
	    // ### More collection methods
	
	    findLastIndex: function(predicate, context) {
	      var key = this.toKeyedSeq().findLastKey(predicate, context);
	      return key === undefined ? -1 : key;
	    },
	
	    first: function() {
	      return this.get(0);
	    },
	
	    flatten: function(depth) {
	      return reify(this, flattenFactory(this, depth, false));
	    },
	
	    get: function(index, notSetValue) {
	      index = wrapIndex(this, index);
	      return (index < 0 || (this.size === Infinity ||
	          (this.size !== undefined && index > this.size))) ?
	        notSetValue :
	        this.find(function(_, key)  {return key === index}, undefined, notSetValue);
	    },
	
	    has: function(index) {
	      index = wrapIndex(this, index);
	      return index >= 0 && (this.size !== undefined ?
	        this.size === Infinity || index < this.size :
	        this.indexOf(index) !== -1
	      );
	    },
	
	    interpose: function(separator) {
	      return reify(this, interposeFactory(this, separator));
	    },
	
	    interleave: function(/*...iterables*/) {
	      var iterables = [this].concat(arrCopy(arguments));
	      var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
	      var interleaved = zipped.flatten(true);
	      if (zipped.size) {
	        interleaved.size = zipped.size * iterables.length;
	      }
	      return reify(this, interleaved);
	    },
	
	    last: function() {
	      return this.get(-1);
	    },
	
	    skipWhile: function(predicate, context) {
	      return reify(this, skipWhileFactory(this, predicate, context, false));
	    },
	
	    zip: function(/*, ...iterables */) {
	      var iterables = [this].concat(arrCopy(arguments));
	      return reify(this, zipWithFactory(this, defaultZipper, iterables));
	    },
	
	    zipWith: function(zipper/*, ...iterables */) {
	      var iterables = arrCopy(arguments);
	      iterables[0] = this;
	      return reify(this, zipWithFactory(this, zipper, iterables));
	    }
	
	  });
	
	  IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
	  IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	
	  mixin(SetIterable, {
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    get: function(value, notSetValue) {
	      return this.has(value) ? value : notSetValue;
	    },
	
	    includes: function(value) {
	      return this.has(value);
	    },
	
	
	    // ### More sequential methods
	
	    keySeq: function() {
	      return this.valueSeq();
	    }
	
	  });
	
	  SetIterable.prototype.has = IterablePrototype.includes;
	
	
	  // Mixin subclasses
	
	  mixin(KeyedSeq, KeyedIterable.prototype);
	  mixin(IndexedSeq, IndexedIterable.prototype);
	  mixin(SetSeq, SetIterable.prototype);
	
	  mixin(KeyedCollection, KeyedIterable.prototype);
	  mixin(IndexedCollection, IndexedIterable.prototype);
	  mixin(SetCollection, SetIterable.prototype);
	
	
	  // #pragma Helper functions
	
	  function keyMapper(v, k) {
	    return k;
	  }
	
	  function entryMapper(v, k) {
	    return [k, v];
	  }
	
	  function not(predicate) {
	    return function() {
	      return !predicate.apply(this, arguments);
	    }
	  }
	
	  function neg(predicate) {
	    return function() {
	      return -predicate.apply(this, arguments);
	    }
	  }
	
	  function quoteString(value) {
	    return typeof value === 'string' ? JSON.stringify(value) : value;
	  }
	
	  function defaultZipper() {
	    return arrCopy(arguments);
	  }
	
	  function defaultNegComparator(a, b) {
	    return a < b ? 1 : a > b ? -1 : 0;
	  }
	
	  function hashIterable(iterable) {
	    if (iterable.size === Infinity) {
	      return 0;
	    }
	    var ordered = isOrdered(iterable);
	    var keyed = isKeyed(iterable);
	    var h = ordered ? 1 : 0;
	    var size = iterable.__iterate(
	      keyed ?
	        ordered ?
	          function(v, k)  { h = 31 * h + hashMerge(hash(v), hash(k)) | 0; } :
	          function(v, k)  { h = h + hashMerge(hash(v), hash(k)) | 0; } :
	        ordered ?
	          function(v ) { h = 31 * h + hash(v) | 0; } :
	          function(v ) { h = h + hash(v) | 0; }
	    );
	    return murmurHashOfSize(size, h);
	  }
	
	  function murmurHashOfSize(size, h) {
	    h = src_Math__imul(h, 0xCC9E2D51);
	    h = src_Math__imul(h << 15 | h >>> -15, 0x1B873593);
	    h = src_Math__imul(h << 13 | h >>> -13, 5);
	    h = (h + 0xE6546B64 | 0) ^ size;
	    h = src_Math__imul(h ^ h >>> 16, 0x85EBCA6B);
	    h = src_Math__imul(h ^ h >>> 13, 0xC2B2AE35);
	    h = smi(h ^ h >>> 16);
	    return h;
	  }
	
	  function hashMerge(a, b) {
	    return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
	  }
	
	  var Immutable = {
	
	    Iterable: Iterable,
	
	    Seq: Seq,
	    Collection: Collection,
	    Map: src_Map__Map,
	    OrderedMap: OrderedMap,
	    List: List,
	    Stack: Stack,
	    Set: src_Set__Set,
	    OrderedSet: OrderedSet,
	
	    Record: Record,
	    Range: Range,
	    Repeat: Repeat,
	
	    is: is,
	    fromJS: fromJS
	
	  };
	
	  return Immutable;
	
	}));

/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	var Dispatcher = __webpack_require__(70),
	    Flux = __webpack_require__(151),
	    FluxMixin = __webpack_require__(160),
	    FluxChildMixin = __webpack_require__(161),
	    StoreWatchMixin = __webpack_require__(162),
	    createStore = __webpack_require__(163);
	
	var Fluxxor = {
	  Dispatcher: Dispatcher,
	  Flux: Flux,
	  FluxMixin: FluxMixin,
	  FluxChildMixin: FluxChildMixin,
	  StoreWatchMixin: StoreWatchMixin,
	  createStore: createStore,
	  version: __webpack_require__(165)
	};
	
	module.exports = Fluxxor;


/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	var _clone = __webpack_require__(71),
	    _mapValues = __webpack_require__(103),
	    _forOwn = __webpack_require__(127),
	    _intersection = __webpack_require__(129),
	    _keys = __webpack_require__(77),
	    _map = __webpack_require__(137),
	    _each = __webpack_require__(142),
	    _size = __webpack_require__(144),
	    _findKey = __webpack_require__(145),
	    _uniq = __webpack_require__(148);
	
	var defaultDispatchInterceptor = function(action, dispatch) {
	  dispatch(action);
	};
	
	var Dispatcher = function(stores) {
	  this.stores = {};
	  this.currentDispatch = null;
	  this.currentActionType = null;
	  this.waitingToDispatch = [];
	  this.dispatchInterceptor = defaultDispatchInterceptor;
	  this._boundDispatch = this._dispatch.bind(this);
	
	  for (var key in stores) {
	    if (stores.hasOwnProperty(key)) {
	      this.addStore(key, stores[key]);
	    }
	  }
	};
	
	Dispatcher.prototype.addStore = function(name, store) {
	  store.dispatcher = this;
	  this.stores[name] = store;
	};
	
	Dispatcher.prototype.dispatch = function(action) {
	  this.dispatchInterceptor(action, this._boundDispatch);
	};
	
	Dispatcher.prototype._dispatch = function(action) {
	  if (!action || !action.type) {
	    throw new Error("Can only dispatch actions with a 'type' property");
	  }
	
	  if (this.currentDispatch) {
	    var complaint = "Cannot dispatch an action ('" + action.type + "') while another action ('" +
	                    this.currentActionType + "') is being dispatched";
	    throw new Error(complaint);
	  }
	
	  this.waitingToDispatch = _clone(this.stores);
	
	  this.currentActionType = action.type;
	  this.currentDispatch = _mapValues(this.stores, function() {
	    return { resolved: false, waitingOn: [], waitCallback: null };
	  });
	
	  try {
	    this.doDispatchLoop(action);
	  } finally {
	    this.currentActionType = null;
	    this.currentDispatch = null;
	  }
	};
	
	Dispatcher.prototype.doDispatchLoop = function(action) {
	  var dispatch, canBeDispatchedTo, wasHandled = false,
	      removeFromDispatchQueue = [], dispatchedThisLoop = [];
	
	  _forOwn(this.waitingToDispatch, function(value, key) {
	    dispatch = this.currentDispatch[key];
	    canBeDispatchedTo = !dispatch.waitingOn.length ||
	      !_intersection(dispatch.waitingOn, _keys(this.waitingToDispatch)).length;
	    if (canBeDispatchedTo) {
	      if (dispatch.waitCallback) {
	        var stores = _map(dispatch.waitingOn, function(key) {
	          return this.stores[key];
	        }, this);
	        var fn = dispatch.waitCallback;
	        dispatch.waitCallback = null;
	        dispatch.waitingOn = [];
	        dispatch.resolved = true;
	        fn.apply(null, stores);
	        wasHandled = true;
	      } else {
	        dispatch.resolved = true;
	        var handled = this.stores[key].__handleAction__(action);
	        if (handled) {
	          wasHandled = true;
	        }
	      }
	
	      dispatchedThisLoop.push(key);
	
	      if (this.currentDispatch[key].resolved) {
	        removeFromDispatchQueue.push(key);
	      }
	    }
	  }, this);
	
	  if (_keys(this.waitingToDispatch).length && !dispatchedThisLoop.length) {
	    var storesWithCircularWaits = _keys(this.waitingToDispatch).join(", ");
	    throw new Error("Indirect circular wait detected among: " + storesWithCircularWaits);
	  }
	
	  _each(removeFromDispatchQueue, function(key) {
	    delete this.waitingToDispatch[key];
	  }, this);
	
	  if (_size(this.waitingToDispatch)) {
	    this.doDispatchLoop(action);
	  }
	
	  if (!wasHandled && console && console.warn) {
	    console.warn("An action of type " + action.type + " was dispatched, but no store handled it");
	  }
	
	};
	
	Dispatcher.prototype.waitForStores = function(store, stores, fn) {
	  if (!this.currentDispatch) {
	    throw new Error("Cannot wait unless an action is being dispatched");
	  }
	
	  var waitingStoreName = _findKey(this.stores, function(val) {
	    return val === store;
	  });
	
	  if (stores.indexOf(waitingStoreName) > -1) {
	    throw new Error("A store cannot wait on itself");
	  }
	
	  var dispatch = this.currentDispatch[waitingStoreName];
	
	  if (dispatch.waitingOn.length) {
	    throw new Error(waitingStoreName + " already waiting on stores");
	  }
	
	  _each(stores, function(storeName) {
	    var storeDispatch = this.currentDispatch[storeName];
	    if (!this.stores[storeName]) {
	      throw new Error("Cannot wait for non-existent store " + storeName);
	    }
	    if (storeDispatch.waitingOn.indexOf(waitingStoreName) > -1) {
	      throw new Error("Circular wait detected between " + waitingStoreName + " and " + storeName);
	    }
	  }, this);
	
	  dispatch.resolved = false;
	  dispatch.waitingOn = _uniq(dispatch.waitingOn.concat(stores));
	  dispatch.waitCallback = fn;
	};
	
	Dispatcher.prototype.setDispatchInterceptor = function(fn) {
	  if (fn) {
	    this.dispatchInterceptor = fn;
	  } else {
	    this.dispatchInterceptor = defaultDispatchInterceptor;
	  }
	};
	
	module.exports = Dispatcher;


/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	var baseClone = __webpack_require__(72),
	    bindCallback = __webpack_require__(100),
	    isIterateeCall = __webpack_require__(102);
	
	/**
	 * Creates a clone of `value`. If `isDeep` is `true` nested objects are cloned,
	 * otherwise they are assigned by reference. If `customizer` is provided it's
	 * invoked to produce the cloned values. If `customizer` returns `undefined`
	 * cloning is handled by the method instead. The `customizer` is bound to
	 * `thisArg` and invoked with up to three argument; (value [, index|key, object]).
	 *
	 * **Note:** This method is loosely based on the
	 * [structured clone algorithm](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm).
	 * The enumerable properties of `arguments` objects and objects created by
	 * constructors other than `Object` are cloned to plain `Object` objects. An
	 * empty object is returned for uncloneable values such as functions, DOM nodes,
	 * Maps, Sets, and WeakMaps.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @param {Function} [customizer] The function to customize cloning values.
	 * @param {*} [thisArg] The `this` binding of `customizer`.
	 * @returns {*} Returns the cloned value.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney' },
	 *   { 'user': 'fred' }
	 * ];
	 *
	 * var shallow = _.clone(users);
	 * shallow[0] === users[0];
	 * // => true
	 *
	 * var deep = _.clone(users, true);
	 * deep[0] === users[0];
	 * // => false
	 *
	 * // using a customizer callback
	 * var el = _.clone(document.body, function(value) {
	 *   if (_.isElement(value)) {
	 *     return value.cloneNode(false);
	 *   }
	 * });
	 *
	 * el === document.body
	 * // => false
	 * el.nodeName
	 * // => BODY
	 * el.childNodes.length;
	 * // => 0
	 */
	function clone(value, isDeep, customizer, thisArg) {
	  if (isDeep && typeof isDeep != 'boolean' && isIterateeCall(value, isDeep, customizer)) {
	    isDeep = false;
	  }
	  else if (typeof isDeep == 'function') {
	    thisArg = customizer;
	    customizer = isDeep;
	    isDeep = false;
	  }
	  return typeof customizer == 'function'
	    ? baseClone(value, isDeep, bindCallback(customizer, thisArg, 3))
	    : baseClone(value, isDeep);
	}
	
	module.exports = clone;


/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	var arrayCopy = __webpack_require__(73),
	    arrayEach = __webpack_require__(74),
	    baseAssign = __webpack_require__(75),
	    baseForOwn = __webpack_require__(92),
	    initCloneArray = __webpack_require__(96),
	    initCloneByTag = __webpack_require__(97),
	    initCloneObject = __webpack_require__(99),
	    isArray = __webpack_require__(89),
	    isObject = __webpack_require__(81);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values supported by `_.clone`. */
	var cloneableTags = {};
	cloneableTags[argsTag] = cloneableTags[arrayTag] =
	cloneableTags[arrayBufferTag] = cloneableTags[boolTag] =
	cloneableTags[dateTag] = cloneableTags[float32Tag] =
	cloneableTags[float64Tag] = cloneableTags[int8Tag] =
	cloneableTags[int16Tag] = cloneableTags[int32Tag] =
	cloneableTags[numberTag] = cloneableTags[objectTag] =
	cloneableTags[regexpTag] = cloneableTags[stringTag] =
	cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	cloneableTags[errorTag] = cloneableTags[funcTag] =
	cloneableTags[mapTag] = cloneableTags[setTag] =
	cloneableTags[weakMapTag] = false;
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * The base implementation of `_.clone` without support for argument juggling
	 * and `this` binding `customizer` functions.
	 *
	 * @private
	 * @param {*} value The value to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @param {Function} [customizer] The function to customize cloning values.
	 * @param {string} [key] The key of `value`.
	 * @param {Object} [object] The object `value` belongs to.
	 * @param {Array} [stackA=[]] Tracks traversed source objects.
	 * @param {Array} [stackB=[]] Associates clones with source counterparts.
	 * @returns {*} Returns the cloned value.
	 */
	function baseClone(value, isDeep, customizer, key, object, stackA, stackB) {
	  var result;
	  if (customizer) {
	    result = object ? customizer(value, key, object) : customizer(value);
	  }
	  if (result !== undefined) {
	    return result;
	  }
	  if (!isObject(value)) {
	    return value;
	  }
	  var isArr = isArray(value);
	  if (isArr) {
	    result = initCloneArray(value);
	    if (!isDeep) {
	      return arrayCopy(value, result);
	    }
	  } else {
	    var tag = objToString.call(value),
	        isFunc = tag == funcTag;
	
	    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	      result = initCloneObject(isFunc ? {} : value);
	      if (!isDeep) {
	        return baseAssign(result, value);
	      }
	    } else {
	      return cloneableTags[tag]
	        ? initCloneByTag(value, tag, isDeep)
	        : (object ? value : {});
	    }
	  }
	  // Check for circular references and return its corresponding clone.
	  stackA || (stackA = []);
	  stackB || (stackB = []);
	
	  var length = stackA.length;
	  while (length--) {
	    if (stackA[length] == value) {
	      return stackB[length];
	    }
	  }
	  // Add the source value to the stack of traversed objects and associate it with its clone.
	  stackA.push(value);
	  stackB.push(result);
	
	  // Recursively populate clone (susceptible to call stack limits).
	  (isArr ? arrayEach : baseForOwn)(value, function(subValue, key) {
	    result[key] = baseClone(subValue, isDeep, customizer, key, value, stackA, stackB);
	  });
	  return result;
	}
	
	module.exports = baseClone;


/***/ },
/* 73 */
/***/ function(module, exports) {

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function arrayCopy(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	module.exports = arrayCopy;


/***/ },
/* 74 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.forEach` for arrays without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	module.exports = arrayEach;


/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	var baseCopy = __webpack_require__(76),
	    keys = __webpack_require__(77);
	
	/**
	 * The base implementation of `_.assign` without support for argument juggling,
	 * multiple sources, and `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return source == null
	    ? object
	    : baseCopy(source, keys(source), object);
	}
	
	module.exports = baseAssign;


/***/ },
/* 76 */
/***/ function(module, exports) {

	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property names to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @returns {Object} Returns `object`.
	 */
	function baseCopy(source, props, object) {
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	    object[key] = source[key];
	  }
	  return object;
	}
	
	module.exports = baseCopy;


/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(78),
	    isArrayLike = __webpack_require__(83),
	    isObject = __webpack_require__(81),
	    shimKeys = __webpack_require__(87);
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeKeys = getNative(Object, 'keys');
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	var keys = !nativeKeys ? shimKeys : function(object) {
	  var Ctor = object == null ? undefined : object.constructor;
	  if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
	      (typeof object != 'function' && isArrayLike(object))) {
	    return shimKeys(object);
	  }
	  return isObject(object) ? nativeKeys(object) : [];
	};
	
	module.exports = keys;


/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	var isNative = __webpack_require__(79);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = object == null ? undefined : object[key];
	  return isNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(80),
	    isObjectLike = __webpack_require__(82);
	
	/** Used to detect host constructors (Safari > 5). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var fnToString = Function.prototype.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * Checks if `value` is a native function.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	 * @example
	 *
	 * _.isNative(Array.prototype.push);
	 * // => true
	 *
	 * _.isNative(_);
	 * // => false
	 */
	function isNative(value) {
	  if (value == null) {
	    return false;
	  }
	  if (isFunction(value)) {
	    return reIsNative.test(fnToString.call(value));
	  }
	  return isObjectLike(value) && reIsHostCtor.test(value);
	}
	
	module.exports = isNative;


/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(81);
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]';
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in older versions of Chrome and Safari which return 'function' for regexes
	  // and Safari 8 which returns 'object' for typed array constructors.
	  return isObject(value) && objToString.call(value) == funcTag;
	}
	
	module.exports = isFunction;


/***/ },
/* 81 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ },
/* 82 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	var getLength = __webpack_require__(84),
	    isLength = __webpack_require__(86);
	
	/**
	 * Checks if `value` is array-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 */
	function isArrayLike(value) {
	  return value != null && isLength(getLength(value));
	}
	
	module.exports = isArrayLike;


/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(85);
	
	/**
	 * Gets the "length" property value of `object`.
	 *
	 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
	 * that affects Safari on at least iOS 8.1-8.3 ARM64.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {*} Returns the "length" value.
	 */
	var getLength = baseProperty('length');
	
	module.exports = getLength;


/***/ },
/* 85 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ },
/* 86 */
/***/ function(module, exports) {

	/**
	 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	var isArguments = __webpack_require__(88),
	    isArray = __webpack_require__(89),
	    isIndex = __webpack_require__(90),
	    isLength = __webpack_require__(86),
	    keysIn = __webpack_require__(91);
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A fallback implementation of `Object.keys` which creates an array of the
	 * own enumerable property names of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function shimKeys(object) {
	  var props = keysIn(object),
	      propsLength = props.length,
	      length = propsLength && object.length;
	
	  var allowIndexes = !!length && isLength(length) &&
	    (isArray(object) || isArguments(object));
	
	  var index = -1,
	      result = [];
	
	  while (++index < propsLength) {
	    var key = props[index];
	    if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = shimKeys;


/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(83),
	    isObjectLike = __webpack_require__(82);
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Native method references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is classified as an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  return isObjectLike(value) && isArrayLike(value) &&
	    hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
	}
	
	module.exports = isArguments;


/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(78),
	    isLength = __webpack_require__(86),
	    isObjectLike = __webpack_require__(82);
	
	/** `Object#toString` result references. */
	var arrayTag = '[object Array]';
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeIsArray = getNative(Array, 'isArray');
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(function() { return arguments; }());
	 * // => false
	 */
	var isArray = nativeIsArray || function(value) {
	  return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
	};
	
	module.exports = isArray;


/***/ },
/* 90 */
/***/ function(module, exports) {

	/** Used to detect unsigned integer values. */
	var reIsUint = /^\d+$/;
	
	/**
	 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return value > -1 && value % 1 == 0 && value < length;
	}
	
	module.exports = isIndex;


/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	var isArguments = __webpack_require__(88),
	    isArray = __webpack_require__(89),
	    isIndex = __webpack_require__(90),
	    isLength = __webpack_require__(86),
	    isObject = __webpack_require__(81);
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  if (object == null) {
	    return [];
	  }
	  if (!isObject(object)) {
	    object = Object(object);
	  }
	  var length = object.length;
	  length = (length && isLength(length) &&
	    (isArray(object) || isArguments(object)) && length) || 0;
	
	  var Ctor = object.constructor,
	      index = -1,
	      isProto = typeof Ctor == 'function' && Ctor.prototype === object,
	      result = Array(length),
	      skipIndexes = length > 0;
	
	  while (++index < length) {
	    result[index] = (index + '');
	  }
	  for (var key in object) {
	    if (!(skipIndexes && isIndex(key, length)) &&
	        !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = keysIn;


/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(93),
	    keys = __webpack_require__(77);
	
	/**
	 * The base implementation of `_.forOwn` without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(94);
	
	/**
	 * The base implementation of `baseForIn` and `baseForOwn` which iterates
	 * over `object` properties returned by `keysFunc` invoking `iteratee` for
	 * each property. Iteratee functions may exit iteration early by explicitly
	 * returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	var toObject = __webpack_require__(95);
	
	/**
	 * Creates a base function for `_.forIn` or `_.forInRight`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var iterable = toObject(object),
	        props = keysFunc(object),
	        length = props.length,
	        index = fromRight ? length : -1;
	
	    while ((fromRight ? index-- : ++index < length)) {
	      var key = props[index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(81);
	
	/**
	 * Converts `value` to an object if it's not one.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {Object} Returns the object.
	 */
	function toObject(value) {
	  return isObject(value) ? value : Object(value);
	}
	
	module.exports = toObject;


/***/ },
/* 96 */
/***/ function(module, exports) {

	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Initializes an array clone.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the initialized clone.
	 */
	function initCloneArray(array) {
	  var length = array.length,
	      result = new array.constructor(length);
	
	  // Add array properties assigned by `RegExp#exec`.
	  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	    result.index = array.index;
	    result.input = array.input;
	  }
	  return result;
	}
	
	module.exports = initCloneArray;


/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	var bufferClone = __webpack_require__(98);
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    stringTag = '[object String]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to match `RegExp` flags from their coerced string values. */
	var reFlags = /\w*$/;
	
	/**
	 * Initializes an object clone based on its `toStringTag`.
	 *
	 * **Note:** This function only supports cloning values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @param {string} tag The `toStringTag` of the object to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneByTag(object, tag, isDeep) {
	  var Ctor = object.constructor;
	  switch (tag) {
	    case arrayBufferTag:
	      return bufferClone(object);
	
	    case boolTag:
	    case dateTag:
	      return new Ctor(+object);
	
	    case float32Tag: case float64Tag:
	    case int8Tag: case int16Tag: case int32Tag:
	    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	      var buffer = object.buffer;
	      return new Ctor(isDeep ? bufferClone(buffer) : buffer, object.byteOffset, object.length);
	
	    case numberTag:
	    case stringTag:
	      return new Ctor(object);
	
	    case regexpTag:
	      var result = new Ctor(object.source, reFlags.exec(object));
	      result.lastIndex = object.lastIndex;
	  }
	  return result;
	}
	
	module.exports = initCloneByTag;


/***/ },
/* 98 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Native method references. */
	var ArrayBuffer = global.ArrayBuffer,
	    Uint8Array = global.Uint8Array;
	
	/**
	 * Creates a clone of the given array buffer.
	 *
	 * @private
	 * @param {ArrayBuffer} buffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function bufferClone(buffer) {
	  var result = new ArrayBuffer(buffer.byteLength),
	      view = new Uint8Array(result);
	
	  view.set(new Uint8Array(buffer));
	  return result;
	}
	
	module.exports = bufferClone;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 99 */
/***/ function(module, exports) {

	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  var Ctor = object.constructor;
	  if (!(typeof Ctor == 'function' && Ctor instanceof Ctor)) {
	    Ctor = Object;
	  }
	  return new Ctor;
	}
	
	module.exports = initCloneObject;


/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(101);
	
	/**
	 * A specialized version of `baseCallback` which only supports `this` binding
	 * and specifying the number of arguments to provide to `func`.
	 *
	 * @private
	 * @param {Function} func The function to bind.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {number} [argCount] The number of arguments to provide to `func`.
	 * @returns {Function} Returns the callback.
	 */
	function bindCallback(func, thisArg, argCount) {
	  if (typeof func != 'function') {
	    return identity;
	  }
	  if (thisArg === undefined) {
	    return func;
	  }
	  switch (argCount) {
	    case 1: return function(value) {
	      return func.call(thisArg, value);
	    };
	    case 3: return function(value, index, collection) {
	      return func.call(thisArg, value, index, collection);
	    };
	    case 4: return function(accumulator, value, index, collection) {
	      return func.call(thisArg, accumulator, value, index, collection);
	    };
	    case 5: return function(value, other, key, object, source) {
	      return func.call(thisArg, value, other, key, object, source);
	    };
	  }
	  return function() {
	    return func.apply(thisArg, arguments);
	  };
	}
	
	module.exports = bindCallback;


/***/ },
/* 101 */
/***/ function(module, exports) {

	/**
	 * This method returns the first argument provided to it.
	 *
	 * @static
	 * @memberOf _
	 * @category Utility
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'user': 'fred' };
	 *
	 * _.identity(object) === object;
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(83),
	    isIndex = __webpack_require__(90),
	    isObject = __webpack_require__(81);
	
	/**
	 * Checks if the provided arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call, else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	      ? (isArrayLike(object) && isIndex(index, object.length))
	      : (type == 'string' && index in object)) {
	    var other = object[index];
	    return value === value ? (value === other) : (other !== other);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	var createObjectMapper = __webpack_require__(104);
	
	/**
	 * Creates an object with the same keys as `object` and values generated by
	 * running each own enumerable property of `object` through `iteratee`. The
	 * iteratee function is bound to `thisArg` and invoked with three arguments:
	 * (value, key, object).
	 *
	 * If a property name is provided for `iteratee` the created `_.property`
	 * style callback returns the property value of the given element.
	 *
	 * If a value is also provided for `thisArg` the created `_.matchesProperty`
	 * style callback returns `true` for elements that have a matching property
	 * value, else `false`.
	 *
	 * If an object is provided for `iteratee` the created `_.matches` style
	 * callback returns `true` for elements that have the properties of the given
	 * object, else `false`.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	 *  per iteration.
	 * @param {*} [thisArg] The `this` binding of `iteratee`.
	 * @returns {Object} Returns the new mapped object.
	 * @example
	 *
	 * _.mapValues({ 'a': 1, 'b': 2 }, function(n) {
	 *   return n * 3;
	 * });
	 * // => { 'a': 3, 'b': 6 }
	 *
	 * var users = {
	 *   'fred':    { 'user': 'fred',    'age': 40 },
	 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	 * };
	 *
	 * // using the `_.property` callback shorthand
	 * _.mapValues(users, 'age');
	 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	 */
	var mapValues = createObjectMapper();
	
	module.exports = mapValues;


/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	var baseCallback = __webpack_require__(105),
	    baseForOwn = __webpack_require__(92);
	
	/**
	 * Creates a function for `_.mapKeys` or `_.mapValues`.
	 *
	 * @private
	 * @param {boolean} [isMapKeys] Specify mapping keys instead of values.
	 * @returns {Function} Returns the new map function.
	 */
	function createObjectMapper(isMapKeys) {
	  return function(object, iteratee, thisArg) {
	    var result = {};
	    iteratee = baseCallback(iteratee, thisArg, 3);
	
	    baseForOwn(object, function(value, key, object) {
	      var mapped = iteratee(value, key, object);
	      key = isMapKeys ? mapped : key;
	      value = isMapKeys ? value : mapped;
	      result[key] = value;
	    });
	    return result;
	  };
	}
	
	module.exports = createObjectMapper;


/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(106),
	    baseMatchesProperty = __webpack_require__(118),
	    bindCallback = __webpack_require__(100),
	    identity = __webpack_require__(101),
	    property = __webpack_require__(125);
	
	/**
	 * The base implementation of `_.callback` which supports specifying the
	 * number of arguments to provide to `func`.
	 *
	 * @private
	 * @param {*} [func=_.identity] The value to convert to a callback.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {number} [argCount] The number of arguments to provide to `func`.
	 * @returns {Function} Returns the callback.
	 */
	function baseCallback(func, thisArg, argCount) {
	  var type = typeof func;
	  if (type == 'function') {
	    return thisArg === undefined
	      ? func
	      : bindCallback(func, thisArg, argCount);
	  }
	  if (func == null) {
	    return identity;
	  }
	  if (type == 'object') {
	    return baseMatches(func);
	  }
	  return thisArg === undefined
	    ? property(func)
	    : baseMatchesProperty(func, thisArg);
	}
	
	module.exports = baseCallback;


/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(107),
	    getMatchData = __webpack_require__(115),
	    toObject = __webpack_require__(95);
	
	/**
	 * The base implementation of `_.matches` which does not clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    var key = matchData[0][0],
	        value = matchData[0][1];
	
	    return function(object) {
	      if (object == null) {
	        return false;
	      }
	      return object[key] === value && (value !== undefined || (key in toObject(object)));
	    };
	  }
	  return function(object) {
	    return baseIsMatch(object, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(108),
	    toObject = __webpack_require__(95);
	
	/**
	 * The base implementation of `_.isMatch` without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Array} matchData The propery names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparing objects.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = toObject(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var result = customizer ? customizer(objValue, srcValue, key) : undefined;
	      if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, true) : result)) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(109),
	    isObject = __webpack_require__(81),
	    isObjectLike = __webpack_require__(82);
	
	/**
	 * The base implementation of `_.isEqual` without support for `this` binding
	 * `customizer` functions.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {Function} [customizer] The function to customize comparing values.
	 * @param {boolean} [isLoose] Specify performing partial comparisons.
	 * @param {Array} [stackA] Tracks traversed `value` objects.
	 * @param {Array} [stackB] Tracks traversed `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, customizer, isLoose, stackA, stackB) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, baseIsEqual, customizer, isLoose, stackA, stackB);
	}
	
	module.exports = baseIsEqual;


/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	var equalArrays = __webpack_require__(110),
	    equalByTag = __webpack_require__(112),
	    equalObjects = __webpack_require__(113),
	    isArray = __webpack_require__(89),
	    isTypedArray = __webpack_require__(114);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} [customizer] The function to customize comparing objects.
	 * @param {boolean} [isLoose] Specify performing partial comparisons.
	 * @param {Array} [stackA=[]] Tracks traversed `value` objects.
	 * @param {Array} [stackB=[]] Tracks traversed `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = arrayTag,
	      othTag = arrayTag;
	
	  if (!objIsArr) {
	    objTag = objToString.call(object);
	    if (objTag == argsTag) {
	      objTag = objectTag;
	    } else if (objTag != objectTag) {
	      objIsArr = isTypedArray(object);
	    }
	  }
	  if (!othIsArr) {
	    othTag = objToString.call(other);
	    if (othTag == argsTag) {
	      othTag = objectTag;
	    } else if (othTag != objectTag) {
	      othIsArr = isTypedArray(other);
	    }
	  }
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && !(objIsArr || objIsObj)) {
	    return equalByTag(object, other, objTag);
	  }
	  if (!isLoose) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      return equalFunc(objIsWrapped ? object.value() : object, othIsWrapped ? other.value() : other, customizer, isLoose, stackA, stackB);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  // For more information on detecting circular references see https://es5.github.io/#JO.
	  stackA || (stackA = []);
	  stackB || (stackB = []);
	
	  var length = stackA.length;
	  while (length--) {
	    if (stackA[length] == object) {
	      return stackB[length] == other;
	    }
	  }
	  // Add `object` and `other` to the stack of traversed objects.
	  stackA.push(object);
	  stackB.push(other);
	
	  var result = (objIsArr ? equalArrays : equalObjects)(object, other, equalFunc, customizer, isLoose, stackA, stackB);
	
	  stackA.pop();
	  stackB.pop();
	
	  return result;
	}
	
	module.exports = baseIsEqualDeep;


/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	var arraySome = __webpack_require__(111);
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} [customizer] The function to customize comparing arrays.
	 * @param {boolean} [isLoose] Specify performing partial comparisons.
	 * @param {Array} [stackA] Tracks traversed `value` objects.
	 * @param {Array} [stackB] Tracks traversed `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, equalFunc, customizer, isLoose, stackA, stackB) {
	  var index = -1,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isLoose && othLength > arrLength)) {
	    return false;
	  }
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index],
	        result = customizer ? customizer(isLoose ? othValue : arrValue, isLoose ? arrValue : othValue, index) : undefined;
	
	    if (result !== undefined) {
	      if (result) {
	        continue;
	      }
	      return false;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (isLoose) {
	      if (!arraySome(other, function(othValue) {
	            return arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB);
	          })) {
	        return false;
	      }
	    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB))) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = equalArrays;


/***/ },
/* 111 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ },
/* 112 */
/***/ function(module, exports) {

	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    stringTag = '[object String]';
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag) {
	  switch (tag) {
	    case boolTag:
	    case dateTag:
	      // Coerce dates and booleans to numbers, dates to milliseconds and booleans
	      // to `1` or `0` treating invalid dates coerced to `NaN` as not equal.
	      return +object == +other;
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case numberTag:
	      // Treat `NaN` vs. `NaN` as equal.
	      return (object != +object)
	        ? other != +other
	        : object == +other;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings primitives and string
	      // objects as equal. See https://es5.github.io/#x15.10.6.4 for more details.
	      return object == (other + '');
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	var keys = __webpack_require__(77);
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} [customizer] The function to customize comparing values.
	 * @param {boolean} [isLoose] Specify performing partial comparisons.
	 * @param {Array} [stackA] Tracks traversed `value` objects.
	 * @param {Array} [stackB] Tracks traversed `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
	  var objProps = keys(object),
	      objLength = objProps.length,
	      othProps = keys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isLoose) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isLoose ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  var skipCtor = isLoose;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key],
	        result = customizer ? customizer(isLoose ? othValue : objValue, isLoose? objValue : othValue, key) : undefined;
	
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(result === undefined ? equalFunc(objValue, othValue, customizer, isLoose, stackA, stackB) : result)) {
	      return false;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (!skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = equalObjects;


/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	var isLength = __webpack_require__(86),
	    isObjectLike = __webpack_require__(82);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dateTag] = typedArrayTags[errorTag] =
	typedArrayTags[funcTag] = typedArrayTags[mapTag] =
	typedArrayTags[numberTag] = typedArrayTags[objectTag] =
	typedArrayTags[regexpTag] = typedArrayTags[setTag] =
	typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	function isTypedArray(value) {
	  return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objToString.call(value)];
	}
	
	module.exports = isTypedArray;


/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(116),
	    pairs = __webpack_require__(117);
	
	/**
	 * Gets the propery names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = pairs(object),
	      length = result.length;
	
	  while (length--) {
	    result[length][2] = isStrictComparable(result[length][1]);
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(81);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	var keys = __webpack_require__(77),
	    toObject = __webpack_require__(95);
	
	/**
	 * Creates a two dimensional array of the key-value pairs for `object`,
	 * e.g. `[[key1, value1], [key2, value2]]`.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the new array of key-value pairs.
	 * @example
	 *
	 * _.pairs({ 'barney': 36, 'fred': 40 });
	 * // => [['barney', 36], ['fred', 40]] (iteration order is not guaranteed)
	 */
	function pairs(object) {
	  object = toObject(object);
	
	  var index = -1,
	      props = keys(object),
	      length = props.length,
	      result = Array(length);
	
	  while (++index < length) {
	    var key = props[index];
	    result[index] = [key, object[key]];
	  }
	  return result;
	}
	
	module.exports = pairs;


/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(119),
	    baseIsEqual = __webpack_require__(108),
	    baseSlice = __webpack_require__(120),
	    isArray = __webpack_require__(89),
	    isKey = __webpack_require__(121),
	    isStrictComparable = __webpack_require__(116),
	    last = __webpack_require__(122),
	    toObject = __webpack_require__(95),
	    toPath = __webpack_require__(123);
	
	/**
	 * The base implementation of `_.matchesProperty` which does not clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to compare.
	 * @returns {Function} Returns the new function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  var isArr = isArray(path),
	      isCommon = isKey(path) && isStrictComparable(srcValue),
	      pathKey = (path + '');
	
	  path = toPath(path);
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    var key = pathKey;
	    object = toObject(object);
	    if ((isArr || !isCommon) && !(key in object)) {
	      object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	      if (object == null) {
	        return false;
	      }
	      key = last(path);
	      object = toObject(object);
	    }
	    return object[key] === srcValue
	      ? (srcValue !== undefined || (key in object))
	      : baseIsEqual(srcValue, object[key], undefined, true);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	var toObject = __webpack_require__(95);
	
	/**
	 * The base implementation of `get` without support for string paths
	 * and default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} path The path of the property to get.
	 * @param {string} [pathKey] The key representation of path.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path, pathKey) {
	  if (object == null) {
	    return;
	  }
	  if (pathKey !== undefined && pathKey in toObject(object)) {
	    path = [pathKey];
	  }
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[path[index++]];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ },
/* 120 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.slice` without an iteratee call guard.
	 *
	 * @private
	 * @param {Array} array The array to slice.
	 * @param {number} [start=0] The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the slice of `array`.
	 */
	function baseSlice(array, start, end) {
	  var index = -1,
	      length = array.length;
	
	  start = start == null ? 0 : (+start || 0);
	  if (start < 0) {
	    start = -start > length ? 0 : (length + start);
	  }
	  end = (end === undefined || end > length) ? length : (+end || 0);
	  if (end < 0) {
	    end += length;
	  }
	  length = start > end ? 0 : ((end - start) >>> 0);
	  start >>>= 0;
	
	  var result = Array(length);
	  while (++index < length) {
	    result[index] = array[index + start];
	  }
	  return result;
	}
	
	module.exports = baseSlice;


/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(89),
	    toObject = __webpack_require__(95);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\n\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  var type = typeof value;
	  if ((type == 'string' && reIsPlainProp.test(value)) || type == 'number') {
	    return true;
	  }
	  if (isArray(value)) {
	    return false;
	  }
	  var result = !reIsDeepProp.test(value);
	  return result || (object != null && value in toObject(object));
	}
	
	module.exports = isKey;


/***/ },
/* 122 */
/***/ function(module, exports) {

	/**
	 * Gets the last element of `array`.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {Array} array The array to query.
	 * @returns {*} Returns the last element of `array`.
	 * @example
	 *
	 * _.last([1, 2, 3]);
	 * // => 3
	 */
	function last(array) {
	  var length = array ? array.length : 0;
	  return length ? array[length - 1] : undefined;
	}
	
	module.exports = last;


/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(124),
	    isArray = __webpack_require__(89);
	
	/** Used to match property names within property paths. */
	var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\n\\]|\\.)*?)\2)\]/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `value` to property path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {Array} Returns the property path array.
	 */
	function toPath(value) {
	  if (isArray(value)) {
	    return value;
	  }
	  var result = [];
	  baseToString(value).replace(rePropName, function(match, number, quote, string) {
	    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	}
	
	module.exports = toPath;


/***/ },
/* 124 */
/***/ function(module, exports) {

	/**
	 * Converts `value` to a string if it's not one. An empty string is returned
	 * for `null` or `undefined` values.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  return value == null ? '' : (value + '');
	}
	
	module.exports = baseToString;


/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(85),
	    basePropertyDeep = __webpack_require__(126),
	    isKey = __webpack_require__(121);
	
	/**
	 * Creates a function that returns the property value at `path` on a
	 * given object.
	 *
	 * @static
	 * @memberOf _
	 * @category Utility
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': { 'c': 2 } } },
	 *   { 'a': { 'b': { 'c': 1 } } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b.c'));
	 * // => [2, 1]
	 *
	 * _.pluck(_.sortBy(objects, _.property(['a', 'b', 'c'])), 'a.b.c');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(path) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(119),
	    toPath = __webpack_require__(123);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new function.
	 */
	function basePropertyDeep(path) {
	  var pathKey = (path + '');
	  path = toPath(path);
	  return function(object) {
	    return baseGet(object, path, pathKey);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(92),
	    createForOwn = __webpack_require__(128);
	
	/**
	 * Iterates over own enumerable properties of an object invoking `iteratee`
	 * for each property. The `iteratee` is bound to `thisArg` and invoked with
	 * three arguments: (value, key, object). Iteratee functions may exit iteration
	 * early by explicitly returning `false`.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @param {*} [thisArg] The `this` binding of `iteratee`.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.forOwn(new Foo, function(value, key) {
	 *   console.log(key);
	 * });
	 * // => logs 'a' and 'b' (iteration order is not guaranteed)
	 */
	var forOwn = createForOwn(baseForOwn);
	
	module.exports = forOwn;


/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	var bindCallback = __webpack_require__(100);
	
	/**
	 * Creates a function for `_.forOwn` or `_.forOwnRight`.
	 *
	 * @private
	 * @param {Function} objectFunc The function to iterate over an object.
	 * @returns {Function} Returns the new each function.
	 */
	function createForOwn(objectFunc) {
	  return function(object, iteratee, thisArg) {
	    if (typeof iteratee != 'function' || thisArg !== undefined) {
	      iteratee = bindCallback(iteratee, thisArg, 3);
	    }
	    return objectFunc(object, iteratee);
	  };
	}
	
	module.exports = createForOwn;


/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(130),
	    cacheIndexOf = __webpack_require__(132),
	    createCache = __webpack_require__(133),
	    isArrayLike = __webpack_require__(83),
	    restParam = __webpack_require__(136);
	
	/**
	 * Creates an array of unique values that are included in all of the provided
	 * arrays using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {...Array} [arrays] The arrays to inspect.
	 * @returns {Array} Returns the new array of shared values.
	 * @example
	 * _.intersection([1, 2], [4, 2], [2, 1]);
	 * // => [2]
	 */
	var intersection = restParam(function(arrays) {
	  var othLength = arrays.length,
	      othIndex = othLength,
	      caches = Array(length),
	      indexOf = baseIndexOf,
	      isCommon = true,
	      result = [];
	
	  while (othIndex--) {
	    var value = arrays[othIndex] = isArrayLike(value = arrays[othIndex]) ? value : [];
	    caches[othIndex] = (isCommon && value.length >= 120) ? createCache(othIndex && value) : null;
	  }
	  var array = arrays[0],
	      index = -1,
	      length = array ? array.length : 0,
	      seen = caches[0];
	
	  outer:
	  while (++index < length) {
	    value = array[index];
	    if ((seen ? cacheIndexOf(seen, value) : indexOf(result, value, 0)) < 0) {
	      var othIndex = othLength;
	      while (--othIndex) {
	        var cache = caches[othIndex];
	        if ((cache ? cacheIndexOf(cache, value) : indexOf(arrays[othIndex], value, 0)) < 0) {
	          continue outer;
	        }
	      }
	      if (seen) {
	        seen.push(value);
	      }
	      result.push(value);
	    }
	  }
	  return result;
	});
	
	module.exports = intersection;


/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	var indexOfNaN = __webpack_require__(131);
	
	/**
	 * The base implementation of `_.indexOf` without support for binary searches.
	 *
	 * @private
	 * @param {Array} array The array to search.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  if (value !== value) {
	    return indexOfNaN(array, fromIndex);
	  }
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseIndexOf;


/***/ },
/* 131 */
/***/ function(module, exports) {

	/**
	 * Gets the index at which the first occurrence of `NaN` is found in `array`.
	 *
	 * @private
	 * @param {Array} array The array to search.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched `NaN`, else `-1`.
	 */
	function indexOfNaN(array, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 0 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    var other = array[index];
	    if (other !== other) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = indexOfNaN;


/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(81);
	
	/**
	 * Checks if `value` is in `cache` mimicking the return signature of
	 * `_.indexOf` by returning `0` if the value is found, else `-1`.
	 *
	 * @private
	 * @param {Object} cache The cache to search.
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `0` if `value` is found, else `-1`.
	 */
	function cacheIndexOf(cache, value) {
	  var data = cache.data,
	      result = (typeof value == 'string' || isObject(value)) ? data.set.has(value) : data.hash[value];
	
	  return result ? 0 : -1;
	}
	
	module.exports = cacheIndexOf;


/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var SetCache = __webpack_require__(134),
	    getNative = __webpack_require__(78);
	
	/** Native method references. */
	var Set = getNative(global, 'Set');
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeCreate = getNative(Object, 'create');
	
	/**
	 * Creates a `Set` cache object to optimize linear searches of large arrays.
	 *
	 * @private
	 * @param {Array} [values] The values to cache.
	 * @returns {null|Object} Returns the new cache object if `Set` is supported, else `null`.
	 */
	function createCache(values) {
	  return (nativeCreate && Set) ? new SetCache(values) : null;
	}
	
	module.exports = createCache;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var cachePush = __webpack_require__(135),
	    getNative = __webpack_require__(78);
	
	/** Native method references. */
	var Set = getNative(global, 'Set');
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeCreate = getNative(Object, 'create');
	
	/**
	 *
	 * Creates a cache object to store unique values.
	 *
	 * @private
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var length = values ? values.length : 0;
	
	  this.data = { 'hash': nativeCreate(null), 'set': new Set };
	  while (length--) {
	    this.push(values[length]);
	  }
	}
	
	// Add functions to the `Set` cache.
	SetCache.prototype.push = cachePush;
	
	module.exports = SetCache;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(81);
	
	/**
	 * Adds `value` to the cache.
	 *
	 * @private
	 * @name push
	 * @memberOf SetCache
	 * @param {*} value The value to cache.
	 */
	function cachePush(value) {
	  var data = this.data;
	  if (typeof value == 'string' || isObject(value)) {
	    data.set.add(value);
	  } else {
	    data.hash[value] = true;
	  }
	}
	
	module.exports = cachePush;


/***/ },
/* 136 */
/***/ function(module, exports) {

	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates a function that invokes `func` with the `this` binding of the
	 * created function and arguments from `start` and beyond provided as an array.
	 *
	 * **Note:** This method is based on the [rest parameter](https://developer.mozilla.org/Web/JavaScript/Reference/Functions/rest_parameters).
	 *
	 * @static
	 * @memberOf _
	 * @category Function
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var say = _.restParam(function(what, names) {
	 *   return what + ' ' + _.initial(names).join(', ') +
	 *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	 * });
	 *
	 * say('hello', 'fred', 'barney', 'pebbles');
	 * // => 'hello fred, barney, & pebbles'
	 */
	function restParam(func, start) {
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  start = nativeMax(start === undefined ? (func.length - 1) : (+start || 0), 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        rest = Array(length);
	
	    while (++index < length) {
	      rest[index] = args[start + index];
	    }
	    switch (start) {
	      case 0: return func.call(this, rest);
	      case 1: return func.call(this, args[0], rest);
	      case 2: return func.call(this, args[0], args[1], rest);
	    }
	    var otherArgs = Array(start + 1);
	    index = -1;
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = rest;
	    return func.apply(this, otherArgs);
	  };
	}
	
	module.exports = restParam;


/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(138),
	    baseCallback = __webpack_require__(105),
	    baseMap = __webpack_require__(139),
	    isArray = __webpack_require__(89);
	
	/**
	 * Creates an array of values by running each element in `collection` through
	 * `iteratee`. The `iteratee` is bound to `thisArg` and invoked with three
	 * arguments: (value, index|key, collection).
	 *
	 * If a property name is provided for `iteratee` the created `_.property`
	 * style callback returns the property value of the given element.
	 *
	 * If a value is also provided for `thisArg` the created `_.matchesProperty`
	 * style callback returns `true` for elements that have a matching property
	 * value, else `false`.
	 *
	 * If an object is provided for `iteratee` the created `_.matches` style
	 * callback returns `true` for elements that have the properties of the given
	 * object, else `false`.
	 *
	 * Many lodash methods are guarded to work as iteratees for methods like
	 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	 *
	 * The guarded methods are:
	 * `ary`, `callback`, `chunk`, `clone`, `create`, `curry`, `curryRight`,
	 * `drop`, `dropRight`, `every`, `fill`, `flatten`, `invert`, `max`, `min`,
	 * `parseInt`, `slice`, `sortBy`, `take`, `takeRight`, `template`, `trim`,
	 * `trimLeft`, `trimRight`, `trunc`, `random`, `range`, `sample`, `some`,
	 * `sum`, `uniq`, and `words`
	 *
	 * @static
	 * @memberOf _
	 * @alias collect
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to iterate over.
	 * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	 *  per iteration.
	 * @param {*} [thisArg] The `this` binding of `iteratee`.
	 * @returns {Array} Returns the new mapped array.
	 * @example
	 *
	 * function timesThree(n) {
	 *   return n * 3;
	 * }
	 *
	 * _.map([1, 2], timesThree);
	 * // => [3, 6]
	 *
	 * _.map({ 'a': 1, 'b': 2 }, timesThree);
	 * // => [3, 6] (iteration order is not guaranteed)
	 *
	 * var users = [
	 *   { 'user': 'barney' },
	 *   { 'user': 'fred' }
	 * ];
	 *
	 * // using the `_.property` callback shorthand
	 * _.map(users, 'user');
	 * // => ['barney', 'fred']
	 */
	function map(collection, iteratee, thisArg) {
	  var func = isArray(collection) ? arrayMap : baseMap;
	  iteratee = baseCallback(iteratee, thisArg, 3);
	  return func(collection, iteratee);
	}
	
	module.exports = map;


/***/ },
/* 138 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(140),
	    isArrayLike = __webpack_require__(83);
	
	/**
	 * The base implementation of `_.map` without support for callback shorthands
	 * and `this` binding.
	 *
	 * @private
	 * @param {Array|Object|string} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function baseMap(collection, iteratee) {
	  var index = -1,
	      result = isArrayLike(collection) ? Array(collection.length) : [];
	
	  baseEach(collection, function(value, key, collection) {
	    result[++index] = iteratee(value, key, collection);
	  });
	  return result;
	}
	
	module.exports = baseMap;


/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(92),
	    createBaseEach = __webpack_require__(141);
	
	/**
	 * The base implementation of `_.forEach` without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Array|Object|string} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object|string} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	module.exports = baseEach;


/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	var getLength = __webpack_require__(84),
	    isLength = __webpack_require__(86),
	    toObject = __webpack_require__(95);
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    var length = collection ? getLength(collection) : 0;
	    if (!isLength(length)) {
	      return eachFunc(collection, iteratee);
	    }
	    var index = fromRight ? length : -1,
	        iterable = toObject(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	module.exports = createBaseEach;


/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	var arrayEach = __webpack_require__(74),
	    baseEach = __webpack_require__(140),
	    createForEach = __webpack_require__(143);
	
	/**
	 * Iterates over elements of `collection` invoking `iteratee` for each element.
	 * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	 * (value, index|key, collection). Iteratee functions may exit iteration early
	 * by explicitly returning `false`.
	 *
	 * **Note:** As with other "Collections" methods, objects with a "length" property
	 * are iterated like arrays. To avoid this behavior `_.forIn` or `_.forOwn`
	 * may be used for object iteration.
	 *
	 * @static
	 * @memberOf _
	 * @alias each
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @param {*} [thisArg] The `this` binding of `iteratee`.
	 * @returns {Array|Object|string} Returns `collection`.
	 * @example
	 *
	 * _([1, 2]).forEach(function(n) {
	 *   console.log(n);
	 * }).value();
	 * // => logs each value from left to right and returns the array
	 *
	 * _.forEach({ 'a': 1, 'b': 2 }, function(n, key) {
	 *   console.log(n, key);
	 * });
	 * // => logs each value-key pair and returns the object (iteration order is not guaranteed)
	 */
	var forEach = createForEach(arrayEach, baseEach);
	
	module.exports = forEach;


/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	var bindCallback = __webpack_require__(100),
	    isArray = __webpack_require__(89);
	
	/**
	 * Creates a function for `_.forEach` or `_.forEachRight`.
	 *
	 * @private
	 * @param {Function} arrayFunc The function to iterate over an array.
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @returns {Function} Returns the new each function.
	 */
	function createForEach(arrayFunc, eachFunc) {
	  return function(collection, iteratee, thisArg) {
	    return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
	      ? arrayFunc(collection, iteratee)
	      : eachFunc(collection, bindCallback(iteratee, thisArg, 3));
	  };
	}
	
	module.exports = createForEach;


/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	var getLength = __webpack_require__(84),
	    isLength = __webpack_require__(86),
	    keys = __webpack_require__(77);
	
	/**
	 * Gets the size of `collection` by returning its length for array-like
	 * values or the number of own enumerable properties for objects.
	 *
	 * @static
	 * @memberOf _
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to inspect.
	 * @returns {number} Returns the size of `collection`.
	 * @example
	 *
	 * _.size([1, 2, 3]);
	 * // => 3
	 *
	 * _.size({ 'a': 1, 'b': 2 });
	 * // => 2
	 *
	 * _.size('pebbles');
	 * // => 7
	 */
	function size(collection) {
	  var length = collection ? getLength(collection) : 0;
	  return isLength(length) ? length : keys(collection).length;
	}
	
	module.exports = size;


/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(92),
	    createFindKey = __webpack_require__(146);
	
	/**
	 * This method is like `_.find` except that it returns the key of the first
	 * element `predicate` returns truthy for instead of the element itself.
	 *
	 * If a property name is provided for `predicate` the created `_.property`
	 * style callback returns the property value of the given element.
	 *
	 * If a value is also provided for `thisArg` the created `_.matchesProperty`
	 * style callback returns `true` for elements that have a matching property
	 * value, else `false`.
	 *
	 * If an object is provided for `predicate` the created `_.matches` style
	 * callback returns `true` for elements that have the properties of the given
	 * object, else `false`.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to search.
	 * @param {Function|Object|string} [predicate=_.identity] The function invoked
	 *  per iteration.
	 * @param {*} [thisArg] The `this` binding of `predicate`.
	 * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
	 * @example
	 *
	 * var users = {
	 *   'barney':  { 'age': 36, 'active': true },
	 *   'fred':    { 'age': 40, 'active': false },
	 *   'pebbles': { 'age': 1,  'active': true }
	 * };
	 *
	 * _.findKey(users, function(chr) {
	 *   return chr.age < 40;
	 * });
	 * // => 'barney' (iteration order is not guaranteed)
	 *
	 * // using the `_.matches` callback shorthand
	 * _.findKey(users, { 'age': 1, 'active': true });
	 * // => 'pebbles'
	 *
	 * // using the `_.matchesProperty` callback shorthand
	 * _.findKey(users, 'active', false);
	 * // => 'fred'
	 *
	 * // using the `_.property` callback shorthand
	 * _.findKey(users, 'active');
	 * // => 'barney'
	 */
	var findKey = createFindKey(baseForOwn);
	
	module.exports = findKey;


/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	var baseCallback = __webpack_require__(105),
	    baseFind = __webpack_require__(147);
	
	/**
	 * Creates a `_.findKey` or `_.findLastKey` function.
	 *
	 * @private
	 * @param {Function} objectFunc The function to iterate over an object.
	 * @returns {Function} Returns the new find function.
	 */
	function createFindKey(objectFunc) {
	  return function(object, predicate, thisArg) {
	    predicate = baseCallback(predicate, thisArg, 3);
	    return baseFind(object, predicate, objectFunc, true);
	  };
	}
	
	module.exports = createFindKey;


/***/ },
/* 147 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.find`, `_.findLast`, `_.findKey`, and `_.findLastKey`,
	 * without support for callback shorthands and `this` binding, which iterates
	 * over `collection` using the provided `eachFunc`.
	 *
	 * @private
	 * @param {Array|Object|string} collection The collection to search.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {Function} eachFunc The function to iterate over `collection`.
	 * @param {boolean} [retKey] Specify returning the key of the found element
	 *  instead of the element itself.
	 * @returns {*} Returns the found element or its key, else `undefined`.
	 */
	function baseFind(collection, predicate, eachFunc, retKey) {
	  var result;
	  eachFunc(collection, function(value, key, collection) {
	    if (predicate(value, key, collection)) {
	      result = retKey ? key : value;
	      return false;
	    }
	  });
	  return result;
	}
	
	module.exports = baseFind;


/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	var baseCallback = __webpack_require__(105),
	    baseUniq = __webpack_require__(149),
	    isIterateeCall = __webpack_require__(102),
	    sortedUniq = __webpack_require__(150);
	
	/**
	 * Creates a duplicate-free version of an array, using
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	 * for equality comparisons, in which only the first occurence of each element
	 * is kept. Providing `true` for `isSorted` performs a faster search algorithm
	 * for sorted arrays. If an iteratee function is provided it's invoked for
	 * each element in the array to generate the criterion by which uniqueness
	 * is computed. The `iteratee` is bound to `thisArg` and invoked with three
	 * arguments: (value, index, array).
	 *
	 * If a property name is provided for `iteratee` the created `_.property`
	 * style callback returns the property value of the given element.
	 *
	 * If a value is also provided for `thisArg` the created `_.matchesProperty`
	 * style callback returns `true` for elements that have a matching property
	 * value, else `false`.
	 *
	 * If an object is provided for `iteratee` the created `_.matches` style
	 * callback returns `true` for elements that have the properties of the given
	 * object, else `false`.
	 *
	 * @static
	 * @memberOf _
	 * @alias unique
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {boolean} [isSorted] Specify the array is sorted.
	 * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	 * @param {*} [thisArg] The `this` binding of `iteratee`.
	 * @returns {Array} Returns the new duplicate-value-free array.
	 * @example
	 *
	 * _.uniq([2, 1, 2]);
	 * // => [2, 1]
	 *
	 * // using `isSorted`
	 * _.uniq([1, 1, 2], true);
	 * // => [1, 2]
	 *
	 * // using an iteratee function
	 * _.uniq([1, 2.5, 1.5, 2], function(n) {
	 *   return this.floor(n);
	 * }, Math);
	 * // => [1, 2.5]
	 *
	 * // using the `_.property` callback shorthand
	 * _.uniq([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	 * // => [{ 'x': 1 }, { 'x': 2 }]
	 */
	function uniq(array, isSorted, iteratee, thisArg) {
	  var length = array ? array.length : 0;
	  if (!length) {
	    return [];
	  }
	  if (isSorted != null && typeof isSorted != 'boolean') {
	    thisArg = iteratee;
	    iteratee = isIterateeCall(array, isSorted, thisArg) ? undefined : isSorted;
	    isSorted = false;
	  }
	  iteratee = iteratee == null ? iteratee : baseCallback(iteratee, thisArg, 3);
	  return (isSorted)
	    ? sortedUniq(array, iteratee)
	    : baseUniq(array, iteratee);
	}
	
	module.exports = uniq;


/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(130),
	    cacheIndexOf = __webpack_require__(132),
	    createCache = __webpack_require__(133);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * The base implementation of `_.uniq` without support for callback shorthands
	 * and `this` binding.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} [iteratee] The function invoked per iteration.
	 * @returns {Array} Returns the new duplicate free array.
	 */
	function baseUniq(array, iteratee) {
	  var index = -1,
	      indexOf = baseIndexOf,
	      length = array.length,
	      isCommon = true,
	      isLarge = isCommon && length >= LARGE_ARRAY_SIZE,
	      seen = isLarge ? createCache() : null,
	      result = [];
	
	  if (seen) {
	    indexOf = cacheIndexOf;
	    isCommon = false;
	  } else {
	    isLarge = false;
	    seen = iteratee ? [] : result;
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value, index, array) : value;
	
	    if (isCommon && value === value) {
	      var seenIndex = seen.length;
	      while (seenIndex--) {
	        if (seen[seenIndex] === computed) {
	          continue outer;
	        }
	      }
	      if (iteratee) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	    else if (indexOf(seen, computed, 0) < 0) {
	      if (iteratee || isLarge) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseUniq;


/***/ },
/* 150 */
/***/ function(module, exports) {

	/**
	 * An implementation of `_.uniq` optimized for sorted arrays without support
	 * for callback shorthands and `this` binding.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} [iteratee] The function invoked per iteration.
	 * @returns {Array} Returns the new duplicate free array.
	 */
	function sortedUniq(array, iteratee) {
	  var seen,
	      index = -1,
	      length = array.length,
	      resIndex = -1,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value, index, array) : value;
	
	    if (!index || seen !== computed) {
	      seen = computed;
	      result[++resIndex] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = sortedUniq;


/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	var EventEmitter = __webpack_require__(152),
	    inherits = __webpack_require__(153),
	    objectPath = __webpack_require__(154),
	    _each = __webpack_require__(142),
	    _reduce = __webpack_require__(155),
	    _isFunction = __webpack_require__(80),
	    _isString = __webpack_require__(159);
	
	var Dispatcher = __webpack_require__(70);
	
	var findLeaves = function(obj, path, callback) {
	  path = path || [];
	
	  for (var key in obj) {
	    if (obj.hasOwnProperty(key)) {
	      if (_isFunction(obj[key])) {
	        callback(path.concat(key), obj[key]);
	      } else {
	        findLeaves(obj[key], path.concat(key), callback);
	      }
	    }
	  }
	};
	
	var Flux = function(stores, actions) {
	  EventEmitter.call(this);
	  this.dispatcher = new Dispatcher(stores);
	  this.actions = {};
	  this.stores = {};
	
	  var dispatcher = this.dispatcher;
	  var flux = this;
	  this.dispatchBinder = {
	    flux: flux,
	    dispatch: function(type, payload) {
	      try {
	        flux.emit("dispatch", type, payload);
	      } finally {
	        dispatcher.dispatch({type: type, payload: payload});
	      }
	    }
	  };
	
	  this.addActions(actions);
	  this.addStores(stores);
	};
	
	inherits(Flux, EventEmitter);
	
	Flux.prototype.addActions = function(actions) {
	  findLeaves(actions, [], this.addAction.bind(this));
	};
	
	// addAction has two signatures:
	// 1: string[, string, string, string...], actionFunction
	// 2: arrayOfStrings, actionFunction
	Flux.prototype.addAction = function() {
	  if (arguments.length < 2) {
	    throw new Error("addAction requires at least two arguments, a string (or array of strings) and a function");
	  }
	
	  var args = Array.prototype.slice.call(arguments);
	
	  if (!_isFunction(args[args.length - 1])) {
	    throw new Error("The last argument to addAction must be a function");
	  }
	
	  var func = args.pop().bind(this.dispatchBinder);
	
	  if (!_isString(args[0])) {
	    args = args[0];
	  }
	
	  var leadingPaths = _reduce(args, function(acc, next) {
	    if (acc) {
	      var nextPath = acc[acc.length - 1].concat([next]);
	      return acc.concat([nextPath]);
	    } else {
	      return [[next]];
	    }
	  }, null);
	
	  // Detect trying to replace a function at any point in the path
	  _each(leadingPaths, function(path) {
	    if (_isFunction(objectPath.get(this.actions, path))) {
	      throw new Error("An action named " + args.join(".") + " already exists");
	    }
	  }, this);
	
	  // Detect trying to replace a namespace at the final point in the path
	  if (objectPath.get(this.actions, args)) {
	    throw new Error("A namespace named " + args.join(".") + " already exists");
	  }
	
	  objectPath.set(this.actions, args, func, true);
	};
	
	Flux.prototype.store = function(name) {
	  return this.stores[name];
	};
	
	Flux.prototype.getAllStores = function() {
	  return this.stores;
	};
	
	Flux.prototype.addStore = function(name, store) {
	  if (name in this.stores) {
	    throw new Error("A store named '" + name + "' already exists");
	  }
	  store.flux = this;
	  this.stores[name] = store;
	  this.dispatcher.addStore(name, store);
	};
	
	Flux.prototype.addStores = function(stores) {
	  for (var key in stores) {
	    if (stores.hasOwnProperty(key)) {
	      this.addStore(key, stores[key]);
	    }
	  }
	};
	
	Flux.prototype.setDispatchInterceptor = function(fn) {
	  this.dispatcher.setDispatchInterceptor(fn);
	};
	
	module.exports = Flux;


/***/ },
/* 152 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Representation of a single EventEmitter function.
	 *
	 * @param {Function} fn Event handler to be called.
	 * @param {Mixed} context Context for function execution.
	 * @param {Boolean} once Only emit once
	 * @api private
	 */
	function EE(fn, context, once) {
	  this.fn = fn;
	  this.context = context;
	  this.once = once || false;
	}
	
	/**
	 * Minimal EventEmitter interface that is molded against the Node.js
	 * EventEmitter interface.
	 *
	 * @constructor
	 * @api public
	 */
	function EventEmitter() { /* Nothing to set */ }
	
	/**
	 * Holds the assigned EventEmitters by name.
	 *
	 * @type {Object}
	 * @private
	 */
	EventEmitter.prototype._events = undefined;
	
	/**
	 * Return a list of assigned event listeners.
	 *
	 * @param {String} event The events that should be listed.
	 * @returns {Array}
	 * @api public
	 */
	EventEmitter.prototype.listeners = function listeners(event) {
	  if (!this._events || !this._events[event]) return [];
	  if (this._events[event].fn) return [this._events[event].fn];
	
	  for (var i = 0, l = this._events[event].length, ee = new Array(l); i < l; i++) {
	    ee[i] = this._events[event][i].fn;
	  }
	
	  return ee;
	};
	
	/**
	 * Emit an event to all registered event listeners.
	 *
	 * @param {String} event The name of the event.
	 * @returns {Boolean} Indication if we've emitted an event.
	 * @api public
	 */
	EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
	  if (!this._events || !this._events[event]) return false;
	
	  var listeners = this._events[event]
	    , len = arguments.length
	    , args
	    , i;
	
	  if ('function' === typeof listeners.fn) {
	    if (listeners.once) this.removeListener(event, listeners.fn, true);
	
	    switch (len) {
	      case 1: return listeners.fn.call(listeners.context), true;
	      case 2: return listeners.fn.call(listeners.context, a1), true;
	      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
	      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
	      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
	      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
	    }
	
	    for (i = 1, args = new Array(len -1); i < len; i++) {
	      args[i - 1] = arguments[i];
	    }
	
	    listeners.fn.apply(listeners.context, args);
	  } else {
	    var length = listeners.length
	      , j;
	
	    for (i = 0; i < length; i++) {
	      if (listeners[i].once) this.removeListener(event, listeners[i].fn, true);
	
	      switch (len) {
	        case 1: listeners[i].fn.call(listeners[i].context); break;
	        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
	        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
	        default:
	          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
	            args[j - 1] = arguments[j];
	          }
	
	          listeners[i].fn.apply(listeners[i].context, args);
	      }
	    }
	  }
	
	  return true;
	};
	
	/**
	 * Register a new EventListener for the given event.
	 *
	 * @param {String} event Name of the event.
	 * @param {Functon} fn Callback function.
	 * @param {Mixed} context The context of the function.
	 * @api public
	 */
	EventEmitter.prototype.on = function on(event, fn, context) {
	  var listener = new EE(fn, context || this);
	
	  if (!this._events) this._events = {};
	  if (!this._events[event]) this._events[event] = listener;
	  else {
	    if (!this._events[event].fn) this._events[event].push(listener);
	    else this._events[event] = [
	      this._events[event], listener
	    ];
	  }
	
	  return this;
	};
	
	/**
	 * Add an EventListener that's only called once.
	 *
	 * @param {String} event Name of the event.
	 * @param {Function} fn Callback function.
	 * @param {Mixed} context The context of the function.
	 * @api public
	 */
	EventEmitter.prototype.once = function once(event, fn, context) {
	  var listener = new EE(fn, context || this, true);
	
	  if (!this._events) this._events = {};
	  if (!this._events[event]) this._events[event] = listener;
	  else {
	    if (!this._events[event].fn) this._events[event].push(listener);
	    else this._events[event] = [
	      this._events[event], listener
	    ];
	  }
	
	  return this;
	};
	
	/**
	 * Remove event listeners.
	 *
	 * @param {String} event The event we want to remove.
	 * @param {Function} fn The listener that we need to find.
	 * @param {Boolean} once Only remove once listeners.
	 * @api public
	 */
	EventEmitter.prototype.removeListener = function removeListener(event, fn, once) {
	  if (!this._events || !this._events[event]) return this;
	
	  var listeners = this._events[event]
	    , events = [];
	
	  if (fn) {
	    if (listeners.fn && (listeners.fn !== fn || (once && !listeners.once))) {
	      events.push(listeners);
	    }
	    if (!listeners.fn) for (var i = 0, length = listeners.length; i < length; i++) {
	      if (listeners[i].fn !== fn || (once && !listeners[i].once)) {
	        events.push(listeners[i]);
	      }
	    }
	  }
	
	  //
	  // Reset the array, or remove it completely if we have no more listeners.
	  //
	  if (events.length) {
	    this._events[event] = events.length === 1 ? events[0] : events;
	  } else {
	    delete this._events[event];
	  }
	
	  return this;
	};
	
	/**
	 * Remove all listeners or only the listeners for the specified event.
	 *
	 * @param {String} event The event want to remove all listeners for.
	 * @api public
	 */
	EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
	  if (!this._events) return this;
	
	  if (event) delete this._events[event];
	  else this._events = {};
	
	  return this;
	};
	
	//
	// Alias methods names because people roll like that.
	//
	EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
	EventEmitter.prototype.addListener = EventEmitter.prototype.on;
	
	//
	// This function doesn't apply anymore.
	//
	EventEmitter.prototype.setMaxListeners = function setMaxListeners() {
	  return this;
	};
	
	//
	// Expose the module.
	//
	EventEmitter.EventEmitter = EventEmitter;
	EventEmitter.EventEmitter2 = EventEmitter;
	EventEmitter.EventEmitter3 = EventEmitter;
	
	//
	// Expose the module.
	//
	module.exports = EventEmitter;


/***/ },
/* 153 */
/***/ function(module, exports) {

	// From https://github.com/isaacs/inherits
	// inherits is licensed under the ISC license:
	//
	//
	// The ISC License
	//
	// Copyright (c) Isaac Z. Schlueter
	//
	// Permission to use, copy, modify, and/or distribute this software for any
	// purpose with or without fee is hereby granted, provided that the above
	// copyright notice and this permission notice appear in all copies.
	//
	// THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
	// REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY AND
	// FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
	// INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
	// LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
	// OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
	// PERFORMANCE OF THIS SOFTWARE.
	
	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor;
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor;
	    var TempCtor = function () {};
	    TempCtor.prototype = superCtor.prototype;
	    ctor.prototype = new TempCtor();
	    ctor.prototype.constructor = ctor;
	  };
	}


/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root, factory){
	  'use strict';
	
	  /*istanbul ignore next:cant test*/
	  if (typeof module === 'object' && typeof module.exports === 'object') {
	    module.exports = factory();
	  } else if (true) {
	    // AMD. Register as an anonymous module.
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else {
	    // Browser globals
	    root.objectPath = factory();
	  }
	})(this, function(){
	  'use strict';
	
	  var
	    toStr = Object.prototype.toString,
	    _hasOwnProperty = Object.prototype.hasOwnProperty;
	
	  function isEmpty(value){
	    if (!value) {
	      return true;
	    }
	    if (isArray(value) && value.length === 0) {
	      return true;
	    } else {
	      for (var i in value) {
	        if (_hasOwnProperty.call(value, i)) {
	          return false;
	        }
	      }
	      return true;
	    }
	  }
	
	  function toString(type){
	    return toStr.call(type);
	  }
	
	  function isNumber(value){
	    return typeof value === 'number' || toString(value) === "[object Number]";
	  }
	
	  function isString(obj){
	    return typeof obj === 'string' || toString(obj) === "[object String]";
	  }
	
	  function isObject(obj){
	    return typeof obj === 'object' && toString(obj) === "[object Object]";
	  }
	
	  function isArray(obj){
	    return typeof obj === 'object' && typeof obj.length === 'number' && toString(obj) === '[object Array]';
	  }
	
	  function isBoolean(obj){
	    return typeof obj === 'boolean' || toString(obj) === '[object Boolean]';
	  }
	
	  function getKey(key){
	    var intKey = parseInt(key);
	    if (intKey.toString() === key) {
	      return intKey;
	    }
	    return key;
	  }
	
	  function set(obj, path, value, doNotReplace){
	    if (isNumber(path)) {
	      path = [path];
	    }
	    if (isEmpty(path)) {
	      return obj;
	    }
	    if (isString(path)) {
	      return set(obj, path.split('.'), value, doNotReplace);
	    }
	    var currentPath = getKey(path[0]);
	
	    if (path.length === 1) {
	      var oldVal = obj[currentPath];
	      if (oldVal === void 0 || !doNotReplace) {
	        obj[currentPath] = value;
	      }
	      return oldVal;
	    }
	
	    if (obj[currentPath] === void 0) {
	      if (isNumber(currentPath)) {
	        obj[currentPath] = [];
	      } else {
	        obj[currentPath] = {};
	      }
	    }
	
	    return set(obj[currentPath], path.slice(1), value, doNotReplace);
	  }
	
	  function del(obj, path) {
	    if (isNumber(path)) {
	      path = [path];
	    }
	
	    if (isEmpty(obj)) {
	      return void 0;
	    }
	
	    if (isEmpty(path)) {
	      return obj;
	    }
	    if(isString(path)) {
	      return del(obj, path.split('.'));
	    }
	
	    var currentPath = getKey(path[0]);
	    var oldVal = obj[currentPath];
	
	    if(path.length === 1) {
	      if (oldVal !== void 0) {
	        if (isArray(obj)) {
	          obj.splice(currentPath, 1);
	        } else {
	          delete obj[currentPath];
	        }
	      }
	    } else {
	      if (obj[currentPath] !== void 0) {
	        return del(obj[currentPath], path.slice(1));
	      }
	    }
	
	    return obj;
	  }
	
	  var objectPath = {};
	
	  objectPath.ensureExists = function (obj, path, value){
	    return set(obj, path, value, true);
	  };
	
	  objectPath.set = function (obj, path, value, doNotReplace){
	    return set(obj, path, value, doNotReplace);
	  };
	
	  objectPath.insert = function (obj, path, value, at){
	    var arr = objectPath.get(obj, path);
	    at = ~~at;
	    if (!isArray(arr)) {
	      arr = [];
	      objectPath.set(obj, path, arr);
	    }
	    arr.splice(at, 0, value);
	  };
	
	  objectPath.empty = function(obj, path) {
	    if (isEmpty(path)) {
	      return obj;
	    }
	    if (isEmpty(obj)) {
	      return void 0;
	    }
	
	    var value, i;
	    if (!(value = objectPath.get(obj, path))) {
	      return obj;
	    }
	
	    if (isString(value)) {
	      return objectPath.set(obj, path, '');
	    } else if (isBoolean(value)) {
	      return objectPath.set(obj, path, false);
	    } else if (isNumber(value)) {
	      return objectPath.set(obj, path, 0);
	    } else if (isArray(value)) {
	      value.length = 0;
	    } else if (isObject(value)) {
	      for (i in value) {
	        if (_hasOwnProperty.call(value, i)) {
	          delete value[i];
	        }
	      }
	    } else {
	      return objectPath.set(obj, path, null);
	    }
	  };
	
	  objectPath.push = function (obj, path /*, values */){
	    var arr = objectPath.get(obj, path);
	    if (!isArray(arr)) {
	      arr = [];
	      objectPath.set(obj, path, arr);
	    }
	
	    arr.push.apply(arr, Array.prototype.slice.call(arguments, 2));
	  };
	
	  objectPath.coalesce = function (obj, paths, defaultValue) {
	    var value;
	
	    for (var i = 0, len = paths.length; i < len; i++) {
	      if ((value = objectPath.get(obj, paths[i])) !== void 0) {
	        return value;
	      }
	    }
	
	    return defaultValue;
	  };
	
	  objectPath.get = function (obj, path, defaultValue){
	    if (isNumber(path)) {
	      path = [path];
	    }
	    if (isEmpty(path)) {
	      return obj;
	    }
	    if (isEmpty(obj)) {
	      return defaultValue;
	    }
	    if (isString(path)) {
	      return objectPath.get(obj, path.split('.'), defaultValue);
	    }
	
	    var currentPath = getKey(path[0]);
	
	    if (path.length === 1) {
	      if (obj[currentPath] === void 0) {
	        return defaultValue;
	      }
	      return obj[currentPath];
	    }
	
	    return objectPath.get(obj[currentPath], path.slice(1), defaultValue);
	  };
	
	  objectPath.del = function(obj, path) {
	    return del(obj, path);
	  };
	
	  return objectPath;
	});

/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	var arrayReduce = __webpack_require__(156),
	    baseEach = __webpack_require__(140),
	    createReduce = __webpack_require__(157);
	
	/**
	 * Reduces `collection` to a value which is the accumulated result of running
	 * each element in `collection` through `iteratee`, where each successive
	 * invocation is supplied the return value of the previous. If `accumulator`
	 * is not provided the first element of `collection` is used as the initial
	 * value. The `iteratee` is bound to `thisArg` and invoked with four arguments:
	 * (accumulator, value, index|key, collection).
	 *
	 * Many lodash methods are guarded to work as iteratees for methods like
	 * `_.reduce`, `_.reduceRight`, and `_.transform`.
	 *
	 * The guarded methods are:
	 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `sortByAll`,
	 * and `sortByOrder`
	 *
	 * @static
	 * @memberOf _
	 * @alias foldl, inject
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @param {*} [thisArg] The `this` binding of `iteratee`.
	 * @returns {*} Returns the accumulated value.
	 * @example
	 *
	 * _.reduce([1, 2], function(total, n) {
	 *   return total + n;
	 * });
	 * // => 3
	 *
	 * _.reduce({ 'a': 1, 'b': 2 }, function(result, n, key) {
	 *   result[key] = n * 3;
	 *   return result;
	 * }, {});
	 * // => { 'a': 3, 'b': 6 } (iteration order is not guaranteed)
	 */
	var reduce = createReduce(arrayReduce, baseEach);
	
	module.exports = reduce;


/***/ },
/* 156 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.reduce` for arrays without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @param {boolean} [initFromArray] Specify using the first element of `array`
	 *  as the initial value.
	 * @returns {*} Returns the accumulated value.
	 */
	function arrayReduce(array, iteratee, accumulator, initFromArray) {
	  var index = -1,
	      length = array.length;
	
	  if (initFromArray && length) {
	    accumulator = array[++index];
	  }
	  while (++index < length) {
	    accumulator = iteratee(accumulator, array[index], index, array);
	  }
	  return accumulator;
	}
	
	module.exports = arrayReduce;


/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	var baseCallback = __webpack_require__(105),
	    baseReduce = __webpack_require__(158),
	    isArray = __webpack_require__(89);
	
	/**
	 * Creates a function for `_.reduce` or `_.reduceRight`.
	 *
	 * @private
	 * @param {Function} arrayFunc The function to iterate over an array.
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @returns {Function} Returns the new each function.
	 */
	function createReduce(arrayFunc, eachFunc) {
	  return function(collection, iteratee, accumulator, thisArg) {
	    var initFromArray = arguments.length < 3;
	    return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
	      ? arrayFunc(collection, iteratee, accumulator, initFromArray)
	      : baseReduce(collection, baseCallback(iteratee, thisArg, 4), accumulator, initFromArray, eachFunc);
	  };
	}
	
	module.exports = createReduce;


/***/ },
/* 158 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.reduce` and `_.reduceRight` without support
	 * for callback shorthands and `this` binding, which iterates over `collection`
	 * using the provided `eachFunc`.
	 *
	 * @private
	 * @param {Array|Object|string} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} accumulator The initial value.
	 * @param {boolean} initFromCollection Specify using the first or last element
	 *  of `collection` as the initial value.
	 * @param {Function} eachFunc The function to iterate over `collection`.
	 * @returns {*} Returns the accumulated value.
	 */
	function baseReduce(collection, iteratee, accumulator, initFromCollection, eachFunc) {
	  eachFunc(collection, function(value, index, collection) {
	    accumulator = initFromCollection
	      ? (initFromCollection = false, value)
	      : iteratee(accumulator, value, index, collection);
	  });
	  return accumulator;
	}
	
	module.exports = baseReduce;


/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	var isObjectLike = __webpack_require__(82);
	
	/** `Object#toString` result references. */
	var stringTag = '[object String]';
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' || (isObjectLike(value) && objToString.call(value) == stringTag);
	}
	
	module.exports = isString;


/***/ },
/* 160 */
/***/ function(module, exports) {

	var FluxMixin = function(React) {
	  return {
	    componentWillMount: function() {
	      if (!this.props.flux && (!this.context || !this.context.flux)) {
	        var namePart = this.constructor.displayName ? " of " + this.constructor.displayName : "";
	        throw new Error("Could not find flux on this.props or this.context" + namePart);
	      }
	    },
	
	    childContextTypes: {
	      flux: React.PropTypes.object
	    },
	
	    contextTypes: {
	      flux: React.PropTypes.object
	    },
	
	    getChildContext: function() {
	      return {
	        flux: this.getFlux()
	      };
	    },
	
	    getFlux: function() {
	      return this.props.flux || (this.context && this.context.flux);
	    }
	  };
	};
	
	FluxMixin.componentWillMount = function() {
	  throw new Error("Fluxxor.FluxMixin is a function that takes React as a " +
	    "parameter and returns the mixin, e.g.: mixins: [Fluxxor.FluxMixin(React)]");
	};
	
	module.exports = FluxMixin;


/***/ },
/* 161 */
/***/ function(module, exports) {

	var FluxChildMixin = function(React) {
	  return {
	    componentWillMount: function() {
	      if (console && console.warn) {
	        var namePart = this.constructor.displayName ? " in " + this.constructor.displayName : "",
	            message = "Fluxxor.FluxChildMixin was found in use" + namePart + ", " +
	                      "but has been deprecated. Use Fluxxor.FluxMixin instead.";
	        console.warn(message);
	      }
	    },
	
	    contextTypes: {
	      flux: React.PropTypes.object
	    },
	
	    getFlux: function() {
	      return this.context.flux;
	    }
	  };
	};
	
	FluxChildMixin.componentWillMount = function() {
	  throw new Error("Fluxxor.FluxChildMixin is a function that takes React as a " +
	    "parameter and returns the mixin, e.g.: mixins[Fluxxor.FluxChildMixin(React)]");
	};
	
	module.exports = FluxChildMixin;


/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	var _each = __webpack_require__(142);
	
	var StoreWatchMixin = function() {
	  var storeNames = Array.prototype.slice.call(arguments);
	  return {
	    componentDidMount: function() {
	      var flux = this.props.flux || this.context.flux;
	      this.mounted = true;
	
	      // No autobinding in ES6 classes
	      this._setStateFromFlux = function() {
	        if(this.mounted) {
	          this.setState(this.getStateFromFlux());
	        }
	      }.bind(this);
	
	      _each(storeNames, function(store) {
	        flux.store(store).on("change", this._setStateFromFlux);
	      }, this);
	    },
	
	    componentWillUnmount: function() {
	      var flux = this.props.flux || this.context.flux;
	      this.mounted = false;
	      _each(storeNames, function(store) {
	        flux.store(store).removeListener("change", this._setStateFromFlux);
	      }, this);
	    },
	
	    getInitialState: function() {
	      return this.getStateFromFlux();
	    }
	  };
	};
	
	StoreWatchMixin.componentWillMount = function() {
	  throw new Error("Fluxxor.StoreWatchMixin is a function that takes one or more " +
	    "store names as parameters and returns the mixin, e.g.: " +
	    "mixins: [Fluxxor.StoreWatchMixin(\"Store1\", \"Store2\")]");
	};
	
	module.exports = StoreWatchMixin;


/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	var _each = __webpack_require__(142),
	    _isFunction = __webpack_require__(80),
	    Store = __webpack_require__(164),
	    inherits = __webpack_require__(153);
	
	var RESERVED_KEYS = ["flux", "waitFor"];
	
	var createStore = function(spec) {
	  _each(RESERVED_KEYS, function(key) {
	    if (spec[key]) {
	      throw new Error("Reserved key '" + key + "' found in store definition");
	    }
	  });
	
	  var constructor = function(options) {
	    options = options || {};
	    Store.call(this);
	
	    for (var key in spec) {
	      if (key === "actions") {
	        this.bindActions(spec[key]);
	      } else if (key === "initialize") {
	        // do nothing
	      } else if (_isFunction(spec[key])) {
	        this[key] = spec[key].bind(this);
	      } else {
	        this[key] = spec[key];
	      }
	    }
	
	    if (spec.initialize) {
	      spec.initialize.call(this, options);
	    }
	  };
	
	  inherits(constructor, Store);
	  return constructor;
	};
	
	module.exports = createStore;


/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	var EventEmitter = __webpack_require__(152),
	    inherits = __webpack_require__(153),
	    _isFunction = __webpack_require__(80),
	    _isObject = __webpack_require__(81);
	
	function Store(dispatcher) {
	  this.dispatcher = dispatcher;
	  this.__actions__ = {};
	  EventEmitter.call(this);
	}
	
	inherits(Store, EventEmitter);
	
	Store.prototype.__handleAction__ = function(action) {
	  var handler;
	  if (!!(handler = this.__actions__[action.type])) {
	    if (_isFunction(handler)) {
	      handler.call(this, action.payload, action.type);
	    } else if (handler && _isFunction(this[handler])) {
	      this[handler].call(this, action.payload, action.type);
	    } else {
	      throw new Error("The handler for action type " + action.type + " is not a function");
	    }
	    return true;
	  } else {
	    return false;
	  }
	};
	
	Store.prototype.bindActions = function() {
	  var actions = Array.prototype.slice.call(arguments);
	
	  if (actions.length > 1 && actions.length % 2 !== 0) {
	    throw new Error("bindActions must take an even number of arguments.");
	  }
	
	  var bindAction = function(type, handler) {
	    if (!handler) {
	      throw new Error("The handler for action type " + type + " is falsy");
	    }
	
	    this.__actions__[type] = handler;
	  }.bind(this);
	
	  if (actions.length === 1 && _isObject(actions[0])) {
	    actions = actions[0];
	    for (var key in actions) {
	      if (actions.hasOwnProperty(key)) {
	        bindAction(key, actions[key]);
	      }
	    }
	  } else {
	    for (var i = 0; i < actions.length; i += 2) {
	      var type = actions[i],
	          handler = actions[i+1];
	
	      if (!type) {
	        throw new Error("Argument " + (i+1) + " to bindActions is a falsy value");
	      }
	
	      bindAction(type, handler);
	    }
	  }
	};
	
	Store.prototype.waitFor = function(stores, fn) {
	  this.dispatcher.waitForStores(this, stores, fn.bind(this));
	};
	
	module.exports = Store;


/***/ },
/* 165 */
/***/ function(module, exports) {

	module.exports = "1.7.3"

/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = __webpack_require__(28)['default'];
	
	var _classCallCheck = __webpack_require__(31)['default'];
	
	var _Object$assign = __webpack_require__(32)['default'];
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _Services = __webpack_require__(167);
	
	var _Services2 = _interopRequireDefault(_Services);
	
	var _Constants = __webpack_require__(168);
	
	var _Constants2 = _interopRequireDefault(_Constants);
	
	var Tracker = (function () {
	  function Tracker() {
	    _classCallCheck(this, Tracker);
	
	    if (!_Services2['default'].segment) {
	      /* eslint-disable no-console */
	      console.error('Tracker missing parameter,' + ' segment: ' + _Services2['default'].segment);
	      /* eslint-enable no-console */
	    }
	  }
	
	  _createClass(Tracker, [{
	    key: 'openEnquiry',
	    value: function openEnquiry(source) {
	      var properties = _Object$assign({ source: source }, this._commonData());
	
	      var eventName = _Constants2['default'].events.OPEN_ENQUIRY;
	      this._segmentTrack(eventName, properties);
	    }
	  }, {
	    key: 'submitEnquiry',
	    value: function submitEnquiry(source, formData) {
	      var properties = _Object$assign({ source: source, formData: formData }, this._commonData());
	      var eventName = _Constants2['default'].events.SUBMIT_ENQUIRY;
	      this._segmentTrack(eventName, properties);
	    }
	  }, {
	    key: 'confirmedEnquiry',
	    value: function confirmedEnquiry(source) {
	      var properties = _Object$assign({ source: source }, this._commonData());
	      var eventName = _Constants2['default'].events.CONFIRMED_ENQUIRY;
	      this._segmentTrack(eventName, properties);
	    }
	  }, {
	    key: 'enquiryValidationError',
	    value: function enquiryValidationError(source, invalidFields) {
	      var properties = _Object$assign({ source: source, invalidFields: invalidFields }, this._commonData());
	      var eventName = _Constants2['default'].events.ENQUIRY_VALIDATION_ERROR;
	      this._segmentTrack(eventName, properties);
	    }
	  }, {
	    key: 'homePageView',
	    value: function homePageView() {
	      var properties = this._commonData();
	
	      var pageName = _Constants2['default'].pages.HOME;
	      this._segmentPage(pageName, properties);
	    }
	  }, {
	    key: 'searchPageView',
	    value: function searchPageView(additionalProperties) {
	      var properties = _Object$assign(additionalProperties, this._commonData());
	
	      var pageName = _Constants2['default'].pages.SEARCH;
	      this._segmentPage(pageName, properties);
	    }
	  }, {
	    key: 'homeListingPageView',
	    value: function homeListingPageView(additionalProperties) {
	      var properties = _Object$assign(additionalProperties, this._commonData());
	
	      var pageName = _Constants2['default'].pages.HOME_LISTING;
	      this._segmentPage(pageName, properties);
	    }
	  }, {
	    key: '_segmentTrack',
	    value: function _segmentTrack(eventName, properties) {
	      if (_Services2['default'].segment) {
	        _Services2['default'].segment.track(eventName, properties);
	      }
	    }
	  }, {
	    key: '_segmentPage',
	    value: function _segmentPage(pageName, properties) {
	      if (_Services2['default'].segment) {
	        _Services2['default'].segment.page(pageName, properties);
	      }
	    }
	  }, {
	    key: '_commonData',
	    value: function _commonData() {
	      return {
	        location: window.location.href,
	        pageTitle: document.title
	      };
	    }
	  }]);
	
	  return Tracker;
	})();
	
	exports['default'] = new Tracker();
	module.exports = exports['default'];

/***/ },
/* 167 */
/***/ function(module, exports) {

	/**
	 * Services module to wrap all 3rd party tracking service objects
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = {
	  segment: window.analytics
	};
	module.exports = exports["default"];

/***/ },
/* 168 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = {
	  events: {
	    OPEN_ENQUIRY: 'Open enquiry form',
	    SUBMIT_ENQUIRY: 'Enquiry form submitted',
	    CONFIRMED_ENQUIRY: 'Enquiry success',
	    ENQUIRY_VALIDATION_ERROR: 'Enquiry form invalid'
	  },
	  pages: {
	    HOME: 'Home page',
	    SEARCH: 'Search page',
	    HOME_LISTING: 'Home listing'
	  }
	};
	module.exports = exports['default'];

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @jsx React.DOM
	 * @copyright Prometheus Research, LLC 2014
	 */
	'use strict';
	
	var _Object$assign = __webpack_require__(32)['default'];
	
	if (_Object$assign === undefined) {
	  Object.assign = __webpack_require__(170);
	}
	
	var Form = __webpack_require__(174);
	
	var Field = __webpack_require__(189);
	var Fieldset = __webpack_require__(188);
	var RepeatingFieldset = __webpack_require__(185);
	var Element = __webpack_require__(184);
	var Input = __webpack_require__(191);
	var defaultValue = __webpack_require__(183);
	var ValidationResult = __webpack_require__(181);
	var FocusStore = __webpack_require__(192);
	
	var Message = __webpack_require__(190);
	var Label = __webpack_require__(186);
	
	var PropTypes = __webpack_require__(175);
	
	var messages = __webpack_require__(180);
	var schema = __webpack_require__(178);
	var Value = __webpack_require__(176);
	
	module.exports = {
	  Form: Form,
	  Field: Field, Fieldset: Fieldset, RepeatingFieldset: RepeatingFieldset,
	  Element: Element, Input: Input,
	  ValidationResult: ValidationResult,
	  Message: Message, Label: Label,
	  PropTypes: PropTypes,
	  schema: schema, messages: messages,
	  defaultValue: defaultValue,
	  Value: Value,
	  FocusStore: FocusStore
	};

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _Object$assign = __webpack_require__(32)['default'];
	
	var _Object$keys = __webpack_require__(171)['default'];
	
	function ToObject(val) {
		if (val == null) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	module.exports = _Object$assign || function (target, source) {
		var from;
		var keys;
		var to = ToObject(target);
	
		for (var s = 1; s < arguments.length; s++) {
			from = arguments[s];
			keys = _Object$keys(Object(from));
	
			for (var i = 0; i < keys.length; i++) {
				to[keys[i]] = from[keys[i]];
			}
		}
	
		return to;
	};

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(172), __esModule: true };

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(173);
	module.exports = __webpack_require__(15).Object.keys;

/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(36);
	
	__webpack_require__(12)('keys', function($keys){
	  return function keys(it){
	    return $keys(toObject(it));
	  };
	});

/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * `<Form />` component is a stateful wrapper around `<Element />` component.
	 *
	 * The basic usage is as follows:
	 *
	 *    <Form
	 *      schema={...}
	 *      defaultValue={...}
	 *      onChange={function(value) { ... }}
	 *      onUpdate={function(value, validation) { ... }}
	 *      />
	 *
	 * Property `defaultValue` is used to set the initial value of the form. It only
	 * takes effect on initial render, after that form uses its own value from the
	 * state.
	 *
	 * Callback `onUpdate` is called on every change to a form value, `onChange` is
	 * only called when form value is valid after the change.
	 *
	 * Alternatively one can read current form value by calling `getValue()` method
	 * (you can access form by keeping a ref to it).
	 *
	 * @copyright Prometheus Research, LLC 2014
	 */
	'use strict';
	
	var _objectWithoutProperties = __webpack_require__(53)['default'];
	
	var _extends = __webpack_require__(54)['default'];
	
	var _require = __webpack_require__(68);
	
	var is = _require.is;
	
	var React = __webpack_require__(40);
	var PropTypes = React.PropTypes;
	var cx = React.addons.classSet;
	var FormPropTypes = __webpack_require__(175);
	var Element = __webpack_require__(184);
	var Value = __webpack_require__(176);
	var emptyFunction = __webpack_require__(177);
	var FocusStore = __webpack_require__(192);
	
	var Form = React.createClass({
	  displayName: 'Form',
	
	  mixins: [FocusStore.ScopeMixin],
	
	  propTypes: {
	    component: PropTypes.constructor,
	    defaultValue: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
	    externalValidation: PropTypes.object,
	    schema: FormPropTypes.Schema,
	    onChange: PropTypes.func,
	    onUpdate: PropTypes.func
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var Component = _props.component;
	    var className = _props.className;
	    var onUpdate = _props.onUpdate;
	    var onChange = _props.onChange;
	    var defaultValue = _props.defaultValue;
	    var externalValidation = _props.externalValidation;
	
	    var props = _objectWithoutProperties(_props, ['component', 'className', 'onUpdate', 'onChange', 'defaultValue', 'externalValidation']);
	
	    var value = this.state.value;
	
	    var classNames = cx(className, 'rf-Form', !value.isValid && 'rf-Form--invalid');
	    return React.createElement(
	      Component,
	      _extends({}, props, { className: classNames }),
	      React.createElement(Element, { value: this.state.value })
	    );
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      component: 'form',
	      onChange: emptyFunction,
	      onUpdate: emptyFunction
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    var _props2 = this.props;
	    var schema = _props2.schema;
	    var defaultValue = _props2.defaultValue;
	    var externalValidation = _props2.externalValidation;
	
	    var value = Value.create(schema, defaultValue, this.onUpdate, this.root);
	    if (externalValidation) {
	      value = value.setExternalValidation(externalValidation);
	    }
	    return { value: value };
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(_ref) {
	    var schema = _ref.schema;
	    var externalValidation = _ref.externalValidation;
	
	    var value = this.root();
	    if (!is(schema, this.props.schema)) {
	      value = value.setSchema(schema);
	    }
	    if (!is(externalValidation, this.props.externalValidation)) {
	      value = value.setExternalValidation(externalValidation);
	    }
	    this.setState({ value: value });
	    this._pendingState = null;
	  },
	
	  root: function root() {
	    return this._pendingState && this._pendingState.value ? this._pendingState.value : this.state.value;
	  },
	
	  onUpdate: function onUpdate(value, keyPath) {
	    this.setState({ value: value });
	    this._pendingState = { value: value };
	    this.props.onUpdate(value.value, value.validation, keyPath);
	    if (value.isValid) {
	      this.props.onChange(value.value, value.validation, keyPath);
	    }
	  },
	
	  getValue: function getValue() {
	    return this.state.value.value;
	  },
	
	  makeDirty: function makeDirty() {
	    this.state.value.makeDirty();
	  },
	
	  setValue: function setValue(newValue) {
	    var value = this.state.value.set(newValue);
	    this.setState({ value: value });
	  },
	
	  getValidation: function getValidation() {
	    return this.state.value.validation;
	  },
	
	  isValid: function isValid() {
	    return this.state.value.isValid;
	  }
	});
	
	module.exports = Form;

/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * validators for react forms component properties.
	 *
	 * @copyright prometheus research, llc 2014
	 */
	'use strict';
	
	var ValueCtor = __webpack_require__(176);
	
	var _require = __webpack_require__(178);
	
	var Node = _require.Node;
	
	function makePropType(validate) {
	  function validator(props, name, component) {
	    return validate(props, name, component);
	  }
	  validator.isRequired = function (props, name, component) {
	    if (props[name] === undefined) {
	      return new Error('Prop "' + name + '" is required for component "' + component + '"');
	    } else {
	      return validate(props, name, component);
	    }
	  };
	  return validator;
	}
	
	var Value = makePropType(function Value(props, name, component) {
	  if (props[name] !== undefined && !(props[name] instanceof ValueCtor)) {
	    return new Error('Invalid Value object passed as prop "' + name + '" to <' + component + ' />');
	  }
	});
	
	var Schema = makePropType(function Schema(props, name, component) {
	  if (props[name] !== undefined && !(props[name] instanceof Node)) {
	    return new Error('Invalid Schema object passed as prop "' + name + '" to <' + component + ' />');
	  }
	});
	
	module.exports = { Value: Value, Schema: Schema };

/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	/**
	 * Value is a wrapper for form value and associated metadata such as form
	 * validaton and dirtyness state.
	 *
	 * @copyright Prometheus Research, LLC 2014
	 * @preventMungle
	 */
	
	var _createClass = __webpack_require__(28)['default'];
	
	var _classCallCheck = __webpack_require__(31)['default'];
	
	var Immutable = __webpack_require__(68);
	var List = Immutable.List;
	var Map = Immutable.Map;
	var is = Immutable.is;
	var fromJS = Immutable.fromJS;
	// jshint ignore:line
	var emptyFunction = __webpack_require__(177);
	
	var _require = __webpack_require__(178);
	
	var ScalarNode = _require.ScalarNode;
	var CompositeNode = _require.CompositeNode;
	
	var invariant = __webpack_require__(179);
	var ValidationResult = __webpack_require__(181);
	var defaultValue = __webpack_require__(183);
	
	var EMPTY_MAP = Map(); // jshint ignore:line
	
	var DIRTY_SENTINEL = '__react_forms_dirty__';
	var DIRTY = EMPTY_MAP.set(DIRTY_SENTINEL, true);
	
	var Value = (function () {
	  function Value(attributes, onUpdate, root, keyPath) {
	    _classCallCheck(this, Value);
	
	    this.attributes = attributes;
	    this.onUpdate = onUpdate;
	    this.__root = root;
	    this.keyPath = keyPath || [];
	  }
	
	  /**
	   * Validate value against schema node.
	   */
	
	  _createClass(Value, [{
	    key: 'is',
	    value: function is(nodeType) {
	      return this.node instanceof nodeType;
	    }
	  }, {
	    key: 'equals',
	    value: function equals(other) {
	      return other && is(this.attributes, other.attributes);
	    }
	  }, {
	    key: 'hashCode',
	    value: function hashCode() {
	      return this.attributes.hashCode();
	    }
	  }, {
	    key: 'makeDirty',
	    value: function makeDirty() {
	      var attributes = this.attributes.setIn(['dirty', DIRTY_SENTINEL], true);
	      return this.__update(attributes);
	    }
	  }, {
	    key: 'makeNotDirty',
	    value: function makeNotDirty() {
	      var attributes = this.attributes.removeIn(['dirty', DIRTY_SENTINEL]);
	      return this.__update(attributes);
	    }
	  }, {
	    key: 'keys',
	    value: function keys() {
	      return this.node.keys(this.value);
	    }
	  }, {
	    key: 'get',
	    value: function get(key) {
	      var abstractNode = this.node.get(key);
	      invariant(abstractNode !== undefined, 'Access to key "%s" which does not exist in schema', key);
	      var value = this.value.get(key);
	      if (value == undefined) {
	        value = defaultValue(abstractNode);
	      }
	
	      var _abstractNode$instantiate = abstractNode.instantiate(value, undefined);
	
	      var node = _abstractNode$instantiate.node;
	      var value = _abstractNode$instantiate.value;
	
	      var externalValidation = this.externalValidation.has(key) ? this.externalValidation.get(key) : ValidationResult.success();
	      var validation = this.validation.has(key) ? this.validation.get(key) : value != undefined ? validate(node, value, ValidationResult.success()) : ValidationResult.success();
	      var serialized = this.serialized.has(key) ? this.serialized.get(key) : serialize(node, value);
	      var dirty = this.dirty.has(key) ? this.dirty.get(key) : this.isDirty ? DIRTY : EMPTY_MAP;
	      var attributes = Map({ // jshint ignore:line
	        abstractNode: abstractNode, node: node,
	        value: value, serialized: serialized,
	        validation: validation, externalValidation: externalValidation,
	        dirty: dirty
	      });
	      return new this.constructor(attributes, this.onUpdate, this.__root, this.keyPath.concat(key));
	    }
	  }, {
	    key: 'getIn',
	    value: function getIn(keyPath) {
	      if (keyPath.length === 0) {
	        return this;
	      }
	      var current = this;
	      for (var i = 0, len = keyPath.length; i < len; i++) {
	        current = current.get(keyPath[i]);
	      }
	      return current;
	    }
	  }, {
	    key: 'map',
	    value: function map(func) {
	      var result = [];
	      var iterator = this.node.keys(this.value);
	      var step;
	      while (!(step = iterator.next()).done) {
	        result.push(func(this.get(step.value), step.value, this));
	      }
	      return result;
	    }
	  }, {
	    key: 'set',
	    value: function set(value) {
	      value = fromJS(value);
	
	      var _abstractNode$instantiate2 = this.abstractNode.instantiate(value, this.node);
	
	      var node = _abstractNode$instantiate2.node;
	      var value = _abstractNode$instantiate2.value;
	
	      var attributes = {
	        node: node, value: value,
	        // either get a new serialized value for scalar nodes or destroy it
	        // otherwise
	        serialized: node instanceof ScalarNode ? node.serialize(value) : EMPTY_MAP
	      };
	      return this.__update(attributes);
	    }
	  }, {
	    key: 'transform',
	    value: function transform(updater) {
	      return this.set(updater(this.value));
	    }
	  }, {
	    key: 'setSerialized',
	    value: function setSerialized(serialized, options) {
	      options = options || {};
	      invariant(this.node instanceof ScalarNode, 'value should be a scalar');
	      var value = serialized !== '' ? this.node.deserialize(serialized) : null;
	      var attributes = { value: value, serialized: serialized };
	      if (options.dirtyOnChange) {
	        attributes.dirty = DIRTY;
	      }
	      if (value instanceof Error) {
	        attributes.validation = value;
	        attributes.value = serialized;
	      }
	      return this.__update(attributes);
	    }
	  }, {
	    key: 'setExternalValidation',
	    value: function setExternalValidation(externalValidation) {
	      return this.__update({ externalValidation: externalValidation });
	    }
	  }, {
	    key: 'setSchema',
	    value: function setSchema(abstractNode) {
	      var _abstractNode$instantiate3 = abstractNode.instantiate(this.value, this.node);
	
	      var node = _abstractNode$instantiate3.node;
	      var value = _abstractNode$instantiate3.value;
	
	      return this.__update({ value: value, node: node, abstractNode: abstractNode });
	    }
	  }, {
	    key: 'notify',
	    value: function notify() {
	      console.warn('Value: notify() method is deprecated, the onUpdate() callback ' + 'is now called automatically by each mutative method');
	    }
	  }, {
	    key: '__update',
	    value: function __update(attributes) {
	      var keyPath = this.keyPath;
	      var cur = this.root;
	      var prev = cur;
	      var trace = [cur];
	      for (var i = 0, len = keyPath.length; i < len; i++) {
	        cur = cur.get(keyPath[i]);
	        trace.push(cur);
	      }
	
	      cur = trace.pop();
	      cur = cur.__with(attributes).__grow();
	
	      while (trace.length > 0) {
	        var par = trace.pop();
	        cur = par.__onUpdate(cur);
	      }
	
	      this.onUpdate(cur, keyPath, prev);
	
	      return cur;
	    }
	  }, {
	    key: '__onUpdate',
	    value: function __onUpdate(child) {
	      var value = this.value.set(child.key, child.value);
	
	      var _abstractNode$instantiate4 = this.abstractNode.instantiate(value, this.node);
	
	      var node = _abstractNode$instantiate4.node;
	      var value = _abstractNode$instantiate4.value;
	      var dirty = _abstractNode$instantiate4.dirty;
	
	      if (node.constructor !== this.node.constructor) {
	        value = defaultValue(node);
	        return this.__with({ node: node, value: value, serialized: EMPTY_MAP, dirty: dirty || EMPTY_MAP }).__grow();
	      } else if (!is(node, this.node)) {
	        return this.__with({ node: node, value: value, serialized: EMPTY_MAP, dirty: dirty || EMPTY_MAP }).__grow();
	      } else {
	        var childrenValidation = child.validation.isSuccess ? ValidationResult.children(this.validation.children.remove(String(child.key))) : ValidationResult.children(this.validation.children.set(String(child.key), child.validation));
	        var validation = validate(node, value, childrenValidation);
	        dirty = dirty ? dirty : child.dirty.size > 0 ? this.dirty.set(child.key, child.dirty) : this.dirty.remove(child.key);
	        var serialized = this.serialized.set(child.key, child.serialized);
	        return this.__with({ node: node, value: value, validation: validation, dirty: dirty, serialized: serialized });
	      }
	    }
	  }, {
	    key: '__grow',
	    value: function __grow() {
	      if (this.node instanceof CompositeNode) {
	        var value = this.value.asMutable();
	        var iterator = this.node.keys(this.value);
	        var children = EMPTY_MAP.asMutable();
	
	        var areChildrenValid = true;
	
	        var step;
	        while (!(step = iterator.next()).done) {
	          if (this.value.get(step.value) != undefined || this.node.get(step.value).defaultValue != undefined) {
	            var child = this.get(step.value).__grow();
	            if (!child.validation.isSuccess) {
	              areChildrenValid = false;
	            }
	            children = children.set(child.key, child);
	            value = value.set(step.value, child.value);
	          }
	        }
	        value = value.asImmutable();
	
	        var _abstractNode$instantiate5 = this.abstractNode.instantiate(value, this.node);
	
	        var node = _abstractNode$instantiate5.node;
	        var value = _abstractNode$instantiate5.value;
	        var dirty = _abstractNode$instantiate5.dirty;
	
	        var childrenValidation = areChildrenValid ? ValidationResult.success() : new ValidationResult(null, children.map(function (c) {
	          return c.validation;
	        }).filter(function (v) {
	          return !v.isSuccess;
	        }));
	        var validation = validate(node, value, childrenValidation);
	        dirty = dirty ? dirty : this.dirty.merge(children.filter(function (c) {
	          return c.dirty.size > 0;
	        }).map(function (c) {
	          return c.dirty;
	        }));
	        var serialized = this.serialized.merge(children.map(function (c) {
	          return c.serialized;
	        }));
	        return this.__with({ node: node, value: value, validation: validation, dirty: dirty, serialized: serialized });
	      } else {
	        var validation = validate(this.node, this.value, ValidationResult.success());
	        return this.__with({ validation: validation });
	      }
	    }
	  }, {
	    key: '__with',
	    value: function __with(attributes) {
	      attributes = this.attributes.merge(attributes);
	      return new this.constructor(attributes, this.onUpdate, this.__root, this.keyPath);
	    }
	  }, {
	    key: 'root',
	    get: function get() {
	      return this.__root();
	    }
	  }, {
	    key: 'key',
	    get: function get() {
	      if (this.keyPath.length > 0) {
	        return this.keyPath[this.keyPath.length - 1];
	      } else {
	        return null;
	      }
	    }
	  }, {
	    key: 'value',
	    get: function get() {
	      return this.attributes.get('value');
	    }
	
	    /**
	     * Schema related attributes
	     */
	  }, {
	    key: 'abstractNode',
	    get: function get() {
	      return this.attributes.get('abstractNode');
	    }
	  }, {
	    key: 'node',
	    get: function get() {
	      return this.attributes.get('node');
	    }
	
	    /**
	     * Validation related attributes
	     */
	  }, {
	    key: 'validation',
	    get: function get() {
	      return this.attributes.get('validation');
	    }
	  }, {
	    key: 'externalValidation',
	    get: function get() {
	      return this.attributes.get('externalValidation');
	    }
	  }, {
	    key: 'isValid',
	    get: function get() {
	      return this.attributes.get('validation').isSuccess && this.attributes.get('externalValidation', ValidationResult.success()).isSuccess;
	    }
	
	    /**
	     * Serialized value attribute
	     */
	  }, {
	    key: 'serialized',
	    get: function get() {
	      return this.attributes.get('serialized');
	    }
	
	    /**
	     * Dirtyness state attributes and methods
	     */
	  }, {
	    key: 'dirty',
	    get: function get() {
	      return this.attributes.get('dirty');
	    }
	  }, {
	    key: 'isDirty',
	    get: function get() {
	      return this.attributes.get('dirty').get(DIRTY_SENTINEL, false);
	    }
	  }, {
	    key: 'hasDirty',
	    get: function get() {
	      return this.attributes.get('dirty').size > 0;
	    }
	  }], [{
	    key: 'create',
	    value: function create(abstractNode, value, onUpdate, root) {
	      onUpdate = onUpdate || emptyFunction;
	      value = fromJS(value);
	      // check for both undefined and null
	      if (value == undefined) {
	        value = defaultValue(abstractNode);
	      }
	
	      var _abstractNode$instantiate6 = abstractNode.instantiate(value, undefined);
	
	      var node = _abstractNode$instantiate6.node;
	      var value = _abstractNode$instantiate6.value;
	
	      var externalValidation = ValidationResult.success();
	      var validation = ValidationResult.success();
	      var serialized = serialize(node, value);
	      var dirty = EMPTY_MAP;
	      var attributes = Map({ // jshint ignore:line
	        abstractNode: abstractNode, node: node,
	        value: value, serialized: serialized,
	        validation: validation, externalValidation: externalValidation,
	        dirty: dirty
	      });
	      var created = new this(attributes, onUpdate, root, null);
	      created = created.__grow();
	      return created;
	    }
	  }]);
	
	  return Value;
	})();
	
	function validate(node, value, childrenValidation) {
	  var result = node.validate(value, childrenValidation);
	  if (result instanceof ValidationResult) {
	    return result;
	  } else if (result instanceof Error) {
	    return new ValidationResult(result.message);
	  } else {
	    return ValidationResult.success();
	  }
	}
	
	/**
	 * Serialize value.
	 */
	function serialize(node, value) {
	  if (node instanceof CompositeNode) {
	    return EMPTY_MAP;
	  } else {
	    return node.serialize(value);
	  }
	}
	
	module.exports = Value;

/***/ },
/* 177 */
/***/ function(module, exports) {

	/**
	 * 
	 * @copyright Prometheus Research, LLC 2014
	 */
	'use strict';
	
	function emptyFunction() {}
	
	emptyFunction.toString = function () {
	  return '<empty function>';
	};
	
	emptyFunction.thatReturnsTrue = function () {
	  return true;
	};
	
	emptyFunction.thatReturnsTrue.toString = function () {
	  return '<empty function that returns true>';
	};
	
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	emptyFunction.thatReturnsArgument.toString = function () {
	  return '<empty function that returns argument>';
	};
	
	module.exports = emptyFunction;

/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @copyright Prometheus Research, LLC 2014
	 */
	'use strict';
	
	var _createClass = __webpack_require__(28)['default'];
	
	var _classCallCheck = __webpack_require__(31)['default'];
	
	var _get = __webpack_require__(3)['default'];
	
	var _inherits = __webpack_require__(17)['default'];
	
	var _extends = __webpack_require__(54)['default'];
	
	var React = __webpack_require__(40);
	var Immutable = __webpack_require__(68);
	var is = Immutable.is;
	var fromJS = Immutable.fromJS;
	var Map = Immutable.Map;
	var OrderedMap = Immutable.OrderedMap;
	// jshint ignore:line
	var invariant = __webpack_require__(179);
	var messages = __webpack_require__(180);
	var ValidationResult = __webpack_require__(181);
	var Checkbox = __webpack_require__(182);
	
	var EMPTY_MAP = Map(); // jshint ignore:line
	var EMPTY_LIST = Immutable.List(); // jshint ignore:line
	
	/**
	 * Node represent schema for data.
	 *
	 * Hierarchy is the following:
	 *
	 *                       ScalarNode
	 *                      /
	 *   Node - ConcreteNode               MappingNode
	 *                      \             /
	 *                       CompositeNode
	 *                                    \
	 *                                     ListNode
	 */
	
	var Node = (function () {
	  function Node(props) {
	    _classCallCheck(this, Node);
	
	    props = Map(this.getDefaultProps()).merge(props); // jshint ignore:line
	    this.props = props;
	  }
	
	  _createClass(Node, [{
	    key: 'getDefaultProps',
	    value: function getDefaultProps() {
	      return EMPTY_MAP;
	    }
	  }, {
	    key: 'equals',
	    value: function equals(node) {
	      if (node === null || node === undefined || node.constructor !== undefined && node.constructor !== this.constructor) {
	        return false;
	      }
	      return is(this.props, node.props) && is(this.children, node.children);
	    }
	  }, {
	    key: 'instantiate',
	    value: function instantiate(value) {
	      throw new Error('instantiate(value): not implemented');
	    }
	  }, {
	    key: 'validate',
	    value: function validate(value, childrenValidation) {
	      throw new Error('validate(value, childrenValidation): not implemented');
	    }
	  }, {
	    key: 'toString',
	    value: function toString() {
	      var props = this.props.map(function (v, k) {
	        return k + ': ' + v;
	      }).toList().join(', ');
	      return this.constructor.name + ' { ' + props + ' }';
	    }
	  }, {
	    key: 'defaultValue',
	    get: function get() {
	      if (this.__defaultValue === undefined) {
	        this.__defaultValue = fromJS(this.props.get('defaultValue'));
	      }
	      return this.__defaultValue;
	    }
	  }], [{
	    key: 'create',
	    value: function create(props) {
	      props = props ? Map(props) : EMPTY_MAP; // jshint ignore:line
	      return new this(props);
	    }
	  }]);
	
	  return Node;
	})();
	
	var ConcreteNode = (function (_Node) {
	  _inherits(ConcreteNode, _Node);
	
	  function ConcreteNode() {
	    _classCallCheck(this, ConcreteNode);
	
	    _get(Object.getPrototypeOf(ConcreteNode.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(ConcreteNode, [{
	    key: 'validate',
	    value: function validate(value, childrenValidation) {
	      if (value == null) {
	        // jshint ignore:line
	        return;
	      }
	      if (!childrenValidation.isSuccess) {
	        return childrenValidation;
	      }
	      var result;
	      var validate = this.props.get('validate');
	      // `validate` could be an array for convenienve
	      if (Array.isArray(validate)) {
	        for (var i = 0, len = validate.length; i < len; i++) {
	          result = validate[i](this, value);
	          if (result instanceof Error) {
	            result;
	          }
	        }
	      } else if (validate) {
	        result = validate(this, value);
	      }
	      return result;
	    }
	  }, {
	    key: 'instantiate',
	    value: function instantiate(value) {
	      return { node: this, value: value };
	    }
	  }]);
	
	  return ConcreteNode;
	})(Node);
	
	var CompositeNode = (function (_ConcreteNode) {
	  _inherits(CompositeNode, _ConcreteNode);
	
	  function CompositeNode() {
	    _classCallCheck(this, CompositeNode);
	
	    _get(Object.getPrototypeOf(CompositeNode.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(CompositeNode, [{
	    key: 'getChildren',
	    value: function getChildren() {
	      throw new Error('getChildren(): not implemented');
	    }
	  }, {
	    key: 'get',
	    value: function get(key) {
	      throw new Error('get(key): not implemented');
	    }
	  }, {
	    key: 'getIn',
	    value: function getIn(keyPath) {
	      var cur = this;
	      for (var i = 0, len = keyPath.length; i < len; i++) {
	        cur = cur.get(keyPath[i]);
	      }
	      return cur;
	    }
	  }, {
	    key: 'has',
	    value: function has(key) {
	      throw new Error('has(key): not implemented');
	    }
	  }, {
	    key: 'keys',
	    value: function keys(value) {
	      throw new Error('keys(value): not implemented');
	    }
	  }, {
	    key: 'children',
	    get: function get() {
	      if (this.__children === undefined) {
	        this.__children = this.getChildren();
	      }
	      return this.__children;
	    }
	  }]);
	
	  return CompositeNode;
	})(ConcreteNode);
	
	var INPUT_TEXT = React.createElement('input', { type: 'text' });
	
	var ScalarNode = (function (_ConcreteNode2) {
	  _inherits(ScalarNode, _ConcreteNode2);
	
	  function ScalarNode() {
	    _classCallCheck(this, ScalarNode);
	
	    _get(Object.getPrototypeOf(ScalarNode.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(ScalarNode, [{
	    key: 'getDefaultProps',
	    value: function getDefaultProps() {
	      return { input: INPUT_TEXT };
	    }
	  }, {
	    key: 'validate',
	    value: function validate(value, childrenValidation) {
	      if (value == null) {
	        // jshint ignore:line
	        return;
	      }
	      value = this.deserialize(value);
	      if (value instanceof Error) {
	        return value;
	      } else {
	        return _get(Object.getPrototypeOf(ScalarNode.prototype), 'validate', this).call(this, value, childrenValidation);
	      }
	    }
	  }, {
	    key: 'serialize',
	    value: function serialize(value) {
	      return value === null ? '' : value;
	    }
	  }, {
	    key: 'deserialize',
	    value: function deserialize(value) {
	      return value === '' ? null : value;
	    }
	  }]);
	
	  return ScalarNode;
	})(ConcreteNode);
	
	var INPUT_NUMBER = React.createElement('input', { type: 'number' });
	
	var NumberNode = (function (_ScalarNode) {
	  _inherits(NumberNode, _ScalarNode);
	
	  function NumberNode() {
	    _classCallCheck(this, NumberNode);
	
	    _get(Object.getPrototypeOf(NumberNode.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(NumberNode, [{
	    key: 'getDefaultProps',
	    value: function getDefaultProps() {
	      return { input: INPUT_NUMBER };
	    }
	  }, {
	    key: 'deserialize',
	    value: function deserialize(value) {
	      if (value === '') {
	        return null;
	        // based on http://stackoverflow.com/a/1830844/182954
	      } else if (!isNaN(parseFloat(value)) && isFinite(value)) {
	          return parseFloat(value);
	        } else {
	          return new Error(messages.INVALID_VALUE);
	        }
	    }
	  }]);
	
	  return NumberNode;
	})(ScalarNode);
	
	var INPUT_CHECKBOX = React.createElement(Checkbox, null);
	
	var BoolNode = (function (_ScalarNode2) {
	  _inherits(BoolNode, _ScalarNode2);
	
	  function BoolNode() {
	    _classCallCheck(this, BoolNode);
	
	    _get(Object.getPrototypeOf(BoolNode.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(BoolNode, [{
	    key: 'getDefaultProps',
	    value: function getDefaultProps() {
	      return { input: INPUT_CHECKBOX };
	    }
	  }, {
	    key: 'serialize',
	    value: function serialize(value) {
	      return value;
	    }
	  }, {
	    key: 'deserialize',
	    value: function deserialize(value) {
	      return value;
	    }
	  }]);
	
	  return BoolNode;
	})(ScalarNode);
	
	var ArrayNode = (function (_ScalarNode3) {
	  _inherits(ArrayNode, _ScalarNode3);
	
	  function ArrayNode() {
	    _classCallCheck(this, ArrayNode);
	
	    _get(Object.getPrototypeOf(ArrayNode.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(ArrayNode, [{
	    key: 'serialize',
	    value: function serialize(value) {
	      return value ? value : EMPTY_LIST;
	    }
	  }, {
	    key: 'deserialize',
	    value: function deserialize(value) {
	      return value;
	    }
	  }]);
	
	  return ArrayNode;
	})(ScalarNode);
	
	var IS_DATE_RE = /^\d\d\d\d-\d\d-\d\d$/;
	var INPUT_DATE = React.createElement('input', { type: 'date' });
	
	var DateNode = (function (_ScalarNode4) {
	  _inherits(DateNode, _ScalarNode4);
	
	  function DateNode() {
	    _classCallCheck(this, DateNode);
	
	    _get(Object.getPrototypeOf(DateNode.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(DateNode, [{
	    key: 'getDefaultProps',
	    value: function getDefaultProps() {
	      return { input: INPUT_DATE };
	    }
	  }, {
	    key: 'serialize',
	    value: function serialize(value) {
	      if (value == null) {
	        // jshint ignore:line
	        return '';
	      }
	      var year = value.getFullYear();
	      var month = value.getMonth() + 1;
	      var day = value.getDate();
	      return year + '-' + this.pad(month, 2) + '-' + this.pad(day, 2);
	    }
	  }, {
	    key: 'deserialize',
	    value: function deserialize(value) {
	      if (value === '') {
	        return null;
	      }
	
	      if (value instanceof Date) {
	        return value;
	      }
	
	      if (!IS_DATE_RE.exec(value)) {
	        return new Error(messages.IS_NOT_A_DATE);
	      }
	
	      value = new Date(value);
	
	      if (isNaN(value.getTime())) {
	        return new Error(messages.INVALID_VALUE);
	      }
	
	      return value;
	    }
	  }, {
	    key: 'pad',
	    value: function pad(num, size) {
	      return ('0000' + num).substr(-size);
	    }
	  }]);
	
	  return DateNode;
	})(ScalarNode);
	
	function createNode(node, props) {
	  props = props ? Map(props) : EMPTY_MAP; // jshint ignore:line
	  return new node(props);
	}
	
	function Scalar(props) {
	  switch (props && props.type || 'string') {
	    case 'string':
	      return createNode(ScalarNode, props);
	    case 'number':
	      return createNode(NumberNode, props);
	    case 'array':
	      return createNode(ArrayNode, props);
	    case 'date':
	      return createNode(DateNode, props);
	    case 'bool':
	      return createNode(BoolNode, props);
	    default:
	      invariant(false, 'invalid type "' + props.type + '" supplied to Scalar');
	  }
	}
	
	var VALUE_IS_REQUIRED = ValidationResult.error(messages.VALUE_IS_REQUIRED);
	
	var MappingNode = (function (_CompositeNode) {
	  _inherits(MappingNode, _CompositeNode);
	
	  function MappingNode(props) {
	    _classCallCheck(this, MappingNode);
	
	    _get(Object.getPrototypeOf(MappingNode.prototype), 'constructor', this).call(this, props);
	    this.__requiredKeys = this.children.toSeq().filter(function (child) {
	      return child.props.get('required');
	    }).keySeq().toSet();
	  }
	
	  _createClass(MappingNode, [{
	    key: 'validate',
	    value: function validate(value, childrenValidation) {
	      var missingKeys = this.__requiredKeys.subtract(value.filter(function (v) {
	        return v != null;
	      }).keys()); // jshint ignore:line
	      if (missingKeys.size > 0) {
	        var missingKeysValidation = Map().asMutable(); // jshint ignore:line
	        missingKeys.forEach(function (k) {
	          return missingKeysValidation = missingKeysValidation.set(k, VALUE_IS_REQUIRED);
	        });
	        return ValidationResult.children(childrenValidation.children.merge(missingKeysValidation));
	      }
	      return _get(Object.getPrototypeOf(MappingNode.prototype), 'validate', this).call(this, value, childrenValidation);
	    }
	  }, {
	    key: 'getChildren',
	    value: function getChildren() {
	      return this.props.get('children');
	    }
	  }, {
	    key: 'get',
	    value: function get(key) {
	      return this.children.get(key);
	    }
	  }, {
	    key: 'has',
	    value: function has(key) {
	      return this.children.has(key);
	    }
	  }, {
	    key: 'keys',
	    value: function keys(value) {
	      return this.children.keys();
	    }
	  }]);
	
	  return MappingNode;
	})(CompositeNode);
	
	function Mapping(props, children) {
	  if (children === undefined) {
	    children = props;
	    children = OrderedMap(children); // jshint ignore:line
	    props = { children: children };
	  } else {
	    children = OrderedMap(children); // jshint ignore:line
	    props = _extends({}, props, { children: children });
	  }
	  props = Map(props); // jshint ignore:line
	  return new MappingNode(props);
	}
	
	var ListNode = (function (_CompositeNode2) {
	  _inherits(ListNode, _CompositeNode2);
	
	  function ListNode() {
	    _classCallCheck(this, ListNode);
	
	    _get(Object.getPrototypeOf(ListNode.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(ListNode, [{
	    key: 'getChildren',
	    value: function getChildren() {
	      return this.props.get('children');
	    }
	  }, {
	    key: 'get',
	    value: function get(key) {
	      return this.children;
	    }
	  }, {
	    key: 'has',
	    value: function has(key) {
	      return true;
	    }
	  }, {
	    key: 'keys',
	    value: function keys(value) {
	      return value.keys();
	    }
	  }]);
	
	  return ListNode;
	})(CompositeNode);
	
	function List(props, children) {
	  if (children === undefined) {
	    children = props;
	    props = { children: children };
	  } else {
	    var newProps = {};
	    for (var k in props) {
	      if (props.hasOwnProperty(k)) {
	        newProps[k] = props[k];
	      }
	      newProps.children = children;
	    }
	    props = newProps;
	  }
	  props = Map(props); // jshint ignore:line
	  return new ListNode(props);
	}
	
	module.exports = {
	  Node: Node,
	  ScalarNode: ScalarNode, NumberNode: NumberNode, ArrayNode: ArrayNode, BoolNode: BoolNode, DateNode: DateNode,
	  CompositeNode: CompositeNode,
	  MappingNode: MappingNode, ListNode: ListNode,
	  Scalar: Scalar, Mapping: Mapping, List: List, createNode: createNode
	};

/***/ },
/* 179 */
/***/ function(module, exports) {

	/**
	 * @jsx React.DOM
	 * @copyright Prometheus Research, LLC 2014
	 */
	'use strict';
	
	function invariant(condition, message, a, b, c, d, e) {
	  if (!condition) {
	    if (message !== undefined) {
	      var replacements = [a, b, c, d, e];
	      var idx = 0;
	      message = message.replace(/%s/g, function () {
	        return replacements[idx++];
	      });
	      throw new Error('React Forms invariant violation: ' + message);
	    } else {
	      throw new Error('React Forms invariant violation');
	    }
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 180 */
/***/ function(module, exports) {

	/**
	 * @jsx React.DOM
	 * @copyright Prometheus Research, LLC 2014
	 */
	'use strict';
	
	module.exports = {
	  INVALID_VALUE: 'invalid value',
	  VALUE_IS_REQUIRED: 'This field is required',
	  AT_LEAST_ONE_ITEM_IS_REQUIRED: 'at least one item is required',
	  IS_NOT_A_DATE: 'should be a date in YYYY-MM-DD format'
	};

/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @copyright Prometheus Research, LLC 2014
	 * @preventMungle
	 */
	'use strict';
	
	var _createClass = __webpack_require__(28)['default'];
	
	var _classCallCheck = __webpack_require__(31)['default'];
	
	var Immutable = __webpack_require__(68);
	var Map = Immutable.Map;
	var is = Immutable.is;
	// jshint ignore:line
	
	var EMPTY_MAP = Map(); // jshint ignore:line
	
	var ValidationResult = (function () {
	  function ValidationResult(error, children) {
	    _classCallCheck(this, ValidationResult);
	
	    this.error = error;
	    this.children = children ? Map(children).mapKeys(function (k) {
	      return String(k);
	    }) : EMPTY_MAP; // jshint ignore:line
	  }
	
	  _createClass(ValidationResult, [{
	    key: 'equals',
	    value: function equals(other) {
	      return other != null && // jshint ignore:line
	      is(this.error, other.error) && is(this.children, other.children);
	    }
	  }, {
	    key: 'get',
	    value: function get(key) {
	      return this.children.get(String(key), VALIDATION_SUCCESS);
	    }
	  }, {
	    key: 'has',
	    value: function has(key) {
	      return this.children.has(String(key));
	    }
	  }, {
	    key: 'toString',
	    value: function toString() {
	      if (this.isSuccess) {
	        return this.constructor.name + ' { SUCCESS }';
	      } else {
	        return this.constructor.name + ' { error: ' + this.error + ', children: ' + this.children + ' }';
	      }
	    }
	  }, {
	    key: 'toJS',
	    value: function toJS() {
	      var error = this.error;
	      var children = this.children;
	
	      return { error: error, children: children };
	    }
	  }, {
	    key: 'isSuccess',
	    get: function get() {
	      return this.error === null && this.children.size === 0;
	    }
	  }, {
	    key: 'isFailure',
	    get: function get() {
	      return !this.isSuccess;
	    }
	  }], [{
	    key: 'error',
	    value: function error(message) {
	      return new ValidationResult(message, EMPTY_MAP);
	    }
	  }, {
	    key: 'children',
	    value: function children(c) {
	      return new ValidationResult(null, c);
	    }
	  }, {
	    key: 'success',
	    value: function success() {
	      return VALIDATION_SUCCESS;
	    }
	  }]);
	
	  return ValidationResult;
	})();
	
	var VALIDATION_SUCCESS = new ValidationResult(null, EMPTY_MAP);
	
	module.exports = ValidationResult;

/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * 
	 * @copyright Prometheus Research, LLC 2014
	 */
	'use strict';
	
	var _objectWithoutProperties = __webpack_require__(53)['default'];
	
	var _extends = __webpack_require__(54)['default'];
	
	var React = __webpack_require__(40);
	var cx = React.addons.classSet;
	
	var Checkbox = React.createClass({
	  displayName: 'Checkbox',
	
	  propTypes: {
	    value: React.PropTypes.bool.isRequired,
	    onChange: React.PropTypes.func.isRequired,
	    className: React.PropTypes.string
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var value = _props.value;
	    var onChange = _props.onChange;
	    var className = _props.className;
	
	    var props = _objectWithoutProperties(_props, ['value', 'onChange', 'className']);
	
	    return React.createElement('input', _extends({}, props, {
	      type: 'checkbox',
	      className: cx('rf-Checkbox', className),
	      onChange: this.onChange,
	      checked: value
	    }));
	  },
	
	  onChange: function onChange(e) {
	    var checked = e.target.checked;
	    this.props.onChange(checked);
	  }
	});
	
	module.exports = Checkbox;

/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Infer default value from schema node.
	 *
	 * @copyright Prometheus Research, LLC 2014
	 */
	'use strict';
	
	var _require = __webpack_require__(68);
	
	var Map = _require.Map;
	var List = _require.List;
	// jshint ignore:line
	
	var _require2 = __webpack_require__(178);
	
	var MappingNode = _require2.MappingNode;
	var ListNode = _require2.ListNode;
	
	var EMPTY_MAP = Map(); // jshint ignore:line
	var EMPTY_LIST = List(); // jshint ignore:line
	
	function defaultValue(node) {
	  if (node.defaultValue !== undefined) {
	    return node.defaultValue;
	  } else if (node instanceof MappingNode) {
	    return EMPTY_MAP;
	  } else if (node instanceof ListNode) {
	    return EMPTY_LIST;
	  } else {
	    return undefined;
	  }
	}
	
	module.exports = defaultValue;

/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * `<Element />` component renders form value into one of then `<Field />`,
	 * `<Fieldset />` or `<RepeatingFieldset />` component:
	 *
	 *    <Element value={...} />
	 *
	 * This component is the main building block for composite form elements such as
	 * `<Fieldset />` and `<RepeatingFieldset />` which use it to render its
	 * children.
	 *
	 * @jsx React.DOM
	 * @copyright Prometheus Research, LLC 2014
	 */
	'use strict';
	
	var _require = __webpack_require__(68);
	
	var is = _require.is;
	
	var React = __webpack_require__(40);
	var cloneWithProps = React.addons.cloneWithProps;
	var PropTypes = __webpack_require__(175);
	var invariant = __webpack_require__(179);
	
	var _require2 = __webpack_require__(178);
	
	var ScalarNode = _require2.ScalarNode;
	var CompositeNode = _require2.CompositeNode;
	var ListNode = _require2.ListNode;
	
	var Element = React.createClass({
	  displayName: 'Element',
	
	  propTypes: {
	    value: PropTypes.Value
	  },
	
	  render: function render() {
	    var Component;
	    var node = this.props.value.node;
	
	    Component = node.props.get('component');
	    if (Component) {
	      return React.isValidElement(Component) ? cloneWithProps(Component, this.props) : React.createElement(Component, this.props);
	    } else {
	      if (node instanceof ListNode) {
	        Component = __webpack_require__(185);
	      } else if (node instanceof CompositeNode) {
	        Component = __webpack_require__(188);
	      } else if (node instanceof ScalarNode) {
	        Component = __webpack_require__(189);
	      } else {
	        invariant(false, 'invalid schema node: ' + node);
	      }
	      return React.createElement(Component, this.props);
	    }
	  },
	
	  shouldComponentUpdate: function shouldComponentUpdate(props) {
	    var shouldUpdate = false;
	    for (var name in props) {
	      if (!is(props[name], this.props[name])) {
	        shouldUpdate = true;
	        break;
	      }
	    }
	    return shouldUpdate;
	  }
	});
	
	module.exports = Element;

/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @copyright Prometheus Research, LLC 2014
	 */
	'use strict';
	
	var _objectWithoutProperties = __webpack_require__(53)['default'];
	
	var _extends = __webpack_require__(54)['default'];
	
	var React = __webpack_require__(40);
	var PropTypes = React.PropTypes;
	var cx = React.addons.classSet;
	var cloneWithProps = React.addons.cloneWithProps;
	var Label = __webpack_require__(186);
	var Element = __webpack_require__(184);
	var FormPropTypes = __webpack_require__(175);
	var emptyFunction = __webpack_require__(177);
	var defaultValue = __webpack_require__(183);
	
	var Item = React.createClass({
	  displayName: 'Item',
	
	  render: function render() {
	    var _props = this.props;
	    var className = _props.className;
	    var noRemoveButton = _props.noRemoveButton;
	    var onRemove = _props.onRemove;
	    var value = _props.value;
	
	    var props = _objectWithoutProperties(_props, ['className', 'noRemoveButton', 'onRemove', 'value']);
	
	    return React.createElement(
	      'div',
	      _extends({}, props, { className: cx('rf-RepeatingFieldset__item', className) }),
	      this.props.children,
	      !noRemoveButton && React.createElement(
	        'button',
	        {
	          onClick: onRemove,
	          type: 'button',
	          className: 'rf-RepeatingFieldset__remove' },
	        '×'
	      )
	    );
	  }
	});
	
	/**
	 * A component which renders values which correspond to List schema node.
	 */
	var RepeatingFieldset = React.createClass({
	  displayName: 'RepeatingFieldset',
	
	  propTypes: {
	    value: FormPropTypes.Value,
	    onAdd: PropTypes.func,
	    onRemove: PropTypes.func,
	    label: PropTypes.string,
	    noLabel: PropTypes.bool,
	    hint: PropTypes.string,
	    noAddButton: PropTypes.bool,
	    noRemoveButton: PropTypes.bool
	  },
	
	  render: function render() {
	    var _this = this;
	
	    var _props2 = this.props;
	    var Item = _props2.item;
	    var value = _props2.value;
	    var className = _props2.className;
	    var noAddButton = _props2.noAddButton;
	    var noRemoveButton = _props2.noRemoveButton;
	    var onAdd = _props2.onAdd;
	    var onRemove = _props2.onRemove;
	    var noLabel = _props2.noLabel;
	    var label = _props2.label;
	    var hint = _props2.hint;
	
	    var props = _objectWithoutProperties(_props2, ['item', 'value', 'className', 'noAddButton', 'noRemoveButton', 'onAdd', 'onRemove', 'noLabel', 'label', 'hint']);
	
	    return React.createElement(
	      'div',
	      _extends({}, props, { className: cx('rf-RepeatingFieldset', className) }),
	      !noLabel && React.createElement(Label, {
	        className: 'rf-RepeatingFieldset__label',
	        label: label || value.node.props.get('label'),
	        hint: hint || value.node.props.get('hint')
	      }),
	      React.createElement(
	        'div',
	        { className: 'rf-RepeatingFieldset__items' },
	        value.map(function (value, key) {
	          var props = {
	            value: value,
	            key: key,
	            index: key,
	            ref: key,
	            noRemoveButton: noRemoveButton,
	            onRemove: _this.onRemove.bind(null, key),
	            children: React.createElement(Element, {
	              className: 'rf-RepeatingFieldset__child',
	              value: value
	            })
	          };
	          return React.isValidElement(Item) ? cloneWithProps(Item, props) : React.createElement(Item, props);
	        })
	      ),
	      !noAddButton && React.createElement(
	        'button',
	        {
	          type: 'button',
	          onClick: this.onAdd,
	          className: 'rf-RepeatingFieldset__add' },
	        'Add'
	      )
	    );
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      item: Item,
	      onAdd: emptyFunction,
	      onRemove: emptyFunction
	    };
	  },
	
	  onAdd: function onAdd() {
	    var newIdx = this.props.value.size;
	    var valueToAdd = defaultValue(this.props.value.node.get(newIdx));
	    this.props.value.transform(function (value) {
	      return value.push(valueToAdd);
	    });
	    this.props.onAdd();
	  },
	
	  onRemove: function onRemove(index) {
	    this.props.value.transform(function (value) {
	      return value.splice(index, 1);
	    });
	    this.props.onRemove(index);
	  },
	
	  getItemByIndex: function getItemByIndex(index) {
	    return this.refs[index];
	  }
	
	});
	
	module.exports = RepeatingFieldset;
	module.exports.Item = Item;

/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * 
	 * @copyright Prometheus Research, LLC 2014
	 */
	'use strict';
	
	var _objectWithoutProperties = __webpack_require__(53)['default'];
	
	var _extends = __webpack_require__(54)['default'];
	
	var React = __webpack_require__(40);
	var Hint = __webpack_require__(187);
	var cx = React.addons.classSet;
	
	var Label = React.createClass({
	  displayName: 'Label',
	
	  propTypes: {
	    label: React.PropTypes.string,
	    hint: React.PropTypes.string,
	    className: React.PropTypes.string
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var hint = _props.hint;
	    var label = _props.label;
	    var className = _props.className;
	
	    var props = _objectWithoutProperties(_props, ['hint', 'label', 'className']);
	
	    if (!hint && !label) {
	      return null;
	    }
	    return React.createElement(
	      'label',
	      _extends({}, props, { className: cx(className, 'rf-Label') }),
	      React.createElement(
	        'span',
	        { className: 'rf-Label__label' },
	        label
	      ),
	      hint && React.createElement(Hint, { hint: hint })
	    );
	  },
	
	  shouldComponentUpdate: function shouldComponentUpdate(nextProps) {
	    return nextProps.label !== this.props.label || nextProps.hint !== this.props.hint || nextProps.className !== this.props.className;
	  }
	});
	
	module.exports = Label;

/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * 
	 * @copyright Prometheus Research, LLC 2014
	 */
	'use strict';
	
	var _objectWithoutProperties = __webpack_require__(53)['default'];
	
	var _extends = __webpack_require__(54)['default'];
	
	var React = __webpack_require__(40);
	var PropTypes = React.PropTypes;
	var cx = React.addons.classSet;
	
	var Hint = React.createClass({
	  displayName: 'Hint',
	
	  propTypes: {
	    hint: PropTypes.string.isRequired,
	    className: PropTypes.string
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var hint = _props.hint;
	    var className = _props.className;
	
	    var props = _objectWithoutProperties(_props, ['hint', 'className']);
	
	    return React.createElement(
	      'span',
	      _extends({}, props, { className: cx('rf-Hint', className) }),
	      hint
	    );
	  }
	});
	
	module.exports = Hint;

/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @jsx React.DOM
	 * @copyright Prometheus Research, LLC 2014
	 */
	'use strict';
	
	var _objectWithoutProperties = __webpack_require__(53)['default'];
	
	var _extends = __webpack_require__(54)['default'];
	
	var React = __webpack_require__(40);
	var PropTypes = React.PropTypes;
	var cx = React.addons.classSet;
	var FormPropTypes = __webpack_require__(175);
	var Label = __webpack_require__(186);
	var Element = __webpack_require__(184);
	
	/**
	 * A component which renders a set of fields.
	 *
	 * It is used by <Form /> component at top level to render its fields.
	 */
	var Fieldset = React.createClass({
	  displayName: 'Fieldset',
	
	  propTypes: {
	    value: FormPropTypes.Value,
	    label: PropTypes.string,
	    noLabel: PropTypes.bool,
	    hint: PropTypes.string
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var value = _props.value;
	    var className = _props.className;
	    var label = _props.label;
	    var noLabel = _props.noLabel;
	    var hint = _props.hint;
	
	    var props = _objectWithoutProperties(_props, ['value', 'className', 'label', 'noLabel', 'hint']);
	
	    return React.createElement(
	      'div',
	      _extends({}, props, { className: cx(className, 'rf-Fieldset') }),
	      !noLabel && React.createElement(Label, {
	        className: 'rf-Fieldset__label',
	        label: label || value.node.props.get('label'),
	        hint: hint || value.node.props.get('hint')
	      }),
	      value.map(function (value, key) {
	        return React.createElement(Element, { key: key, value: value });
	      })
	    );
	  }
	});
	
	module.exports = Fieldset;

/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * 
	 * @copyright Prometheus Research, LLC 2014
	 */
	'use strict';
	
	var _objectWithoutProperties = __webpack_require__(53)['default'];
	
	var _extends = __webpack_require__(54)['default'];
	
	var React = __webpack_require__(40);
	var cx = React.addons.classSet;
	var PropTypes = __webpack_require__(175);
	var Message = __webpack_require__(190);
	var Label = __webpack_require__(186);
	var Input = __webpack_require__(191);
	var FocusStore = __webpack_require__(192);
	
	/**
	 * Field component represents values which correspond to Scalar schema nodes
	 * and so received PropetyValue as value.
	 *
	 * It provides basic markup which include <input /> component (can be customized
	 * via schema) and <label /> (label text and hint text).
	 */
	var Field = React.createClass({
	  displayName: 'Field',
	
	  mixins: [FocusStore.FocusableMixin],
	
	  propTypes: {
	    label: React.PropTypes.string,
	    hint: React.PropTypes.string,
	    value: PropTypes.Value,
	    input: React.PropTypes.oneOfType,
	    noLabel: React.PropTypes.bool
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var value = _props.value;
	    var hint = _props.hint;
	    var label = _props.label;
	    var noLabel = _props.noLabel;
	    var input = _props.input;
	    var className = _props.className;
	
	    var props = _objectWithoutProperties(_props, ['value', 'hint', 'label', 'noLabel', 'input', 'className']);
	
	    var node = value.node;
	    var validation = value.validation;
	    var isDirty = value.isDirty;
	    var externalValidation = value.externalValidation;
	
	    var isInvalid = isDirty && (validation.isFailure || externalValidation.isFailure);
	
	    var classNames = cx({
	      'rf-Field': true,
	      'rf-Field--invalid': isInvalid,
	      'rf-Field--dirty': isDirty,
	      'rf-Field--required': node.props.get('required')
	    });
	
	    var id = this._rootNodeID;
	
	    return React.createElement(
	      'div',
	      _extends({}, props, { className: cx(classNames, className) }),
	      !noLabel && React.createElement(Label, {
	        htmlFor: id,
	        className: 'rf-Field__label',
	        label: label || node.props.get('label'),
	        hint: hint || node.props.get('hint')
	      }),
	      React.createElement(Input, {
	        ref: 'input',
	        id: id,
	        value: value,
	        input: input,
	        dirtyOnBlur: node.props.get('dirtyOnBlur', true),
	        dirtyOnChange: node.props.get('dirtyOnChange', true)
	      }),
	      validation.isFailure && isDirty && React.createElement(
	        Message,
	        null,
	        validation.error
	      ),
	      externalValidation.isFailure && React.createElement(
	        Message,
	        null,
	        externalValidation.error
	      )
	    );
	  },
	
	  focus: function focus() {
	    this.refs.input.focus();
	  }
	});
	
	module.exports = Field;

/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * 
	 * @copyright Prometheus Research, LLC 2014
	 */
	'use strict';
	
	var _objectWithoutProperties = __webpack_require__(53)['default'];
	
	var _extends = __webpack_require__(54)['default'];
	
	var React = __webpack_require__(40);
	var cx = React.addons.classSet;
	
	var Message = React.createClass({
	  displayName: 'Message',
	
	  propTypes: {
	    className: React.PropTypes.string
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var className = _props.className;
	
	    var props = _objectWithoutProperties(_props, ['className']);
	
	    return React.createElement(
	      'span',
	      _extends({}, props, { className: cx('rf-Message', className) }),
	      this.props.children
	    );
	  }
	});
	
	module.exports = Message;

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * 
	 * @copyright Prometheus Research, LLC 2014
	 */
	'use strict';
	
	var _extends = __webpack_require__(54)['default'];
	
	var _objectWithoutProperties = __webpack_require__(53)['default'];
	
	var React = __webpack_require__(40);
	var cloneWithProps = React.addons.cloneWithProps;
	var FormPropTypes = __webpack_require__(175);
	
	var Input = React.createClass({
	  displayName: 'Input',
	
	  propTypes: {
	    value: FormPropTypes.Value.isRequired,
	    input: React.PropTypes.any,
	    markDirty: React.PropTypes.bool
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var Component = _props.input;
	    var value = _props.value;
	    var dirtyOnBlur = _props.dirtyOnBlur;
	
	    var props = _objectWithoutProperties(_props, ['input', 'value', 'dirtyOnBlur']);
	
	    props = _extends({}, props, {
	      ref: 'input',
	      value: value.serialized,
	      name: value.node.props.get('name') || value.keyPath.join('__'),
	      onChange: this.onChange,
	      onBlur: dirtyOnBlur && this.onBlur,
	      dirtyOnBlur: undefined,
	      dirtyOnChange: undefined
	    });
	    Component = Component || value.node.props.get('input');
	    if (Component) {
	      return React.isValidElement(Component) ? cloneWithProps(Component, props) : React.createElement(Component, props);
	    } else {
	      return React.createElement('input', _extends({}, props, { type: 'text' }));
	    }
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      dirtyOnBlur: true,
	      dirtyOnChange: true
	    };
	  },
	
	  focus: function focus() {
	    var input = this.refs.input;
	    if (input.focus) {
	      input.focus();
	    } else {
	      input.getDOMNode().focus();
	    }
	  },
	
	  onChange: function onChange(e) {
	    if (e && e.stopPropagation) {
	      e.stopPropagation();
	    }
	
	    var serialized = getValueFromEvent(e);
	    this.props.value.setSerialized(serialized, { dirty: this.props.dirtyOnChange });
	  },
	
	  onBlur: function onBlur() {
	    var value = this.props.value;
	
	    if (!value.isDirty) {
	      value.makeDirty();
	    }
	  }
	
	});
	
	/**
	 * Extract value from event
	 *
	 * We support both React.DOM 'change' events and custom change events
	 * emitted from custom components.
	 *
	 * @param {Event} e
	 * @returns {Any}
	 */
	function getValueFromEvent(e) {
	  return e && e.target && e.target.value !== undefined ? e.target.value : e;
	}
	
	module.exports = Input;

/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @copyright Prometheus Research, LLC 2014
	 */
	'use strict';
	
	var React = __webpack_require__(40);
	var Immutable = __webpack_require__(68);
	var invariant = __webpack_require__(179);
	
	var state = Immutable.Map();
	
	function getComponentFingerprint(component) {
	  return component._rootNodeID + '__' + component._mountDepth;
	}
	
	var ContextTypes = {
	  focusScope: React.PropTypes.object
	};
	
	var ScopeMixin = {
	
	  childContextTypes: ContextTypes,
	
	  getChildContext: function getChildContext() {
	    return { focusScope: this };
	  },
	
	  componentWillMount: function componentWillMount() {
	    FocusStore.registerScope(this);
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    FocusStore.unregisterScope(this);
	  },
	
	  /**
	   * Put focus on an element.
	   *
	   * @param {Array<String>} keyPath
	   */
	  focusElement: function focusElement(keyPath) {
	    FocusStore.focusElement(this, keyPath);
	  }
	
	};
	
	var FocusableMixin = {
	
	  contextTypes: ContextTypes,
	
	  _getFocusScope: function _getFocusScope() {
	    var focusScope = this.context.focusScope;
	    if (focusScope === undefined && typeof this.getFocusScope === 'function') {
	      focusScope = this.getFocusScope();
	    }
	    return focusScope;
	  },
	
	  _getKeyPath: function _getKeyPath() {
	    if (typeof this.getKeyPath === 'function') {
	      return this.getKeyPath();
	    } else {
	      return this.props.value.keyPath;
	    }
	  },
	
	  componentDidMount: function componentDidMount() {
	    var scope = this._getFocusScope();
	    if (!scope) {
	      return;
	    }
	    var keyPath = this._getKeyPath();
	    FocusStore.registerFocusable(scope, keyPath, this);
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    var scope = this._getFocusScope();
	    if (!scope) {
	      return;
	    }
	    var keyPath = this._getKeyPath();
	    FocusStore.unregisterFocusable(scope, keyPath, this);
	  }
	};
	
	var FocusStore = {
	
	  ScopeMixin: ScopeMixin,
	  FocusableMixin: FocusableMixin,
	
	  registerScope: function registerScope(scopeComponent) {
	    var scopeID = getComponentFingerprint(scopeComponent);
	    state = state.set(scopeID, Immutable.Map());
	  },
	
	  unregisterScope: function unregisterScope(scopeComponent) {
	    var scopeID = getComponentFingerprint(scopeComponent);
	    state = state.remove(scopeID);
	  },
	
	  registerFocusable: function registerFocusable(scopeComponent, keyPath, focusableComponent) {
	    var key = keyPath.join('.');
	    var scopeID = getComponentFingerprint(scopeComponent);
	    state = state.update(scopeID, function (scope) {
	      return scope.set(key, focusableComponent);
	    });
	  },
	
	  unregisterFocusable: function unregisterFocusable(scopeComponent, keyPath, focusableComponent) {
	    var key = keyPath.join('.');
	    var scopeID = getComponentFingerprint(scopeComponent);
	    state = state.updateIn(scopeID, function (scope) {
	      return scope && scope.remove(key);
	    });
	  },
	
	  focusElement: function focusElement(scopeComponent, keyPath) {
	    var key = keyPath.join('.');
	    var scopeID = getComponentFingerprint(scopeComponent);
	    var component = state.getIn([scopeID, key]);
	    if (typeof component.focus === 'function') {
	      component.focus();
	    } else {
	      var node = component.getDOMNode();
	      if (node) {
	        node.focus();
	      }
	    }
	  },
	
	  _getState: function _getState() {
	    return state;
	  }
	
	};
	
	module.exports = FocusStore;

/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _Object$assign = __webpack_require__(32)['default'];
	
	var React = __webpack_require__(40);
	var ReactForms = __webpack_require__(169);
	var Mapping = ReactForms.schema.Mapping;
	
	var i18n = __webpack_require__(61);
	var gettext = i18n.gettext;
	
	var Scalar = __webpack_require__(194);
	var scalars = __webpack_require__(198);
	var ToggleSelect = __webpack_require__(223);
	
	var buildLayout = __webpack_require__(224);
	
	var messages = {
	  CALL_RES: gettext('Call reservations on %(telephone_number)s'),
	  CALL_OTHER: gettext('Call our %(team_name)s team on %(telephone_number)s'),
	  EMAIL: gettext('Email'),
	  CALL: gettext('Call Me'),
	  MESSAGE_LABEL: gettext('Message'),
	  CONTACT_PREFERENCE_LABEL: gettext('How would you like us to contact you?')
	};
	
	var contactChoices = [{ value: 'email', name: messages.EMAIL }, { value: 'call', name: messages.CALL }];
	
	var contactMappings = {
	  'email': __webpack_require__(229).mapping,
	  'call': __webpack_require__(238).mapping
	};
	
	var buildSchema = function buildSchema(contactPreference, defaultValues) {
	  var Component = buildLayout(contactPreference);
	  var topicMapping = __webpack_require__(274).mapping(defaultValues);
	  var contactMapping = contactMappings[contactPreference](defaultValues);
	
	  var fields = _Object$assign(topicMapping, {
	    message: scalars.TextScalar({
	      label: messages.MESSAGE_LABEL
	    }),
	    contact_preference: Scalar({
	      label: messages.CONTACT_PREFERENCE_LABEL,
	      input: React.createElement(ToggleSelect, { options: contactChoices, className: 'ignore-react-onclickoutside' }),
	      defaultValue: 'email'
	    })
	  }, contactMapping);
	
	  return Mapping({ component: Component }, fields);
	};
	
	module.exports = buildSchema;

/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var React = __webpack_require__(40);
	var ReactForms = __webpack_require__(169);
	var Scalar = ReactForms.schema.Scalar;
	
	var BooleanField = __webpack_require__(195);
	var PriceInput = __webpack_require__(196);
	var Field = __webpack_require__(197);
	
	module.exports = function (props) {
	  var className;
	  var Component = Field;
	
	  if (!props.input && props.type === 'bool') {
	    Component = BooleanField;
	    props.input = React.createElement('input', { type: 'checkbox' });
	  } else if (!props.input && props.type === 'price') {
	    Component = Field;
	    props.type = 'string';
	    props.input = React.createElement(PriceInput, null);
	  } else if (!props.input) {
	    props.input = React.createElement('input', { type: 'text', className: 'ofs-Input ofs-Input--text' });
	  }
	
	  props.component = React.createElement(Component, { className: className });
	  return Scalar(props);
	};

/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _objectWithoutProperties = __webpack_require__(53)['default'];
	
	var _extends = __webpack_require__(54)['default'];
	
	var React = __webpack_require__(40);
	var cx = __webpack_require__(49);
	
	var ReactForms = __webpack_require__(169);
	var PropTypes = ReactForms.PropTypes;
	var Message = ReactForms.Message;
	var FocusStore = ReactForms.FocusStore;
	var Hint = __webpack_require__(187);
	
	var BooleanField = React.createClass({
	  displayName: 'BooleanField',
	
	  mixins: [FocusStore.FocusableMixin],
	
	  propTypes: {
	    label: React.PropTypes.string,
	    hint: React.PropTypes.string,
	    value: PropTypes.Value,
	    input: React.PropTypes.oneOfType,
	    noLabel: React.PropTypes.bool
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var value = _props.value;
	    var hint = _props.hint;
	    var label = _props.label;
	    var className = _props.className;
	
	    var props = _objectWithoutProperties(_props, ['value', 'hint', 'label', 'className']);
	
	    var node = value.node;
	    var validation = value.validation;
	    var isDirty = value.isDirty;
	    var externalValidation = value.externalValidation;
	
	    var isInvalid = isDirty && (validation.isFailure || externalValidation.isFailure);
	
	    var classNames = cx({
	      'ofs-Form__Field': true,
	      'ofs-Form__Field--inline': true,
	      'ofs-Form__Field--invalid': isInvalid,
	      'ofs-Form__Field--dirty': isDirty
	    });
	
	    var id = this._rootNodeID;
	
	    return React.createElement(
	      'div',
	      _extends({}, props, { className: cx(classNames, className), value: undefined }),
	      React.createElement(
	        'label',
	        { className: 'ofs-Form__Label ofs-Form__Label--no-bold' },
	        React.createElement('input', {
	          type: 'checkbox',
	          className: 'ofs-Input ofs-Input--checkbox',
	          ref: 'input',
	          id: id,
	          checked: value.value,
	          onBlur: this.onBlur,
	          onChange: this.onChange }),
	        React.createElement(
	          'div',
	          { className: 'ofs-Input__OptionLabel' },
	          label || node.props.get('label')
	        )
	      ),
	      hint || node.props.get('hint') ? React.createElement(Hint, { hint: hint || node.props.get('hint') }) : null,
	      validation.isFailure && isDirty && React.createElement(
	        Message,
	        null,
	        validation.error
	      ),
	      externalValidation.isFailure && React.createElement(
	        Message,
	        null,
	        externalValidation.error
	      )
	    );
	  },
	
	  focus: function focus() {
	    this.refs.input.focus();
	  },
	
	  onChange: function onChange(e) {
	    if (e.stopPropagation) {
	      e.stopPropagation();
	    }
	
	    var serialized = getValueFromEvent(e);
	    this.props.value.setSerialized(serialized);
	  },
	
	  onBlur: function onBlur() {
	    var value = this.props.value;
	
	    if (!value.isDirty) {
	      value.makeDirty();
	    }
	  }
	});
	
	/**
	 * Extract value from event
	 *
	 * We support both React.DOM 'change' events and custom change events
	 * emitted from custom components.
	 *
	 * @param {Event} e
	 * @returns {Any}
	 */
	function getValueFromEvent(e) {
	  return e && e.target && e.target.checked !== undefined ? e.target.checked : e;
	}
	
	module.exports = BooleanField;

/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _reactAddons = __webpack_require__(40);
	
	var _reactAddons2 = _interopRequireDefault(_reactAddons);
	
	var _classnames = __webpack_require__(49);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ofsComponentsSimpleChoiceSimpleChoice = __webpack_require__(47);
	
	var _ofsComponentsSimpleChoiceSimpleChoice2 = _interopRequireDefault(_ofsComponentsSimpleChoiceSimpleChoice);
	
	var PriceInput = _reactAddons2['default'].createClass({
	  displayName: 'PriceInput',
	
	  propTypes: {
	    value: _reactAddons2['default'].PropTypes.string,
	    onChange: _reactAddons2['default'].PropTypes.func.isRequired,
	    className: _reactAddons2['default'].PropTypes.string
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var value = _props.value;
	    var className = _props.className;
	
	    var currencyValue;
	    var numericValue;
	
	    if (value) {
	      currencyValue = value.slice(0, 3);
	      numericValue = value.slice(4);
	    }
	
	    var classes = {
	      'ofs-Input__Wrapper': true
	    };
	
	    if (className) {
	      classes[className] = true;
	    }
	
	    return _reactAddons2['default'].createElement(
	      'div',
	      { className: (0, _classnames2['default'])(classes) },
	      _reactAddons2['default'].createElement(
	        'div',
	        { className: 'ofs-Input__Prefix' },
	        _reactAddons2['default'].createElement(
	          _ofsComponentsSimpleChoiceSimpleChoice2['default'],
	          { ref: 'currency',
	            value: currencyValue, onChange: this.onChange },
	          _reactAddons2['default'].createElement(
	            'div',
	            { value: 'USD' },
	            '$ USD'
	          ),
	          _reactAddons2['default'].createElement(
	            'div',
	            { value: 'GBP' },
	            '£ GBP'
	          ),
	          _reactAddons2['default'].createElement(
	            'div',
	            { value: 'EUR' },
	            '€ EUR'
	          ),
	          _reactAddons2['default'].createElement(
	            'div',
	            { value: 'AUD' },
	            '$ AUD'
	          ),
	          _reactAddons2['default'].createElement(
	            'div',
	            { value: 'CAD' },
	            '$ CAD'
	          ),
	          _reactAddons2['default'].createElement(
	            'div',
	            { value: 'BRL' },
	            'R$ BRL'
	          ),
	          _reactAddons2['default'].createElement(
	            'div',
	            { value: 'INR' },
	            '₹ INR'
	          )
	        )
	      ),
	      _reactAddons2['default'].createElement(
	        'div',
	        { className: 'ofs-Input__Value' },
	        _reactAddons2['default'].createElement('input', { className: 'ofs-Input ofs-Input--text', ref: 'numeric',
	          type: 'number', onChange: this.onChange, value: numericValue })
	      )
	    );
	  },
	
	  onChange: function onChange() {
	    var currencyValue = this.refs['currency'].getSelectedValue();
	    var numericValue = this.refs['numeric'].getDOMNode().value;
	    var value = null;
	
	    // set default currency
	    if (!currencyValue) {
	      currencyValue = 'USD';
	    }
	
	    if (currencyValue && numericValue) {
	      value = currencyValue + '|' + numericValue;
	    }
	    this.props.onChange(value);
	  }
	});
	
	exports['default'] = PriceInput;
	module.exports = exports['default'];

/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _objectWithoutProperties = __webpack_require__(53)['default'];
	
	var _extends = __webpack_require__(54)['default'];
	
	var React = __webpack_require__(40);
	var cx = __webpack_require__(49);
	
	var ReactForms = __webpack_require__(169);
	var PropTypes = ReactForms.PropTypes;
	var Message = ReactForms.Message;
	var Label = ReactForms.Label;
	var Input = ReactForms.Input;
	var FocusStore = ReactForms.FocusStore;
	var Hint = __webpack_require__(187);
	
	var Field = React.createClass({
	  displayName: 'Field',
	
	  mixins: [FocusStore.FocusableMixin],
	
	  propTypes: {
	    label: React.PropTypes.string,
	    hint: React.PropTypes.string,
	    value: PropTypes.Value,
	    input: React.PropTypes.oneOfType,
	    noLabel: React.PropTypes.bool
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var value = _props.value;
	    var hint = _props.hint;
	    var label = _props.label;
	    var noLabel = _props.noLabel;
	    var input = _props.input;
	    var className = _props.className;
	
	    var props = _objectWithoutProperties(_props, ['value', 'hint', 'label', 'noLabel', 'input', 'className']);
	
	    var node = value.node;
	    var validation = value.validation;
	    var isDirty = value.isDirty;
	    var externalValidation = value.externalValidation;
	
	    var isInvalid = isDirty && (validation.isFailure || externalValidation.isFailure);
	    var required = node.props.get('required');
	
	    var classNames = cx({
	      'ofs-Form__Field': true,
	      'ofs-Form__Field--invalid': isInvalid,
	      'ofs-Form__Field--dirty': isDirty,
	      'ofs-Form__Field--required': required
	    });
	
	    var id = this._rootNodeID;
	
	    var label = label || node.props.get('label');
	
	    if (required && typeof label !== 'undefined') {
	      label += '*';
	    }
	
	    return React.createElement(
	      'div',
	      _extends({}, props, { className: cx(classNames, className), value: undefined }),
	      !noLabel && React.createElement(Label, {
	        htmlFor: id,
	        className: 'ofs-Form__Label',
	        label: label
	      }),
	      React.createElement(Input, {
	        ref: 'input',
	        id: id,
	        value: value,
	        input: input,
	        dirtyOnBlur: node.props.get('dirtyOnBlur', true),
	        dirtyOnChange: node.props.get('dirtyOnChange', true)
	      }),
	      hint || node.props.get('hint') ? React.createElement(Hint, { hint: hint || node.props.get('hint') }) : null,
	      validation.isFailure && isDirty && React.createElement(
	        Message,
	        null,
	        validation.error
	      ),
	      externalValidation.isFailure && React.createElement(
	        Message,
	        null,
	        externalValidation.error
	      )
	    );
	  },
	
	  focus: function focus() {
	    this.refs.input.focus();
	  }
	});
	
	module.exports = Field;

/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = {
	  //ArrayScalar: require('./ArrayeNode').ArrayScalar,
	  //BoolScalar: require('./BoolNode').BoolScalar,
	  //CharScalar: require('./CharNode').CharScalar,
	  DateScalar: __webpack_require__(199),
	  //EmailScalar: require('./EmailNode').EmailScalar,
	  //PriceScalar: require('./PriceNode').PriceScalar,
	  TextScalar: __webpack_require__(222)
	};

/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var React = __webpack_require__(40);
	var ReactForms = __webpack_require__(169);
	var DateNode = ReactForms.schema.DateNode;
	var createNode = ReactForms.schema.createNode;
	var DateSelect = __webpack_require__(200);
	
	var Field = __webpack_require__(197);
	
	function DateScalar(props) {
	  props.input = props.input || React.createElement(DateSelect, { placeholder: props.placeholder });
	  props.type = 'date';
	  props.component = Field;
	  return createNode(DateNode, props);
	}
	
	module.exports = DateScalar;

/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _objectWithoutProperties = __webpack_require__(53)['default'];
	
	var _extends = __webpack_require__(54)['default'];
	
	var React = __webpack_require__(40);
	var cx = __webpack_require__(49);
	var $ = __webpack_require__(39);
	var moment = __webpack_require__(57);
	var Fluxxor = __webpack_require__(69);
	var FluxMixin = Fluxxor.FluxMixin(React);
	
	var DatePicker = __webpack_require__(201);
	var Icon = __webpack_require__(51);
	
	var DateSelect = React.createClass({
	  displayName: 'DateSelect',
	
	  mixins: [FluxMixin],
	
	  showPicker: function showPicker() {
	    var trigger = $(this.refs.input.getDOMNode());
	
	    var yesterday = new Date();
	    yesterday.setDate(yesterday.getDate() - 1);
	
	    this.getFlux().actions.layers.addPopover(React.createElement(DatePicker, {
	      selectionType: 'single',
	      trigger: trigger,
	      onSelect: this.handleSelect,
	      minimumDate: yesterday,
	      value: this.props.value ? moment(this.props.value) : null }));
	  },
	
	  handleSelect: function handleSelect(value) {
	    var _this = this;
	
	    setTimeout(function () {
	      _this.props.onChange(value.isoDateFormat());
	      _this.getFlux().actions.layers.remove();
	    }, 0);
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var placeholder = _props.placeholder;
	    var value = _props.value;
	
	    var props = _objectWithoutProperties(_props, ['placeholder', 'value']);
	
	    var displayValue = null;
	    if (value) {
	      displayValue = moment(value).longDateFormat();
	    }
	
	    var inputClasses = cx({
	      'ofs-Input': true,
	      'ofs-Input--date': true
	    });
	
	    return React.createElement(
	      'div',
	      { className: 'ofs-Input__Wrapper' },
	      React.createElement('input', _extends({ type: 'hidden', value: value }, props)),
	      React.createElement(
	        'div',
	        { onClick: this.showPicker, className: inputClasses, ref: 'input' },
	        displayValue ? React.createElement(
	          'span',
	          { className: 'value' },
	          displayValue
	        ) : React.createElement(
	          'span',
	          { className: 'ofs-Input__Placeholder' },
	          placeholder || 'Select a date'
	        )
	      ),
	      React.createElement(
	        'div',
	        { className: 'ofs-Input__Icon', onClick: this.showPicker },
	        React.createElement(Icon, { glyph: 'calendar', size: 'small' })
	      )
	    );
	  }
	});
	
	module.exports = DateSelect;

/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(54)['default'];
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(40);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDaterangePicker = __webpack_require__(202);
	
	var _reactDaterangePicker2 = _interopRequireDefault(_reactDaterangePicker);
	
	var _DatePickerPaginationArrow = __webpack_require__(219);
	
	var _DatePickerPaginationArrow2 = _interopRequireDefault(_DatePickerPaginationArrow);
	
	var _ofsI18n = __webpack_require__(61);
	
	var _ofsI18n2 = _interopRequireDefault(_ofsI18n);
	
	var gettext = _ofsI18n2['default'].gettext;
	
	var messages = {
	  SELECTED_LABEL: gettext("Your selected dates")
	};
	
	var DatePicker = _react2['default'].createClass({
	  displayName: 'DatePicker',
	
	  render: function render() {
	    return _react2['default'].createElement(_reactDaterangePicker2['default'], _extends({
	      bemNamespace: 'ofs',
	      bemBlock: 'DatePicker',
	      firstOfWeek: 1,
	      paginationArrowComponent: _DatePickerPaginationArrow2['default'],
	      selectedLabel: messages.SELECTED_LABEL
	    }, this.props));
	  }
	});
	
	exports['default'] = DatePicker;
	module.exports = exports['default'];

/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reactAddons = __webpack_require__(40);
	
	var _reactAddons2 = _interopRequireDefault(_reactAddons);
	
	var _moment = __webpack_require__(58);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__(60);
	
	var _immutable = __webpack_require__(68);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _calendar = __webpack_require__(203);
	
	var _calendar2 = _interopRequireDefault(_calendar);
	
	var _utilsBemMixin = __webpack_require__(204);
	
	var _utilsBemMixin2 = _interopRequireDefault(_utilsBemMixin);
	
	var _utilsCustomPropTypes = __webpack_require__(206);
	
	var _utilsCustomPropTypes2 = _interopRequireDefault(_utilsCustomPropTypes);
	
	var _Legend = __webpack_require__(208);
	
	var _Legend2 = _interopRequireDefault(_Legend);
	
	var _calendarCalendarMonth = __webpack_require__(209);
	
	var _calendarCalendarMonth2 = _interopRequireDefault(_calendarCalendarMonth);
	
	var _calendarCalendarDate = __webpack_require__(213);
	
	var _calendarCalendarDate2 = _interopRequireDefault(_calendarCalendarDate);
	
	var _PaginationArrow = __webpack_require__(218);
	
	var _PaginationArrow2 = _interopRequireDefault(_PaginationArrow);
	
	var _utilsIsMomentRange = __webpack_require__(207);
	
	var _utilsIsMomentRange2 = _interopRequireDefault(_utilsIsMomentRange);
	
	var PureRenderMixin = _reactAddons2['default'].addons.PureRenderMixin;
	var absoluteMinimum = (0, _moment2['default'])(new Date(-8640000000000000 / 2)).startOf('day');
	var absoluteMaximum = (0, _moment2['default'])(new Date(8640000000000000 / 2)).startOf('day');
	
	_reactAddons2['default'].initializeTouchEvents(true);
	
	function noop() {}
	
	var DateRangePicker = _reactAddons2['default'].createClass({
	  displayName: 'DateRangePicker',
	
	  mixins: [_utilsBemMixin2['default'], PureRenderMixin],
	
	  propTypes: {
	    bemBlock: _reactAddons2['default'].PropTypes.string,
	    bemNamespace: _reactAddons2['default'].PropTypes.string,
	    dateStates: _reactAddons2['default'].PropTypes.array, // an array of date ranges and their states
	    defaultState: _reactAddons2['default'].PropTypes.string,
	    disableNavigation: _reactAddons2['default'].PropTypes.bool,
	    firstOfWeek: _reactAddons2['default'].PropTypes.oneOf([0, 1, 2, 3, 4, 5, 6]),
	    helpMessage: _reactAddons2['default'].PropTypes.string,
	    initialDate: _reactAddons2['default'].PropTypes.instanceOf(Date),
	    initialFromValue: _reactAddons2['default'].PropTypes.bool,
	    initialMonth: _reactAddons2['default'].PropTypes.number, // Overrides values derived from initialDate/initialRange
	    initialRange: _reactAddons2['default'].PropTypes.object,
	    initialYear: _reactAddons2['default'].PropTypes.number, // Overrides values derived from initialDate/initialRange
	    maximumDate: _reactAddons2['default'].PropTypes.instanceOf(Date),
	    minimumDate: _reactAddons2['default'].PropTypes.instanceOf(Date),
	    numberOfCalendars: _reactAddons2['default'].PropTypes.number,
	    onHighlightDate: _reactAddons2['default'].PropTypes.func, // triggered when a date is highlighted (hovered)
	    onHighlightRange: _reactAddons2['default'].PropTypes.func, // triggered when a range is highlighted (hovered)
	    onSelect: _reactAddons2['default'].PropTypes.func, // triggered when a date or range is selectec
	    onSelectStart: _reactAddons2['default'].PropTypes.func, // triggered when the first date in a range is selected
	    paginationArrowComponent: _reactAddons2['default'].PropTypes.func,
	    selectedLabel: _reactAddons2['default'].PropTypes.string,
	    selectionType: _reactAddons2['default'].PropTypes.oneOf(['single', 'range']),
	    singleDateRange: _reactAddons2['default'].PropTypes.bool,
	    showLegend: _reactAddons2['default'].PropTypes.bool,
	    stateDefinitions: _reactAddons2['default'].PropTypes.object,
	    value: _utilsCustomPropTypes2['default'].momentOrMomentRange
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    var date = new Date();
	    var initialDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
	
	    return {
	      bemNamespace: null,
	      bemBlock: 'DateRangePicker',
	      numberOfCalendars: 1,
	      firstOfWeek: 0,
	      disableNavigation: false,
	      nextLabel: '',
	      previousLabel: '',
	      initialDate: initialDate,
	      initialFromValue: true,
	      selectionType: 'range',
	      singleDateRange: false,
	      stateDefinitions: {
	        '__default': {
	          color: null,
	          selectable: true,
	          label: null
	        }
	      },
	      selectedLabel: "Your selected dates",
	      defaultState: '__default',
	      dateStates: [],
	      showLegend: false,
	      onSelect: noop,
	      paginationArrowComponent: _PaginationArrow2['default']
	    };
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    var nextDateStates = this.getDateStates(nextProps);
	    var nextEnabledRange = this.getEnabledRange(nextProps);
	
	    this.setState({
	      dateStates: this.state.dateStates && _immutable2['default'].is(this.state.dateStates, nextDateStates) ? this.state.dateStates : nextDateStates,
	      enabledRange: this.state.enabledRange && this.state.enabledRange.isSame(nextEnabledRange) ? this.state.enabledRange : nextEnabledRange
	    });
	  },
	
	  getInitialState: function getInitialState() {
	    var now = new Date();
	    var _props = this.props;
	    var initialYear = _props.initialYear;
	    var initialMonth = _props.initialMonth;
	    var initialFromValue = _props.initialFromValue;
	    var selectionType = _props.selectionType;
	    var value = _props.value;
	
	    var year = now.getFullYear();
	    var month = now.getMonth();
	
	    if (initialYear && initialMonth) {
	      year = initialYear;
	      month = initialMonth;
	    }
	
	    if (initialFromValue && value) {
	      if (selectionType === 'single') {
	        year = value.year();
	        month = value.month();
	      } else {
	        year = value.start.year();
	        month = value.start.month();
	      }
	    }
	
	    return {
	      year: year,
	      month: month,
	      selectedStartDate: null,
	      highlightStartDate: null,
	      highlightedDate: null,
	      highlightRange: null,
	      hideSelection: false,
	      enabledRange: this.getEnabledRange(this.props),
	      dateStates: this.getDateStates(this.props)
	    };
	  },
	
	  getEnabledRange: function getEnabledRange(props) {
	    var min = props.minimumDate ? (0, _moment2['default'])(props.minimumDate).startOf('day') : absoluteMinimum;
	    var max = props.maximumDate ? (0, _moment2['default'])(props.maximumDate).startOf('day') : absoluteMaximum;
	
	    return _moment2['default'].range(min, max);
	  },
	
	  getDateStates: function getDateStates(props) {
	    var dateStates = props.dateStates;
	    var defaultState = props.defaultState;
	    var stateDefinitions = props.stateDefinitions;
	
	    var actualStates = [];
	    var minDate = absoluteMinimum;
	    var maxDate = absoluteMaximum;
	    var dateCursor = (0, _moment2['default'])(minDate).startOf('day');
	
	    var defs = _immutable2['default'].fromJS(stateDefinitions);
	
	    dateStates.forEach(function (s) {
	      var r = s.range;
	      var start = r.start.startOf('day');
	      var end = r.end.startOf('day');
	
	      if (!dateCursor.isSame(start, 'day')) {
	        actualStates.push({
	          state: defaultState,
	          range: _moment2['default'].range(dateCursor, start)
	        });
	      }
	      actualStates.push(s);
	      dateCursor = end;
	    });
	
	    actualStates.push({
	      state: defaultState,
	      range: _moment2['default'].range(dateCursor, maxDate)
	    });
	
	    // sanitize date states
	    return _immutable2['default'].List(actualStates).map(function (s) {
	      var def = defs.get(s.state);
	      return _immutable2['default'].Map({
	        range: s.range,
	        state: s.state,
	        selectable: def.get('selectable', true),
	        color: def.get('color')
	      });
	    });
	  },
	
	  isDateDisabled: function isDateDisabled(date) {
	    return !this.state.enabledRange.contains(date);
	  },
	
	  isDateSelectable: function isDateSelectable(date) {
	    return this.dateRangesForDate(date).some(function (r) {
	      return r.get('selectable');
	    });
	  },
	
	  nonSelectableStateRanges: function nonSelectableStateRanges() {
	    return this.state.dateStates.filter(function (d) {
	      return !d.get('selectable');
	    });
	  },
	
	  dateRangesForDate: function dateRangesForDate(date) {
	    return this.state.dateStates.filter(function (d) {
	      return d.get('range').contains(date);
	    });
	  },
	
	  sanitizeRange: function sanitizeRange(range, forwards) {
	    /* Truncates the provided range at the first intersection
	     * with a non-selectable state. Using forwards to determine
	     * which direction to work
	     */
	    var blockedRanges = this.nonSelectableStateRanges().map(function (r) {
	      return r.get('range');
	    });
	    var intersect = undefined;
	
	    if (forwards) {
	      intersect = blockedRanges.find(function (r) {
	        return range.intersect(r);
	      });
	      if (intersect) {
	        return _moment2['default'].range(range.start, intersect.start);
	      }
	    } else {
	      intersect = blockedRanges.findLast(function (r) {
	        return range.intersect(r);
	      });
	
	      if (intersect) {
	        return _moment2['default'].range(intersect.end, range.end);
	      }
	    }
	
	    if (range.start.isBefore(this.state.enabledRange.start)) {
	      return _moment2['default'].range(this.state.enabledRange.start, range.end);
	    }
	
	    if (range.end.isAfter(this.state.enabledRange.end)) {
	      return _moment2['default'].range(range.start, this.state.enabledRange.end);
	    }
	
	    return range;
	  },
	
	  highlightRange: function highlightRange(range) {
	    this.setState({
	      highlightedRange: range,
	      highlightedDate: null
	    });
	    if (typeof this.props.onHighlightRange === 'function') {
	      this.props.onHighlightRange(range, this.statesForRange(range));
	    }
	  },
	
	  onUnHighlightDate: function onUnHighlightDate() {
	    this.setState({
	      highlightedDate: null
	    });
	  },
	
	  onSelectDate: function onSelectDate(date) {
	    var selectionType = this.props.selectionType;
	    var selectedStartDate = this.state.selectedStartDate;
	
	    if (selectionType === 'range') {
	      if (selectedStartDate) {
	        this.completeRangeSelection();
	      } else if (!this.isDateDisabled(date) && this.isDateSelectable(date)) {
	        this.startRangeSelection(date);
	        if (this.props.singleDateRange) {
	          this.highlightRange(_moment2['default'].range(date, date));
	        }
	      }
	    } else {
	      if (!this.isDateDisabled(date) && this.isDateSelectable(date)) {
	        this.completeSelection();
	      }
	    }
	  },
	
	  onHighlightDate: function onHighlightDate(date) {
	    var selectionType = this.props.selectionType;
	    var selectedStartDate = this.state.selectedStartDate;
	
	    var datePair = undefined;
	    var range = undefined;
	    var forwards = undefined;
	
	    if (selectionType === 'range') {
	      if (selectedStartDate) {
	        datePair = _immutable2['default'].List.of(selectedStartDate, date).sortBy(function (d) {
	          return d.unix();
	        });
	        range = _moment2['default'].range(datePair.get(0), datePair.get(1));
	        forwards = range.start.unix() === selectedStartDate.unix();
	        range = this.sanitizeRange(range, forwards);
	        this.highlightRange(range);
	      } else if (!this.isDateDisabled(date) && this.isDateSelectable(date)) {
	        this.highlightDate(date);
	      }
	    } else {
	      if (!this.isDateDisabled(date) && this.isDateSelectable(date)) {
	        this.highlightDate(date);
	      }
	    }
	  },
	
	  startRangeSelection: function startRangeSelection(date) {
	    this.setState({
	      hideSelection: true,
	      selectedStartDate: date
	    });
	    if (typeof this.props.onSelectStart === 'function') {
	      this.props.onSelectStart((0, _moment2['default'])(date));
	    }
	  },
	
	  statesForDate: function statesForDate(date) {
	    return this.state.dateStates.filter(function (d) {
	      return date.within(d.get('range'));
	    }).map(function (d) {
	      return d.get('state');
	    });
	  },
	
	  statesForRange: function statesForRange(range) {
	    if (range.start.isSame(range.end, 'day')) {
	      return this.statesForDate(range.start);
	    }
	    return this.state.dateStates.filter(function (d) {
	      return d.get('range').intersect(range);
	    }).map(function (d) {
	      return d.get('state');
	    });
	  },
	
	  completeSelection: function completeSelection() {
	    var highlightedDate = this.state.highlightedDate;
	    if (highlightedDate) {
	      this.setState({
	        hideSelection: false,
	        highlightedDate: null
	      });
	      this.props.onSelect(highlightedDate, this.statesForDate(highlightedDate));
	    }
	  },
	
	  completeRangeSelection: function completeRangeSelection() {
	    var range = this.state.highlightedRange;
	
	    if (range && (!range.start.isSame(range.end, 'day') || this.props.singleDateRange)) {
	      this.setState({
	        selectedStartDate: null,
	        highlightedRange: null,
	        highlightedDate: null,
	        hideSelection: false
	      });
	      this.props.onSelect(range, this.statesForRange(range));
	    }
	  },
	
	  highlightDate: function highlightDate(date) {
	    this.setState({
	      highlightedDate: date
	    });
	    if (typeof this.props.onHighlightDate === 'function') {
	      this.props.onHighlightDate(date, this.statesForDate(date));
	    }
	  },
	
	  getMonthDate: function getMonthDate() {
	    return (0, _moment2['default'])(new Date(this.state.year, this.state.month, 1));
	  },
	
	  canMoveBack: function canMoveBack() {
	    if (this.getMonthDate().subtract(1, 'days').isBefore(this.state.enabledRange.start)) {
	      return false;
	    }
	    return true;
	  },
	
	  moveBack: function moveBack() {
	    var monthDate = undefined;
	
	    if (this.canMoveBack()) {
	      monthDate = this.getMonthDate();
	      monthDate.subtract(1, 'months');
	      this.setState({
	        year: monthDate.year(),
	        month: monthDate.month()
	      });
	    }
	  },
	
	  canMoveForward: function canMoveForward() {
	    if (this.getMonthDate().add(this.props.numberOfCalendars, 'months').isAfter(this.state.enabledRange.end)) {
	      return false;
	    }
	    return true;
	  },
	
	  moveForward: function moveForward() {
	    var monthDate = undefined;
	
	    if (this.canMoveForward()) {
	      monthDate = this.getMonthDate();
	      monthDate.add(1, 'months');
	      this.setState({
	        year: monthDate.year(),
	        month: monthDate.month()
	      });
	    }
	  },
	
	  changeYear: function changeYear(year) {
	    var _state = this.state;
	    var enabledRange = _state.enabledRange;
	    var month = _state.month;
	
	    if ((0, _moment2['default'])({ years: year, months: month, date: 1 }).unix() < enabledRange.start.unix()) {
	      month = enabledRange.start.month();
	    }
	
	    if ((0, _moment2['default'])({ years: year, months: month + 1, date: 1 }).unix() > enabledRange.end.unix()) {
	      month = enabledRange.end.month();
	    }
	
	    this.setState({
	      year: year,
	      month: month
	    });
	  },
	
	  changeMonth: function changeMonth(date) {
	    this.setState({
	      month: date
	    });
	  },
	
	  renderCalendar: function renderCalendar(index) {
	    var _props2 = this.props;
	    var bemBlock = _props2.bemBlock;
	    var bemNamespace = _props2.bemNamespace;
	    var firstOfWeek = _props2.firstOfWeek;
	    var numberOfCalendars = _props2.numberOfCalendars;
	    var selectionType = _props2.selectionType;
	    var value = _props2.value;
	    var _state2 = this.state;
	    var dateStates = _state2.dateStates;
	    var enabledRange = _state2.enabledRange;
	    var hideSelection = _state2.hideSelection;
	    var highlightedDate = _state2.highlightedDate;
	    var highlightedRange = _state2.highlightedRange;
	
	    var monthDate = this.getMonthDate();
	    var year = monthDate.year();
	    var month = monthDate.month();
	    var key = index + '-' + year + '-' + month;
	    var props = undefined;
	
	    monthDate.add(index, 'months');
	
	    var cal = new _calendar2['default'].Calendar(firstOfWeek);
	    var monthDates = _immutable2['default'].fromJS(cal.monthDates(monthDate.year(), monthDate.month()));
	    var monthStart = monthDates.first().first();
	    var monthEnd = monthDates.last().last();
	    var monthRange = _moment2['default'].range(monthStart, monthEnd);
	
	    if (_moment2['default'].isMoment(value)) {
	      if (!monthRange.contains(value)) {
	        value = null;
	      }
	    } else if ((0, _utilsIsMomentRange2['default'])(value)) {
	      if (!monthRange.overlaps(value)) {
	        value = null;
	      }
	    }
	
	    if (!_moment2['default'].isMoment(highlightedDate) || !monthRange.contains(highlightedDate)) {
	      highlightedDate = null;
	    }
	
	    if (!(0, _utilsIsMomentRange2['default'])(highlightedRange) || !monthRange.overlaps(highlightedRange)) {
	      highlightedRange = null;
	    }
	
	    props = {
	      bemBlock: bemBlock,
	      bemNamespace: bemNamespace,
	      dateStates: dateStates,
	      enabledRange: enabledRange,
	      firstOfWeek: firstOfWeek,
	      hideSelection: hideSelection,
	      highlightedDate: highlightedDate,
	      highlightedRange: highlightedRange,
	      index: index,
	      key: key,
	      selectionType: selectionType,
	      value: value,
	      maxIndex: numberOfCalendars - 1,
	      firstOfMonth: monthDate,
	      onMonthChange: this.changeMonth,
	      onYearChange: this.changeYear,
	      onSelectDate: this.onSelectDate,
	      onHighlightDate: this.onHighlightDate,
	      onUnHighlightDate: this.onUnHighlightDate,
	      dateRangesForDate: this.dateRangesForDate,
	      dateComponent: _calendarCalendarDate2['default']
	    };
	
	    return _reactAddons2['default'].createElement(_calendarCalendarMonth2['default'], props);
	  },
	
	  render: function render() {
	    var _props3 = this.props;
	    var PaginationArrowComponent = _props3.paginationArrowComponent;
	    var numberOfCalendars = _props3.numberOfCalendars;
	    var stateDefinitions = _props3.stateDefinitions;
	    var selectedLabel = _props3.selectedLabel;
	    var showLegend = _props3.showLegend;
	    var helpMessage = _props3.helpMessage;
	
	    var calendars = _immutable2['default'].Range(0, numberOfCalendars).map(this.renderCalendar);
	
	    return _reactAddons2['default'].createElement(
	      'div',
	      { className: this.cx({ element: null }) },
	      _reactAddons2['default'].createElement(PaginationArrowComponent, { direction: 'previous', onTrigger: this.moveBack, disabled: !this.canMoveBack() }),
	      calendars.toJS(),
	      _reactAddons2['default'].createElement(PaginationArrowComponent, { direction: 'next', onTrigger: this.moveForward, disabled: !this.canMoveForward() }),
	      helpMessage ? _reactAddons2['default'].createElement(
	        'span',
	        { className: this.cx({ element: 'HelpMessage' }) },
	        helpMessage
	      ) : null,
	      showLegend ? _reactAddons2['default'].createElement(_Legend2['default'], { stateDefinitions: stateDefinitions, selectedLabel: selectedLabel }) : null
	    );
	  }
	});
	
	exports['default'] = DateRangePicker;
	module.exports = exports['default'];

/***/ },
/* 203 */
/***/ function(module, exports) {

	/*!
	 * calendar: a port of the calendar module from Python
	 * Copyright(c) 2011 Luciano Ramalho <luciano@ramalho.org>
	 * MIT Licensed
	 */
	
	exports.version = '0.1.0';
	
	var CalendarException = function CalendarException(message) {
	   this.message = message;
	   this.toString = function() {
	      return this.constructor.name + ": " + this.message
	   };
	}
	
	var Calendar = function Calendar(firstWeekDay) {
	    //properties
	    this.firstWeekDay = firstWeekDay || 0; // 0 = Sunday
	};
	
	Calendar.prototype = {
	    constructor : Calendar,
	    weekStartDate : function weekStartDate(date) {
	        var startDate = new Date(date.getTime());
	        while (startDate.getDay() !== this.firstWeekDay) {
	            startDate.setDate(startDate.getDate() - 1);
	        }
	        return startDate;
	    },
	    monthDates : function monthDates(year, month, dayFormatter, weekFormatter) {
	        if ((typeof year !== "number") || (year < 1970)) {
	            throw new CalendarException('year must be a number >= 1970');
	        };
	        if ((typeof month !== "number") || (month < 0) || (month > 11)) {
	            throw new CalendarException('month must be a number (Jan is 0)');
	        };
	        var weeks = [],
	            week = [],
	            i = 0,
	            date = this.weekStartDate(new Date(year, month, 1));
	        do {
	            for (i=0; i<7; i++) {
	                week.push(dayFormatter ? dayFormatter(date) : date);
	                date = new Date(date.getTime());
	                date.setDate(date.getDate() + 1);
	            }
	            weeks.push(weekFormatter ? weekFormatter(week) : week);
	            week = [];
	        } while ((date.getMonth()<=month) && (date.getFullYear()===year));
	        return weeks;
	    },
	    monthDays : function monthDays(year, month) {
	        var getDayOrZero = function getDayOrZero(date) {
	            return date.getMonth() === month ? date.getDate() : 0;
	        };
	        return this.monthDates(year, month, getDayOrZero);
	    },
	    monthText : function monthText(year, month) {
	        if (typeof year === "undefined") {
	            var now = new Date();
	            year = now.getFullYear();
	            month = now.getMonth();
	        };
	        var getDayOrBlank = function getDayOrBlank(date) {
	            var s = date.getMonth() === month ? date.getDate().toString() : "  ";
	            while (s.length < 2) s = " "+s;
	            return s;
	        };
	        var weeks = this.monthDates(year, month, getDayOrBlank,
	            function (week) { return week.join(" ") });
	        return weeks.join("\n");
	    }
	};
	var months = "JAN FEB MAR APR MAY JUN JUL AUG SEP OCT NOV DEC".split(" ");
	for (var i=0; i<months.length; i++)
	    Calendar[months[i]] = i;
	
	exports.Calendar = Calendar;


/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(40);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bemCx = __webpack_require__(205);
	
	var _bemCx2 = _interopRequireDefault(_bemCx);
	
	var BemMixin = {
	  propTypes: {
	    bemNamespace: _react2['default'].PropTypes.string,
	    bemBlock: _react2['default'].PropTypes.string
	  },
	
	  contextTypes: {
	    bemNamespace: _react2['default'].PropTypes.string,
	    bemBlock: _react2['default'].PropTypes.string
	  },
	
	  childContextTypes: {
	    bemNamespace: _react2['default'].PropTypes.string,
	    bemBlock: _react2['default'].PropTypes.string
	  },
	
	  getChildContext: function getChildContext() {
	    return {
	      bemNamespace: this.getBemNamespace(),
	      bemBlock: this.getBemBlock()
	    };
	  },
	
	  getBemNamespace: function getBemNamespace() {
	    if (this.props.bemNamespace) {
	      return this.props.bemNamespace;
	    }
	    if (this.context.bemNamespace) {
	      return this.context.bemNamespace;
	    }
	    return null;
	  },
	
	  getBemBlock: function getBemBlock() {
	    if (this.props.bemBlock) {
	      return this.props.bemBlock;
	    }
	    if (this.context.bemBlock) {
	      return this.context.bemBlock;
	    }
	    return null;
	  },
	
	  cx: function cx() {
	    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var opts = {
	      namespace: this.getBemNamespace(),
	      element: this.constructor.displayName,
	      block: this.getBemBlock()
	    };
	
	    _extends(opts, options);
	    return (0, _bemCx2['default'])(opts);
	  }
	};
	
	exports['default'] = BemMixin;
	module.exports = exports['default'];

/***/ },
/* 205 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = bemCx;
	
	function bemCx() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	  var block = options.block;
	  var element = options.element;
	  var namespace = options.namespace;
	  var modifiers = options.modifiers;
	  var states = options.states;
	
	  var bemClasses = [];
	  var baseClassName = undefined;
	
	  if (element) {
	    if (namespace) {
	      baseClassName = namespace + '-' + block + '__' + element;
	    } else {
	      baseClassName = block + '__' + element;
	    }
	  } else {
	    if (namespace) {
	      baseClassName = namespace + '-' + block;
	    } else {
	      baseClassName = block;
	    }
	  }
	
	  bemClasses.push(baseClassName);
	
	  if (states) {
	    if (typeof states === 'object') {
	      states = Object.keys(states).filter(function (s) {
	        return states[s];
	      });
	    }
	
	    states.forEach(function (state) {
	      bemClasses.push(baseClassName + '--is-' + state);
	    });
	  }
	
	  if (modifiers) {
	    if (typeof modifiers === 'object') {
	      modifiers = Object.keys(modifiers).filter(function (m) {
	        return modifiers[m];
	      });
	    }
	
	    modifiers.forEach(function (modifier) {
	      bemClasses.push(baseClassName + '--' + modifier);
	
	      if (states) {
	        states.forEach(function (state) {
	          bemClasses.push(baseClassName + '--' + modifier + '--is-' + state);
	        });
	      }
	    });
	  }
	
	  return bemClasses.join(' ');
	}
	
	module.exports = exports['default'];

/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _moment2 = __webpack_require__(58);
	
	var _moment3 = _interopRequireDefault(_moment2);
	
	__webpack_require__(60);
	
	var _isMomentRange = __webpack_require__(207);
	
	var _isMomentRange2 = _interopRequireDefault(_isMomentRange);
	
	exports['default'] = {
	  momentOrMomentRange: function momentOrMomentRange(props, propName) {
	    var val = props[propName];
	
	    if (!val) {
	      return null;
	    } else if (_moment3['default'].isMoment(val)) {
	      return null;
	    } else if ((0, _isMomentRange2['default'])(val)) {
	      return null;
	    }
	    return new Error('\'' + propName + '\' must be a moment or a moment range');
	  },
	
	  moment: function moment(props, propName) {
	    var val = props[propName];
	
	    if (!val) {
	      return null;
	    } else if (_moment3['default'].isMoment(val)) {
	      return null;
	    }
	    return new Error('\'' + propName + '\' must be a moment');
	  },
	
	  momentRange: function momentRange(props, propName) {
	    var val = props[propName];
	
	    if (!val) {
	      return null;
	    } else if ((0, _isMomentRange2['default'])(val)) {
	      return null;
	    }
	    return new Error('\'' + propName + '\' must be a moment range');
	  }
	};
	module.exports = exports['default'];

/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = isMomentRange;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _moment = __webpack_require__(58);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__(60);
	
	function isMomentRange(val) {
	  return val && val.start && val.end && _moment2['default'].isMoment(val.start) && _moment2['default'].isMoment(val.end);
	}
	
	module.exports = exports['default'];

/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reactAddons = __webpack_require__(40);
	
	var _reactAddons2 = _interopRequireDefault(_reactAddons);
	
	var _utilsBemMixin = __webpack_require__(204);
	
	var _utilsBemMixin2 = _interopRequireDefault(_utilsBemMixin);
	
	var PureRenderMixin = _reactAddons2['default'].addons.PureRenderMixin;
	
	var Legend = _reactAddons2['default'].createClass({
	  displayName: 'Legend',
	
	  mixins: [_utilsBemMixin2['default'], PureRenderMixin],
	
	  propTypes: {
	    selectedLabel: _reactAddons2['default'].PropTypes.string.isRequired,
	    stateDefinitions: _reactAddons2['default'].PropTypes.object.isRequired
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var selectedLabel = _props.selectedLabel;
	    var stateDefinitions = _props.stateDefinitions;
	
	    var items = [];
	    var name = undefined;
	    var def = undefined;
	    var style = undefined;
	
	    for (name in stateDefinitions) {
	      def = stateDefinitions[name];
	      if (def.label && def.color) {
	        style = {
	          backgroundColor: def.color
	        };
	        items.push(_reactAddons2['default'].createElement(
	          'li',
	          { className: this.cx({ element: 'LegendItem' }), key: name },
	          _reactAddons2['default'].createElement('span', { className: this.cx({ element: 'LegendItemColor' }), style: style }),
	          _reactAddons2['default'].createElement(
	            'span',
	            { className: this.cx({ element: 'LegendItemLabel' }) },
	            def.label
	          )
	        ));
	      }
	    }
	
	    return _reactAddons2['default'].createElement(
	      'ul',
	      { className: this.cx() },
	      _reactAddons2['default'].createElement(
	        'li',
	        { className: this.cx({ element: 'LegendItem' }) },
	        _reactAddons2['default'].createElement('span', { className: this.cx({ element: 'LegendItemColor', modifiers: { 'selection': true } }) }),
	        _reactAddons2['default'].createElement(
	          'span',
	          { className: this.cx({ element: 'LegendItemLabel' }) },
	          selectedLabel
	        )
	      ),
	      items
	    );
	  }
	});
	
	exports['default'] = Legend;
	module.exports = exports['default'];

/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var _reactAddons = __webpack_require__(40);
	
	var _reactAddons2 = _interopRequireDefault(_reactAddons);
	
	var _moment = __webpack_require__(58);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__(60);
	
	var _calendar = __webpack_require__(203);
	
	var _calendar2 = _interopRequireDefault(_calendar);
	
	var _immutable = __webpack_require__(68);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _utilsBemMixin = __webpack_require__(204);
	
	var _utilsBemMixin2 = _interopRequireDefault(_utilsBemMixin);
	
	var _utilsCustomPropTypes = __webpack_require__(206);
	
	var _utilsCustomPropTypes2 = _interopRequireDefault(_utilsCustomPropTypes);
	
	var _utilsIsMomentRange = __webpack_require__(207);
	
	var _utilsIsMomentRange2 = _interopRequireDefault(_utilsIsMomentRange);
	
	var _utilsPureRenderMixin = __webpack_require__(210);
	
	var _utilsPureRenderMixin2 = _interopRequireDefault(_utilsPureRenderMixin);
	
	var lang = (0, _moment2['default'])().localeData();
	
	var WEEKDAYS = _immutable2['default'].List(lang._weekdays).zip(_immutable2['default'].List(lang._weekdaysShort));
	var MONTHS = _immutable2['default'].List(lang._months);
	
	var CalendarMonth = _reactAddons2['default'].createClass({
	  displayName: 'CalendarMonth',
	
	  mixins: [_utilsBemMixin2['default'], _utilsPureRenderMixin2['default']],
	
	  propTypes: {
	    dateComponent: _reactAddons2['default'].PropTypes.func,
	    disableNavigation: _reactAddons2['default'].PropTypes.bool,
	    enabledRange: _utilsCustomPropTypes2['default'].momentRange,
	    firstOfMonth: _utilsCustomPropTypes2['default'].moment,
	    firstOfWeek: _reactAddons2['default'].PropTypes.oneOf([0, 1, 2, 3, 4, 5, 6]),
	    hideSelection: _reactAddons2['default'].PropTypes.bool,
	    highlightedDate: _reactAddons2['default'].PropTypes.object,
	    highlightedRange: _reactAddons2['default'].PropTypes.object,
	    onMonthChange: _reactAddons2['default'].PropTypes.func,
	    onYearChange: _reactAddons2['default'].PropTypes.func,
	    value: _utilsCustomPropTypes2['default'].momentOrMomentRange
	  },
	
	  renderDay: function renderDay(date, i) {
	    var _props = this.props;
	    var CalendarDate = _props.dateComponent;
	    var value = _props.value;
	    var highlightedDate = _props.highlightedDate;
	    var highlightedRange = _props.highlightedRange;
	    var hideSelection = _props.hideSelection;
	    var enabledRange = _props.enabledRange;
	
	    var props = _objectWithoutProperties(_props, ['dateComponent', 'value', 'highlightedDate', 'highlightedRange', 'hideSelection', 'enabledRange']);
	
	    var d = (0, _moment2['default'])(date);
	
	    var isInSelectedRange = undefined;
	    var isSelectedDate = undefined;
	    var isSelectedRangeStart = undefined;
	    var isSelectedRangeEnd = undefined;
	
	    if (!hideSelection && value && _moment2['default'].isMoment(value) && value.isSame(d, 'day')) {
	      isSelectedDate = true;
	    } else if (!hideSelection && value && (0, _utilsIsMomentRange2['default'])(value) && value.contains(d)) {
	      isInSelectedRange = true;
	
	      isSelectedRangeStart = value.start.isSame(d, 'day');
	      isSelectedRangeEnd = value.end.isSame(d, 'day');
	    }
	
	    return _reactAddons2['default'].createElement(CalendarDate, _extends({
	      key: i,
	      isToday: d.isSame((0, _moment2['default'])(), 'day'),
	      isDisabled: !enabledRange.contains(d),
	      isHighlightedDate: !!(highlightedDate && highlightedDate.isSame(d, 'day')),
	      isHighlightedRangeStart: !!(highlightedRange && highlightedRange.start.isSame(d, 'day')),
	      isHighlightedRangeEnd: !!(highlightedRange && highlightedRange.end.isSame(d, 'day')),
	      isInHighlightedRange: !!(highlightedRange && highlightedRange.contains(d)),
	      isSelectedDate: isSelectedDate,
	      isSelectedRangeStart: isSelectedRangeStart,
	      isSelectedRangeEnd: isSelectedRangeEnd,
	      isInSelectedRange: isInSelectedRange,
	      date: d
	    }, props));
	  },
	
	  renderWeek: function renderWeek(dates, i) {
	    var days = dates.map(this.renderDay);
	    return _reactAddons2['default'].createElement(
	      'tr',
	      { className: this.cx({ element: 'Week' }), key: i },
	      days.toJS()
	    );
	  },
	
	  renderDayHeaders: function renderDayHeaders() {
	    var firstOfWeek = this.props.firstOfWeek;
	
	    var indices = _immutable2['default'].Range(firstOfWeek, 7).concat(_immutable2['default'].Range(0, firstOfWeek));
	
	    var headers = indices.map((function (index) {
	      var weekday = WEEKDAYS.get(index);
	      return _reactAddons2['default'].createElement(
	        'th',
	        { className: this.cx({ element: 'WeekdayHeading' }), key: weekday, scope: 'col' },
	        _reactAddons2['default'].createElement(
	          'abbr',
	          { title: weekday[0] },
	          weekday[1]
	        )
	      );
	    }).bind(this));
	
	    return _reactAddons2['default'].createElement(
	      'tr',
	      { className: this.cx({ element: 'Weekdays' }) },
	      headers.toJS()
	    );
	  },
	
	  handleYearChange: function handleYearChange(event) {
	    this.props.onYearChange(parseInt(event.target.value, 10));
	  },
	
	  renderYearChoice: function renderYearChoice(year) {
	    var enabledRange = this.props.enabledRange;
	
	    if (year < enabledRange.start.year()) {
	      return null;
	    }
	
	    if (year > enabledRange.end.year()) {
	      return null;
	    }
	
	    return _reactAddons2['default'].createElement(
	      'option',
	      { key: year, value: year },
	      year
	    );
	  },
	
	  renderHeaderYear: function renderHeaderYear() {
	    var firstOfMonth = this.props.firstOfMonth;
	
	    var y = firstOfMonth.year();
	    var years = _immutable2['default'].Range(y - 5, y).concat(_immutable2['default'].Range(y, y + 10));
	    var choices = years.map(this.renderYearChoice);
	    var modifiers = { year: true };
	
	    return _reactAddons2['default'].createElement(
	      'span',
	      { className: this.cx({ element: 'MonthHeaderLabel', modifiers: modifiers }) },
	      firstOfMonth.format('YYYY'),
	      this.props.disableNavigation ? null : _reactAddons2['default'].createElement(
	        'select',
	        { className: this.cx({ element: 'MonthHeaderSelect' }), value: y, onChange: this.handleYearChange },
	        choices.toJS()
	      )
	    );
	  },
	
	  handleMonthChange: function handleMonthChange(event) {
	    this.props.onMonthChange(parseInt(event.target.value, 10));
	  },
	
	  renderMonthChoice: function renderMonthChoice(month, i) {
	    var _props2 = this.props;
	    var firstOfMonth = _props2.firstOfMonth;
	    var enabledRange = _props2.enabledRange;
	
	    var disabled = false;
	    var year = firstOfMonth.year();
	
	    if ((0, _moment2['default'])({ years: year, months: i + 1, date: 1 }).unix() < enabledRange.start.unix()) {
	      disabled = true;
	    }
	
	    if ((0, _moment2['default'])({ years: year, months: i, date: 1 }).unix() > enabledRange.end.unix()) {
	      disabled = true;
	    }
	
	    return _reactAddons2['default'].createElement(
	      'option',
	      { key: month, value: i, disabled: disabled ? 'disabled' : null },
	      month
	    );
	  },
	
	  renderHeaderMonth: function renderHeaderMonth() {
	    var firstOfMonth = this.props.firstOfMonth;
	
	    var choices = MONTHS.map(this.renderMonthChoice);
	    var modifiers = { month: true };
	
	    return _reactAddons2['default'].createElement(
	      'span',
	      { className: this.cx({ element: 'MonthHeaderLabel', modifiers: modifiers }) },
	      firstOfMonth.format('MMMM'),
	      this.props.disableNavigation ? null : _reactAddons2['default'].createElement(
	        'select',
	        { className: this.cx({ element: 'MonthHeaderSelect' }), value: firstOfMonth.month(), onChange: this.handleMonthChange },
	        choices.toJS()
	      )
	    );
	  },
	
	  renderHeader: function renderHeader() {
	    return _reactAddons2['default'].createElement(
	      'div',
	      { className: this.cx({ element: 'MonthHeader' }) },
	      this.renderHeaderMonth(),
	      ' ',
	      this.renderHeaderYear()
	    );
	  },
	
	  render: function render() {
	    var _props3 = this.props;
	    var firstOfWeek = _props3.firstOfWeek;
	    var firstOfMonth = _props3.firstOfMonth;
	
	    var cal = new _calendar2['default'].Calendar(firstOfWeek);
	    var monthDates = _immutable2['default'].fromJS(cal.monthDates(firstOfMonth.year(), firstOfMonth.month()));
	    var weeks = monthDates.map(this.renderWeek);
	
	    return _reactAddons2['default'].createElement(
	      'div',
	      { className: this.cx({ element: 'Month' }) },
	      this.renderHeader(),
	      _reactAddons2['default'].createElement(
	        'table',
	        { className: this.cx({ element: 'MonthDates' }) },
	        _reactAddons2['default'].createElement(
	          'thead',
	          null,
	          this.renderDayHeaders()
	        ),
	        _reactAddons2['default'].createElement(
	          'tbody',
	          null,
	          weeks.toJS()
	        )
	      )
	    );
	  }
	});
	
	exports['default'] = CalendarMonth;
	module.exports = exports['default'];

/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _utilsShallowEqual = __webpack_require__(211);
	
	var _utilsShallowEqual2 = _interopRequireDefault(_utilsShallowEqual);
	
	var PureRenderMixin = {
	  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
	    return !(0, _utilsShallowEqual2['default'])(this.props, nextProps) || !(0, _utilsShallowEqual2['default'])(this.state, nextState);
	  }
	};
	
	exports['default'] = PureRenderMixin;
	module.exports = exports['default'];

/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _moment = __webpack_require__(58);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__(60);
	
	var _areMomentRangesEqual = __webpack_require__(212);
	
	var _areMomentRangesEqual2 = _interopRequireDefault(_areMomentRangesEqual);
	
	var _isMomentRange = __webpack_require__(207);
	
	var _isMomentRange2 = _interopRequireDefault(_isMomentRange);
	
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	  var key;
	
	  // Test for A's keys different from B.
	  for (key in objA) {
	    if (objA.hasOwnProperty(key)) {
	      if (!objB.hasOwnProperty(key)) {
	        return false;
	      } else if (_moment2['default'].isMoment(objA[key]) && _moment2['default'].isMoment(objB[key])) {
	        if (!objA[key].isSame(objB[key], 'day')) {
	          return false;
	        }
	      } else if ((0, _isMomentRange2['default'])(objA[key]) && (0, _isMomentRange2['default'])(objB[key]) && !(0, _areMomentRangesEqual2['default'])(objA[key], objB[key])) {
	        return false;
	      } else if (objA[key] !== objB[key]) {
	        return false;
	      }
	    }
	  }
	
	  // Test for B's keys missing from A.
	  for (key in objB) {
	    if (objB.hasOwnProperty(key) && !objA.hasOwnProperty(key)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	exports['default'] = shallowEqual;
	module.exports = exports['default'];

/***/ },
/* 212 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = areMomentRangesEqual;
	
	function areMomentRangesEqual(r1, r2) {
	  return r1.start.isSame(r2.start, 'day') && r1.end.isSame(r2.end, 'day');
	}
	
	module.exports = exports['default'];

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reactAddons = __webpack_require__(40);
	
	var _reactAddons2 = _interopRequireDefault(_reactAddons);
	
	var _immutable = __webpack_require__(68);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _utilsBemMixin = __webpack_require__(204);
	
	var _utilsBemMixin2 = _interopRequireDefault(_utilsBemMixin);
	
	var _utilsCustomPropTypes = __webpack_require__(206);
	
	var _utilsCustomPropTypes2 = _interopRequireDefault(_utilsCustomPropTypes);
	
	var _utilsPureRenderMixin = __webpack_require__(210);
	
	var _utilsPureRenderMixin2 = _interopRequireDefault(_utilsPureRenderMixin);
	
	var _utilsLightenDarkenColor = __webpack_require__(214);
	
	var _utilsLightenDarkenColor2 = _interopRequireDefault(_utilsLightenDarkenColor);
	
	var _CalendarDatePeriod = __webpack_require__(215);
	
	var _CalendarDatePeriod2 = _interopRequireDefault(_CalendarDatePeriod);
	
	var _CalendarHighlight = __webpack_require__(216);
	
	var _CalendarHighlight2 = _interopRequireDefault(_CalendarHighlight);
	
	var _CalendarSelection = __webpack_require__(217);
	
	var _CalendarSelection2 = _interopRequireDefault(_CalendarSelection);
	
	var CalendarDate = _reactAddons2['default'].createClass({
	  displayName: 'CalendarDate',
	
	  mixins: [_utilsBemMixin2['default'], _utilsPureRenderMixin2['default']],
	
	  propTypes: {
	    date: _utilsCustomPropTypes2['default'].moment,
	
	    firstOfMonth: _reactAddons2['default'].PropTypes.object.isRequired,
	
	    isSelectedDate: _reactAddons2['default'].PropTypes.bool,
	    isSelectedRangeStart: _reactAddons2['default'].PropTypes.bool,
	    isSelectedRangeEnd: _reactAddons2['default'].PropTypes.bool,
	    isInSelectedRange: _reactAddons2['default'].PropTypes.bool,
	
	    isHighlightedDate: _reactAddons2['default'].PropTypes.bool,
	    isHighlightedRangeStart: _reactAddons2['default'].PropTypes.bool,
	    isHighlightedRangeEnd: _reactAddons2['default'].PropTypes.bool,
	    isInHighlightedRange: _reactAddons2['default'].PropTypes.bool,
	
	    highlightedDate: _reactAddons2['default'].PropTypes.object,
	    dateStates: _reactAddons2['default'].PropTypes.instanceOf(_immutable2['default'].List),
	    isDisabled: _reactAddons2['default'].PropTypes.bool,
	    isToday: _reactAddons2['default'].PropTypes.bool,
	
	    dateRangesForDate: _reactAddons2['default'].PropTypes.func,
	    onHighlightDate: _reactAddons2['default'].PropTypes.func,
	    onUnHighlightDate: _reactAddons2['default'].PropTypes.func,
	    onSelectDate: _reactAddons2['default'].PropTypes.func
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      mouseDown: false
	    };
	  },
	
	  mouseUp: function mouseUp() {
	    this.props.onSelectDate(this.props.date);
	
	    if (this.state.mouseDown) {
	      this.setState({
	        mouseDown: false
	      });
	    }
	    document.removeEventListener('mouseup', this.mouseUp);
	  },
	
	  mouseDown: function mouseDown() {
	    this.setState({
	      mouseDown: true
	    });
	    document.addEventListener('mouseup', this.mouseUp);
	  },
	
	  touchEnd: function touchEnd() {
	    this.props.onHighlightDate(this.props.date);
	    this.props.onSelectDate(this.props.date);
	
	    if (this.state.mouseDown) {
	      this.setState({
	        mouseDown: false
	      });
	    }
	    document.removeEventListener('touchend', this.touchEnd);
	  },
	
	  touchStart: function touchStart(event) {
	    event.preventDefault();
	    this.setState({
	      mouseDown: true
	    });
	    document.addEventListener('touchend', this.touchEnd);
	  },
	
	  mouseEnter: function mouseEnter() {
	    this.props.onHighlightDate(this.props.date);
	  },
	
	  mouseLeave: function mouseLeave() {
	    if (this.state.mouseDown) {
	      this.props.onSelectDate(this.props.date);
	
	      this.setState({
	        mouseDown: false
	      });
	    }
	    this.props.onUnHighlightDate(this.props.date);
	  },
	
	  getBemModifiers: function getBemModifiers() {
	    var _props = this.props;
	    var date = _props.date;
	    var firstOfMonth = _props.firstOfMonth;
	    var today = _props.isToday;
	
	    var otherMonth = false;
	    var weekend = false;
	
	    if (date.month() !== firstOfMonth.month()) {
	      otherMonth = true;
	    }
	
	    if (date.day() === 0 || date.day() === 6) {
	      weekend = true;
	    }
	
	    return { today: today, weekend: weekend, otherMonth: otherMonth };
	  },
	
	  getBemStates: function getBemStates() {
	    var _props2 = this.props;
	    var isSelectedDate = _props2.isSelectedDate;
	    var isInSelectedRange = _props2.isInSelectedRange;
	    var isInHighlightedRange = _props2.isInHighlightedRange;
	    var highlighted = _props2.isHighlightedDate;
	    var disabled = _props2.isDisabled;
	
	    var selected = isSelectedDate || isInSelectedRange || isInHighlightedRange;
	
	    return { disabled: disabled, highlighted: highlighted, selected: selected };
	  },
	
	  render: function render() {
	    var _props3 = this.props;
	    var date = _props3.date;
	    var dateRangesForDate = _props3.dateRangesForDate;
	    var isSelectedDate = _props3.isSelectedDate;
	    var isSelectedRangeStart = _props3.isSelectedRangeStart;
	    var isSelectedRangeEnd = _props3.isSelectedRangeEnd;
	    var isInSelectedRange = _props3.isInSelectedRange;
	    var isHighlightedDate = _props3.isHighlightedDate;
	    var isHighlightedRangeStart = _props3.isHighlightedRangeStart;
	    var isHighlightedRangeEnd = _props3.isHighlightedRangeEnd;
	    var isInHighlightedRange = _props3.isInHighlightedRange;
	
	    var bemModifiers = this.getBemModifiers();
	    var bemStates = this.getBemStates();
	    var pending = isInHighlightedRange;
	
	    var color = undefined;
	    var amColor = undefined;
	    var pmColor = undefined;
	    var states = dateRangesForDate(date);
	    var numStates = states.count();
	    var cellStyle = {};
	    var style = {};
	
	    var highlightModifier = undefined;
	    var selectionModifier = undefined;
	
	    if (isSelectedDate || isSelectedRangeStart && isSelectedRangeEnd || isHighlightedRangeStart && isHighlightedRangeEnd) {
	      selectionModifier = 'single';
	    } else if (isSelectedRangeStart || isHighlightedRangeStart) {
	      selectionModifier = 'start';
	    } else if (isSelectedRangeEnd || isHighlightedRangeEnd) {
	      selectionModifier = 'end';
	    } else if (isInSelectedRange || isInHighlightedRange) {
	      selectionModifier = 'segment';
	    }
	
	    if (isHighlightedDate) {
	      highlightModifier = 'single';
	    }
	
	    if (numStates === 1) {
	      // If there's only one state, it means we're not at a boundary
	      color = states.getIn([0, 'color']);
	
	      if (color) {
	
	        style = {
	          backgroundColor: color
	        };
	        cellStyle = {
	          borderLeftColor: (0, _utilsLightenDarkenColor2['default'])(color, -10),
	          borderRightColor: (0, _utilsLightenDarkenColor2['default'])(color, -10)
	        };
	      }
	    } else {
	      amColor = states.getIn([0, 'color']);
	      pmColor = states.getIn([1, 'color']);
	
	      if (amColor) {
	        cellStyle.borderLeftColor = (0, _utilsLightenDarkenColor2['default'])(amColor, -10);
	      }
	
	      if (pmColor) {
	        cellStyle.borderRightColor = (0, _utilsLightenDarkenColor2['default'])(pmColor, -10);
	      }
	    }
	
	    return _reactAddons2['default'].createElement(
	      'td',
	      { className: this.cx({ element: 'Date', modifiers: bemModifiers, states: bemStates }),
	        style: cellStyle,
	        onTouchStart: this.touchStart,
	        onMouseEnter: this.mouseEnter,
	        onMouseLeave: this.mouseLeave,
	        onMouseDown: this.mouseDown },
	      numStates > 1 && _reactAddons2['default'].createElement(
	        'div',
	        { className: this.cx({ element: "HalfDateStates" }) },
	        _reactAddons2['default'].createElement(_CalendarDatePeriod2['default'], { period: 'am', color: amColor }),
	        _reactAddons2['default'].createElement(_CalendarDatePeriod2['default'], { period: 'pm', color: pmColor })
	      ),
	      numStates === 1 && _reactAddons2['default'].createElement('div', { className: this.cx({ element: "FullDateStates" }), style: style }),
	      _reactAddons2['default'].createElement(
	        'span',
	        { className: this.cx({ element: "DateLabel" }) },
	        date.format('D')
	      ),
	      selectionModifier ? _reactAddons2['default'].createElement(_CalendarSelection2['default'], { modifier: selectionModifier, pending: pending }) : null,
	      highlightModifier ? _reactAddons2['default'].createElement(_CalendarHighlight2['default'], { modifier: highlightModifier }) : null
	    );
	  }
	});
	
	exports['default'] = CalendarDate;
	module.exports = exports['default'];

/***/ },
/* 214 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = lightenDarkenColor;
	
	function lightenDarkenColor(col, amt) {
	  var usePound = false;
	  var num = undefined;
	  var r = undefined;
	  var b = undefined;
	  var g = undefined;
	
	  if (col[0] === "#") {
	    col = col.slice(1);
	    usePound = true;
	  }
	
	  num = parseInt(col, 16);
	
	  r = (num >> 16) + amt;
	
	  if (r > 255) {
	    r = 255;
	  } else if (r < 0) {
	    r = 0;
	  }
	
	  b = (num >> 8 & 0x00FF) + amt;
	
	  if (b > 255) {
	    b = 255;
	  } else if (b < 0) {
	    b = 0;
	  }
	
	  g = (num & 0x0000FF) + amt;
	
	  if (g > 255) {
	    g = 255;
	  } else if (g < 0) {
	    g = 0;
	  }
	
	  return (usePound ? "#" : "") + (g | b << 8 | r << 16).toString(16);
	}
	
	module.exports = exports["default"];

/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var _reactAddons = __webpack_require__(40);
	
	var _reactAddons2 = _interopRequireDefault(_reactAddons);
	
	var _utilsBemMixin = __webpack_require__(204);
	
	var _utilsBemMixin2 = _interopRequireDefault(_utilsBemMixin);
	
	var _utilsPureRenderMixin = __webpack_require__(210);
	
	var _utilsPureRenderMixin2 = _interopRequireDefault(_utilsPureRenderMixin);
	
	var CalendarDatePeriod = _reactAddons2['default'].createClass({
	  displayName: 'CalendarDatePeriod',
	
	  mixins: [_utilsBemMixin2['default'], _utilsPureRenderMixin2['default']],
	
	  propTypes: {
	    color: _reactAddons2['default'].PropTypes.string,
	    period: _reactAddons2['default'].PropTypes.string
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var color = _props.color;
	    var period = _props.period;
	
	    var modifiers = _defineProperty({}, period, true);
	    var style = undefined;
	
	    if (color) {
	      style = { backgroundColor: color };
	    }
	
	    return _reactAddons2['default'].createElement('div', { style: style, className: this.cx({ modifiers: modifiers }) });
	  }
	});
	
	exports['default'] = CalendarDatePeriod;
	module.exports = exports['default'];

/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var _reactAddons = __webpack_require__(40);
	
	var _reactAddons2 = _interopRequireDefault(_reactAddons);
	
	var _utilsBemMixin = __webpack_require__(204);
	
	var _utilsBemMixin2 = _interopRequireDefault(_utilsBemMixin);
	
	var _utilsPureRenderMixin = __webpack_require__(210);
	
	var _utilsPureRenderMixin2 = _interopRequireDefault(_utilsPureRenderMixin);
	
	var CalendarHighlight = _reactAddons2['default'].createClass({
	  displayName: 'CalendarHighlight',
	
	  mixins: [_utilsBemMixin2['default'], _utilsPureRenderMixin2['default']],
	
	  propTypes: {
	    modifier: _reactAddons2['default'].PropTypes.string
	  },
	
	  render: function render() {
	    var modifier = this.props.modifier;
	
	    var modifiers = _defineProperty({}, modifier, true);
	    var states = {};
	
	    return _reactAddons2['default'].createElement('div', { className: this.cx({ states: states, modifiers: modifiers }) });
	  }
	});
	
	exports['default'] = CalendarHighlight;
	module.exports = exports['default'];

/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var _reactAddons = __webpack_require__(40);
	
	var _reactAddons2 = _interopRequireDefault(_reactAddons);
	
	var _utilsBemMixin = __webpack_require__(204);
	
	var _utilsBemMixin2 = _interopRequireDefault(_utilsBemMixin);
	
	var _utilsPureRenderMixin = __webpack_require__(210);
	
	var _utilsPureRenderMixin2 = _interopRequireDefault(_utilsPureRenderMixin);
	
	var CalendarSelection = _reactAddons2['default'].createClass({
	  displayName: 'CalendarSelection',
	
	  mixins: [_utilsBemMixin2['default'], _utilsPureRenderMixin2['default']],
	
	  propTypes: {
	    modifier: _reactAddons2['default'].PropTypes.string,
	    pending: _reactAddons2['default'].PropTypes.bool.isRequired
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var modifier = _props.modifier;
	    var pending = _props.pending;
	
	    var modifiers = _defineProperty({}, modifier, true);
	    var states = {
	      pending: pending
	    };
	
	    return _reactAddons2['default'].createElement('div', { className: this.cx({ states: states, modifiers: modifiers }) });
	  }
	});
	
	exports['default'] = CalendarSelection;
	module.exports = exports['default'];

/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var _reactAddons = __webpack_require__(40);
	
	var _reactAddons2 = _interopRequireDefault(_reactAddons);
	
	var _utilsBemMixin = __webpack_require__(204);
	
	var _utilsBemMixin2 = _interopRequireDefault(_utilsBemMixin);
	
	var PureRenderMixin = _reactAddons2['default'].addons.PureRenderMixin;
	
	var PaginationArrow = _reactAddons2['default'].createClass({
	  displayName: 'PaginationArrow',
	
	  mixins: [_utilsBemMixin2['default'], PureRenderMixin],
	
	  propTypes: {
	    disabled: _reactAddons2['default'].PropTypes.bool,
	    onTrigger: _reactAddons2['default'].PropTypes.func,
	    direction: _reactAddons2['default'].PropTypes.oneOf(['next', 'previous'])
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      disabled: false
	    };
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var disabled = _props.disabled;
	    var direction = _props.direction;
	    var onTrigger = _props.onTrigger;
	
	    var props = _objectWithoutProperties(_props, ['disabled', 'direction', 'onTrigger']);
	
	    var modifiers = _defineProperty({}, direction, true);
	    var states = { disabled: disabled };
	
	    var elementOpts = {
	      modifiers: modifiers,
	      states: states
	    };
	
	    var iconOpts = {
	      element: 'PaginationArrowIcon',
	      modifiers: modifiers,
	      states: states
	    };
	
	    return _reactAddons2['default'].createElement(
	      'div',
	      _extends({ className: this.cx(elementOpts) }, props, { onClick: onTrigger }),
	      _reactAddons2['default'].createElement('div', { className: this.cx(iconOpts) })
	    );
	  }
	});
	
	exports['default'] = PaginationArrow;
	module.exports = exports['default'];

/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _defineProperty = __webpack_require__(52)['default'];
	
	var _objectWithoutProperties = __webpack_require__(53)['default'];
	
	var _extends = __webpack_require__(54)['default'];
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _reactAddons = __webpack_require__(40);
	
	var _reactAddons2 = _interopRequireDefault(_reactAddons);
	
	var _BemMixin = __webpack_require__(220);
	
	var _BemMixin2 = _interopRequireDefault(_BemMixin);
	
	var _commonIcon = __webpack_require__(51);
	
	var _commonIcon2 = _interopRequireDefault(_commonIcon);
	
	var PureRenderMixin = _reactAddons2['default'].addons.PureRenderMixin;
	
	var DatePickerPaginationArrow = _reactAddons2['default'].createClass({
	  displayName: 'DatePickerPaginationArrow',
	
	  mixins: [_BemMixin2['default'], PureRenderMixin],
	
	  render: function render() {
	    var _props = this.props;
	    var disabled = _props.disabled;
	    var direction = _props.direction;
	    var onTrigger = _props.onTrigger;
	
	    var props = _objectWithoutProperties(_props, ['disabled', 'direction', 'onTrigger']);
	
	    var modifiers = _defineProperty({}, direction, true);
	    var states = { disabled: disabled };
	
	    var elementOpts = {
	      element: "PaginationArrow",
	      modifiers: modifiers,
	      states: states
	    };
	
	    var iconOpts = {
	      element: "PaginationArrowIcon",
	      modifiers: modifiers,
	      states: states
	    };
	
	    return _reactAddons2['default'].createElement(
	      'div',
	      _extends({ className: this.cx(elementOpts) }, props, { onClick: onTrigger }),
	      _reactAddons2['default'].createElement(
	        'div',
	        { className: this.cx(iconOpts) },
	        _reactAddons2['default'].createElement(_commonIcon2['default'], { glyph: 'arrow', size: 'small', variant: direction === 'previous' ? 'left' : 'right' })
	      )
	    );
	  }
	});
	
	exports['default'] = DatePickerPaginationArrow;
	module.exports = exports['default'];

/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _Object$assign = __webpack_require__(32)['default'];
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(40);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bemCx = __webpack_require__(221);
	
	var _bemCx2 = _interopRequireDefault(_bemCx);
	
	var BemMixin = {
	  propTypes: {
	    bemNamespace: _react2['default'].PropTypes.string,
	    bemBlock: _react2['default'].PropTypes.string
	  },
	
	  contextTypes: {
	    bemNamespace: _react2['default'].PropTypes.string,
	    bemBlock: _react2['default'].PropTypes.string
	  },
	
	  childContextTypes: {
	    bemNamespace: _react2['default'].PropTypes.string,
	    bemBlock: _react2['default'].PropTypes.string
	  },
	
	  getChildContext: function getChildContext() {
	    return {
	      bemNamespace: this.getBemNamespace(),
	      bemBlock: this.getBemBlock()
	    };
	  },
	
	  getBemNamespace: function getBemNamespace() {
	    if (this.props.bemNamespace) {
	      return this.props.bemNamespace;
	    }
	    if (this.context.bemNamespace) {
	      return this.context.bemNamespace;
	    }
	    return null;
	  },
	
	  getBemBlock: function getBemBlock() {
	    if (this.props.bemBlock) {
	      return this.props.bemBlock;
	    }
	    if (this.context.bemBlock) {
	      return this.context.bemBlock;
	    }
	    return null;
	  },
	
	  cx: function cx() {
	    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var opts = {
	      namespace: this.getBemNamespace(),
	      element: this.constructor.displayName,
	      block: this.getBemBlock()
	    };
	
	    _Object$assign(opts, options);
	    return (0, _bemCx2['default'])(opts);
	  }
	};
	
	exports['default'] = BemMixin;
	module.exports = exports['default'];

/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _Object$keys = __webpack_require__(171)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = bemCx;
	
	function bemCx() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	  var block = options.block;
	  var element = options.element;
	  var namespace = options.namespace;
	  var modifiers = options.modifiers;
	  var states = options.states;
	
	  var bemClasses = [];
	  var baseClassName;
	
	  if (element) {
	    if (namespace) {
	      baseClassName = namespace + '-' + block + '__' + element;
	    } else {
	      baseClassName = block + '__' + element;
	    }
	  } else {
	    if (namespace) {
	      baseClassName = namespace + '-' + block;
	    } else {
	      baseClassName = block;
	    }
	  }
	
	  bemClasses.push(baseClassName);
	
	  if (states) {
	    if (typeof states == 'object') {
	      states = _Object$keys(states).filter(function (s) {
	        return states[s];
	      });
	    }
	
	    states.forEach(function (state) {
	      bemClasses.push(baseClassName + '--is-' + state);
	    });
	  }
	
	  if (modifiers) {
	    if (typeof modifiers == 'object') {
	      modifiers = _Object$keys(modifiers).filter(function (m) {
	        return modifiers[m];
	      });
	    }
	
	    modifiers.forEach(function (modifier) {
	      bemClasses.push(baseClassName + '--' + modifier);
	
	      if (states) {
	        states.forEach(function (state) {
	          bemClasses.push(baseClassName + '--' + modifier + '--is-' + state);
	        });
	      }
	    });
	  }
	
	  return bemClasses.join(' ');
	}
	
	module.exports = exports['default'];

/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var React = __webpack_require__(40);
	var ReactForms = __webpack_require__(169);
	var ScalarNode = ReactForms.schema.ScalarNode;
	var createNode = ReactForms.schema.createNode;
	
	var Field = __webpack_require__(197);
	
	function TextScalar(props) {
	  props.input = props.input || React.createElement('textarea', { className: 'ofs-Input ofs-Input--textarea' });
	  props.type = 'string';
	  props.component = Field;
	  return createNode(ScalarNode, props);
	}
	
	module.exports = TextScalar;

/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _defineProperty = __webpack_require__(52)['default'];
	
	var _extends = __webpack_require__(54)['default'];
	
	var React = __webpack_require__(40);
	var cx = __webpack_require__(49);
	
	var ToggleSelect = React.createClass({
	  displayName: 'ToggleSelect',
	
	  render: function render() {
	    var options = this.props.options;
	
	    options = options.map(this.renderOption);
	
	    var classes = cx({
	      'ofs-Input': true,
	      'ofs-Input--toggle': true
	    });
	
	    return React.createElement(
	      'div',
	      { className: classes },
	      React.createElement('input', _extends({ type: 'hidden' }, this.props)),
	      options
	    );
	  },
	
	  onChange: function onChange(value) {
	    if (this.props.onChange) {
	      this.props.onChange(value);
	    }
	  },
	
	  renderOption: function renderOption(option) {
	    var className = this.props.className;
	
	    var width = 100 / this.props.options.length;
	
	    var classes = cx(_defineProperty({
	      'ofs-Input__ToggleOption': true,
	      'ofs-Input__ToggleOption--is-selected': option.value === this.props.value
	    }, className, true));
	
	    var style = {
	      width: width + '%'
	    };
	
	    return React.createElement(
	      'div',
	      { style: style, key: option.value, className: classes, onClick: this.onChange.bind(null, option.value) },
	      option.name
	    );
	  }
	});
	
	module.exports = ToggleSelect;

/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(40);
	var PureRenderMixin = __webpack_require__(40).addons.PureRenderMixin;
	
	var ReactForms = __webpack_require__(169);
	
	var Layout = __webpack_require__(225);
	var Row = __webpack_require__(226);
	var Column = __webpack_require__(227);
	var Group = __webpack_require__(228);
	
	var FormElement = ReactForms.Element;
	
	var contactLayouts = {
	  'email': __webpack_require__(229).layout,
	  'call': __webpack_require__(238).layout
	};
	
	var buildLayout = function buildLayout(contactPreference) {
	  var topicLayout = __webpack_require__(274).layout;
	  var contactLayout = contactLayouts[contactPreference];
	
	  return React.createClass({
	    mixins: [PureRenderMixin],
	
	    render: function render() {
	      var value = this.props.value;
	
	      return React.createElement(
	        Layout,
	        null,
	        topicLayout(value),
	        React.createElement(
	          Group,
	          null,
	          React.createElement(
	            Row,
	            null,
	            React.createElement(
	              Column,
	              { size: 'full' },
	              React.createElement(FormElement, { value: value.get('message') })
	            )
	          ),
	          React.createElement(
	            Row,
	            null,
	            React.createElement(
	              Column,
	              { size: 'full' },
	              React.createElement(FormElement, { value: value.get('contact_preference') })
	            )
	          ),
	          contactLayout(value)
	        )
	      );
	    }
	  });
	};
	
	module.exports = buildLayout;

/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var React = __webpack_require__(40);
	
	var Layout = React.createClass({
	  displayName: "Layout",
	
	  render: function render() {
	    return React.createElement(
	      "div",
	      { className: "ofs-FormLayout" },
	      this.props.children
	    );
	  }
	});
	
	module.exports = Layout;

/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _reactAddons = __webpack_require__(40);
	
	var _reactAddons2 = _interopRequireDefault(_reactAddons);
	
	var _classnames = __webpack_require__(49);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var Row = _reactAddons2['default'].createClass({
	  displayName: 'Row',
	
	  render: function render() {
	    var classes = (0, _classnames2['default'])({
	      'ofs-Grid': true
	    });
	
	    return _reactAddons2['default'].createElement(
	      'div',
	      { className: classes },
	      this.props.children
	    );
	  }
	});
	
	exports['default'] = Row;
	module.exports = exports['default'];

/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(40);
	var cx = __webpack_require__(49);
	
	var Column = React.createClass({
	  displayName: 'Column',
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      size: 'full'
	    };
	  },
	
	  render: function render() {
	    var classNames = cx('ofs-Grid__Column', 'ofs-Grid__Column--' + this.props.size);
	
	    return React.createElement(
	      'div',
	      { className: classNames },
	      this.props.children
	    );
	  }
	});
	
	module.exports = Column;

/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var React = __webpack_require__(40);
	
	var Group = React.createClass({
	  displayName: "Group",
	
	  render: function render() {
	    return React.createElement(
	      "div",
	      { className: "ofs-FormGroup" },
	      this.props.children
	    );
	  }
	});
	
	module.exports = Group;

/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var React = __webpack_require__(40);
	var ReactForms = __webpack_require__(169);
	var Mapping = ReactForms.schema.Mapping;
	var List = ReactForms.schema.List;
	var email = __webpack_require__(230);
	
	var i18n = __webpack_require__(61);
	var gettext = i18n.gettext;
	
	var Scalar = __webpack_require__(194);
	var EmailScalar = __webpack_require__(237);
	
	var FormElement = ReactForms.Element;
	var Row = __webpack_require__(226);
	var Column = __webpack_require__(227);
	
	var messages = {
	  EMAIL_LABEL: gettext('Email address'),
	  EMAIL_ERROR: gettext('Must be a valid email address'),
	  SIGNUP_LABEL: gettext('Send me emails with news and promotions')
	};
	
	var mapping = function mapping(defaultValues) {
	  return {
	    email: EmailScalar({
	      label: messages.EMAIL_LABEL,
	      defaultValue: defaultValues.get('email', null),
	      required: true
	    }),
	    signup: Scalar({
	      type: 'bool',
	      defaultValue: true,
	      label: messages.SIGNUP_LABEL
	    })
	  };
	};
	
	var layout = function layout(value) {
	  return [React.createElement(
	    Row,
	    null,
	    React.createElement(
	      Column,
	      { size: 'full' },
	      React.createElement(FormElement, { className: 'bdd-enquire-modal-field-email', value: value.get('email') })
	    )
	  ), React.createElement(
	    Row,
	    null,
	    React.createElement(
	      Column,
	      { size: 'full' },
	      React.createElement(FormElement, { className: 'bdd-enquire-modal-field-subscribe', value: value.get('signup') })
	    )
	  )];
	};
	
	module.exports = { mapping: mapping, layout: layout };

/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(231);


/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	var util = __webpack_require__(232);
	var email = module.exports = function() {};
	
	var strToObj = function(str) {
	  var obj = {};
	  for(var i = 0; i < str.length; i++) {
	    obj[str[i]] = str.charCodeAt(i);
	  }
	  return obj;
	};
	
	var chars = strToObj("abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!#$%&'*+-/=?^_`{|}~.");
	var specialchars = strToObj("\\\"(),:;<>@[\] ");
	var escapers = strToObj('\\"');
	var hostchars = strToObj("abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789.-");
	
	email.parse = function(address, dothrow, callback) {
	  callback = (typeof callback == 'undefined' && typeof dothrow == 'function') ? dothrow : null;
	  var userland = true;
	  var quotation = false;
	  var escaped = false;
	  var _user = "", _domain = "";
	  var hostisip = false;
	  var hoststartpos = 0;
	  try {
	    if(address.length >= 254) throw util.format("[Error parsing email address: address is longer than 253, actual]", address.length);
	    for(var i = 0; i < address.length; i++) {
	      //console.log(i, address[i])
	      if(userland) {
	        if(address[i] == '"' && i == 0) { quotation = true; _user += address[i]; continue; }
	        if(typeof chars[address[i]] != 'undefined') { //needed I'm sure.
	          _user += address[i]; continue;
	        } else if(typeof specialchars[address[i]] != 'undefined') {
	          if(quotation) {
	            if(!escaped && address[i] == "\\") { escaped = true; _user += address[i]; continue; }
	            if(!escaped && address[i] == '"' && address[i+1] == "@") { userland = false; hoststartpos = i+2; _user += address[i]; i+=1; continue; }
	            if(escaped && typeof escapers[address[i]] != 'undefined') { escaped = false; _user += address[i]; continue; }
	            if(!escaped && typeof escapers[address[i]] != 'undefined') throw util.format("[Error parsing email address: invalid use of %s (pos: %s)]", address[i], i, address);
	          } else if(address[i] == "@" && !quotation) {
	            userland = false;
	            hoststartpos = i+1;
	            continue;
	          } else {
	            throw util.format("[Error parsing email address: special character '%s' (pos: %s) used without quotation marks]", address[i], i);
	          }
	        } else {
	          throw util.format("[Error parsing email address: character '%s' (pos: %s) is not allowed in an email address user space.]", address[i], i, address);
	        }
	        _user += address[i];
	      } else { //parsing hostname. Probably could be done with regex.
	        if(i == hoststartpos && address[i] == '[') { hostisip = true; hostchars['['] = '['; hostchars[']'] = ']'; hostchars[':'] = ':'; _domain += address[i]; continue; }
	        if(typeof hostchars[address[i]] == 'undefined') throw util.format("[Error parsing email address: character '%s' (pos: %s) is not allowed in the hostname section]", address[i], i);
	        if(i >= hoststartpos && /[@\.]/.test(address[i - 1]) && !/[a-z0-9]/i.test(address[i])) throw util.format("[Error parsing email address: All domain segments must start with a letter or number, never a symbol like '%s'.")
	        _domain += address[i];
	      }
	    }
	    if(hostisip && !__webpack_require__(236).isIP(address.substring(hoststartpos+1,address.length-1))) throw util.format("[Error parsing email address: invalid IP address]");
	    if(hostisip && address[address.length-1] != "]") throw util.format("[Error parsing email address: IP address notation must end with a ']']");
	    if(!hostisip && (/^.+@([a-z0-9]{64,}(|\.))/i).test(address)) throw util.format("[Error parsing email address: hostname has elements greater than 63 characters]");
	    if(userland) throw util.format("[Error parsing email address: quotation mark not closed]" , address);
	  } catch (err) {
	    if(callback) callback(err);
	    if(typeof dothrow != 'undefined' && typeof dothrow != 'function') throw err;
	    return false; //redundant?
	  }
	  if(callback) callback(null, {user: _user, domain: _domain});
	  else return {user: _user, domain: _domain};
	}
	
	email.valid = function(address, dothrow, callback) {
	  return !!email.parse(address, dothrow, callback);
	}


/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var formatRegExp = /%[sdj%]/g;
	exports.format = function(f) {
	  if (!isString(f)) {
	    var objects = [];
	    for (var i = 0; i < arguments.length; i++) {
	      objects.push(inspect(arguments[i]));
	    }
	    return objects.join(' ');
	  }
	
	  var i = 1;
	  var args = arguments;
	  var len = args.length;
	  var str = String(f).replace(formatRegExp, function(x) {
	    if (x === '%%') return '%';
	    if (i >= len) return x;
	    switch (x) {
	      case '%s': return String(args[i++]);
	      case '%d': return Number(args[i++]);
	      case '%j':
	        try {
	          return JSON.stringify(args[i++]);
	        } catch (_) {
	          return '[Circular]';
	        }
	      default:
	        return x;
	    }
	  });
	  for (var x = args[i]; i < len; x = args[++i]) {
	    if (isNull(x) || !isObject(x)) {
	      str += ' ' + x;
	    } else {
	      str += ' ' + inspect(x);
	    }
	  }
	  return str;
	};
	
	
	// Mark that a method should not be used.
	// Returns a modified function which warns once by default.
	// If --no-deprecation is set, then it is a no-op.
	exports.deprecate = function(fn, msg) {
	  // Allow for deprecating things in the process of starting up.
	  if (isUndefined(global.process)) {
	    return function() {
	      return exports.deprecate(fn, msg).apply(this, arguments);
	    };
	  }
	
	  if (process.noDeprecation === true) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (process.throwDeprecation) {
	        throw new Error(msg);
	      } else if (process.traceDeprecation) {
	        console.trace(msg);
	      } else {
	        console.error(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	};
	
	
	var debugs = {};
	var debugEnviron;
	exports.debuglog = function(set) {
	  if (isUndefined(debugEnviron))
	    debugEnviron = ({"NODE_ENV":"production"}).NODE_DEBUG || '';
	  set = set.toUpperCase();
	  if (!debugs[set]) {
	    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
	      var pid = process.pid;
	      debugs[set] = function() {
	        var msg = exports.format.apply(exports, arguments);
	        console.error('%s %d: %s', set, pid, msg);
	      };
	    } else {
	      debugs[set] = function() {};
	    }
	  }
	  return debugs[set];
	};
	
	
	/**
	 * Echos the value of a value. Trys to print the value out
	 * in the best way possible given the different types.
	 *
	 * @param {Object} obj The object to print out.
	 * @param {Object} opts Optional options object that alters the output.
	 */
	/* legacy: obj, showHidden, depth, colors*/
	function inspect(obj, opts) {
	  // default options
	  var ctx = {
	    seen: [],
	    stylize: stylizeNoColor
	  };
	  // legacy...
	  if (arguments.length >= 3) ctx.depth = arguments[2];
	  if (arguments.length >= 4) ctx.colors = arguments[3];
	  if (isBoolean(opts)) {
	    // legacy...
	    ctx.showHidden = opts;
	  } else if (opts) {
	    // got an "options" object
	    exports._extend(ctx, opts);
	  }
	  // set default options
	  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
	  if (isUndefined(ctx.depth)) ctx.depth = 2;
	  if (isUndefined(ctx.colors)) ctx.colors = false;
	  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
	  if (ctx.colors) ctx.stylize = stylizeWithColor;
	  return formatValue(ctx, obj, ctx.depth);
	}
	exports.inspect = inspect;
	
	
	// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
	inspect.colors = {
	  'bold' : [1, 22],
	  'italic' : [3, 23],
	  'underline' : [4, 24],
	  'inverse' : [7, 27],
	  'white' : [37, 39],
	  'grey' : [90, 39],
	  'black' : [30, 39],
	  'blue' : [34, 39],
	  'cyan' : [36, 39],
	  'green' : [32, 39],
	  'magenta' : [35, 39],
	  'red' : [31, 39],
	  'yellow' : [33, 39]
	};
	
	// Don't use 'blue' not visible on cmd.exe
	inspect.styles = {
	  'special': 'cyan',
	  'number': 'yellow',
	  'boolean': 'yellow',
	  'undefined': 'grey',
	  'null': 'bold',
	  'string': 'green',
	  'date': 'magenta',
	  // "name": intentionally not styling
	  'regexp': 'red'
	};
	
	
	function stylizeWithColor(str, styleType) {
	  var style = inspect.styles[styleType];
	
	  if (style) {
	    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
	           '\u001b[' + inspect.colors[style][1] + 'm';
	  } else {
	    return str;
	  }
	}
	
	
	function stylizeNoColor(str, styleType) {
	  return str;
	}
	
	
	function arrayToHash(array) {
	  var hash = {};
	
	  array.forEach(function(val, idx) {
	    hash[val] = true;
	  });
	
	  return hash;
	}
	
	
	function formatValue(ctx, value, recurseTimes) {
	  // Provide a hook for user-specified inspect functions.
	  // Check that value is an object with an inspect function on it
	  if (ctx.customInspect &&
	      value &&
	      isFunction(value.inspect) &&
	      // Filter out the util module, it's inspect function is special
	      value.inspect !== exports.inspect &&
	      // Also filter out any prototype objects using the circular check.
	      !(value.constructor && value.constructor.prototype === value)) {
	    var ret = value.inspect(recurseTimes, ctx);
	    if (!isString(ret)) {
	      ret = formatValue(ctx, ret, recurseTimes);
	    }
	    return ret;
	  }
	
	  // Primitive types cannot have properties
	  var primitive = formatPrimitive(ctx, value);
	  if (primitive) {
	    return primitive;
	  }
	
	  // Look up the keys of the object.
	  var keys = Object.keys(value);
	  var visibleKeys = arrayToHash(keys);
	
	  if (ctx.showHidden) {
	    keys = Object.getOwnPropertyNames(value);
	  }
	
	  // IE doesn't make error fields non-enumerable
	  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
	  if (isError(value)
	      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
	    return formatError(value);
	  }
	
	  // Some type of object without properties can be shortcutted.
	  if (keys.length === 0) {
	    if (isFunction(value)) {
	      var name = value.name ? ': ' + value.name : '';
	      return ctx.stylize('[Function' + name + ']', 'special');
	    }
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    }
	    if (isDate(value)) {
	      return ctx.stylize(Date.prototype.toString.call(value), 'date');
	    }
	    if (isError(value)) {
	      return formatError(value);
	    }
	  }
	
	  var base = '', array = false, braces = ['{', '}'];
	
	  // Make Array say that they are Array
	  if (isArray(value)) {
	    array = true;
	    braces = ['[', ']'];
	  }
	
	  // Make functions say that they are functions
	  if (isFunction(value)) {
	    var n = value.name ? ': ' + value.name : '';
	    base = ' [Function' + n + ']';
	  }
	
	  // Make RegExps say that they are RegExps
	  if (isRegExp(value)) {
	    base = ' ' + RegExp.prototype.toString.call(value);
	  }
	
	  // Make dates with properties first say the date
	  if (isDate(value)) {
	    base = ' ' + Date.prototype.toUTCString.call(value);
	  }
	
	  // Make error with message first say the error
	  if (isError(value)) {
	    base = ' ' + formatError(value);
	  }
	
	  if (keys.length === 0 && (!array || value.length == 0)) {
	    return braces[0] + base + braces[1];
	  }
	
	  if (recurseTimes < 0) {
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    } else {
	      return ctx.stylize('[Object]', 'special');
	    }
	  }
	
	  ctx.seen.push(value);
	
	  var output;
	  if (array) {
	    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
	  } else {
	    output = keys.map(function(key) {
	      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
	    });
	  }
	
	  ctx.seen.pop();
	
	  return reduceToSingleString(output, base, braces);
	}
	
	
	function formatPrimitive(ctx, value) {
	  if (isUndefined(value))
	    return ctx.stylize('undefined', 'undefined');
	  if (isString(value)) {
	    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
	                                             .replace(/'/g, "\\'")
	                                             .replace(/\\"/g, '"') + '\'';
	    return ctx.stylize(simple, 'string');
	  }
	  if (isNumber(value))
	    return ctx.stylize('' + value, 'number');
	  if (isBoolean(value))
	    return ctx.stylize('' + value, 'boolean');
	  // For some reason typeof null is "object", so special case here.
	  if (isNull(value))
	    return ctx.stylize('null', 'null');
	}
	
	
	function formatError(value) {
	  return '[' + Error.prototype.toString.call(value) + ']';
	}
	
	
	function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
	  var output = [];
	  for (var i = 0, l = value.length; i < l; ++i) {
	    if (hasOwnProperty(value, String(i))) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          String(i), true));
	    } else {
	      output.push('');
	    }
	  }
	  keys.forEach(function(key) {
	    if (!key.match(/^\d+$/)) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          key, true));
	    }
	  });
	  return output;
	}
	
	
	function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
	  var name, str, desc;
	  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
	  if (desc.get) {
	    if (desc.set) {
	      str = ctx.stylize('[Getter/Setter]', 'special');
	    } else {
	      str = ctx.stylize('[Getter]', 'special');
	    }
	  } else {
	    if (desc.set) {
	      str = ctx.stylize('[Setter]', 'special');
	    }
	  }
	  if (!hasOwnProperty(visibleKeys, key)) {
	    name = '[' + key + ']';
	  }
	  if (!str) {
	    if (ctx.seen.indexOf(desc.value) < 0) {
	      if (isNull(recurseTimes)) {
	        str = formatValue(ctx, desc.value, null);
	      } else {
	        str = formatValue(ctx, desc.value, recurseTimes - 1);
	      }
	      if (str.indexOf('\n') > -1) {
	        if (array) {
	          str = str.split('\n').map(function(line) {
	            return '  ' + line;
	          }).join('\n').substr(2);
	        } else {
	          str = '\n' + str.split('\n').map(function(line) {
	            return '   ' + line;
	          }).join('\n');
	        }
	      }
	    } else {
	      str = ctx.stylize('[Circular]', 'special');
	    }
	  }
	  if (isUndefined(name)) {
	    if (array && key.match(/^\d+$/)) {
	      return str;
	    }
	    name = JSON.stringify('' + key);
	    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
	      name = name.substr(1, name.length - 2);
	      name = ctx.stylize(name, 'name');
	    } else {
	      name = name.replace(/'/g, "\\'")
	                 .replace(/\\"/g, '"')
	                 .replace(/(^"|"$)/g, "'");
	      name = ctx.stylize(name, 'string');
	    }
	  }
	
	  return name + ': ' + str;
	}
	
	
	function reduceToSingleString(output, base, braces) {
	  var numLinesEst = 0;
	  var length = output.reduce(function(prev, cur) {
	    numLinesEst++;
	    if (cur.indexOf('\n') >= 0) numLinesEst++;
	    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
	  }, 0);
	
	  if (length > 60) {
	    return braces[0] +
	           (base === '' ? '' : base + '\n ') +
	           ' ' +
	           output.join(',\n  ') +
	           ' ' +
	           braces[1];
	  }
	
	  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
	}
	
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	function isArray(ar) {
	  return Array.isArray(ar);
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return isObject(re) && objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return isObject(d) && objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return isObject(e) &&
	      (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = __webpack_require__(234);
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	
	function pad(n) {
	  return n < 10 ? '0' + n.toString(10) : n.toString(10);
	}
	
	
	var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
	              'Oct', 'Nov', 'Dec'];
	
	// 26 Feb 16:19:34
	function timestamp() {
	  var d = new Date();
	  var time = [pad(d.getHours()),
	              pad(d.getMinutes()),
	              pad(d.getSeconds())].join(':');
	  return [d.getDate(), months[d.getMonth()], time].join(' ');
	}
	
	
	// log is just a thin wrapper to console.log that prepends a timestamp
	exports.log = function() {
	  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
	};
	
	
	/**
	 * Inherit the prototype methods from one constructor into another.
	 *
	 * The Function.prototype.inherits from lang.js rewritten as a standalone
	 * function (not on Function.prototype). NOTE: If this file is to be loaded
	 * during bootstrapping this function needs to be rewritten using some native
	 * functions as prototype setup using normal JavaScript does not work as
	 * expected during bootstrapping (see mirror.js in r114903).
	 *
	 * @param {function} ctor Constructor function which needs to inherit the
	 *     prototype.
	 * @param {function} superCtor Constructor function to inherit prototype from.
	 */
	exports.inherits = __webpack_require__(235);
	
	exports._extend = function(origin, add) {
	  // Don't do anything if add isn't an object
	  if (!add || !isObject(add)) return origin;
	
	  var keys = Object.keys(add);
	  var i = keys.length;
	  while (i--) {
	    origin[keys[i]] = add[keys[i]];
	  }
	  return origin;
	};
	
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(233)))

/***/ },
/* 233 */
/***/ function(module, exports) {

	// shim for using process in browser
	
	var process = module.exports = {};
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = setTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    clearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        setTimeout(drainQueue, 0);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 234 */
/***/ function(module, exports) {

	module.exports = function isBuffer(arg) {
	  return arg && typeof arg === 'object'
	    && typeof arg.copy === 'function'
	    && typeof arg.fill === 'function'
	    && typeof arg.readUInt8 === 'function';
	}

/***/ },
/* 235 */
/***/ function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}


/***/ },
/* 236 */
/***/ function(module, exports) {



/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = EmailScalar;
	
	var _react = __webpack_require__(40);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactForms = __webpack_require__(169);
	
	var _reactForms2 = _interopRequireDefault(_reactForms);
	
	var _emailValidation = __webpack_require__(230);
	
	var _emailValidation2 = _interopRequireDefault(_emailValidation);
	
	var _ofsFormsComponentsBetterField = __webpack_require__(197);
	
	var _ofsFormsComponentsBetterField2 = _interopRequireDefault(_ofsFormsComponentsBetterField);
	
	var _ofsI18n = __webpack_require__(61);
	
	var Scalar = _reactForms2['default'].schema.Scalar;
	
	var MESSAGES = {
	  EMAIL_ERROR: (0, _ofsI18n.gettext)('Must be a valid email address')
	};
	
	function emailValidator(schema, v) {
	  if (!_emailValidation2['default'].valid(v)) {
	    return new Error(MESSAGES.EMAIL_ERROR);
	  }
	}
	
	function EmailScalar(props) {
	  var Component = _ofsFormsComponentsBetterField2['default'];
	
	  props.input = _react2['default'].createElement('input', { type: 'email', className: 'ofs-Input ofs-Input--text' });
	  props.component = _react2['default'].createElement(Component, null);
	  props.validate = emailValidator;
	  return Scalar(props);
	}
	
	module.exports = exports['default'];

/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var Immutable = __webpack_require__(68);
	
	var moment = __webpack_require__(57);
	
	var React = __webpack_require__(40);
	var ReactForms = __webpack_require__(169);
	
	var i18n = __webpack_require__(61);
	var gettext = i18n.gettext;
	
	var Scalar = __webpack_require__(194);
	var TimeScalar = __webpack_require__(239);
	
	var SelectOne = __webpack_require__(270);
	
	var FormElement = ReactForms.Element;
	var Row = __webpack_require__(226);
	var Column = __webpack_require__(227);
	
	var timezones = __webpack_require__(271);
	var timezoneOptions = Immutable.fromJS(timezones).map(function (v) {
	  return { value: v.get(0), name: v.get(1) };
	}).toJS();
	
	var InternationalPhoneInput = __webpack_require__(272);
	
	var messages = {
	  PHONE_NUMBER_LABEL: gettext('Phone number'),
	  TIMEZONE_LABEL: gettext('Your timezone'),
	  PREFER_CALL_TIME_LABEL: gettext('I prefer to be called at this time')
	};
	
	var mapping = function mapping() {
	  return {
	    phone_number: Scalar({
	      label: messages.PHONE_NUMBER_LABEL,
	      input: React.createElement(InternationalPhoneInput, null),
	      required: true
	    }),
	    timezone: Scalar({
	      label: messages.TIMEZONE_LABEL,
	      defaultValue: moment().format('ZZ'),
	      input: React.createElement(SelectOne, { options: timezoneOptions }),
	      required: true
	    }),
	    prefer_call_time: Scalar({
	      type: 'bool',
	      label: messages.PREFER_CALL_TIME_LABEL
	    }),
	    call_time: TimeScalar({
	      label: null
	    })
	  };
	};
	
	var layout = function layout(value) {
	  return [React.createElement(
	    Row,
	    null,
	    React.createElement(
	      Column,
	      { size: 'full' },
	      React.createElement(FormElement, { value: value.get('phone_number') })
	    )
	  ), React.createElement(
	    Row,
	    null,
	    React.createElement(
	      Column,
	      { size: 'full' },
	      React.createElement(FormElement, { className: 'bdd-enquire-modal-field-timezone', value: value.get('timezone') })
	    )
	  ), React.createElement(
	    Row,
	    null,
	    React.createElement(
	      Column,
	      { size: 'half' },
	      React.createElement(FormElement, { className: 'bdd-enquire-modal-field-calltime', value: value.get('call_time') })
	    ),
	    React.createElement(
	      Column,
	      { size: 'half' },
	      React.createElement(FormElement, { className: 'bdd-enquire-modal-field-calltime-prefer', value: value.get('prefer_call_time') })
	    )
	  )];
	};
	
	module.exports = { mapping: mapping, layout: layout };

/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var React = __webpack_require__(40);
	var ReactForms = __webpack_require__(169);
	var ScalarNode = ReactForms.schema.ScalarNode;
	var createNode = ReactForms.schema.createNode;
	var TimeSelect = __webpack_require__(240);
	
	var Field = __webpack_require__(197);
	
	function TimeScalar(props) {
	  props.input = props.input || React.createElement(TimeSelect, null);
	  props.type = 'string';
	  props.component = Field;
	  return createNode(ScalarNode, props);
	}
	
	module.exports = TimeScalar;

/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _slicedToArray = __webpack_require__(241)['default'];
	
	var _extends = __webpack_require__(54)['default'];
	
	var React = __webpack_require__(40);
	var pad = __webpack_require__(269);
	
	var Immutable = __webpack_require__(68);
	
	var SelectOne = __webpack_require__(270);
	
	var hourChoices = Immutable.Range(0, 24).map(function (i) {
	  var v = pad(2, i, '0');
	  return {
	    name: v,
	    value: v
	  };
	}).toJS();
	
	var minuteChoices = Immutable.Range(0, 60, 5).map(function (i) {
	  var v = pad(2, i, '0');
	  return {
	    name: v,
	    value: v
	  };
	}).toJS();
	
	var TimeSelect = React.createClass({
	  displayName: 'TimeSelect',
	
	  getInitialState: function getInitialState() {
	    return {
	      tempMinutes: null,
	      tempHour: null
	    };
	  },
	
	  onHourChange: function onHourChange(event) {
	    var hour = event.target.value;
	    var value = this.props.value;
	
	    var __;
	    var minutes = null;
	
	    if (value) {
	      var _value$split = value.split(':');
	
	      var _value$split2 = _slicedToArray(_value$split, 3);
	
	      __ = _value$split2[0];
	      minutes = _value$split2[1];
	      __ = _value$split2[2];
	    } else if (this.state.tempMinutes) {
	      minutes = this.state.tempMinutes;
	    }
	
	    if (hour && minutes) {
	      this.props.onChange(hour + ':' + minutes + ':00');
	      this.setState({ tempMinutes: null });
	    } else {
	      this.setState({ tempHour: hour });
	    }
	  },
	
	  onMinuteChange: function onMinuteChange(event) {
	    var minutes = event.target.value;
	    var value = this.props.value;
	
	    var __;
	    var hour = null;
	
	    if (value) {
	      var _value$split3 = value.split(':');
	
	      var _value$split32 = _slicedToArray(_value$split3, 3);
	
	      hour = _value$split32[0];
	      __ = _value$split32[1];
	      __ = _value$split32[2];
	    } else if (this.state.tempHour) {
	      hour = this.state.tempHour;
	    }
	
	    if (hour && minutes) {
	      this.props.onChange(hour + ':' + minutes + ':00');
	      this.setState({ tempHour: null });
	    } else {
	      this.setState({ tempMinutes: minutes });
	    }
	  },
	
	  render: function render() {
	    var value = this.props.value;
	
	    var hour = null;
	    var minutes = null;
	
	    var __;
	
	    if (value) {
	      var _value$split4 = value.split(':');
	
	      var _value$split42 = _slicedToArray(_value$split4, 3);
	
	      hour = _value$split42[0];
	      minutes = _value$split42[1];
	      __ = _value$split42[2];
	    }
	
	    return React.createElement(
	      'div',
	      { className: 'ofs-Input__Wrapper' },
	      React.createElement('input', _extends({ type: 'hidden' }, this.props, { value: value, ref: 'input' })),
	      React.createElement(
	        'div',
	        { className: 'ofs-Input__TimeInput' },
	        React.createElement(SelectOne, { className: 'bdd-time-select-hours', onChange: this.onHourChange, placeholder: '--', options: hourChoices, value: hour })
	      ),
	      React.createElement(
	        'div',
	        { className: 'ofs-Input__TimeInput' },
	        React.createElement(SelectOne, { className: 'bdd-time-select-minutes', onChange: this.onMinuteChange, placeholder: '--', options: minuteChoices, value: minutes })
	      )
	    );
	  }
	});
	
	module.exports = TimeSelect;

/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getIterator = __webpack_require__(242)["default"];
	
	var _isIterable = __webpack_require__(266)["default"];
	
	exports["default"] = (function () {
	  function sliceIterator(arr, i) {
	    var _arr = [];
	    var _n = true;
	    var _d = false;
	    var _e = undefined;
	
	    try {
	      for (var _i = _getIterator(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
	        _arr.push(_s.value);
	
	        if (i && _arr.length === i) break;
	      }
	    } catch (err) {
	      _d = true;
	      _e = err;
	    } finally {
	      try {
	        if (!_n && _i["return"]) _i["return"]();
	      } finally {
	        if (_d) throw _e;
	      }
	    }
	
	    return _arr;
	  }
	
	  return function (arr, i) {
	    if (Array.isArray(arr)) {
	      return arr;
	    } else if (_isIterable(Object(arr))) {
	      return sliceIterator(arr, i);
	    } else {
	      throw new TypeError("Invalid attempt to destructure non-iterable instance");
	    }
	  };
	})();
	
	exports.__esModule = true;

/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(243), __esModule: true };

/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(244);
	__webpack_require__(260);
	module.exports = __webpack_require__(263);

/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(245);
	var Iterators = __webpack_require__(248);
	Iterators.NodeList = Iterators.HTMLCollection = Iterators.Array;

/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var setUnscope = __webpack_require__(246)
	  , step       = __webpack_require__(247)
	  , Iterators  = __webpack_require__(248)
	  , toIObject  = __webpack_require__(8);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	__webpack_require__(249)(Array, 'Array', function(iterated, kind){
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , kind  = this._k
	    , index = this._i++;
	  if(!O || index >= O.length){
	    this._t = undefined;
	    return step(1);
	  }
	  if(kind == 'keys'  )return step(0, index);
	  if(kind == 'values')return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	setUnscope('keys');
	setUnscope('values');
	setUnscope('entries');

/***/ },
/* 246 */
/***/ function(module, exports) {

	module.exports = function(){ /* empty */ };

/***/ },
/* 247 */
/***/ function(module, exports) {

	module.exports = function(done, value){
	  return {value: value, done: !!done};
	};

/***/ },
/* 248 */
/***/ function(module, exports) {

	module.exports = {};

/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY         = __webpack_require__(250)
	  , $def            = __webpack_require__(13)
	  , $redef          = __webpack_require__(251)
	  , hide            = __webpack_require__(252)
	  , has             = __webpack_require__(38)
	  , SYMBOL_ITERATOR = __webpack_require__(255)('iterator')
	  , Iterators       = __webpack_require__(248)
	  , BUGGY           = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
	  , FF_ITERATOR     = '@@iterator'
	  , KEYS            = 'keys'
	  , VALUES          = 'values';
	var returnThis = function(){ return this; };
	module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCE){
	  __webpack_require__(258)(Constructor, NAME, next);
	  var createMethod = function(kind){
	    switch(kind){
	      case KEYS: return function keys(){ return new Constructor(this, kind); };
	      case VALUES: return function values(){ return new Constructor(this, kind); };
	    } return function entries(){ return new Constructor(this, kind); };
	  };
	  var TAG      = NAME + ' Iterator'
	    , proto    = Base.prototype
	    , _native  = proto[SYMBOL_ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
	    , _default = _native || createMethod(DEFAULT)
	    , methods, key;
	  // Fix native
	  if(_native){
	    var IteratorPrototype = __webpack_require__(6).getProto(_default.call(new Base));
	    // Set @@toStringTag to native iterators
	    __webpack_require__(259)(IteratorPrototype, TAG, true);
	    // FF fix
	    if(!LIBRARY && has(proto, FF_ITERATOR))hide(IteratorPrototype, SYMBOL_ITERATOR, returnThis);
	  }
	  // Define iterator
	  if(!LIBRARY || FORCE)hide(proto, SYMBOL_ITERATOR, _default);
	  // Plug for library
	  Iterators[NAME] = _default;
	  Iterators[TAG]  = returnThis;
	  if(DEFAULT){
	    methods = {
	      keys:    IS_SET            ? _default : createMethod(KEYS),
	      values:  DEFAULT == VALUES ? _default : createMethod(VALUES),
	      entries: DEFAULT != VALUES ? _default : createMethod('entries')
	    };
	    if(FORCE)for(key in methods){
	      if(!(key in proto))$redef(proto, key, methods[key]);
	    } else $def($def.P + $def.F * BUGGY, NAME, methods);
	  }
	};

/***/ },
/* 250 */
/***/ function(module, exports) {

	module.exports = true;

/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(252);

/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	var $          = __webpack_require__(6)
	  , createDesc = __webpack_require__(253);
	module.exports = __webpack_require__(254) ? function(object, key, value){
	  return $.setDesc(object, key, createDesc(1, value));
	} : function(object, key, value){
	  object[key] = value;
	  return object;
	};

/***/ },
/* 253 */
/***/ function(module, exports) {

	module.exports = function(bitmap, value){
	  return {
	    enumerable  : !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable    : !(bitmap & 4),
	    value       : value
	  };
	};

/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(16)(function(){
	  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	var store  = __webpack_require__(256)('wks')
	  , Symbol = __webpack_require__(14).Symbol;
	module.exports = function(name){
	  return store[name] || (store[name] =
	    Symbol && Symbol[name] || (Symbol || __webpack_require__(257))('Symbol.' + name));
	};

/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(14)
	  , SHARED = '__core-js_shared__'
	  , store  = global[SHARED] || (global[SHARED] = {});
	module.exports = function(key){
	  return store[key] || (store[key] = {});
	};

/***/ },
/* 257 */
/***/ function(module, exports) {

	var id = 0
	  , px = Math.random();
	module.exports = function(key){
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};

/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(6)
	  , IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(252)(IteratorPrototype, __webpack_require__(255)('iterator'), function(){ return this; });
	
	module.exports = function(Constructor, NAME, next){
	  Constructor.prototype = $.create(IteratorPrototype, {next: __webpack_require__(253)(1,next)});
	  __webpack_require__(259)(Constructor, NAME + ' Iterator');
	};

/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	var has  = __webpack_require__(38)
	  , hide = __webpack_require__(252)
	  , TAG  = __webpack_require__(255)('toStringTag');
	
	module.exports = function(it, tag, stat){
	  if(it && !has(it = stat ? it : it.prototype, TAG))hide(it, TAG, tag);
	};

/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $at  = __webpack_require__(261)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(249)(String, 'String', function(iterated){
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , index = this._i
	    , point;
	  if(index >= O.length)return {value: undefined, done: true};
	  point = $at(O, index);
	  this._i += point.length;
	  return {value: point, done: false};
	});

/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	// true  -> String#at
	// false -> String#codePointAt
	var toInteger = __webpack_require__(262)
	  , defined   = __webpack_require__(11);
	module.exports = function(TO_STRING){
	  return function(that, pos){
	    var s = String(defined(that))
	      , i = toInteger(pos)
	      , l = s.length
	      , a, b;
	    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l
	      || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	        ? TO_STRING ? s.charAt(i) : a
	        : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};

/***/ },
/* 262 */
/***/ function(module, exports) {

	// 7.1.4 ToInteger
	var ceil  = Math.ceil
	  , floor = Math.floor;
	module.exports = function(it){
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};

/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(25)
	  , get      = __webpack_require__(264);
	module.exports = __webpack_require__(15).getIterator = function(it){
	  var iterFn = get(it);
	  if(typeof iterFn != 'function')throw TypeError(it + ' is not iterable!');
	  return anObject(iterFn.call(it));
	};

/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	var classof   = __webpack_require__(265)
	  , ITERATOR  = __webpack_require__(255)('iterator')
	  , Iterators = __webpack_require__(248);
	module.exports = __webpack_require__(15).getIteratorMethod = function(it){
	  if(it != undefined)return it[ITERATOR] || it['@@iterator'] || Iterators[classof(it)];
	};

/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(10)
	  , TAG = __webpack_require__(255)('toStringTag')
	  // ES3 wrong here
	  , ARG = cof(function(){ return arguments; }()) == 'Arguments';
	
	module.exports = function(it){
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = (O = Object(it))[TAG]) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};

/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(267), __esModule: true };

/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(244);
	__webpack_require__(260);
	module.exports = __webpack_require__(268);

/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	var classof   = __webpack_require__(265)
	  , ITERATOR  = __webpack_require__(255)('iterator')
	  , Iterators = __webpack_require__(248);
	module.exports = __webpack_require__(15).isIterable = function(it){
	  var O = Object(it);
	  return ITERATOR in O || '@@iterator' in O || Iterators.hasOwnProperty(classof(O));
	};

/***/ },
/* 269 */
/***/ function(module, exports) {

	// Generated by CoffeeScript 1.7.1
	module.exports = function(string, size, options) {
	  var escapecolor, i, pad, prefix, _i, _ref;
	  if (options == null) {
	    options = {};
	  }
	  prefix = typeof string === 'number';
	  if (prefix) {
	    _ref = [string, size], size = _ref[0], string = _ref[1];
	  }
	  if (typeof options === 'string') {
	    options = {
	      char: options
	    };
	  }
	  if (options.char == null) {
	    options.char = ' ';
	  }
	  string = string.toString();
	  pad = '';
	  if (options.colors) {
	    escapecolor = /\x1B\[([0-9]{1,2}(;[0-9]{1,2})?)?[m|K]/g;
	    size += string.length - string.replace(escapecolor, '').length;
	  }
	  size = size - string.length;
	  for (i = _i = 0; 0 <= size ? _i < size : _i > size; i = 0 <= size ? ++_i : --_i) {
	    pad += options.char;
	  }
	  if (prefix) {
	    return pad + string;
	  } else {
	    return string + pad;
	  }
	};


/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _reactAddons = __webpack_require__(40);
	
	var _reactAddons2 = _interopRequireDefault(_reactAddons);
	
	var _ofsComponentsSimpleChoiceSimpleChoice = __webpack_require__(47);
	
	var _ofsComponentsSimpleChoiceSimpleChoice2 = _interopRequireDefault(_ofsComponentsSimpleChoiceSimpleChoice);
	
	var SelectOne = _reactAddons2['default'].createClass({
	  displayName: 'SelectOne',
	
	  propTypes: {
	    options: _reactAddons2['default'].PropTypes.array.isRequired,
	    allowEmpty: _reactAddons2['default'].PropTypes.bool,
	    emptyLabel: _reactAddons2['default'].PropTypes.string,
	    onChange: _reactAddons2['default'].PropTypes.func
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var options = _props.options;
	    var allowEmpty = _props.allowEmpty;
	    var emptyLabel = _props.emptyLabel;
	
	    options = options.map(this.renderOption);
	
	    if (allowEmpty) {
	      options.unshift(_reactAddons2['default'].createElement(
	        'div',
	        { key: '', value: '' },
	        emptyLabel
	      ));
	    }
	
	    return _reactAddons2['default'].createElement(
	      _ofsComponentsSimpleChoiceSimpleChoice2['default'],
	      this.props,
	      options
	    );
	  },
	
	  renderOption: function renderOption(option) {
	    return _reactAddons2['default'].createElement(
	      'div',
	      { key: option.value + ':' + option.name, value: option.value },
	      option.name
	    );
	  }
	});
	
	exports['default'] = SelectOne;
	module.exports = exports['default'];

/***/ },
/* 271 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = [["-1200", "(GMT -12:00) Baker/Howland Island"], ["-1100", "(GMT -11:00) Samoa Time Zone, Niue"], ["-1000", "(GMT -10:00) Hawaii-Aleutian Standard Time, Cook Islands, Tahiti"], ["-0930", "(GMT -9:30) Marquesas Islands"], ["-0900", "(GMT -9:00) Alaska Standard Time, Gambier Islands"], ["-0800", "(GMT -8:00) Pacific Standard Time, Clipperton Island"], ["-0700", "(GMT -7:00) Mountain Standard Time"], ["-0600", "(GMT -6:00) Central Standard Time"], ["-0500", "(GMT -5:00) Eastern Standard Time, Western Caribbean Standard Time"], ["-0430", "(GMT -4:30) Venezuelan Standard Time"], ["-0400", "(GMT -4:00) Atlantic Standard Time, Eastern Caribbean Standard Time"], ["-0330", "(GMT -3:30) Newfoundland Standard Time"], ["-0300", "(GMT -3:00) Argentina, Brazil, French Guiana, Uruguay"], ["-0200", "(GMT -2:00) South Georgia/South Sandwich Islands"], ["-0100", "(GMT -1:00) Azores, Cape Verde Islands"], ["+0000", "(GMT) Greenwich Mean Time, Western European Time"], ["+0100", "(GMT +1:00) Central European Time, West Africa Time"], ["+0200", "(GMT +2:00) Central Africa Time, Eastern European Time, Kaliningrad Time"], ["+0300", "(GMT +3:00) Moscow Time, East Africa Time"], ["+0330", "(GMT +3:30) Iran Standard Time"], ["+0400", "(GMT +4:00) Azerbaijan Standard Time, Samara Time"], ["+0430", "(GMT +4:30) Afghanistan"], ["+0500", "(GMT +5:00) Pakistan Standard Time, Yekaterinburg Time"], ["+0530", "(GMT +5:30) Indian Standard Time, Sri Lanka Time"], ["+0545", "(GMT +5:45) Nepal Time"], ["+0600", "(GMT +6:00) Bangladesh Standard Time, Bhutan Time, Omsk Time"], ["+0630", "(GMT +6:30) Cocos Islands, Myanmar"], ["+0700", "(GMT +7:00) Krasnoyarsk Time, Cambodia, Laos, Thailand, Vietnam"], ["+0800", "(GMT +8:00) Australian Western Standard Time, Beijing Time, Irkutsk Time"], ["+0845", "(GMT +8:45) Australian Central Western Standard Time"], ["+0900", "(GMT +9:00) Japan Standard Time, Korea Standard Time, Yakutsk Time"], ["+0930", "(GMT +9:30) Australian Central Standard Time"], ["+1000", "(GMT +10:00) Australian Eastern Standard Time, Vladivostok Time"], ["+1030", "(GMT +10:30) Lord Howe Island"], ["+1100", "(GMT +11:00) Magadan Time, Solomon Islands, Vanuatu"], ["+1130", "(GMT +11:30) Norfolk Island"], ["+1200", "(GMT +12:00) Fiji, Gilbert Islands, Kamchatka Time, New Zealand Standard Time"], ["+1245", "(GMT +12:45) Chatham Islands Standard Time"], ["+1300", "(GMT +13:00) Phoenix Islands Time, Tonga"], ["+1400", "(GMT +14:00) Line Islands"]];

/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _slicedToArray = __webpack_require__(241)['default'];
	
	var _extends = __webpack_require__(54)['default'];
	
	var React = __webpack_require__(40);
	
	var Immutable = __webpack_require__(68);
	
	var SelectOne = __webpack_require__(270);
	
	var COUNTRIES = Immutable.fromJS(__webpack_require__(273));
	
	var countryChoices = COUNTRIES.map(function (country) {
	  return {
	    name: country.get('name') + ' (+' + country.get('phone_prefix') + ')',
	    value: country.get('iso_alpha3')
	  };
	}).toJS();
	
	var InternationalPhoneInput = React.createClass({
	  displayName: 'InternationalPhoneInput',
	
	  getInitialState: function getInitialState() {
	    var value = this.props.value;
	
	    if (value) {
	      var _value$split = value.split('|');
	
	      var _value$split2 = _slicedToArray(_value$split, 2);
	
	      var prefix = _value$split2[0];
	      var number = _value$split2[1];
	    }
	
	    return {
	      tempPrefix: prefix || null,
	      tempNumber: number || null
	    };
	  },
	
	  onPrefixChange: function onPrefixChange(event) {
	    var country = event.target.value;
	    var number = this.state.tempNumber;
	    var prefix = this.state.tempPrefix;
	
	    var _prefix = COUNTRIES.find(function (c) {
	      return c.get('iso_alpha3') === country;
	    });
	
	    if (_prefix) {
	      prefix = _prefix.get('phone_prefix');
	    }
	
	    if (prefix && number) {
	      this.props.onChange(prefix + '|' + number);
	    } else {
	      this.props.onChange(null);
	    }
	
	    this.setState({ tempPrefix: prefix });
	  },
	
	  onNumberChange: function onNumberChange(event) {
	    var number = event.target.value;
	    var prefix = this.state.tempPrefix;
	
	    if (prefix && number) {
	      this.props.onChange(prefix + '|' + number);
	    } else {
	      this.props.onChange(null);
	    }
	    this.setState({ tempNumber: number });
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var placeholder = _props.placeholder;
	    var value = _props.value;
	
	    var prefix = null;
	    var number = null;
	
	    if (value) {
	      var _value$split3 = value.split('|');
	
	      var _value$split32 = _slicedToArray(_value$split3, 2);
	
	      prefix = _value$split32[0];
	      number = _value$split32[1];
	    }
	
	    return React.createElement(
	      'div',
	      { className: 'ofs-Input__Wrapper' },
	      React.createElement('input', _extends({ type: 'hidden' }, this.props, { ref: 'input', value: value })),
	      React.createElement(
	        'div',
	        { className: 'ofs-Input__Prefix' },
	        React.createElement(SelectOne, { onChange: this.onPrefixChange, placeholder: '--', options: countryChoices, value: prefix, className: 'bdd-enquire-modal-field-phone-country' })
	      ),
	      React.createElement(
	        'div',
	        { className: 'ofs-Input__Value' },
	        React.createElement('input', { onChange: this.onNumberChange, type: 'tel', value: number, placeholder: placeholder, className: 'bdd-enquire-modal-field-phone-number' })
	      )
	    );
	  }
	});
	
	module.exports = InternationalPhoneInput;

/***/ },
/* 273 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = [{ "name": "United Kingdom", "iso_alpha2": "GB", "iso_alpha3": "GBR", "iso_numeric": 826, "phone_prefix": "44", "currency_code": "GBP" }, { "name": "United States", "iso_alpha2": "US", "iso_alpha3": "USA", "iso_numeric": 840, "phone_prefix": "1", "currency_code": "USD" }, { "name": "France", "iso_alpha2": "FR", "iso_alpha3": "FRA", "iso_numeric": 250, "phone_prefix": "33", "currency_code": "EUR" }, { "name": "Afghanistan", "iso_alpha2": "AF", "iso_alpha3": "AFG", "iso_numeric": 4, "phone_prefix": "93", "currency_code": "AFN" }, { "name": "Aland Islands", "iso_alpha2": "AX", "iso_alpha3": "ALA", "iso_numeric": 248, "phone_prefix": "358-18", "currency_code": "EUR" }, { "name": "Albania", "iso_alpha2": "AL", "iso_alpha3": "ALB", "iso_numeric": 8, "phone_prefix": "355", "currency_code": "ALL" }, { "name": "Algeria", "iso_alpha2": "DZ", "iso_alpha3": "DZA", "iso_numeric": 12, "phone_prefix": "213", "currency_code": "DZD" }, { "name": "American Samoa", "iso_alpha2": "AS", "iso_alpha3": "ASM", "iso_numeric": 16, "phone_prefix": "1-684", "currency_code": "USD" }, { "name": "Andorra", "iso_alpha2": "AD", "iso_alpha3": "AND", "iso_numeric": 20, "phone_prefix": "376", "currency_code": "EUR" }, { "name": "Angola", "iso_alpha2": "AO", "iso_alpha3": "AGO", "iso_numeric": 24, "phone_prefix": "244", "currency_code": "AOA" }, { "name": "Anguilla", "iso_alpha2": "AI", "iso_alpha3": "AIA", "iso_numeric": 660, "phone_prefix": "1-264", "currency_code": "XCD" }, { "name": "Antarctica", "iso_alpha2": "AQ", "iso_alpha3": "ATA", "iso_numeric": 10, "phone_prefix": "672", "currency_code": "672" }, { "name": "Antigua and Barbuda", "iso_alpha2": "AG", "iso_alpha3": "ATG", "iso_numeric": 28, "phone_prefix": "1-268", "currency_code": "XCD" }, { "name": "Argentina", "iso_alpha2": "AR", "iso_alpha3": "ARG", "iso_numeric": 32, "phone_prefix": "54", "currency_code": "ARS" }, { "name": "Armenia", "iso_alpha2": "AM", "iso_alpha3": "ARM", "iso_numeric": 51, "phone_prefix": "374", "currency_code": "AMD" }, { "name": "Aruba", "iso_alpha2": "AW", "iso_alpha3": "ABW", "iso_numeric": 533, "phone_prefix": "297", "currency_code": "AWG" }, { "name": "Australia", "iso_alpha2": "AU", "iso_alpha3": "AUS", "iso_numeric": 36, "phone_prefix": "61", "currency_code": "AUD" }, { "name": "Austria", "iso_alpha2": "AT", "iso_alpha3": "AUT", "iso_numeric": 40, "phone_prefix": "43", "currency_code": "EUR" }, { "name": "Azerbaijan", "iso_alpha2": "AZ", "iso_alpha3": "AZE", "iso_numeric": 31, "phone_prefix": "994", "currency_code": "AZN" }, { "name": "Bahamas", "iso_alpha2": "BS", "iso_alpha3": "BHS", "iso_numeric": 44, "phone_prefix": "1-242", "currency_code": "BSD" }, { "name": "Bahrain", "iso_alpha2": "BH", "iso_alpha3": "BHR", "iso_numeric": 48, "phone_prefix": "973", "currency_code": "BHD" }, { "name": "Bangladesh", "iso_alpha2": "BD", "iso_alpha3": "BGD", "iso_numeric": 50, "phone_prefix": "880", "currency_code": "BDT" }, { "name": "Barbados", "iso_alpha2": "BB", "iso_alpha3": "BRB", "iso_numeric": 52, "phone_prefix": "1-246", "currency_code": "BBD" }, { "name": "Belarus", "iso_alpha2": "BY", "iso_alpha3": "BLR", "iso_numeric": 112, "phone_prefix": "375", "currency_code": "BYR" }, { "name": "Belgium", "iso_alpha2": "BE", "iso_alpha3": "BEL", "iso_numeric": 56, "phone_prefix": "32", "currency_code": "EUR" }, { "name": "Belize", "iso_alpha2": "BZ", "iso_alpha3": "BLZ", "iso_numeric": 84, "phone_prefix": "501", "currency_code": "BZD" }, { "name": "Benin", "iso_alpha2": "BJ", "iso_alpha3": "BEN", "iso_numeric": 204, "phone_prefix": "229", "currency_code": "XOF" }, { "name": "Bermuda", "iso_alpha2": "BM", "iso_alpha3": "BMU", "iso_numeric": 60, "phone_prefix": "1-441", "currency_code": "BMD" }, { "name": "Bhutan", "iso_alpha2": "BT", "iso_alpha3": "BTN", "iso_numeric": 64, "phone_prefix": "975", "currency_code": "BTN" }, { "name": "Bolivia", "iso_alpha2": "BO", "iso_alpha3": "BOL", "iso_numeric": 68, "phone_prefix": "591", "currency_code": "BOB" }, { "name": "Bosnia and Herzegovina", "iso_alpha2": "BA", "iso_alpha3": "BIH", "iso_numeric": 70, "phone_prefix": "387", "currency_code": "BAM" }, { "name": "Botswana", "iso_alpha2": "BW", "iso_alpha3": "BWA", "iso_numeric": 72, "phone_prefix": "267", "currency_code": "BWP" }, { "name": "Bouvet Island", "iso_alpha2": "BV", "iso_alpha3": "BVT", "iso_numeric": 74, "phone_prefix": "47", "currency_code": "NOK" }, { "name": "Brazil", "iso_alpha2": "BR", "iso_alpha3": "BRA", "iso_numeric": 76, "phone_prefix": "55", "currency_code": "BRL" }, { "name": "British Indian Ocean Territory", "iso_alpha2": "IO", "iso_alpha3": "IOT", "iso_numeric": 86, "phone_prefix": "246", "currency_code": "USD" }, { "name": "British Virgin Islands", "iso_alpha2": "VG", "iso_alpha3": "VGB", "iso_numeric": 92, "phone_prefix": "1-284", "currency_code": "USD" }, { "name": "Brunei", "iso_alpha2": "BN", "iso_alpha3": "BRN", "iso_numeric": 96, "phone_prefix": "673", "currency_code": "BND" }, { "name": "Bulgaria", "iso_alpha2": "BG", "iso_alpha3": "BGR", "iso_numeric": 100, "phone_prefix": "359", "currency_code": "BGN" }, { "name": "Burkina Faso", "iso_alpha2": "BF", "iso_alpha3": "BFA", "iso_numeric": 854, "phone_prefix": "226", "currency_code": "XOF" }, { "name": "Burundi", "iso_alpha2": "BI", "iso_alpha3": "BDI", "iso_numeric": 108, "phone_prefix": "257", "currency_code": "BIF" }, { "name": "Cambodia", "iso_alpha2": "KH", "iso_alpha3": "KHM", "iso_numeric": 116, "phone_prefix": "855", "currency_code": "KHR" }, { "name": "Cameroon", "iso_alpha2": "CM", "iso_alpha3": "CMR", "iso_numeric": 120, "phone_prefix": "237", "currency_code": "XAF" }, { "name": "Canada", "iso_alpha2": "CA", "iso_alpha3": "CAN", "iso_numeric": 124, "phone_prefix": "1", "currency_code": "CAD" }, { "name": "Cape Verde", "iso_alpha2": "CV", "iso_alpha3": "CPV", "iso_numeric": 132, "phone_prefix": "238", "currency_code": "CVE" }, { "name": "Cayman Islands", "iso_alpha2": "KY", "iso_alpha3": "CYM", "iso_numeric": 136, "phone_prefix": "1-345", "currency_code": "KYD" }, { "name": "Central African Republic", "iso_alpha2": "CF", "iso_alpha3": "CAF", "iso_numeric": 140, "phone_prefix": "236", "currency_code": "XAF" }, { "name": "Chad", "iso_alpha2": "TD", "iso_alpha3": "TCD", "iso_numeric": 148, "phone_prefix": "235", "currency_code": "XAF" }, { "name": "Chile", "iso_alpha2": "CL", "iso_alpha3": "CHL", "iso_numeric": 152, "phone_prefix": "56", "currency_code": "CLP" }, { "name": "China", "iso_alpha2": "CN", "iso_alpha3": "CHN", "iso_numeric": 156, "phone_prefix": "86", "currency_code": "CNY" }, { "name": "Christmas Island", "iso_alpha2": "CX", "iso_alpha3": "CXR", "iso_numeric": 162, "phone_prefix": "61", "currency_code": "AUD" }, { "name": "Cocos Islands", "iso_alpha2": "CC", "iso_alpha3": "CCK", "iso_numeric": 166, "phone_prefix": "61", "currency_code": "AUD" }, { "name": "Colombia", "iso_alpha2": "CO", "iso_alpha3": "COL", "iso_numeric": 170, "phone_prefix": "57", "currency_code": "COP" }, { "name": "Comoros", "iso_alpha2": "KM", "iso_alpha3": "COM", "iso_numeric": 174, "phone_prefix": "269", "currency_code": "KMF" }, { "name": "Cook Islands", "iso_alpha2": "CK", "iso_alpha3": "COK", "iso_numeric": 184, "phone_prefix": "682", "currency_code": "NZD" }, { "name": "Costa Rica", "iso_alpha2": "CR", "iso_alpha3": "CRI", "iso_numeric": 188, "phone_prefix": "506", "currency_code": "CRC" }, { "name": "Croatia", "iso_alpha2": "HR", "iso_alpha3": "HRV", "iso_numeric": 191, "phone_prefix": "385", "currency_code": "HRK" }, { "name": "Cuba", "iso_alpha2": "CU", "iso_alpha3": "CUB", "iso_numeric": 192, "phone_prefix": "53", "currency_code": "CUP" }, { "name": "Cyprus", "iso_alpha2": "CY", "iso_alpha3": "CYP", "iso_numeric": 196, "phone_prefix": "357", "currency_code": "EUR" }, { "name": "Czech Republic", "iso_alpha2": "CZ", "iso_alpha3": "CZE", "iso_numeric": 203, "phone_prefix": "420", "currency_code": "CZK" }, { "name": "Democratic Republic of the Congo", "iso_alpha2": "CD", "iso_alpha3": "COD", "iso_numeric": 180, "phone_prefix": "243", "currency_code": "CDF" }, { "name": "Denmark", "iso_alpha2": "DK", "iso_alpha3": "DNK", "iso_numeric": 208, "phone_prefix": "45", "currency_code": "DKK" }, { "name": "Djibouti", "iso_alpha2": "DJ", "iso_alpha3": "DJI", "iso_numeric": 262, "phone_prefix": "253", "currency_code": "DJF" }, { "name": "Dominica", "iso_alpha2": "DM", "iso_alpha3": "DMA", "iso_numeric": 212, "phone_prefix": "1-767", "currency_code": "XCD" }, { "name": "Dominican Republic", "iso_alpha2": "DO", "iso_alpha3": "DOM", "iso_numeric": 214, "phone_prefix": "1", "currency_code": "DOP" }, { "name": "East Timor", "iso_alpha2": "TL", "iso_alpha3": "TLS", "iso_numeric": 626, "phone_prefix": "670", "currency_code": "USD" }, { "name": "Ecuador", "iso_alpha2": "EC", "iso_alpha3": "ECU", "iso_numeric": 218, "phone_prefix": "593", "currency_code": "USD" }, { "name": "Egypt", "iso_alpha2": "EG", "iso_alpha3": "EGY", "iso_numeric": 818, "phone_prefix": "20", "currency_code": "EGP" }, { "name": "El Salvador", "iso_alpha2": "SV", "iso_alpha3": "SLV", "iso_numeric": 222, "phone_prefix": "503", "currency_code": "USD" }, { "name": "Equatorial Guinea", "iso_alpha2": "GQ", "iso_alpha3": "GNQ", "iso_numeric": 226, "phone_prefix": "240", "currency_code": "XAF" }, { "name": "Eritrea", "iso_alpha2": "ER", "iso_alpha3": "ERI", "iso_numeric": 232, "phone_prefix": "291", "currency_code": "ERN" }, { "name": "Estonia", "iso_alpha2": "EE", "iso_alpha3": "EST", "iso_numeric": 233, "phone_prefix": "372", "currency_code": "EEK" }, { "name": "Ethiopia", "iso_alpha2": "ET", "iso_alpha3": "ETH", "iso_numeric": 231, "phone_prefix": "251", "currency_code": "ETB" }, { "name": "Falkland Islands", "iso_alpha2": "FK", "iso_alpha3": "FLK", "iso_numeric": 238, "phone_prefix": "500", "currency_code": "FKP" }, { "name": "Faroe Islands", "iso_alpha2": "FO", "iso_alpha3": "FRO", "iso_numeric": 234, "phone_prefix": "298", "currency_code": "DKK" }, { "name": "Fiji", "iso_alpha2": "FJ", "iso_alpha3": "FJI", "iso_numeric": 242, "phone_prefix": "679", "currency_code": "FJD" }, { "name": "Finland", "iso_alpha2": "FI", "iso_alpha3": "FIN", "iso_numeric": 246, "phone_prefix": "358", "currency_code": "EUR" }, { "name": "French Guiana", "iso_alpha2": "GF", "iso_alpha3": "GUF", "iso_numeric": 254, "phone_prefix": "594", "currency_code": "EUR" }, { "name": "French Polynesia", "iso_alpha2": "PF", "iso_alpha3": "PYF", "iso_numeric": 258, "phone_prefix": "689", "currency_code": "XPF" }, { "name": "French Southern Territories", "iso_alpha2": "TF", "iso_alpha3": "ATF", "iso_numeric": 260, "phone_prefix": "689", "currency_code": "EUR" }, { "name": "Gabon", "iso_alpha2": "GA", "iso_alpha3": "GAB", "iso_numeric": 266, "phone_prefix": "241", "currency_code": "XAF" }, { "name": "Gambia", "iso_alpha2": "GM", "iso_alpha3": "GMB", "iso_numeric": 270, "phone_prefix": "220", "currency_code": "GMD" }, { "name": "Georgia", "iso_alpha2": "GE", "iso_alpha3": "GEO", "iso_numeric": 268, "phone_prefix": "995", "currency_code": "GEL" }, { "name": "Germany", "iso_alpha2": "DE", "iso_alpha3": "DEU", "iso_numeric": 276, "phone_prefix": "49", "currency_code": "EUR" }, { "name": "Ghana", "iso_alpha2": "GH", "iso_alpha3": "GHA", "iso_numeric": 288, "phone_prefix": "233", "currency_code": "GHS" }, { "name": "Gibraltar", "iso_alpha2": "GI", "iso_alpha3": "GIB", "iso_numeric": 292, "phone_prefix": "350", "currency_code": "GIP" }, { "name": "Greece", "iso_alpha2": "GR", "iso_alpha3": "GRC", "iso_numeric": 300, "phone_prefix": "30", "currency_code": "EUR" }, { "name": "Greenland", "iso_alpha2": "GL", "iso_alpha3": "GRL", "iso_numeric": 304, "phone_prefix": "299", "currency_code": "DKK" }, { "name": "Grenada", "iso_alpha2": "GD", "iso_alpha3": "GRD", "iso_numeric": 308, "phone_prefix": "1-473", "currency_code": "XCD" }, { "name": "Guadeloupe", "iso_alpha2": "GP", "iso_alpha3": "GLP", "iso_numeric": 312, "phone_prefix": "590", "currency_code": "EUR" }, { "name": "Guam", "iso_alpha2": "GU", "iso_alpha3": "GUM", "iso_numeric": 316, "phone_prefix": "1-671", "currency_code": "USD" }, { "name": "Guatemala", "iso_alpha2": "GT", "iso_alpha3": "GTM", "iso_numeric": 320, "phone_prefix": "502", "currency_code": "GTQ" }, { "name": "Guernsey", "iso_alpha2": "GG", "iso_alpha3": "GGY", "iso_numeric": 831, "phone_prefix": "44 ", "currency_code": "GBP" }, { "name": "Guinea", "iso_alpha2": "GN", "iso_alpha3": "GIN", "iso_numeric": 324, "phone_prefix": "224", "currency_code": "GNF" }, { "name": "Guinea-Bissau", "iso_alpha2": "GW", "iso_alpha3": "GNB", "iso_numeric": 624, "phone_prefix": "245", "currency_code": "XOF" }, { "name": "Guyana", "iso_alpha2": "GY", "iso_alpha3": "GUY", "iso_numeric": 328, "phone_prefix": "592", "currency_code": "GYD" }, { "name": "Haiti", "iso_alpha2": "HT", "iso_alpha3": "HTI", "iso_numeric": 332, "phone_prefix": "509", "currency_code": "HTG" }, { "name": "Heard Island and McDonald Islands", "iso_alpha2": "HM", "iso_alpha3": "HMD", "iso_numeric": 334, "phone_prefix": " ", "currency_code": "AUD" }, { "name": "Honduras", "iso_alpha2": "HN", "iso_alpha3": "HND", "iso_numeric": 340, "phone_prefix": "504", "currency_code": "HNL" }, { "name": "Hong Kong", "iso_alpha2": "HK", "iso_alpha3": "HKG", "iso_numeric": 344, "phone_prefix": "852", "currency_code": "HKD" }, { "name": "Hungary", "iso_alpha2": "HU", "iso_alpha3": "HUN", "iso_numeric": 348, "phone_prefix": "36", "currency_code": "HUF" }, { "name": "Iceland", "iso_alpha2": "IS", "iso_alpha3": "ISL", "iso_numeric": 352, "phone_prefix": "354", "currency_code": "ISK" }, { "name": "India", "iso_alpha2": "IN", "iso_alpha3": "IND", "iso_numeric": 356, "phone_prefix": "91", "currency_code": "INR" }, { "name": "Indonesia", "iso_alpha2": "ID", "iso_alpha3": "IDN", "iso_numeric": 360, "phone_prefix": "62", "currency_code": "IDR" }, { "name": "Iran", "iso_alpha2": "IR", "iso_alpha3": "IRN", "iso_numeric": 364, "phone_prefix": "98", "currency_code": "IRR" }, { "name": "Iraq", "iso_alpha2": "IQ", "iso_alpha3": "IRQ", "iso_numeric": 368, "phone_prefix": "964", "currency_code": "IQD" }, { "name": "Ireland", "iso_alpha2": "IE", "iso_alpha3": "IRL", "iso_numeric": 372, "phone_prefix": "353", "currency_code": "EUR" }, { "name": "Isle of Man", "iso_alpha2": "IM", "iso_alpha3": "IMN", "iso_numeric": 833, "phone_prefix": "44 ", "currency_code": "GBP" }, { "name": "Israel", "iso_alpha2": "IL", "iso_alpha3": "ISR", "iso_numeric": 376, "phone_prefix": "972", "currency_code": "ILS" }, { "name": "Italy", "iso_alpha2": "IT", "iso_alpha3": "ITA", "iso_numeric": 380, "phone_prefix": "39", "currency_code": "EUR" }, { "name": "Ivory Coast", "iso_alpha2": "CI", "iso_alpha3": "CIV", "iso_numeric": 384, "phone_prefix": "225", "currency_code": "XOF" }, { "name": "Jamaica", "iso_alpha2": "JM", "iso_alpha3": "JAM", "iso_numeric": 388, "phone_prefix": "1-876", "currency_code": "JMD" }, { "name": "Japan", "iso_alpha2": "JP", "iso_alpha3": "JPN", "iso_numeric": 392, "phone_prefix": "81", "currency_code": "JPY" }, { "name": "Jersey", "iso_alpha2": "JE", "iso_alpha3": "JEY", "iso_numeric": 832, "phone_prefix": "44 ", "currency_code": "GBP" }, { "name": "Jordan", "iso_alpha2": "JO", "iso_alpha3": "JOR", "iso_numeric": 400, "phone_prefix": "962", "currency_code": "JOD" }, { "name": "Kazakhstan", "iso_alpha2": "KZ", "iso_alpha3": "KAZ", "iso_numeric": 398, "phone_prefix": "7", "currency_code": "KZT" }, { "name": "Kenya", "iso_alpha2": "KE", "iso_alpha3": "KEN", "iso_numeric": 404, "phone_prefix": "254", "currency_code": "KES" }, { "name": "Kiribati", "iso_alpha2": "KI", "iso_alpha3": "KIR", "iso_numeric": 296, "phone_prefix": "686", "currency_code": "AUD" }, { "name": "Kuwait", "iso_alpha2": "KW", "iso_alpha3": "KWT", "iso_numeric": 414, "phone_prefix": "965", "currency_code": "KWD" }, { "name": "Kyrgyzstan", "iso_alpha2": "KG", "iso_alpha3": "KGZ", "iso_numeric": 417, "phone_prefix": "996", "currency_code": "KGS" }, { "name": "Laos", "iso_alpha2": "LA", "iso_alpha3": "LAO", "iso_numeric": 418, "phone_prefix": "856", "currency_code": "LAK" }, { "name": "Latvia", "iso_alpha2": "LV", "iso_alpha3": "LVA", "iso_numeric": 428, "phone_prefix": "371", "currency_code": "LVL" }, { "name": "Lebanon", "iso_alpha2": "LB", "iso_alpha3": "LBN", "iso_numeric": 422, "phone_prefix": "961", "currency_code": "LBP" }, { "name": "Lesotho", "iso_alpha2": "LS", "iso_alpha3": "LSO", "iso_numeric": 426, "phone_prefix": "266", "currency_code": "LSL" }, { "name": "Liberia", "iso_alpha2": "LR", "iso_alpha3": "LBR", "iso_numeric": 430, "phone_prefix": "231", "currency_code": "LRD" }, { "name": "Libya", "iso_alpha2": "LY", "iso_alpha3": "LBY", "iso_numeric": 434, "phone_prefix": "218", "currency_code": "LYD" }, { "name": "Liechtenstein", "iso_alpha2": "LI", "iso_alpha3": "LIE", "iso_numeric": 438, "phone_prefix": "423", "currency_code": "CHF" }, { "name": "Lithuania", "iso_alpha2": "LT", "iso_alpha3": "LTU", "iso_numeric": 440, "phone_prefix": "370", "currency_code": "LTL" }, { "name": "Luxembourg", "iso_alpha2": "LU", "iso_alpha3": "LUX", "iso_numeric": 442, "phone_prefix": "352", "currency_code": "EUR" }, { "name": "Macao", "iso_alpha2": "MO", "iso_alpha3": "MAC", "iso_numeric": 446, "phone_prefix": "853", "currency_code": "MOP" }, { "name": "Macedonia", "iso_alpha2": "MK", "iso_alpha3": "MKD", "iso_numeric": 807, "phone_prefix": "389", "currency_code": "MKD" }, { "name": "Madagascar", "iso_alpha2": "MG", "iso_alpha3": "MDG", "iso_numeric": 450, "phone_prefix": "261", "currency_code": "MGA" }, { "name": "Malawi", "iso_alpha2": "MW", "iso_alpha3": "MWI", "iso_numeric": 454, "phone_prefix": "265", "currency_code": "MWK" }, { "name": "Malaysia", "iso_alpha2": "MY", "iso_alpha3": "MYS", "iso_numeric": 458, "phone_prefix": "60", "currency_code": "MYR" }, { "name": "Maldives", "iso_alpha2": "MV", "iso_alpha3": "MDV", "iso_numeric": 462, "phone_prefix": "960", "currency_code": "MVR" }, { "name": "Mali", "iso_alpha2": "ML", "iso_alpha3": "MLI", "iso_numeric": 466, "phone_prefix": "223", "currency_code": "XOF" }, { "name": "Malta", "iso_alpha2": "MT", "iso_alpha3": "MLT", "iso_numeric": 470, "phone_prefix": "356", "currency_code": "EUR" }, { "name": "Marshall Islands", "iso_alpha2": "MH", "iso_alpha3": "MHL", "iso_numeric": 584, "phone_prefix": "692", "currency_code": "USD" }, { "name": "Martinique", "iso_alpha2": "MQ", "iso_alpha3": "MTQ", "iso_numeric": 474, "phone_prefix": "596", "currency_code": "EUR" }, { "name": "Mauritania", "iso_alpha2": "MR", "iso_alpha3": "MRT", "iso_numeric": 478, "phone_prefix": "222", "currency_code": "MRO" }, { "name": "Mauritius", "iso_alpha2": "MU", "iso_alpha3": "MUS", "iso_numeric": 480, "phone_prefix": "230", "currency_code": "MUR" }, { "name": "Mayotte", "iso_alpha2": "YT", "iso_alpha3": "MYT", "iso_numeric": 175, "phone_prefix": "269", "currency_code": "EUR" }, { "name": "Mexico", "iso_alpha2": "MX", "iso_alpha3": "MEX", "iso_numeric": 484, "phone_prefix": "52", "currency_code": "MXN" }, { "name": "Micronesia", "iso_alpha2": "FM", "iso_alpha3": "FSM", "iso_numeric": 583, "phone_prefix": "691", "currency_code": "USD" }, { "name": "Moldova", "iso_alpha2": "MD", "iso_alpha3": "MDA", "iso_numeric": 498, "phone_prefix": "373", "currency_code": "MDL" }, { "name": "Monaco", "iso_alpha2": "MC", "iso_alpha3": "MCO", "iso_numeric": 492, "phone_prefix": "377", "currency_code": "EUR" }, { "name": "Mongolia", "iso_alpha2": "MN", "iso_alpha3": "MNG", "iso_numeric": 496, "phone_prefix": "976", "currency_code": "MNT" }, { "name": "Montenegro", "iso_alpha2": "ME", "iso_alpha3": "MNE", "iso_numeric": 499, "phone_prefix": "381", "currency_code": "EUR" }, { "name": "Montserrat", "iso_alpha2": "MS", "iso_alpha3": "MSR", "iso_numeric": 500, "phone_prefix": "1-664", "currency_code": "XCD" }, { "name": "Morocco", "iso_alpha2": "MA", "iso_alpha3": "MAR", "iso_numeric": 504, "phone_prefix": "212", "currency_code": "MAD" }, { "name": "Mozambique", "iso_alpha2": "MZ", "iso_alpha3": "MOZ", "iso_numeric": 508, "phone_prefix": "258", "currency_code": "MZN" }, { "name": "Myanmar", "iso_alpha2": "MM", "iso_alpha3": "MMR", "iso_numeric": 104, "phone_prefix": "95", "currency_code": "MMK" }, { "name": "Namibia", "iso_alpha2": "NA", "iso_alpha3": "NAM", "iso_numeric": 516, "phone_prefix": "264", "currency_code": "NAD" }, { "name": "Nauru", "iso_alpha2": "NR", "iso_alpha3": "NRU", "iso_numeric": 520, "phone_prefix": "674", "currency_code": "AUD" }, { "name": "Nepal", "iso_alpha2": "NP", "iso_alpha3": "NPL", "iso_numeric": 524, "phone_prefix": "977", "currency_code": "NPR" }, { "name": "Netherlands", "iso_alpha2": "NL", "iso_alpha3": "NLD", "iso_numeric": 528, "phone_prefix": "31", "currency_code": "EUR" }, { "name": "Netherlands Antilles", "iso_alpha2": "AN", "iso_alpha3": "ANT", "iso_numeric": 530, "phone_prefix": "599", "currency_code": "ANG" }, { "name": "New Caledonia", "iso_alpha2": "NC", "iso_alpha3": "NCL", "iso_numeric": 540, "phone_prefix": "687", "currency_code": "XPF" }, { "name": "New Zealand", "iso_alpha2": "NZ", "iso_alpha3": "NZL", "iso_numeric": 554, "phone_prefix": "64", "currency_code": "NZD" }, { "name": "Nicaragua", "iso_alpha2": "NI", "iso_alpha3": "NIC", "iso_numeric": 558, "phone_prefix": "505", "currency_code": "NIO" }, { "name": "Niger", "iso_alpha2": "NE", "iso_alpha3": "NER", "iso_numeric": 562, "phone_prefix": "227", "currency_code": "XOF" }, { "name": "Nigeria", "iso_alpha2": "NG", "iso_alpha3": "NGA", "iso_numeric": 566, "phone_prefix": "234", "currency_code": "NGN" }, { "name": "Niue", "iso_alpha2": "NU", "iso_alpha3": "NIU", "iso_numeric": 570, "phone_prefix": "683", "currency_code": "NZD" }, { "name": "Norfolk Island", "iso_alpha2": "NF", "iso_alpha3": "NFK", "iso_numeric": 574, "phone_prefix": "672", "currency_code": "AUD" }, { "name": "North Korea", "iso_alpha2": "KP", "iso_alpha3": "PRK", "iso_numeric": 408, "phone_prefix": "850", "currency_code": "KPW" }, { "name": "Northern Mariana Islands", "iso_alpha2": "MP", "iso_alpha3": "MNP", "iso_numeric": 580, "phone_prefix": "1-670", "currency_code": "USD" }, { "name": "Norway", "iso_alpha2": "NO", "iso_alpha3": "NOR", "iso_numeric": 578, "phone_prefix": "47", "currency_code": "NOK" }, { "name": "Oman", "iso_alpha2": "OM", "iso_alpha3": "OMN", "iso_numeric": 512, "phone_prefix": "968", "currency_code": "OMR" }, { "name": "Pakistan", "iso_alpha2": "PK", "iso_alpha3": "PAK", "iso_numeric": 586, "phone_prefix": "92", "currency_code": "PKR" }, { "name": "Palau", "iso_alpha2": "PW", "iso_alpha3": "PLW", "iso_numeric": 585, "phone_prefix": "680", "currency_code": "USD" }, { "name": "Palestinian Territory", "iso_alpha2": "PS", "iso_alpha3": "PSE", "iso_numeric": 275, "phone_prefix": "970", "currency_code": "ILS" }, { "name": "Panama", "iso_alpha2": "PA", "iso_alpha3": "PAN", "iso_numeric": 591, "phone_prefix": "507", "currency_code": "PAB" }, { "name": "Papua New Guinea", "iso_alpha2": "PG", "iso_alpha3": "PNG", "iso_numeric": 598, "phone_prefix": "675", "currency_code": "PGK" }, { "name": "Paraguay", "iso_alpha2": "PY", "iso_alpha3": "PRY", "iso_numeric": 600, "phone_prefix": "595", "currency_code": "PYG" }, { "name": "Peru", "iso_alpha2": "PE", "iso_alpha3": "PER", "iso_numeric": 604, "phone_prefix": "51", "currency_code": "PEN" }, { "name": "Philippines", "iso_alpha2": "PH", "iso_alpha3": "PHL", "iso_numeric": 608, "phone_prefix": "63", "currency_code": "PHP" }, { "name": "Pitcairn", "iso_alpha2": "PN", "iso_alpha3": "PCN", "iso_numeric": 612, "phone_prefix": "870", "currency_code": "NZD" }, { "name": "Poland", "iso_alpha2": "PL", "iso_alpha3": "POL", "iso_numeric": 616, "phone_prefix": "48", "currency_code": "PLN" }, { "name": "Portugal", "iso_alpha2": "PT", "iso_alpha3": "PRT", "iso_numeric": 620, "phone_prefix": "351", "currency_code": "EUR" }, { "name": "Puerto Rico", "iso_alpha2": "PR", "iso_alpha3": "PRI", "iso_numeric": 630, "phone_prefix": "1", "currency_code": "USD" }, { "name": "Qatar", "iso_alpha2": "QA", "iso_alpha3": "QAT", "iso_numeric": 634, "phone_prefix": "974", "currency_code": "QAR" }, { "name": "Republic of the Congo", "iso_alpha2": "CG", "iso_alpha3": "COG", "iso_numeric": 178, "phone_prefix": "242", "currency_code": "XAF" }, { "name": "Reunion", "iso_alpha2": "RE", "iso_alpha3": "REU", "iso_numeric": 638, "phone_prefix": "262", "currency_code": "EUR" }, { "name": "Romania", "iso_alpha2": "RO", "iso_alpha3": "ROU", "iso_numeric": 642, "phone_prefix": "40", "currency_code": "RON" }, { "name": "Russia", "iso_alpha2": "RU", "iso_alpha3": "RUS", "iso_numeric": 643, "phone_prefix": "7", "currency_code": "RUB" }, { "name": "Rwanda", "iso_alpha2": "RW", "iso_alpha3": "RWA", "iso_numeric": 646, "phone_prefix": "250", "currency_code": "RWF" }, { "name": "Saint Barth\\u00e9lemy", "iso_alpha2": "BL", "iso_alpha3": "BLM", "iso_numeric": 652, "phone_prefix": "590", "currency_code": "EUR" }, { "name": "Saint Helena", "iso_alpha2": "SH", "iso_alpha3": "SHN", "iso_numeric": 654, "phone_prefix": "290", "currency_code": "SHP" }, { "name": "Saint Kitts and Nevis", "iso_alpha2": "KN", "iso_alpha3": "KNA", "iso_numeric": 659, "phone_prefix": "1-869", "currency_code": "XCD" }, { "name": "Saint Lucia", "iso_alpha2": "LC", "iso_alpha3": "LCA", "iso_numeric": 662, "phone_prefix": "1-758", "currency_code": "XCD" }, { "name": "Saint Martin", "iso_alpha2": "MF", "iso_alpha3": "MAF", "iso_numeric": 663, "phone_prefix": "590", "currency_code": "EUR" }, { "name": "Saint Pierre and Miquelon", "iso_alpha2": "PM", "iso_alpha3": "SPM", "iso_numeric": 666, "phone_prefix": "508", "currency_code": "EUR" }, { "name": "Saint Vincent and the Grenadines", "iso_alpha2": "VC", "iso_alpha3": "VCT", "iso_numeric": 670, "phone_prefix": "1-784", "currency_code": "XCD" }, { "name": "Samoa", "iso_alpha2": "WS", "iso_alpha3": "WSM", "iso_numeric": 882, "phone_prefix": "685", "currency_code": "WST" }, { "name": "San Marino", "iso_alpha2": "SM", "iso_alpha3": "SMR", "iso_numeric": 674, "phone_prefix": "378", "currency_code": "EUR" }, { "name": "Sao Tome and Principe", "iso_alpha2": "ST", "iso_alpha3": "STP", "iso_numeric": 678, "phone_prefix": "239", "currency_code": "STD" }, { "name": "Saudi Arabia", "iso_alpha2": "SA", "iso_alpha3": "SAU", "iso_numeric": 682, "phone_prefix": "966", "currency_code": "SAR" }, { "name": "Senegal", "iso_alpha2": "SN", "iso_alpha3": "SEN", "iso_numeric": 686, "phone_prefix": "221", "currency_code": "XOF" }, { "name": "Serbia", "iso_alpha2": "RS", "iso_alpha3": "SRB", "iso_numeric": 688, "phone_prefix": "381", "currency_code": "RSD" }, { "name": "Serbia and Montenegro", "iso_alpha2": "CS", "iso_alpha3": "SCG", "iso_numeric": 891, "phone_prefix": "381", "currency_code": "RSD" }, { "name": "Seychelles", "iso_alpha2": "SC", "iso_alpha3": "SYC", "iso_numeric": 690, "phone_prefix": "248", "currency_code": "SCR" }, { "name": "Sierra Leone", "iso_alpha2": "SL", "iso_alpha3": "SLE", "iso_numeric": 694, "phone_prefix": "232", "currency_code": "SLL" }, { "name": "Singapore", "iso_alpha2": "SG", "iso_alpha3": "SGP", "iso_numeric": 702, "phone_prefix": "65", "currency_code": "SGD" }, { "name": "Slovakia", "iso_alpha2": "SK", "iso_alpha3": "SVK", "iso_numeric": 703, "phone_prefix": "421", "currency_code": "EUR" }, { "name": "Slovenia", "iso_alpha2": "SI", "iso_alpha3": "SVN", "iso_numeric": 705, "phone_prefix": "386", "currency_code": "EUR" }, { "name": "Solomon Islands", "iso_alpha2": "SB", "iso_alpha3": "SLB", "iso_numeric": 90, "phone_prefix": "677", "currency_code": "SBD" }, { "name": "Somalia", "iso_alpha2": "SO", "iso_alpha3": "SOM", "iso_numeric": 706, "phone_prefix": "252", "currency_code": "SOS" }, { "name": "South Africa", "iso_alpha2": "ZA", "iso_alpha3": "ZAF", "iso_numeric": 710, "phone_prefix": "27", "currency_code": "ZAR" }, { "name": "South Georgia and the South Sandwich Islands", "iso_alpha2": "GS", "iso_alpha3": "SGS", "iso_numeric": 239, "phone_prefix": "500", "currency_code": "GBP" }, { "name": "South Korea", "iso_alpha2": "KR", "iso_alpha3": "KOR", "iso_numeric": 410, "phone_prefix": "82", "currency_code": "KRW" }, { "name": "Spain", "iso_alpha2": "ES", "iso_alpha3": "ESP", "iso_numeric": 724, "phone_prefix": "34", "currency_code": "EUR" }, { "name": "Sri Lanka", "iso_alpha2": "LK", "iso_alpha3": "LKA", "iso_numeric": 144, "phone_prefix": "94", "currency_code": "LKR" }, { "name": "Sudan", "iso_alpha2": "SD", "iso_alpha3": "SDN", "iso_numeric": 736, "phone_prefix": "249", "currency_code": "SDG" }, { "name": "Suriname", "iso_alpha2": "SR", "iso_alpha3": "SUR", "iso_numeric": 740, "phone_prefix": "597", "currency_code": "SRD" }, { "name": "Svalbard and Jan Mayen", "iso_alpha2": "SJ", "iso_alpha3": "SJM", "iso_numeric": 744, "phone_prefix": "47", "currency_code": "NOK" }, { "name": "Swaziland", "iso_alpha2": "SZ", "iso_alpha3": "SWZ", "iso_numeric": 748, "phone_prefix": "268", "currency_code": "SZL" }, { "name": "Sweden", "iso_alpha2": "SE", "iso_alpha3": "SWE", "iso_numeric": 752, "phone_prefix": "46", "currency_code": "SEK" }, { "name": "Switzerland", "iso_alpha2": "CH", "iso_alpha3": "CHE", "iso_numeric": 756, "phone_prefix": "41", "currency_code": "CHF" }, { "name": "Syria", "iso_alpha2": "SY", "iso_alpha3": "SYR", "iso_numeric": 760, "phone_prefix": "963", "currency_code": "SYP" }, { "name": "Taiwan", "iso_alpha2": "TW", "iso_alpha3": "TWN", "iso_numeric": 158, "phone_prefix": "886", "currency_code": "TWD" }, { "name": "Tajikistan", "iso_alpha2": "TJ", "iso_alpha3": "TJK", "iso_numeric": 762, "phone_prefix": "992", "currency_code": "TJS" }, { "name": "Tanzania", "iso_alpha2": "TZ", "iso_alpha3": "TZA", "iso_numeric": 834, "phone_prefix": "255", "currency_code": "TZS" }, { "name": "Thailand", "iso_alpha2": "TH", "iso_alpha3": "THA", "iso_numeric": 764, "phone_prefix": "66", "currency_code": "THB" }, { "name": "Togo", "iso_alpha2": "TG", "iso_alpha3": "TGO", "iso_numeric": 768, "phone_prefix": "228", "currency_code": "XOF" }, { "name": "Tokelau", "iso_alpha2": "TK", "iso_alpha3": "TKL", "iso_numeric": 772, "phone_prefix": "690", "currency_code": "NZD" }, { "name": "Tonga", "iso_alpha2": "TO", "iso_alpha3": "TON", "iso_numeric": 776, "phone_prefix": "676", "currency_code": "TOP" }, { "name": "Trinidad and Tobago", "iso_alpha2": "TT", "iso_alpha3": "TTO", "iso_numeric": 780, "phone_prefix": "1-868", "currency_code": "TTD" }, { "name": "Tunisia", "iso_alpha2": "TN", "iso_alpha3": "TUN", "iso_numeric": 788, "phone_prefix": "216", "currency_code": "TND" }, { "name": "Turkey", "iso_alpha2": "TR", "iso_alpha3": "TUR", "iso_numeric": 792, "phone_prefix": "90", "currency_code": "TRY" }, { "name": "Turkmenistan", "iso_alpha2": "TM", "iso_alpha3": "TKM", "iso_numeric": 795, "phone_prefix": "993", "currency_code": "TMT" }, { "name": "Turks and Caicos Islands", "iso_alpha2": "TC", "iso_alpha3": "TCA", "iso_numeric": 796, "phone_prefix": "1-649", "currency_code": "USD" }, { "name": "Tuvalu", "iso_alpha2": "TV", "iso_alpha3": "TUV", "iso_numeric": 798, "phone_prefix": "688", "currency_code": "AUD" }, { "name": "U.S. Virgin Islands", "iso_alpha2": "VI", "iso_alpha3": "VIR", "iso_numeric": 850, "phone_prefix": "1-340", "currency_code": "USD" }, { "name": "Uganda", "iso_alpha2": "UG", "iso_alpha3": "UGA", "iso_numeric": 800, "phone_prefix": "256", "currency_code": "UGX" }, { "name": "Ukraine", "iso_alpha2": "UA", "iso_alpha3": "UKR", "iso_numeric": 804, "phone_prefix": "380", "currency_code": "UAH" }, { "name": "United Arab Emirates", "iso_alpha2": "AE", "iso_alpha3": "ARE", "iso_numeric": 784, "phone_prefix": "971", "currency_code": "AED" }, { "name": "United States Minor Outlying Islands", "iso_alpha2": "UM", "iso_alpha3": "UMI", "iso_numeric": 581, "phone_prefix": "1", "currency_code": "USD" }, { "name": "Uruguay", "iso_alpha2": "UY", "iso_alpha3": "URY", "iso_numeric": 858, "phone_prefix": "598", "currency_code": "UYU" }, { "name": "Uzbekistan", "iso_alpha2": "UZ", "iso_alpha3": "UZB", "iso_numeric": 860, "phone_prefix": "998", "currency_code": "UZS" }, { "name": "Vanuatu", "iso_alpha2": "VU", "iso_alpha3": "VUT", "iso_numeric": 548, "phone_prefix": "678", "currency_code": "VUV" }, { "name": "Vatican", "iso_alpha2": "VA", "iso_alpha3": "VAT", "iso_numeric": 336, "phone_prefix": "379", "currency_code": "EUR" }, { "name": "Venezuela", "iso_alpha2": "VE", "iso_alpha3": "VEN", "iso_numeric": 862, "phone_prefix": "58", "currency_code": "VEF" }, { "name": "Vietnam", "iso_alpha2": "VN", "iso_alpha3": "VNM", "iso_numeric": 704, "phone_prefix": "84", "currency_code": "VND" }, { "name": "Wallis and Futuna", "iso_alpha2": "WF", "iso_alpha3": "WLF", "iso_numeric": 876, "phone_prefix": "681", "currency_code": "XPF" }, { "name": "Western Sahara", "iso_alpha2": "EH", "iso_alpha3": "ESH", "iso_numeric": 732, "phone_prefix": "212", "currency_code": "MAD" }, { "name": "Yemen", "iso_alpha2": "YE", "iso_alpha3": "YEM", "iso_numeric": 887, "phone_prefix": "967", "currency_code": "YER" }, { "name": "Zambia", "iso_alpha2": "ZM", "iso_alpha3": "ZMB", "iso_numeric": 894, "phone_prefix": "260", "currency_code": "ZMK" }, { "name": "Zimbabwe", "iso_alpha2": "ZW", "iso_alpha3": "ZWE", "iso_numeric": 716, "phone_prefix": "263", "currency_code": "ZWL" }];

/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var React = __webpack_require__(40);
	var ReactForms = __webpack_require__(169);
	var Immutable = __webpack_require__(68);
	
	var settings = __webpack_require__(62);
	var i18n = __webpack_require__(61);
	var gettext = i18n.gettext;
	var interpolate = i18n.interpolate;
	
	var SelectOne = __webpack_require__(270);
	var Scalar = __webpack_require__(194);
	var scalars = __webpack_require__(198);
	
	var FormElement = ReactForms.Element;
	var Row = __webpack_require__(226);
	var Column = __webpack_require__(227);
	var Group = __webpack_require__(228);
	
	var messages = {
	  START_DATE_LABEL: gettext('Arrival date'),
	  START_DATE_PLACEHOLDER: gettext('Select an arrival date'),
	  END_DATE_LABEL: gettext('Departure date'),
	  END_DATE_PLACEHOLDER: gettext('Select a departure date'),
	  FLEXIBLE_DATES_LABEL: gettext('My dates are flexible'),
	  ADULTS_LABEL: gettext('Adults'),
	  CHILDREN_LABEL: gettext('Children'),
	  CHILDREN_HINT: gettext('Age 4-12'),
	  TODDLERS_LABEL: gettext('Toddlers'),
	  TODDLERS_HINT: gettext('Age 1-3'),
	  BABIES_LABEL: gettext('Babies'),
	  BABIES_HINT: gettext('Under 1'),
	  FOOTER_MESSAGE: gettext('Alternatively, contact our <b>Reservations team</b> directly'),
	  CONTACT_MESSAGE: gettext('<strong>%(phone_number)s</strong> or <a href="%(email_url)s">%(email_address)s</a>')
	};
	
	var adultOptions = Immutable.Range(1, 17).map(function (i) {
	  return { value: i, name: i };
	}).toJS();
	var guestOptions = Immutable.Range(0, 17).map(function (i) {
	  return { value: i, name: i };
	}).toJS();
	
	var mapping = function mapping(defaultValues) {
	  return {
	    start_date: scalars.DateScalar({
	      label: messages.START_DATE_LABEL,
	      defaultValue: defaultValues.get('startDate', null),
	      placeholder: messages.START_DATE_PLACEHOLDER
	    }),
	    end_date: scalars.DateScalar({
	      label: messages.END_DATE_LABEL,
	      defaultValue: defaultValues.get('endDate', null),
	      placeholder: messages.END_DATE_PLACEHOLDER
	    }),
	    flexible_dates: Scalar({
	      type: 'bool',
	      label: messages.FLEXIBLE_DATES_LABEL
	    }),
	    adults: Scalar({
	      type: 'number',
	      defaultValue: parseInt(defaultValues.get('numberOfGuests')) || 1,
	      input: React.createElement(SelectOne, { options: adultOptions }),
	      label: messages.ADULTS_LABEL
	    }),
	    children: Scalar({
	      type: 'number',
	      defaultValue: 0,
	      input: React.createElement(SelectOne, { options: guestOptions }),
	      label: messages.CHILDREN_LABEL,
	      hint: messages.CHILDREN_HINT
	    }),
	    toddlers: Scalar({
	      type: 'number',
	      defaultValue: 0,
	      input: React.createElement(SelectOne, { options: guestOptions }),
	      label: messages.TODDLERS_LABEL,
	      hint: messages.TODDLERS_HINT
	    }),
	    babies: Scalar({
	      type: 'number',
	      defaultValue: 0,
	      input: React.createElement(SelectOne, { options: guestOptions }),
	      label: messages.BABIES_LABEL,
	      hint: messages.BABIES_HINT
	    })
	  };
	};
	
	var layout = function layout(value) {
	  return [React.createElement(
	    Group,
	    null,
	    React.createElement(
	      Row,
	      null,
	      React.createElement(
	        Column,
	        { size: 'half' },
	        React.createElement(FormElement, { value: value.get('start_date') })
	      ),
	      React.createElement(
	        Column,
	        { size: 'half' },
	        React.createElement(FormElement, { value: value.get('end_date') })
	      )
	    ),
	    React.createElement(
	      Row,
	      null,
	      React.createElement(
	        Column,
	        { size: 'full' },
	        React.createElement(FormElement, { value: value.get('flexible_dates') })
	      )
	    )
	  ), React.createElement(
	    Group,
	    null,
	    React.createElement(
	      Row,
	      null,
	      React.createElement(
	        Column,
	        { size: 'quarter' },
	        React.createElement(FormElement, { value: value.get('adults') })
	      ),
	      React.createElement(
	        Column,
	        { size: 'quarter' },
	        React.createElement(FormElement, { value: value.get('children') })
	      ),
	      React.createElement(
	        Column,
	        { size: 'quarter' },
	        React.createElement(FormElement, { value: value.get('toddlers') })
	      ),
	      React.createElement(
	        Column,
	        { size: 'quarter' },
	        React.createElement(FormElement, { value: value.get('babies') })
	      )
	    )
	  )];
	};
	
	var Footer = React.createClass({
	  displayName: 'Footer',
	
	  render: function render() {
	    var contact = settings.cities[this.props.cityCode].contact;
	    var contactMsg = interpolate(messages.CONTACT_MESSAGE, {
	      phone_number: contact['reservations']['phone'],
	      email_url: 'mailto:' + contact['reservations']['email'],
	      email_address: contact['reservations']['email']
	    }, true);
	
	    return React.createElement(
	      'div',
	      { className: 'ofs-InfoPanel u-text-center' },
	      React.createElement('p', { dangerouslySetInnerHTML: { __html: messages.FOOTER_MESSAGE } }),
	      React.createElement('p', { dangerouslySetInnerHTML: { __html: contactMsg } })
	    );
	  }
	});
	
	module.exports = { mapping: mapping, layout: layout, Footer: Footer };

/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	var http = module.exports;
	var EventEmitter = __webpack_require__(276).EventEmitter;
	var Request = __webpack_require__(277);
	var url = __webpack_require__(302)
	
	http.request = function (params, cb) {
	    if (typeof params === 'string') {
	        params = url.parse(params)
	    }
	    if (!params) params = {};
	    if (!params.host && !params.port) {
	        params.port = parseInt(window.location.port, 10);
	    }
	    if (!params.host && params.hostname) {
	        params.host = params.hostname;
	    }
	
	    if (!params.protocol) {
	        if (params.scheme) {
	            params.protocol = params.scheme + ':';
	        } else {
	            params.protocol = window.location.protocol;
	        }
	    }
	
	    if (!params.host) {
	        params.host = window.location.hostname || window.location.host;
	    }
	    if (/:/.test(params.host)) {
	        if (!params.port) {
	            params.port = params.host.split(':')[1];
	        }
	        params.host = params.host.split(':')[0];
	    }
	    if (!params.port) params.port = params.protocol == 'https:' ? 443 : 80;
	    
	    var req = new Request(new xhrHttp, params);
	    if (cb) req.on('response', cb);
	    return req;
	};
	
	http.get = function (params, cb) {
	    params.method = 'GET';
	    var req = http.request(params, cb);
	    req.end();
	    return req;
	};
	
	http.Agent = function () {};
	http.Agent.defaultMaxSockets = 4;
	
	var xhrHttp = (function () {
	    if (typeof window === 'undefined') {
	        throw new Error('no window object present');
	    }
	    else if (window.XMLHttpRequest) {
	        return window.XMLHttpRequest;
	    }
	    else if (window.ActiveXObject) {
	        var axs = [
	            'Msxml2.XMLHTTP.6.0',
	            'Msxml2.XMLHTTP.3.0',
	            'Microsoft.XMLHTTP'
	        ];
	        for (var i = 0; i < axs.length; i++) {
	            try {
	                var ax = new(window.ActiveXObject)(axs[i]);
	                return function () {
	                    if (ax) {
	                        var ax_ = ax;
	                        ax = null;
	                        return ax_;
	                    }
	                    else {
	                        return new(window.ActiveXObject)(axs[i]);
	                    }
	                };
	            }
	            catch (e) {}
	        }
	        throw new Error('ajax not supported in this browser')
	    }
	    else {
	        throw new Error('ajax not supported in this browser');
	    }
	})();
	
	http.STATUS_CODES = {
	    100 : 'Continue',
	    101 : 'Switching Protocols',
	    102 : 'Processing',                 // RFC 2518, obsoleted by RFC 4918
	    200 : 'OK',
	    201 : 'Created',
	    202 : 'Accepted',
	    203 : 'Non-Authoritative Information',
	    204 : 'No Content',
	    205 : 'Reset Content',
	    206 : 'Partial Content',
	    207 : 'Multi-Status',               // RFC 4918
	    300 : 'Multiple Choices',
	    301 : 'Moved Permanently',
	    302 : 'Moved Temporarily',
	    303 : 'See Other',
	    304 : 'Not Modified',
	    305 : 'Use Proxy',
	    307 : 'Temporary Redirect',
	    400 : 'Bad Request',
	    401 : 'Unauthorized',
	    402 : 'Payment Required',
	    403 : 'Forbidden',
	    404 : 'Not Found',
	    405 : 'Method Not Allowed',
	    406 : 'Not Acceptable',
	    407 : 'Proxy Authentication Required',
	    408 : 'Request Time-out',
	    409 : 'Conflict',
	    410 : 'Gone',
	    411 : 'Length Required',
	    412 : 'Precondition Failed',
	    413 : 'Request Entity Too Large',
	    414 : 'Request-URI Too Large',
	    415 : 'Unsupported Media Type',
	    416 : 'Requested Range Not Satisfiable',
	    417 : 'Expectation Failed',
	    418 : 'I\'m a teapot',              // RFC 2324
	    422 : 'Unprocessable Entity',       // RFC 4918
	    423 : 'Locked',                     // RFC 4918
	    424 : 'Failed Dependency',          // RFC 4918
	    425 : 'Unordered Collection',       // RFC 4918
	    426 : 'Upgrade Required',           // RFC 2817
	    428 : 'Precondition Required',      // RFC 6585
	    429 : 'Too Many Requests',          // RFC 6585
	    431 : 'Request Header Fields Too Large',// RFC 6585
	    500 : 'Internal Server Error',
	    501 : 'Not Implemented',
	    502 : 'Bad Gateway',
	    503 : 'Service Unavailable',
	    504 : 'Gateway Time-out',
	    505 : 'HTTP Version Not Supported',
	    506 : 'Variant Also Negotiates',    // RFC 2295
	    507 : 'Insufficient Storage',       // RFC 4918
	    509 : 'Bandwidth Limit Exceeded',
	    510 : 'Not Extended',               // RFC 2774
	    511 : 'Network Authentication Required' // RFC 6585
	};

/***/ },
/* 276 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      }
	      throw TypeError('Uncaught, unspecified "error" event.');
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        len = arguments.length;
	        args = new Array(len - 1);
	        for (i = 1; i < len; i++)
	          args[i - 1] = arguments[i];
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    len = arguments.length;
	    args = new Array(len - 1);
	    for (i = 1; i < len; i++)
	      args[i - 1] = arguments[i];
	
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    var m;
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  var ret;
	  if (!emitter._events || !emitter._events[type])
	    ret = 0;
	  else if (isFunction(emitter._events[type]))
	    ret = 1;
	  else
	    ret = emitter._events[type].length;
	  return ret;
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	var Stream = __webpack_require__(278);
	var Response = __webpack_require__(299);
	var Base64 = __webpack_require__(300);
	var inherits = __webpack_require__(301);
	
	var Request = module.exports = function (xhr, params) {
	    var self = this;
	    self.writable = true;
	    self.xhr = xhr;
	    self.body = [];
	    
	    self.uri = (params.protocol || 'http:') + '//'
	        + params.host
	        + (params.port ? ':' + params.port : '')
	        + (params.path || '/')
	    ;
	    
	    if (typeof params.withCredentials === 'undefined') {
	        params.withCredentials = true;
	    }
	
	    try { xhr.withCredentials = params.withCredentials }
	    catch (e) {}
	    
	    if (params.responseType) try { xhr.responseType = params.responseType }
	    catch (e) {}
	    
	    xhr.open(
	        params.method || 'GET',
	        self.uri,
	        true
	    );
	
	    xhr.onerror = function(event) {
	        self.emit('error', new Error('Network error'));
	    };
	
	    self._headers = {};
	    
	    if (params.headers) {
	        var keys = objectKeys(params.headers);
	        for (var i = 0; i < keys.length; i++) {
	            var key = keys[i];
	            if (!self.isSafeRequestHeader(key)) continue;
	            var value = params.headers[key];
	            self.setHeader(key, value);
	        }
	    }
	    
	    if (params.auth) {
	        //basic auth
	        this.setHeader('Authorization', 'Basic ' + Base64.btoa(params.auth));
	    }
	
	    var res = new Response;
	    res.on('close', function () {
	        self.emit('close');
	    });
	    
	    res.on('ready', function () {
	        self.emit('response', res);
	    });
	
	    res.on('error', function (err) {
	        self.emit('error', err);
	    });
	    
	    xhr.onreadystatechange = function () {
	        // Fix for IE9 bug
	        // SCRIPT575: Could not complete the operation due to error c00c023f
	        // It happens when a request is aborted, calling the success callback anyway with readyState === 4
	        if (xhr.__aborted) return;
	        res.handle(xhr);
	    };
	};
	
	inherits(Request, Stream);
	
	Request.prototype.setHeader = function (key, value) {
	    this._headers[key.toLowerCase()] = value
	};
	
	Request.prototype.getHeader = function (key) {
	    return this._headers[key.toLowerCase()]
	};
	
	Request.prototype.removeHeader = function (key) {
	    delete this._headers[key.toLowerCase()]
	};
	
	Request.prototype.write = function (s) {
	    this.body.push(s);
	};
	
	Request.prototype.destroy = function (s) {
	    this.xhr.__aborted = true;
	    this.xhr.abort();
	    this.emit('close');
	};
	
	Request.prototype.end = function (s) {
	    if (s !== undefined) this.body.push(s);
	
	    var keys = objectKeys(this._headers);
	    for (var i = 0; i < keys.length; i++) {
	        var key = keys[i];
	        var value = this._headers[key];
	        if (isArray(value)) {
	            for (var j = 0; j < value.length; j++) {
	                this.xhr.setRequestHeader(key, value[j]);
	            }
	        }
	        else this.xhr.setRequestHeader(key, value)
	    }
	
	    if (this.body.length === 0) {
	        this.xhr.send('');
	    }
	    else if (typeof this.body[0] === 'string') {
	        this.xhr.send(this.body.join(''));
	    }
	    else if (isArray(this.body[0])) {
	        var body = [];
	        for (var i = 0; i < this.body.length; i++) {
	            body.push.apply(body, this.body[i]);
	        }
	        this.xhr.send(body);
	    }
	    else if (/Array/.test(Object.prototype.toString.call(this.body[0]))) {
	        var len = 0;
	        for (var i = 0; i < this.body.length; i++) {
	            len += this.body[i].length;
	        }
	        var body = new(this.body[0].constructor)(len);
	        var k = 0;
	        
	        for (var i = 0; i < this.body.length; i++) {
	            var b = this.body[i];
	            for (var j = 0; j < b.length; j++) {
	                body[k++] = b[j];
	            }
	        }
	        this.xhr.send(body);
	    }
	    else if (isXHR2Compatible(this.body[0])) {
	        this.xhr.send(this.body[0]);
	    }
	    else {
	        var body = '';
	        for (var i = 0; i < this.body.length; i++) {
	            body += this.body[i].toString();
	        }
	        this.xhr.send(body);
	    }
	};
	
	// Taken from http://dxr.mozilla.org/mozilla/mozilla-central/content/base/src/nsXMLHttpRequest.cpp.html
	Request.unsafeHeaders = [
	    "accept-charset",
	    "accept-encoding",
	    "access-control-request-headers",
	    "access-control-request-method",
	    "connection",
	    "content-length",
	    "cookie",
	    "cookie2",
	    "content-transfer-encoding",
	    "date",
	    "expect",
	    "host",
	    "keep-alive",
	    "origin",
	    "referer",
	    "te",
	    "trailer",
	    "transfer-encoding",
	    "upgrade",
	    "user-agent",
	    "via"
	];
	
	Request.prototype.isSafeRequestHeader = function (headerName) {
	    if (!headerName) return false;
	    return indexOf(Request.unsafeHeaders, headerName.toLowerCase()) === -1;
	};
	
	var objectKeys = Object.keys || function (obj) {
	    var keys = [];
	    for (var key in obj) keys.push(key);
	    return keys;
	};
	
	var isArray = Array.isArray || function (xs) {
	    return Object.prototype.toString.call(xs) === '[object Array]';
	};
	
	var indexOf = function (xs, x) {
	    if (xs.indexOf) return xs.indexOf(x);
	    for (var i = 0; i < xs.length; i++) {
	        if (xs[i] === x) return i;
	    }
	    return -1;
	};
	
	var isXHR2Compatible = function (obj) {
	    if (typeof Blob !== 'undefined' && obj instanceof Blob) return true;
	    if (typeof ArrayBuffer !== 'undefined' && obj instanceof ArrayBuffer) return true;
	    if (typeof FormData !== 'undefined' && obj instanceof FormData) return true;
	};


/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	module.exports = Stream;
	
	var EE = __webpack_require__(276).EventEmitter;
	var inherits = __webpack_require__(279);
	
	inherits(Stream, EE);
	Stream.Readable = __webpack_require__(280);
	Stream.Writable = __webpack_require__(295);
	Stream.Duplex = __webpack_require__(296);
	Stream.Transform = __webpack_require__(297);
	Stream.PassThrough = __webpack_require__(298);
	
	// Backwards-compat with node 0.4.x
	Stream.Stream = Stream;
	
	
	
	// old-style streams.  Note that the pipe method (the only relevant
	// part of this class) is overridden in the Readable class.
	
	function Stream() {
	  EE.call(this);
	}
	
	Stream.prototype.pipe = function(dest, options) {
	  var source = this;
	
	  function ondata(chunk) {
	    if (dest.writable) {
	      if (false === dest.write(chunk) && source.pause) {
	        source.pause();
	      }
	    }
	  }
	
	  source.on('data', ondata);
	
	  function ondrain() {
	    if (source.readable && source.resume) {
	      source.resume();
	    }
	  }
	
	  dest.on('drain', ondrain);
	
	  // If the 'end' option is not supplied, dest.end() will be called when
	  // source gets the 'end' or 'close' events.  Only dest.end() once.
	  if (!dest._isStdio && (!options || options.end !== false)) {
	    source.on('end', onend);
	    source.on('close', onclose);
	  }
	
	  var didOnEnd = false;
	  function onend() {
	    if (didOnEnd) return;
	    didOnEnd = true;
	
	    dest.end();
	  }
	
	
	  function onclose() {
	    if (didOnEnd) return;
	    didOnEnd = true;
	
	    if (typeof dest.destroy === 'function') dest.destroy();
	  }
	
	  // don't leave dangling pipes when there are errors.
	  function onerror(er) {
	    cleanup();
	    if (EE.listenerCount(this, 'error') === 0) {
	      throw er; // Unhandled stream error in pipe.
	    }
	  }
	
	  source.on('error', onerror);
	  dest.on('error', onerror);
	
	  // remove all the event listeners that were added.
	  function cleanup() {
	    source.removeListener('data', ondata);
	    dest.removeListener('drain', ondrain);
	
	    source.removeListener('end', onend);
	    source.removeListener('close', onclose);
	
	    source.removeListener('error', onerror);
	    dest.removeListener('error', onerror);
	
	    source.removeListener('end', cleanup);
	    source.removeListener('close', cleanup);
	
	    dest.removeListener('close', cleanup);
	  }
	
	  source.on('end', cleanup);
	  source.on('close', cleanup);
	
	  dest.on('close', cleanup);
	
	  dest.emit('pipe', source);
	
	  // Allow for unix-like usage: A.pipe(B).pipe(C)
	  return dest;
	};


/***/ },
/* 279 */
235,
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(281);
	exports.Stream = __webpack_require__(278);
	exports.Readable = exports;
	exports.Writable = __webpack_require__(291);
	exports.Duplex = __webpack_require__(290);
	exports.Transform = __webpack_require__(293);
	exports.PassThrough = __webpack_require__(294);


/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	module.exports = Readable;
	
	/*<replacement>*/
	var isArray = __webpack_require__(282);
	/*</replacement>*/
	
	
	/*<replacement>*/
	var Buffer = __webpack_require__(283).Buffer;
	/*</replacement>*/
	
	Readable.ReadableState = ReadableState;
	
	var EE = __webpack_require__(276).EventEmitter;
	
	/*<replacement>*/
	if (!EE.listenerCount) EE.listenerCount = function(emitter, type) {
	  return emitter.listeners(type).length;
	};
	/*</replacement>*/
	
	var Stream = __webpack_require__(278);
	
	/*<replacement>*/
	var util = __webpack_require__(287);
	util.inherits = __webpack_require__(288);
	/*</replacement>*/
	
	var StringDecoder;
	
	
	/*<replacement>*/
	var debug = __webpack_require__(289);
	if (debug && debug.debuglog) {
	  debug = debug.debuglog('stream');
	} else {
	  debug = function () {};
	}
	/*</replacement>*/
	
	
	util.inherits(Readable, Stream);
	
	function ReadableState(options, stream) {
	  var Duplex = __webpack_require__(290);
	
	  options = options || {};
	
	  // the point at which it stops calling _read() to fill the buffer
	  // Note: 0 is a valid value, means "don't call _read preemptively ever"
	  var hwm = options.highWaterMark;
	  var defaultHwm = options.objectMode ? 16 : 16 * 1024;
	  this.highWaterMark = (hwm || hwm === 0) ? hwm : defaultHwm;
	
	  // cast to ints.
	  this.highWaterMark = ~~this.highWaterMark;
	
	  this.buffer = [];
	  this.length = 0;
	  this.pipes = null;
	  this.pipesCount = 0;
	  this.flowing = null;
	  this.ended = false;
	  this.endEmitted = false;
	  this.reading = false;
	
	  // a flag to be able to tell if the onwrite cb is called immediately,
	  // or on a later tick.  We set this to true at first, because any
	  // actions that shouldn't happen until "later" should generally also
	  // not happen before the first write call.
	  this.sync = true;
	
	  // whenever we return null, then we set a flag to say
	  // that we're awaiting a 'readable' event emission.
	  this.needReadable = false;
	  this.emittedReadable = false;
	  this.readableListening = false;
	
	
	  // object stream flag. Used to make read(n) ignore n and to
	  // make all the buffer merging and length checks go away
	  this.objectMode = !!options.objectMode;
	
	  if (stream instanceof Duplex)
	    this.objectMode = this.objectMode || !!options.readableObjectMode;
	
	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';
	
	  // when piping, we only care about 'readable' events that happen
	  // after read()ing all the bytes and not getting any pushback.
	  this.ranOut = false;
	
	  // the number of writers that are awaiting a drain event in .pipe()s
	  this.awaitDrain = 0;
	
	  // if true, a maybeReadMore has been scheduled
	  this.readingMore = false;
	
	  this.decoder = null;
	  this.encoding = null;
	  if (options.encoding) {
	    if (!StringDecoder)
	      StringDecoder = __webpack_require__(292).StringDecoder;
	    this.decoder = new StringDecoder(options.encoding);
	    this.encoding = options.encoding;
	  }
	}
	
	function Readable(options) {
	  var Duplex = __webpack_require__(290);
	
	  if (!(this instanceof Readable))
	    return new Readable(options);
	
	  this._readableState = new ReadableState(options, this);
	
	  // legacy
	  this.readable = true;
	
	  Stream.call(this);
	}
	
	// Manually shove something into the read() buffer.
	// This returns true if the highWaterMark has not been hit yet,
	// similar to how Writable.write() returns true if you should
	// write() some more.
	Readable.prototype.push = function(chunk, encoding) {
	  var state = this._readableState;
	
	  if (util.isString(chunk) && !state.objectMode) {
	    encoding = encoding || state.defaultEncoding;
	    if (encoding !== state.encoding) {
	      chunk = new Buffer(chunk, encoding);
	      encoding = '';
	    }
	  }
	
	  return readableAddChunk(this, state, chunk, encoding, false);
	};
	
	// Unshift should *always* be something directly out of read()
	Readable.prototype.unshift = function(chunk) {
	  var state = this._readableState;
	  return readableAddChunk(this, state, chunk, '', true);
	};
	
	function readableAddChunk(stream, state, chunk, encoding, addToFront) {
	  var er = chunkInvalid(state, chunk);
	  if (er) {
	    stream.emit('error', er);
	  } else if (util.isNullOrUndefined(chunk)) {
	    state.reading = false;
	    if (!state.ended)
	      onEofChunk(stream, state);
	  } else if (state.objectMode || chunk && chunk.length > 0) {
	    if (state.ended && !addToFront) {
	      var e = new Error('stream.push() after EOF');
	      stream.emit('error', e);
	    } else if (state.endEmitted && addToFront) {
	      var e = new Error('stream.unshift() after end event');
	      stream.emit('error', e);
	    } else {
	      if (state.decoder && !addToFront && !encoding)
	        chunk = state.decoder.write(chunk);
	
	      if (!addToFront)
	        state.reading = false;
	
	      // if we want the data now, just emit it.
	      if (state.flowing && state.length === 0 && !state.sync) {
	        stream.emit('data', chunk);
	        stream.read(0);
	      } else {
	        // update the buffer info.
	        state.length += state.objectMode ? 1 : chunk.length;
	        if (addToFront)
	          state.buffer.unshift(chunk);
	        else
	          state.buffer.push(chunk);
	
	        if (state.needReadable)
	          emitReadable(stream);
	      }
	
	      maybeReadMore(stream, state);
	    }
	  } else if (!addToFront) {
	    state.reading = false;
	  }
	
	  return needMoreData(state);
	}
	
	
	
	// if it's past the high water mark, we can push in some more.
	// Also, if we have no data yet, we can stand some
	// more bytes.  This is to work around cases where hwm=0,
	// such as the repl.  Also, if the push() triggered a
	// readable event, and the user called read(largeNumber) such that
	// needReadable was set, then we ought to push more, so that another
	// 'readable' event will be triggered.
	function needMoreData(state) {
	  return !state.ended &&
	         (state.needReadable ||
	          state.length < state.highWaterMark ||
	          state.length === 0);
	}
	
	// backwards compatibility.
	Readable.prototype.setEncoding = function(enc) {
	  if (!StringDecoder)
	    StringDecoder = __webpack_require__(292).StringDecoder;
	  this._readableState.decoder = new StringDecoder(enc);
	  this._readableState.encoding = enc;
	  return this;
	};
	
	// Don't raise the hwm > 128MB
	var MAX_HWM = 0x800000;
	function roundUpToNextPowerOf2(n) {
	  if (n >= MAX_HWM) {
	    n = MAX_HWM;
	  } else {
	    // Get the next highest power of 2
	    n--;
	    for (var p = 1; p < 32; p <<= 1) n |= n >> p;
	    n++;
	  }
	  return n;
	}
	
	function howMuchToRead(n, state) {
	  if (state.length === 0 && state.ended)
	    return 0;
	
	  if (state.objectMode)
	    return n === 0 ? 0 : 1;
	
	  if (isNaN(n) || util.isNull(n)) {
	    // only flow one buffer at a time
	    if (state.flowing && state.buffer.length)
	      return state.buffer[0].length;
	    else
	      return state.length;
	  }
	
	  if (n <= 0)
	    return 0;
	
	  // If we're asking for more than the target buffer level,
	  // then raise the water mark.  Bump up to the next highest
	  // power of 2, to prevent increasing it excessively in tiny
	  // amounts.
	  if (n > state.highWaterMark)
	    state.highWaterMark = roundUpToNextPowerOf2(n);
	
	  // don't have that much.  return null, unless we've ended.
	  if (n > state.length) {
	    if (!state.ended) {
	      state.needReadable = true;
	      return 0;
	    } else
	      return state.length;
	  }
	
	  return n;
	}
	
	// you can override either this method, or the async _read(n) below.
	Readable.prototype.read = function(n) {
	  debug('read', n);
	  var state = this._readableState;
	  var nOrig = n;
	
	  if (!util.isNumber(n) || n > 0)
	    state.emittedReadable = false;
	
	  // if we're doing read(0) to trigger a readable event, but we
	  // already have a bunch of data in the buffer, then just trigger
	  // the 'readable' event and move on.
	  if (n === 0 &&
	      state.needReadable &&
	      (state.length >= state.highWaterMark || state.ended)) {
	    debug('read: emitReadable', state.length, state.ended);
	    if (state.length === 0 && state.ended)
	      endReadable(this);
	    else
	      emitReadable(this);
	    return null;
	  }
	
	  n = howMuchToRead(n, state);
	
	  // if we've ended, and we're now clear, then finish it up.
	  if (n === 0 && state.ended) {
	    if (state.length === 0)
	      endReadable(this);
	    return null;
	  }
	
	  // All the actual chunk generation logic needs to be
	  // *below* the call to _read.  The reason is that in certain
	  // synthetic stream cases, such as passthrough streams, _read
	  // may be a completely synchronous operation which may change
	  // the state of the read buffer, providing enough data when
	  // before there was *not* enough.
	  //
	  // So, the steps are:
	  // 1. Figure out what the state of things will be after we do
	  // a read from the buffer.
	  //
	  // 2. If that resulting state will trigger a _read, then call _read.
	  // Note that this may be asynchronous, or synchronous.  Yes, it is
	  // deeply ugly to write APIs this way, but that still doesn't mean
	  // that the Readable class should behave improperly, as streams are
	  // designed to be sync/async agnostic.
	  // Take note if the _read call is sync or async (ie, if the read call
	  // has returned yet), so that we know whether or not it's safe to emit
	  // 'readable' etc.
	  //
	  // 3. Actually pull the requested chunks out of the buffer and return.
	
	  // if we need a readable event, then we need to do some reading.
	  var doRead = state.needReadable;
	  debug('need readable', doRead);
	
	  // if we currently have less than the highWaterMark, then also read some
	  if (state.length === 0 || state.length - n < state.highWaterMark) {
	    doRead = true;
	    debug('length less than watermark', doRead);
	  }
	
	  // however, if we've ended, then there's no point, and if we're already
	  // reading, then it's unnecessary.
	  if (state.ended || state.reading) {
	    doRead = false;
	    debug('reading or ended', doRead);
	  }
	
	  if (doRead) {
	    debug('do read');
	    state.reading = true;
	    state.sync = true;
	    // if the length is currently zero, then we *need* a readable event.
	    if (state.length === 0)
	      state.needReadable = true;
	    // call internal read method
	    this._read(state.highWaterMark);
	    state.sync = false;
	  }
	
	  // If _read pushed data synchronously, then `reading` will be false,
	  // and we need to re-evaluate how much data we can return to the user.
	  if (doRead && !state.reading)
	    n = howMuchToRead(nOrig, state);
	
	  var ret;
	  if (n > 0)
	    ret = fromList(n, state);
	  else
	    ret = null;
	
	  if (util.isNull(ret)) {
	    state.needReadable = true;
	    n = 0;
	  }
	
	  state.length -= n;
	
	  // If we have nothing in the buffer, then we want to know
	  // as soon as we *do* get something into the buffer.
	  if (state.length === 0 && !state.ended)
	    state.needReadable = true;
	
	  // If we tried to read() past the EOF, then emit end on the next tick.
	  if (nOrig !== n && state.ended && state.length === 0)
	    endReadable(this);
	
	  if (!util.isNull(ret))
	    this.emit('data', ret);
	
	  return ret;
	};
	
	function chunkInvalid(state, chunk) {
	  var er = null;
	  if (!util.isBuffer(chunk) &&
	      !util.isString(chunk) &&
	      !util.isNullOrUndefined(chunk) &&
	      !state.objectMode) {
	    er = new TypeError('Invalid non-string/buffer chunk');
	  }
	  return er;
	}
	
	
	function onEofChunk(stream, state) {
	  if (state.decoder && !state.ended) {
	    var chunk = state.decoder.end();
	    if (chunk && chunk.length) {
	      state.buffer.push(chunk);
	      state.length += state.objectMode ? 1 : chunk.length;
	    }
	  }
	  state.ended = true;
	
	  // emit 'readable' now to make sure it gets picked up.
	  emitReadable(stream);
	}
	
	// Don't emit readable right away in sync mode, because this can trigger
	// another read() call => stack overflow.  This way, it might trigger
	// a nextTick recursion warning, but that's not so bad.
	function emitReadable(stream) {
	  var state = stream._readableState;
	  state.needReadable = false;
	  if (!state.emittedReadable) {
	    debug('emitReadable', state.flowing);
	    state.emittedReadable = true;
	    if (state.sync)
	      process.nextTick(function() {
	        emitReadable_(stream);
	      });
	    else
	      emitReadable_(stream);
	  }
	}
	
	function emitReadable_(stream) {
	  debug('emit readable');
	  stream.emit('readable');
	  flow(stream);
	}
	
	
	// at this point, the user has presumably seen the 'readable' event,
	// and called read() to consume some data.  that may have triggered
	// in turn another _read(n) call, in which case reading = true if
	// it's in progress.
	// However, if we're not ended, or reading, and the length < hwm,
	// then go ahead and try to read some more preemptively.
	function maybeReadMore(stream, state) {
	  if (!state.readingMore) {
	    state.readingMore = true;
	    process.nextTick(function() {
	      maybeReadMore_(stream, state);
	    });
	  }
	}
	
	function maybeReadMore_(stream, state) {
	  var len = state.length;
	  while (!state.reading && !state.flowing && !state.ended &&
	         state.length < state.highWaterMark) {
	    debug('maybeReadMore read 0');
	    stream.read(0);
	    if (len === state.length)
	      // didn't get any data, stop spinning.
	      break;
	    else
	      len = state.length;
	  }
	  state.readingMore = false;
	}
	
	// abstract method.  to be overridden in specific implementation classes.
	// call cb(er, data) where data is <= n in length.
	// for virtual (non-string, non-buffer) streams, "length" is somewhat
	// arbitrary, and perhaps not very meaningful.
	Readable.prototype._read = function(n) {
	  this.emit('error', new Error('not implemented'));
	};
	
	Readable.prototype.pipe = function(dest, pipeOpts) {
	  var src = this;
	  var state = this._readableState;
	
	  switch (state.pipesCount) {
	    case 0:
	      state.pipes = dest;
	      break;
	    case 1:
	      state.pipes = [state.pipes, dest];
	      break;
	    default:
	      state.pipes.push(dest);
	      break;
	  }
	  state.pipesCount += 1;
	  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
	
	  var doEnd = (!pipeOpts || pipeOpts.end !== false) &&
	              dest !== process.stdout &&
	              dest !== process.stderr;
	
	  var endFn = doEnd ? onend : cleanup;
	  if (state.endEmitted)
	    process.nextTick(endFn);
	  else
	    src.once('end', endFn);
	
	  dest.on('unpipe', onunpipe);
	  function onunpipe(readable) {
	    debug('onunpipe');
	    if (readable === src) {
	      cleanup();
	    }
	  }
	
	  function onend() {
	    debug('onend');
	    dest.end();
	  }
	
	  // when the dest drains, it reduces the awaitDrain counter
	  // on the source.  This would be more elegant with a .once()
	  // handler in flow(), but adding and removing repeatedly is
	  // too slow.
	  var ondrain = pipeOnDrain(src);
	  dest.on('drain', ondrain);
	
	  function cleanup() {
	    debug('cleanup');
	    // cleanup event handlers once the pipe is broken
	    dest.removeListener('close', onclose);
	    dest.removeListener('finish', onfinish);
	    dest.removeListener('drain', ondrain);
	    dest.removeListener('error', onerror);
	    dest.removeListener('unpipe', onunpipe);
	    src.removeListener('end', onend);
	    src.removeListener('end', cleanup);
	    src.removeListener('data', ondata);
	
	    // if the reader is waiting for a drain event from this
	    // specific writer, then it would cause it to never start
	    // flowing again.
	    // So, if this is awaiting a drain, then we just call it now.
	    // If we don't know, then assume that we are waiting for one.
	    if (state.awaitDrain &&
	        (!dest._writableState || dest._writableState.needDrain))
	      ondrain();
	  }
	
	  src.on('data', ondata);
	  function ondata(chunk) {
	    debug('ondata');
	    var ret = dest.write(chunk);
	    if (false === ret) {
	      debug('false write response, pause',
	            src._readableState.awaitDrain);
	      src._readableState.awaitDrain++;
	      src.pause();
	    }
	  }
	
	  // if the dest has an error, then stop piping into it.
	  // however, don't suppress the throwing behavior for this.
	  function onerror(er) {
	    debug('onerror', er);
	    unpipe();
	    dest.removeListener('error', onerror);
	    if (EE.listenerCount(dest, 'error') === 0)
	      dest.emit('error', er);
	  }
	  // This is a brutally ugly hack to make sure that our error handler
	  // is attached before any userland ones.  NEVER DO THIS.
	  if (!dest._events || !dest._events.error)
	    dest.on('error', onerror);
	  else if (isArray(dest._events.error))
	    dest._events.error.unshift(onerror);
	  else
	    dest._events.error = [onerror, dest._events.error];
	
	
	
	  // Both close and finish should trigger unpipe, but only once.
	  function onclose() {
	    dest.removeListener('finish', onfinish);
	    unpipe();
	  }
	  dest.once('close', onclose);
	  function onfinish() {
	    debug('onfinish');
	    dest.removeListener('close', onclose);
	    unpipe();
	  }
	  dest.once('finish', onfinish);
	
	  function unpipe() {
	    debug('unpipe');
	    src.unpipe(dest);
	  }
	
	  // tell the dest that it's being piped to
	  dest.emit('pipe', src);
	
	  // start the flow if it hasn't been started already.
	  if (!state.flowing) {
	    debug('pipe resume');
	    src.resume();
	  }
	
	  return dest;
	};
	
	function pipeOnDrain(src) {
	  return function() {
	    var state = src._readableState;
	    debug('pipeOnDrain', state.awaitDrain);
	    if (state.awaitDrain)
	      state.awaitDrain--;
	    if (state.awaitDrain === 0 && EE.listenerCount(src, 'data')) {
	      state.flowing = true;
	      flow(src);
	    }
	  };
	}
	
	
	Readable.prototype.unpipe = function(dest) {
	  var state = this._readableState;
	
	  // if we're not piping anywhere, then do nothing.
	  if (state.pipesCount === 0)
	    return this;
	
	  // just one destination.  most common case.
	  if (state.pipesCount === 1) {
	    // passed in one, but it's not the right one.
	    if (dest && dest !== state.pipes)
	      return this;
	
	    if (!dest)
	      dest = state.pipes;
	
	    // got a match.
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	    if (dest)
	      dest.emit('unpipe', this);
	    return this;
	  }
	
	  // slow case. multiple pipe destinations.
	
	  if (!dest) {
	    // remove all.
	    var dests = state.pipes;
	    var len = state.pipesCount;
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	
	    for (var i = 0; i < len; i++)
	      dests[i].emit('unpipe', this);
	    return this;
	  }
	
	  // try to find the right one.
	  var i = indexOf(state.pipes, dest);
	  if (i === -1)
	    return this;
	
	  state.pipes.splice(i, 1);
	  state.pipesCount -= 1;
	  if (state.pipesCount === 1)
	    state.pipes = state.pipes[0];
	
	  dest.emit('unpipe', this);
	
	  return this;
	};
	
	// set up data events if they are asked for
	// Ensure readable listeners eventually get something
	Readable.prototype.on = function(ev, fn) {
	  var res = Stream.prototype.on.call(this, ev, fn);
	
	  // If listening to data, and it has not explicitly been paused,
	  // then call resume to start the flow of data on the next tick.
	  if (ev === 'data' && false !== this._readableState.flowing) {
	    this.resume();
	  }
	
	  if (ev === 'readable' && this.readable) {
	    var state = this._readableState;
	    if (!state.readableListening) {
	      state.readableListening = true;
	      state.emittedReadable = false;
	      state.needReadable = true;
	      if (!state.reading) {
	        var self = this;
	        process.nextTick(function() {
	          debug('readable nexttick read 0');
	          self.read(0);
	        });
	      } else if (state.length) {
	        emitReadable(this, state);
	      }
	    }
	  }
	
	  return res;
	};
	Readable.prototype.addListener = Readable.prototype.on;
	
	// pause() and resume() are remnants of the legacy readable stream API
	// If the user uses them, then switch into old mode.
	Readable.prototype.resume = function() {
	  var state = this._readableState;
	  if (!state.flowing) {
	    debug('resume');
	    state.flowing = true;
	    if (!state.reading) {
	      debug('resume read 0');
	      this.read(0);
	    }
	    resume(this, state);
	  }
	  return this;
	};
	
	function resume(stream, state) {
	  if (!state.resumeScheduled) {
	    state.resumeScheduled = true;
	    process.nextTick(function() {
	      resume_(stream, state);
	    });
	  }
	}
	
	function resume_(stream, state) {
	  state.resumeScheduled = false;
	  stream.emit('resume');
	  flow(stream);
	  if (state.flowing && !state.reading)
	    stream.read(0);
	}
	
	Readable.prototype.pause = function() {
	  debug('call pause flowing=%j', this._readableState.flowing);
	  if (false !== this._readableState.flowing) {
	    debug('pause');
	    this._readableState.flowing = false;
	    this.emit('pause');
	  }
	  return this;
	};
	
	function flow(stream) {
	  var state = stream._readableState;
	  debug('flow', state.flowing);
	  if (state.flowing) {
	    do {
	      var chunk = stream.read();
	    } while (null !== chunk && state.flowing);
	  }
	}
	
	// wrap an old-style stream as the async data source.
	// This is *not* part of the readable stream interface.
	// It is an ugly unfortunate mess of history.
	Readable.prototype.wrap = function(stream) {
	  var state = this._readableState;
	  var paused = false;
	
	  var self = this;
	  stream.on('end', function() {
	    debug('wrapped end');
	    if (state.decoder && !state.ended) {
	      var chunk = state.decoder.end();
	      if (chunk && chunk.length)
	        self.push(chunk);
	    }
	
	    self.push(null);
	  });
	
	  stream.on('data', function(chunk) {
	    debug('wrapped data');
	    if (state.decoder)
	      chunk = state.decoder.write(chunk);
	    if (!chunk || !state.objectMode && !chunk.length)
	      return;
	
	    var ret = self.push(chunk);
	    if (!ret) {
	      paused = true;
	      stream.pause();
	    }
	  });
	
	  // proxy all the other methods.
	  // important when wrapping filters and duplexes.
	  for (var i in stream) {
	    if (util.isFunction(stream[i]) && util.isUndefined(this[i])) {
	      this[i] = function(method) { return function() {
	        return stream[method].apply(stream, arguments);
	      }}(i);
	    }
	  }
	
	  // proxy certain important events.
	  var events = ['error', 'close', 'destroy', 'pause', 'resume'];
	  forEach(events, function(ev) {
	    stream.on(ev, self.emit.bind(self, ev));
	  });
	
	  // when we try to consume some more bytes, simply unpause the
	  // underlying stream.
	  self._read = function(n) {
	    debug('wrapped _read', n);
	    if (paused) {
	      paused = false;
	      stream.resume();
	    }
	  };
	
	  return self;
	};
	
	
	
	// exposed for testing purposes only.
	Readable._fromList = fromList;
	
	// Pluck off n bytes from an array of buffers.
	// Length is the combined lengths of all the buffers in the list.
	function fromList(n, state) {
	  var list = state.buffer;
	  var length = state.length;
	  var stringMode = !!state.decoder;
	  var objectMode = !!state.objectMode;
	  var ret;
	
	  // nothing in the list, definitely empty.
	  if (list.length === 0)
	    return null;
	
	  if (length === 0)
	    ret = null;
	  else if (objectMode)
	    ret = list.shift();
	  else if (!n || n >= length) {
	    // read it all, truncate the array.
	    if (stringMode)
	      ret = list.join('');
	    else
	      ret = Buffer.concat(list, length);
	    list.length = 0;
	  } else {
	    // read just some of it.
	    if (n < list[0].length) {
	      // just take a part of the first list item.
	      // slice is the same for buffers and strings.
	      var buf = list[0];
	      ret = buf.slice(0, n);
	      list[0] = buf.slice(n);
	    } else if (n === list[0].length) {
	      // first list is a perfect match
	      ret = list.shift();
	    } else {
	      // complex case.
	      // we have enough to cover it, but it spans past the first buffer.
	      if (stringMode)
	        ret = '';
	      else
	        ret = new Buffer(n);
	
	      var c = 0;
	      for (var i = 0, l = list.length; i < l && c < n; i++) {
	        var buf = list[0];
	        var cpy = Math.min(n - c, buf.length);
	
	        if (stringMode)
	          ret += buf.slice(0, cpy);
	        else
	          buf.copy(ret, c, 0, cpy);
	
	        if (cpy < buf.length)
	          list[0] = buf.slice(cpy);
	        else
	          list.shift();
	
	        c += cpy;
	      }
	    }
	  }
	
	  return ret;
	}
	
	function endReadable(stream) {
	  var state = stream._readableState;
	
	  // If we get here before consuming all the bytes, then that is a
	  // bug in node.  Should never happen.
	  if (state.length > 0)
	    throw new Error('endReadable called on non-empty stream');
	
	  if (!state.endEmitted) {
	    state.ended = true;
	    process.nextTick(function() {
	      // Check that we didn't get one last unshift.
	      if (!state.endEmitted && state.length === 0) {
	        state.endEmitted = true;
	        stream.readable = false;
	        stream.emit('end');
	      }
	    });
	  }
	}
	
	function forEach (xs, f) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    f(xs[i], i);
	  }
	}
	
	function indexOf (xs, x) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    if (xs[i] === x) return i;
	  }
	  return -1;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(233)))

/***/ },
/* 282 */
/***/ function(module, exports) {

	module.exports = Array.isArray || function (arr) {
	  return Object.prototype.toString.call(arr) == '[object Array]';
	};


/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer, global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	var base64 = __webpack_require__(284)
	var ieee754 = __webpack_require__(285)
	var isArray = __webpack_require__(286)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	Buffer.poolSize = 8192 // not used by this implementation
	
	var rootParent = {}
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Safari 5-7 lacks support for changing the `Object.prototype.constructor` property
	 *     on objects.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : (function () {
	      function Bar () {}
	      try {
	        var arr = new Uint8Array(1)
	        arr.foo = function () { return 42 }
	        arr.constructor = Bar
	        return arr.foo() === 42 && // typed array instances can be augmented
	            arr.constructor === Bar && // constructor can be set
	            typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	            arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	      } catch (e) {
	        return false
	      }
	    })()
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	/**
	 * Class: Buffer
	 * =============
	 *
	 * The Buffer constructor returns instances of `Uint8Array` that are augmented
	 * with function properties for all the node `Buffer` API functions. We use
	 * `Uint8Array` so that square bracket notation works as expected -- it returns
	 * a single octet.
	 *
	 * By augmenting the instances, we can avoid modifying the `Uint8Array`
	 * prototype.
	 */
	function Buffer (arg) {
	  if (!(this instanceof Buffer)) {
	    // Avoid going through an ArgumentsAdaptorTrampoline in the common case.
	    if (arguments.length > 1) return new Buffer(arg, arguments[1])
	    return new Buffer(arg)
	  }
	
	  this.length = 0
	  this.parent = undefined
	
	  // Common case.
	  if (typeof arg === 'number') {
	    return fromNumber(this, arg)
	  }
	
	  // Slightly less common case.
	  if (typeof arg === 'string') {
	    return fromString(this, arg, arguments.length > 1 ? arguments[1] : 'utf8')
	  }
	
	  // Unusual.
	  return fromObject(this, arg)
	}
	
	function fromNumber (that, length) {
	  that = allocate(that, length < 0 ? 0 : checked(length) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < length; i++) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8'
	
	  // Assumption: byteLength() return value is always < kMaxLength.
	  var length = byteLength(string, encoding) | 0
	  that = allocate(that, length)
	
	  that.write(string, encoding)
	  return that
	}
	
	function fromObject (that, object) {
	  if (Buffer.isBuffer(object)) return fromBuffer(that, object)
	
	  if (isArray(object)) return fromArray(that, object)
	
	  if (object == null) {
	    throw new TypeError('must start with number, buffer, array or string')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined') {
	    if (object.buffer instanceof ArrayBuffer) {
	      return fromTypedArray(that, object)
	    }
	    if (object instanceof ArrayBuffer) {
	      return fromArrayBuffer(that, object)
	    }
	  }
	
	  if (object.length) return fromArrayLike(that, object)
	
	  return fromJsonObject(that, object)
	}
	
	function fromBuffer (that, buffer) {
	  var length = checked(buffer.length) | 0
	  that = allocate(that, length)
	  buffer.copy(that, 0, 0, length)
	  return that
	}
	
	function fromArray (that, array) {
	  var length = checked(array.length) | 0
	  that = allocate(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	// Duplicate of fromArray() to keep fromArray() monomorphic.
	function fromTypedArray (that, array) {
	  var length = checked(array.length) | 0
	  that = allocate(that, length)
	  // Truncating the elements is probably not what people expect from typed
	  // arrays with BYTES_PER_ELEMENT > 1 but it's compatible with the behavior
	  // of the old Buffer constructor.
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array) {
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    array.byteLength
	    that = Buffer._augment(new Uint8Array(array))
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromTypedArray(that, new Uint8Array(array))
	  }
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = checked(array.length) | 0
	  that = allocate(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	// Deserialize { type: 'Buffer', data: [1,2,3,...] } into a Buffer object.
	// Returns a zero-length buffer for inputs that don't conform to the spec.
	function fromJsonObject (that, object) {
	  var array
	  var length = 0
	
	  if (object.type === 'Buffer' && isArray(object.data)) {
	    array = object.data
	    length = checked(array.length) | 0
	  }
	  that = allocate(that, length)
	
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	}
	
	function allocate (that, length) {
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = Buffer._augment(new Uint8Array(length))
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that.length = length
	    that._isBuffer = true
	  }
	
	  var fromPool = length !== 0 && length <= Buffer.poolSize >>> 1
	  if (fromPool) that.parent = rootParent
	
	  return that
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (subject, encoding) {
	  if (!(this instanceof SlowBuffer)) return new SlowBuffer(subject, encoding)
	
	  var buf = new Buffer(subject, encoding)
	  delete buf.parent
	  return buf
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  var i = 0
	  var len = Math.min(x, y)
	  while (i < len) {
	    if (a[i] !== b[i]) break
	
	    ++i
	  }
	
	  if (i !== len) {
	    x = a[i]
	    y = b[i]
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'binary':
	    case 'base64':
	    case 'raw':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) throw new TypeError('list argument must be an Array of Buffers.')
	
	  if (list.length === 0) {
	    return new Buffer(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; i++) {
	      length += list[i].length
	    }
	  }
	
	  var buf = new Buffer(length)
	  var pos = 0
	  for (i = 0; i < list.length; i++) {
	    var item = list[i]
	    item.copy(buf, pos)
	    pos += item.length
	  }
	  return buf
	}
	
	function byteLength (string, encoding) {
	  if (typeof string !== 'string') string = '' + string
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'binary':
	      // Deprecated
	      case 'raw':
	      case 'raws':
	        return len
	      case 'utf8':
	      case 'utf-8':
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	// pre-set for values that may exist in the future
	Buffer.prototype.length = undefined
	Buffer.prototype.parent = undefined
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  start = start | 0
	  end = end === undefined || end === Infinity ? this.length : end | 0
	
	  if (!encoding) encoding = 'utf8'
	  if (start < 0) start = 0
	  if (end > this.length) end = this.length
	  if (end <= start) return ''
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'binary':
	        return binarySlice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return 0
	  return Buffer.compare(this, b)
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset) {
	  if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff
	  else if (byteOffset < -0x80000000) byteOffset = -0x80000000
	  byteOffset >>= 0
	
	  if (this.length === 0) return -1
	  if (byteOffset >= this.length) return -1
	
	  // Negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = Math.max(this.length + byteOffset, 0)
	
	  if (typeof val === 'string') {
	    if (val.length === 0) return -1 // special case: looking for empty string always fails
	    return String.prototype.indexOf.call(this, val, byteOffset)
	  }
	  if (Buffer.isBuffer(val)) {
	    return arrayIndexOf(this, val, byteOffset)
	  }
	  if (typeof val === 'number') {
	    if (Buffer.TYPED_ARRAY_SUPPORT && Uint8Array.prototype.indexOf === 'function') {
	      return Uint8Array.prototype.indexOf.call(this, val, byteOffset)
	    }
	    return arrayIndexOf(this, [ val ], byteOffset)
	  }
	
	  function arrayIndexOf (arr, val, byteOffset) {
	    var foundIndex = -1
	    for (var i = 0; byteOffset + i < arr.length; i++) {
	      if (arr[byteOffset + i] === val[foundIndex === -1 ? 0 : i - foundIndex]) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === val.length) return byteOffset + foundIndex
	      } else {
	        foundIndex = -1
	      }
	    }
	    return -1
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	// `get` is deprecated
	Buffer.prototype.get = function get (offset) {
	  console.log('.get() is deprecated. Access using array indexes instead.')
	  return this.readUInt8(offset)
	}
	
	// `set` is deprecated
	Buffer.prototype.set = function set (v, offset) {
	  console.log('.set() is deprecated. Access using array indexes instead.')
	  return this.writeUInt8(v, offset)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new Error('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; i++) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) throw new Error('Invalid hex string')
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function binaryWrite (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    var swap = encoding
	    encoding = offset
	    offset = length | 0
	    length = swap
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'binary':
	        return binaryWrite(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; i++) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function binarySlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; i++) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; i++) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = Buffer._augment(this.subarray(start, end))
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; i++) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  if (newBuf.length) newBuf.parent = this.parent || this
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('buffer must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('value is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkInt(this, value, offset, byteLength, Math.pow(2, 8 * byteLength), 0)
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkInt(this, value, offset, byteLength, Math.pow(2, 8 * byteLength), 0)
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = value
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; i++) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = value
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = value
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; i++) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = value
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = value
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = value < 0 ? 1 : 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = value < 0 ? 1 : 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = value
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = value
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = value
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = value
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = value
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (value > max || value < min) throw new RangeError('value is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('index out of range')
	  if (offset < 0) throw new RangeError('index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; i--) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; i++) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    target._set(this.subarray(start, start + len), targetStart)
	  }
	
	  return len
	}
	
	// fill(value, start=0, end=buffer.length)
	Buffer.prototype.fill = function fill (value, start, end) {
	  if (!value) value = 0
	  if (!start) start = 0
	  if (!end) end = this.length
	
	  if (end < start) throw new RangeError('end < start')
	
	  // Fill 0 bytes; we're done
	  if (end === start) return
	  if (this.length === 0) return
	
	  if (start < 0 || start >= this.length) throw new RangeError('start out of bounds')
	  if (end < 0 || end > this.length) throw new RangeError('end out of bounds')
	
	  var i
	  if (typeof value === 'number') {
	    for (i = start; i < end; i++) {
	      this[i] = value
	    }
	  } else {
	    var bytes = utf8ToBytes(value.toString())
	    var len = bytes.length
	    for (i = start; i < end; i++) {
	      this[i] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	/**
	 * Creates a new `ArrayBuffer` with the *copied* memory of the buffer instance.
	 * Added in Node 0.12. Only available in browsers that support ArrayBuffer.
	 */
	Buffer.prototype.toArrayBuffer = function toArrayBuffer () {
	  if (typeof Uint8Array !== 'undefined') {
	    if (Buffer.TYPED_ARRAY_SUPPORT) {
	      return (new Buffer(this)).buffer
	    } else {
	      var buf = new Uint8Array(this.length)
	      for (var i = 0, len = buf.length; i < len; i += 1) {
	        buf[i] = this[i]
	      }
	      return buf.buffer
	    }
	  } else {
	    throw new TypeError('Buffer.toArrayBuffer not supported in this browser')
	  }
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var BP = Buffer.prototype
	
	/**
	 * Augment a Uint8Array *instance* (not the Uint8Array class!) with Buffer methods
	 */
	Buffer._augment = function _augment (arr) {
	  arr.constructor = Buffer
	  arr._isBuffer = true
	
	  // save reference to original Uint8Array set method before overwriting
	  arr._set = arr.set
	
	  // deprecated
	  arr.get = BP.get
	  arr.set = BP.set
	
	  arr.write = BP.write
	  arr.toString = BP.toString
	  arr.toLocaleString = BP.toString
	  arr.toJSON = BP.toJSON
	  arr.equals = BP.equals
	  arr.compare = BP.compare
	  arr.indexOf = BP.indexOf
	  arr.copy = BP.copy
	  arr.slice = BP.slice
	  arr.readUIntLE = BP.readUIntLE
	  arr.readUIntBE = BP.readUIntBE
	  arr.readUInt8 = BP.readUInt8
	  arr.readUInt16LE = BP.readUInt16LE
	  arr.readUInt16BE = BP.readUInt16BE
	  arr.readUInt32LE = BP.readUInt32LE
	  arr.readUInt32BE = BP.readUInt32BE
	  arr.readIntLE = BP.readIntLE
	  arr.readIntBE = BP.readIntBE
	  arr.readInt8 = BP.readInt8
	  arr.readInt16LE = BP.readInt16LE
	  arr.readInt16BE = BP.readInt16BE
	  arr.readInt32LE = BP.readInt32LE
	  arr.readInt32BE = BP.readInt32BE
	  arr.readFloatLE = BP.readFloatLE
	  arr.readFloatBE = BP.readFloatBE
	  arr.readDoubleLE = BP.readDoubleLE
	  arr.readDoubleBE = BP.readDoubleBE
	  arr.writeUInt8 = BP.writeUInt8
	  arr.writeUIntLE = BP.writeUIntLE
	  arr.writeUIntBE = BP.writeUIntBE
	  arr.writeUInt16LE = BP.writeUInt16LE
	  arr.writeUInt16BE = BP.writeUInt16BE
	  arr.writeUInt32LE = BP.writeUInt32LE
	  arr.writeUInt32BE = BP.writeUInt32BE
	  arr.writeIntLE = BP.writeIntLE
	  arr.writeIntBE = BP.writeIntBE
	  arr.writeInt8 = BP.writeInt8
	  arr.writeInt16LE = BP.writeInt16LE
	  arr.writeInt16BE = BP.writeInt16BE
	  arr.writeInt32LE = BP.writeInt32LE
	  arr.writeInt32BE = BP.writeInt32BE
	  arr.writeFloatLE = BP.writeFloatLE
	  arr.writeFloatBE = BP.writeFloatBE
	  arr.writeDoubleLE = BP.writeDoubleLE
	  arr.writeDoubleBE = BP.writeDoubleBE
	  arr.fill = BP.fill
	  arr.inspect = BP.inspect
	  arr.toArrayBuffer = BP.toArrayBuffer
	
	  return arr
	}
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; i++) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00 | 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; i++) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; i++) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; i++) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(283).Buffer, (function() { return this; }())))

/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

	var lookup = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
	
	;(function (exports) {
		'use strict';
	
	  var Arr = (typeof Uint8Array !== 'undefined')
	    ? Uint8Array
	    : Array
	
		var PLUS   = '+'.charCodeAt(0)
		var SLASH  = '/'.charCodeAt(0)
		var NUMBER = '0'.charCodeAt(0)
		var LOWER  = 'a'.charCodeAt(0)
		var UPPER  = 'A'.charCodeAt(0)
		var PLUS_URL_SAFE = '-'.charCodeAt(0)
		var SLASH_URL_SAFE = '_'.charCodeAt(0)
	
		function decode (elt) {
			var code = elt.charCodeAt(0)
			if (code === PLUS ||
			    code === PLUS_URL_SAFE)
				return 62 // '+'
			if (code === SLASH ||
			    code === SLASH_URL_SAFE)
				return 63 // '/'
			if (code < NUMBER)
				return -1 //no match
			if (code < NUMBER + 10)
				return code - NUMBER + 26 + 26
			if (code < UPPER + 26)
				return code - UPPER
			if (code < LOWER + 26)
				return code - LOWER + 26
		}
	
		function b64ToByteArray (b64) {
			var i, j, l, tmp, placeHolders, arr
	
			if (b64.length % 4 > 0) {
				throw new Error('Invalid string. Length must be a multiple of 4')
			}
	
			// the number of equal signs (place holders)
			// if there are two placeholders, than the two characters before it
			// represent one byte
			// if there is only one, then the three characters before it represent 2 bytes
			// this is just a cheap hack to not do indexOf twice
			var len = b64.length
			placeHolders = '=' === b64.charAt(len - 2) ? 2 : '=' === b64.charAt(len - 1) ? 1 : 0
	
			// base64 is 4/3 + up to two characters of the original data
			arr = new Arr(b64.length * 3 / 4 - placeHolders)
	
			// if there are placeholders, only get up to the last complete 4 chars
			l = placeHolders > 0 ? b64.length - 4 : b64.length
	
			var L = 0
	
			function push (v) {
				arr[L++] = v
			}
	
			for (i = 0, j = 0; i < l; i += 4, j += 3) {
				tmp = (decode(b64.charAt(i)) << 18) | (decode(b64.charAt(i + 1)) << 12) | (decode(b64.charAt(i + 2)) << 6) | decode(b64.charAt(i + 3))
				push((tmp & 0xFF0000) >> 16)
				push((tmp & 0xFF00) >> 8)
				push(tmp & 0xFF)
			}
	
			if (placeHolders === 2) {
				tmp = (decode(b64.charAt(i)) << 2) | (decode(b64.charAt(i + 1)) >> 4)
				push(tmp & 0xFF)
			} else if (placeHolders === 1) {
				tmp = (decode(b64.charAt(i)) << 10) | (decode(b64.charAt(i + 1)) << 4) | (decode(b64.charAt(i + 2)) >> 2)
				push((tmp >> 8) & 0xFF)
				push(tmp & 0xFF)
			}
	
			return arr
		}
	
		function uint8ToBase64 (uint8) {
			var i,
				extraBytes = uint8.length % 3, // if we have 1 byte left, pad 2 bytes
				output = "",
				temp, length
	
			function encode (num) {
				return lookup.charAt(num)
			}
	
			function tripletToBase64 (num) {
				return encode(num >> 18 & 0x3F) + encode(num >> 12 & 0x3F) + encode(num >> 6 & 0x3F) + encode(num & 0x3F)
			}
	
			// go through the array every three bytes, we'll deal with trailing stuff later
			for (i = 0, length = uint8.length - extraBytes; i < length; i += 3) {
				temp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2])
				output += tripletToBase64(temp)
			}
	
			// pad the end with zeros, but make sure to not forget the extra bytes
			switch (extraBytes) {
				case 1:
					temp = uint8[uint8.length - 1]
					output += encode(temp >> 2)
					output += encode((temp << 4) & 0x3F)
					output += '=='
					break
				case 2:
					temp = (uint8[uint8.length - 2] << 8) + (uint8[uint8.length - 1])
					output += encode(temp >> 10)
					output += encode((temp >> 4) & 0x3F)
					output += encode((temp << 2) & 0x3F)
					output += '='
					break
			}
	
			return output
		}
	
		exports.toByteArray = b64ToByteArray
		exports.fromByteArray = uint8ToBase64
	}( false ? (this.base64js = {}) : exports))


/***/ },
/* 285 */
/***/ function(module, exports) {

	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = nBytes * 8 - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = nBytes * 8 - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ },
/* 286 */
/***/ function(module, exports) {

	
	/**
	 * isArray
	 */
	
	var isArray = Array.isArray;
	
	/**
	 * toString
	 */
	
	var str = Object.prototype.toString;
	
	/**
	 * Whether or not the given `val`
	 * is an array.
	 *
	 * example:
	 *
	 *        isArray([]);
	 *        // > true
	 *        isArray(arguments);
	 *        // > false
	 *        isArray('');
	 *        // > false
	 *
	 * @param {mixed} val
	 * @return {bool}
	 */
	
	module.exports = isArray || function (val) {
	  return !! val && '[object Array]' == str.call(val);
	};


/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	function isArray(ar) {
	  return Array.isArray(ar);
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return isObject(re) && objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return isObject(d) && objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return isObject(e) &&
	      (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	function isBuffer(arg) {
	  return Buffer.isBuffer(arg);
	}
	exports.isBuffer = isBuffer;
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(283).Buffer))

/***/ },
/* 288 */
235,
/* 289 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a duplex stream is just a stream that is both readable and writable.
	// Since JS doesn't have multiple prototypal inheritance, this class
	// prototypally inherits from Readable, and then parasitically from
	// Writable.
	
	module.exports = Duplex;
	
	/*<replacement>*/
	var objectKeys = Object.keys || function (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}
	/*</replacement>*/
	
	
	/*<replacement>*/
	var util = __webpack_require__(287);
	util.inherits = __webpack_require__(288);
	/*</replacement>*/
	
	var Readable = __webpack_require__(281);
	var Writable = __webpack_require__(291);
	
	util.inherits(Duplex, Readable);
	
	forEach(objectKeys(Writable.prototype), function(method) {
	  if (!Duplex.prototype[method])
	    Duplex.prototype[method] = Writable.prototype[method];
	});
	
	function Duplex(options) {
	  if (!(this instanceof Duplex))
	    return new Duplex(options);
	
	  Readable.call(this, options);
	  Writable.call(this, options);
	
	  if (options && options.readable === false)
	    this.readable = false;
	
	  if (options && options.writable === false)
	    this.writable = false;
	
	  this.allowHalfOpen = true;
	  if (options && options.allowHalfOpen === false)
	    this.allowHalfOpen = false;
	
	  this.once('end', onend);
	}
	
	// the no-half-open enforcer
	function onend() {
	  // if we allow half-open state, or if the writable side ended,
	  // then we're ok.
	  if (this.allowHalfOpen || this._writableState.ended)
	    return;
	
	  // no more data can be written.
	  // But allow more writes to happen in this tick.
	  process.nextTick(this.end.bind(this));
	}
	
	function forEach (xs, f) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    f(xs[i], i);
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(233)))

/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// A bit simpler than readable streams.
	// Implement an async ._write(chunk, cb), and it'll handle all
	// the drain event emission and buffering.
	
	module.exports = Writable;
	
	/*<replacement>*/
	var Buffer = __webpack_require__(283).Buffer;
	/*</replacement>*/
	
	Writable.WritableState = WritableState;
	
	
	/*<replacement>*/
	var util = __webpack_require__(287);
	util.inherits = __webpack_require__(288);
	/*</replacement>*/
	
	var Stream = __webpack_require__(278);
	
	util.inherits(Writable, Stream);
	
	function WriteReq(chunk, encoding, cb) {
	  this.chunk = chunk;
	  this.encoding = encoding;
	  this.callback = cb;
	}
	
	function WritableState(options, stream) {
	  var Duplex = __webpack_require__(290);
	
	  options = options || {};
	
	  // the point at which write() starts returning false
	  // Note: 0 is a valid value, means that we always return false if
	  // the entire buffer is not flushed immediately on write()
	  var hwm = options.highWaterMark;
	  var defaultHwm = options.objectMode ? 16 : 16 * 1024;
	  this.highWaterMark = (hwm || hwm === 0) ? hwm : defaultHwm;
	
	  // object stream flag to indicate whether or not this stream
	  // contains buffers or objects.
	  this.objectMode = !!options.objectMode;
	
	  if (stream instanceof Duplex)
	    this.objectMode = this.objectMode || !!options.writableObjectMode;
	
	  // cast to ints.
	  this.highWaterMark = ~~this.highWaterMark;
	
	  this.needDrain = false;
	  // at the start of calling end()
	  this.ending = false;
	  // when end() has been called, and returned
	  this.ended = false;
	  // when 'finish' is emitted
	  this.finished = false;
	
	  // should we decode strings into buffers before passing to _write?
	  // this is here so that some node-core streams can optimize string
	  // handling at a lower level.
	  var noDecode = options.decodeStrings === false;
	  this.decodeStrings = !noDecode;
	
	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';
	
	  // not an actual buffer we keep track of, but a measurement
	  // of how much we're waiting to get pushed to some underlying
	  // socket or file.
	  this.length = 0;
	
	  // a flag to see when we're in the middle of a write.
	  this.writing = false;
	
	  // when true all writes will be buffered until .uncork() call
	  this.corked = 0;
	
	  // a flag to be able to tell if the onwrite cb is called immediately,
	  // or on a later tick.  We set this to true at first, because any
	  // actions that shouldn't happen until "later" should generally also
	  // not happen before the first write call.
	  this.sync = true;
	
	  // a flag to know if we're processing previously buffered items, which
	  // may call the _write() callback in the same tick, so that we don't
	  // end up in an overlapped onwrite situation.
	  this.bufferProcessing = false;
	
	  // the callback that's passed to _write(chunk,cb)
	  this.onwrite = function(er) {
	    onwrite(stream, er);
	  };
	
	  // the callback that the user supplies to write(chunk,encoding,cb)
	  this.writecb = null;
	
	  // the amount that is being written when _write is called.
	  this.writelen = 0;
	
	  this.buffer = [];
	
	  // number of pending user-supplied write callbacks
	  // this must be 0 before 'finish' can be emitted
	  this.pendingcb = 0;
	
	  // emit prefinish if the only thing we're waiting for is _write cbs
	  // This is relevant for synchronous Transform streams
	  this.prefinished = false;
	
	  // True if the error was already emitted and should not be thrown again
	  this.errorEmitted = false;
	}
	
	function Writable(options) {
	  var Duplex = __webpack_require__(290);
	
	  // Writable ctor is applied to Duplexes, though they're not
	  // instanceof Writable, they're instanceof Readable.
	  if (!(this instanceof Writable) && !(this instanceof Duplex))
	    return new Writable(options);
	
	  this._writableState = new WritableState(options, this);
	
	  // legacy.
	  this.writable = true;
	
	  Stream.call(this);
	}
	
	// Otherwise people can pipe Writable streams, which is just wrong.
	Writable.prototype.pipe = function() {
	  this.emit('error', new Error('Cannot pipe. Not readable.'));
	};
	
	
	function writeAfterEnd(stream, state, cb) {
	  var er = new Error('write after end');
	  // TODO: defer error events consistently everywhere, not just the cb
	  stream.emit('error', er);
	  process.nextTick(function() {
	    cb(er);
	  });
	}
	
	// If we get something that is not a buffer, string, null, or undefined,
	// and we're not in objectMode, then that's an error.
	// Otherwise stream chunks are all considered to be of length=1, and the
	// watermarks determine how many objects to keep in the buffer, rather than
	// how many bytes or characters.
	function validChunk(stream, state, chunk, cb) {
	  var valid = true;
	  if (!util.isBuffer(chunk) &&
	      !util.isString(chunk) &&
	      !util.isNullOrUndefined(chunk) &&
	      !state.objectMode) {
	    var er = new TypeError('Invalid non-string/buffer chunk');
	    stream.emit('error', er);
	    process.nextTick(function() {
	      cb(er);
	    });
	    valid = false;
	  }
	  return valid;
	}
	
	Writable.prototype.write = function(chunk, encoding, cb) {
	  var state = this._writableState;
	  var ret = false;
	
	  if (util.isFunction(encoding)) {
	    cb = encoding;
	    encoding = null;
	  }
	
	  if (util.isBuffer(chunk))
	    encoding = 'buffer';
	  else if (!encoding)
	    encoding = state.defaultEncoding;
	
	  if (!util.isFunction(cb))
	    cb = function() {};
	
	  if (state.ended)
	    writeAfterEnd(this, state, cb);
	  else if (validChunk(this, state, chunk, cb)) {
	    state.pendingcb++;
	    ret = writeOrBuffer(this, state, chunk, encoding, cb);
	  }
	
	  return ret;
	};
	
	Writable.prototype.cork = function() {
	  var state = this._writableState;
	
	  state.corked++;
	};
	
	Writable.prototype.uncork = function() {
	  var state = this._writableState;
	
	  if (state.corked) {
	    state.corked--;
	
	    if (!state.writing &&
	        !state.corked &&
	        !state.finished &&
	        !state.bufferProcessing &&
	        state.buffer.length)
	      clearBuffer(this, state);
	  }
	};
	
	function decodeChunk(state, chunk, encoding) {
	  if (!state.objectMode &&
	      state.decodeStrings !== false &&
	      util.isString(chunk)) {
	    chunk = new Buffer(chunk, encoding);
	  }
	  return chunk;
	}
	
	// if we're already writing something, then just put this
	// in the queue, and wait our turn.  Otherwise, call _write
	// If we return false, then we need a drain event, so set that flag.
	function writeOrBuffer(stream, state, chunk, encoding, cb) {
	  chunk = decodeChunk(state, chunk, encoding);
	  if (util.isBuffer(chunk))
	    encoding = 'buffer';
	  var len = state.objectMode ? 1 : chunk.length;
	
	  state.length += len;
	
	  var ret = state.length < state.highWaterMark;
	  // we must ensure that previous needDrain will not be reset to false.
	  if (!ret)
	    state.needDrain = true;
	
	  if (state.writing || state.corked)
	    state.buffer.push(new WriteReq(chunk, encoding, cb));
	  else
	    doWrite(stream, state, false, len, chunk, encoding, cb);
	
	  return ret;
	}
	
	function doWrite(stream, state, writev, len, chunk, encoding, cb) {
	  state.writelen = len;
	  state.writecb = cb;
	  state.writing = true;
	  state.sync = true;
	  if (writev)
	    stream._writev(chunk, state.onwrite);
	  else
	    stream._write(chunk, encoding, state.onwrite);
	  state.sync = false;
	}
	
	function onwriteError(stream, state, sync, er, cb) {
	  if (sync)
	    process.nextTick(function() {
	      state.pendingcb--;
	      cb(er);
	    });
	  else {
	    state.pendingcb--;
	    cb(er);
	  }
	
	  stream._writableState.errorEmitted = true;
	  stream.emit('error', er);
	}
	
	function onwriteStateUpdate(state) {
	  state.writing = false;
	  state.writecb = null;
	  state.length -= state.writelen;
	  state.writelen = 0;
	}
	
	function onwrite(stream, er) {
	  var state = stream._writableState;
	  var sync = state.sync;
	  var cb = state.writecb;
	
	  onwriteStateUpdate(state);
	
	  if (er)
	    onwriteError(stream, state, sync, er, cb);
	  else {
	    // Check if we're actually ready to finish, but don't emit yet
	    var finished = needFinish(stream, state);
	
	    if (!finished &&
	        !state.corked &&
	        !state.bufferProcessing &&
	        state.buffer.length) {
	      clearBuffer(stream, state);
	    }
	
	    if (sync) {
	      process.nextTick(function() {
	        afterWrite(stream, state, finished, cb);
	      });
	    } else {
	      afterWrite(stream, state, finished, cb);
	    }
	  }
	}
	
	function afterWrite(stream, state, finished, cb) {
	  if (!finished)
	    onwriteDrain(stream, state);
	  state.pendingcb--;
	  cb();
	  finishMaybe(stream, state);
	}
	
	// Must force callback to be called on nextTick, so that we don't
	// emit 'drain' before the write() consumer gets the 'false' return
	// value, and has a chance to attach a 'drain' listener.
	function onwriteDrain(stream, state) {
	  if (state.length === 0 && state.needDrain) {
	    state.needDrain = false;
	    stream.emit('drain');
	  }
	}
	
	
	// if there's something in the buffer waiting, then process it
	function clearBuffer(stream, state) {
	  state.bufferProcessing = true;
	
	  if (stream._writev && state.buffer.length > 1) {
	    // Fast case, write everything using _writev()
	    var cbs = [];
	    for (var c = 0; c < state.buffer.length; c++)
	      cbs.push(state.buffer[c].callback);
	
	    // count the one we are adding, as well.
	    // TODO(isaacs) clean this up
	    state.pendingcb++;
	    doWrite(stream, state, true, state.length, state.buffer, '', function(err) {
	      for (var i = 0; i < cbs.length; i++) {
	        state.pendingcb--;
	        cbs[i](err);
	      }
	    });
	
	    // Clear buffer
	    state.buffer = [];
	  } else {
	    // Slow case, write chunks one-by-one
	    for (var c = 0; c < state.buffer.length; c++) {
	      var entry = state.buffer[c];
	      var chunk = entry.chunk;
	      var encoding = entry.encoding;
	      var cb = entry.callback;
	      var len = state.objectMode ? 1 : chunk.length;
	
	      doWrite(stream, state, false, len, chunk, encoding, cb);
	
	      // if we didn't call the onwrite immediately, then
	      // it means that we need to wait until it does.
	      // also, that means that the chunk and cb are currently
	      // being processed, so move the buffer counter past them.
	      if (state.writing) {
	        c++;
	        break;
	      }
	    }
	
	    if (c < state.buffer.length)
	      state.buffer = state.buffer.slice(c);
	    else
	      state.buffer.length = 0;
	  }
	
	  state.bufferProcessing = false;
	}
	
	Writable.prototype._write = function(chunk, encoding, cb) {
	  cb(new Error('not implemented'));
	
	};
	
	Writable.prototype._writev = null;
	
	Writable.prototype.end = function(chunk, encoding, cb) {
	  var state = this._writableState;
	
	  if (util.isFunction(chunk)) {
	    cb = chunk;
	    chunk = null;
	    encoding = null;
	  } else if (util.isFunction(encoding)) {
	    cb = encoding;
	    encoding = null;
	  }
	
	  if (!util.isNullOrUndefined(chunk))
	    this.write(chunk, encoding);
	
	  // .end() fully uncorks
	  if (state.corked) {
	    state.corked = 1;
	    this.uncork();
	  }
	
	  // ignore unnecessary end() calls.
	  if (!state.ending && !state.finished)
	    endWritable(this, state, cb);
	};
	
	
	function needFinish(stream, state) {
	  return (state.ending &&
	          state.length === 0 &&
	          !state.finished &&
	          !state.writing);
	}
	
	function prefinish(stream, state) {
	  if (!state.prefinished) {
	    state.prefinished = true;
	    stream.emit('prefinish');
	  }
	}
	
	function finishMaybe(stream, state) {
	  var need = needFinish(stream, state);
	  if (need) {
	    if (state.pendingcb === 0) {
	      prefinish(stream, state);
	      state.finished = true;
	      stream.emit('finish');
	    } else
	      prefinish(stream, state);
	  }
	  return need;
	}
	
	function endWritable(stream, state, cb) {
	  state.ending = true;
	  finishMaybe(stream, state);
	  if (cb) {
	    if (state.finished)
	      process.nextTick(cb);
	    else
	      stream.once('finish', cb);
	  }
	  state.ended = true;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(233)))

/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var Buffer = __webpack_require__(283).Buffer;
	
	var isBufferEncoding = Buffer.isEncoding
	  || function(encoding) {
	       switch (encoding && encoding.toLowerCase()) {
	         case 'hex': case 'utf8': case 'utf-8': case 'ascii': case 'binary': case 'base64': case 'ucs2': case 'ucs-2': case 'utf16le': case 'utf-16le': case 'raw': return true;
	         default: return false;
	       }
	     }
	
	
	function assertEncoding(encoding) {
	  if (encoding && !isBufferEncoding(encoding)) {
	    throw new Error('Unknown encoding: ' + encoding);
	  }
	}
	
	// StringDecoder provides an interface for efficiently splitting a series of
	// buffers into a series of JS strings without breaking apart multi-byte
	// characters. CESU-8 is handled as part of the UTF-8 encoding.
	//
	// @TODO Handling all encodings inside a single object makes it very difficult
	// to reason about this code, so it should be split up in the future.
	// @TODO There should be a utf8-strict encoding that rejects invalid UTF-8 code
	// points as used by CESU-8.
	var StringDecoder = exports.StringDecoder = function(encoding) {
	  this.encoding = (encoding || 'utf8').toLowerCase().replace(/[-_]/, '');
	  assertEncoding(encoding);
	  switch (this.encoding) {
	    case 'utf8':
	      // CESU-8 represents each of Surrogate Pair by 3-bytes
	      this.surrogateSize = 3;
	      break;
	    case 'ucs2':
	    case 'utf16le':
	      // UTF-16 represents each of Surrogate Pair by 2-bytes
	      this.surrogateSize = 2;
	      this.detectIncompleteChar = utf16DetectIncompleteChar;
	      break;
	    case 'base64':
	      // Base-64 stores 3 bytes in 4 chars, and pads the remainder.
	      this.surrogateSize = 3;
	      this.detectIncompleteChar = base64DetectIncompleteChar;
	      break;
	    default:
	      this.write = passThroughWrite;
	      return;
	  }
	
	  // Enough space to store all bytes of a single character. UTF-8 needs 4
	  // bytes, but CESU-8 may require up to 6 (3 bytes per surrogate).
	  this.charBuffer = new Buffer(6);
	  // Number of bytes received for the current incomplete multi-byte character.
	  this.charReceived = 0;
	  // Number of bytes expected for the current incomplete multi-byte character.
	  this.charLength = 0;
	};
	
	
	// write decodes the given buffer and returns it as JS string that is
	// guaranteed to not contain any partial multi-byte characters. Any partial
	// character found at the end of the buffer is buffered up, and will be
	// returned when calling write again with the remaining bytes.
	//
	// Note: Converting a Buffer containing an orphan surrogate to a String
	// currently works, but converting a String to a Buffer (via `new Buffer`, or
	// Buffer#write) will replace incomplete surrogates with the unicode
	// replacement character. See https://codereview.chromium.org/121173009/ .
	StringDecoder.prototype.write = function(buffer) {
	  var charStr = '';
	  // if our last write ended with an incomplete multibyte character
	  while (this.charLength) {
	    // determine how many remaining bytes this buffer has to offer for this char
	    var available = (buffer.length >= this.charLength - this.charReceived) ?
	        this.charLength - this.charReceived :
	        buffer.length;
	
	    // add the new bytes to the char buffer
	    buffer.copy(this.charBuffer, this.charReceived, 0, available);
	    this.charReceived += available;
	
	    if (this.charReceived < this.charLength) {
	      // still not enough chars in this buffer? wait for more ...
	      return '';
	    }
	
	    // remove bytes belonging to the current character from the buffer
	    buffer = buffer.slice(available, buffer.length);
	
	    // get the character that was split
	    charStr = this.charBuffer.slice(0, this.charLength).toString(this.encoding);
	
	    // CESU-8: lead surrogate (D800-DBFF) is also the incomplete character
	    var charCode = charStr.charCodeAt(charStr.length - 1);
	    if (charCode >= 0xD800 && charCode <= 0xDBFF) {
	      this.charLength += this.surrogateSize;
	      charStr = '';
	      continue;
	    }
	    this.charReceived = this.charLength = 0;
	
	    // if there are no more bytes in this buffer, just emit our char
	    if (buffer.length === 0) {
	      return charStr;
	    }
	    break;
	  }
	
	  // determine and set charLength / charReceived
	  this.detectIncompleteChar(buffer);
	
	  var end = buffer.length;
	  if (this.charLength) {
	    // buffer the incomplete character bytes we got
	    buffer.copy(this.charBuffer, 0, buffer.length - this.charReceived, end);
	    end -= this.charReceived;
	  }
	
	  charStr += buffer.toString(this.encoding, 0, end);
	
	  var end = charStr.length - 1;
	  var charCode = charStr.charCodeAt(end);
	  // CESU-8: lead surrogate (D800-DBFF) is also the incomplete character
	  if (charCode >= 0xD800 && charCode <= 0xDBFF) {
	    var size = this.surrogateSize;
	    this.charLength += size;
	    this.charReceived += size;
	    this.charBuffer.copy(this.charBuffer, size, 0, size);
	    buffer.copy(this.charBuffer, 0, 0, size);
	    return charStr.substring(0, end);
	  }
	
	  // or just emit the charStr
	  return charStr;
	};
	
	// detectIncompleteChar determines if there is an incomplete UTF-8 character at
	// the end of the given buffer. If so, it sets this.charLength to the byte
	// length that character, and sets this.charReceived to the number of bytes
	// that are available for this character.
	StringDecoder.prototype.detectIncompleteChar = function(buffer) {
	  // determine how many bytes we have to check at the end of this buffer
	  var i = (buffer.length >= 3) ? 3 : buffer.length;
	
	  // Figure out if one of the last i bytes of our buffer announces an
	  // incomplete char.
	  for (; i > 0; i--) {
	    var c = buffer[buffer.length - i];
	
	    // See http://en.wikipedia.org/wiki/UTF-8#Description
	
	    // 110XXXXX
	    if (i == 1 && c >> 5 == 0x06) {
	      this.charLength = 2;
	      break;
	    }
	
	    // 1110XXXX
	    if (i <= 2 && c >> 4 == 0x0E) {
	      this.charLength = 3;
	      break;
	    }
	
	    // 11110XXX
	    if (i <= 3 && c >> 3 == 0x1E) {
	      this.charLength = 4;
	      break;
	    }
	  }
	  this.charReceived = i;
	};
	
	StringDecoder.prototype.end = function(buffer) {
	  var res = '';
	  if (buffer && buffer.length)
	    res = this.write(buffer);
	
	  if (this.charReceived) {
	    var cr = this.charReceived;
	    var buf = this.charBuffer;
	    var enc = this.encoding;
	    res += buf.slice(0, cr).toString(enc);
	  }
	
	  return res;
	};
	
	function passThroughWrite(buffer) {
	  return buffer.toString(this.encoding);
	}
	
	function utf16DetectIncompleteChar(buffer) {
	  this.charReceived = buffer.length % 2;
	  this.charLength = this.charReceived ? 2 : 0;
	}
	
	function base64DetectIncompleteChar(buffer) {
	  this.charReceived = buffer.length % 3;
	  this.charLength = this.charReceived ? 3 : 0;
	}


/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	
	// a transform stream is a readable/writable stream where you do
	// something with the data.  Sometimes it's called a "filter",
	// but that's not a great name for it, since that implies a thing where
	// some bits pass through, and others are simply ignored.  (That would
	// be a valid example of a transform, of course.)
	//
	// While the output is causally related to the input, it's not a
	// necessarily symmetric or synchronous transformation.  For example,
	// a zlib stream might take multiple plain-text writes(), and then
	// emit a single compressed chunk some time in the future.
	//
	// Here's how this works:
	//
	// The Transform stream has all the aspects of the readable and writable
	// stream classes.  When you write(chunk), that calls _write(chunk,cb)
	// internally, and returns false if there's a lot of pending writes
	// buffered up.  When you call read(), that calls _read(n) until
	// there's enough pending readable data buffered up.
	//
	// In a transform stream, the written data is placed in a buffer.  When
	// _read(n) is called, it transforms the queued up data, calling the
	// buffered _write cb's as it consumes chunks.  If consuming a single
	// written chunk would result in multiple output chunks, then the first
	// outputted bit calls the readcb, and subsequent chunks just go into
	// the read buffer, and will cause it to emit 'readable' if necessary.
	//
	// This way, back-pressure is actually determined by the reading side,
	// since _read has to be called to start processing a new chunk.  However,
	// a pathological inflate type of transform can cause excessive buffering
	// here.  For example, imagine a stream where every byte of input is
	// interpreted as an integer from 0-255, and then results in that many
	// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
	// 1kb of data being output.  In this case, you could write a very small
	// amount of input, and end up with a very large amount of output.  In
	// such a pathological inflating mechanism, there'd be no way to tell
	// the system to stop doing the transform.  A single 4MB write could
	// cause the system to run out of memory.
	//
	// However, even in such a pathological case, only a single written chunk
	// would be consumed, and then the rest would wait (un-transformed) until
	// the results of the previous transformed chunk were consumed.
	
	module.exports = Transform;
	
	var Duplex = __webpack_require__(290);
	
	/*<replacement>*/
	var util = __webpack_require__(287);
	util.inherits = __webpack_require__(288);
	/*</replacement>*/
	
	util.inherits(Transform, Duplex);
	
	
	function TransformState(options, stream) {
	  this.afterTransform = function(er, data) {
	    return afterTransform(stream, er, data);
	  };
	
	  this.needTransform = false;
	  this.transforming = false;
	  this.writecb = null;
	  this.writechunk = null;
	}
	
	function afterTransform(stream, er, data) {
	  var ts = stream._transformState;
	  ts.transforming = false;
	
	  var cb = ts.writecb;
	
	  if (!cb)
	    return stream.emit('error', new Error('no writecb in Transform class'));
	
	  ts.writechunk = null;
	  ts.writecb = null;
	
	  if (!util.isNullOrUndefined(data))
	    stream.push(data);
	
	  if (cb)
	    cb(er);
	
	  var rs = stream._readableState;
	  rs.reading = false;
	  if (rs.needReadable || rs.length < rs.highWaterMark) {
	    stream._read(rs.highWaterMark);
	  }
	}
	
	
	function Transform(options) {
	  if (!(this instanceof Transform))
	    return new Transform(options);
	
	  Duplex.call(this, options);
	
	  this._transformState = new TransformState(options, this);
	
	  // when the writable side finishes, then flush out anything remaining.
	  var stream = this;
	
	  // start out asking for a readable event once data is transformed.
	  this._readableState.needReadable = true;
	
	  // we have implemented the _read method, and done the other things
	  // that Readable wants before the first _read call, so unset the
	  // sync guard flag.
	  this._readableState.sync = false;
	
	  this.once('prefinish', function() {
	    if (util.isFunction(this._flush))
	      this._flush(function(er) {
	        done(stream, er);
	      });
	    else
	      done(stream);
	  });
	}
	
	Transform.prototype.push = function(chunk, encoding) {
	  this._transformState.needTransform = false;
	  return Duplex.prototype.push.call(this, chunk, encoding);
	};
	
	// This is the part where you do stuff!
	// override this function in implementation classes.
	// 'chunk' is an input chunk.
	//
	// Call `push(newChunk)` to pass along transformed output
	// to the readable side.  You may call 'push' zero or more times.
	//
	// Call `cb(err)` when you are done with this chunk.  If you pass
	// an error, then that'll put the hurt on the whole operation.  If you
	// never call cb(), then you'll never get another chunk.
	Transform.prototype._transform = function(chunk, encoding, cb) {
	  throw new Error('not implemented');
	};
	
	Transform.prototype._write = function(chunk, encoding, cb) {
	  var ts = this._transformState;
	  ts.writecb = cb;
	  ts.writechunk = chunk;
	  ts.writeencoding = encoding;
	  if (!ts.transforming) {
	    var rs = this._readableState;
	    if (ts.needTransform ||
	        rs.needReadable ||
	        rs.length < rs.highWaterMark)
	      this._read(rs.highWaterMark);
	  }
	};
	
	// Doesn't matter what the args are here.
	// _transform does all the work.
	// That we got here means that the readable side wants more data.
	Transform.prototype._read = function(n) {
	  var ts = this._transformState;
	
	  if (!util.isNull(ts.writechunk) && ts.writecb && !ts.transforming) {
	    ts.transforming = true;
	    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
	  } else {
	    // mark that we need a transform, so that any data that comes in
	    // will get processed, now that we've asked for it.
	    ts.needTransform = true;
	  }
	};
	
	
	function done(stream, er) {
	  if (er)
	    return stream.emit('error', er);
	
	  // if there's nothing in the write buffer, then that means
	  // that nothing more will ever be provided
	  var ws = stream._writableState;
	  var ts = stream._transformState;
	
	  if (ws.length)
	    throw new Error('calling transform done when ws.length != 0');
	
	  if (ts.transforming)
	    throw new Error('calling transform done when still transforming');
	
	  return stream.push(null);
	}


/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a passthrough stream.
	// basically just the most minimal sort of Transform stream.
	// Every written chunk gets output as-is.
	
	module.exports = PassThrough;
	
	var Transform = __webpack_require__(293);
	
	/*<replacement>*/
	var util = __webpack_require__(287);
	util.inherits = __webpack_require__(288);
	/*</replacement>*/
	
	util.inherits(PassThrough, Transform);
	
	function PassThrough(options) {
	  if (!(this instanceof PassThrough))
	    return new PassThrough(options);
	
	  Transform.call(this, options);
	}
	
	PassThrough.prototype._transform = function(chunk, encoding, cb) {
	  cb(null, chunk);
	};


/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(291)


/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(290)


/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(293)


/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(294)


/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	var Stream = __webpack_require__(278);
	var util = __webpack_require__(232);
	
	var Response = module.exports = function (res) {
	    this.offset = 0;
	    this.readable = true;
	};
	
	util.inherits(Response, Stream);
	
	var capable = {
	    streaming : true,
	    status2 : true
	};
	
	function parseHeaders (res) {
	    var lines = res.getAllResponseHeaders().split(/\r?\n/);
	    var headers = {};
	    for (var i = 0; i < lines.length; i++) {
	        var line = lines[i];
	        if (line === '') continue;
	        
	        var m = line.match(/^([^:]+):\s*(.*)/);
	        if (m) {
	            var key = m[1].toLowerCase(), value = m[2];
	            
	            if (headers[key] !== undefined) {
	            
	                if (isArray(headers[key])) {
	                    headers[key].push(value);
	                }
	                else {
	                    headers[key] = [ headers[key], value ];
	                }
	            }
	            else {
	                headers[key] = value;
	            }
	        }
	        else {
	            headers[line] = true;
	        }
	    }
	    return headers;
	}
	
	Response.prototype.getResponse = function (xhr) {
	    var respType = String(xhr.responseType).toLowerCase();
	    if (respType === 'blob') return xhr.responseBlob || xhr.response;
	    if (respType === 'arraybuffer') return xhr.response;
	    return xhr.responseText;
	}
	
	Response.prototype.getHeader = function (key) {
	    return this.headers[key.toLowerCase()];
	};
	
	Response.prototype.handle = function (res) {
	    if (res.readyState === 2 && capable.status2) {
	        try {
	            this.statusCode = res.status;
	            this.headers = parseHeaders(res);
	        }
	        catch (err) {
	            capable.status2 = false;
	        }
	        
	        if (capable.status2) {
	            this.emit('ready');
	        }
	    }
	    else if (capable.streaming && res.readyState === 3) {
	        try {
	            if (!this.statusCode) {
	                this.statusCode = res.status;
	                this.headers = parseHeaders(res);
	                this.emit('ready');
	            }
	        }
	        catch (err) {}
	        
	        try {
	            this._emitData(res);
	        }
	        catch (err) {
	            capable.streaming = false;
	        }
	    }
	    else if (res.readyState === 4) {
	        if (!this.statusCode) {
	            this.statusCode = res.status;
	            this.emit('ready');
	        }
	        this._emitData(res);
	        
	        if (res.error) {
	            this.emit('error', this.getResponse(res));
	        }
	        else this.emit('end');
	        
	        this.emit('close');
	    }
	};
	
	Response.prototype._emitData = function (res) {
	    var respBody = this.getResponse(res);
	    if (respBody.toString().match(/ArrayBuffer/)) {
	        this.emit('data', new Uint8Array(respBody, this.offset));
	        this.offset = respBody.byteLength;
	        return;
	    }
	    if (respBody.length > this.offset) {
	        this.emit('data', respBody.slice(this.offset));
	        this.offset = respBody.length;
	    }
	};
	
	var isArray = Array.isArray || function (xs) {
	    return Object.prototype.toString.call(xs) === '[object Array]';
	};


/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	;(function () {
	
	  var object =  true ? exports : this; // #8: web workers
	  var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	
	  function InvalidCharacterError(message) {
	    this.message = message;
	  }
	  InvalidCharacterError.prototype = new Error;
	  InvalidCharacterError.prototype.name = 'InvalidCharacterError';
	
	  // encoder
	  // [https://gist.github.com/999166] by [https://github.com/nignag]
	  object.btoa || (
	  object.btoa = function (input) {
	    for (
	      // initialize result and counter
	      var block, charCode, idx = 0, map = chars, output = '';
	      // if the next input index does not exist:
	      //   change the mapping table to "="
	      //   check if d has no fractional digits
	      input.charAt(idx | 0) || (map = '=', idx % 1);
	      // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
	      output += map.charAt(63 & block >> 8 - idx % 1 * 8)
	    ) {
	      charCode = input.charCodeAt(idx += 3/4);
	      if (charCode > 0xFF) {
	        throw new InvalidCharacterError("'btoa' failed: The string to be encoded contains characters outside of the Latin1 range.");
	      }
	      block = block << 8 | charCode;
	    }
	    return output;
	  });
	
	  // decoder
	  // [https://gist.github.com/1020396] by [https://github.com/atk]
	  object.atob || (
	  object.atob = function (input) {
	    input = input.replace(/=+$/, '');
	    if (input.length % 4 == 1) {
	      throw new InvalidCharacterError("'atob' failed: The string to be decoded is not correctly encoded.");
	    }
	    for (
	      // initialize result and counters
	      var bc = 0, bs, buffer, idx = 0, output = '';
	      // get next character
	      buffer = input.charAt(idx++);
	      // character found in table? initialize bit storage and add its ascii value;
	      ~buffer && (bs = bc % 4 ? bs * 64 + buffer : buffer,
	        // and if not first of each 4 characters,
	        // convert the first 8 bits to one ascii character
	        bc++ % 4) ? output += String.fromCharCode(255 & bs >> (-2 * bc & 6)) : 0
	    ) {
	      // try to find character in table (0-63, not found => -1)
	      buffer = chars.indexOf(buffer);
	    }
	    return output;
	  });
	
	}());


/***/ },
/* 301 */
235,
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var punycode = __webpack_require__(303);
	
	exports.parse = urlParse;
	exports.resolve = urlResolve;
	exports.resolveObject = urlResolveObject;
	exports.format = urlFormat;
	
	exports.Url = Url;
	
	function Url() {
	  this.protocol = null;
	  this.slashes = null;
	  this.auth = null;
	  this.host = null;
	  this.port = null;
	  this.hostname = null;
	  this.hash = null;
	  this.search = null;
	  this.query = null;
	  this.pathname = null;
	  this.path = null;
	  this.href = null;
	}
	
	// Reference: RFC 3986, RFC 1808, RFC 2396
	
	// define these here so at least they only have to be
	// compiled once on the first module load.
	var protocolPattern = /^([a-z0-9.+-]+:)/i,
	    portPattern = /:[0-9]*$/,
	
	    // RFC 2396: characters reserved for delimiting URLs.
	    // We actually just auto-escape these.
	    delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],
	
	    // RFC 2396: characters not allowed for various reasons.
	    unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),
	
	    // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
	    autoEscape = ['\''].concat(unwise),
	    // Characters that are never ever allowed in a hostname.
	    // Note that any invalid chars are also handled, but these
	    // are the ones that are *expected* to be seen, so we fast-path
	    // them.
	    nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
	    hostEndingChars = ['/', '?', '#'],
	    hostnameMaxLen = 255,
	    hostnamePartPattern = /^[a-z0-9A-Z_-]{0,63}$/,
	    hostnamePartStart = /^([a-z0-9A-Z_-]{0,63})(.*)$/,
	    // protocols that can allow "unsafe" and "unwise" chars.
	    unsafeProtocol = {
	      'javascript': true,
	      'javascript:': true
	    },
	    // protocols that never have a hostname.
	    hostlessProtocol = {
	      'javascript': true,
	      'javascript:': true
	    },
	    // protocols that always contain a // bit.
	    slashedProtocol = {
	      'http': true,
	      'https': true,
	      'ftp': true,
	      'gopher': true,
	      'file': true,
	      'http:': true,
	      'https:': true,
	      'ftp:': true,
	      'gopher:': true,
	      'file:': true
	    },
	    querystring = __webpack_require__(304);
	
	function urlParse(url, parseQueryString, slashesDenoteHost) {
	  if (url && isObject(url) && url instanceof Url) return url;
	
	  var u = new Url;
	  u.parse(url, parseQueryString, slashesDenoteHost);
	  return u;
	}
	
	Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
	  if (!isString(url)) {
	    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
	  }
	
	  var rest = url;
	
	  // trim before proceeding.
	  // This is to support parse stuff like "  http://foo.com  \n"
	  rest = rest.trim();
	
	  var proto = protocolPattern.exec(rest);
	  if (proto) {
	    proto = proto[0];
	    var lowerProto = proto.toLowerCase();
	    this.protocol = lowerProto;
	    rest = rest.substr(proto.length);
	  }
	
	  // figure out if it's got a host
	  // user@server is *always* interpreted as a hostname, and url
	  // resolution will treat //foo/bar as host=foo,path=bar because that's
	  // how the browser resolves relative URLs.
	  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
	    var slashes = rest.substr(0, 2) === '//';
	    if (slashes && !(proto && hostlessProtocol[proto])) {
	      rest = rest.substr(2);
	      this.slashes = true;
	    }
	  }
	
	  if (!hostlessProtocol[proto] &&
	      (slashes || (proto && !slashedProtocol[proto]))) {
	
	    // there's a hostname.
	    // the first instance of /, ?, ;, or # ends the host.
	    //
	    // If there is an @ in the hostname, then non-host chars *are* allowed
	    // to the left of the last @ sign, unless some host-ending character
	    // comes *before* the @-sign.
	    // URLs are obnoxious.
	    //
	    // ex:
	    // http://a@b@c/ => user:a@b host:c
	    // http://a@b?@c => user:a host:c path:/?@c
	
	    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
	    // Review our test case against browsers more comprehensively.
	
	    // find the first instance of any hostEndingChars
	    var hostEnd = -1;
	    for (var i = 0; i < hostEndingChars.length; i++) {
	      var hec = rest.indexOf(hostEndingChars[i]);
	      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
	        hostEnd = hec;
	    }
	
	    // at this point, either we have an explicit point where the
	    // auth portion cannot go past, or the last @ char is the decider.
	    var auth, atSign;
	    if (hostEnd === -1) {
	      // atSign can be anywhere.
	      atSign = rest.lastIndexOf('@');
	    } else {
	      // atSign must be in auth portion.
	      // http://a@b/c@d => host:b auth:a path:/c@d
	      atSign = rest.lastIndexOf('@', hostEnd);
	    }
	
	    // Now we have a portion which is definitely the auth.
	    // Pull that off.
	    if (atSign !== -1) {
	      auth = rest.slice(0, atSign);
	      rest = rest.slice(atSign + 1);
	      this.auth = decodeURIComponent(auth);
	    }
	
	    // the host is the remaining to the left of the first non-host char
	    hostEnd = -1;
	    for (var i = 0; i < nonHostChars.length; i++) {
	      var hec = rest.indexOf(nonHostChars[i]);
	      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
	        hostEnd = hec;
	    }
	    // if we still have not hit it, then the entire thing is a host.
	    if (hostEnd === -1)
	      hostEnd = rest.length;
	
	    this.host = rest.slice(0, hostEnd);
	    rest = rest.slice(hostEnd);
	
	    // pull out port.
	    this.parseHost();
	
	    // we've indicated that there is a hostname,
	    // so even if it's empty, it has to be present.
	    this.hostname = this.hostname || '';
	
	    // if hostname begins with [ and ends with ]
	    // assume that it's an IPv6 address.
	    var ipv6Hostname = this.hostname[0] === '[' &&
	        this.hostname[this.hostname.length - 1] === ']';
	
	    // validate a little.
	    if (!ipv6Hostname) {
	      var hostparts = this.hostname.split(/\./);
	      for (var i = 0, l = hostparts.length; i < l; i++) {
	        var part = hostparts[i];
	        if (!part) continue;
	        if (!part.match(hostnamePartPattern)) {
	          var newpart = '';
	          for (var j = 0, k = part.length; j < k; j++) {
	            if (part.charCodeAt(j) > 127) {
	              // we replace non-ASCII char with a temporary placeholder
	              // we need this to make sure size of hostname is not
	              // broken by replacing non-ASCII by nothing
	              newpart += 'x';
	            } else {
	              newpart += part[j];
	            }
	          }
	          // we test again with ASCII char only
	          if (!newpart.match(hostnamePartPattern)) {
	            var validParts = hostparts.slice(0, i);
	            var notHost = hostparts.slice(i + 1);
	            var bit = part.match(hostnamePartStart);
	            if (bit) {
	              validParts.push(bit[1]);
	              notHost.unshift(bit[2]);
	            }
	            if (notHost.length) {
	              rest = '/' + notHost.join('.') + rest;
	            }
	            this.hostname = validParts.join('.');
	            break;
	          }
	        }
	      }
	    }
	
	    if (this.hostname.length > hostnameMaxLen) {
	      this.hostname = '';
	    } else {
	      // hostnames are always lower case.
	      this.hostname = this.hostname.toLowerCase();
	    }
	
	    if (!ipv6Hostname) {
	      // IDNA Support: Returns a puny coded representation of "domain".
	      // It only converts the part of the domain name that
	      // has non ASCII characters. I.e. it dosent matter if
	      // you call it with a domain that already is in ASCII.
	      var domainArray = this.hostname.split('.');
	      var newOut = [];
	      for (var i = 0; i < domainArray.length; ++i) {
	        var s = domainArray[i];
	        newOut.push(s.match(/[^A-Za-z0-9_-]/) ?
	            'xn--' + punycode.encode(s) : s);
	      }
	      this.hostname = newOut.join('.');
	    }
	
	    var p = this.port ? ':' + this.port : '';
	    var h = this.hostname || '';
	    this.host = h + p;
	    this.href += this.host;
	
	    // strip [ and ] from the hostname
	    // the host field still retains them, though
	    if (ipv6Hostname) {
	      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
	      if (rest[0] !== '/') {
	        rest = '/' + rest;
	      }
	    }
	  }
	
	  // now rest is set to the post-host stuff.
	  // chop off any delim chars.
	  if (!unsafeProtocol[lowerProto]) {
	
	    // First, make 100% sure that any "autoEscape" chars get
	    // escaped, even if encodeURIComponent doesn't think they
	    // need to be.
	    for (var i = 0, l = autoEscape.length; i < l; i++) {
	      var ae = autoEscape[i];
	      var esc = encodeURIComponent(ae);
	      if (esc === ae) {
	        esc = escape(ae);
	      }
	      rest = rest.split(ae).join(esc);
	    }
	  }
	
	
	  // chop off from the tail first.
	  var hash = rest.indexOf('#');
	  if (hash !== -1) {
	    // got a fragment string.
	    this.hash = rest.substr(hash);
	    rest = rest.slice(0, hash);
	  }
	  var qm = rest.indexOf('?');
	  if (qm !== -1) {
	    this.search = rest.substr(qm);
	    this.query = rest.substr(qm + 1);
	    if (parseQueryString) {
	      this.query = querystring.parse(this.query);
	    }
	    rest = rest.slice(0, qm);
	  } else if (parseQueryString) {
	    // no query string, but parseQueryString still requested
	    this.search = '';
	    this.query = {};
	  }
	  if (rest) this.pathname = rest;
	  if (slashedProtocol[lowerProto] &&
	      this.hostname && !this.pathname) {
	    this.pathname = '/';
	  }
	
	  //to support http.request
	  if (this.pathname || this.search) {
	    var p = this.pathname || '';
	    var s = this.search || '';
	    this.path = p + s;
	  }
	
	  // finally, reconstruct the href based on what has been validated.
	  this.href = this.format();
	  return this;
	};
	
	// format a parsed object into a url string
	function urlFormat(obj) {
	  // ensure it's an object, and not a string url.
	  // If it's an obj, this is a no-op.
	  // this way, you can call url_format() on strings
	  // to clean up potentially wonky urls.
	  if (isString(obj)) obj = urlParse(obj);
	  if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
	  return obj.format();
	}
	
	Url.prototype.format = function() {
	  var auth = this.auth || '';
	  if (auth) {
	    auth = encodeURIComponent(auth);
	    auth = auth.replace(/%3A/i, ':');
	    auth += '@';
	  }
	
	  var protocol = this.protocol || '',
	      pathname = this.pathname || '',
	      hash = this.hash || '',
	      host = false,
	      query = '';
	
	  if (this.host) {
	    host = auth + this.host;
	  } else if (this.hostname) {
	    host = auth + (this.hostname.indexOf(':') === -1 ?
	        this.hostname :
	        '[' + this.hostname + ']');
	    if (this.port) {
	      host += ':' + this.port;
	    }
	  }
	
	  if (this.query &&
	      isObject(this.query) &&
	      Object.keys(this.query).length) {
	    query = querystring.stringify(this.query);
	  }
	
	  var search = this.search || (query && ('?' + query)) || '';
	
	  if (protocol && protocol.substr(-1) !== ':') protocol += ':';
	
	  // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
	  // unless they had them to begin with.
	  if (this.slashes ||
	      (!protocol || slashedProtocol[protocol]) && host !== false) {
	    host = '//' + (host || '');
	    if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
	  } else if (!host) {
	    host = '';
	  }
	
	  if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
	  if (search && search.charAt(0) !== '?') search = '?' + search;
	
	  pathname = pathname.replace(/[?#]/g, function(match) {
	    return encodeURIComponent(match);
	  });
	  search = search.replace('#', '%23');
	
	  return protocol + host + pathname + search + hash;
	};
	
	function urlResolve(source, relative) {
	  return urlParse(source, false, true).resolve(relative);
	}
	
	Url.prototype.resolve = function(relative) {
	  return this.resolveObject(urlParse(relative, false, true)).format();
	};
	
	function urlResolveObject(source, relative) {
	  if (!source) return relative;
	  return urlParse(source, false, true).resolveObject(relative);
	}
	
	Url.prototype.resolveObject = function(relative) {
	  if (isString(relative)) {
	    var rel = new Url();
	    rel.parse(relative, false, true);
	    relative = rel;
	  }
	
	  var result = new Url();
	  Object.keys(this).forEach(function(k) {
	    result[k] = this[k];
	  }, this);
	
	  // hash is always overridden, no matter what.
	  // even href="" will remove it.
	  result.hash = relative.hash;
	
	  // if the relative url is empty, then there's nothing left to do here.
	  if (relative.href === '') {
	    result.href = result.format();
	    return result;
	  }
	
	  // hrefs like //foo/bar always cut to the protocol.
	  if (relative.slashes && !relative.protocol) {
	    // take everything except the protocol from relative
	    Object.keys(relative).forEach(function(k) {
	      if (k !== 'protocol')
	        result[k] = relative[k];
	    });
	
	    //urlParse appends trailing / to urls like http://www.example.com
	    if (slashedProtocol[result.protocol] &&
	        result.hostname && !result.pathname) {
	      result.path = result.pathname = '/';
	    }
	
	    result.href = result.format();
	    return result;
	  }
	
	  if (relative.protocol && relative.protocol !== result.protocol) {
	    // if it's a known url protocol, then changing
	    // the protocol does weird things
	    // first, if it's not file:, then we MUST have a host,
	    // and if there was a path
	    // to begin with, then we MUST have a path.
	    // if it is file:, then the host is dropped,
	    // because that's known to be hostless.
	    // anything else is assumed to be absolute.
	    if (!slashedProtocol[relative.protocol]) {
	      Object.keys(relative).forEach(function(k) {
	        result[k] = relative[k];
	      });
	      result.href = result.format();
	      return result;
	    }
	
	    result.protocol = relative.protocol;
	    if (!relative.host && !hostlessProtocol[relative.protocol]) {
	      var relPath = (relative.pathname || '').split('/');
	      while (relPath.length && !(relative.host = relPath.shift()));
	      if (!relative.host) relative.host = '';
	      if (!relative.hostname) relative.hostname = '';
	      if (relPath[0] !== '') relPath.unshift('');
	      if (relPath.length < 2) relPath.unshift('');
	      result.pathname = relPath.join('/');
	    } else {
	      result.pathname = relative.pathname;
	    }
	    result.search = relative.search;
	    result.query = relative.query;
	    result.host = relative.host || '';
	    result.auth = relative.auth;
	    result.hostname = relative.hostname || relative.host;
	    result.port = relative.port;
	    // to support http.request
	    if (result.pathname || result.search) {
	      var p = result.pathname || '';
	      var s = result.search || '';
	      result.path = p + s;
	    }
	    result.slashes = result.slashes || relative.slashes;
	    result.href = result.format();
	    return result;
	  }
	
	  var isSourceAbs = (result.pathname && result.pathname.charAt(0) === '/'),
	      isRelAbs = (
	          relative.host ||
	          relative.pathname && relative.pathname.charAt(0) === '/'
	      ),
	      mustEndAbs = (isRelAbs || isSourceAbs ||
	                    (result.host && relative.pathname)),
	      removeAllDots = mustEndAbs,
	      srcPath = result.pathname && result.pathname.split('/') || [],
	      relPath = relative.pathname && relative.pathname.split('/') || [],
	      psychotic = result.protocol && !slashedProtocol[result.protocol];
	
	  // if the url is a non-slashed url, then relative
	  // links like ../.. should be able
	  // to crawl up to the hostname, as well.  This is strange.
	  // result.protocol has already been set by now.
	  // Later on, put the first path part into the host field.
	  if (psychotic) {
	    result.hostname = '';
	    result.port = null;
	    if (result.host) {
	      if (srcPath[0] === '') srcPath[0] = result.host;
	      else srcPath.unshift(result.host);
	    }
	    result.host = '';
	    if (relative.protocol) {
	      relative.hostname = null;
	      relative.port = null;
	      if (relative.host) {
	        if (relPath[0] === '') relPath[0] = relative.host;
	        else relPath.unshift(relative.host);
	      }
	      relative.host = null;
	    }
	    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
	  }
	
	  if (isRelAbs) {
	    // it's absolute.
	    result.host = (relative.host || relative.host === '') ?
	                  relative.host : result.host;
	    result.hostname = (relative.hostname || relative.hostname === '') ?
	                      relative.hostname : result.hostname;
	    result.search = relative.search;
	    result.query = relative.query;
	    srcPath = relPath;
	    // fall through to the dot-handling below.
	  } else if (relPath.length) {
	    // it's relative
	    // throw away the existing file, and take the new path instead.
	    if (!srcPath) srcPath = [];
	    srcPath.pop();
	    srcPath = srcPath.concat(relPath);
	    result.search = relative.search;
	    result.query = relative.query;
	  } else if (!isNullOrUndefined(relative.search)) {
	    // just pull out the search.
	    // like href='?foo'.
	    // Put this after the other two cases because it simplifies the booleans
	    if (psychotic) {
	      result.hostname = result.host = srcPath.shift();
	      //occationaly the auth can get stuck only in host
	      //this especialy happens in cases like
	      //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
	      var authInHost = result.host && result.host.indexOf('@') > 0 ?
	                       result.host.split('@') : false;
	      if (authInHost) {
	        result.auth = authInHost.shift();
	        result.host = result.hostname = authInHost.shift();
	      }
	    }
	    result.search = relative.search;
	    result.query = relative.query;
	    //to support http.request
	    if (!isNull(result.pathname) || !isNull(result.search)) {
	      result.path = (result.pathname ? result.pathname : '') +
	                    (result.search ? result.search : '');
	    }
	    result.href = result.format();
	    return result;
	  }
	
	  if (!srcPath.length) {
	    // no path at all.  easy.
	    // we've already handled the other stuff above.
	    result.pathname = null;
	    //to support http.request
	    if (result.search) {
	      result.path = '/' + result.search;
	    } else {
	      result.path = null;
	    }
	    result.href = result.format();
	    return result;
	  }
	
	  // if a url ENDs in . or .., then it must get a trailing slash.
	  // however, if it ends in anything else non-slashy,
	  // then it must NOT get a trailing slash.
	  var last = srcPath.slice(-1)[0];
	  var hasTrailingSlash = (
	      (result.host || relative.host) && (last === '.' || last === '..') ||
	      last === '');
	
	  // strip single dots, resolve double dots to parent dir
	  // if the path tries to go above the root, `up` ends up > 0
	  var up = 0;
	  for (var i = srcPath.length; i >= 0; i--) {
	    last = srcPath[i];
	    if (last == '.') {
	      srcPath.splice(i, 1);
	    } else if (last === '..') {
	      srcPath.splice(i, 1);
	      up++;
	    } else if (up) {
	      srcPath.splice(i, 1);
	      up--;
	    }
	  }
	
	  // if the path is allowed to go above the root, restore leading ..s
	  if (!mustEndAbs && !removeAllDots) {
	    for (; up--; up) {
	      srcPath.unshift('..');
	    }
	  }
	
	  if (mustEndAbs && srcPath[0] !== '' &&
	      (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
	    srcPath.unshift('');
	  }
	
	  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
	    srcPath.push('');
	  }
	
	  var isAbsolute = srcPath[0] === '' ||
	      (srcPath[0] && srcPath[0].charAt(0) === '/');
	
	  // put the host back
	  if (psychotic) {
	    result.hostname = result.host = isAbsolute ? '' :
	                                    srcPath.length ? srcPath.shift() : '';
	    //occationaly the auth can get stuck only in host
	    //this especialy happens in cases like
	    //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
	    var authInHost = result.host && result.host.indexOf('@') > 0 ?
	                     result.host.split('@') : false;
	    if (authInHost) {
	      result.auth = authInHost.shift();
	      result.host = result.hostname = authInHost.shift();
	    }
	  }
	
	  mustEndAbs = mustEndAbs || (result.host && srcPath.length);
	
	  if (mustEndAbs && !isAbsolute) {
	    srcPath.unshift('');
	  }
	
	  if (!srcPath.length) {
	    result.pathname = null;
	    result.path = null;
	  } else {
	    result.pathname = srcPath.join('/');
	  }
	
	  //to support request.http
	  if (!isNull(result.pathname) || !isNull(result.search)) {
	    result.path = (result.pathname ? result.pathname : '') +
	                  (result.search ? result.search : '');
	  }
	  result.auth = relative.auth || result.auth;
	  result.slashes = result.slashes || relative.slashes;
	  result.href = result.format();
	  return result;
	};
	
	Url.prototype.parseHost = function() {
	  var host = this.host;
	  var port = portPattern.exec(host);
	  if (port) {
	    port = port[0];
	    if (port !== ':') {
	      this.port = port.substr(1);
	    }
	    host = host.substr(0, host.length - port.length);
	  }
	  if (host) this.hostname = host;
	};
	
	function isString(arg) {
	  return typeof arg === "string";
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isNull(arg) {
	  return arg === null;
	}
	function isNullOrUndefined(arg) {
	  return  arg == null;
	}


/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/*! https://mths.be/punycode v1.3.2 by @mathias */
	;(function(root) {
	
		/** Detect free variables */
		var freeExports = typeof exports == 'object' && exports &&
			!exports.nodeType && exports;
		var freeModule = typeof module == 'object' && module &&
			!module.nodeType && module;
		var freeGlobal = typeof global == 'object' && global;
		if (
			freeGlobal.global === freeGlobal ||
			freeGlobal.window === freeGlobal ||
			freeGlobal.self === freeGlobal
		) {
			root = freeGlobal;
		}
	
		/**
		 * The `punycode` object.
		 * @name punycode
		 * @type Object
		 */
		var punycode,
	
		/** Highest positive signed 32-bit float value */
		maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1
	
		/** Bootstring parameters */
		base = 36,
		tMin = 1,
		tMax = 26,
		skew = 38,
		damp = 700,
		initialBias = 72,
		initialN = 128, // 0x80
		delimiter = '-', // '\x2D'
	
		/** Regular expressions */
		regexPunycode = /^xn--/,
		regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
		regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators
	
		/** Error messages */
		errors = {
			'overflow': 'Overflow: input needs wider integers to process',
			'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
			'invalid-input': 'Invalid input'
		},
	
		/** Convenience shortcuts */
		baseMinusTMin = base - tMin,
		floor = Math.floor,
		stringFromCharCode = String.fromCharCode,
	
		/** Temporary variable */
		key;
	
		/*--------------------------------------------------------------------------*/
	
		/**
		 * A generic error utility function.
		 * @private
		 * @param {String} type The error type.
		 * @returns {Error} Throws a `RangeError` with the applicable error message.
		 */
		function error(type) {
			throw RangeError(errors[type]);
		}
	
		/**
		 * A generic `Array#map` utility function.
		 * @private
		 * @param {Array} array The array to iterate over.
		 * @param {Function} callback The function that gets called for every array
		 * item.
		 * @returns {Array} A new array of values returned by the callback function.
		 */
		function map(array, fn) {
			var length = array.length;
			var result = [];
			while (length--) {
				result[length] = fn(array[length]);
			}
			return result;
		}
	
		/**
		 * A simple `Array#map`-like wrapper to work with domain name strings or email
		 * addresses.
		 * @private
		 * @param {String} domain The domain name or email address.
		 * @param {Function} callback The function that gets called for every
		 * character.
		 * @returns {Array} A new string of characters returned by the callback
		 * function.
		 */
		function mapDomain(string, fn) {
			var parts = string.split('@');
			var result = '';
			if (parts.length > 1) {
				// In email addresses, only the domain name should be punycoded. Leave
				// the local part (i.e. everything up to `@`) intact.
				result = parts[0] + '@';
				string = parts[1];
			}
			// Avoid `split(regex)` for IE8 compatibility. See #17.
			string = string.replace(regexSeparators, '\x2E');
			var labels = string.split('.');
			var encoded = map(labels, fn).join('.');
			return result + encoded;
		}
	
		/**
		 * Creates an array containing the numeric code points of each Unicode
		 * character in the string. While JavaScript uses UCS-2 internally,
		 * this function will convert a pair of surrogate halves (each of which
		 * UCS-2 exposes as separate characters) into a single code point,
		 * matching UTF-16.
		 * @see `punycode.ucs2.encode`
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode.ucs2
		 * @name decode
		 * @param {String} string The Unicode input string (UCS-2).
		 * @returns {Array} The new array of code points.
		 */
		function ucs2decode(string) {
			var output = [],
			    counter = 0,
			    length = string.length,
			    value,
			    extra;
			while (counter < length) {
				value = string.charCodeAt(counter++);
				if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
					// high surrogate, and there is a next character
					extra = string.charCodeAt(counter++);
					if ((extra & 0xFC00) == 0xDC00) { // low surrogate
						output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
					} else {
						// unmatched surrogate; only append this code unit, in case the next
						// code unit is the high surrogate of a surrogate pair
						output.push(value);
						counter--;
					}
				} else {
					output.push(value);
				}
			}
			return output;
		}
	
		/**
		 * Creates a string based on an array of numeric code points.
		 * @see `punycode.ucs2.decode`
		 * @memberOf punycode.ucs2
		 * @name encode
		 * @param {Array} codePoints The array of numeric code points.
		 * @returns {String} The new Unicode string (UCS-2).
		 */
		function ucs2encode(array) {
			return map(array, function(value) {
				var output = '';
				if (value > 0xFFFF) {
					value -= 0x10000;
					output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
					value = 0xDC00 | value & 0x3FF;
				}
				output += stringFromCharCode(value);
				return output;
			}).join('');
		}
	
		/**
		 * Converts a basic code point into a digit/integer.
		 * @see `digitToBasic()`
		 * @private
		 * @param {Number} codePoint The basic numeric code point value.
		 * @returns {Number} The numeric value of a basic code point (for use in
		 * representing integers) in the range `0` to `base - 1`, or `base` if
		 * the code point does not represent a value.
		 */
		function basicToDigit(codePoint) {
			if (codePoint - 48 < 10) {
				return codePoint - 22;
			}
			if (codePoint - 65 < 26) {
				return codePoint - 65;
			}
			if (codePoint - 97 < 26) {
				return codePoint - 97;
			}
			return base;
		}
	
		/**
		 * Converts a digit/integer into a basic code point.
		 * @see `basicToDigit()`
		 * @private
		 * @param {Number} digit The numeric value of a basic code point.
		 * @returns {Number} The basic code point whose value (when used for
		 * representing integers) is `digit`, which needs to be in the range
		 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
		 * used; else, the lowercase form is used. The behavior is undefined
		 * if `flag` is non-zero and `digit` has no uppercase form.
		 */
		function digitToBasic(digit, flag) {
			//  0..25 map to ASCII a..z or A..Z
			// 26..35 map to ASCII 0..9
			return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
		}
	
		/**
		 * Bias adaptation function as per section 3.4 of RFC 3492.
		 * http://tools.ietf.org/html/rfc3492#section-3.4
		 * @private
		 */
		function adapt(delta, numPoints, firstTime) {
			var k = 0;
			delta = firstTime ? floor(delta / damp) : delta >> 1;
			delta += floor(delta / numPoints);
			for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
				delta = floor(delta / baseMinusTMin);
			}
			return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
		}
	
		/**
		 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
		 * symbols.
		 * @memberOf punycode
		 * @param {String} input The Punycode string of ASCII-only symbols.
		 * @returns {String} The resulting string of Unicode symbols.
		 */
		function decode(input) {
			// Don't use UCS-2
			var output = [],
			    inputLength = input.length,
			    out,
			    i = 0,
			    n = initialN,
			    bias = initialBias,
			    basic,
			    j,
			    index,
			    oldi,
			    w,
			    k,
			    digit,
			    t,
			    /** Cached calculation results */
			    baseMinusT;
	
			// Handle the basic code points: let `basic` be the number of input code
			// points before the last delimiter, or `0` if there is none, then copy
			// the first basic code points to the output.
	
			basic = input.lastIndexOf(delimiter);
			if (basic < 0) {
				basic = 0;
			}
	
			for (j = 0; j < basic; ++j) {
				// if it's not a basic code point
				if (input.charCodeAt(j) >= 0x80) {
					error('not-basic');
				}
				output.push(input.charCodeAt(j));
			}
	
			// Main decoding loop: start just after the last delimiter if any basic code
			// points were copied; start at the beginning otherwise.
	
			for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {
	
				// `index` is the index of the next character to be consumed.
				// Decode a generalized variable-length integer into `delta`,
				// which gets added to `i`. The overflow checking is easier
				// if we increase `i` as we go, then subtract off its starting
				// value at the end to obtain `delta`.
				for (oldi = i, w = 1, k = base; /* no condition */; k += base) {
	
					if (index >= inputLength) {
						error('invalid-input');
					}
	
					digit = basicToDigit(input.charCodeAt(index++));
	
					if (digit >= base || digit > floor((maxInt - i) / w)) {
						error('overflow');
					}
	
					i += digit * w;
					t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
	
					if (digit < t) {
						break;
					}
	
					baseMinusT = base - t;
					if (w > floor(maxInt / baseMinusT)) {
						error('overflow');
					}
	
					w *= baseMinusT;
	
				}
	
				out = output.length + 1;
				bias = adapt(i - oldi, out, oldi == 0);
	
				// `i` was supposed to wrap around from `out` to `0`,
				// incrementing `n` each time, so we'll fix that now:
				if (floor(i / out) > maxInt - n) {
					error('overflow');
				}
	
				n += floor(i / out);
				i %= out;
	
				// Insert `n` at position `i` of the output
				output.splice(i++, 0, n);
	
			}
	
			return ucs2encode(output);
		}
	
		/**
		 * Converts a string of Unicode symbols (e.g. a domain name label) to a
		 * Punycode string of ASCII-only symbols.
		 * @memberOf punycode
		 * @param {String} input The string of Unicode symbols.
		 * @returns {String} The resulting Punycode string of ASCII-only symbols.
		 */
		function encode(input) {
			var n,
			    delta,
			    handledCPCount,
			    basicLength,
			    bias,
			    j,
			    m,
			    q,
			    k,
			    t,
			    currentValue,
			    output = [],
			    /** `inputLength` will hold the number of code points in `input`. */
			    inputLength,
			    /** Cached calculation results */
			    handledCPCountPlusOne,
			    baseMinusT,
			    qMinusT;
	
			// Convert the input in UCS-2 to Unicode
			input = ucs2decode(input);
	
			// Cache the length
			inputLength = input.length;
	
			// Initialize the state
			n = initialN;
			delta = 0;
			bias = initialBias;
	
			// Handle the basic code points
			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue < 0x80) {
					output.push(stringFromCharCode(currentValue));
				}
			}
	
			handledCPCount = basicLength = output.length;
	
			// `handledCPCount` is the number of code points that have been handled;
			// `basicLength` is the number of basic code points.
	
			// Finish the basic string - if it is not empty - with a delimiter
			if (basicLength) {
				output.push(delimiter);
			}
	
			// Main encoding loop:
			while (handledCPCount < inputLength) {
	
				// All non-basic code points < n have been handled already. Find the next
				// larger one:
				for (m = maxInt, j = 0; j < inputLength; ++j) {
					currentValue = input[j];
					if (currentValue >= n && currentValue < m) {
						m = currentValue;
					}
				}
	
				// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
				// but guard against overflow
				handledCPCountPlusOne = handledCPCount + 1;
				if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
					error('overflow');
				}
	
				delta += (m - n) * handledCPCountPlusOne;
				n = m;
	
				for (j = 0; j < inputLength; ++j) {
					currentValue = input[j];
	
					if (currentValue < n && ++delta > maxInt) {
						error('overflow');
					}
	
					if (currentValue == n) {
						// Represent delta as a generalized variable-length integer
						for (q = delta, k = base; /* no condition */; k += base) {
							t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
							if (q < t) {
								break;
							}
							qMinusT = q - t;
							baseMinusT = base - t;
							output.push(
								stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
							);
							q = floor(qMinusT / baseMinusT);
						}
	
						output.push(stringFromCharCode(digitToBasic(q, 0)));
						bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
						delta = 0;
						++handledCPCount;
					}
				}
	
				++delta;
				++n;
	
			}
			return output.join('');
		}
	
		/**
		 * Converts a Punycode string representing a domain name or an email address
		 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
		 * it doesn't matter if you call it on a string that has already been
		 * converted to Unicode.
		 * @memberOf punycode
		 * @param {String} input The Punycoded domain name or email address to
		 * convert to Unicode.
		 * @returns {String} The Unicode representation of the given Punycode
		 * string.
		 */
		function toUnicode(input) {
			return mapDomain(input, function(string) {
				return regexPunycode.test(string)
					? decode(string.slice(4).toLowerCase())
					: string;
			});
		}
	
		/**
		 * Converts a Unicode string representing a domain name or an email address to
		 * Punycode. Only the non-ASCII parts of the domain name will be converted,
		 * i.e. it doesn't matter if you call it with a domain that's already in
		 * ASCII.
		 * @memberOf punycode
		 * @param {String} input The domain name or email address to convert, as a
		 * Unicode string.
		 * @returns {String} The Punycode representation of the given domain name or
		 * email address.
		 */
		function toASCII(input) {
			return mapDomain(input, function(string) {
				return regexNonASCII.test(string)
					? 'xn--' + encode(string)
					: string;
			});
		}
	
		/*--------------------------------------------------------------------------*/
	
		/** Define the public API */
		punycode = {
			/**
			 * A string representing the current Punycode.js version number.
			 * @memberOf punycode
			 * @type String
			 */
			'version': '1.3.2',
			/**
			 * An object of methods to convert from JavaScript's internal character
			 * representation (UCS-2) to Unicode code points, and back.
			 * @see <https://mathiasbynens.be/notes/javascript-encoding>
			 * @memberOf punycode
			 * @type Object
			 */
			'ucs2': {
				'decode': ucs2decode,
				'encode': ucs2encode
			},
			'decode': decode,
			'encode': encode,
			'toASCII': toASCII,
			'toUnicode': toUnicode
		};
	
		/** Expose `punycode` */
		// Some AMD build optimizers, like r.js, check for specific condition patterns
		// like the following:
		if (
			true
		) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
				return punycode;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (freeExports && freeModule) {
			if (module.exports == freeExports) { // in Node.js or RingoJS v0.8.0+
				freeModule.exports = punycode;
			} else { // in Narwhal or RingoJS v0.7.0-
				for (key in punycode) {
					punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
				}
			}
		} else { // in Rhino or a web browser
			root.punycode = punycode;
		}
	
	}(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59)(module), (function() { return this; }())))

/***/ },
/* 304 */
[974, 305, 306],
/* 305 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	// If obj.hasOwnProperty has been overridden, then calling
	// obj.hasOwnProperty(prop) will break.
	// See: https://github.com/joyent/node/issues/1707
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	module.exports = function(qs, sep, eq, options) {
	  sep = sep || '&';
	  eq = eq || '=';
	  var obj = {};
	
	  if (typeof qs !== 'string' || qs.length === 0) {
	    return obj;
	  }
	
	  var regexp = /\+/g;
	  qs = qs.split(sep);
	
	  var maxKeys = 1000;
	  if (options && typeof options.maxKeys === 'number') {
	    maxKeys = options.maxKeys;
	  }
	
	  var len = qs.length;
	  // maxKeys <= 0 means that we should not limit keys count
	  if (maxKeys > 0 && len > maxKeys) {
	    len = maxKeys;
	  }
	
	  for (var i = 0; i < len; ++i) {
	    var x = qs[i].replace(regexp, '%20'),
	        idx = x.indexOf(eq),
	        kstr, vstr, k, v;
	
	    if (idx >= 0) {
	      kstr = x.substr(0, idx);
	      vstr = x.substr(idx + 1);
	    } else {
	      kstr = x;
	      vstr = '';
	    }
	
	    k = decodeURIComponent(kstr);
	    v = decodeURIComponent(vstr);
	
	    if (!hasOwnProperty(obj, k)) {
	      obj[k] = v;
	    } else if (Array.isArray(obj[k])) {
	      obj[k].push(v);
	    } else {
	      obj[k] = [obj[k], v];
	    }
	  }
	
	  return obj;
	};


/***/ },
/* 306 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	var stringifyPrimitive = function(v) {
	  switch (typeof v) {
	    case 'string':
	      return v;
	
	    case 'boolean':
	      return v ? 'true' : 'false';
	
	    case 'number':
	      return isFinite(v) ? v : '';
	
	    default:
	      return '';
	  }
	};
	
	module.exports = function(obj, sep, eq, name) {
	  sep = sep || '&';
	  eq = eq || '=';
	  if (obj === null) {
	    obj = undefined;
	  }
	
	  if (typeof obj === 'object') {
	    return Object.keys(obj).map(function(k) {
	      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
	      if (Array.isArray(obj[k])) {
	        return obj[k].map(function(v) {
	          return ks + encodeURIComponent(stringifyPrimitive(v));
	        }).join(sep);
	      } else {
	        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
	      }
	    }).join(sep);
	
	  }
	
	  if (!name) return '';
	  return encodeURIComponent(stringifyPrimitive(name)) + eq +
	         encodeURIComponent(stringifyPrimitive(obj));
	};


/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * http-post
	 *
	 * (c) copyright 2012 Sam Thompson <sam@emberlabs.org>
	 * License: The MIT License - http://opensource.org/licenses/mit-license.php
	 */
	
	module.exports = function(options, data, files, fn) {
		if (typeof(files) == 'function' || typeof(files) == 'undefined') {
			fn = files;
			files = [];
		}
	
		if (typeof(fn) != 'function') {
			fn = function() {};
		}
	
		if (typeof(options) == 'string') {
			var options = __webpack_require__(302).parse(options);
		}
	
		var fs = __webpack_require__(236);
		var endl = "\r\n";
		var length = 0;
		var contentType = '';
	
		// If we have files, we have to chose multipart, otherweise we just stringify the query 
		if (files.length) {
			var boundary = '-----np' + Math.random();
			var toWrite = [];
	
			for(var k in data) {
				toWrite.push('--' + boundary + endl);
				toWrite.push('Content-Disposition: form-data; name="' + k + '"' + endl);
				toWrite.push(endl);
				toWrite.push(data[k] + endl);
			}
	
			var name = '', stats;
			for (var k in files) {
				if (fs.existsSync(files[k].path)) {
					// Determine the name
					name = (typeof(files[k].name) == 'string') ? files[k].name : files[k].path.replace(/\\/g,'/').replace( /.*\//, '' );
	
					// Determine the size and store it in our files area
					stats = fs.statSync(files[k].path);
					files[k].length = stats.size;
	
					toWrite.push('--' + boundary + endl);
					toWrite.push('Content-Disposition: form-data; name="' + files[k].param + '"; filename="' + name + '"' + endl);
					//toWrite.push('Content-Type: image/png');
					toWrite.push(endl);
					toWrite.push(files[k]);
				}
			}
	
			// The final multipart terminator
			toWrite.push('--' + boundary + '--' + endl);
	
			// Now that toWrite is filled... we need to determine the size
			for(var k in toWrite) {
				length += toWrite[k].length;
			}
	
			contentType = 'multipart/form-data; boundary=' + boundary;
		}
		else {
			data = __webpack_require__(308).stringify(data);
	
			length = data.length;
			contentType = 'application/x-www-form-urlencoded';
		}
	
		options.method = 'POST';
		options.headers = {
			'Content-Type': contentType,
			'Content-Length': length
		};
	
		var req = __webpack_require__(275).request(options, function(responce) {
			fn(responce);
		});
	
		// Multipart and form-urlencded work slightly differnetly for sending
		if (files.length) {
			for(var k in toWrite) {
				if (typeof(toWrite[k]) == 'string') {
					req.write(toWrite[k]);
				}
				else {
					// @todo make it work better for larger files
					req.write(fs.readFileSync(toWrite[k].path, 'binary'));
					req.write(endl);
				}
			}
		}
		else {
			req.write(data);
		}
		req.end();
	
		return req;
	}


/***/ },
/* 308 */
[974, 309, 310],
/* 309 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	// If obj.hasOwnProperty has been overridden, then calling
	// obj.hasOwnProperty(prop) will break.
	// See: https://github.com/joyent/node/issues/1707
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	module.exports = function(qs, sep, eq, options) {
	  sep = sep || '&';
	  eq = eq || '=';
	  var obj = {};
	
	  if (typeof qs !== 'string' || qs.length === 0) {
	    return obj;
	  }
	
	  var regexp = /\+/g;
	  qs = qs.split(sep);
	
	  var maxKeys = 1000;
	  if (options && typeof options.maxKeys === 'number') {
	    maxKeys = options.maxKeys;
	  }
	
	  var len = qs.length;
	  // maxKeys <= 0 means that we should not limit keys count
	  if (maxKeys > 0 && len > maxKeys) {
	    len = maxKeys;
	  }
	
	  for (var i = 0; i < len; ++i) {
	    var x = qs[i].replace(regexp, '%20'),
	        idx = x.indexOf(eq),
	        kstr, vstr, k, v;
	
	    if (idx >= 0) {
	      kstr = x.substr(0, idx);
	      vstr = x.substr(idx + 1);
	    } else {
	      kstr = x;
	      vstr = '';
	    }
	
	    k = decodeURIComponent(kstr);
	    v = decodeURIComponent(vstr);
	
	    if (!hasOwnProperty(obj, k)) {
	      obj[k] = v;
	    } else if (isArray(obj[k])) {
	      obj[k].push(v);
	    } else {
	      obj[k] = [obj[k], v];
	    }
	  }
	
	  return obj;
	};
	
	var isArray = Array.isArray || function (xs) {
	  return Object.prototype.toString.call(xs) === '[object Array]';
	};


/***/ },
/* 310 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	var stringifyPrimitive = function(v) {
	  switch (typeof v) {
	    case 'string':
	      return v;
	
	    case 'boolean':
	      return v ? 'true' : 'false';
	
	    case 'number':
	      return isFinite(v) ? v : '';
	
	    default:
	      return '';
	  }
	};
	
	module.exports = function(obj, sep, eq, name) {
	  sep = sep || '&';
	  eq = eq || '=';
	  if (obj === null) {
	    obj = undefined;
	  }
	
	  if (typeof obj === 'object') {
	    return map(objectKeys(obj), function(k) {
	      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
	      if (isArray(obj[k])) {
	        return map(obj[k], function(v) {
	          return ks + encodeURIComponent(stringifyPrimitive(v));
	        }).join(sep);
	      } else {
	        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
	      }
	    }).join(sep);
	
	  }
	
	  if (!name) return '';
	  return encodeURIComponent(stringifyPrimitive(name)) + eq +
	         encodeURIComponent(stringifyPrimitive(obj));
	};
	
	var isArray = Array.isArray || function (xs) {
	  return Object.prototype.toString.call(xs) === '[object Array]';
	};
	
	function map (xs, f) {
	  if (xs.map) return xs.map(f);
	  var res = [];
	  for (var i = 0; i < xs.length; i++) {
	    res.push(f(xs[i], i));
	  }
	  return res;
	}
	
	var objectKeys = Object.keys || function (obj) {
	  var res = [];
	  for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
	  }
	  return res;
	};


/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _objectWithoutProperties = __webpack_require__(53)['default'];
	
	var _Object$keys = __webpack_require__(171)['default'];
	
	var i18n = __webpack_require__(61);
	var gettext = i18n.gettext;
	
	var React = __webpack_require__(40);
	var Immutable = __webpack_require__(68);
	var PureRenderMixin = __webpack_require__(40).addons.PureRenderMixin;
	var Fluxxor = __webpack_require__(69);
	var FluxMixin = Fluxxor.FluxMixin(React);
	var StoreWatchMixin = Fluxxor.StoreWatchMixin;
	var tracker = __webpack_require__(166);
	var ReactForms = __webpack_require__(169);
	var Form = ReactForms.Form;
	
	var http = __webpack_require__(275);
	http.post = __webpack_require__(307);
	
	var settings = __webpack_require__(62);
	var cities = settings.cities;
	
	var buildSchema = __webpack_require__(312);
	
	var messages = {
	  HEADING: gettext('How can we help?'),
	  SUBMITTING: gettext('Submitting…'),
	  SUCCESS_HEADING: gettext('Thank you for your enquiry'),
	  SUCCESS_MESSAGE: gettext('We\'ll get back to you soon.'),
	  ERROR_HEADING: gettext('Something went wrong'),
	  ERROR_DEFAULT_MESSAGE: gettext('There was a problem with your submission.'),
	  FOOTER_PHONE_SEARCH: gettext('Call reservations on %(phone_number)s'),
	  FOOTER_PHONE_CITY: gettext('Call our %(city)s team on %(phone_number)s'),
	  FOOTER_PHONE_GLOBAL: gettext('Call our team on %(phone_number)s'),
	  FOOTER_EMAIL: gettext('Email <a href="%(email_url)s">%(email)s</a>'),
	  SUBMIT_BUTTON: gettext('Send enquiry'),
	  REQUIRED_FIELD: gettext('* indicates a required field')
	};
	
	var topicFooters = {
	  'search_enquiry': __webpack_require__(314).Footer,
	  'booking_enquiry': __webpack_require__(315).Footer,
	  'host_enquiry': __webpack_require__(316).Footer,
	  'general_enquiry': __webpack_require__(317).Footer
	};
	
	var OFSForm = React.createClass({
	  displayName: 'OFSForm',
	
	  mixins: [PureRenderMixin],
	
	  render: function render() {
	    var _props = this.props;
	    var children = _props.children;
	
	    var props = _objectWithoutProperties(_props, ['children']);
	
	    return React.createElement(
	      'form',
	      props,
	      children,
	      React.createElement(
	        'div',
	        { className: 'ofs-EnquiryForm__Actions' },
	        React.createElement(
	          'button',
	          { className: 'ofs-Button bdd-enquire-modal-button-submit' },
	          messages.SUBMIT_BUTTON
	        ),
	        React.createElement(
	          'div',
	          { className: 'ofs-Form__HelpText rf-Required' },
	          messages.REQUIRED_FIELD
	        )
	      )
	    );
	  }
	});
	
	var ContactForm = React.createClass({
	  displayName: 'ContactForm',
	
	  mixins: [PureRenderMixin, FluxMixin, StoreWatchMixin("EnquiryStore", "GuestStore")],
	
	  getInitialState: function getInitialState() {
	    return {
	      status: 'default',
	      topic: 'search_enquiry',
	      cityCode: this.getFlux().store('EnquiryStore').state.get('cityCode', 'LON'),
	      contactPreference: 'email'
	    };
	  },
	
	  getStateFromFlux: function getStateFromFlux() {
	    var flux = this.getFlux();
	    var enquiryStoreState = flux.store('EnquiryStore').state;
	    var guestStoreState = flux.store('GuestStore').state;
	    var defaultValues = enquiryStoreState.merge(guestStoreState);
	
	    var topic = 'search_enquiry';
	    var contactPreference = 'email';
	
	    if (this.state) {
	      topic = this.state.topic;
	      contactPreference = this.state.contactPreference;
	    }
	    var schema = buildSchema(topic, contactPreference, defaultValues);
	
	    return { defaultValues: defaultValues, schema: schema };
	  },
	
	  onUpdate: function onUpdate(value, validation, update) {
	    var field = Immutable.List(update).last();
	    var changedValue = value.getIn(update);
	    var newState = {};
	
	    if (field === 'enquiry_option') {
	      newState['topic'] = changedValue;
	      newState['schema'] = buildSchema(changedValue, this.state.contactPreference, this.state.defaultValues);
	    } else if (field === 'contact_preference') {
	      newState['contactPreference'] = changedValue;
	      newState['schema'] = buildSchema(this.state.topic, changedValue, this.state.defaultValues);
	    } else if (field === 'location') {
	      newState['cityCode'] = changedValue;
	    }
	    this.setState(newState);
	  },
	
	  onSubmit: function onSubmit(event) {
	    var source = this.props.source;
	
	    var data;
	    event.preventDefault();
	    this.refs.form.makeDirty();
	
	    if (!this.refs.form.isValid()) {
	      var invalidFields = _Object$keys(this.refs.form.getValidation().children.toJS());
	      tracker.enquiryValidationError(source, invalidFields);
	      return;
	    }
	
	    data = this.refs.form.getValue().toJSON();
	
	    tracker.submitEnquiry(source, data);
	    http.post(settings.urls.enquiry, data, (function (response) {
	      if (response.statusCode !== 200) {
	        this.setState({
	          status: 'error',
	          error: null
	        });
	      } else {
	        tracker.confirmedEnquiry(source);
	        this.getFlux().actions.tracking.sendEnquiryEvent({ source: source, eventType: 'general-enquiry' });
	        this.setState({ status: 'success' });
	      }
	    }).bind(this)).on('error', (function (e) {
	      this.setState({
	        status: 'error',
	        error: e.message
	      });
	    }).bind(this));
	
	    this.setState({ status: 'submitting' });
	  },
	
	  render: function render() {
	    var cityCode = this.state.cityCode;
	    var cityName = null;
	
	    if (cityCode !== "" && cityCode !== null) {
	      cityName = cities[cityCode].name;
	    }
	    var status = this.state.status;
	    var Footer = topicFooters[this.state.topic];
	
	    return React.createElement(
	      'section',
	      { className: 'ofs-EnquiryForm' },
	      React.createElement(
	        'div',
	        { className: 'ofs-EnquiryForm__Content' },
	        React.createElement(
	          'h2',
	          { className: 'ofs-EnquiryForm__Title' },
	          messages.HEADING
	        ),
	        status === 'default' && React.createElement(Form, { component: OFSForm,
	          className: 'ofs-Form -form--condensed',
	          ref: 'form',
	          method: 'post',
	          action: '.',
	          onUpdate: this.onUpdate,
	          schema: this.state.schema,
	          onSubmit: this.onSubmit }),
	        status === 'submitting' && React.createElement(
	          'div',
	          { className: 'ofs-EnquiryForm__Message' },
	          React.createElement(
	            'h3',
	            null,
	            messages.SUBMITTING
	          )
	        ),
	        status === 'success' && React.createElement(
	          'div',
	          { className: 'ofs-EnquiryForm__Message' },
	          React.createElement(
	            'h3',
	            null,
	            messages.SUCCESS_HEADING
	          ),
	          React.createElement(
	            'p',
	            null,
	            messages.SUCCESS_MESSAGE
	          )
	        ),
	        status === 'error' && React.createElement(
	          'div',
	          { className: 'ofs-EnquiryForm__Message' },
	          React.createElement(
	            'h3',
	            null,
	            messages.ERROR_HEADING
	          ),
	          React.createElement(
	            'p',
	            null,
	            this.state.message || messages.ERROR_DEFAULT_MESSAGE
	          )
	        )
	      ),
	      React.createElement(Footer, { cityCode: cityCode, cityName: cityName })
	    );
	  }
	});
	
	module.exports = ContactForm;

/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _Object$assign = __webpack_require__(32)['default'];
	
	var React = __webpack_require__(40);
	var ReactForms = __webpack_require__(169);
	var Mapping = ReactForms.schema.Mapping;
	
	var i18n = __webpack_require__(61);
	var gettext = i18n.gettext;
	
	var Scalar = __webpack_require__(194);
	var scalars = __webpack_require__(198);
	
	var SelectOne = __webpack_require__(270);
	var ToggleSelect = __webpack_require__(223);
	
	var buildLayout = __webpack_require__(313);
	
	var messages = {
	  SEARCH_ENQUIRE_OPTION: gettext("I'm interested in booking"),
	  BOOKING_ENQUIRE_OPTION: gettext("I've got a question about an existing booking"),
	  HOST_ENQUIRE_OPTION: gettext("I'd like to list my home"),
	  GENERAL_ENQUIRE_OPTION: gettext("Other enquiries"),
	  CALL_RES: gettext('Call reservations on %(telephone_number)s'),
	  CALL_OTHER: gettext('Call our %(team_name)s team on %(telephone_number)s'),
	  EMAIL: gettext('Email'),
	  CALL: gettext('Call Me'),
	  MESSAGE_LABEL: gettext('Message'),
	  CONTACT_PREFERENCE_LABEL: gettext('How would you like us to contact you?')
	};
	
	var enquiryChoices = [{ value: 'search_enquiry', name: messages.SEARCH_ENQUIRE_OPTION }, { value: 'booking_enquiry', name: messages.BOOKING_ENQUIRE_OPTION }, { value: 'host_enquiry', name: messages.HOST_ENQUIRE_OPTION }, { value: 'general_enquiry', name: messages.GENERAL_ENQUIRE_OPTION }];
	
	var contactChoices = [{ value: 'email', name: messages.EMAIL }, { value: 'call', name: messages.CALL }];
	
	var topicMappings = {
	  'search_enquiry': __webpack_require__(314).mapping,
	  'booking_enquiry': __webpack_require__(315).mapping,
	  'host_enquiry': __webpack_require__(316).mapping,
	  'general_enquiry': __webpack_require__(317).mapping
	};
	
	var contactMappings = {
	  'email': __webpack_require__(229).mapping,
	  'call': __webpack_require__(238).mapping
	};
	
	var buildSchema = function buildSchema(topic, contactPreference, defaultValues) {
	  var Component = buildLayout(topic, contactPreference);
	  var topicMapping = topicMappings[topic](defaultValues);
	  var contactMapping = contactMappings[contactPreference](defaultValues);
	
	  var fields = _Object$assign({
	    enquiry_option: Scalar({
	      input: React.createElement(SelectOne, { options: enquiryChoices }),
	      defaultValue: topic,
	      required: true,
	      name: 'enquiry_option'
	    })
	  }, topicMapping, {
	    message: scalars.TextScalar({
	      label: messages.MESSAGE_LABEL,
	      required: false
	    }),
	    contact_preference: Scalar({
	      label: messages.CONTACT_PREFERENCE_LABEL,
	      input: React.createElement(ToggleSelect, { options: contactChoices, className: 'ignore-react-onclickoutside' }),
	      defaultValue: 'email',
	      required: true
	    })
	  }, contactMapping);
	
	  return Mapping({ component: Component }, fields);
	};
	
	module.exports = buildSchema;

/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(40);
	var PureRenderMixin = __webpack_require__(40).addons.PureRenderMixin;
	
	var ReactForms = __webpack_require__(169);
	
	var Layout = __webpack_require__(225);
	var Row = __webpack_require__(226);
	var Column = __webpack_require__(227);
	var Group = __webpack_require__(228);
	
	var FormElement = ReactForms.Element;
	
	var topicLayouts = {
	  'search_enquiry': __webpack_require__(314).layout,
	  'booking_enquiry': __webpack_require__(315).layout,
	  'host_enquiry': __webpack_require__(316).layout,
	  'general_enquiry': __webpack_require__(317).layout
	};
	
	var contactLayouts = {
	  'email': __webpack_require__(229).layout,
	  'call': __webpack_require__(238).layout
	};
	
	var buildLayout = function buildLayout(topic, contactPreference) {
	  var topicLayout = topicLayouts[topic];
	  var contactLayout = contactLayouts[contactPreference];
	
	  return React.createClass({
	    mixins: [PureRenderMixin],
	
	    render: function render() {
	      var value = this.props.value;
	      return React.createElement(
	        Layout,
	        null,
	        React.createElement(
	          Group,
	          null,
	          React.createElement(
	            Row,
	            null,
	            React.createElement(
	              Column,
	              { size: 'full' },
	              React.createElement(FormElement, { value: value.get('enquiry_option') })
	            )
	          )
	        ),
	        topicLayout(value),
	        React.createElement(
	          Group,
	          null,
	          React.createElement(
	            Row,
	            null,
	            React.createElement(
	              Column,
	              { size: 'full' },
	              React.createElement(FormElement, { value: value.get('message') })
	            )
	          ),
	          React.createElement(
	            Row,
	            null,
	            React.createElement(
	              Column,
	              { size: 'full' },
	              React.createElement(FormElement, {
	                className: 'bdd-enquire-modal-button-group-contact',
	                value: value.get('contact_preference')
	              })
	            )
	          ),
	          contactLayout(value)
	        )
	      );
	    }
	  });
	};
	
	module.exports = buildLayout;

/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var React = __webpack_require__(40);
	var ReactForms = __webpack_require__(169);
	var Immutable = __webpack_require__(68);
	
	var settings = __webpack_require__(62);
	var i18n = __webpack_require__(61);
	var gettext = i18n.gettext;
	var interpolate = i18n.interpolate;
	
	var SelectOne = __webpack_require__(270);
	var Scalar = __webpack_require__(194);
	var scalars = __webpack_require__(198);
	
	var FormElement = ReactForms.Element;
	var Row = __webpack_require__(226);
	var Column = __webpack_require__(227);
	var Group = __webpack_require__(228);
	
	var messages = {
	  START_DATE_LABEL: gettext('Arrival date'),
	  START_DATE_PLACEHOLDER: gettext('Select an arrival date'),
	  END_DATE_LABEL: gettext('Departure date'),
	  END_DATE_PLACEHOLDER: gettext('Select a departure date'),
	  FLEXIBLE_DATES_LABEL: gettext('My dates are flexible'),
	  LOCATION_LABEL: gettext('Location'),
	  BUDGET_LABEL: gettext('Approximate budget (per night)'),
	  ADULTS_LABEL: gettext('Adults'),
	  CHILDREN_LABEL: gettext('Children'),
	  CHILDREN_HINT: gettext('Age 4-12'),
	  TODDLERS_LABEL: gettext('Toddlers'),
	  TODDLERS_HINT: gettext('Age 1-3'),
	  BABIES_LABEL: gettext('Babies'),
	  BABIES_HINT: gettext('Under 1'),
	  FOOTER_MESSAGE: gettext('Alternatively, contact our <b>Reservations team</b> directly'),
	  CONTACT_MESSAGE: gettext('<strong>%(phone_number)s</strong> or <a href="%(email_url)s">%(email_address)s</a>')
	};
	
	var adultOptions = Immutable.Range(1, 17).map(function (i) {
	  return { value: i, name: i };
	}).toJS();
	var guestOptions = Immutable.Range(0, 17).map(function (i) {
	  return { value: i, name: i };
	}).toJS();
	
	var locationOptions = [{ value: 'LON', name: 'London' }, { value: 'LAX', name: 'Los Angeles' }, { value: 'NYC', name: 'New York' }, { value: 'PAR', name: 'Paris' }, { value: 'OTHER', name: 'Other' }];
	
	var mapping = function mapping(defaultValues) {
	  var defaultMaxBudget = defaultValues.get('budgetMax', null);
	
	  return {
	    'start_date': scalars.DateScalar({
	      label: messages.START_DATE_LABEL,
	      defaultValue: defaultValues.get('startDate', null),
	      placeholder: messages.START_DATE_PLACEHOLDER
	    }),
	    'end_date': scalars.DateScalar({
	      label: messages.END_DATE_LABEL,
	      defaultValue: defaultValues.get('endDate', null),
	      placeholder: messages.END_DATE_PLACEHOLDER
	    }),
	    'flexible_dates': Scalar({
	      type: 'bool',
	      label: messages.FLEXIBLE_DATES_LABEL
	    }),
	    'location': Scalar({
	      type: 'string',
	      defaultValue: defaultValues.get('cityCode') || 'LON',
	      input: React.createElement(SelectOne, { options: locationOptions }),
	      label: messages.LOCATION_LABEL
	    }),
	    'budget': Scalar({
	      type: 'price',
	      // string should have a pipe separating currency and maxBudget.
	      defaultValue: defaultMaxBudget ? defaultValues.get('currency') + '|' + defaultMaxBudget : null,
	      label: messages.BUDGET_LABEL
	    }),
	    'adults': Scalar({
	      type: 'number',
	      defaultValue: parseInt(defaultValues.get('numberOfGuests')) || 1,
	      input: React.createElement(SelectOne, { options: adultOptions }),
	      label: messages.ADULTS_LABEL
	    }),
	    'children': Scalar({
	      type: 'number',
	      defaultValue: 0,
	      input: React.createElement(SelectOne, { options: guestOptions }),
	      label: messages.CHILDREN_LABEL,
	      hint: messages.CHILDREN_HINT
	    }),
	    'toddlers': Scalar({
	      type: 'number',
	      defaultValue: 0,
	      input: React.createElement(SelectOne, { options: guestOptions }),
	      label: messages.TODDLERS_LABEL,
	      hint: messages.TODDLERS_HINT
	    }),
	    'babies': Scalar({
	      type: 'number',
	      defaultValue: 0,
	      input: React.createElement(SelectOne, { options: guestOptions }),
	      label: messages.BABIES_LABEL,
	      hint: messages.BABIES_HINT
	    })
	  };
	};
	
	var layout = function layout(value) {
	  return [React.createElement(
	    Group,
	    null,
	    React.createElement(
	      Row,
	      null,
	      React.createElement(
	        Column,
	        { size: 'half' },
	        React.createElement(FormElement, { className: 'bdd-enquire-modal-field-start-date', value: value.get('start_date') })
	      ),
	      React.createElement(
	        Column,
	        { size: 'half' },
	        React.createElement(FormElement, { className: 'bdd-enquire-modal-field-end-date', value: value.get('end_date') })
	      )
	    ),
	    React.createElement(
	      Row,
	      null,
	      React.createElement(
	        Column,
	        { size: 'full' },
	        React.createElement(FormElement, { className: 'bdd-enquire-modal-field-flexible-dates', value: value.get('flexible_dates') })
	      )
	    )
	  ), React.createElement(
	    Group,
	    null,
	    React.createElement(
	      Row,
	      null,
	      React.createElement(
	        Column,
	        { size: 'half' },
	        React.createElement(FormElement, { className: 'bdd-enquire-modal-field-location', value: value.get('location') })
	      ),
	      React.createElement(
	        Column,
	        { size: 'half' },
	        React.createElement(FormElement, { className: 'bdd-enquire-modal-field-budget', value: value.get('budget') })
	      )
	    )
	  ), React.createElement(
	    Group,
	    null,
	    React.createElement(
	      Row,
	      null,
	      React.createElement(
	        Column,
	        { size: 'quarter' },
	        React.createElement(FormElement, { className: 'bdd-enquire-modal-field-adults', value: value.get('adults') })
	      ),
	      React.createElement(
	        Column,
	        { size: 'quarter' },
	        React.createElement(FormElement, { className: 'bdd-enquire-modal-field-children', value: value.get('children') })
	      ),
	      React.createElement(
	        Column,
	        { size: 'quarter' },
	        React.createElement(FormElement, { className: 'bdd-enquire-modal-field-toddlers', value: value.get('toddlers') })
	      ),
	      React.createElement(
	        Column,
	        { size: 'quarter' },
	        React.createElement(FormElement, { className: 'bdd-enquire-modal-field-babies', value: value.get('babies') })
	      )
	    )
	  )];
	};
	
	var Footer = React.createClass({
	  displayName: 'Footer',
	
	  render: function render() {
	    var contact = null;
	    var contactMsg = null;
	    if (this.props.cityCode !== "" && this.props.cityCode !== null) {
	      contact = settings.cities[this.props.cityCode].contact;
	      contactMsg = interpolate(messages.CONTACT_MESSAGE, {
	        'phone_number': contact['reservations']['phone'],
	        'email_url': 'mailto:' + contact['reservations']['email'],
	        'email_address': contact['reservations']['email']
	      }, true);
	    }
	
	    return React.createElement(
	      'div',
	      { className: 'ofs-InfoPanel u-text-center' },
	      React.createElement('p', { dangerouslySetInnerHTML: { __html: messages.FOOTER_MESSAGE } }),
	      React.createElement('p', { dangerouslySetInnerHTML: { __html: contactMsg } })
	    );
	  }
	});
	
	module.exports = { mapping: mapping, layout: layout, Footer: Footer };

/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var React = __webpack_require__(40);
	var ReactForms = __webpack_require__(169);
	
	var settings = __webpack_require__(62);
	var i18n = __webpack_require__(61);
	var gettext = i18n.gettext;
	var interpolate = i18n.interpolate;
	
	var Scalar = __webpack_require__(194);
	var SelectOne = __webpack_require__(270);
	
	var FormElement = ReactForms.Element;
	var Row = __webpack_require__(226);
	var Column = __webpack_require__(227);
	var Group = __webpack_require__(228);
	
	var messages = {
	  FIRST_NAME_LABEL: gettext('First name'),
	  LAST_NAME_LABEL: gettext('Second name'),
	  LOCATION_LABEL: gettext('Location'),
	  BOOKING_REF_LABEL: gettext('Booking reference'),
	  FOOTER_MESSAGE: gettext('Alternatively, contact our <b>%(city_name)s team</b> directly'),
	  CONTACT_MESSAGE: gettext('<strong>%(phone_number)s</strong> or <a href="%(email_url)s">%(email_address)s</a>')
	};
	
	var locationOptions = [{ value: 'LON', name: 'London' }, { value: 'LAX', name: 'Los Angeles' }, { value: 'NYC', name: 'New York' }, { value: 'PAR', name: 'Paris' }, { value: 'OTHER', name: 'Other' }];
	
	var mapping = function mapping(defaultValues) {
	  return {
	    first_name: Scalar({
	      type: 'string',
	      defaultValue: defaultValues.get('firstName', null),
	      label: messages.FIRST_NAME_LABEL
	    }),
	    last_name: Scalar({
	      type: 'string',
	      defaultValue: defaultValues.get('lastName', null),
	      label: messages.LAST_NAME_LABEL
	    }),
	    location: Scalar({
	      type: 'string',
	      input: React.createElement(SelectOne, { options: locationOptions }),
	      defaultValue: defaultValues.get('cityCode') || 'LON',
	      label: messages.LOCATION_LABEL
	    }),
	    booking_ref: Scalar({
	      type: 'string',
	      defaultValue: defaultValues.get('bookingRef', null),
	      label: messages.BOOKING_REF_LABEL
	    })
	  };
	};
	
	var layout = function layout(value) {
	  return React.createElement(
	    Group,
	    null,
	    React.createElement(
	      Row,
	      null,
	      React.createElement(
	        Column,
	        { size: 'half' },
	        React.createElement(FormElement, { value: value.get('first_name') })
	      ),
	      React.createElement(
	        Column,
	        { size: 'half' },
	        React.createElement(FormElement, { value: value.get('last_name') })
	      )
	    ),
	    React.createElement(
	      Row,
	      null,
	      React.createElement(
	        Column,
	        { size: 'half' },
	        React.createElement(FormElement, { value: value.get('location') })
	      ),
	      React.createElement(
	        Column,
	        { size: 'half' },
	        React.createElement(FormElement, { value: value.get('booking_ref') })
	      )
	    )
	  );
	};
	
	var Footer = React.createClass({
	  displayName: 'Footer',
	
	  render: function render() {
	    var footerMsg = interpolate(messages.FOOTER_MESSAGE, {
	      city_name: this.props.cityName
	    }, true);
	
	    var contact = settings.cities[this.props.cityCode].contact;
	    var contactMsg = interpolate(messages.CONTACT_MESSAGE, {
	      phone_number: contact['guests']['phone'],
	      email_url: 'mailto:' + contact['guests']['email'],
	      email_address: contact['guests']['email']
	    }, true);
	
	    return React.createElement(
	      'div',
	      { className: 'ofs-InfoPanel u-text-center' },
	      React.createElement('p', { dangerouslySetInnerHTML: { __html: footerMsg } }),
	      React.createElement('p', { dangerouslySetInnerHTML: { __html: contactMsg } })
	    );
	  }
	});
	
	module.exports = { mapping: mapping, layout: layout, Footer: Footer };

/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var React = __webpack_require__(40);
	var ReactForms = __webpack_require__(169);
	
	var i18n = __webpack_require__(61);
	var gettext = i18n.gettext;
	var interpolate = i18n.interpolate;
	
	var SelectOne = __webpack_require__(270);
	
	var settings = __webpack_require__(62);
	
	var Scalar = __webpack_require__(194);
	
	var FormElement = ReactForms.Element;
	var Row = __webpack_require__(226);
	var Column = __webpack_require__(227);
	var Group = __webpack_require__(228);
	
	var messages = {
	  // TODO: remove 'host questionnaire' link from `INTRO_PARAGRAPH` when new host questionnaire is rolled out
	  INTRO_PARAGRAPH: gettext('To list with us please start on our page about becoming a onefinestay host. <a href="%(host_url)s">Read more</a> or take our <a href="%(questionnaire_url)s">host questionnaire</a>.'),
	  INTRO_HEADING: gettext('Need to ask something else?'),
	  LOCATION_LABEL: gettext('Location'),
	  FOOTER_MESSAGE: gettext('Alternatively, contact our <b>%(city_name)s team</b> directly'),
	  CONTACT_MESSAGE: gettext('<strong>%(phone_number)s</strong> or <a href="%(email_url)s">%(email_address)s</a>')
	};
	
	var locationOptions = [{ value: 'LON', name: 'London' }, { value: 'LAX', name: 'Los Angeles' }, { value: 'NYC', name: 'New York' }, { value: 'PAR', name: 'Paris' }, { value: 'OTHER', name: 'Other' }];
	
	var mapping = function mapping(defaultValues) {
	  return {
	    location: Scalar({
	      type: 'string',
	      input: React.createElement(SelectOne, { options: locationOptions }),
	      defaultValue: defaultValues.get('cityCode', null),
	      label: messages.LOCATION_LABEL
	    })
	  };
	};
	
	var layout = function layout(value) {
	  var msg = interpolate(messages.INTRO_PARAGRAPH, {
	    host_url: settings.urls['host-intro'],
	    questionnaire_url: settings.urls['host-questionnaire']
	  }, true);
	
	  return React.createElement(
	    Group,
	    null,
	    React.createElement(
	      Row,
	      null,
	      React.createElement(
	        Column,
	        { size: 'full' },
	        React.createElement('p', { dangerouslySetInnerHTML: { __html: msg } }),
	        React.createElement(
	          'h3',
	          null,
	          messages.INTRO_HEADING
	        )
	      )
	    ),
	    React.createElement(
	      Row,
	      null,
	      React.createElement(
	        Column,
	        { size: 'full' },
	        React.createElement(FormElement, { value: value.get('location') })
	      )
	    )
	  );
	};
	
	var Footer = React.createClass({
	  displayName: 'Footer',
	
	  render: function render() {
	    var footerMsg = interpolate(messages.FOOTER_MESSAGE, {
	      city_name: this.props.cityName
	    }, true);
	
	    var contact = settings.cities[this.props.cityCode].contact;
	    var contactMsg = interpolate(messages.CONTACT_MESSAGE, {
	      phone_number: contact['hosts']['phone'],
	      email_url: 'mailto:' + contact['hosts']['email'],
	      email_address: contact['hosts']['email']
	    }, true);
	
	    return React.createElement(
	      'div',
	      { className: 'ofs-InfoPanel u-text-center' },
	      React.createElement('p', { dangerouslySetInnerHTML: { __html: footerMsg } }),
	      React.createElement('p', { dangerouslySetInnerHTML: { __html: contactMsg } })
	    );
	  }
	});
	
	module.exports = { mapping: mapping, layout: layout, Footer: Footer };

/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var mapping;
	var layout;
	
	// TODO ?
	module.exports = { mapping: mapping, layout: layout };
	
	var React = __webpack_require__(40);
	var ReactForms = __webpack_require__(169);
	
	var i18n = __webpack_require__(61);
	var gettext = i18n.gettext;
	var interpolate = i18n.interpolate;
	
	var settings = __webpack_require__(62);
	
	var Scalar = __webpack_require__(194);
	
	var FormElement = ReactForms.Element;
	var Row = __webpack_require__(226);
	var Column = __webpack_require__(227);
	var Group = __webpack_require__(228);
	
	var messages = {
	  FIRST_NAME_LABEL: gettext('First name'),
	  LAST_NAME_LABEL: gettext('Second name'),
	  COMPANY_LABEL: gettext('Company'),
	  INTRO_PARAGRAPH: gettext('Before filling this out have you seen our <a href="%(jobs_url)s">jobs page</a>, <a href="%(partners_url)s">partners page</a>, <a href="%(press_url)s">press room page</a> and page for <a href="%(international_url)s">international launch</a>?</p>'),
	  INTRO_HEADING: gettext('Need to ask something else?'),
	  FOOTER_MESSAGE: gettext('Alternatively, contact us directly')
	};
	
	var mapping = function mapping(defaultValues) {
	  return {
	    first_name: Scalar({
	      type: 'string',
	      defaultValue: defaultValues.get('firstName', null),
	      label: messages.FIRST_NAME_LABEL
	    }),
	    last_name: Scalar({
	      type: 'string',
	      defaultValue: defaultValues.get('lastName', null),
	      label: messages.LAST_NAME_LABEL
	    }),
	    company: Scalar({
	      type: 'string',
	      defaultValue: defaultValues.get('company', null),
	      label: messages.COMPANY_LABEL
	    })
	  };
	};
	
	var layout = function layout(value) {
	  var msg = interpolate(messages.INTRO_PARAGRAPH, {
	    jobs_url: settings.urls.jobs,
	    partners_url: settings.urls.partners,
	    press_url: settings.urls.press,
	    international_url: settings.urls.international
	  }, true);
	
	  return React.createElement(
	    Group,
	    null,
	    React.createElement(
	      Row,
	      null,
	      React.createElement(
	        Column,
	        { size: 'full' },
	        React.createElement('p', { dangerouslySetInnerHTML: { __html: msg } }),
	        React.createElement(
	          'h3',
	          null,
	          messages.INTRO_HEADING
	        )
	      )
	    ),
	    React.createElement(
	      Row,
	      null,
	      React.createElement(
	        Column,
	        { size: 'half' },
	        React.createElement(FormElement, { value: value.get('first_name') })
	      ),
	      React.createElement(
	        Column,
	        { size: 'half' },
	        React.createElement(FormElement, { value: value.get('last_name') })
	      )
	    ),
	    React.createElement(
	      Row,
	      null,
	      React.createElement(
	        Column,
	        { size: 'full' },
	        React.createElement(FormElement, { value: value.get('company') })
	      )
	    )
	  );
	};
	
	var Footer = React.createClass({
	  displayName: 'Footer',
	
	  render: function render() {
	    var emailAddress = 'info@onefinestay.com';
	    var emailUrl = 'mailto:' + emailAddress;
	
	    return React.createElement(
	      'div',
	      { className: 'ofs-InfoPanel u-text-center' },
	      React.createElement(
	        'p',
	        null,
	        messages.FOOTER_MESSAGE
	      ),
	      React.createElement(
	        'p',
	        null,
	        React.createElement(
	          'a',
	          { href: emailUrl },
	          emailAddress
	        )
	      )
	    );
	  }
	});
	
	module.exports = { mapping: mapping, layout: layout, Footer: Footer };

/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _objectWithoutProperties = __webpack_require__(53)['default'];
	
	var i18n = __webpack_require__(61);
	var gettext = i18n.gettext;
	
	var React = __webpack_require__(40);
	var Immutable = __webpack_require__(68);
	var PureRenderMixin = __webpack_require__(40).addons.PureRenderMixin;
	var Fluxxor = __webpack_require__(69);
	var FluxMixin = Fluxxor.FluxMixin(React);
	var StoreWatchMixin = Fluxxor.StoreWatchMixin;
	var tracker = __webpack_require__(166);
	var ReactForms = __webpack_require__(169);
	var Form = ReactForms.Form;
	
	var buildSchema = __webpack_require__(319);
	var Footer = __webpack_require__(315).Footer;
	
	var http = __webpack_require__(275);
	http.post = __webpack_require__(307);
	
	var messages = {
	  HEADING: gettext('How can we help?'),
	  INTRO: gettext('The more information you fill in the better we\'ll be able to help you.'),
	  SUBMITTING: gettext('Submitting…'),
	  SUCCESS_HEADING: gettext('Thank you for your enquiry'),
	  SUCCESS_MESSAGE: gettext('We\'ll get back to you soon.'),
	  ERROR_HEADING: gettext('Something went wrong'),
	  ERROR_DEFAULT_MESSAGE: gettext('There was a problem with your submission.'),
	  ENQUIRE_ABOUT_UNIT: gettext('Enquire about %(home_name)s, %(city_name)s'),
	  FOOTER_PHONE_SEARCH: gettext('Call reservations on %(phone_number)s'),
	  FOOTER_PHONE_CITY: gettext('Call our %(city)s team on %(phone_number)s'),
	  FOOTER_PHONE_GLOBAL: gettext('Call our team on %(phone_number)s'),
	  FOOTER_EMAIL: gettext('Email <a href="%(email_url)s">%(email)s</a>'),
	  SUBMIT_BUTTON: gettext('Send enquiry'),
	  REQUIRED_FIELD: gettext('* indicates a required field')
	};
	
	var settings = __webpack_require__(62);
	var cities = settings.cities;
	
	var OFSForm = React.createClass({
	  displayName: 'OFSForm',
	
	  mixins: [PureRenderMixin],
	
	  render: function render() {
	    var _props = this.props;
	    var children = _props.children;
	
	    var props = _objectWithoutProperties(_props, ['children']);
	
	    return React.createElement(
	      'form',
	      props,
	      children,
	      React.createElement(
	        'div',
	        { className: 'ofs-EnquiryForm__Actions' },
	        React.createElement(
	          'button',
	          { className: 'ofs-Button' },
	          messages.SUBMIT_BUTTON
	        ),
	        React.createElement(
	          'div',
	          { className: 'ofs-Form__HelpText rf-Required' },
	          messages.REQUIRED_FIELD
	        )
	      )
	    );
	  }
	});
	
	var ContactForm = React.createClass({
	  displayName: 'ContactForm',
	
	  mixins: [PureRenderMixin, FluxMixin, StoreWatchMixin("EnquiryStore")],
	
	  getInitialState: function getInitialState() {
	    return {
	      status: 'default',
	      cityCode: this.getFlux().store('EnquiryStore').state.get('cityCode', 'LON'),
	      contactPreference: 'email'
	    };
	  },
	
	  getStateFromFlux: function getStateFromFlux() {
	    var defaultValues = this.getFlux().store('EnquiryStore').state;
	    var contactPreference = 'email';
	
	    if (this.state) {
	      contactPreference = this.state.contactPreference;
	    }
	    var schema = buildSchema(contactPreference, defaultValues);
	
	    return { defaultValues: defaultValues, schema: schema };
	  },
	
	  onUpdate: function onUpdate(value, validation, update) {
	    var field = Immutable.List(update).last();
	    var changedValue = value.getIn(update);
	    var newState = {};
	
	    if (field === 'contact_preference') {
	      newState['contactPreference'] = changedValue;
	      newState['schema'] = buildSchema(changedValue, this.state.defaultValues);
	    } else if (field === 'location') {
	      newState['cityCode'] = changedValue;
	    }
	
	    this.setState(newState);
	  },
	
	  onSubmit: function onSubmit(event) {
	    var source = this.props.source;
	
	    var data;
	    event.preventDefault();
	    this.refs.form.makeDirty();
	
	    if (!this.refs.form.isValid()) {
	      tracker.enquiryValidationError(source);
	      return;
	    }
	
	    data = this.refs.form.getValue().toJSON();
	    data.enquiry_option = 'booking_enquiry';
	
	    tracker.submitEnquiry(source, data);
	    http.post(settings.urls.enquiry, data, (function (response) {
	      if (response.statusCode !== 200) {
	        this.setState({
	          status: 'error',
	          error: null
	        });
	      } else {
	        tracker.confirmedEnquiry(source);
	        this.getFlux().actions.tracking.sendEnquiryEvent({ source: source, eventType: 'booking-enquiry' });
	        this.setState({ status: 'success' });
	      }
	    }).bind(this)).on('error', (function (e) {
	      this.setState({
	        status: 'error',
	        error: e.message
	      });
	    }).bind(this));
	
	    this.setState({ status: 'submitting' });
	  },
	
	  render: function render() {
	    var cityCode = this.state.cityCode;
	    var cityName = null;
	
	    if (cityCode !== "" && cityCode !== null) {
	      cityName = cities[cityCode].name;
	    }
	    var status = this.state.status;
	
	    return React.createElement(
	      'section',
	      { className: 'ofs-EnquiryForm' },
	      React.createElement(
	        'div',
	        { className: 'ofs-EnquiryForm__Content' },
	        React.createElement(
	          'h2',
	          { className: 'ofs-EnquiryForm__Title' },
	          messages.HEADING
	        ),
	        status === 'default' && React.createElement(Form, { component: OFSForm,
	          className: 'ofs-Form -form--condensed',
	          ref: 'form',
	          method: 'post',
	          action: '.',
	          onUpdate: this.onUpdate,
	          schema: this.state.schema,
	          onSubmit: this.onSubmit }),
	        status === 'submitting' && React.createElement(
	          'div',
	          { className: 'ofs-EnquiryForm__Message' },
	          React.createElement(
	            'h3',
	            null,
	            messages.SUBMITTING
	          )
	        ),
	        status === 'success' && React.createElement(
	          'div',
	          { className: 'ofs-EnquiryForm__Message' },
	          React.createElement(
	            'h3',
	            null,
	            messages.SUCCESS_HEADING
	          ),
	          React.createElement(
	            'p',
	            null,
	            messages.SUCCESS_MESSAGE
	          )
	        ),
	        status === 'error' && React.createElement(
	          'div',
	          { className: 'ofs-EnquiryForm__Message' },
	          React.createElement(
	            'h3',
	            null,
	            messages.ERROR_HEADING
	          ),
	          React.createElement(
	            'p',
	            null,
	            this.state.message
	          )
	        )
	      ),
	      React.createElement(Footer, { cityCode: cityCode, cityName: cityName })
	    );
	  }
	});
	
	module.exports = ContactForm;

/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _Object$assign = __webpack_require__(32)['default'];
	
	var i18n = __webpack_require__(61);
	var gettext = i18n.gettext;
	
	var React = __webpack_require__(40);
	var ReactForms = __webpack_require__(169);
	var Mapping = ReactForms.schema.Mapping;
	
	var Scalar = __webpack_require__(194);
	var scalars = __webpack_require__(198);
	var ToggleSelect = __webpack_require__(223);
	
	var buildLayout = __webpack_require__(320);
	
	var messages = {
	  CALL_RES: gettext('Call reservations on %(telephone_number)s'),
	  CALL_OTHER: gettext('Call our %(team_name)s team on %(telephone_number)s'),
	  EMAIL: gettext('Email'),
	  CALL: gettext('Call Me'),
	  MESSAGE_LABEL: gettext('Message'),
	  CONTACT_PREFERENCE_LABEL: gettext('How would you like us to contact you?')
	};
	
	var contactChoices = [{ value: 'email', name: messages.EMAIL }, { value: 'call', name: messages.CALL }];
	
	var contactMappings = {
	  'email': __webpack_require__(229).mapping,
	  'call': __webpack_require__(238).mapping
	};
	
	var buildSchema = function buildSchema(contactPreference, defaultValues) {
	  var Component = buildLayout(contactPreference);
	  var topicMapping = __webpack_require__(315).mapping(defaultValues);
	  var contactMapping = contactMappings[contactPreference](defaultValues);
	
	  var fields = _Object$assign(topicMapping, {
	    message: scalars.TextScalar({
	      label: messages.MESSAGE_LABEL
	    }),
	    contact_preference: Scalar({
	      label: messages.CONTACT_PREFERENCE_LABEL,
	      input: React.createElement(ToggleSelect, { options: contactChoices, className: 'ignore-react-onclickoutside' }),
	      defaultValue: 'email'
	    })
	  }, contactMapping);
	
	  return Mapping({ component: Component }, fields);
	};
	
	module.exports = buildSchema;

/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(40);
	var PureRenderMixin = __webpack_require__(40).addons.PureRenderMixin;
	
	var ReactForms = __webpack_require__(169);
	
	var Layout = __webpack_require__(225);
	var Row = __webpack_require__(226);
	var Column = __webpack_require__(227);
	var Group = __webpack_require__(228);
	
	var FormElement = ReactForms.Element;
	
	var contactLayouts = {
	  'email': __webpack_require__(229).layout,
	  'call': __webpack_require__(238).layout
	};
	
	var buildLayout = function buildLayout(contactPreference) {
	  var topicLayout = __webpack_require__(315).layout;
	  var contactLayout = contactLayouts[contactPreference];
	
	  return React.createClass({
	    mixins: [PureRenderMixin],
	
	    render: function render() {
	      var value = this.props.value;
	
	      return React.createElement(
	        Layout,
	        null,
	        topicLayout(value),
	        React.createElement(
	          Group,
	          null,
	          React.createElement(
	            Row,
	            null,
	            React.createElement(
	              Column,
	              { size: 'full' },
	              React.createElement(FormElement, { value: value.get('message') })
	            )
	          ),
	          React.createElement(
	            Row,
	            null,
	            React.createElement(
	              Column,
	              { size: 'full' },
	              React.createElement(FormElement, { value: value.get('contact_preference') })
	            )
	          ),
	          contactLayout(value)
	        )
	      );
	    }
	  });
	};
	
	module.exports = buildLayout;

/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var i18n = __webpack_require__(61);
	var gettext = i18n.gettext;
	
	var React = __webpack_require__(40);
	var Immutable = __webpack_require__(68);
	var PureRenderMixin = __webpack_require__(40).addons.PureRenderMixin;
	var Fluxxor = __webpack_require__(69);
	var FluxMixin = Fluxxor.FluxMixin(React);
	var StoreWatchMixin = Fluxxor.StoreWatchMixin;
	var tracker = __webpack_require__(166);
	var ReactForms = __webpack_require__(169);
	var Form = ReactForms.Form;
	
	var buildSchema = __webpack_require__(322);
	var Footer = __webpack_require__(314).Footer;
	
	var http = __webpack_require__(275);
	http.post = __webpack_require__(307);
	
	var messages = {
	  HEADING: gettext('Can\'t find what you\'re looking for?'),
	  INTRO: gettext('We have a number of other properties not yet listed on the site. Please fill out this form and we will get back to you shortly.'),
	  SUBMITTING: gettext('Submitting…'),
	  SUCCESS_HEADING: gettext('Thank you for your enquiry'),
	  SUCCESS_MESSAGE: gettext('We\'ll get back to you soon.'),
	  ERROR_HEADING: gettext('Something went wrong'),
	  ERROR_DEFAULT_MESSAGE: gettext('There was a problem with your submission.'),
	  ENQUIRE_ABOUT_UNIT: gettext('Enquire about %(home_name)s, %(city_name)s'),
	  FOOTER_PHONE_SEARCH: gettext('Call reservations on %(phone_number)s'),
	  FOOTER_PHONE_CITY: gettext('Call our %(city)s team on %(phone_number)s'),
	  FOOTER_PHONE_GLOBAL: gettext('Call our team on %(phone_number)s'),
	  FOOTER_EMAIL: gettext('Email <a href="%(email_url)s">%(email)s</a>'),
	  SUBMIT_BUTTON: gettext('Send enquiry'),
	  REQUIRED_FIELD: gettext('* indicates a required field')
	};
	
	var settings = __webpack_require__(62);
	var cities = settings.cities;
	
	var OFSForm = React.createClass({
	  displayName: 'OFSForm',
	
	  mixins: [PureRenderMixin],
	
	  render: function render() {
	    var children = this.props.children;
	
	    return React.createElement(
	      'form',
	      this.props,
	      children,
	      React.createElement(
	        'div',
	        { className: 'ofs-EnquiryForm__Actions' },
	        React.createElement(
	          'button',
	          { className: 'ofs-Button' },
	          messages.SUBMIT_BUTTON
	        ),
	        React.createElement(
	          'div',
	          { className: 'ofs-Form__HelpText rf-Required' },
	          messages.REQUIRED_FIELD
	        )
	      )
	    );
	  }
	});
	
	var ContactForm = React.createClass({
	  displayName: 'ContactForm',
	
	  mixins: [PureRenderMixin, FluxMixin, StoreWatchMixin("EnquiryStore", "GuestStore")],
	
	  getInitialState: function getInitialState() {
	    return {
	      status: 'default',
	      contactPreference: 'email'
	    };
	  },
	
	  getStateFromFlux: function getStateFromFlux() {
	    var flux = this.getFlux();
	    var enquiryStoreState = flux.store('EnquiryStore').state;
	    var guestStoreState = flux.store('GuestStore').state;
	    var defaultValues = enquiryStoreState.merge(guestStoreState);
	
	    var contactPreference = 'email';
	
	    if (this.state) {
	      contactPreference = this.state.contactPreference;
	    }
	    var schema = buildSchema(contactPreference, defaultValues);
	
	    return { defaultValues: defaultValues, schema: schema };
	  },
	
	  onUpdate: function onUpdate(value, validation, update) {
	    var field = Immutable.List(update).last();
	    var changedValue = value.getIn(update);
	    var newState = {};
	
	    if (field === 'contact_preference') {
	      newState['contactPreference'] = changedValue;
	      newState['schema'] = buildSchema(changedValue, this.state.defaultValues);
	    }
	
	    this.setState(newState);
	  },
	
	  onSubmit: function onSubmit(event) {
	    var data;
	    var source = this.props.source;
	
	    event.preventDefault();
	    this.refs.form.makeDirty();
	
	    if (!this.refs.form.isValid()) {
	      return;
	    }
	
	    data = this.refs.form.getValue().toJSON();
	    data['enquiry_option'] = 'search_enquiry';
	
	    tracker.submitEnquiry(source, data);
	    http.post(settings.urls.enquiry, data, (function (response) {
	      if (response.statusCode !== 200) {
	        this.setState({
	          status: 'error',
	          error: null
	        });
	      } else {
	        tracker.confirmedEnquiry(source);
	        this.getFlux().actions.tracking.sendEnquiryEvent({ source: source, eventType: 'search-enquiry' });
	        this.setState({ status: 'success' });
	      }
	    }).bind(this)).on('error', (function (e) {
	      this.setState({
	        status: 'error',
	        error: e.message
	      });
	    }).bind(this));
	
	    this.setState({ status: 'submitting' });
	  },
	
	  render: function render() {
	    var cityCode = this.state.defaultValues.get('cityCode', 'LON');
	    var cityName = null;
	
	    if (cityCode !== "" && cityCode !== null) {
	      cityName = cities[cityCode].name;
	    }
	    var status = this.state.status;
	
	    return React.createElement(
	      'section',
	      { className: 'ofs-EnquiryForm' },
	      React.createElement(
	        'div',
	        { className: 'ofs-EnquiryForm__Content' },
	        React.createElement(
	          'h2',
	          { className: 'ofs-EnquiryForm__Title' },
	          messages.HEADING
	        ),
	        status === 'default' && React.createElement(Form, { component: OFSForm,
	          className: 'ofs-Form -form--condensed',
	          ref: 'form',
	          method: 'post',
	          action: '.',
	          onUpdate: this.onUpdate,
	          schema: this.state.schema,
	          onSubmit: this.onSubmit }),
	        status === 'submitting' && React.createElement(
	          'div',
	          { className: 'ofs-EnquiryForm__Message' },
	          React.createElement(
	            'h3',
	            null,
	            messages.SUBMITTING
	          )
	        ),
	        status === 'success' && React.createElement(
	          'div',
	          { className: 'ofs-EnquiryForm__Message' },
	          React.createElement(
	            'h3',
	            null,
	            messages.SUCCESS_HEADING
	          ),
	          React.createElement(
	            'p',
	            null,
	            messages.SUCCESS_MESSAGE
	          )
	        ),
	        status === 'error' && React.createElement(
	          'div',
	          { className: 'ofs-EnquiryForm__Message' },
	          React.createElement(
	            'h3',
	            null,
	            messages.ERROR_HEADING
	          ),
	          React.createElement(
	            'p',
	            null,
	            this.state.message
	          )
	        )
	      ),
	      React.createElement(Footer, { cityCode: cityCode, cityName: cityName })
	    );
	  }
	});
	
	module.exports = ContactForm;

/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _Object$assign = __webpack_require__(32)['default'];
	
	var React = __webpack_require__(40);
	var ReactForms = __webpack_require__(169);
	var Mapping = ReactForms.schema.Mapping;
	var i18n = __webpack_require__(61);
	var gettext = i18n.gettext;
	
	var Scalar = __webpack_require__(194);
	var scalars = __webpack_require__(198);
	var ToggleSelect = __webpack_require__(223);
	
	var buildLayout = __webpack_require__(323);
	
	var messages = {
	  CALL_RES: gettext('Call reservations on %(telephone_number)s'),
	  CALL_OTHER: gettext('Call our %(team_name)s team on %(telephone_number)s'),
	  EMAIL: gettext('Email'),
	  CALL: gettext('Call Me'),
	  MESSAGE_LABEL: gettext('Message'),
	  CONTACT_PREFERENCE_LABEL: gettext('How would you like us to contact you?')
	};
	
	var contactChoices = [{ value: 'email', name: messages.EMAIL }, { value: 'call', name: messages.CALL }];
	
	var contactMappings = {
	  'email': __webpack_require__(229).mapping,
	  'call': __webpack_require__(238).mapping
	};
	
	var buildSchema = function buildSchema(contactPreference, defaultValues) {
	  var Component = buildLayout(contactPreference);
	  var topicMapping = __webpack_require__(314).mapping(defaultValues);
	  var contactMapping = contactMappings[contactPreference](defaultValues);
	
	  var fields = _Object$assign(topicMapping, {
	    'message': scalars.TextScalar({
	      label: messages.MESSAGE_LABEL
	    }),
	    'contact_preference': Scalar({
	      label: messages.CONTACT_PREFERENCE_LABEL,
	      input: React.createElement(ToggleSelect, { options: contactChoices, className: 'ignore-react-onclickoutside' }),
	      defaultValue: contactPreference
	    })
	  }, contactMapping);
	
	  return Mapping({ component: Component }, fields);
	};
	
	module.exports = buildSchema;

/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(40);
	var PureRenderMixin = __webpack_require__(40).addons.PureRenderMixin;
	
	var ReactForms = __webpack_require__(169);
	
	var Layout = __webpack_require__(225);
	var Row = __webpack_require__(226);
	var Column = __webpack_require__(227);
	var Group = __webpack_require__(228);
	
	var Element = ReactForms.Element;
	
	var contactLayouts = {
	  'email': __webpack_require__(229).layout,
	  'call': __webpack_require__(238).layout
	};
	
	var buildLayout = function buildLayout(contactPreference) {
	  var topicLayout = __webpack_require__(314).layout;
	  var contactLayout = contactLayouts[contactPreference];
	
	  return React.createClass({
	    mixins: [PureRenderMixin],
	
	    render: function render() {
	      var value = this.props.value;
	
	      return React.createElement(
	        Layout,
	        null,
	        topicLayout(value),
	        React.createElement(
	          Group,
	          null,
	          React.createElement(
	            Row,
	            null,
	            React.createElement(
	              Column,
	              { size: 'full' },
	              React.createElement(Element, { value: value.get('message') })
	            )
	          ),
	          React.createElement(
	            Row,
	            null,
	            React.createElement(
	              Column,
	              { size: 'full' },
	              React.createElement(Element, { value: value.get('contact_preference') })
	            )
	          ),
	          contactLayout(value)
	        )
	      );
	    }
	  });
	};
	
	module.exports = buildLayout;

/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var messages = __webpack_require__(325);
	
	var i18nConfig = {
	    previousMonth: messages.previousMonth,
	    nextMonth: messages.nextMonth,
	    months: messages.fullMonths,
	    weekdays: messages.fullDays,
	    weekdaysShort: messages.mediumDays
	};
	
	module.exports = i18nConfig;

/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ofsI18n = __webpack_require__(61);
	
	var messages = {
	  previousMonth: (0, _ofsI18n.gettext)('Previous Month'),
	  nextMonth: (0, _ofsI18n.gettext)('Next Month'),
	  shortDays: (0, _ofsI18n.gettext)("Su_Mo_Tu_We_Th_Fr_Sa").split("_"),
	  mediumDays: (0, _ofsI18n.gettext)("Sun_Mon_Tue_Wed_Thu_Fri_Sat").split("_"),
	  fullDays: (0, _ofsI18n.gettext)("Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday").split("_"),
	  shortMonths: (0, _ofsI18n.gettext)("Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec").split("_"),
	  fullMonths: (0, _ofsI18n.gettext)("January_February_March_April_May_June_July_August_September_October_November_December").split("_")
	};
	
	module.exports = messages;

/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var React = __webpack_require__(40);
	var Tooltip = React.createFactory(__webpack_require__(327));
	
	module.exports = function (el, config) {
	  React.render(Tooltip(config), el);
	};

/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var React = __webpack_require__(40);
	var $ = __webpack_require__(39);
	var _ = __webpack_require__(66);
	var Tether = __webpack_require__(328);
	
	var Tooltip = React.createClass({
	  displayName: 'Tooltip',
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      orientation: 'right'
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      visible: false
	    };
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.initTether();
	    this.bindMouseEvents();
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    this.state.tether.position();
	  },
	
	  initTether: function initTether() {
	    // if the tooltip points to the left, we need to attach the arrow on the right and vice versa
	    var attachment = this.props.orientation === "left" ? "right" : "left";
	    var tether = new Tether({
	      element: $(this.getDOMNode()).parent()[0],
	      target: this.props.tetherTo,
	      attachment: 'bottom ' + attachment,
	      targetAttachment: 'top center',
	      offset: '20px 0',
	      constraints: [{
	        to: 'scrollParent',
	        pin: true
	      }]
	    });
	    tether.enable();
	
	    this.setState({
	      tether: tether
	    });
	  },
	
	  bindMouseEvents: function bindMouseEvents() {
	    var onBodyClick = _.bind(this.onBodyClick, this);
	    var onClick = _.bind(this.onClick, this);
	    var onMouseEnter = _.bind(this.onMouseEnter, this);
	    var onMouseLeave = _.bind(this.onMouseLeave, this);
	
	    $('body').on('click', onBodyClick);
	    $(this.props.tetherTo).on('click', onClick);
	    $(this.props.tetherTo).on('mouseenter', onMouseEnter);
	    $(this.props.tetherTo).on('mouseleave', onMouseLeave);
	
	    this.setState({
	      listeners: {
	        onBodyClick: onBodyClick,
	        onClick: onClick,
	        onMouseEnter: onMouseEnter,
	        onMouseLeave: onMouseLeave
	      }
	    });
	  },
	
	  onClick: function onClick(e) {
	    e.stopPropagation();
	    this.setState({ visible: !this.state.visible });
	  },
	
	  onBodyClick: function onBodyClick(e) {
	    var $el = $(this.getDOMNode());
	    var $target = $(e.target);
	
	    var clickOutside = !$el.is($target) && !$el.has($target).length;
	
	    if (this.state.visible === true && clickOutside) {
	      this.setState({ visible: false });
	    }
	  },
	
	  onMouseEnter: function onMouseEnter() {
	    this.setState({ visible: true });
	  },
	
	  onMouseLeave: function onMouseLeave() {
	    this.setState({ visible: false });
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    this.destroyTether();
	    this.unbindMouseEvents();
	  },
	
	  destroyTether: function destroyTether() {
	    this.state.tether.destroy();
	  },
	
	  unbindMouseEvents: function unbindMouseEvents() {
	    $('body').off('click', this.state.onBodyClick);
	    $(this.props.tetherTo).off('click', this.state.onClick);
	    $(this.props.tetherTo).off('mouseenter', this.state.onMouseEnter);
	    $(this.props.tetherTo).off('mouseleave', this.state.onMouseLeave);
	  },
	
	  render: function render() {
	    var visibilityClass = this.state.visible ? "" : "react-tooltip-hidden";
	    var contents = this.props.label;
	
	    if (this.props.children) {
	      contents = this.props.children;
	    }
	
	    return React.createElement(
	      'div',
	      { className: visibilityClass },
	      React.createElement(
	        'div',
	        { className: 'react-tooltip-label' },
	        contents
	      ),
	      React.createElement('div', { className: "react-tooltip-arrow react-tooltip-arrow-" + this.props.orientation })
	    );
	  }
	});
	
	module.exports = Tooltip;

/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! tether 0.6.5 */
	
	'use strict';
	
	(function (root, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    module.exports = factory(require, exports, module);
	  } else {
	    root.Tether = factory();
	  }
	})(undefined, function (require, exports, module) {
	
	  (function () {
	    var Evented,
	        addClass,
	        defer,
	        deferred,
	        extend,
	        flush,
	        getBounds,
	        getOffsetParent,
	        getOrigin,
	        getScrollBarSize,
	        getScrollParent,
	        hasClass,
	        node,
	        removeClass,
	        uniqueId,
	        updateClasses,
	        zeroPosCache,
	        __hasProp = ({}).hasOwnProperty,
	        __indexOf = [].indexOf || function (item) {
	      for (var i = 0, l = this.length; i < l; i++) {
	        if (i in this && this[i] === item) return i;
	      }return -1;
	    },
	        __slice = [].slice;
	
	    if (this.Tether == null) {
	      this.Tether = {
	        modules: []
	      };
	    }
	
	    getScrollParent = function (el) {
	      var parent, position, scrollParent, style, _ref;
	      position = getComputedStyle(el).position;
	      if (position === 'fixed') {
	        return el;
	      }
	      scrollParent = void 0;
	      parent = el;
	      while (parent = parent.parentNode) {
	        try {
	          style = getComputedStyle(parent);
	        } catch (_error) {}
	        if (style == null) {
	          return parent;
	        }
	        if (/(auto|scroll)/.test(style['overflow'] + style['overflow-y'] + style['overflow-x'])) {
	          if (position !== 'absolute' || ((_ref = style['position']) === 'relative' || _ref === 'absolute' || _ref === 'fixed')) {
	            return parent;
	          }
	        }
	      }
	      return document.body;
	    };
	
	    uniqueId = (function () {
	      var id;
	      id = 0;
	      return function () {
	        return id++;
	      };
	    })();
	
	    zeroPosCache = {};
	
	    getOrigin = function (doc) {
	      var id, k, node, v, _ref;
	      node = doc._tetherZeroElement;
	      if (node == null) {
	        node = doc.createElement('div');
	        node.setAttribute('data-tether-id', uniqueId());
	        extend(node.style, {
	          top: 0,
	          left: 0,
	          position: 'absolute'
	        });
	        doc.body.appendChild(node);
	        doc._tetherZeroElement = node;
	      }
	      id = node.getAttribute('data-tether-id');
	      if (zeroPosCache[id] == null) {
	        zeroPosCache[id] = {};
	        _ref = node.getBoundingClientRect();
	        for (k in _ref) {
	          v = _ref[k];
	          zeroPosCache[id][k] = v;
	        }
	        defer(function () {
	          return zeroPosCache[id] = void 0;
	        });
	      }
	      return zeroPosCache[id];
	    };
	
	    node = null;
	
	    getBounds = function (el) {
	      var box, doc, docEl, k, origin, v, _ref;
	      if (el === document) {
	        doc = document;
	        el = document.documentElement;
	      } else {
	        doc = el.ownerDocument;
	      }
	      docEl = doc.documentElement;
	      box = {};
	      _ref = el.getBoundingClientRect();
	      for (k in _ref) {
	        v = _ref[k];
	        box[k] = v;
	      }
	      origin = getOrigin(doc);
	      box.top -= origin.top;
	      box.left -= origin.left;
	      if (box.width == null) {
	        box.width = document.body.scrollWidth - box.left - box.right;
	      }
	      if (box.height == null) {
	        box.height = document.body.scrollHeight - box.top - box.bottom;
	      }
	      box.top = box.top - docEl.clientTop;
	      box.left = box.left - docEl.clientLeft;
	      box.right = doc.body.clientWidth - box.width - box.left;
	      box.bottom = doc.body.clientHeight - box.height - box.top;
	      return box;
	    };
	
	    getOffsetParent = function (el) {
	      return el.offsetParent || document.documentElement;
	    };
	
	    getScrollBarSize = function () {
	      var inner, outer, width, widthContained, widthScroll;
	      inner = document.createElement('div');
	      inner.style.width = '100%';
	      inner.style.height = '200px';
	      outer = document.createElement('div');
	      extend(outer.style, {
	        position: 'absolute',
	        top: 0,
	        left: 0,
	        pointerEvents: 'none',
	        visibility: 'hidden',
	        width: '200px',
	        height: '150px',
	        overflow: 'hidden'
	      });
	      outer.appendChild(inner);
	      document.body.appendChild(outer);
	      widthContained = inner.offsetWidth;
	      outer.style.overflow = 'scroll';
	      widthScroll = inner.offsetWidth;
	      if (widthContained === widthScroll) {
	        widthScroll = outer.clientWidth;
	      }
	      document.body.removeChild(outer);
	      width = widthContained - widthScroll;
	      return {
	        width: width,
	        height: width
	      };
	    };
	
	    extend = function (out) {
	      var args, key, obj, val, _i, _len, _ref;
	      if (out == null) {
	        out = {};
	      }
	      args = [];
	      Array.prototype.push.apply(args, arguments);
	      _ref = args.slice(1);
	      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	        obj = _ref[_i];
	        if (obj) {
	          for (key in obj) {
	            if (!__hasProp.call(obj, key)) continue;
	            val = obj[key];
	            out[key] = val;
	          }
	        }
	      }
	      return out;
	    };
	
	    removeClass = function (el, name) {
	      var cls, _i, _len, _ref, _results;
	      if (el.classList != null) {
	        _ref = name.split(' ');
	        _results = [];
	        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	          cls = _ref[_i];
	          if (cls.trim()) {
	            _results.push(el.classList.remove(cls));
	          }
	        }
	        return _results;
	      } else {
	        return el.className = el.className.replace(new RegExp("(^| )" + name.split(' ').join('|') + "( |$)", 'gi'), ' ');
	      }
	    };
	
	    addClass = function (el, name) {
	      var cls, _i, _len, _ref, _results;
	      if (el.classList != null) {
	        _ref = name.split(' ');
	        _results = [];
	        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	          cls = _ref[_i];
	          if (cls.trim()) {
	            _results.push(el.classList.add(cls));
	          }
	        }
	        return _results;
	      } else {
	        removeClass(el, name);
	        return el.className += " " + name;
	      }
	    };
	
	    hasClass = function (el, name) {
	      if (el.classList != null) {
	        return el.classList.contains(name);
	      } else {
	        return new RegExp("(^| )" + name + "( |$)", 'gi').test(el.className);
	      }
	    };
	
	    updateClasses = function (el, add, all) {
	      var cls, _i, _j, _len, _len1, _results;
	      for (_i = 0, _len = all.length; _i < _len; _i++) {
	        cls = all[_i];
	        if (__indexOf.call(add, cls) < 0) {
	          if (hasClass(el, cls)) {
	            removeClass(el, cls);
	          }
	        }
	      }
	      _results = [];
	      for (_j = 0, _len1 = add.length; _j < _len1; _j++) {
	        cls = add[_j];
	        if (!hasClass(el, cls)) {
	          _results.push(addClass(el, cls));
	        } else {
	          _results.push(void 0);
	        }
	      }
	      return _results;
	    };
	
	    deferred = [];
	
	    defer = function (fn) {
	      return deferred.push(fn);
	    };
	
	    flush = function () {
	      var fn, _results;
	      _results = [];
	      while (fn = deferred.pop()) {
	        _results.push(fn());
	      }
	      return _results;
	    };
	
	    Evented = (function () {
	      function Evented() {}
	
	      Evented.prototype.on = function (event, handler, ctx, once) {
	        var _base;
	        if (once == null) {
	          once = false;
	        }
	        if (this.bindings == null) {
	          this.bindings = {};
	        }
	        if ((_base = this.bindings)[event] == null) {
	          _base[event] = [];
	        }
	        return this.bindings[event].push({
	          handler: handler,
	          ctx: ctx,
	          once: once
	        });
	      };
	
	      Evented.prototype.once = function (event, handler, ctx) {
	        return this.on(event, handler, ctx, true);
	      };
	
	      Evented.prototype.off = function (event, handler) {
	        var i, _ref, _results;
	        if (((_ref = this.bindings) != null ? _ref[event] : void 0) == null) {
	          return;
	        }
	        if (handler == null) {
	          return delete this.bindings[event];
	        } else {
	          i = 0;
	          _results = [];
	          while (i < this.bindings[event].length) {
	            if (this.bindings[event][i].handler === handler) {
	              _results.push(this.bindings[event].splice(i, 1));
	            } else {
	              _results.push(i++);
	            }
	          }
	          return _results;
	        }
	      };
	
	      Evented.prototype.trigger = function () {
	        var args, ctx, event, handler, i, once, _ref, _ref1, _results;
	        event = arguments[0], args = 2 <= arguments.length ? __slice.call(arguments, 1) : [];
	        if ((_ref = this.bindings) != null ? _ref[event] : void 0) {
	          i = 0;
	          _results = [];
	          while (i < this.bindings[event].length) {
	            _ref1 = this.bindings[event][i], handler = _ref1.handler, ctx = _ref1.ctx, once = _ref1.once;
	            handler.apply(ctx != null ? ctx : this, args);
	            if (once) {
	              _results.push(this.bindings[event].splice(i, 1));
	            } else {
	              _results.push(i++);
	            }
	          }
	          return _results;
	        }
	      };
	
	      return Evented;
	    })();
	
	    this.Tether.Utils = {
	      getScrollParent: getScrollParent,
	      getBounds: getBounds,
	      getOffsetParent: getOffsetParent,
	      extend: extend,
	      addClass: addClass,
	      removeClass: removeClass,
	      hasClass: hasClass,
	      updateClasses: updateClasses,
	      defer: defer,
	      flush: flush,
	      uniqueId: uniqueId,
	      Evented: Evented,
	      getScrollBarSize: getScrollBarSize
	    };
	  }).call(this);
	
	  (function () {
	    var MIRROR_LR,
	        MIRROR_TB,
	        OFFSET_MAP,
	        Tether,
	        addClass,
	        addOffset,
	        attachmentToOffset,
	        autoToFixedAttachment,
	        defer,
	        extend,
	        flush,
	        getBounds,
	        getOffsetParent,
	        getOuterSize,
	        getScrollBarSize,
	        getScrollParent,
	        getSize,
	        now,
	        offsetToPx,
	        parseAttachment,
	        parseOffset,
	        position,
	        removeClass,
	        tethers,
	        transformKey,
	        updateClasses,
	        within,
	        _Tether,
	        _ref,
	        __slice = [].slice,
	        __bind = function __bind(fn, me) {
	      return function () {
	        return fn.apply(me, arguments);
	      };
	    };
	
	    if (this.Tether == null) {
	      throw new Error("You must include the utils.js file before tether.js");
	    }
	
	    Tether = this.Tether;
	
	    _ref = Tether.Utils, getScrollParent = _ref.getScrollParent, getSize = _ref.getSize, getOuterSize = _ref.getOuterSize, getBounds = _ref.getBounds, getOffsetParent = _ref.getOffsetParent, extend = _ref.extend, addClass = _ref.addClass, removeClass = _ref.removeClass, updateClasses = _ref.updateClasses, defer = _ref.defer, flush = _ref.flush, getScrollBarSize = _ref.getScrollBarSize;
	
	    within = function (a, b, diff) {
	      if (diff == null) {
	        diff = 1;
	      }
	      return a + diff >= b && b >= a - diff;
	    };
	
	    transformKey = (function () {
	      var el, key, _i, _len, _ref1;
	      el = document.createElement('div');
	      _ref1 = ['transform', 'webkitTransform', 'OTransform', 'MozTransform', 'msTransform'];
	      for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
	        key = _ref1[_i];
	        if (el.style[key] !== void 0) {
	          return key;
	        }
	      }
	    })();
	
	    tethers = [];
	
	    position = function () {
	      var tether, _i, _len;
	      for (_i = 0, _len = tethers.length; _i < _len; _i++) {
	        tether = tethers[_i];
	        tether.position(false);
	      }
	      return flush();
	    };
	
	    now = function () {
	      var _ref1;
	      return (_ref1 = typeof performance !== "undefined" && performance !== null ? typeof performance.now === "function" ? performance.now() : void 0 : void 0) != null ? _ref1 : +new Date();
	    };
	
	    (function () {
	      var event, lastCall, lastDuration, pendingTimeout, tick, _i, _len, _ref1, _results;
	      lastCall = null;
	      lastDuration = null;
	      pendingTimeout = null;
	      tick = function () {
	        if (lastDuration != null && lastDuration > 16) {
	          lastDuration = Math.min(lastDuration - 16, 250);
	          pendingTimeout = setTimeout(tick, 250);
	          return;
	        }
	        if (lastCall != null && now() - lastCall < 10) {
	          return;
	        }
	        if (pendingTimeout != null) {
	          clearTimeout(pendingTimeout);
	          pendingTimeout = null;
	        }
	        lastCall = now();
	        position();
	        return lastDuration = now() - lastCall;
	      };
	      _ref1 = ['resize', 'scroll', 'touchmove'];
	      _results = [];
	      for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
	        event = _ref1[_i];
	        _results.push(window.addEventListener(event, tick));
	      }
	      return _results;
	    })();
	
	    MIRROR_LR = {
	      center: 'center',
	      left: 'right',
	      right: 'left'
	    };
	
	    MIRROR_TB = {
	      middle: 'middle',
	      top: 'bottom',
	      bottom: 'top'
	    };
	
	    OFFSET_MAP = {
	      top: 0,
	      left: 0,
	      middle: '50%',
	      center: '50%',
	      bottom: '100%',
	      right: '100%'
	    };
	
	    autoToFixedAttachment = function (attachment, relativeToAttachment) {
	      var left, top;
	      left = attachment.left, top = attachment.top;
	      if (left === 'auto') {
	        left = MIRROR_LR[relativeToAttachment.left];
	      }
	      if (top === 'auto') {
	        top = MIRROR_TB[relativeToAttachment.top];
	      }
	      return {
	        left: left,
	        top: top
	      };
	    };
	
	    attachmentToOffset = function (attachment) {
	      var _ref1, _ref2;
	      return {
	        left: (_ref1 = OFFSET_MAP[attachment.left]) != null ? _ref1 : attachment.left,
	        top: (_ref2 = OFFSET_MAP[attachment.top]) != null ? _ref2 : attachment.top
	      };
	    };
	
	    addOffset = function () {
	      var left, offsets, out, top, _i, _len, _ref1;
	      offsets = 1 <= arguments.length ? __slice.call(arguments, 0) : [];
	      out = {
	        top: 0,
	        left: 0
	      };
	      for (_i = 0, _len = offsets.length; _i < _len; _i++) {
	        _ref1 = offsets[_i], top = _ref1.top, left = _ref1.left;
	        if (typeof top === 'string') {
	          top = parseFloat(top, 10);
	        }
	        if (typeof left === 'string') {
	          left = parseFloat(left, 10);
	        }
	        out.top += top;
	        out.left += left;
	      }
	      return out;
	    };
	
	    offsetToPx = function (offset, size) {
	      if (typeof offset.left === 'string' && offset.left.indexOf('%') !== -1) {
	        offset.left = parseFloat(offset.left, 10) / 100 * size.width;
	      }
	      if (typeof offset.top === 'string' && offset.top.indexOf('%') !== -1) {
	        offset.top = parseFloat(offset.top, 10) / 100 * size.height;
	      }
	      return offset;
	    };
	
	    parseAttachment = parseOffset = function (value) {
	      var left, top, _ref1;
	      _ref1 = value.split(' '), top = _ref1[0], left = _ref1[1];
	      return {
	        top: top,
	        left: left
	      };
	    };
	
	    _Tether = (function () {
	      _Tether.modules = [];
	
	      function _Tether(options) {
	        this.position = __bind(this.position, this);
	        var module, _i, _len, _ref1, _ref2;
	        tethers.push(this);
	        this.history = [];
	        this.setOptions(options, false);
	        _ref1 = Tether.modules;
	        for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
	          module = _ref1[_i];
	          if ((_ref2 = module.initialize) != null) {
	            _ref2.call(this);
	          }
	        }
	        this.position();
	      }
	
	      _Tether.prototype.getClass = function (key) {
	        var _ref1, _ref2;
	        if ((_ref1 = this.options.classes) != null ? _ref1[key] : void 0) {
	          return this.options.classes[key];
	        } else if (((_ref2 = this.options.classes) != null ? _ref2[key] : void 0) !== false) {
	          if (this.options.classPrefix) {
	            return "" + this.options.classPrefix + "-" + key;
	          } else {
	            return key;
	          }
	        } else {
	          return '';
	        }
	      };
	
	      _Tether.prototype.setOptions = function (options, position) {
	        var defaults, key, _i, _len, _ref1, _ref2;
	        this.options = options;
	        if (position == null) {
	          position = true;
	        }
	        defaults = {
	          offset: '0 0',
	          targetOffset: '0 0',
	          targetAttachment: 'auto auto',
	          classPrefix: 'tether'
	        };
	        this.options = extend(defaults, this.options);
	        _ref1 = this.options, this.element = _ref1.element, this.target = _ref1.target, this.targetModifier = _ref1.targetModifier;
	        if (this.target === 'viewport') {
	          this.target = document.body;
	          this.targetModifier = 'visible';
	        } else if (this.target === 'scroll-handle') {
	          this.target = document.body;
	          this.targetModifier = 'scroll-handle';
	        }
	        _ref2 = ['element', 'target'];
	        for (_i = 0, _len = _ref2.length; _i < _len; _i++) {
	          key = _ref2[_i];
	          if (this[key] == null) {
	            throw new Error("Tether Error: Both element and target must be defined");
	          }
	          if (this[key].jquery != null) {
	            this[key] = this[key][0];
	          } else if (typeof this[key] === 'string') {
	            this[key] = document.querySelector(this[key]);
	          }
	        }
	        addClass(this.element, this.getClass('element'));
	        addClass(this.target, this.getClass('target'));
	        if (!this.options.attachment) {
	          throw new Error("Tether Error: You must provide an attachment");
	        }
	        this.targetAttachment = parseAttachment(this.options.targetAttachment);
	        this.attachment = parseAttachment(this.options.attachment);
	        this.offset = parseOffset(this.options.offset);
	        this.targetOffset = parseOffset(this.options.targetOffset);
	        if (this.scrollParent != null) {
	          this.disable();
	        }
	        if (this.targetModifier === 'scroll-handle') {
	          this.scrollParent = this.target;
	        } else {
	          this.scrollParent = getScrollParent(this.target);
	        }
	        if (this.options.enabled !== false) {
	          return this.enable(position);
	        }
	      };
	
	      _Tether.prototype.getTargetBounds = function () {
	        var bounds, fitAdj, hasBottomScroll, height, out, scrollBottom, scrollPercentage, style, target;
	        if (this.targetModifier != null) {
	          switch (this.targetModifier) {
	            case 'visible':
	              if (this.target === document.body) {
	                return {
	                  top: pageYOffset,
	                  left: pageXOffset,
	                  height: innerHeight,
	                  width: innerWidth
	                };
	              } else {
	                bounds = getBounds(this.target);
	                out = {
	                  height: bounds.height,
	                  width: bounds.width,
	                  top: bounds.top,
	                  left: bounds.left
	                };
	                out.height = Math.min(out.height, bounds.height - (pageYOffset - bounds.top));
	                out.height = Math.min(out.height, bounds.height - (bounds.top + bounds.height - (pageYOffset + innerHeight)));
	                out.height = Math.min(innerHeight, out.height);
	                out.height -= 2;
	                out.width = Math.min(out.width, bounds.width - (pageXOffset - bounds.left));
	                out.width = Math.min(out.width, bounds.width - (bounds.left + bounds.width - (pageXOffset + innerWidth)));
	                out.width = Math.min(innerWidth, out.width);
	                out.width -= 2;
	                if (out.top < pageYOffset) {
	                  out.top = pageYOffset;
	                }
	                if (out.left < pageXOffset) {
	                  out.left = pageXOffset;
	                }
	                return out;
	              }
	              break;
	            case 'scroll-handle':
	              target = this.target;
	              if (target === document.body) {
	                target = document.documentElement;
	                bounds = {
	                  left: pageXOffset,
	                  top: pageYOffset,
	                  height: innerHeight,
	                  width: innerWidth
	                };
	              } else {
	                bounds = getBounds(target);
	              }
	              style = getComputedStyle(target);
	              hasBottomScroll = target.scrollWidth > target.clientWidth || 'scroll' === [style.overflow, style.overflowX] || this.target !== document.body;
	              scrollBottom = 0;
	              if (hasBottomScroll) {
	                scrollBottom = 15;
	              }
	              height = bounds.height - parseFloat(style.borderTopWidth) - parseFloat(style.borderBottomWidth) - scrollBottom;
	              out = {
	                width: 15,
	                height: height * 0.975 * (height / target.scrollHeight),
	                left: bounds.left + bounds.width - parseFloat(style.borderLeftWidth) - 15
	              };
	              fitAdj = 0;
	              if (height < 408 && this.target === document.body) {
	                fitAdj = -0.00011 * Math.pow(height, 2) - 0.00727 * height + 22.58;
	              }
	              if (this.target !== document.body) {
	                out.height = Math.max(out.height, 24);
	              }
	              scrollPercentage = this.target.scrollTop / (target.scrollHeight - height);
	              out.top = scrollPercentage * (height - out.height - fitAdj) + bounds.top + parseFloat(style.borderTopWidth);
	              if (this.target === document.body) {
	                out.height = Math.max(out.height, 24);
	              }
	              return out;
	          }
	        } else {
	          return getBounds(this.target);
	        }
	      };
	
	      _Tether.prototype.clearCache = function () {
	        return this._cache = {};
	      };
	
	      _Tether.prototype.cache = function (k, getter) {
	        if (this._cache == null) {
	          this._cache = {};
	        }
	        if (this._cache[k] == null) {
	          this._cache[k] = getter.call(this);
	        }
	        return this._cache[k];
	      };
	
	      _Tether.prototype.enable = function (position) {
	        if (position == null) {
	          position = true;
	        }
	        addClass(this.target, this.getClass('enabled'));
	        addClass(this.element, this.getClass('enabled'));
	        this.enabled = true;
	        if (this.scrollParent !== document) {
	          this.scrollParent.addEventListener('scroll', this.position);
	        }
	        if (position) {
	          return this.position();
	        }
	      };
	
	      _Tether.prototype.disable = function () {
	        removeClass(this.target, this.getClass('enabled'));
	        removeClass(this.element, this.getClass('enabled'));
	        this.enabled = false;
	        if (this.scrollParent != null) {
	          return this.scrollParent.removeEventListener('scroll', this.position);
	        }
	      };
	
	      _Tether.prototype.destroy = function () {
	        var i, tether, _i, _len, _results;
	        this.disable();
	        _results = [];
	        for (i = _i = 0, _len = tethers.length; _i < _len; i = ++_i) {
	          tether = tethers[i];
	          if (tether === this) {
	            tethers.splice(i, 1);
	            break;
	          } else {
	            _results.push(void 0);
	          }
	        }
	        return _results;
	      };
	
	      _Tether.prototype.updateAttachClasses = function (elementAttach, targetAttach) {
	        var add,
	            all,
	            side,
	            sides,
	            _i,
	            _j,
	            _len,
	            _len1,
	            _ref1,
	            _this = this;
	        if (elementAttach == null) {
	          elementAttach = this.attachment;
	        }
	        if (targetAttach == null) {
	          targetAttach = this.targetAttachment;
	        }
	        sides = ['left', 'top', 'bottom', 'right', 'middle', 'center'];
	        if ((_ref1 = this._addAttachClasses) != null ? _ref1.length : void 0) {
	          this._addAttachClasses.splice(0, this._addAttachClasses.length);
	        }
	        add = this._addAttachClasses != null ? this._addAttachClasses : this._addAttachClasses = [];
	        if (elementAttach.top) {
	          add.push("" + this.getClass('element-attached') + "-" + elementAttach.top);
	        }
	        if (elementAttach.left) {
	          add.push("" + this.getClass('element-attached') + "-" + elementAttach.left);
	        }
	        if (targetAttach.top) {
	          add.push("" + this.getClass('target-attached') + "-" + targetAttach.top);
	        }
	        if (targetAttach.left) {
	          add.push("" + this.getClass('target-attached') + "-" + targetAttach.left);
	        }
	        all = [];
	        for (_i = 0, _len = sides.length; _i < _len; _i++) {
	          side = sides[_i];
	          all.push("" + this.getClass('element-attached') + "-" + side);
	        }
	        for (_j = 0, _len1 = sides.length; _j < _len1; _j++) {
	          side = sides[_j];
	          all.push("" + this.getClass('target-attached') + "-" + side);
	        }
	        return defer(function () {
	          if (_this._addAttachClasses == null) {
	            return;
	          }
	          updateClasses(_this.element, _this._addAttachClasses, all);
	          updateClasses(_this.target, _this._addAttachClasses, all);
	          return _this._addAttachClasses = void 0;
	        });
	      };
	
	      _Tether.prototype.position = function (flushChanges) {
	        var elementPos,
	            elementStyle,
	            height,
	            left,
	            manualOffset,
	            manualTargetOffset,
	            module,
	            next,
	            offset,
	            offsetBorder,
	            offsetParent,
	            offsetParentSize,
	            offsetParentStyle,
	            offsetPosition,
	            ret,
	            scrollLeft,
	            scrollTop,
	            scrollbarSize,
	            side,
	            targetAttachment,
	            targetOffset,
	            targetPos,
	            targetSize,
	            top,
	            width,
	            _i,
	            _j,
	            _len,
	            _len1,
	            _ref1,
	            _ref2,
	            _ref3,
	            _ref4,
	            _ref5,
	            _ref6,
	            _this = this;
	        if (flushChanges == null) {
	          flushChanges = true;
	        }
	        if (!this.enabled) {
	          return;
	        }
	        this.clearCache();
	        targetAttachment = autoToFixedAttachment(this.targetAttachment, this.attachment);
	        this.updateAttachClasses(this.attachment, targetAttachment);
	        elementPos = this.cache('element-bounds', function () {
	          return getBounds(_this.element);
	        });
	        width = elementPos.width, height = elementPos.height;
	        if (width === 0 && height === 0 && this.lastSize != null) {
	          _ref1 = this.lastSize, width = _ref1.width, height = _ref1.height;
	        } else {
	          this.lastSize = {
	            width: width,
	            height: height
	          };
	        }
	        targetSize = targetPos = this.cache('target-bounds', function () {
	          return _this.getTargetBounds();
	        });
	        offset = offsetToPx(attachmentToOffset(this.attachment), {
	          width: width,
	          height: height
	        });
	        targetOffset = offsetToPx(attachmentToOffset(targetAttachment), targetSize);
	        manualOffset = offsetToPx(this.offset, {
	          width: width,
	          height: height
	        });
	        manualTargetOffset = offsetToPx(this.targetOffset, targetSize);
	        offset = addOffset(offset, manualOffset);
	        targetOffset = addOffset(targetOffset, manualTargetOffset);
	        left = targetPos.left + targetOffset.left - offset.left;
	        top = targetPos.top + targetOffset.top - offset.top;
	        _ref2 = Tether.modules;
	        for (_i = 0, _len = _ref2.length; _i < _len; _i++) {
	          module = _ref2[_i];
	          ret = module.position.call(this, {
	            left: left,
	            top: top,
	            targetAttachment: targetAttachment,
	            targetPos: targetPos,
	            attachment: this.attachment,
	            elementPos: elementPos,
	            offset: offset,
	            targetOffset: targetOffset,
	            manualOffset: manualOffset,
	            manualTargetOffset: manualTargetOffset,
	            scrollbarSize: scrollbarSize
	          });
	          if (ret == null || typeof ret !== 'object') {
	            continue;
	          } else if (ret === false) {
	            return false;
	          } else {
	            top = ret.top, left = ret.left;
	          }
	        }
	        next = {
	          page: {
	            top: top,
	            left: left
	          },
	          viewport: {
	            top: top - pageYOffset,
	            bottom: pageYOffset - top - height + innerHeight,
	            left: left - pageXOffset,
	            right: pageXOffset - left - width + innerWidth
	          }
	        };
	        if (document.body.scrollWidth > window.innerWidth) {
	          scrollbarSize = this.cache('scrollbar-size', getScrollBarSize);
	          next.viewport.bottom -= scrollbarSize.height;
	        }
	        if (document.body.scrollHeight > window.innerHeight) {
	          scrollbarSize = this.cache('scrollbar-size', getScrollBarSize);
	          next.viewport.right -= scrollbarSize.width;
	        }
	        if ((_ref3 = document.body.style.position) !== '' && _ref3 !== 'static' || (_ref4 = document.body.parentElement.style.position) !== '' && _ref4 !== 'static') {
	          next.page.bottom = document.body.scrollHeight - top - height;
	          next.page.right = document.body.scrollWidth - left - width;
	        }
	        if (((_ref5 = this.options.optimizations) != null ? _ref5.moveElement : void 0) !== false && this.targetModifier == null) {
	          offsetParent = this.cache('target-offsetparent', function () {
	            return getOffsetParent(_this.target);
	          });
	          offsetPosition = this.cache('target-offsetparent-bounds', function () {
	            return getBounds(offsetParent);
	          });
	          offsetParentStyle = getComputedStyle(offsetParent);
	          elementStyle = getComputedStyle(this.element);
	          offsetParentSize = offsetPosition;
	          offsetBorder = {};
	          _ref6 = ['Top', 'Left', 'Bottom', 'Right'];
	          for (_j = 0, _len1 = _ref6.length; _j < _len1; _j++) {
	            side = _ref6[_j];
	            offsetBorder[side.toLowerCase()] = parseFloat(offsetParentStyle["border" + side + "Width"]);
	          }
	          offsetPosition.right = document.body.scrollWidth - offsetPosition.left - offsetParentSize.width + offsetBorder.right;
	          offsetPosition.bottom = document.body.scrollHeight - offsetPosition.top - offsetParentSize.height + offsetBorder.bottom;
	          if (next.page.top >= offsetPosition.top + offsetBorder.top && next.page.bottom >= offsetPosition.bottom) {
	            if (next.page.left >= offsetPosition.left + offsetBorder.left && next.page.right >= offsetPosition.right) {
	              scrollTop = offsetParent.scrollTop;
	              scrollLeft = offsetParent.scrollLeft;
	              next.offset = {
	                top: next.page.top - offsetPosition.top + scrollTop - offsetBorder.top,
	                left: next.page.left - offsetPosition.left + scrollLeft - offsetBorder.left
	              };
	            }
	          }
	        }
	        this.move(next);
	        this.history.unshift(next);
	        if (this.history.length > 3) {
	          this.history.pop();
	        }
	        if (flushChanges) {
	          flush();
	        }
	        return true;
	      };
	
	      _Tether.prototype.move = function (position) {
	        var css,
	            elVal,
	            found,
	            key,
	            moved,
	            offsetParent,
	            point,
	            same,
	            transcribe,
	            type,
	            val,
	            write,
	            writeCSS,
	            _i,
	            _len,
	            _ref1,
	            _ref2,
	            _this = this;
	        if (this.element.parentNode == null) {
	          return;
	        }
	        same = {};
	        for (type in position) {
	          same[type] = {};
	          for (key in position[type]) {
	            found = false;
	            _ref1 = this.history;
	            for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
	              point = _ref1[_i];
	              if (!within((_ref2 = point[type]) != null ? _ref2[key] : void 0, position[type][key])) {
	                found = true;
	                break;
	              }
	            }
	            if (!found) {
	              same[type][key] = true;
	            }
	          }
	        }
	        css = {
	          top: '',
	          left: '',
	          right: '',
	          bottom: ''
	        };
	        transcribe = function (same, pos) {
	          var xPos, yPos, _ref3;
	          if (((_ref3 = _this.options.optimizations) != null ? _ref3.gpu : void 0) !== false) {
	            if (same.top) {
	              css.top = 0;
	              yPos = pos.top;
	            } else {
	              css.bottom = 0;
	              yPos = -pos.bottom;
	            }
	            if (same.left) {
	              css.left = 0;
	              xPos = pos.left;
	            } else {
	              css.right = 0;
	              xPos = -pos.right;
	            }
	            css[transformKey] = "translateX(" + Math.round(xPos) + "px) translateY(" + Math.round(yPos) + "px)";
	            if (transformKey !== 'msTransform') {
	              return css[transformKey] += " translateZ(0)";
	            }
	          } else {
	            if (same.top) {
	              css.top = "" + pos.top + "px";
	            } else {
	              css.bottom = "" + pos.bottom + "px";
	            }
	            if (same.left) {
	              return css.left = "" + pos.left + "px";
	            } else {
	              return css.right = "" + pos.right + "px";
	            }
	          }
	        };
	        moved = false;
	        if ((same.page.top || same.page.bottom) && (same.page.left || same.page.right)) {
	          css.position = 'absolute';
	          transcribe(same.page, position.page);
	        } else if ((same.viewport.top || same.viewport.bottom) && (same.viewport.left || same.viewport.right)) {
	          css.position = 'fixed';
	          transcribe(same.viewport, position.viewport);
	        } else if (same.offset != null && same.offset.top && same.offset.left) {
	          css.position = 'absolute';
	          offsetParent = this.cache('target-offsetparent', function () {
	            return getOffsetParent(_this.target);
	          });
	          if (getOffsetParent(this.element) !== offsetParent) {
	            defer(function () {
	              _this.element.parentNode.removeChild(_this.element);
	              return offsetParent.appendChild(_this.element);
	            });
	          }
	          transcribe(same.offset, position.offset);
	          moved = true;
	        } else {
	          css.position = 'absolute';
	          transcribe({
	            top: true,
	            left: true
	          }, position.page);
	        }
	        if (!moved && this.element.parentNode.tagName !== 'BODY') {
	          this.element.parentNode.removeChild(this.element);
	          document.body.appendChild(this.element);
	        }
	        writeCSS = {};
	        write = false;
	        for (key in css) {
	          val = css[key];
	          elVal = this.element.style[key];
	          if (elVal !== '' && val !== '' && (key === 'top' || key === 'left' || key === 'bottom' || key === 'right')) {
	            elVal = parseFloat(elVal);
	            val = parseFloat(val);
	          }
	          if (elVal !== val) {
	            write = true;
	            writeCSS[key] = css[key];
	          }
	        }
	        if (write) {
	          return defer(function () {
	            return extend(_this.element.style, writeCSS);
	          });
	        }
	      };
	
	      return _Tether;
	    })();
	
	    Tether.position = position;
	
	    this.Tether = extend(_Tether, Tether);
	  }).call(this);
	
	  (function () {
	    var BOUNDS_FORMAT,
	        MIRROR_ATTACH,
	        defer,
	        extend,
	        getBoundingRect,
	        getBounds,
	        getOuterSize,
	        getSize,
	        updateClasses,
	        _ref,
	        __indexOf = [].indexOf || function (item) {
	      for (var i = 0, l = this.length; i < l; i++) {
	        if (i in this && this[i] === item) return i;
	      }return -1;
	    };
	
	    _ref = this.Tether.Utils, getOuterSize = _ref.getOuterSize, getBounds = _ref.getBounds, getSize = _ref.getSize, extend = _ref.extend, updateClasses = _ref.updateClasses, defer = _ref.defer;
	
	    MIRROR_ATTACH = {
	      left: 'right',
	      right: 'left',
	      top: 'bottom',
	      bottom: 'top',
	      middle: 'middle'
	    };
	
	    BOUNDS_FORMAT = ['left', 'top', 'right', 'bottom'];
	
	    getBoundingRect = function (tether, to) {
	      var i, pos, side, size, style, _i, _len;
	      if (to === 'scrollParent') {
	        to = tether.scrollParent;
	      } else if (to === 'window') {
	        to = [pageXOffset, pageYOffset, innerWidth + pageXOffset, innerHeight + pageYOffset];
	      }
	      if (to === document) {
	        to = to.documentElement;
	      }
	      if (to.nodeType != null) {
	        pos = size = getBounds(to);
	        style = getComputedStyle(to);
	        to = [pos.left, pos.top, size.width + pos.left, size.height + pos.top];
	        for (i = _i = 0, _len = BOUNDS_FORMAT.length; _i < _len; i = ++_i) {
	          side = BOUNDS_FORMAT[i];
	          side = side[0].toUpperCase() + side.substr(1);
	          if (side === 'Top' || side === 'Left') {
	            to[i] += parseFloat(style["border" + side + "Width"]);
	          } else {
	            to[i] -= parseFloat(style["border" + side + "Width"]);
	          }
	        }
	      }
	      return to;
	    };
	
	    this.Tether.modules.push({
	      position: function position(_arg) {
	        var addClasses,
	            allClasses,
	            attachment,
	            bounds,
	            changeAttachX,
	            changeAttachY,
	            cls,
	            constraint,
	            eAttachment,
	            height,
	            left,
	            oob,
	            oobClass,
	            p,
	            pin,
	            pinned,
	            pinnedClass,
	            removeClass,
	            side,
	            tAttachment,
	            targetAttachment,
	            targetHeight,
	            targetSize,
	            targetWidth,
	            to,
	            top,
	            width,
	            _i,
	            _j,
	            _k,
	            _l,
	            _len,
	            _len1,
	            _len2,
	            _len3,
	            _len4,
	            _len5,
	            _m,
	            _n,
	            _ref1,
	            _ref2,
	            _ref3,
	            _ref4,
	            _ref5,
	            _ref6,
	            _ref7,
	            _ref8,
	            _this = this;
	        top = _arg.top, left = _arg.left, targetAttachment = _arg.targetAttachment;
	        if (!this.options.constraints) {
	          return true;
	        }
	        removeClass = function (prefix) {
	          var side, _i, _len, _results;
	          _this.removeClass(prefix);
	          _results = [];
	          for (_i = 0, _len = BOUNDS_FORMAT.length; _i < _len; _i++) {
	            side = BOUNDS_FORMAT[_i];
	            _results.push(_this.removeClass("" + prefix + "-" + side));
	          }
	          return _results;
	        };
	        _ref1 = this.cache('element-bounds', function () {
	          return getBounds(_this.element);
	        }), height = _ref1.height, width = _ref1.width;
	        if (width === 0 && height === 0 && this.lastSize != null) {
	          _ref2 = this.lastSize, width = _ref2.width, height = _ref2.height;
	        }
	        targetSize = this.cache('target-bounds', function () {
	          return _this.getTargetBounds();
	        });
	        targetHeight = targetSize.height;
	        targetWidth = targetSize.width;
	        tAttachment = {};
	        eAttachment = {};
	        allClasses = [this.getClass('pinned'), this.getClass('out-of-bounds')];
	        _ref3 = this.options.constraints;
	        for (_i = 0, _len = _ref3.length; _i < _len; _i++) {
	          constraint = _ref3[_i];
	          if (constraint.outOfBoundsClass) {
	            allClasses.push(constraint.outOfBoundsClass);
	          }
	          if (constraint.pinnedClass) {
	            allClasses.push(constraint.pinnedClass);
	          }
	        }
	        for (_j = 0, _len1 = allClasses.length; _j < _len1; _j++) {
	          cls = allClasses[_j];
	          _ref4 = ['left', 'top', 'right', 'bottom'];
	          for (_k = 0, _len2 = _ref4.length; _k < _len2; _k++) {
	            side = _ref4[_k];
	            allClasses.push("" + cls + "-" + side);
	          }
	        }
	        addClasses = [];
	        tAttachment = extend({}, targetAttachment);
	        eAttachment = extend({}, this.attachment);
	        _ref5 = this.options.constraints;
	        for (_l = 0, _len3 = _ref5.length; _l < _len3; _l++) {
	          constraint = _ref5[_l];
	          to = constraint.to, attachment = constraint.attachment, pin = constraint.pin;
	          if (attachment == null) {
	            attachment = '';
	          }
	          if (__indexOf.call(attachment, ' ') >= 0) {
	            _ref6 = attachment.split(' '), changeAttachY = _ref6[0], changeAttachX = _ref6[1];
	          } else {
	            changeAttachX = changeAttachY = attachment;
	          }
	          bounds = getBoundingRect(this, to);
	          if (changeAttachY === 'target' || changeAttachY === 'both') {
	            if (top < bounds[1] && tAttachment.top === 'top') {
	              top += targetHeight;
	              tAttachment.top = 'bottom';
	            }
	            if (top + height > bounds[3] && tAttachment.top === 'bottom') {
	              top -= targetHeight;
	              tAttachment.top = 'top';
	            }
	          }
	          if (changeAttachY === 'together') {
	            if (top < bounds[1] && tAttachment.top === 'top') {
	              if (eAttachment.top === 'bottom') {
	                top += targetHeight;
	                tAttachment.top = 'bottom';
	                top += height;
	                eAttachment.top = 'top';
	              } else if (eAttachment.top === 'top') {
	                top += targetHeight;
	                tAttachment.top = 'bottom';
	                top -= height;
	                eAttachment.top = 'bottom';
	              }
	            }
	            if (top + height > bounds[3] && tAttachment.top === 'bottom') {
	              if (eAttachment.top === 'top') {
	                top -= targetHeight;
	                tAttachment.top = 'top';
	                top -= height;
	                eAttachment.top = 'bottom';
	              } else if (eAttachment.top === 'bottom') {
	                top -= targetHeight;
	                tAttachment.top = 'top';
	                top += height;
	                eAttachment.top = 'top';
	              }
	            }
	            if (tAttachment.top === 'middle') {
	              if (top + height > bounds[3] && eAttachment.top === 'top') {
	                top -= height;
	                eAttachment.top = 'bottom';
	              } else if (top < bounds[1] && eAttachment.top === 'bottom') {
	                top += height;
	                eAttachment.top = 'top';
	              }
	            }
	          }
	          if (changeAttachX === 'target' || changeAttachX === 'both') {
	            if (left < bounds[0] && tAttachment.left === 'left') {
	              left += targetWidth;
	              tAttachment.left = 'right';
	            }
	            if (left + width > bounds[2] && tAttachment.left === 'right') {
	              left -= targetWidth;
	              tAttachment.left = 'left';
	            }
	          }
	          if (changeAttachX === 'together') {
	            if (left < bounds[0] && tAttachment.left === 'left') {
	              if (eAttachment.left === 'right') {
	                left += targetWidth;
	                tAttachment.left = 'right';
	                left += width;
	                eAttachment.left = 'left';
	              } else if (eAttachment.left === 'left') {
	                left += targetWidth;
	                tAttachment.left = 'right';
	                left -= width;
	                eAttachment.left = 'right';
	              }
	            } else if (left + width > bounds[2] && tAttachment.left === 'right') {
	              if (eAttachment.left === 'left') {
	                left -= targetWidth;
	                tAttachment.left = 'left';
	                left -= width;
	                eAttachment.left = 'right';
	              } else if (eAttachment.left === 'right') {
	                left -= targetWidth;
	                tAttachment.left = 'left';
	                left += width;
	                eAttachment.left = 'left';
	              }
	            } else if (tAttachment.left === 'center') {
	              if (left + width > bounds[2] && eAttachment.left === 'left') {
	                left -= width;
	                eAttachment.left = 'right';
	              } else if (left < bounds[0] && eAttachment.left === 'right') {
	                left += width;
	                eAttachment.left = 'left';
	              }
	            }
	          }
	          if (changeAttachY === 'element' || changeAttachY === 'both') {
	            if (top < bounds[1] && eAttachment.top === 'bottom') {
	              top += height;
	              eAttachment.top = 'top';
	            }
	            if (top + height > bounds[3] && eAttachment.top === 'top') {
	              top -= height;
	              eAttachment.top = 'bottom';
	            }
	          }
	          if (changeAttachX === 'element' || changeAttachX === 'both') {
	            if (left < bounds[0] && eAttachment.left === 'right') {
	              left += width;
	              eAttachment.left = 'left';
	            }
	            if (left + width > bounds[2] && eAttachment.left === 'left') {
	              left -= width;
	              eAttachment.left = 'right';
	            }
	          }
	          if (typeof pin === 'string') {
	            pin = (function () {
	              var _len4, _m, _ref7, _results;
	              _ref7 = pin.split(',');
	              _results = [];
	              for (_m = 0, _len4 = _ref7.length; _m < _len4; _m++) {
	                p = _ref7[_m];
	                _results.push(p.trim());
	              }
	              return _results;
	            })();
	          } else if (pin === true) {
	            pin = ['top', 'left', 'right', 'bottom'];
	          }
	          pin || (pin = []);
	          pinned = [];
	          oob = [];
	          if (top < bounds[1]) {
	            if (__indexOf.call(pin, 'top') >= 0) {
	              top = bounds[1];
	              pinned.push('top');
	            } else {
	              oob.push('top');
	            }
	          }
	          if (top + height > bounds[3]) {
	            if (__indexOf.call(pin, 'bottom') >= 0) {
	              top = bounds[3] - height;
	              pinned.push('bottom');
	            } else {
	              oob.push('bottom');
	            }
	          }
	          if (left < bounds[0]) {
	            if (__indexOf.call(pin, 'left') >= 0) {
	              left = bounds[0];
	              pinned.push('left');
	            } else {
	              oob.push('left');
	            }
	          }
	          if (left + width > bounds[2]) {
	            if (__indexOf.call(pin, 'right') >= 0) {
	              left = bounds[2] - width;
	              pinned.push('right');
	            } else {
	              oob.push('right');
	            }
	          }
	          if (pinned.length) {
	            pinnedClass = (_ref7 = this.options.pinnedClass) != null ? _ref7 : this.getClass('pinned');
	            addClasses.push(pinnedClass);
	            for (_m = 0, _len4 = pinned.length; _m < _len4; _m++) {
	              side = pinned[_m];
	              addClasses.push("" + pinnedClass + "-" + side);
	            }
	          }
	          if (oob.length) {
	            oobClass = (_ref8 = this.options.outOfBoundsClass) != null ? _ref8 : this.getClass('out-of-bounds');
	            addClasses.push(oobClass);
	            for (_n = 0, _len5 = oob.length; _n < _len5; _n++) {
	              side = oob[_n];
	              addClasses.push("" + oobClass + "-" + side);
	            }
	          }
	          if (__indexOf.call(pinned, 'left') >= 0 || __indexOf.call(pinned, 'right') >= 0) {
	            eAttachment.left = tAttachment.left = false;
	          }
	          if (__indexOf.call(pinned, 'top') >= 0 || __indexOf.call(pinned, 'bottom') >= 0) {
	            eAttachment.top = tAttachment.top = false;
	          }
	          if (tAttachment.top !== targetAttachment.top || tAttachment.left !== targetAttachment.left || eAttachment.top !== this.attachment.top || eAttachment.left !== this.attachment.left) {
	            this.updateAttachClasses(eAttachment, tAttachment);
	          }
	        }
	        defer(function () {
	          updateClasses(_this.target, addClasses, allClasses);
	          return updateClasses(_this.element, addClasses, allClasses);
	        });
	        return {
	          top: top,
	          left: left
	        };
	      }
	    });
	  }).call(this);
	
	  (function () {
	    var defer, getBounds, updateClasses, _ref;
	
	    _ref = this.Tether.Utils, getBounds = _ref.getBounds, updateClasses = _ref.updateClasses, defer = _ref.defer;
	
	    this.Tether.modules.push({
	      position: function position(_arg) {
	        var abutted,
	            addClasses,
	            allClasses,
	            bottom,
	            height,
	            left,
	            right,
	            side,
	            sides,
	            targetPos,
	            top,
	            width,
	            _i,
	            _j,
	            _k,
	            _l,
	            _len,
	            _len1,
	            _len2,
	            _len3,
	            _ref1,
	            _ref2,
	            _ref3,
	            _ref4,
	            _ref5,
	            _this = this;
	        top = _arg.top, left = _arg.left;
	        _ref1 = this.cache('element-bounds', function () {
	          return getBounds(_this.element);
	        }), height = _ref1.height, width = _ref1.width;
	        targetPos = this.getTargetBounds();
	        bottom = top + height;
	        right = left + width;
	        abutted = [];
	        if (top <= targetPos.bottom && bottom >= targetPos.top) {
	          _ref2 = ['left', 'right'];
	          for (_i = 0, _len = _ref2.length; _i < _len; _i++) {
	            side = _ref2[_i];
	            if ((_ref3 = targetPos[side]) === left || _ref3 === right) {
	              abutted.push(side);
	            }
	          }
	        }
	        if (left <= targetPos.right && right >= targetPos.left) {
	          _ref4 = ['top', 'bottom'];
	          for (_j = 0, _len1 = _ref4.length; _j < _len1; _j++) {
	            side = _ref4[_j];
	            if ((_ref5 = targetPos[side]) === top || _ref5 === bottom) {
	              abutted.push(side);
	            }
	          }
	        }
	        allClasses = [];
	        addClasses = [];
	        sides = ['left', 'top', 'right', 'bottom'];
	        allClasses.push(this.getClass('abutted'));
	        for (_k = 0, _len2 = sides.length; _k < _len2; _k++) {
	          side = sides[_k];
	          allClasses.push("" + this.getClass('abutted') + "-" + side);
	        }
	        if (abutted.length) {
	          addClasses.push(this.getClass('abutted'));
	        }
	        for (_l = 0, _len3 = abutted.length; _l < _len3; _l++) {
	          side = abutted[_l];
	          addClasses.push("" + this.getClass('abutted') + "-" + side);
	        }
	        defer(function () {
	          updateClasses(_this.target, addClasses, allClasses);
	          return updateClasses(_this.element, addClasses, allClasses);
	        });
	        return true;
	      }
	    });
	  }).call(this);
	
	  (function () {
	    this.Tether.modules.push({
	      position: function position(_arg) {
	        var left, result, shift, shiftLeft, shiftTop, top, _ref;
	        top = _arg.top, left = _arg.left;
	        if (!this.options.shift) {
	          return;
	        }
	        result = function (val) {
	          if (typeof val === 'function') {
	            return val.call(this, {
	              top: top,
	              left: left
	            });
	          } else {
	            return val;
	          }
	        };
	        shift = result(this.options.shift);
	        if (typeof shift === 'string') {
	          shift = shift.split(' ');
	          shift[1] || (shift[1] = shift[0]);
	          shiftTop = shift[0], shiftLeft = shift[1];
	          shiftTop = parseFloat(shiftTop, 10);
	          shiftLeft = parseFloat(shiftLeft, 10);
	        } else {
	          _ref = [shift.top, shift.left], shiftTop = _ref[0], shiftLeft = _ref[1];
	        }
	        top += shiftTop;
	        left += shiftLeft;
	        return {
	          top: top,
	          left: left
	        };
	      }
	    });
	  }).call(this);
	
	  return this.Tether;
	});

/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _jquery = __webpack_require__(39);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactAddons = __webpack_require__(40);
	
	var _reactAddons2 = _interopRequireDefault(_reactAddons);
	
	var _fluxxor = __webpack_require__(69);
	
	var _fluxxor2 = _interopRequireDefault(_fluxxor);
	
	var _classnames = __webpack_require__(49);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	/* eslint-disable new-cap */
	
	/* eslint-enable new-cap */
	
	var _reactDaterangePicker = __webpack_require__(202);
	
	var _reactDaterangePicker2 = _interopRequireDefault(_reactDaterangePicker);
	
	var _ofsComponentsDatepickerDatePickerPaginationArrow = __webpack_require__(219);
	
	var _ofsComponentsDatepickerDatePickerPaginationArrow2 = _interopRequireDefault(_ofsComponentsDatepickerDatePickerPaginationArrow);
	
	var _ofsI18n = __webpack_require__(61);
	
	var _ofsMoment = __webpack_require__(57);
	
	var _ofsMoment2 = _interopRequireDefault(_ofsMoment);
	
	var _ofsComponentsCommonIcon = __webpack_require__(51);
	
	var _ofsComponentsCommonIcon2 = _interopRequireDefault(_ofsComponentsCommonIcon);
	
	var FluxMixin = _fluxxor2['default'].FluxMixin(_reactAddons2['default']);
	
	var messages = {
	  SELECTED_LABEL: (0, _ofsI18n.gettext)("Your selected dates")
	};
	
	function noop() {}
	
	var DatePicker = _reactAddons2['default'].createClass({
	  displayName: 'DatePicker',
	
	  mixins: [FluxMixin],
	
	  propTypes: {
	    value: _reactAddons2['default'].PropTypes.instanceOf(Date),
	    name: _reactAddons2['default'].PropTypes.string.isRequired,
	    label: _reactAddons2['default'].PropTypes.string,
	    placeholder: _reactAddons2['default'].PropTypes.string,
	    initialDate: _reactAddons2['default'].PropTypes.shape({
	      month: _reactAddons2['default'].PropTypes.number,
	      year: _reactAddons2['default'].PropTypes.number
	    }),
	    stateDefinitions: _reactAddons2['default'].PropTypes.object,
	    dateStates: _reactAddons2['default'].PropTypes.array,
	    defaultState: _reactAddons2['default'].PropTypes.string,
	    onSelect: _reactAddons2['default'].PropTypes.func
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onSelect: noop
	    };
	  },
	
	  handleClick: function handleClick(event) {
	    event.preventDefault();
	
	    var flux = this.getFlux();
	    var layers = flux.store('LayerStore').state;
	
	    // if there is already a popover then don't add another one
	    if (layers.filter(function (component) {
	      return component.type === 'popover';
	    }).size > 0) {
	      return;
	    }
	
	    var trigger = (0, _jquery2['default'])(event.target).closest('.ofs-Input__Wrapper')[0];
	    var triggerRightPos = trigger.getBoundingClientRect().right;
	    var _props = this.props;
	    var value = _props.value;
	    var initialDate = _props.initialDate;
	    var stateDefinitions = _props.stateDefinitions;
	    var dateStates = _props.dateStates;
	    var defaultState = _props.defaultState;
	
	    if (value) {
	      value = (0, _ofsMoment2['default'])(value);
	    }
	
	    var initialMonth;
	    var initialYear;
	
	    if (initialDate) {
	      initialMonth = initialDate.month;
	      initialYear = initialDate.year;
	    }
	
	    var panelAttatchment = "top center";
	    var targetAttachment = "bottom center";
	
	    //safe tablet size
	    var windowWidth = window.innerWidth;
	    if (windowWidth > 640) {
	      panelAttatchment = "top right";
	      targetAttachment = "bottom right";
	      if (triggerRightPos < windowWidth / 2) {
	        panelAttatchment = "top left";
	        targetAttachment = "bottom left";
	      }
	    }
	
	    this.getFlux().actions.layers.addPopover(_reactAddons2['default'].createElement(_reactDaterangePicker2['default'], {
	      trigger: trigger,
	      panelAttachment: panelAttatchment,
	      targetAttachment: targetAttachment,
	
	      stateDefinitions: stateDefinitions,
	      dateStates: dateStates,
	      defaultState: defaultState,
	      selectedLabel: messages.SELECTED_LABEL,
	
	      value: value,
	      numberOfCalendars: 1,
	      selectionType: 'single',
	      paginationArrowComponent: _ofsComponentsDatepickerDatePickerPaginationArrow2['default'],
	      minimumDate: new Date(),
	      firstOfWeek: 1,
	      initialMonth: initialMonth,
	      initialYear: initialYear,
	
	      bemNamespace: 'ofs',
	      bemBlock: 'DatePicker',
	
	      onSelect: this.handleSelect,
	      showLegend: true
	    }));
	  },
	
	  handleSelect: function handleSelect(value, states) {
	    var _this = this;
	
	    // wait till next event loop
	    setTimeout(function () {
	      _this.getFlux().actions.layers.remove();
	      _this.props.onSelect(value, states);
	    }, 0);
	  },
	
	  render: function render() {
	    var _props2 = this.props;
	    var name = _props2.name;
	    var label = _props2.label;
	    var placeholder = _props2.placeholder;
	    var value = _props2.value;
	
	    var displayValue;
	    var formValue;
	
	    if (value) {
	      displayValue = (0, _ofsMoment2['default'])(value).longDateFormat();
	      formValue = (0, _ofsMoment2['default'])(value).isoDateFormat();
	    }
	
	    var inputClasses = (0, _classnames2['default'])({
	      'ofs-Input': true,
	      'ofs-Input--date': true,
	      'u-pointer': true
	    });
	
	    return _reactAddons2['default'].createElement(
	      'div',
	      { className: 'ofs-Form__Field' },
	      label ? _reactAddons2['default'].createElement(
	        'label',
	        { className: 'ofs-Form__Label' },
	        label
	      ) : null,
	      _reactAddons2['default'].createElement('input', { type: 'hidden',
	        name: name,
	        value: formValue }),
	      _reactAddons2['default'].createElement(
	        'div',
	        { className: 'ofs-Input__Wrapper ignore-react-onclickoutside' },
	        _reactAddons2['default'].createElement(
	          'div',
	          { className: inputClasses, onClick: this.handleClick },
	          formValue ? _reactAddons2['default'].createElement(
	            'span',
	            { className: 'value' },
	            displayValue
	          ) : _reactAddons2['default'].createElement(
	            'span',
	            { className: 'ofs-Input__Placeholder' },
	            placeholder
	          )
	        ),
	        _reactAddons2['default'].createElement(
	          'div',
	          { className: 'ofs-Input__Icon', onClick: this.handleClick },
	          _reactAddons2['default'].createElement(_ofsComponentsCommonIcon2['default'], { glyph: 'calendar', size: 'small' })
	        )
	      )
	    );
	  }
	});
	
	exports['default'] = DatePicker;
	module.exports = exports['default'];

/***/ },
/* 330 */,
/* 331 */,
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(40);
	var cx = __webpack_require__(49);
	var Fluxxor = __webpack_require__(69);
	var GalleryItem = __webpack_require__(333);
	var _ = __webpack_require__(66);
	var ModalMixin = __webpack_require__(334);
	
	var Gallery = React.createClass({
	  displayName: 'Gallery',
	
	  mixins: [ModalMixin, Fluxxor.StoreWatchMixin("GalleryStore")],
	
	  getStateFromFlux: function getStateFromFlux() {
	    return this.getFlux().store('GalleryStore').getState();
	  },
	
	  getPreviousIndex: function getPreviousIndex() {
	    if (this.state.activeImageIndex === 0) {
	      return this.state.imageList.length - 1;
	    }
	    return this.state.activeImageIndex - 1;
	  },
	
	  getNextIndex: function getNextIndex() {
	    if (this.state.activeImageIndex === this.state.imageList.length - 1) {
	      return 0;
	    }
	    return this.state.activeImageIndex + 1;
	  },
	
	  handlePrevious: function handlePrevious(event) {
	    event.preventDefault();
	    this.getFlux().actions.gallery.changeActive(this.getPreviousIndex());
	  },
	
	  handleNext: function handleNext(event) {
	    event.preventDefault();
	    this.getFlux().actions.gallery.changeActive(this.getNextIndex());
	  },
	
	  handleImageClick: function handleImageClick() {
	    if (this.state.isHeaderVisible) {
	      this.getFlux().actions.gallery.hideHeader();
	    } else {
	      this.getFlux().actions.gallery.showHeader();
	    }
	  },
	
	  render: function render() {
	    var galleryItems = this.state.imageList.map(_.bind(function (item, index) {
	      var key = item.label + ':' + item.url;
	      return React.createElement(GalleryItem, { key: key, url: item.url, width: item.width, height: item.height, active: index == this.state.activeImageIndex });
	    }, this));
	
	    var activeItem = this.state.imageList[this.state.activeImageIndex];
	    var nextItem = this.state.imageList[this.getNextIndex()];
	    var previousItem = this.state.imageList[this.getPreviousIndex()];
	
	    var overlayClasses = cx({
	      'react-modal-overlay': true,
	      'react-modal-loaded': this.state.loaded
	    });
	
	    var classes = cx({
	      'react-gallery-toolbar': true,
	      'hidden': !this.state.isHeaderVisible
	    });
	
	    return React.createElement(
	      'div',
	      { className: overlayClasses, onClick: this.handleClose },
	      React.createElement(
	        'div',
	        { className: 'react-gallery', onClick: this.killClick, style: this.state.style },
	        React.createElement(
	          'header',
	          { className: classes },
	          React.createElement(
	            'h1',
	            null,
	            activeItem.label
	          ),
	          React.createElement(
	            'a',
	            { href: 'javascript:;', onClick: this.handleClose, className: 'react-modal-close' },
	            'Close'
	          )
	        ),
	        React.createElement(
	          'a',
	          { href: 'javascript:;', className: 'react-gallery-previous', onClick: this.handlePrevious },
	          React.createElement('span', { className: 'icon icon-left-arrow' }),
	          previousItem.label !== activeItem.label ? React.createElement(
	            'span',
	            { className: 'label' },
	            nextItem.label
	          ) : null
	        ),
	        React.createElement(
	          'div',
	          { className: 'react-gallery-items', onClick: this.handleImageClick },
	          galleryItems
	        ),
	        React.createElement(
	          'a',
	          { href: 'javascript:;', className: 'react-gallery-next', onClick: this.handleNext },
	          nextItem.label !== activeItem.label ? React.createElement(
	            'span',
	            { className: 'label' },
	            nextItem.label
	          ) : null,
	          React.createElement('span', { className: 'icon icon-right-arrow' })
	        )
	      )
	    );
	  }
	
	});
	
	module.exports = Gallery;

/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(40);
	var cx = __webpack_require__(49);
	var $ = __webpack_require__(39);
	var _ = __webpack_require__(66);
	
	var GalleryItem = React.createClass({
	  displayName: 'GalleryItem',
	
	  propTypes: {
	    url: React.PropTypes.string.isRequired,
	    width: React.PropTypes.number.isRequired,
	    height: React.PropTypes.number.isRequired,
	    active: React.PropTypes.bool
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {};
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      style: {}
	    };
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps() {
	    this.setState({ style: {} });
	  },
	
	  scaleImage: function scaleImage() {
	    var $el = $(this.getDOMNode());
	    var elWidth = $el.width();
	    var elHeight = $el.height();
	
	    var ratio = this.props.width / this.props.height;
	    var elRatio = elWidth / elHeight;
	
	    var height;
	    var width;
	    var top = 0;
	    var left = 0;
	
	    if (elRatio >= ratio) {
	      // Image should be full height and centred horizontally
	      height = elHeight;
	      width = elHeight * ratio;
	      left = (elWidth - width) / 2;
	    } else {
	      // Image should be full width and centred vertically
	      width = elWidth;
	      height = elWidth / ratio;
	      top = (elHeight - height) / 2;
	    }
	
	    this.setState({
	      style: {
	        width: width,
	        height: height,
	        top: top,
	        left: left
	      }
	    });
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.setState({ style: {} });
	    this.scaleImage();
	    $(window).on('resize.gallery', this.scaleImage);
	  },
	
	  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
	    return !_.isEqual(nextProps, this.props) || !_.isEqual(nextState, this.state);
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    this.scaleImage();
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    $(window).off('resize.gallery');
	  },
	
	  render: function render() {
	    var style = this.state.style;
	
	    var classes = cx({
	      'react-gallery-item': true,
	      'active': this.props.active
	    });
	
	    return React.createElement(
	      'div',
	      { className: classes },
	      React.createElement(
	        'div',
	        { className: 'wrapper', style: style },
	        React.createElement('img', { src: this.props.url })
	      )
	    );
	  }
	
	});
	
	module.exports = GalleryItem;

/***/ },
/* 334 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(40);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fluxxor = __webpack_require__(69);
	
	var _underscore = __webpack_require__(66);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _jquery = __webpack_require__(39);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var ModalMixin = {
	  mixins: [(0, _fluxxor.FluxMixin)(_react2['default'])],
	
	  getInitialState: function getInitialState() {
	    return {
	      loaded: false,
	      style: {}
	    };
	  },
	
	  handleClose: function handleClose() {
	    this.setState({ loaded: false });
	    this.close();
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    (0, _jquery2['default'])(window).off('resize.modal- ' + this._rootNodeID);
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.setPosition();
	    this.setState({ loaded: true });
	    (0, _jquery2['default'])(window).on('resize.modal-' + this._rootNodeID, this.setPosition);
	  },
	
	  close: function close() {
	    this.getFlux().actions.layers.remove();
	  },
	
	  killClick: function killClick(e) {
	    e.stopPropagation();
	  },
	
	  setPosition: function setPosition() {
	    var $el = (0, _jquery2['default'])(this.getDOMNode());
	    var $modal = $el.find('.react-modal');
	    var offset = 40;
	
	    var style = this.state.style;
	
	    if ($modal.css('position') === 'relative') {
	      style['top'] = (0, _jquery2['default'])(window).scrollTop() + offset + 'px';
	    } else {
	      style['top'] = 0;
	    }
	    this.setState({ style: style });
	  }
	};
	
	exports['default'] = ModalMixin;
	module.exports = exports['default'];

/***/ },
/* 335 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _fluxxor = __webpack_require__(69);
	
	var _fluxxor2 = _interopRequireDefault(_fluxxor);
	
	var _immutable = __webpack_require__(68);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _constants = __webpack_require__(336);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var LayerStore = _fluxxor2['default'].createStore({
	  initialize: function initialize() {
	    this.bindActions(_constants2['default'].ADD_MODAL, this.onAddModal, _constants2['default'].ADD_POPOVER, this.onAddPopover, _constants2['default'].ADD_TOOLTIP, this.onAddTooltip, _constants2['default'].REMOVE_LAYER, this.onRemove);
	    this.setMaxListeners(0);
	    this.state = _immutable2['default'].List();
	  },
	
	  onAddModal: function onAddModal(payload) {
	    this.state = this.state.push({
	      component: payload.component,
	      type: 'modal',
	      modalStyle: payload.modalStyle
	    });
	    this.emit('change');
	  },
	
	  onAddPopover: function onAddPopover(payload) {
	    this.state = this.state.push({ component: payload.component, type: 'popover' });
	    this.emit('change');
	  },
	
	  onAddTooltip: function onAddTooltip(payload) {
	    this.state = this.state.push({ component: payload.component, type: 'tooltip' });
	    this.emit('change');
	  },
	
	  onRemove: function onRemove() {
	    this.state = this.state.pop();
	    this.emit('change');
	  }
	});
	
	exports['default'] = LayerStore;
	module.exports = exports['default'];

/***/ },
/* 336 */
/***/ function(module, exports) {

	'use strict';
	
	var Constants = {
	  // Normal UI events
	  CLICKED: 'CLICKED',
	  RESIZED: 'RESIZED',
	  SCROLLED: 'SCROLLED',
	
	  // Data changes
	  FORM_FIELD_CHANGED: 'FORM_FIELD_CHANGED',
	  FORM_SUBMIT: 'FORM_SUBMIT',
	  CITY_UPDATE: 'CITY_UPDATE',
	  PRICE_UPDATE: 'PRICE_UPDATE',
	  BOOKING_QUOTE_UPDATE: 'BOOKING_QUOTE_UPDATE',
	  BOOKING_QUOTE_ERROR: 'BOOKING_QUOTE_ERROR',
	  CHANGE_PAGE_DATE_RANGE: 'CHANGE_PAGE_DATE_RANGE',
	
	  CHANGE_CONTEXT_CITY: 'CHANGE_CONTEXT_CITY',
	  CHANGE_CONTEXT_DATES: 'CHANGE_CONTEXT_DATES',
	  CHANGE_CONTEXT_CURRENCY: 'CHANGE_CONTEXT_CURRENCY',
	  CHANGE_GUEST_BUDGET: 'CHANGE_GUEST_BUDGET',
	
	  SEARCH_UPDATE_FILTERS: 'SEARCH_UPDATE_FILTERS',
	  SEARCH_FETCH_SUCCESS: 'SEARCH_FETCH_SUCCESS',
	
	  // Specific UI interactions
	  CHANGE_ACTIVE_FIELDSET: 'CHANGE_ACTIVE_FIELDSET',
	  CHANGE_ACTIVE_ROOM: 'CHANGE_ACTIVE_ROOM',
	  CHANGE_ACTIVE_CONTAINER: 'CHANGE_ACTIVE_CONTAINER',
	  SELECT_MEDIA: 'SELECT_MEDIA',
	  UNSELECT_MEDIA: 'UNSELECT_MEDIA',
	  ASSIGN_MEDIA: 'ASSIGN_MEDIA',
	  UNASSIGN_MEDIA: 'UNASSIGN_MEDIA',
	  DRAG_MEDIA_START: 'DRAG_MEDIA_START',
	  DRAG_MEDIA_OVER: 'DRAG_MEDIA_OVER',
	  DRAG_MEDIA_END: 'DRAG_MEDIA_END',
	  TEXT_EXPANDED: 'TEXT_EXPANDED',
	  OPEN_GALLERY: 'OPEN_GALLERY',
	  CLOSE_GALLERY: 'CLOSE_GALLERY',
	  CHANGE_ACTIVE_GALLERY_IMAGE: 'CHANGE_ACTIVE_GALLERY_IMAGE',
	  SHOW_GALLERY_HEADER: 'SHOW_GALLERY_HEADER',
	  HIDE_GALLERY_HEADER: 'HIDE_GALLERY_HEADER',
	  OPEN_MODAL: 'OPEN_MODAL',
	  CLOSE_MODAL: 'CLOSE_MODAL',
	
	  ADD_POPOVER: 'ADD_POPOVER',
	  ADD_MODAL: 'ADD_MODAL',
	  ADD_TOOLTIP: 'ADD_TOOLTIP',
	  REMOVE_LAYER: 'REMOVE_LAYER',
	
	  PUSH_ENQUIRY_EVENT: 'PUSH_ENQUIRY_EVENT',
	  PUSH_GENERIC_EVENT: 'PUSH_GENERIC_EVENT',
	  PUSH_FORM_SUBMIT: 'PUSH_FORM_SUBMIT',
	
	  HIGHLIGHT_CALENDAR_DATE: 'HIGHLIGHT_CALENDAR_DATE',
	  HIGHLIGHT_CALENDAR_RANGE: 'HIGHLIGHT_CALENDAR_RANGE',
	  UNHIGHLIGHT_CALENDAR_DATE: 'UNHIGHLIGHT_CALENDAR_DATE',
	  START_CALENDAR_RANGE_SELECTION: 'START_CALENDAR_RANGE_SELECTION',
	  COMPLETE_CALENDAR_RANGE_SELECTION: 'COMPLETE_CALENDAR_RANGE_SELECTION',
	
	  SIMILAR_HOMES_LOAD: 'SIMILAR_HOMES_LOAD',
	  SIMILAR_HOMES_UPDATE: 'SIMILAR_HOMES_UPDATE',
	
	  CONTENT_MODULE_ADD: 'CONTENT_MODULE_ADD',
	  CONTENT_MODULE_CHANGE_VALUE: 'CONTENT_MODULE_CHANGE_VALUE',
	  CONTENT_MODULE_REMOVE: 'CONTENT_MODULE_REMOVE',
	  CONTENT_MODULES_REPLACE: 'CONTENT_MODULES_REPLACE',
	
	  // Guest Store
	  CHANGE_GUEST_NUMBER: 'CHANGE_GUEST_NUMBER',
	
	  // Language Store
	  ACCEPT_LANGUAGE_WARNING: 'ACCEPT_LANGUAGE_WARNING',
	  SET_LANGUAGE: 'SET_LANGUAGE',
	
	  // Scroll Store
	  DISABLE_SCROLL: 'DISABLE_SCROLL',
	  ENABLE_SCROLL: 'ENABLE_SCROLL',
	  SCROLL_TO: 'SCROLL_TO',
	
	  // Introduction Store
	  RESET_REQUEST_ERROR: 'RESET_REQUEST_ERROR'
	};
	
	module.exports = Constants;

/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _reactAddons = __webpack_require__(40);
	
	var _reactAddons2 = _interopRequireDefault(_reactAddons);
	
	var _fluxxor = __webpack_require__(69);
	
	var _jquery = __webpack_require__(39);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _Modal = __webpack_require__(338);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _ModalOverlay = __webpack_require__(339);
	
	var _ModalOverlay2 = _interopRequireDefault(_ModalOverlay);
	
	var _Popover = __webpack_require__(340);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	var _Tooltip = __webpack_require__(342);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var cloneWithProps = _reactAddons2['default'].addons.cloneWithProps;
	
	var LayerStack = _reactAddons2['default'].createClass({
	  displayName: 'LayerStack',
	
	  mixins: [(0, _fluxxor.FluxMixin)(_reactAddons2['default']), (0, _fluxxor.StoreWatchMixin)("LayerStore")],
	
	  componentDidUpdate: function componentDidUpdate() {
	    var numModalLayers = this.state.layers.filter(function (l) {
	      return l.type === 'modal';
	    }).count();
	
	    if (numModalLayers > 0 && !(0, _jquery2['default'])('html').hasClass('has-open-modal')) {
	      (0, _jquery2['default'])('html, body').addClass('has-open-modal');
	    } else if (numModalLayers === 0 && (0, _jquery2['default'])('html').hasClass('has-open-modal')) {
	      (0, _jquery2['default'])('html, body').removeClass('has-open-modal');
	    }
	  },
	
	  getStateFromFlux: function getStateFromFlux() {
	    var flux = this.getFlux();
	    return {
	      layers: flux.store('LayerStore').state
	    };
	  },
	
	  render: function render() {
	    var layers = [];
	
	    this.state.layers.forEach((function (l) {
	      var Component = l.component;
	      var style = l.modalStyle;
	      if (l.type === 'modal') {
	        layers.push(_reactAddons2['default'].createElement(_ModalOverlay2['default'], null));
	        layers.push(_reactAddons2['default'].createElement(
	          _Modal2['default'],
	          {
	            modalStyle: style,
	            popupAd: Component.props.popupAd },
	          cloneWithProps(Component, { flux: this.getFlux() })
	        ));
	      } else if (l.type === 'popover') {
	        layers.push(_reactAddons2['default'].createElement(
	          _Popover2['default'],
	          {
	            panelAttachment: Component.props.panelAttachment,
	            targetAttachment: Component.props.targetAttachment,
	            attachTo: Component.props.trigger },
	          cloneWithProps(Component, { flux: this.getFlux() })
	        ));
	      } else {
	        layers.push(_reactAddons2['default'].createElement(
	          _Tooltip2['default'],
	          {
	            panelAttachment: Component.props.panelAttachment,
	            targetAttachment: Component.props.targetAttachment,
	            attachTo: Component.props.trigger },
	          cloneWithProps(Component, { flux: this.getFlux() })
	        ));
	      }
	    }).bind(this));
	
	    return _reactAddons2['default'].createElement(
	      'div',
	      { className: 'ofs-LayerStack' },
	      layers
	    );
	  }
	});
	
	exports['default'] = LayerStack;
	module.exports = exports['default'];

/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _reactAddons = __webpack_require__(40);
	
	var _reactAddons2 = _interopRequireDefault(_reactAddons);
	
	var _fluxxor = __webpack_require__(69);
	
	var _classnames = __webpack_require__(49);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ofsComponentsCommonIcon = __webpack_require__(51);
	
	var _ofsComponentsCommonIcon2 = _interopRequireDefault(_ofsComponentsCommonIcon);
	
	var Modal = _reactAddons2['default'].createClass({
	  displayName: 'Modal',
	
	  mixins: [(0, _fluxxor.FluxMixin)(_reactAddons2['default'])],
	
	  getInitialState: function getInitialState() {
	    return {
	      loaded: false,
	      modalStyle: {},
	      modalClasses: []
	    };
	  },
	
	  handleClose: function handleClose() {
	    this.setState({ loaded: false });
	    this.close();
	  },
	
	  close: function close() {
	    this.getFlux().actions.layers.remove();
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.setState({
	      loaded: true,
	      modalStyle: this.props.modalStyle
	    });
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var popupAd = _props.popupAd;
	    var fullBleedModal = _props.fullBleedModal;
	
	    var modalClasses = this.state.modalClasses.map(function (c) {
	      return 'ofs-Modal--' + c;
	    });
	
	    modalClasses.unshift('ofs-Modal');
	
	    if (popupAd) {
	      modalClasses.push('ofs-Modal--popupAd');
	    }
	
	    var modalContentClasses = (0, _classnames2['default'])({
	      'ofs-Modal__Content': true,
	      'u-no-padding': fullBleedModal
	    });
	
	    return _reactAddons2['default'].createElement(
	      'div',
	      { className: 'ofs-Modal__Wrapper', onClick: this.handleClose },
	      _reactAddons2['default'].createElement(
	        'div',
	        { ref: 'modal', role: 'dialog', className: _classnames2['default'].apply(this, modalClasses),
	          onClick: function (event) {
	            return event.stopPropagation();
	          }, style: this.state.modalStyle },
	        _reactAddons2['default'].createElement(
	          'header',
	          { className: 'ofs-Modal__Toolbar' },
	          this.props.title ? _reactAddons2['default'].createElement(
	            'h1',
	            null,
	            this.props.title
	          ) : null,
	          _reactAddons2['default'].createElement(
	            'a',
	            { href: 'javascript:;', onClick: this.handleClose, className: 'ofs-Modal__Close' },
	            _reactAddons2['default'].createElement(_ofsComponentsCommonIcon2['default'], { glyph: 'cross', size: 'small' })
	          )
	        ),
	        _reactAddons2['default'].createElement(
	          'div',
	          { className: modalContentClasses },
	          this.props.children
	        )
	      )
	    );
	  }
	});
	
	exports['default'] = Modal;
	module.exports = exports['default'];

/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _reactAddons = __webpack_require__(40);
	
	var _reactAddons2 = _interopRequireDefault(_reactAddons);
	
	var _fluxxor = __webpack_require__(69);
	
	var _classnames = __webpack_require__(49);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var ModalOverlay = _reactAddons2['default'].createClass({
	  displayName: 'ModalOverlay',
	
	  mixins: [_reactAddons2['default'].addons.PureRenderMixin, (0, _fluxxor.FluxMixin)(_reactAddons2['default'])],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      transparent: false
	    };
	  },
	
	  close: function close() {
	    this.getFlux().actions.layers.remove();
	  },
	
	  render: function render() {
	    var classes = {
	      'ofs-ModalOverlay': true,
	      'ofs-ModalOverlay--transparent': this.props.transparent
	    };
	
	    return _reactAddons2['default'].createElement('div', { className: (0, _classnames2['default'])(classes), onClick: this.close });
	  }
	});
	
	exports['default'] = ModalOverlay;
	module.exports = exports['default'];

/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _reactAddons = __webpack_require__(40);
	
	var _reactAddons2 = _interopRequireDefault(_reactAddons);
	
	var _fluxxor = __webpack_require__(69);
	
	var _reactOnclickoutside = __webpack_require__(48);
	
	var _reactOnclickoutside2 = _interopRequireDefault(_reactOnclickoutside);
	
	var _classnames = __webpack_require__(49);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ofsReactRawTether = __webpack_require__(341);
	
	var _ofsReactRawTether2 = _interopRequireDefault(_ofsReactRawTether);
	
	var Popover = _reactAddons2['default'].createClass({
	  displayName: 'Popover',
	
	  mixins: [(0, _fluxxor.FluxMixin)(_reactAddons2['default']), _reactOnclickoutside2['default']],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      panelAttachment: 'top center',
	      targetAttachment: 'bottom center'
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      panelStyle: {},
	      anchorStyle: {},
	      panelClasses: [],
	      anchorClasses: []
	    };
	  },
	
	  close: function close() {
	    this.getFlux().actions.layers.remove(this);
	  },
	
	  handleClickOutside: function handleClickOutside() {
	    this.close();
	  },
	
	  getAnchorOptions: function getAnchorOptions() {
	    return {
	      element: this.refs.anchor.getDOMNode(),
	      target: this.props.attachTo,
	      onPosition: this.onAnchorPosition,
	      attachment: 'top center',
	      targetAttachment: 'bottom center',
	      offset: '5px 0'
	    };
	  },
	
	  getPanelOptions: function getPanelOptions() {
	    return {
	      element: this.refs.panel.getDOMNode(),
	      target: this.props.attachTo,
	      offset: '-10px 0',
	      onPosition: this.onPanelPosition,
	      attachment: this.props.panelAttachment,
	      targetAttachment: this.props.targetAttachment
	    };
	  },
	
	  onResize: function onResize() {
	    if (this.state.panelTether) {
	      this.state.panelTether.setOptions(this.getPanelOptions());
	    }
	  },
	
	  componentDidMount: function componentDidMount() {
	    var panelTether = new _ofsReactRawTether2['default'](this.getPanelOptions());
	    var anchorTether = new _ofsReactRawTether2['default'](this.getAnchorOptions());
	    panelTether.enable();
	    anchorTether.enable();
	    this.setState({ panelTether: panelTether, anchorTether: anchorTether });
	
	    window.addEventListener('resize', this.onResize);
	  },
	
	  onPanelPosition: function onPanelPosition(position, elementClasses, targetClasses) {
	    var panelStyle = {
	      top: position.page.top,
	      left: position.page.left
	    };
	    var panelClasses = elementClasses;
	    this.setState({ panelStyle: panelStyle, panelClasses: panelClasses });
	  },
	
	  onAnchorPosition: function onAnchorPosition(position, elementClasses, targetClasses) {
	    var anchorStyle = {
	      top: position.page.top,
	      left: position.page.left
	    };
	    var anchorClasses = elementClasses;
	    this.setState({ anchorStyle: anchorStyle, anchorClasses: anchorClasses });
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    if (this.state.panelTether) {
	      this.state.panelTether.disable();
	    }
	    if (this.state.anchorTether) {
	      this.state.anchorTether.disable();
	    }
	    window.removeEventListener('resize', this.onResize);
	  },
	
	  render: function render() {
	    var panelClasses = this.state.panelClasses.map(function (c) {
	      return 'ofs-Popover__Panel--' + c;
	    });
	    var anchorClasses = this.state.anchorClasses.map(function (c) {
	      return 'ofs-Popover__Anchor--' + c;
	    });
	
	    panelClasses.unshift('ofs-Popover__Panel');
	    anchorClasses.unshift('ofs-Popover__Anchor');
	    panelClasses.unshift('ofs-Popover__Panel--opened');
	    anchorClasses.unshift('ofs-Popover__Anchor--opened');
	
	    return _reactAddons2['default'].createElement(
	      'div',
	      { className: 'ofs-Popover ignore-react-onclickoutside' },
	      _reactAddons2['default'].createElement(
	        'div',
	        { ref: 'panel', className: _classnames2['default'].apply(this, panelClasses), style: this.state.panelStyle },
	        this.props.children
	      ),
	      _reactAddons2['default'].createElement('div', { ref: 'anchor', className: _classnames2['default'].apply(this, anchorClasses), style: this.state.anchorStyle })
	    );
	  }
	});
	
	exports['default'] = Popover;
	module.exports = exports['default'];

/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(3)['default'];
	
	var _inherits = __webpack_require__(17)['default'];
	
	var _createClass = __webpack_require__(28)['default'];
	
	var _classCallCheck = __webpack_require__(31)['default'];
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _libTether = __webpack_require__(328);
	
	var _libTether2 = _interopRequireDefault(_libTether);
	
	var RawTether = (function (_Tether) {
	  _inherits(RawTether, _Tether);
	
	  function RawTether() {
	    _classCallCheck(this, RawTether);
	
	    _get(Object.getPrototypeOf(RawTether.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(RawTether, [{
	    key: 'updateAttachClasses',
	    value: function updateAttachClasses(elementAttach, targetAttach) {
	      var add, all, side, sides, _i, _j, _len, _len1, _ref1;
	
	      if (elementAttach == null) {
	        elementAttach = this.attachment;
	      }
	      if (targetAttach == null) {
	        targetAttach = this.targetAttachment;
	      }
	      sides = ['left', 'top', 'bottom', 'right', 'middle', 'center'];
	      if ((_ref1 = this._addAttachClasses) != null ? _ref1.length : void 0) {
	        this._addAttachClasses.splice(0, this._addAttachClasses.length);
	      }
	      add = this._addAttachClasses != null ? this._addAttachClasses : this._addAttachClasses = [];
	      if (elementAttach.top) {
	        add.push("" + this.getClass('element-attached') + "-" + elementAttach.top);
	      }
	      if (elementAttach.left) {
	        add.push("" + this.getClass('element-attached') + "-" + elementAttach.left);
	      }
	      if (targetAttach.top) {
	        add.push("" + this.getClass('target-attached') + "-" + targetAttach.top);
	      }
	      if (targetAttach.left) {
	        add.push("" + this.getClass('target-attached') + "-" + targetAttach.left);
	      }
	      all = [];
	      for (_i = 0, _len = sides.length; _i < _len; _i++) {
	        side = sides[_i];
	        all.push("" + this.getClass('element-attached') + "-" + side);
	      }
	      for (_j = 0, _len1 = sides.length; _j < _len1; _j++) {
	        side = sides[_j];
	        all.push("" + this.getClass('target-attached') + "-" + side);
	      }
	    }
	  }, {
	    key: 'move',
	    value: function move(position) {
	      var classes = this._addAttachClasses;
	      var targetClasses = [];
	      var elementClasses = [];
	
	      classes.forEach(function (c) {
	        var cleaned = c.slice(7);
	
	        if (cleaned.slice(0, 7) === 'element') {
	          elementClasses.push(cleaned.slice(8));
	        } else if (cleaned.slice(0, 6) === 'target') {
	          targetClasses.push(cleaned.slice(7));
	        }
	      });
	
	      this.options.onPosition(position, elementClasses, targetClasses);
	    }
	  }]);
	
	  return RawTether;
	})(_libTether2['default']);
	
	exports['default'] = RawTether;
	module.exports = exports['default'];

/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _reactAddons = __webpack_require__(40);
	
	var _reactAddons2 = _interopRequireDefault(_reactAddons);
	
	var _fluxxor = __webpack_require__(69);
	
	var _reactOnclickoutside = __webpack_require__(48);
	
	var _reactOnclickoutside2 = _interopRequireDefault(_reactOnclickoutside);
	
	var _classnames = __webpack_require__(49);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ofsBreakpoints = __webpack_require__(343);
	
	var _ofsBreakpoints2 = _interopRequireDefault(_ofsBreakpoints);
	
	var _ofsReactRawTether = __webpack_require__(341);
	
	var _ofsReactRawTether2 = _interopRequireDefault(_ofsReactRawTether);
	
	var Tooltip = _reactAddons2['default'].createClass({
	  displayName: 'Tooltip',
	
	  mixins: [(0, _fluxxor.FluxMixin)(_reactAddons2['default']), _reactOnclickoutside2['default']],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      panelAttachment: 'top center',
	      targetAttachment: 'bottom center'
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      panelStyle: {},
	      anchorStyle: {},
	      panelClasses: [],
	      anchorClasses: []
	    };
	  },
	
	  close: function close() {
	    this.getFlux().actions.layers.remove(this);
	  },
	
	  handleClickOutside: function handleClickOutside() {
	    this.close();
	  },
	
	  getAnchorOptions: function getAnchorOptions() {
	    return {
	      element: this.refs.anchor.getDOMNode(),
	      target: this.props.attachTo,
	      attachment: this.props.panelAttachment,
	      targetAttachment: this.props.targetAttachment,
	      offset: '0 0',
	      onPosition: this.onAnchorPosition
	    };
	  },
	
	  getPanelOptions: function getPanelOptions() {
	    return {
	      element: this.refs.panel.getDOMNode(),
	      target: this.props.attachTo,
	      offset: '0 0',
	      onPosition: this.onPanelPosition,
	      attachment: this.props.panelAttachment,
	      targetAttachment: this.props.targetAttachment
	    };
	  },
	
	  onResize: function onResize() {
	    if (this._panelTether) {
	      this._panelTether.setOptions(this.getPanelOptions());
	    }
	  },
	
	  componentDidMount: function componentDidMount() {
	    this._panelTether = new _ofsReactRawTether2['default'](this.getPanelOptions());
	    this._anchorTether = new _ofsReactRawTether2['default'](this.getAnchorOptions());
	    this._panelTether.enable();
	    this._anchorTether.enable();
	
	    window.addEventListener('resize', this.onResize);
	  },
	
	  onPanelPosition: function onPanelPosition(position, elementClasses) {
	    var panelStyle = {
	      top: position.page.top,
	      left: this.calculateLeft(position.page.left)
	    };
	    var panelClasses = elementClasses;
	    this.setState({ panelStyle: panelStyle, panelClasses: panelClasses });
	  },
	
	  calculateCenter: function calculateCenter() {
	    return (window.outerWidth - _reactAddons2['default'].findDOMNode(this.refs.panel).offsetWidth) / 2;
	  },
	
	  isScreenTiny: function isScreenTiny() {
	    return window.outerWidth <= _ofsBreakpoints2['default'].tiny;
	  },
	
	  hasBreathingRoom: function hasBreathingRoom() {
	    return window.outerWidth - _reactAddons2['default'].findDOMNode(this.refs.panel).offsetWidth > 20;
	  },
	
	  calculateLeft: function calculateLeft(defaultValue) {
	    if (this.isScreenTiny()) {
	      return this.calculateCenter();
	      // the tooltip might want to be partially cut off. lets fix that here.
	    } else if (defaultValue < 0) {
	        // if there is "lots" of room available then use a small hardcoded value.
	        // We use this hardcoded value instead of centering the panel to prevent
	        // the panel and the anchor becoming detached - which can happen with
	        // larger screens.
	        if (this.hasBreathingRoom()) {
	          return 10;
	        } else {
	          return this.calculateCenter();
	        }
	      } else {
	        return defaultValue;
	      }
	  },
	
	  onAnchorPosition: function onAnchorPosition(position, elementClasses) {
	    var anchorStyle = {
	      top: position.page.top,
	      left: position.page.left
	    };
	    var anchorClasses = elementClasses;
	    this.setState({ anchorStyle: anchorStyle, anchorClasses: anchorClasses });
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._panelTether) {
	      this._panelTether.disable();
	    }
	    if (this._anchorTether) {
	      this._anchorTether.disable();
	    }
	    window.removeEventListener('resize', this.onResize);
	  },
	
	  render: function render() {
	    var panelClasses = this.state.panelClasses.map(function (c) {
	      return 'ofs-Tooltip__Panel--' + c;
	    });
	    var anchorClasses = this.state.anchorClasses.map(function (c) {
	      return 'ofs-Tooltip__Anchor--' + c;
	    });
	
	    panelClasses.unshift('ofs-Tooltip__Panel');
	    anchorClasses.unshift('ofs-Tooltip__Anchor');
	    return _reactAddons2['default'].createElement(
	      'div',
	      { className: 'ofs-Tooltip' },
	      _reactAddons2['default'].createElement(
	        'div',
	        { ref: 'panel', className: _classnames2['default'].apply(this, panelClasses), style: this.state.panelStyle },
	        this.props.children
	      ),
	      _reactAddons2['default'].createElement('div', { ref: 'anchor', className: _classnames2['default'].apply(this, anchorClasses), style: this.state.anchorStyle })
	    );
	  }
	});
	
	exports['default'] = Tooltip;
	module.exports = exports['default'];

/***/ },
/* 343 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var BREAKPOINTS = {
	  'tiny': 320,
	  'small': 640,
	  'medium': 850,
	  'large': 1024,
	  'widescreen': 1400
	};
	
	exports['default'] = BREAKPOINTS;
	module.exports = exports['default'];

/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = __webpack_require__(28)['default'];
	
	var _classCallCheck = __webpack_require__(31)['default'];
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _mousetrap = __webpack_require__(345);
	
	var _mousetrap2 = _interopRequireDefault(_mousetrap);
	
	var _immutable = __webpack_require__(68);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var Keyboard = (function () {
	  function Keyboard() {
	    _classCallCheck(this, Keyboard);
	
	    this.keyStack = _immutable2['default'].fromJS([[]]);
	  }
	
	  _createClass(Keyboard, [{
	    key: 'push',
	    value: function push() {
	      this.keyStack = this.keyStack.push(_immutable2['default'].fromJS([]));
	      _mousetrap2['default'].reset();
	    }
	  }, {
	    key: 'pushCopy',
	    value: function pushCopy() {
	      this.keyStack = this.keyStack.push(this.keyStack.last());
	    }
	  }, {
	    key: 'pop',
	    value: function pop() {
	      if (this.keyStack.count() > 1) {
	        _mousetrap2['default'].reset();
	        this.keyStack = this.keyStack.splice(this.keyStack.count() - 1, 1).toList();
	        this.keyStack.last().forEach(function (k) {
	          _mousetrap2['default'].bind(k.key, k.action);
	        });
	      } else {
	        throw new Error('Cannot pop the last level of keyboard bindings.');
	      }
	    }
	  }, {
	    key: 'on',
	    value: function on(key, action) {
	      this.keyStack = this.keyStack.updateIn([-1], function (keys) {
	        return keys.push({ key: key, action: action });
	      });
	      _mousetrap2['default'].bind(key, action);
	    }
	  }, {
	    key: 'off',
	    value: function off(key) {
	      var index = this.keyStack.last().findIndex(function (k) {
	        return k.key === key;
	      });
	
	      if (index >= 0) {
	        this.keyStack = this.keyStack.updateIn([-1], function (keys) {
	          return keys.splice(index, 1).toList();
	        });
	      }
	      _mousetrap2['default'].unbind(key);
	    }
	  }, {
	    key: 'trigger',
	    value: function trigger(key) {
	      _mousetrap2['default'].trigger(key);
	    }
	  }]);
	
	  return Keyboard;
	})();
	
	exports['default'] = Keyboard;
	module.exports = exports['default'];

/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*global define:false */
	/**
	 * Copyright 2015 Craig Campbell
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * Mousetrap is a simple keyboard shortcut library for Javascript with
	 * no external dependencies
	 *
	 * @version 1.5.3
	 * @url craig.is/killing/mice
	 */
	(function(window, document, undefined) {
	
	    /**
	     * mapping of special keycodes to their corresponding keys
	     *
	     * everything in this dictionary cannot use keypress events
	     * so it has to be here to map to the correct keycodes for
	     * keyup/keydown events
	     *
	     * @type {Object}
	     */
	    var _MAP = {
	        8: 'backspace',
	        9: 'tab',
	        13: 'enter',
	        16: 'shift',
	        17: 'ctrl',
	        18: 'alt',
	        20: 'capslock',
	        27: 'esc',
	        32: 'space',
	        33: 'pageup',
	        34: 'pagedown',
	        35: 'end',
	        36: 'home',
	        37: 'left',
	        38: 'up',
	        39: 'right',
	        40: 'down',
	        45: 'ins',
	        46: 'del',
	        91: 'meta',
	        93: 'meta',
	        224: 'meta'
	    };
	
	    /**
	     * mapping for special characters so they can support
	     *
	     * this dictionary is only used incase you want to bind a
	     * keyup or keydown event to one of these keys
	     *
	     * @type {Object}
	     */
	    var _KEYCODE_MAP = {
	        106: '*',
	        107: '+',
	        109: '-',
	        110: '.',
	        111 : '/',
	        186: ';',
	        187: '=',
	        188: ',',
	        189: '-',
	        190: '.',
	        191: '/',
	        192: '`',
	        219: '[',
	        220: '\\',
	        221: ']',
	        222: '\''
	    };
	
	    /**
	     * this is a mapping of keys that require shift on a US keypad
	     * back to the non shift equivelents
	     *
	     * this is so you can use keyup events with these keys
	     *
	     * note that this will only work reliably on US keyboards
	     *
	     * @type {Object}
	     */
	    var _SHIFT_MAP = {
	        '~': '`',
	        '!': '1',
	        '@': '2',
	        '#': '3',
	        '$': '4',
	        '%': '5',
	        '^': '6',
	        '&': '7',
	        '*': '8',
	        '(': '9',
	        ')': '0',
	        '_': '-',
	        '+': '=',
	        ':': ';',
	        '\"': '\'',
	        '<': ',',
	        '>': '.',
	        '?': '/',
	        '|': '\\'
	    };
	
	    /**
	     * this is a list of special strings you can use to map
	     * to modifier keys when you specify your keyboard shortcuts
	     *
	     * @type {Object}
	     */
	    var _SPECIAL_ALIASES = {
	        'option': 'alt',
	        'command': 'meta',
	        'return': 'enter',
	        'escape': 'esc',
	        'plus': '+',
	        'mod': /Mac|iPod|iPhone|iPad/.test(navigator.platform) ? 'meta' : 'ctrl'
	    };
	
	    /**
	     * variable to store the flipped version of _MAP from above
	     * needed to check if we should use keypress or not when no action
	     * is specified
	     *
	     * @type {Object|undefined}
	     */
	    var _REVERSE_MAP;
	
	    /**
	     * loop through the f keys, f1 to f19 and add them to the map
	     * programatically
	     */
	    for (var i = 1; i < 20; ++i) {
	        _MAP[111 + i] = 'f' + i;
	    }
	
	    /**
	     * loop through to map numbers on the numeric keypad
	     */
	    for (i = 0; i <= 9; ++i) {
	        _MAP[i + 96] = i;
	    }
	
	    /**
	     * cross browser add event method
	     *
	     * @param {Element|HTMLDocument} object
	     * @param {string} type
	     * @param {Function} callback
	     * @returns void
	     */
	    function _addEvent(object, type, callback) {
	        if (object.addEventListener) {
	            object.addEventListener(type, callback, false);
	            return;
	        }
	
	        object.attachEvent('on' + type, callback);
	    }
	
	    /**
	     * takes the event and returns the key character
	     *
	     * @param {Event} e
	     * @return {string}
	     */
	    function _characterFromEvent(e) {
	
	        // for keypress events we should return the character as is
	        if (e.type == 'keypress') {
	            var character = String.fromCharCode(e.which);
	
	            // if the shift key is not pressed then it is safe to assume
	            // that we want the character to be lowercase.  this means if
	            // you accidentally have caps lock on then your key bindings
	            // will continue to work
	            //
	            // the only side effect that might not be desired is if you
	            // bind something like 'A' cause you want to trigger an
	            // event when capital A is pressed caps lock will no longer
	            // trigger the event.  shift+a will though.
	            if (!e.shiftKey) {
	                character = character.toLowerCase();
	            }
	
	            return character;
	        }
	
	        // for non keypress events the special maps are needed
	        if (_MAP[e.which]) {
	            return _MAP[e.which];
	        }
	
	        if (_KEYCODE_MAP[e.which]) {
	            return _KEYCODE_MAP[e.which];
	        }
	
	        // if it is not in the special map
	
	        // with keydown and keyup events the character seems to always
	        // come in as an uppercase character whether you are pressing shift
	        // or not.  we should make sure it is always lowercase for comparisons
	        return String.fromCharCode(e.which).toLowerCase();
	    }
	
	    /**
	     * checks if two arrays are equal
	     *
	     * @param {Array} modifiers1
	     * @param {Array} modifiers2
	     * @returns {boolean}
	     */
	    function _modifiersMatch(modifiers1, modifiers2) {
	        return modifiers1.sort().join(',') === modifiers2.sort().join(',');
	    }
	
	    /**
	     * takes a key event and figures out what the modifiers are
	     *
	     * @param {Event} e
	     * @returns {Array}
	     */
	    function _eventModifiers(e) {
	        var modifiers = [];
	
	        if (e.shiftKey) {
	            modifiers.push('shift');
	        }
	
	        if (e.altKey) {
	            modifiers.push('alt');
	        }
	
	        if (e.ctrlKey) {
	            modifiers.push('ctrl');
	        }
	
	        if (e.metaKey) {
	            modifiers.push('meta');
	        }
	
	        return modifiers;
	    }
	
	    /**
	     * prevents default for this event
	     *
	     * @param {Event} e
	     * @returns void
	     */
	    function _preventDefault(e) {
	        if (e.preventDefault) {
	            e.preventDefault();
	            return;
	        }
	
	        e.returnValue = false;
	    }
	
	    /**
	     * stops propogation for this event
	     *
	     * @param {Event} e
	     * @returns void
	     */
	    function _stopPropagation(e) {
	        if (e.stopPropagation) {
	            e.stopPropagation();
	            return;
	        }
	
	        e.cancelBubble = true;
	    }
	
	    /**
	     * determines if the keycode specified is a modifier key or not
	     *
	     * @param {string} key
	     * @returns {boolean}
	     */
	    function _isModifier(key) {
	        return key == 'shift' || key == 'ctrl' || key == 'alt' || key == 'meta';
	    }
	
	    /**
	     * reverses the map lookup so that we can look for specific keys
	     * to see what can and can't use keypress
	     *
	     * @return {Object}
	     */
	    function _getReverseMap() {
	        if (!_REVERSE_MAP) {
	            _REVERSE_MAP = {};
	            for (var key in _MAP) {
	
	                // pull out the numeric keypad from here cause keypress should
	                // be able to detect the keys from the character
	                if (key > 95 && key < 112) {
	                    continue;
	                }
	
	                if (_MAP.hasOwnProperty(key)) {
	                    _REVERSE_MAP[_MAP[key]] = key;
	                }
	            }
	        }
	        return _REVERSE_MAP;
	    }
	
	    /**
	     * picks the best action based on the key combination
	     *
	     * @param {string} key - character for key
	     * @param {Array} modifiers
	     * @param {string=} action passed in
	     */
	    function _pickBestAction(key, modifiers, action) {
	
	        // if no action was picked in we should try to pick the one
	        // that we think would work best for this key
	        if (!action) {
	            action = _getReverseMap()[key] ? 'keydown' : 'keypress';
	        }
	
	        // modifier keys don't work as expected with keypress,
	        // switch to keydown
	        if (action == 'keypress' && modifiers.length) {
	            action = 'keydown';
	        }
	
	        return action;
	    }
	
	    /**
	     * Converts from a string key combination to an array
	     *
	     * @param  {string} combination like "command+shift+l"
	     * @return {Array}
	     */
	    function _keysFromString(combination) {
	        if (combination === '+') {
	            return ['+'];
	        }
	
	        combination = combination.replace(/\+{2}/g, '+plus');
	        return combination.split('+');
	    }
	
	    /**
	     * Gets info for a specific key combination
	     *
	     * @param  {string} combination key combination ("command+s" or "a" or "*")
	     * @param  {string=} action
	     * @returns {Object}
	     */
	    function _getKeyInfo(combination, action) {
	        var keys;
	        var key;
	        var i;
	        var modifiers = [];
	
	        // take the keys from this pattern and figure out what the actual
	        // pattern is all about
	        keys = _keysFromString(combination);
	
	        for (i = 0; i < keys.length; ++i) {
	            key = keys[i];
	
	            // normalize key names
	            if (_SPECIAL_ALIASES[key]) {
	                key = _SPECIAL_ALIASES[key];
	            }
	
	            // if this is not a keypress event then we should
	            // be smart about using shift keys
	            // this will only work for US keyboards however
	            if (action && action != 'keypress' && _SHIFT_MAP[key]) {
	                key = _SHIFT_MAP[key];
	                modifiers.push('shift');
	            }
	
	            // if this key is a modifier then add it to the list of modifiers
	            if (_isModifier(key)) {
	                modifiers.push(key);
	            }
	        }
	
	        // depending on what the key combination is
	        // we will try to pick the best event for it
	        action = _pickBestAction(key, modifiers, action);
	
	        return {
	            key: key,
	            modifiers: modifiers,
	            action: action
	        };
	    }
	
	    function _belongsTo(element, ancestor) {
	        if (element === null || element === document) {
	            return false;
	        }
	
	        if (element === ancestor) {
	            return true;
	        }
	
	        return _belongsTo(element.parentNode, ancestor);
	    }
	
	    function Mousetrap(targetElement) {
	        var self = this;
	
	        targetElement = targetElement || document;
	
	        if (!(self instanceof Mousetrap)) {
	            return new Mousetrap(targetElement);
	        }
	
	        /**
	         * element to attach key events to
	         *
	         * @type {Element}
	         */
	        self.target = targetElement;
	
	        /**
	         * a list of all the callbacks setup via Mousetrap.bind()
	         *
	         * @type {Object}
	         */
	        self._callbacks = {};
	
	        /**
	         * direct map of string combinations to callbacks used for trigger()
	         *
	         * @type {Object}
	         */
	        self._directMap = {};
	
	        /**
	         * keeps track of what level each sequence is at since multiple
	         * sequences can start out with the same sequence
	         *
	         * @type {Object}
	         */
	        var _sequenceLevels = {};
	
	        /**
	         * variable to store the setTimeout call
	         *
	         * @type {null|number}
	         */
	        var _resetTimer;
	
	        /**
	         * temporary state where we will ignore the next keyup
	         *
	         * @type {boolean|string}
	         */
	        var _ignoreNextKeyup = false;
	
	        /**
	         * temporary state where we will ignore the next keypress
	         *
	         * @type {boolean}
	         */
	        var _ignoreNextKeypress = false;
	
	        /**
	         * are we currently inside of a sequence?
	         * type of action ("keyup" or "keydown" or "keypress") or false
	         *
	         * @type {boolean|string}
	         */
	        var _nextExpectedAction = false;
	
	        /**
	         * resets all sequence counters except for the ones passed in
	         *
	         * @param {Object} doNotReset
	         * @returns void
	         */
	        function _resetSequences(doNotReset) {
	            doNotReset = doNotReset || {};
	
	            var activeSequences = false,
	                key;
	
	            for (key in _sequenceLevels) {
	                if (doNotReset[key]) {
	                    activeSequences = true;
	                    continue;
	                }
	                _sequenceLevels[key] = 0;
	            }
	
	            if (!activeSequences) {
	                _nextExpectedAction = false;
	            }
	        }
	
	        /**
	         * finds all callbacks that match based on the keycode, modifiers,
	         * and action
	         *
	         * @param {string} character
	         * @param {Array} modifiers
	         * @param {Event|Object} e
	         * @param {string=} sequenceName - name of the sequence we are looking for
	         * @param {string=} combination
	         * @param {number=} level
	         * @returns {Array}
	         */
	        function _getMatches(character, modifiers, e, sequenceName, combination, level) {
	            var i;
	            var callback;
	            var matches = [];
	            var action = e.type;
	
	            // if there are no events related to this keycode
	            if (!self._callbacks[character]) {
	                return [];
	            }
	
	            // if a modifier key is coming up on its own we should allow it
	            if (action == 'keyup' && _isModifier(character)) {
	                modifiers = [character];
	            }
	
	            // loop through all callbacks for the key that was pressed
	            // and see if any of them match
	            for (i = 0; i < self._callbacks[character].length; ++i) {
	                callback = self._callbacks[character][i];
	
	                // if a sequence name is not specified, but this is a sequence at
	                // the wrong level then move onto the next match
	                if (!sequenceName && callback.seq && _sequenceLevels[callback.seq] != callback.level) {
	                    continue;
	                }
	
	                // if the action we are looking for doesn't match the action we got
	                // then we should keep going
	                if (action != callback.action) {
	                    continue;
	                }
	
	                // if this is a keypress event and the meta key and control key
	                // are not pressed that means that we need to only look at the
	                // character, otherwise check the modifiers as well
	                //
	                // chrome will not fire a keypress if meta or control is down
	                // safari will fire a keypress if meta or meta+shift is down
	                // firefox will fire a keypress if meta or control is down
	                if ((action == 'keypress' && !e.metaKey && !e.ctrlKey) || _modifiersMatch(modifiers, callback.modifiers)) {
	
	                    // when you bind a combination or sequence a second time it
	                    // should overwrite the first one.  if a sequenceName or
	                    // combination is specified in this call it does just that
	                    //
	                    // @todo make deleting its own method?
	                    var deleteCombo = !sequenceName && callback.combo == combination;
	                    var deleteSequence = sequenceName && callback.seq == sequenceName && callback.level == level;
	                    if (deleteCombo || deleteSequence) {
	                        self._callbacks[character].splice(i, 1);
	                    }
	
	                    matches.push(callback);
	                }
	            }
	
	            return matches;
	        }
	
	        /**
	         * actually calls the callback function
	         *
	         * if your callback function returns false this will use the jquery
	         * convention - prevent default and stop propogation on the event
	         *
	         * @param {Function} callback
	         * @param {Event} e
	         * @returns void
	         */
	        function _fireCallback(callback, e, combo, sequence) {
	
	            // if this event should not happen stop here
	            if (self.stopCallback(e, e.target || e.srcElement, combo, sequence)) {
	                return;
	            }
	
	            if (callback(e, combo) === false) {
	                _preventDefault(e);
	                _stopPropagation(e);
	            }
	        }
	
	        /**
	         * handles a character key event
	         *
	         * @param {string} character
	         * @param {Array} modifiers
	         * @param {Event} e
	         * @returns void
	         */
	        self._handleKey = function(character, modifiers, e) {
	            var callbacks = _getMatches(character, modifiers, e);
	            var i;
	            var doNotReset = {};
	            var maxLevel = 0;
	            var processedSequenceCallback = false;
	
	            // Calculate the maxLevel for sequences so we can only execute the longest callback sequence
	            for (i = 0; i < callbacks.length; ++i) {
	                if (callbacks[i].seq) {
	                    maxLevel = Math.max(maxLevel, callbacks[i].level);
	                }
	            }
	
	            // loop through matching callbacks for this key event
	            for (i = 0; i < callbacks.length; ++i) {
	
	                // fire for all sequence callbacks
	                // this is because if for example you have multiple sequences
	                // bound such as "g i" and "g t" they both need to fire the
	                // callback for matching g cause otherwise you can only ever
	                // match the first one
	                if (callbacks[i].seq) {
	
	                    // only fire callbacks for the maxLevel to prevent
	                    // subsequences from also firing
	                    //
	                    // for example 'a option b' should not cause 'option b' to fire
	                    // even though 'option b' is part of the other sequence
	                    //
	                    // any sequences that do not match here will be discarded
	                    // below by the _resetSequences call
	                    if (callbacks[i].level != maxLevel) {
	                        continue;
	                    }
	
	                    processedSequenceCallback = true;
	
	                    // keep a list of which sequences were matches for later
	                    doNotReset[callbacks[i].seq] = 1;
	                    _fireCallback(callbacks[i].callback, e, callbacks[i].combo, callbacks[i].seq);
	                    continue;
	                }
	
	                // if there were no sequence matches but we are still here
	                // that means this is a regular match so we should fire that
	                if (!processedSequenceCallback) {
	                    _fireCallback(callbacks[i].callback, e, callbacks[i].combo);
	                }
	            }
	
	            // if the key you pressed matches the type of sequence without
	            // being a modifier (ie "keyup" or "keypress") then we should
	            // reset all sequences that were not matched by this event
	            //
	            // this is so, for example, if you have the sequence "h a t" and you
	            // type "h e a r t" it does not match.  in this case the "e" will
	            // cause the sequence to reset
	            //
	            // modifier keys are ignored because you can have a sequence
	            // that contains modifiers such as "enter ctrl+space" and in most
	            // cases the modifier key will be pressed before the next key
	            //
	            // also if you have a sequence such as "ctrl+b a" then pressing the
	            // "b" key will trigger a "keypress" and a "keydown"
	            //
	            // the "keydown" is expected when there is a modifier, but the
	            // "keypress" ends up matching the _nextExpectedAction since it occurs
	            // after and that causes the sequence to reset
	            //
	            // we ignore keypresses in a sequence that directly follow a keydown
	            // for the same character
	            var ignoreThisKeypress = e.type == 'keypress' && _ignoreNextKeypress;
	            if (e.type == _nextExpectedAction && !_isModifier(character) && !ignoreThisKeypress) {
	                _resetSequences(doNotReset);
	            }
	
	            _ignoreNextKeypress = processedSequenceCallback && e.type == 'keydown';
	        };
	
	        /**
	         * handles a keydown event
	         *
	         * @param {Event} e
	         * @returns void
	         */
	        function _handleKeyEvent(e) {
	
	            // normalize e.which for key events
	            // @see http://stackoverflow.com/questions/4285627/javascript-keycode-vs-charcode-utter-confusion
	            if (typeof e.which !== 'number') {
	                e.which = e.keyCode;
	            }
	
	            var character = _characterFromEvent(e);
	
	            // no character found then stop
	            if (!character) {
	                return;
	            }
	
	            // need to use === for the character check because the character can be 0
	            if (e.type == 'keyup' && _ignoreNextKeyup === character) {
	                _ignoreNextKeyup = false;
	                return;
	            }
	
	            self.handleKey(character, _eventModifiers(e), e);
	        }
	
	        /**
	         * called to set a 1 second timeout on the specified sequence
	         *
	         * this is so after each key press in the sequence you have 1 second
	         * to press the next key before you have to start over
	         *
	         * @returns void
	         */
	        function _resetSequenceTimer() {
	            clearTimeout(_resetTimer);
	            _resetTimer = setTimeout(_resetSequences, 1000);
	        }
	
	        /**
	         * binds a key sequence to an event
	         *
	         * @param {string} combo - combo specified in bind call
	         * @param {Array} keys
	         * @param {Function} callback
	         * @param {string=} action
	         * @returns void
	         */
	        function _bindSequence(combo, keys, callback, action) {
	
	            // start off by adding a sequence level record for this combination
	            // and setting the level to 0
	            _sequenceLevels[combo] = 0;
	
	            /**
	             * callback to increase the sequence level for this sequence and reset
	             * all other sequences that were active
	             *
	             * @param {string} nextAction
	             * @returns {Function}
	             */
	            function _increaseSequence(nextAction) {
	                return function() {
	                    _nextExpectedAction = nextAction;
	                    ++_sequenceLevels[combo];
	                    _resetSequenceTimer();
	                };
	            }
	
	            /**
	             * wraps the specified callback inside of another function in order
	             * to reset all sequence counters as soon as this sequence is done
	             *
	             * @param {Event} e
	             * @returns void
	             */
	            function _callbackAndReset(e) {
	                _fireCallback(callback, e, combo);
	
	                // we should ignore the next key up if the action is key down
	                // or keypress.  this is so if you finish a sequence and
	                // release the key the final key will not trigger a keyup
	                if (action !== 'keyup') {
	                    _ignoreNextKeyup = _characterFromEvent(e);
	                }
	
	                // weird race condition if a sequence ends with the key
	                // another sequence begins with
	                setTimeout(_resetSequences, 10);
	            }
	
	            // loop through keys one at a time and bind the appropriate callback
	            // function.  for any key leading up to the final one it should
	            // increase the sequence. after the final, it should reset all sequences
	            //
	            // if an action is specified in the original bind call then that will
	            // be used throughout.  otherwise we will pass the action that the
	            // next key in the sequence should match.  this allows a sequence
	            // to mix and match keypress and keydown events depending on which
	            // ones are better suited to the key provided
	            for (var i = 0; i < keys.length; ++i) {
	                var isFinal = i + 1 === keys.length;
	                var wrappedCallback = isFinal ? _callbackAndReset : _increaseSequence(action || _getKeyInfo(keys[i + 1]).action);
	                _bindSingle(keys[i], wrappedCallback, action, combo, i);
	            }
	        }
	
	        /**
	         * binds a single keyboard combination
	         *
	         * @param {string} combination
	         * @param {Function} callback
	         * @param {string=} action
	         * @param {string=} sequenceName - name of sequence if part of sequence
	         * @param {number=} level - what part of the sequence the command is
	         * @returns void
	         */
	        function _bindSingle(combination, callback, action, sequenceName, level) {
	
	            // store a direct mapped reference for use with Mousetrap.trigger
	            self._directMap[combination + ':' + action] = callback;
	
	            // make sure multiple spaces in a row become a single space
	            combination = combination.replace(/\s+/g, ' ');
	
	            var sequence = combination.split(' ');
	            var info;
	
	            // if this pattern is a sequence of keys then run through this method
	            // to reprocess each pattern one key at a time
	            if (sequence.length > 1) {
	                _bindSequence(combination, sequence, callback, action);
	                return;
	            }
	
	            info = _getKeyInfo(combination, action);
	
	            // make sure to initialize array if this is the first time
	            // a callback is added for this key
	            self._callbacks[info.key] = self._callbacks[info.key] || [];
	
	            // remove an existing match if there is one
	            _getMatches(info.key, info.modifiers, {type: info.action}, sequenceName, combination, level);
	
	            // add this call back to the array
	            // if it is a sequence put it at the beginning
	            // if not put it at the end
	            //
	            // this is important because the way these are processed expects
	            // the sequence ones to come first
	            self._callbacks[info.key][sequenceName ? 'unshift' : 'push']({
	                callback: callback,
	                modifiers: info.modifiers,
	                action: info.action,
	                seq: sequenceName,
	                level: level,
	                combo: combination
	            });
	        }
	
	        /**
	         * binds multiple combinations to the same callback
	         *
	         * @param {Array} combinations
	         * @param {Function} callback
	         * @param {string|undefined} action
	         * @returns void
	         */
	        self._bindMultiple = function(combinations, callback, action) {
	            for (var i = 0; i < combinations.length; ++i) {
	                _bindSingle(combinations[i], callback, action);
	            }
	        };
	
	        // start!
	        _addEvent(targetElement, 'keypress', _handleKeyEvent);
	        _addEvent(targetElement, 'keydown', _handleKeyEvent);
	        _addEvent(targetElement, 'keyup', _handleKeyEvent);
	    }
	
	    /**
	     * binds an event to mousetrap
	     *
	     * can be a single key, a combination of keys separated with +,
	     * an array of keys, or a sequence of keys separated by spaces
	     *
	     * be sure to list the modifier keys first to make sure that the
	     * correct key ends up getting bound (the last key in the pattern)
	     *
	     * @param {string|Array} keys
	     * @param {Function} callback
	     * @param {string=} action - 'keypress', 'keydown', or 'keyup'
	     * @returns void
	     */
	    Mousetrap.prototype.bind = function(keys, callback, action) {
	        var self = this;
	        keys = keys instanceof Array ? keys : [keys];
	        self._bindMultiple.call(self, keys, callback, action);
	        return self;
	    };
	
	    /**
	     * unbinds an event to mousetrap
	     *
	     * the unbinding sets the callback function of the specified key combo
	     * to an empty function and deletes the corresponding key in the
	     * _directMap dict.
	     *
	     * TODO: actually remove this from the _callbacks dictionary instead
	     * of binding an empty function
	     *
	     * the keycombo+action has to be exactly the same as
	     * it was defined in the bind method
	     *
	     * @param {string|Array} keys
	     * @param {string} action
	     * @returns void
	     */
	    Mousetrap.prototype.unbind = function(keys, action) {
	        var self = this;
	        return self.bind.call(self, keys, function() {}, action);
	    };
	
	    /**
	     * triggers an event that has already been bound
	     *
	     * @param {string} keys
	     * @param {string=} action
	     * @returns void
	     */
	    Mousetrap.prototype.trigger = function(keys, action) {
	        var self = this;
	        if (self._directMap[keys + ':' + action]) {
	            self._directMap[keys + ':' + action]({}, keys);
	        }
	        return self;
	    };
	
	    /**
	     * resets the library back to its initial state.  this is useful
	     * if you want to clear out the current keyboard shortcuts and bind
	     * new ones - for example if you switch to another page
	     *
	     * @returns void
	     */
	    Mousetrap.prototype.reset = function() {
	        var self = this;
	        self._callbacks = {};
	        self._directMap = {};
	        return self;
	    };
	
	    /**
	     * should we stop this event before firing off callbacks
	     *
	     * @param {Event} e
	     * @param {Element} element
	     * @return {boolean}
	     */
	    Mousetrap.prototype.stopCallback = function(e, element) {
	        var self = this;
	
	        // if the element has the class "mousetrap" then no need to stop
	        if ((' ' + element.className + ' ').indexOf(' mousetrap ') > -1) {
	            return false;
	        }
	
	        if (_belongsTo(element, self.target)) {
	            return false;
	        }
	
	        // stop for input, select, and textarea
	        return element.tagName == 'INPUT' || element.tagName == 'SELECT' || element.tagName == 'TEXTAREA' || element.isContentEditable;
	    };
	
	    /**
	     * exposes _handleKey publicly so it can be overwritten by extensions
	     */
	    Mousetrap.prototype.handleKey = function() {
	        var self = this;
	        return self._handleKey.apply(self, arguments);
	    };
	
	    /**
	     * Init the global mousetrap functions
	     *
	     * This method is needed to allow the global mousetrap functions to work
	     * now that mousetrap is a constructor function.
	     */
	    Mousetrap.init = function() {
	        var documentMousetrap = Mousetrap(document);
	        for (var method in documentMousetrap) {
	            if (method.charAt(0) !== '_') {
	                Mousetrap[method] = (function(method) {
	                    return function() {
	                        return documentMousetrap[method].apply(documentMousetrap, arguments);
	                    };
	                } (method));
	            }
	        }
	    };
	
	    Mousetrap.init();
	
	    // expose mousetrap to the global object
	    window.Mousetrap = Mousetrap;
	
	    // expose as a common js module
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = Mousetrap;
	    }
	
	    // expose mousetrap as an AMD module
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	            return Mousetrap;
	        }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }
	}) (window, document);


/***/ },
/* 346 */,
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(3)['default'];
	
	var _inherits = __webpack_require__(17)['default'];
	
	var _createClass = __webpack_require__(28)['default'];
	
	var _classCallCheck = __webpack_require__(31)['default'];
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _backbone = __webpack_require__(348);
	
	var _backbone2 = _interopRequireDefault(_backbone);
	
	var _underscore = __webpack_require__(66);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _Paginator = __webpack_require__(349);
	
	var _Paginator2 = _interopRequireDefault(_Paginator);
	
	var TastypieCollection = (function (_Backbone$Collection) {
	  _inherits(TastypieCollection, _Backbone$Collection);
	
	  function TastypieCollection() {
	    _classCallCheck(this, TastypieCollection);
	
	    _get(Object.getPrototypeOf(TastypieCollection.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(TastypieCollection, [{
	    key: 'initialize',
	    value: function initialize(options) {
	      this.paginator = new _Paginator2['default']({}, this);
	    }
	  }, {
	    key: 'destroyAll',
	    value: function destroyAll(options) {
	      var payload = {
	        'objects': [],
	        'deleted_objects': []
	      };
	
	      this.forEach(function (model) {
	        payload.deleted_objects.push(model.get('resource_uri'));
	      });
	
	      var collection = this;
	
	      options.success = function (resp) {
	        var size = collection.size();
	        for (var i = size - 1; i >= 0; i--) {
	          var model = collection.at(i);
	          model.trigger('destroy', model, model.collection);
	        }
	      };
	
	      var syncOptions = _underscore2['default'].extend({ 'attrs': payload }, options);
	      return _backbone2['default'].sync('patch', this, syncOptions);
	    }
	  }, {
	    key: 'parse',
	    value: function parse(response) {
	      this.paginator.set(response.meta);
	      return response.objects || response;
	    }
	  }, {
	    key: 'patch',
	    value: function patch(values, options) {
	      if (!options) {
	        options = {};
	      }
	
	      var payload = {
	        'objects': [],
	        'deleted_objects': []
	      };
	
	      var valid = true;
	
	      this.forEach(function (model) {
	        var modelData = model.changedAttributes() || {};
	
	        if (values) {
	          modelData = _underscore2['default'].extend(modelData, values);
	        }
	
	        if (_underscore2['default'].size(modelData) > 0) {
	          modelData.resource_uri = model.get('resource_uri');
	          payload.objects.push(modelData);
	        }
	      });
	
	      var collection = this;
	
	      options.success = function (resp) {
	        options = {
	          add: false,
	          remove: false,
	          parse: true
	        };
	        collection.set(resp, options);
	        collection.trigger('sync', collection, resp, options);
	      };
	
	      if (valid) {
	        options = _underscore2['default'].extend({ 'attrs': payload }, options);
	        return _backbone2['default'].sync('patch', this, options);
	      }
	      return false;
	    }
	  }]);
	
	  return TastypieCollection;
	})(_backbone2['default'].Collection);
	
	exports['default'] = TastypieCollection;
	module.exports = exports['default'];

/***/ },
/* 348 */
/***/ function(module, exports) {

	module.exports = Backbone;

/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(3)['default'];
	
	var _inherits = __webpack_require__(17)['default'];
	
	var _createClass = __webpack_require__(28)['default'];
	
	var _classCallCheck = __webpack_require__(31)['default'];
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _backbone = __webpack_require__(348);
	
	var _backbone2 = _interopRequireDefault(_backbone);
	
	var Paginator = (function (_Backbone$Model) {
	  _inherits(Paginator, _Backbone$Model);
	
	  function Paginator() {
	    _classCallCheck(this, Paginator);
	
	    _get(Object.getPrototypeOf(Paginator.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(Paginator, [{
	    key: 'initialize',
	    value: function initialize(options) {
	      this.collection = options.collection;
	    }
	  }]);
	
	  return Paginator;
	})(_backbone2['default'].Model);
	
	exports['default'] = Paginator;
	module.exports = exports['default'];

/***/ },
/* 350 */,
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _get = __webpack_require__(3)['default'];
	
	var _inherits = __webpack_require__(17)['default'];
	
	var _createClass = __webpack_require__(28)['default'];
	
	var _classCallCheck = __webpack_require__(31)['default'];
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _backbone = __webpack_require__(348);
	
	var _backbone2 = _interopRequireDefault(_backbone);
	
	var _underscore = __webpack_require__(66);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var TastypieModel = (function (_Backbone$Model) {
	  _inherits(TastypieModel, _Backbone$Model);
	
	  function TastypieModel() {
	    _classCallCheck(this, TastypieModel);
	
	    _get(Object.getPrototypeOf(TastypieModel.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(TastypieModel, [{
	    key: 'base_url',
	    value: function base_url() {
	      var temp_url = _get(Object.getPrototypeOf(TastypieModel.prototype), 'url', this).call(this);
	      return temp_url.charAt(temp_url.length - 1) == '/' ? temp_url : temp_url + '/';
	    }
	  }, {
	    key: 'url',
	    value: function url() {
	      return this.base_url();
	    }
	  }]);
	
	  return TastypieModel;
	})(_backbone2['default'].Model);
	
	exports['default'] = TastypieModel;
	module.exports = exports['default'];

/***/ },
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _utilsGetPayload = __webpack_require__(356);
	
	var _utilsGetPayload2 = _interopRequireDefault(_utilsGetPayload);
	
	exports['default'] = (0, _utilsGetPayload2['default'])();
	module.exports = exports['default'];

/***/ },
/* 356 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = getPayload;
	
	function getPayload() {
	  if (typeof global.__PAYLOAD__ === 'undefined') {
	    throw new Error('JS payload not defined');
	  }
	
	  return global.__PAYLOAD__;
	}
	
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(40);
	
	var FluxMixin = {
	  propTypes: {
	    flux: React.PropTypes.object
	  },
	
	  contextTypes: {
	    flux: React.PropTypes.object
	  },
	
	  childContextTypes: {
	    flux: React.PropTypes.object
	  },
	
	  getChildContext: function getChildContext() {
	    return {
	      flux: this.getFlux()
	    };
	  },
	
	  getFlux: function getFlux() {
	    return this.props.flux || this.context.flux;
	  }
	};
	
	module.exports = FluxMixin;

/***/ },
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(3)['default'];
	
	var _inherits = __webpack_require__(17)['default'];
	
	var _createClass = __webpack_require__(28)['default'];
	
	var _classCallCheck = __webpack_require__(31)['default'];
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _TastypieCollection2 = __webpack_require__(347);
	
	var _TastypieCollection3 = _interopRequireDefault(_TastypieCollection2);
	
	var SelectableCollection = (function (_TastypieCollection) {
	  _inherits(SelectableCollection, _TastypieCollection);
	
	  function SelectableCollection() {
	    _classCallCheck(this, SelectableCollection);
	
	    _get(Object.getPrototypeOf(SelectableCollection.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(SelectableCollection, [{
	    key: 'initialize',
	    value: function initialize(options) {
	      this.listenTo(this, 'addedToSelection', this.modelAddedToSelection);
	      this.listenTo(this, 'addedToNewSelection', this.modelAddedToNewSelection);
	      this.listenTo(this, 'removedFromSelection', this.modelRemovedFromSelection);
	      _get(Object.getPrototypeOf(SelectableCollection.prototype), 'initialize', this).call(this, options);
	    }
	  }, {
	    key: 'modelAddedToSelection',
	    value: function modelAddedToSelection(selectedModel) {}
	  }, {
	    key: 'modelAddedToNewSelection',
	    value: function modelAddedToNewSelection(selectedModel) {
	      this.each(function (model) {
	        if (model !== selectedModel) {
	          model.deselect();
	        }
	      });
	    }
	  }, {
	    key: 'modelRemovedFromSelection',
	    value: function modelRemovedFromSelection() {}
	  }, {
	    key: 'deselectAll',
	    value: function deselectAll() {
	      this.each(function (model) {
	        model.deselect();
	      });
	    }
	  }]);
	
	  return SelectableCollection;
	})(_TastypieCollection3['default']);
	
	exports['default'] = SelectableCollection;
	module.exports = exports['default'];

/***/ },
/* 411 */,
/* 412 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _get = __webpack_require__(3)["default"];
	
	var _inherits = __webpack_require__(17)["default"];
	
	var _createClass = __webpack_require__(28)["default"];
	
	var _classCallCheck = __webpack_require__(31)["default"];
	
	var _interopRequireDefault = __webpack_require__(1)["default"];
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TastypieModel2 = __webpack_require__(351);
	
	var _TastypieModel3 = _interopRequireDefault(_TastypieModel2);
	
	var SelectableModel = (function (_TastypieModel) {
	  _inherits(SelectableModel, _TastypieModel);
	
	  function SelectableModel() {
	    _classCallCheck(this, SelectableModel);
	
	    _get(Object.getPrototypeOf(SelectableModel.prototype), "constructor", this).apply(this, arguments);
	  }
	
	  _createClass(SelectableModel, [{
	    key: "initialize",
	    value: function initialize(options) {
	      this.selected = false;
	      _get(Object.getPrototypeOf(SelectableModel.prototype), "initialize", this).call(this, options);
	    }
	  }, {
	    key: "addToSelection",
	    value: function addToSelection(options) {
	      this.selected = true;
	      this.trigger("selected", this, options);
	      this.trigger("addedToSelection", this, options);
	    }
	  }, {
	    key: "addToNewSelection",
	    value: function addToNewSelection(options) {
	      this.selected = true;
	      this.trigger("selected", this, options);
	      this.trigger("addedToNewSelection", this, options);
	    }
	  }, {
	    key: "removeFromSelection",
	    value: function removeFromSelection(options) {
	      this.selected = false;
	      this.trigger("deselected", this, options);
	      this.trigger("removedFromSelection", this, options);
	    }
	  }, {
	    key: "deselect",
	    value: function deselect(options) {
	      this.selected = false;
	      this.trigger("deselected", this, options);
	    }
	  }]);
	
	  return SelectableModel;
	})(_TastypieModel3["default"]);
	
	exports["default"] = SelectableModel;
	module.exports = exports["default"];

/***/ },
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = __webpack_require__(28)['default'];
	
	var _classCallCheck = __webpack_require__(31)['default'];
	
	var _Object$freeze = __webpack_require__(42)['default'];
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(40);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fluxxor = __webpack_require__(69);
	
	var _jquery = __webpack_require__(39);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _immutable = __webpack_require__(68);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _fastclick = __webpack_require__(451);
	
	var _fastclick2 = _interopRequireDefault(_fastclick);
	
	var _jsCookie = __webpack_require__(452);
	
	var _jsCookie2 = _interopRequireDefault(_jsCookie);
	
	var _ofsComponentsLayersLayerStack = __webpack_require__(337);
	
	var _ofsComponentsLayersLayerStack2 = _interopRequireDefault(_ofsComponentsLayersLayerStack);
	
	var _ofsUtilsKeyboard = __webpack_require__(344);
	
	var _ofsUtilsKeyboard2 = _interopRequireDefault(_ofsUtilsKeyboard);
	
	var _ofsLegacyComponents = __webpack_require__(45);
	
	var _ofsLegacyComponents2 = _interopRequireDefault(_ofsLegacyComponents);
	
	var _ofsComponentsHeader = __webpack_require__(453);
	
	var _ofsComponentsHeader2 = _interopRequireDefault(_ofsComponentsHeader);
	
	var _ofsReactComponentsLanguageWarning = __webpack_require__(454);
	
	var _ofsReactComponentsLanguageWarning2 = _interopRequireDefault(_ofsReactComponentsLanguageWarning);
	
	var _baseActions = __webpack_require__(455);
	
	var _baseActions2 = _interopRequireDefault(_baseActions);
	
	var _storesDate = __webpack_require__(456);
	
	var _storesDate2 = _interopRequireDefault(_storesDate);
	
	var _storesEnquiry = __webpack_require__(457);
	
	var _storesEnquiry2 = _interopRequireDefault(_storesEnquiry);
	
	var _storesGuest = __webpack_require__(458);
	
	var _storesGuest2 = _interopRequireDefault(_storesGuest);
	
	var _storesLayers = __webpack_require__(335);
	
	var _storesLayers2 = _interopRequireDefault(_storesLayers);
	
	var _storesTracking = __webpack_require__(459);
	
	var _storesTracking2 = _interopRequireDefault(_storesTracking);
	
	var _storesLanguage = __webpack_require__(469);
	
	var _storesLanguage2 = _interopRequireDefault(_storesLanguage);
	
	var _viewsHeader = __webpack_require__(470);
	
	var _viewsHeader2 = _interopRequireDefault(_viewsHeader);
	
	var _viewsCurrencySelector = __webpack_require__(492);
	
	var _viewsCurrencySelector2 = _interopRequireDefault(_viewsCurrencySelector);
	
	var _viewsLanguageSelector = __webpack_require__(493);
	
	var _viewsLanguageSelector2 = _interopRequireDefault(_viewsLanguageSelector);
	
	var _ofsComponentsMailingNewsletterSignUp = __webpack_require__(494);
	
	var _ofsComponentsMailingNewsletterSignUp2 = _interopRequireDefault(_ofsComponentsMailingNewsletterSignUp);
	
	var _viewsWelcomeVoucher = __webpack_require__(498);
	
	var _viewsWelcomeVoucher2 = _interopRequireDefault(_viewsWelcomeVoucher);
	
	var EntryPoint = (function () {
	  _createClass(EntryPoint, [{
	    key: 'getStores',
	    value: function getStores() {
	      return {
	        DateStore: new _storesDate2['default'](this.options.dates),
	        GuestStore: new _storesGuest2['default'](this.options.guests),
	        EnquiryStore: new _storesEnquiry2['default'](_immutable2['default'].fromJS(this.options.enquiry) || _immutable2['default'].Map()),
	        LayerStore: new _storesLayers2['default'](),
	        TrackingStore: new _storesTracking2['default'](),
	        LanguageStore: new _storesLanguage2['default'](this.options.language)
	      };
	    }
	  }, {
	    key: 'getActions',
	    value: function getActions() {
	      return _baseActions2['default'];
	    }
	  }]);
	
	  function EntryPoint(options) {
	    _classCallCheck(this, EntryPoint);
	
	    this.options = _Object$freeze(options || {});
	    this.flux = typeof window !== 'undefined' && window.ofsFlux ? window.ofsFlux : new _fluxxor.Flux(this.getStores(), this.getActions());
	    this.keyboard = new _ofsUtilsKeyboard2['default']();
	
	    if (typeof window !== 'undefined') {
	      window.ofsFlux = this.flux; // Legacy support
	    }
	  }
	
	  _createClass(EntryPoint, [{
	    key: 'renderToDocument',
	    value: function renderToDocument(document) {
	      var _this = this;
	
	      (0, _fastclick2['default'])(document.body);
	
	      _react2['default'].render(_react2['default'].createElement(_ofsComponentsLayersLayerStack2['default'], { flux: this.flux, keyboard: this.keyboard }), document.getElementById('layer-stack'));
	
	      var languageWarningEl = document.getElementById('language-warning');
	
	      if (languageWarningEl) {
	        _react2['default'].render(_react2['default'].createElement(_ofsReactComponentsLanguageWarning2['default'], { flux: this.flux }), languageWarningEl);
	      }
	
	      _ofsLegacyComponents2['default'].initComponents((0, _jquery2['default'])(document)); // Legacy components
	
	      var currencySelectorEl = document.getElementById('currency-selector');
	      if (currencySelectorEl) {
	        _react2['default'].render(_react2['default'].createElement(_viewsCurrencySelector2['default'], { flux: this.flux }), currencySelectorEl);
	      }
	
	      var languageSelectorEl = document.getElementById('language-selector');
	      if (languageSelectorEl) {
	        _react2['default'].render(_react2['default'].createElement(_viewsLanguageSelector2['default'], { flux: this.flux }), languageSelectorEl);
	      }
	
	      var mailingFormEl = document.getElementById('mailing-form');
	      if (mailingFormEl) {
	        _react2['default'].render(_react2['default'].createElement(_ofsComponentsMailingNewsletterSignUp2['default'], { source: 'footer' }), mailingFormEl);
	      }
	
	      // init header
	      if ((0, _jquery2['default'])('.-js--legacy-header').length) {
	        // legacy header
	        (0, _ofsComponentsHeader2['default'])(this.flux);
	      } else {
	        (0, _viewsHeader2['default'])(this.flux);
	      }
	
	      var $pageContainer = (0, _jquery2['default'])('.ofs-PageContainer');
	      var pageContainerWidth = $pageContainer.width();
	
	      // refresh width on resize
	      (0, _jquery2['default'])(window).on('resize', function () {
	        return pageContainerWidth = $pageContainer.width();
	      });
	
	      (0, _jquery2['default'])('#mobile-menu-toggle').on('click', function (event) {
	        event.preventDefault();
	        var $body = (0, _jquery2['default'])('body');
	
	        if ($body.css('position') !== 'fixed') {
	          $body.css('position', 'fixed');
	        } else {
	          $body.css('position', 'static');
	        }
	
	        if (parseInt($pageContainer.css('width')) === pageContainerWidth) {
	          // reset width
	          $pageContainer.css('width', '100%');
	        } else {
	          $pageContainer.css('width', pageContainerWidth);
	        }
	
	        (0, _jquery2['default'])('.ofs-Flyout').toggleClass('ofs-Flyout--is-visible');
	        $pageContainer.toggleClass('ofs-PageContainer--offset');
	      });
	
	      // welcome voucher
	      var welcomeVoucher = document.getElementById('welcome-voucher');
	
	      if (welcomeVoucher && pageContainerWidth > 640 && document.location.href.search('no_welcome_voucher') == -1) {
	        setTimeout(function () {
	          _this.flux.actions.layers.addModal(_react2['default'].createElement(_viewsWelcomeVoucher2['default'], { popupAd: true }));
	        }, 3000);
	        _jsCookie2['default'].set('welcome_voucher', true, { 'path': '/' });
	      }
	    }
	  }, {
	    key: 'renderToString',
	    value: function renderToString() {}
	  }, {
	    key: 'render',
	    value: function render(document) {
	      if (document) {
	        this.renderToDocument(document);
	      } else {
	        return this.renderToString();
	      }
	    }
	  }]);
	
	  return EntryPoint;
	})();
	
	exports['default'] = EntryPoint;
	module.exports = exports['default'];

/***/ },
/* 451 */
/***/ function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	;(function () {
		'use strict';
	
		/**
		 * @preserve FastClick: polyfill to remove click delays on browsers with touch UIs.
		 *
		 * @codingstandard ftlabs-jsv2
		 * @copyright The Financial Times Limited [All Rights Reserved]
		 * @license MIT License (see LICENSE.txt)
		 */
	
		/*jslint browser:true, node:true*/
		/*global define, Event, Node*/
	
	
		/**
		 * Instantiate fast-clicking listeners on the specified layer.
		 *
		 * @constructor
		 * @param {Element} layer The layer to listen on
		 * @param {Object} [options={}] The options to override the defaults
		 */
		function FastClick(layer, options) {
			var oldOnClick;
	
			options = options || {};
	
			/**
			 * Whether a click is currently being tracked.
			 *
			 * @type boolean
			 */
			this.trackingClick = false;
	
	
			/**
			 * Timestamp for when click tracking started.
			 *
			 * @type number
			 */
			this.trackingClickStart = 0;
	
	
			/**
			 * The element being tracked for a click.
			 *
			 * @type EventTarget
			 */
			this.targetElement = null;
	
	
			/**
			 * X-coordinate of touch start event.
			 *
			 * @type number
			 */
			this.touchStartX = 0;
	
	
			/**
			 * Y-coordinate of touch start event.
			 *
			 * @type number
			 */
			this.touchStartY = 0;
	
	
			/**
			 * ID of the last touch, retrieved from Touch.identifier.
			 *
			 * @type number
			 */
			this.lastTouchIdentifier = 0;
	
	
			/**
			 * Touchmove boundary, beyond which a click will be cancelled.
			 *
			 * @type number
			 */
			this.touchBoundary = options.touchBoundary || 10;
	
	
			/**
			 * The FastClick layer.
			 *
			 * @type Element
			 */
			this.layer = layer;
	
			/**
			 * The minimum time between tap(touchstart and touchend) events
			 *
			 * @type number
			 */
			this.tapDelay = options.tapDelay || 200;
	
			/**
			 * The maximum time for a tap
			 *
			 * @type number
			 */
			this.tapTimeout = options.tapTimeout || 700;
	
			if (FastClick.notNeeded(layer)) {
				return;
			}
	
			// Some old versions of Android don't have Function.prototype.bind
			function bind(method, context) {
				return function() { return method.apply(context, arguments); };
			}
	
	
			var methods = ['onMouse', 'onClick', 'onTouchStart', 'onTouchMove', 'onTouchEnd', 'onTouchCancel'];
			var context = this;
			for (var i = 0, l = methods.length; i < l; i++) {
				context[methods[i]] = bind(context[methods[i]], context);
			}
	
			// Set up event handlers as required
			if (deviceIsAndroid) {
				layer.addEventListener('mouseover', this.onMouse, true);
				layer.addEventListener('mousedown', this.onMouse, true);
				layer.addEventListener('mouseup', this.onMouse, true);
			}
	
			layer.addEventListener('click', this.onClick, true);
			layer.addEventListener('touchstart', this.onTouchStart, false);
			layer.addEventListener('touchmove', this.onTouchMove, false);
			layer.addEventListener('touchend', this.onTouchEnd, false);
			layer.addEventListener('touchcancel', this.onTouchCancel, false);
	
			// Hack is required for browsers that don't support Event#stopImmediatePropagation (e.g. Android 2)
			// which is how FastClick normally stops click events bubbling to callbacks registered on the FastClick
			// layer when they are cancelled.
			if (!Event.prototype.stopImmediatePropagation) {
				layer.removeEventListener = function(type, callback, capture) {
					var rmv = Node.prototype.removeEventListener;
					if (type === 'click') {
						rmv.call(layer, type, callback.hijacked || callback, capture);
					} else {
						rmv.call(layer, type, callback, capture);
					}
				};
	
				layer.addEventListener = function(type, callback, capture) {
					var adv = Node.prototype.addEventListener;
					if (type === 'click') {
						adv.call(layer, type, callback.hijacked || (callback.hijacked = function(event) {
							if (!event.propagationStopped) {
								callback(event);
							}
						}), capture);
					} else {
						adv.call(layer, type, callback, capture);
					}
				};
			}
	
			// If a handler is already declared in the element's onclick attribute, it will be fired before
			// FastClick's onClick handler. Fix this by pulling out the user-defined handler function and
			// adding it as listener.
			if (typeof layer.onclick === 'function') {
	
				// Android browser on at least 3.2 requires a new reference to the function in layer.onclick
				// - the old one won't work if passed to addEventListener directly.
				oldOnClick = layer.onclick;
				layer.addEventListener('click', function(event) {
					oldOnClick(event);
				}, false);
				layer.onclick = null;
			}
		}
	
		/**
		* Windows Phone 8.1 fakes user agent string to look like Android and iPhone.
		*
		* @type boolean
		*/
		var deviceIsWindowsPhone = navigator.userAgent.indexOf("Windows Phone") >= 0;
	
		/**
		 * Android requires exceptions.
		 *
		 * @type boolean
		 */
		var deviceIsAndroid = navigator.userAgent.indexOf('Android') > 0 && !deviceIsWindowsPhone;
	
	
		/**
		 * iOS requires exceptions.
		 *
		 * @type boolean
		 */
		var deviceIsIOS = /iP(ad|hone|od)/.test(navigator.userAgent) && !deviceIsWindowsPhone;
	
	
		/**
		 * iOS 4 requires an exception for select elements.
		 *
		 * @type boolean
		 */
		var deviceIsIOS4 = deviceIsIOS && (/OS 4_\d(_\d)?/).test(navigator.userAgent);
	
	
		/**
		 * iOS 6.0-7.* requires the target element to be manually derived
		 *
		 * @type boolean
		 */
		var deviceIsIOSWithBadTarget = deviceIsIOS && (/OS [6-7]_\d/).test(navigator.userAgent);
	
		/**
		 * BlackBerry requires exceptions.
		 *
		 * @type boolean
		 */
		var deviceIsBlackBerry10 = navigator.userAgent.indexOf('BB10') > 0;
	
		/**
		 * Determine whether a given element requires a native click.
		 *
		 * @param {EventTarget|Element} target Target DOM element
		 * @returns {boolean} Returns true if the element needs a native click
		 */
		FastClick.prototype.needsClick = function(target) {
			switch (target.nodeName.toLowerCase()) {
	
			// Don't send a synthetic click to disabled inputs (issue #62)
			case 'button':
			case 'select':
			case 'textarea':
				if (target.disabled) {
					return true;
				}
	
				break;
			case 'input':
	
				// File inputs need real clicks on iOS 6 due to a browser bug (issue #68)
				if ((deviceIsIOS && target.type === 'file') || target.disabled) {
					return true;
				}
	
				break;
			case 'label':
			case 'iframe': // iOS8 homescreen apps can prevent events bubbling into frames
			case 'video':
				return true;
			}
	
			return (/\bneedsclick\b/).test(target.className);
		};
	
	
		/**
		 * Determine whether a given element requires a call to focus to simulate click into element.
		 *
		 * @param {EventTarget|Element} target Target DOM element
		 * @returns {boolean} Returns true if the element requires a call to focus to simulate native click.
		 */
		FastClick.prototype.needsFocus = function(target) {
			switch (target.nodeName.toLowerCase()) {
			case 'textarea':
				return true;
			case 'select':
				return !deviceIsAndroid;
			case 'input':
				switch (target.type) {
				case 'button':
				case 'checkbox':
				case 'file':
				case 'image':
				case 'radio':
				case 'submit':
					return false;
				}
	
				// No point in attempting to focus disabled inputs
				return !target.disabled && !target.readOnly;
			default:
				return (/\bneedsfocus\b/).test(target.className);
			}
		};
	
	
		/**
		 * Send a click event to the specified element.
		 *
		 * @param {EventTarget|Element} targetElement
		 * @param {Event} event
		 */
		FastClick.prototype.sendClick = function(targetElement, event) {
			var clickEvent, touch;
	
			// On some Android devices activeElement needs to be blurred otherwise the synthetic click will have no effect (#24)
			if (document.activeElement && document.activeElement !== targetElement) {
				document.activeElement.blur();
			}
	
			touch = event.changedTouches[0];
	
			// Synthesise a click event, with an extra attribute so it can be tracked
			clickEvent = document.createEvent('MouseEvents');
			clickEvent.initMouseEvent(this.determineEventType(targetElement), true, true, window, 1, touch.screenX, touch.screenY, touch.clientX, touch.clientY, false, false, false, false, 0, null);
			clickEvent.forwardedTouchEvent = true;
			targetElement.dispatchEvent(clickEvent);
		};
	
		FastClick.prototype.determineEventType = function(targetElement) {
	
			//Issue #159: Android Chrome Select Box does not open with a synthetic click event
			if (deviceIsAndroid && targetElement.tagName.toLowerCase() === 'select') {
				return 'mousedown';
			}
	
			return 'click';
		};
	
	
		/**
		 * @param {EventTarget|Element} targetElement
		 */
		FastClick.prototype.focus = function(targetElement) {
			var length;
	
			// Issue #160: on iOS 7, some input elements (e.g. date datetime month) throw a vague TypeError on setSelectionRange. These elements don't have an integer value for the selectionStart and selectionEnd properties, but unfortunately that can't be used for detection because accessing the properties also throws a TypeError. Just check the type instead. Filed as Apple bug #15122724.
			if (deviceIsIOS && targetElement.setSelectionRange && targetElement.type.indexOf('date') !== 0 && targetElement.type !== 'time' && targetElement.type !== 'month') {
				length = targetElement.value.length;
				targetElement.setSelectionRange(length, length);
			} else {
				targetElement.focus();
			}
		};
	
	
		/**
		 * Check whether the given target element is a child of a scrollable layer and if so, set a flag on it.
		 *
		 * @param {EventTarget|Element} targetElement
		 */
		FastClick.prototype.updateScrollParent = function(targetElement) {
			var scrollParent, parentElement;
	
			scrollParent = targetElement.fastClickScrollParent;
	
			// Attempt to discover whether the target element is contained within a scrollable layer. Re-check if the
			// target element was moved to another parent.
			if (!scrollParent || !scrollParent.contains(targetElement)) {
				parentElement = targetElement;
				do {
					if (parentElement.scrollHeight > parentElement.offsetHeight) {
						scrollParent = parentElement;
						targetElement.fastClickScrollParent = parentElement;
						break;
					}
	
					parentElement = parentElement.parentElement;
				} while (parentElement);
			}
	
			// Always update the scroll top tracker if possible.
			if (scrollParent) {
				scrollParent.fastClickLastScrollTop = scrollParent.scrollTop;
			}
		};
	
	
		/**
		 * @param {EventTarget} targetElement
		 * @returns {Element|EventTarget}
		 */
		FastClick.prototype.getTargetElementFromEventTarget = function(eventTarget) {
	
			// On some older browsers (notably Safari on iOS 4.1 - see issue #56) the event target may be a text node.
			if (eventTarget.nodeType === Node.TEXT_NODE) {
				return eventTarget.parentNode;
			}
	
			return eventTarget;
		};
	
	
		/**
		 * On touch start, record the position and scroll offset.
		 *
		 * @param {Event} event
		 * @returns {boolean}
		 */
		FastClick.prototype.onTouchStart = function(event) {
			var targetElement, touch, selection;
	
			// Ignore multiple touches, otherwise pinch-to-zoom is prevented if both fingers are on the FastClick element (issue #111).
			if (event.targetTouches.length > 1) {
				return true;
			}
	
			targetElement = this.getTargetElementFromEventTarget(event.target);
			touch = event.targetTouches[0];
	
			if (deviceIsIOS) {
	
				// Only trusted events will deselect text on iOS (issue #49)
				selection = window.getSelection();
				if (selection.rangeCount && !selection.isCollapsed) {
					return true;
				}
	
				if (!deviceIsIOS4) {
	
					// Weird things happen on iOS when an alert or confirm dialog is opened from a click event callback (issue #23):
					// when the user next taps anywhere else on the page, new touchstart and touchend events are dispatched
					// with the same identifier as the touch event that previously triggered the click that triggered the alert.
					// Sadly, there is an issue on iOS 4 that causes some normal touch events to have the same identifier as an
					// immediately preceeding touch event (issue #52), so this fix is unavailable on that platform.
					// Issue 120: touch.identifier is 0 when Chrome dev tools 'Emulate touch events' is set with an iOS device UA string,
					// which causes all touch events to be ignored. As this block only applies to iOS, and iOS identifiers are always long,
					// random integers, it's safe to to continue if the identifier is 0 here.
					if (touch.identifier && touch.identifier === this.lastTouchIdentifier) {
						event.preventDefault();
						return false;
					}
	
					this.lastTouchIdentifier = touch.identifier;
	
					// If the target element is a child of a scrollable layer (using -webkit-overflow-scrolling: touch) and:
					// 1) the user does a fling scroll on the scrollable layer
					// 2) the user stops the fling scroll with another tap
					// then the event.target of the last 'touchend' event will be the element that was under the user's finger
					// when the fling scroll was started, causing FastClick to send a click event to that layer - unless a check
					// is made to ensure that a parent layer was not scrolled before sending a synthetic click (issue #42).
					this.updateScrollParent(targetElement);
				}
			}
	
			this.trackingClick = true;
			this.trackingClickStart = event.timeStamp;
			this.targetElement = targetElement;
	
			this.touchStartX = touch.pageX;
			this.touchStartY = touch.pageY;
	
			// Prevent phantom clicks on fast double-tap (issue #36)
			if ((event.timeStamp - this.lastClickTime) < this.tapDelay) {
				event.preventDefault();
			}
	
			return true;
		};
	
	
		/**
		 * Based on a touchmove event object, check whether the touch has moved past a boundary since it started.
		 *
		 * @param {Event} event
		 * @returns {boolean}
		 */
		FastClick.prototype.touchHasMoved = function(event) {
			var touch = event.changedTouches[0], boundary = this.touchBoundary;
	
			if (Math.abs(touch.pageX - this.touchStartX) > boundary || Math.abs(touch.pageY - this.touchStartY) > boundary) {
				return true;
			}
	
			return false;
		};
	
	
		/**
		 * Update the last position.
		 *
		 * @param {Event} event
		 * @returns {boolean}
		 */
		FastClick.prototype.onTouchMove = function(event) {
			if (!this.trackingClick) {
				return true;
			}
	
			// If the touch has moved, cancel the click tracking
			if (this.targetElement !== this.getTargetElementFromEventTarget(event.target) || this.touchHasMoved(event)) {
				this.trackingClick = false;
				this.targetElement = null;
			}
	
			return true;
		};
	
	
		/**
		 * Attempt to find the labelled control for the given label element.
		 *
		 * @param {EventTarget|HTMLLabelElement} labelElement
		 * @returns {Element|null}
		 */
		FastClick.prototype.findControl = function(labelElement) {
	
			// Fast path for newer browsers supporting the HTML5 control attribute
			if (labelElement.control !== undefined) {
				return labelElement.control;
			}
	
			// All browsers under test that support touch events also support the HTML5 htmlFor attribute
			if (labelElement.htmlFor) {
				return document.getElementById(labelElement.htmlFor);
			}
	
			// If no for attribute exists, attempt to retrieve the first labellable descendant element
			// the list of which is defined here: http://www.w3.org/TR/html5/forms.html#category-label
			return labelElement.querySelector('button, input:not([type=hidden]), keygen, meter, output, progress, select, textarea');
		};
	
	
		/**
		 * On touch end, determine whether to send a click event at once.
		 *
		 * @param {Event} event
		 * @returns {boolean}
		 */
		FastClick.prototype.onTouchEnd = function(event) {
			var forElement, trackingClickStart, targetTagName, scrollParent, touch, targetElement = this.targetElement;
	
			if (!this.trackingClick) {
				return true;
			}
	
			// Prevent phantom clicks on fast double-tap (issue #36)
			if ((event.timeStamp - this.lastClickTime) < this.tapDelay) {
				this.cancelNextClick = true;
				return true;
			}
	
			if ((event.timeStamp - this.trackingClickStart) > this.tapTimeout) {
				return true;
			}
	
			// Reset to prevent wrong click cancel on input (issue #156).
			this.cancelNextClick = false;
	
			this.lastClickTime = event.timeStamp;
	
			trackingClickStart = this.trackingClickStart;
			this.trackingClick = false;
			this.trackingClickStart = 0;
	
			// On some iOS devices, the targetElement supplied with the event is invalid if the layer
			// is performing a transition or scroll, and has to be re-detected manually. Note that
			// for this to function correctly, it must be called *after* the event target is checked!
			// See issue #57; also filed as rdar://13048589 .
			if (deviceIsIOSWithBadTarget) {
				touch = event.changedTouches[0];
	
				// In certain cases arguments of elementFromPoint can be negative, so prevent setting targetElement to null
				targetElement = document.elementFromPoint(touch.pageX - window.pageXOffset, touch.pageY - window.pageYOffset) || targetElement;
				targetElement.fastClickScrollParent = this.targetElement.fastClickScrollParent;
			}
	
			targetTagName = targetElement.tagName.toLowerCase();
			if (targetTagName === 'label') {
				forElement = this.findControl(targetElement);
				if (forElement) {
					this.focus(targetElement);
					if (deviceIsAndroid) {
						return false;
					}
	
					targetElement = forElement;
				}
			} else if (this.needsFocus(targetElement)) {
	
				// Case 1: If the touch started a while ago (best guess is 100ms based on tests for issue #36) then focus will be triggered anyway. Return early and unset the target element reference so that the subsequent click will be allowed through.
				// Case 2: Without this exception for input elements tapped when the document is contained in an iframe, then any inputted text won't be visible even though the value attribute is updated as the user types (issue #37).
				if ((event.timeStamp - trackingClickStart) > 100 || (deviceIsIOS && window.top !== window && targetTagName === 'input')) {
					this.targetElement = null;
					return false;
				}
	
				this.focus(targetElement);
				this.sendClick(targetElement, event);
	
				// Select elements need the event to go through on iOS 4, otherwise the selector menu won't open.
				// Also this breaks opening selects when VoiceOver is active on iOS6, iOS7 (and possibly others)
				if (!deviceIsIOS || targetTagName !== 'select') {
					this.targetElement = null;
					event.preventDefault();
				}
	
				return false;
			}
	
			if (deviceIsIOS && !deviceIsIOS4) {
	
				// Don't send a synthetic click event if the target element is contained within a parent layer that was scrolled
				// and this tap is being used to stop the scrolling (usually initiated by a fling - issue #42).
				scrollParent = targetElement.fastClickScrollParent;
				if (scrollParent && scrollParent.fastClickLastScrollTop !== scrollParent.scrollTop) {
					return true;
				}
			}
	
			// Prevent the actual click from going though - unless the target node is marked as requiring
			// real clicks or if it is in the whitelist in which case only non-programmatic clicks are permitted.
			if (!this.needsClick(targetElement)) {
				event.preventDefault();
				this.sendClick(targetElement, event);
			}
	
			return false;
		};
	
	
		/**
		 * On touch cancel, stop tracking the click.
		 *
		 * @returns {void}
		 */
		FastClick.prototype.onTouchCancel = function() {
			this.trackingClick = false;
			this.targetElement = null;
		};
	
	
		/**
		 * Determine mouse events which should be permitted.
		 *
		 * @param {Event} event
		 * @returns {boolean}
		 */
		FastClick.prototype.onMouse = function(event) {
	
			// If a target element was never set (because a touch event was never fired) allow the event
			if (!this.targetElement) {
				return true;
			}
	
			if (event.forwardedTouchEvent) {
				return true;
			}
	
			// Programmatically generated events targeting a specific element should be permitted
			if (!event.cancelable) {
				return true;
			}
	
			// Derive and check the target element to see whether the mouse event needs to be permitted;
			// unless explicitly enabled, prevent non-touch click events from triggering actions,
			// to prevent ghost/doubleclicks.
			if (!this.needsClick(this.targetElement) || this.cancelNextClick) {
	
				// Prevent any user-added listeners declared on FastClick element from being fired.
				if (event.stopImmediatePropagation) {
					event.stopImmediatePropagation();
				} else {
	
					// Part of the hack for browsers that don't support Event#stopImmediatePropagation (e.g. Android 2)
					event.propagationStopped = true;
				}
	
				// Cancel the event
				event.stopPropagation();
				event.preventDefault();
	
				return false;
			}
	
			// If the mouse event is permitted, return true for the action to go through.
			return true;
		};
	
	
		/**
		 * On actual clicks, determine whether this is a touch-generated click, a click action occurring
		 * naturally after a delay after a touch (which needs to be cancelled to avoid duplication), or
		 * an actual click which should be permitted.
		 *
		 * @param {Event} event
		 * @returns {boolean}
		 */
		FastClick.prototype.onClick = function(event) {
			var permitted;
	
			// It's possible for another FastClick-like library delivered with third-party code to fire a click event before FastClick does (issue #44). In that case, set the click-tracking flag back to false and return early. This will cause onTouchEnd to return early.
			if (this.trackingClick) {
				this.targetElement = null;
				this.trackingClick = false;
				return true;
			}
	
			// Very odd behaviour on iOS (issue #18): if a submit element is present inside a form and the user hits enter in the iOS simulator or clicks the Go button on the pop-up OS keyboard the a kind of 'fake' click event will be triggered with the submit-type input element as the target.
			if (event.target.type === 'submit' && event.detail === 0) {
				return true;
			}
	
			permitted = this.onMouse(event);
	
			// Only unset targetElement if the click is not permitted. This will ensure that the check for !targetElement in onMouse fails and the browser's click doesn't go through.
			if (!permitted) {
				this.targetElement = null;
			}
	
			// If clicks are permitted, return true for the action to go through.
			return permitted;
		};
	
	
		/**
		 * Remove all FastClick's event listeners.
		 *
		 * @returns {void}
		 */
		FastClick.prototype.destroy = function() {
			var layer = this.layer;
	
			if (deviceIsAndroid) {
				layer.removeEventListener('mouseover', this.onMouse, true);
				layer.removeEventListener('mousedown', this.onMouse, true);
				layer.removeEventListener('mouseup', this.onMouse, true);
			}
	
			layer.removeEventListener('click', this.onClick, true);
			layer.removeEventListener('touchstart', this.onTouchStart, false);
			layer.removeEventListener('touchmove', this.onTouchMove, false);
			layer.removeEventListener('touchend', this.onTouchEnd, false);
			layer.removeEventListener('touchcancel', this.onTouchCancel, false);
		};
	
	
		/**
		 * Check whether FastClick is needed.
		 *
		 * @param {Element} layer The layer to listen on
		 */
		FastClick.notNeeded = function(layer) {
			var metaViewport;
			var chromeVersion;
			var blackberryVersion;
			var firefoxVersion;
	
			// Devices that don't support touch don't need FastClick
			if (typeof window.ontouchstart === 'undefined') {
				return true;
			}
	
			// Chrome version - zero for other browsers
			chromeVersion = +(/Chrome\/([0-9]+)/.exec(navigator.userAgent) || [,0])[1];
	
			if (chromeVersion) {
	
				if (deviceIsAndroid) {
					metaViewport = document.querySelector('meta[name=viewport]');
	
					if (metaViewport) {
						// Chrome on Android with user-scalable="no" doesn't need FastClick (issue #89)
						if (metaViewport.content.indexOf('user-scalable=no') !== -1) {
							return true;
						}
						// Chrome 32 and above with width=device-width or less don't need FastClick
						if (chromeVersion > 31 && document.documentElement.scrollWidth <= window.outerWidth) {
							return true;
						}
					}
	
				// Chrome desktop doesn't need FastClick (issue #15)
				} else {
					return true;
				}
			}
	
			if (deviceIsBlackBerry10) {
				blackberryVersion = navigator.userAgent.match(/Version\/([0-9]*)\.([0-9]*)/);
	
				// BlackBerry 10.3+ does not require Fastclick library.
				// https://github.com/ftlabs/fastclick/issues/251
				if (blackberryVersion[1] >= 10 && blackberryVersion[2] >= 3) {
					metaViewport = document.querySelector('meta[name=viewport]');
	
					if (metaViewport) {
						// user-scalable=no eliminates click delay.
						if (metaViewport.content.indexOf('user-scalable=no') !== -1) {
							return true;
						}
						// width=device-width (or less than device-width) eliminates click delay.
						if (document.documentElement.scrollWidth <= window.outerWidth) {
							return true;
						}
					}
				}
			}
	
			// IE10 with -ms-touch-action: none or manipulation, which disables double-tap-to-zoom (issue #97)
			if (layer.style.msTouchAction === 'none' || layer.style.touchAction === 'manipulation') {
				return true;
			}
	
			// Firefox version - zero for other browsers
			firefoxVersion = +(/Firefox\/([0-9]+)/.exec(navigator.userAgent) || [,0])[1];
	
			if (firefoxVersion >= 27) {
				// Firefox 27+ does not have tap delay if the content is not zoomable - https://bugzilla.mozilla.org/show_bug.cgi?id=922896
	
				metaViewport = document.querySelector('meta[name=viewport]');
				if (metaViewport && (metaViewport.content.indexOf('user-scalable=no') !== -1 || document.documentElement.scrollWidth <= window.outerWidth)) {
					return true;
				}
			}
	
			// IE11: prefixed -ms-touch-action is no longer supported and it's recomended to use non-prefixed version
			// http://msdn.microsoft.com/en-us/library/windows/apps/Hh767313.aspx
			if (layer.style.touchAction === 'none' || layer.style.touchAction === 'manipulation') {
				return true;
			}
	
			return false;
		};
	
	
		/**
		 * Factory method for creating a FastClick object
		 *
		 * @param {Element} layer The layer to listen on
		 * @param {Object} [options={}] The options to override the defaults
		 */
		FastClick.attach = function(layer, options) {
			return new FastClick(layer, options);
		};
	
	
		if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) {
	
			// AMD. Register as an anonymous module.
			define(function() {
				return FastClick;
			});
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = FastClick.attach;
			module.exports.FastClick = FastClick;
		} else {
			window.FastClick = FastClick;
		}
	}());


/***/ },
/* 452 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * Javascript Cookie v1.5.1
	 * https://github.com/js-cookie/js-cookie
	 *
	 * Copyright 2006, 2014 Klaus Hartl
	 * Released under the MIT license
	 */
	(function (factory) {
		var jQuery;
		if (true) {
			// AMD (Register as an anonymous module)
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(39)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof exports === 'object') {
			// Node/CommonJS
			try {
				jQuery = require('jquery');
			} catch(e) {}
			module.exports = factory(jQuery);
		} else {
			// Browser globals
			var _OldCookies = window.Cookies;
			var api = window.Cookies = factory(window.jQuery);
			api.noConflict = function() {
				window.Cookies = _OldCookies;
				return api;
			};
		}
	}(function ($) {
	
		var pluses = /\+/g;
	
		function encode(s) {
			return api.raw ? s : encodeURIComponent(s);
		}
	
		function decode(s) {
			return api.raw ? s : decodeURIComponent(s);
		}
	
		function stringifyCookieValue(value) {
			return encode(api.json ? JSON.stringify(value) : String(value));
		}
	
		function parseCookieValue(s) {
			if (s.indexOf('"') === 0) {
				// This is a quoted cookie as according to RFC2068, unescape...
				s = s.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, '\\');
			}
	
			try {
				// Replace server-side written pluses with spaces.
				// If we can't decode the cookie, ignore it, it's unusable.
				// If we can't parse the cookie, ignore it, it's unusable.
				s = decodeURIComponent(s.replace(pluses, ' '));
				return api.json ? JSON.parse(s) : s;
			} catch(e) {}
		}
	
		function read(s, converter) {
			var value = api.raw ? s : parseCookieValue(s);
			return isFunction(converter) ? converter(value) : value;
		}
	
		function extend() {
			var key, options;
			var i = 0;
			var result = {};
			for (; i < arguments.length; i++) {
				options = arguments[ i ];
				for (key in options) {
					result[key] = options[key];
				}
			}
			return result;
		}
	
		function isFunction(obj) {
			return Object.prototype.toString.call(obj) === '[object Function]';
		}
	
		var api = function (key, value, options) {
	
			// Write
	
			if (arguments.length > 1 && !isFunction(value)) {
				options = extend(api.defaults, options);
	
				if (typeof options.expires === 'number') {
					var days = options.expires, t = options.expires = new Date();
					t.setMilliseconds(t.getMilliseconds() + days * 864e+5);
				}
	
				return (document.cookie = [
					encode(key), '=', stringifyCookieValue(value),
					options.expires ? '; expires=' + options.expires.toUTCString() : '', // use expires attribute, max-age is not supported by IE
					options.path    ? '; path=' + options.path : '',
					options.domain  ? '; domain=' + options.domain : '',
					options.secure  ? '; secure' : ''
				].join(''));
			}
	
			// Read
	
			var result = key ? undefined : {},
				// To prevent the for loop in the first place assign an empty array
				// in case there are no cookies at all. Also prevents odd result when
				// calling "get()".
				cookies = document.cookie ? document.cookie.split('; ') : [],
				i = 0,
				l = cookies.length;
	
			for (; i < l; i++) {
				var parts = cookies[i].split('='),
					name = decode(parts.shift()),
					cookie = parts.join('=');
	
				if (key === name) {
					// If second argument (value) is a function it's a converter...
					result = read(cookie, value);
					break;
				}
	
				// Prevent storing a cookie that we couldn't decode.
				if (!key && (cookie = read(cookie)) !== undefined) {
					result[name] = cookie;
				}
			}
	
			return result;
		};
	
		api.get = api.set = api;
		api.defaults = {};
	
		api.remove = function (key, options) {
			// Must not alter options, thus extending a fresh object...
			api(key, '', extend(options, { expires: -1 }));
			return !api(key);
		};
	
		if ( $ ) {
			$.cookie = api;
			$.removeCookie = api.remove;
		}
	
		return api;
	}));


/***/ },
/* 453 */
/***/ function(module, exports) {

	/*global Backbone, $, _, ofs, moment */
	'use strict';
	
	var DesktopHeaderTabView = Backbone.View.extend({
	  el: '#header',
	  events: {
	    'click .nav.desktop a': 'highlightTab'
	  },
	  searchPanelHeight: 0,
	  servicePanelHeight: 0,
	  accountPanelHeight: 0,
	  transitionDuration: 400,
	  initialize: function initialize(options) {
	    this.flux = options.flux;
	
	    this.$el.find('#id-region').select2({ minimumResultsForSearch: 99 });
	    this.$el.find('#id-sleeps').select2({ minimumResultsForSearch: 99 });
	
	    var isTouchDevice = ('ontouchstart' in document.documentElement);
	    if (isTouchDevice) {
	      this.transitionDuration = 0;
	    }
	
	    // Grab heights of all .header panels
	    var panelWrap = this.$el.find('.panel-wrap');
	    panelWrap.css({ 'height': '0px', 'overflow': 'hidden' });
	    panelWrap.find('.panel').show();
	
	    this.showSearch = false;
	    if ($('.header .search-form').hasClass('homepage-functionality')) {
	      this.showSearch = true;
	    }
	
	    this.searchPanelHeight = panelWrap.find('.search').outerHeight();
	    this.servicePanelHeight = panelWrap.find('.service').outerHeight();
	    this.accountPanelHeight = panelWrap.find('.account').outerHeight();
	
	    panelWrap.css({ 'height': 'auto', 'overflow': 'visible' });
	    panelWrap.find('.panel').hide();
	
	    // IE8 bug: any element resize triggers $(window).resize... so do not bind
	    // stackoverflow.com/questions/1852751/window-resize-event-firing-in-internet-explorer
	    if (!$('html').hasClass('lt-ie9')) {
	      var panelRemoveCheck = _.debounce(this.panelRemove, 300);
	      $(window).resize(panelRemoveCheck);
	    }
	  },
	  highlightTab: function highlightTab(event) {
	    this.undelegateEvents();
	    var navItem = this.$el.find('.nav-item');
	    var clickedTab = $(event.currentTarget).parent('.nav-item');
	
	    if (clickedTab.hasClass('active')) {
	      clickedTab.removeClass('active');
	    } else {
	      navItem.removeClass('active');
	      clickedTab.addClass('active');
	    }
	
	    this.switchPanel(clickedTab);
	  },
	  switchPanel: function switchPanel(clickedTab) {
	    var self = this;
	    var searchForm = this.$el.find('.search-form');
	
	    // Selects the panel corresponding to the tab the user clicked on
	    var panel = this.targetPanel(clickedTab);
	
	    var correctHeight;
	
	    if (panel.hasClass('active')) {
	      // Close panel; selected panel already open
	      this.$el.find('.panel.active').removeClass('active').transition({
	        height: 0,
	        duration: this.transitionDuration
	      }, function () {
	        this.css({ 'display': 'none' });
	        self.delegateEvents();
	      });
	
	      if (this.showSearch) {
	        if (panel.hasClass('search') && searchForm.css('opacity') === 0) {
	          searchForm.css({ 'display': 'block', 'opacity': 0 }).transition({ opacity: 1, duration: this.transitionDuration });
	        } else if (!panel.hasClass('search')) {
	          searchForm.css({ 'display': 'block', 'opacity': 0 }).transition({ opacity: 1, duration: this.transitionDuration });
	        }
	      } else {
	        searchForm.transition({ opacity: 0, duration: self.transitionDuration }, function () {
	          this.css({ 'display': 'none' });
	          self.delegateEvents();
	        });
	      }
	    } else if (this.$el.find('.panel').hasClass('active')) {
	      // Hide previous panel, open new panel
	      var currentPanelHeight = this.$el.find('.panel.active').outerHeight();
	
	      if (clickedTab.hasClass('search')) {
	        correctHeight = this.searchPanelHeight;
	      } else if (clickedTab.hasClass('service')) {
	        correctHeight = this.servicePanelHeight;
	      } else if (clickedTab.hasClass('account')) {
	        correctHeight = this.accountPanelHeight;
	      }
	
	      panel.css({ 'height': currentPanelHeight + 'px' });
	
	      this.$el.find('.panel.active .row').transition({
	        opacity: 0,
	        duration: this.transitionDuration
	      }, function () {
	        self.$el.find('.panel.active').hide().removeClass('active');
	        panel.show().addClass('active');
	
	        panel.transition({
	          height: correctHeight,
	          duration: self.transitionDuration
	        }, function () {
	          this.find('.row').transition({ opacity: 1, duration: self.transitionDuration });
	        });
	
	        if (panel.hasClass('search')) {
	          searchForm.css({ 'display': 'block', 'opacity': 0 }).transition({ opacity: 1, duration: self.transitionDuration });
	          self.delegateEvents();
	        } else {
	          searchForm.transition({
	            opacity: 0, duration: self.transitionDuration
	          }, function () {
	            this.css({ 'display': 'none' });
	            self.delegateEvents();
	          });
	        }
	      });
	    } else {
	      // Open panel; no panels open currently
	      if (clickedTab.hasClass('search')) {
	        correctHeight = this.searchPanelHeight;
	      } else if (clickedTab.hasClass('service')) {
	        correctHeight = this.servicePanelHeight;
	      } else if (clickedTab.hasClass('account')) {
	        correctHeight = this.accountPanelHeight;
	      }
	
	      panel.find('.row').css({ 'opacity': 1 });
	      panel.addClass('active').css({ 'display': 'block', 'height': 0 }).transition({ height: correctHeight, duration: this.transitionDuration }, function () {
	        self.delegateEvents();
	      });
	
	      if (panel.hasClass('search') && searchForm.is(':visible')) {
	        // do nothing, as searchForm is already visible
	      } else if (panel.hasClass('search') && !searchForm.is(':visible')) {
	          searchForm.css({ 'display': 'block', 'opacity': 0 }).transition({ opacity: 1, duration: this.transitionDuration });
	        } else {
	          searchForm.transition({ opacity: 0, duration: this.transitionDuration }, function () {
	            this.css({ 'display': 'none', 'height': currentPanelHeight });
	          });
	        }
	    }
	  },
	  targetPanel: function targetPanel(clickedTab) {
	    if (clickedTab.hasClass('search')) {
	      return this.$el.find('.search.panel');
	    } else if (clickedTab.hasClass('service')) {
	      return this.$el.find('.service.panel');
	    } else if (clickedTab.hasClass('account')) {
	      return this.$el.find('.account.panel');
	    }
	  },
	  panelRemove: function panelRemove() {
	    var activePanel = $('.panel.active');
	    var activeNavItem = $('.nav-item.active');
	    var searchForm = $('#header .search-form');
	
	    if ($(window).width() < 600) {
	      activePanel.removeClass('active').slideUp();
	      activeNavItem.removeClass('active');
	      searchForm.transition({ opacity: 0, duration: this.transitionDuration }, function () {
	        this.css({ 'display': 'none' });
	      });
	    } else if ($(window).width() < 1000 && $(window).width() > 600) {
	      activePanel.removeClass('active').slideUp();
	      activeNavItem.removeClass('active');
	      if (searchForm.hasClass('homepage-functionality')) {
	        searchForm.css({ 'display': 'block', 'opacity': 0 }).transition({ opacity: 1, duration: this.transitionDuration });
	      } else {
	        searchForm.transition({ opacity: 0, duration: this.transitionDuration }, function () {
	          this.css({ 'display': 'none' });
	        });
	      }
	    } else if ($(window).width() > 1000) {
	      activePanel.removeClass('active').slideUp();
	      activeNavItem.removeClass('active');
	      if (searchForm.hasClass('homepage-functionality')) {
	        searchForm.css({ 'display': 'block', 'opacity': 0 }).transition({ opacity: 1, duration: this.transitionDuration });
	      } else {
	        searchForm.transition({ opacity: 0, duration: this.transitionDuration }, function () {
	          this.css({ 'display': 'none' });
	        });
	      }
	    }
	  }
	});
	
	var MobileHeaderTabView = Backbone.View.extend({
	  el: '#container',
	  htmlBody: $('body'),
	  initWindowWidth: 0,
	  events: {
	    'click .burger a': 'toggleFlyout',
	    'click .contact a': 'togglePanel',
	    'click .select-list': 'toggleSearch'
	  },
	  initialize: function initialize(options) {
	    this.flux = options.flux;
	
	    var self = this;
	    this.initWindowWidth = $(window).width();
	    var hideFlyoutCheck = _.debounce(function () {
	      if (self.initWindowWidth !== $(window).width() && self.$el.hasClass('visible')) {
	        self.hideFlyout();
	      }
	    }, 300);
	    $(window).resize(hideFlyoutCheck);
	  },
	  toggleFlyout: function toggleFlyout() {
	    // Prevent iPad flicker; too hacky?
	    $('.flyout').show();
	
	    this.$el.find('.burger').addClass('active');
	    this.$el.css({ 'width': this.$el.width() });
	
	    if (this.$el.hasClass('visible')) {
	      this.hideFlyout();
	    } else {
	      this.showFlyout();
	    }
	  },
	  showFlyout: function showFlyout() {
	    var self = this;
	    this.$el.addClass('visible').transition({ x: '260px' }, function () {
	      self.htmlBody.css({ 'position': 'fixed' });
	    });
	  },
	  hideFlyout: function hideFlyout() {
	    this.$el.find('.burger').removeClass('active');
	
	    var self = this;
	    this.$el.removeClass('visible').transition({ x: '0' }, function () {
	      self.resetContainerWidth();
	      self.htmlBody.css({ 'position': 'static' });
	      $('.flyout').hide();
	    });
	  },
	  windowWidthCheck: function windowWidthCheck() {
	    if ($(window).width() > 1000 && this.$el.hasClass('visible')) {
	      this.hideFlyout();
	    }
	  },
	  resetContainerWidth: function resetContainerWidth() {
	    // -webkit-transform is removed as it affects position: fixed;
	    this.$el.css({ 'width': '100%', '-webkit-transform': '' });
	  },
	
	  togglePanel: function togglePanel() {
	    if (this.$el.find('.header .search-form').hasClass('active')) {
	      this.$el.find('.header .search-form').removeClass('active').hide();
	    }
	
	    var panel = this.$el.find('.panel.contact');
	
	    if (panel.hasClass('active')) {
	      this.hidePanel(panel);
	    } else {
	      this.showPanel(panel);
	    }
	  },
	  showPanel: function showPanel(panel) {
	    this.$el.find('.nav-item.phone').addClass('active');
	    panel.addClass('active').show();
	  },
	  hidePanel: function hidePanel(panel) {
	    this.$el.find('.nav-item.phone').removeClass('active');
	    panel.removeClass('active').hide();
	  },
	  toggleSearch: function toggleSearch() {
	    var panel = this.$el.find('.panel.contact');
	    if (panel.hasClass('active')) {
	      this.hidePanel(panel);
	    }
	
	    var searchPanel = this.$el.find('.header .search-form');
	    if (searchPanel.hasClass('active')) {
	      this.$el.find('#header .search-form').removeClass('active').hide();
	    } else {
	      this.$el.find('#header .search-form').addClass('active').css({ 'opacity': 1 }).show();
	    }
	  }
	});
	
	var QuickSearchFormView = Backbone.View.extend({
	  el: '#header .search-form',
	  events: {
	    'change #header-quicksearch_start_date': 'updateDepartureDate',
	    'change #header-quicksearch_end_date': 'shouldUpdateDateStore',
	    'change #header-quicksearch_sleeps': 'updateGuestStore'
	  },
	  initialize: function initialize(options) {
	    this.flux = options.flux;
	
	    var startDate = this.flux.stores.DateStore.getFormattedStartDate();
	    var endDate = this.flux.stores.DateStore.getFormattedEndDate();
	    var guests = this.flux.stores.GuestStore.getNumberOfGuests();
	    this.$el.find('#header-quicksearch_start_date').val(startDate);
	    this.$el.find('#header-quicksearch_end_date').val(endDate);
	    var pikadayArray = ofs.components.pikadayElements;
	    for (var i = 0; i < pikadayArray.length; i++) {
	      if (pikadayArray[i]._o.field.id === 'header-quicksearch_start_date') {
	        pikadayArray[i].setDate(startDate, false);
	      } else if (pikadayArray[i]._o.field.id === 'header-quicksearch_end_date') {
	        pikadayArray[i].setDate(endDate, false);
	      }
	    }
	    this.$el.find('#header-quicksearch_sleeps').val(guests).trigger("change");
	  },
	
	  updateDepartureDate: function updateDepartureDate() {
	    var startDate;
	    var pikadayArray = ofs.components.pikadayElements;
	    for (var i = 0; i < pikadayArray.length; i++) {
	      if (pikadayArray[i]._o.field.id === 'header-quicksearch_start_date') {
	        startDate = pikadayArray[i].getDate();
	      }
	    }
	
	    for (var j = 0; j < pikadayArray.length; j++) {
	      if (pikadayArray[j]._o.field.id === 'header-quicksearch_end_date') {
	        pikadayArray[j].gotoDate(startDate);
	        var endDate = pikadayArray[j].getDate();
	        this.updateDateStore(startDate, endDate);
	      }
	    }
	  },
	
	  updateDateStore: function updateDateStore(startDate, endDate) {
	    if (startDate !== null && endDate !== null) {
	      var daterange = moment().range(moment(startDate), moment(endDate));
	      this.flux.actions.calendar.completeRangeSelection(daterange, null);
	    }
	  },
	
	  shouldUpdateDateStore: function shouldUpdateDateStore(event) {
	    var pikadayArray = ofs.components.pikadayElements;
	    var startDate = null;
	    var endDate = null;
	    for (var i = 0; i < pikadayArray.length; i++) {
	      if (pikadayArray[i]._o.field.id === 'header-quicksearch_start_date') {
	        startDate = pikadayArray[i].getDate();
	      } else if (pikadayArray[i]._o.field.id === 'header-quicksearch_end_date') {
	        endDate = pikadayArray[i].getDate();
	      }
	    }
	
	    this.updateDateStore(startDate, endDate);
	  },
	
	  updateGuestStore: function updateGuestStore(event) {
	    this.flux.actions.guest.updateGuestNumber(event.target.value);
	  }
	});
	
	var isoSearchForm = function isoSearchForm() {
	  $('.search-form form').submit(function (event) {
	    $(event.target).find('input[data-ofs-component="datepicker"]').each(function (index, input) {
	      var date = $(input).data('picker').getMoment();
	      if (date) {
	        $(input).val(date.format("YYYY-MM-DD"));
	      }
	    });
	  });
	};
	
	module.exports = function (flux) {
	  new DesktopHeaderTabView({ flux: flux });
	  new MobileHeaderTabView({ flux: flux });
	  new QuickSearchFormView({ flux: flux });
	  isoSearchForm();
	};

/***/ },
/* 454 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var i18n = __webpack_require__(61);
	var gettext = i18n.gettext;
	
	var React = __webpack_require__(40);
	var Fluxxor = __webpack_require__(69);
	var FluxMixin = Fluxxor.FluxMixin(React);
	
	var messages = {
	  ACCEPT_BUTTON: gettext("I understand"),
	  WARNING_HEADER: gettext("Hello. (Thanks for visiting). onefinestay.com is being translated"),
	  WARNING_BODY: gettext("While we're translating onefinestay.com into French some parts of the site will be in English only. Something you need to know right away? Talk to our French-speaking reservations team on +44 20 7167 2545. We're here from 8am-10pm GMT.")
	};
	
	var SetEnglishLink = React.createClass({
	  displayName: 'SetEnglishLink',
	
	  mixins: [FluxMixin],
	
	  getStateFromFlux: function getStateFromFlux() {
	    return this.getFlux().store('LanguageStore').getState();
	  },
	
	  setEnglish: function setEnglish() {
	    this.getFlux().actions.language.setLanguage('en');
	    this.getFlux().actions.tracking.sendGenericEvent({
	      category: 'setLanguage',
	      action: 'en'
	    });
	  },
	
	  render: function render() {
	    return React.createElement(
	      'a',
	      { href: 'javascript:void(0)', className: 'ofs-Link', onClick: this.setEnglish },
	      'Show me the site in English'
	    ) // jshint ignore:line
	    ;
	  }
	});
	
	var AcceptWarningButton = React.createClass({
	  displayName: 'AcceptWarningButton',
	
	  mixins: [FluxMixin],
	
	  getStateFromFlux: function getStateFromFlux() {
	    return this.getFlux().store('LanguageStore').getState();
	  },
	
	  acceptWarning: function acceptWarning() {
	    this.getFlux().actions.language.acceptLanguageWarning();
	  },
	
	  render: function render() {
	    return React.createElement(
	      'button',
	      { className: 'ofs-Button ofs-Button--small', onClick: this.acceptWarning },
	      messages.ACCEPT_BUTTON
	    );
	  }
	});
	
	var WarningMessage = React.createClass({
	  displayName: 'WarningMessage',
	
	  mixins: [FluxMixin],
	
	  getStateFromFlux: function getStateFromFlux() {
	    var flux = this.getFlux();
	    return flux.store('LanguageStore').getState();
	  },
	
	  render: function render() {
	    return React.createElement(
	      'div',
	      { className: 'ofs-LanguageWarning -theme--dark' },
	      React.createElement(
	        'div',
	        { className: 'ofs-Container' },
	        React.createElement(
	          'div',
	          { className: 'ofs-Container__Content' },
	          React.createElement(
	            'div',
	            { className: 'ofs-Row' },
	            React.createElement(
	              'div',
	              { className: 'ofs-LanguageWarning__Message ofs-Row__Column ofs-Row__Column--two-thirds ofs-Row__Column--small-two-thirds' },
	              React.createElement(
	                'h4',
	                null,
	                messages.WARNING_HEADER
	              ),
	              React.createElement(
	                'p',
	                null,
	                messages.WARNING_BODY
	              )
	            ),
	            React.createElement(
	              'div',
	              { className: 'ofs-LanguageWarning__Actions ofs-Row__Column ofs-Row__Column--third ofs-Row__Column--small-thirds' },
	              React.createElement(AcceptWarningButton, null),
	              React.createElement('br', null),
	              React.createElement(SetEnglishLink, null)
	            )
	          )
	        )
	      )
	    );
	  }
	});
	
	var LanguageWarning = React.createClass({
	  displayName: 'LanguageWarning',
	
	  mixins: [Fluxxor.StoreWatchMixin("LanguageStore"), FluxMixin],
	
	  getStateFromFlux: function getStateFromFlux() {
	    var flux = this.getFlux();
	    return flux.store('LanguageStore').getState();
	  },
	
	  render: function render() {
	    return this.state.acceptedWarning || this.state.complete ? null : React.createElement(WarningMessage, null);
	  }
	});
	
	module.exports = LanguageWarning;

/***/ },
/* 455 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var Constants = __webpack_require__(336);
	var Gallery = __webpack_require__(332);
	
	var BaseActions = {
	  resize: function resize(event) {
	    this.dispatch(Constants.RESIZED, { event: event });
	  },
	
	  scroll: function scroll(event) {
	    this.dispatch(Constants.SCROLLED, { event: event });
	  },
	
	  click: function click(event) {
	    this.dispatch(Constants.CLICKED, { event: event });
	  },
	
	  // React-form Changes
	  formFieldChange: function formFieldChange(name, value, context) {
	    this.dispatch(Constants.FORM_FIELD_CHANGED, { name: name, value: value, context: context });
	  },
	
	  updateCityData: function updateCityData(data) {
	    this.dispatch(Constants.CITY_UPDATE, { data: data });
	  },
	
	  updatePriceData: function updatePriceData(data) {
	    this.dispatch(Constants.PRICE_UPDATE, { data: data });
	  },
	
	  changeActiveFieldset: function changeActiveFieldset(index, context) {
	    this.dispatch(Constants.CHANGE_ACTIVE_FIELDSET, { index: index, context: context });
	  },
	
	  changeContextCity: function changeContextCity(cityCode) {
	    this.dispatch(Constants.CHANGE_CONTEXT_CITY, { cityCode: cityCode });
	  },
	
	  changeBudget: function changeBudget(budgetMax) {
	    this.dispatch(Constants.CHANGE_GUEST_BUDGET, budgetMax);
	  },
	
	  onboarding: {
	    introduction: {
	      formSubmit: function formSubmit(payload) {
	        this.dispatch(Constants.FORM_SUBMIT, payload);
	      },
	      resetRequestError: function resetRequestError() {
	        this.dispatch(Constants.RESET_REQUEST_ERROR);
	      }
	    }
	  },
	
	  quote: {
	    update: function update(data) {
	      this.dispatch(Constants.BOOKING_QUOTE_UPDATE, { data: data });
	    },
	
	    error: function error(response) {
	      var data = JSON.parse(response.responseText);
	      this.dispatch(Constants.BOOKING_QUOTE_ERROR, { data: data });
	    }
	  },
	
	  // Availability Calendar
	  calendar: {
	    completeRangeSelection: function completeRangeSelection(range, states) {
	      this.dispatch(Constants.COMPLETE_CALENDAR_RANGE_SELECTION, { range: range, states: states });
	      this.dispatch(Constants.CHANGE_PAGE_DATE_RANGE, { range: range });
	    },
	
	    legacyCompleteRangeSelection: function legacyCompleteRangeSelection(range) {
	      this.dispatch(Constants.CHANGE_PAGE_DATE_RANGE, { range: range });
	    }
	
	  },
	
	  guest: {
	    updateGuestNumber: function updateGuestNumber(numberOfGuests) {
	      this.dispatch(Constants.CHANGE_GUEST_NUMBER, numberOfGuests);
	    }
	  },
	
	  // Rooms Widget
	  rooms: {
	    changeActive: function changeActive(index_, context) {
	      var index = parseInt(index_, 10);
	      this.dispatch(Constants.CHANGE_ACTIVE_ROOM, { index: index, context: context });
	    }
	  },
	
	  // Media Organiser
	  mediaOrganiser: {
	    changeActive: function changeActive(uuid) {
	      this.dispatch(Constants.CHANGE_ACTIVE_CONTAINER, { uuid: uuid });
	    },
	    selectMedia: function selectMedia(mediaID) {
	      this.dispatch(Constants.SELECT_MEDIA, { mediaID: mediaID });
	    },
	    unselectMedia: function unselectMedia(mediaID) {
	      this.dispatch(Constants.UNSELECT_MEDIA, { mediaID: mediaID });
	    },
	    assignMedia: function assignMedia(container, media) {
	      this.dispatch(Constants.ASSIGN_MEDIA, { container: container, media: media });
	    },
	    unAssignMedia: function unAssignMedia(container, media) {
	      this.dispatch(Constants.UNASSIGN_MEDIA, { container: container, media: media });
	    },
	    dragMediaStart: function dragMediaStart(media, x, y) {
	      this.dispatch(Constants.DRAG_MEDIA_START, { media: media, x: x, y: y });
	    },
	    dragMediaOver: function dragMediaOver(media, x, y) {
	      this.dispatch(Constants.DRAG_MEDIA_OVER, { media: media, x: x, y: y });
	    },
	    dragMediaEnd: function dragMediaEnd(media) {
	      this.dispatch(Constants.DRAG_MEDIA_END, { media: media });
	    }
	  },
	
	  // Modal
	  modal: {
	    open: function open(renderFunction) {
	      this.dispatch(Constants.OPEN_MODAL, { renderFunction: renderFunction });
	    },
	
	    close: function close() {
	      this.dispatch(Constants.CLOSE_MODAL, {});
	    }
	  },
	
	  layers: {
	    addModal: function addModal(component, modalStyle) {
	      this.dispatch(Constants.ADD_MODAL, { component: component, modalStyle: modalStyle });
	    },
	
	    addPopover: function addPopover(component) {
	      this.dispatch(Constants.ADD_POPOVER, { component: component });
	    },
	
	    addTooltip: function addTooltip(component) {
	      this.dispatch(Constants.ADD_TOOLTIP, { component: component });
	    },
	
	    remove: function remove(component) {
	      this.dispatch(Constants.REMOVE_LAYER, { component: component });
	    }
	  },
	
	  tracking: {
	    sendEnquiryEvent: function sendEnquiryEvent(payload) {
	      this.dispatch(Constants.PUSH_ENQUIRY_EVENT, payload);
	    },
	    sendGenericEvent: function sendGenericEvent(payload) {
	      this.dispatch(Constants.PUSH_GENERIC_EVENT, payload);
	    },
	    trackFormSubmit: function trackFormSubmit(label) {
	      this.dispatch(Constants.PUSH_FORM_SUBMIT, label);
	    }
	  },
	
	  // Image Gallery
	  gallery: {
	    open: function open(image) {
	      this.dispatch(Constants.CHANGE_ACTIVE_GALLERY_IMAGE, { image: image });
	      this.dispatch(Constants.ADD_LAYER, { component: Gallery, isModal: true });
	    },
	
	    changeActive: function changeActive(index_, context) {
	      var index = parseInt(index_, 10);
	      this.dispatch(Constants.CHANGE_ACTIVE_GALLERY_IMAGE, { index: index, context: context });
	    },
	
	    showHeader: function showHeader() {
	      this.dispatch(Constants.SHOW_GALLERY_HEADER, {});
	    },
	
	    hideHeader: function hideHeader() {
	      this.dispatch(Constants.HIDE_GALLERY_HEADER, {});
	    }
	  },
	
	  // Similar Homes
	  similarHomes: {
	    load: function load() {
	      this.dispatch(Constants.SIMILAR_HOMES_LOAD, {});
	    },
	
	    update: function update(json) {
	      this.dispatch(Constants.SIMILAR_HOMES_UPDATE, { json: json });
	    }
	  },
	
	  // Text Truncator Componets
	  expandText: function expandText(data) {
	    this.dispatch(Constants.TEXT_EXPANDED, { data: data });
	  },
	
	  contentModules: {
	    addModule: function addModule(layout, index) {
	      this.dispatch(Constants.CONTENT_MODULE_ADD, { layout: layout, index: index });
	    },
	
	    removeModule: function removeModule(index) {
	      this.dispatch(Constants.CONTENT_MODULE_REMOVE, { index: index });
	    },
	
	    replaceModules: function replaceModules(modules) {
	      this.dispatch(Constants.CONTENT_MODULES_REPLACE, { modules: modules });
	    },
	
	    changeValue: function changeValue(index, name, value) {
	      this.dispatch(Constants.CONTENT_MODULE_CHANGE_VALUE, { index: index, name: name, value: value });
	    }
	  },
	
	  language: {
	    acceptLanguageWarning: function acceptLanguageWarning() {
	      this.dispatch(Constants.ACCEPT_LANGUAGE_WARNING, {});
	    },
	    setLanguage: function setLanguage(lang) {
	      this.dispatch(Constants.SET_LANGUAGE, { lang: lang });
	    }
	  },
	
	  // use odd name because `scroll` already exists
	  scrollManager: {
	    to: function to(payload) {
	      this.dispatch(Constants.SCROLL_TO, payload);
	    }
	  }
	};
	
	module.exports = BaseActions;

/***/ },
/* 456 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var React = __webpack_require__(40);
	var Fluxxor = __webpack_require__(69);
	var _ = __webpack_require__(66);
	
	var moment = __webpack_require__(57);
	
	var DateStore = Fluxxor.createStore({
	  actions: {
	    CHANGE_PAGE_DATE_RANGE: 'onDateRangeChange'
	  },
	
	  initialize: function initialize(options) {
	    this.setMaxListeners(0);
	    this.state = _.clone(options);
	    if (this.state.startDate) {
	      this.state.startDate = moment(this.state.startDate);
	    }
	    if (this.state.endDate) {
	      this.state.endDate = moment(this.state.endDate);
	    }
	    if (this.state.startDate && this.state.endDate) {
	      this.state.range = moment().range(this.state.startDate, this.state.endDate);
	    }
	  },
	
	  onDateRangeChange: function onDateRangeChange(payload) {
	    var range = payload.range;
	
	    this.state = React.addons.update(this.state, {
	      range: { $set: range },
	      startDate: { $set: range.start },
	      endDate: { $set: range.end }
	    });
	    this.emit('change');
	  },
	
	  getState: function getState() {
	    return this.state;
	  },
	
	  getFormattedStartDate: function getFormattedStartDate() {
	    if (this.state.range) {
	      return this.state.range.start.format('D MMMM YYYY');
	    }
	    return null;
	  },
	
	  getFormattedEndDate: function getFormattedEndDate() {
	    if (this.state.range) {
	      return this.state.range.end.format('D MMMM YYYY');
	    }
	    return null;
	  },
	
	  getISO8601StartDate: function getISO8601StartDate() {
	    if (this.state.range) {
	      return this.state.range.start.format('YYYY-MM-DD');
	    }
	    return null;
	  },
	
	  getISO8601EndDate: function getISO8601EndDate() {
	    if (this.state.range) {
	      return this.state.range.end.format('YYYY-MM-DD');
	    }
	    return null;
	  }
	});
	
	module.exports = DateStore;

/***/ },
/* 457 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _fluxxor = __webpack_require__(69);
	
	var _fluxxor2 = _interopRequireDefault(_fluxxor);
	
	var _immutable = __webpack_require__(68);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _ofsMoment = __webpack_require__(57);
	
	var _ofsMoment2 = _interopRequireDefault(_ofsMoment);
	
	var _ofsAppsCoreConstants = __webpack_require__(336);
	
	var _ofsAppsCoreConstants2 = _interopRequireDefault(_ofsAppsCoreConstants);
	
	var _ofsPayload = __webpack_require__(355);
	
	var USER = _immutable2['default'].fromJS(_ofsPayload.user);
	
	var EnquiryStore = _fluxxor2['default'].createStore({
	  initialize: function initialize(options) {
	    this.bindActions(_ofsAppsCoreConstants2['default'].CHANGE_CONTEXT_CITY, this.onCityChange, _ofsAppsCoreConstants2['default'].CHANGE_PAGE_DATE_RANGE, this.onDateRangeChange, 'SEARCH_UPDATE_FILTERS_SUCCESS', this.onCurrencyChange);
	    this.setMaxListeners(0);
	    if (options.get('startDate')) {
	      options = options.set('startDate', (0, _ofsMoment2['default'])(options.get('startDate')).toDate());
	    }
	    if (options.get('endDate')) {
	      options = options.set('endDate', (0, _ofsMoment2['default'])(options.get('endDate')).toDate());
	    }
	    this.state = options;
	  },
	
	  onCityChange: function onCityChange(payload) {
	    this.state = this.state.set('cityCode', payload.cityCode);
	    this.emit('change');
	  },
	
	  onDateRangeChange: function onDateRangeChange(payload) {
	    this.state = this.state.set('startDate', payload.range.start.toDate()).set('endDate', payload.range.end.toDate());
	    this.emit('change');
	  },
	
	  onCurrencyChange: function onCurrencyChange(payload) {
	    var filters = payload.filters;
	    var priceFilters = payload.priceFilters;
	
	    this.state = this.state.set('currency', filters.currency ? filters.currency['iso_4217'] : USER.getIn(['currency', 'iso_4217'])).set('budgetMax', filters['price_max']);
	    this.emit('change');
	  }
	
	});
	
	exports['default'] = EnquiryStore;
	module.exports = exports['default'];

/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var React = __webpack_require__(40);
	var Fluxxor = __webpack_require__(69);
	var _ = __webpack_require__(66);
	
	var GuestStore = Fluxxor.createStore({
	  actions: {
	    CHANGE_GUEST_NUMBER: 'onGuestNumberChange'
	  },
	
	  initialize: function initialize(options) {
	    this.setMaxListeners(0);
	    this.state = _.clone(options);
	  },
	
	  onGuestNumberChange: function onGuestNumberChange(payload) {
	    this.state = React.addons.update(this.state, {
	      numberOfGuests: { $set: payload }
	    });
	
	    this.emit('change');
	  },
	
	  getState: function getState() {
	    return this.state;
	  },
	
	  getNumberOfGuests: function getNumberOfGuests() {
	    return this.state.numberOfGuests || 1;
	  }
	});
	
	module.exports = GuestStore;

/***/ },
/* 459 */
/***/ function(module, exports, __webpack_require__) {

	/* global ga */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	var _utilsTrackingOptimizely = __webpack_require__(46);
	
	var _utilsTrackingOptimizely2 = _interopRequireDefault(_utilsTrackingOptimizely);
	
	var Fluxxor = __webpack_require__(69);
	var _ = __webpack_require__(66);
	
	var convertro = __webpack_require__(460);
	var adobe = __webpack_require__(461);
	var adwords = __webpack_require__(462);
	var bingGoal16 = __webpack_require__(467);
	var facebook = __webpack_require__(468);
	
	var TrackingStore = Fluxxor.createStore({
	  actions: {
	    PUSH_ENQUIRY_EVENT: 'sendEnquiryEvent',
	    PUSH_GENERIC_EVENT: 'sendGenericEvent',
	    PUSH_FORM_SUBMIT: 'sendFormSubmit'
	  },
	
	  initialize: function initialize() {
	    this.setMaxListeners(0);
	    this.state = [];
	  },
	
	  sendFormSubmit: function sendFormSubmit(label) {
	    (0, _utilsTrackingOptimizely2['default'])(label);
	    this.sendGenericEvent({
	      action: 'submitted',
	      label: label
	    });
	  },
	
	  sendGenericEvent: function sendGenericEvent(payload) {
	    var event = {
	      'hitType': 'event', // Required.
	      'eventCategory': payload.category, // Required.
	      'eventAction': payload.action // Required.
	    };
	
	    if (payload.label) {
	      event.eventLabel = payload.label;
	    }
	
	    if (payload.value && payload.value % 1 === 0 && payload.value >= 0) {
	      event.eventValue = payload.value;
	    }
	
	    if (payload.nonInteraction) {
	      event.nonInteraction = 1;
	    }
	
	    ga('send', event);
	  },
	
	  sendEnquiryEvent: function sendEnquiryEvent(payload) {
	
	    var ga = window.ga;
	    var source = payload.source;
	    var url = window.location.origin + window.location.pathname;
	    ga('send', 'event', 'Enquiry', source, url);
	
	    convertro(payload.eventType);
	    adobe(payload.source);
	    adwords(payload.source);
	    bingGoal16('Enquiry', payload.source, url);
	    facebook('6023373046219', '0.00', 'GBP');
	    (0, _utilsTrackingOptimizely2['default'])(payload.source);
	  },
	
	  getState: function getState() {
	    return this.state;
	  }
	});
	
	module.exports = TrackingStore;

/***/ },
/* 460 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var settings = __webpack_require__(62);
	
	var trackConvertro = function trackConvertro(eventType) {
	    if (settings.tracking.gactive && settings.tracking.convertroTracking) {
	        $CVO = window.$CVO || [];
	        $CVO.push(["trackEvent", {
	            type: eventType,
	            id: eventType + '-{cvoid}-{r}',
	            amount: '1'
	        }]);
	
	        if (settings.user.isAuthenticated) {
	            $CVO.push(['trackUser', {
	                id: settings.user.id
	            }]);
	        }
	    } else {
	        console.log('Convertro tracking disabled', eventType);
	    }
	};
	
	module.exports = trackConvertro;

/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var settings = __webpack_require__(62);
	
	var sourceMap = {
	    "header enquiry": "ev_Header_or_Footer_Contact",
	    "responsive enquire home availability": "ev_Home_listing_Contact",
	    "responsive ask a question": "ev_Home_listing_Contact",
	    "enquire home availability": "ev_Home_listing_Contact",
	    "enquire booking checkout": "ev_Check_Out_Footer_Contact",
	    "enquire booking": "ev_Header_or_Footer_Contact",
	    "enquire home": "ev_Home_listing_Contact",
	    "enquire home property": "ev_Home_listing_Contact",
	    "ask a question": "ev_Home_listing_Contact",
	    "search enquiry": "ev_Search_Results_Enquiry_button",
	    "footer enquiry": "ev_Header_or_Footer_Contact",
	    "payment method telephone": "ev_Check_Out_Summary_Contact"
	};
	
	var trackAdobe = function trackAdobe(source) {
	    var convertedSource = sourceMap[source] || encodeURIComponent(source);
	    if (settings.tracking.gactive && settings.tracking.adobePixelTracking) {
	        var src = "http://pixel.everesttech.net/3818/t?" + convertedSource + "=1";
	        var img = document.createElement("img");
	        img.src = src;
	        img.width = 1;
	        img.height = 1;
	        img.style.position = "absolute";
	        img.style.visibility = "hidden";
	        document.body.appendChild(img);
	    } else {
	        console.log('Adobe pixel tracking disabled', convertedSource);
	    }
	};
	
	module.exports = trackAdobe;

/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var settings = __webpack_require__(62);
	var URI = __webpack_require__(463);
	
	var data = {
	    headerFooterContactUs: {
	        'value': 15.53,
	        'label': 'huq4CJ_KgggQgeuO1gM',
	        'guid': 'ON',
	        'script': 0
	    },
	    searchResultPage: {
	        'value': 15.53,
	        'label': '8g6QCJfLgggQgeuO1gM',
	        'guid': 'ON',
	        'script': 0
	    },
	    homeListingPage: {
	        'value': 26.40,
	        'label': '_p_MCP_NgggQgeuO1gM',
	        'guid': 'ON',
	        'script': 0
	    },
	    homeListingAvailabilityEnquiry: {
	        'value': 16.00,
	        'label': 'OsQrCI_MgggQgeuO1gM',
	        'guid': 'ON',
	        'script': 0
	    },
	    checkoutPages: {
	        'value': 40.00,
	        'label': 'A0eqCIfUgwgQgeuO1gM',
	        'guid': 'ON',
	        'script': 0
	    }
	};
	
	var sourceMap = {
	    "header enquiry": data.headerFooterContactUs,
	    "responsive enquire home availability": data.homeListingPage,
	    "responsive ask a question": data.homeListingPage,
	    "enquire home availability": data.homeListingAvailabilityEnquiry,
	    "enquire booking checkout": data.checkoutPages,
	    "enquire booking": data.headerFooterContactUs,
	    "enquire home": data.homeListingPage,
	    "enquire home property": data.homeListingPage,
	    "ask a question": data.homeListingPage,
	    "search enquiry": data.searchResultPage,
	    "footer enquiry": data.headerFooterContactUs,
	    "payment method telephone": data.checkoutPages
	};
	
	var trackGoogleAdwords = function trackGoogleAdwords(source) {
	    var adwordsData = sourceMap[source];
	    if (settings.tracking.gactive && settings.tracking.googleAdwordsTracking && typeof adwordsData !== 'undefined') {
	        var src = new URI("https://www.googleadservices.com/pagead/conversion/985904513/");
	        src.search(adwordsData);
	        var img = document.createElement("img");
	        img.src = src.toString();
	        img.width = 1;
	        img.height = 1;
	        img.style.position = "absolute";
	        img.style.visibility = "hidden";
	        document.body.appendChild(img);
	    } else {
	        console.log('Google adwords pixel tracking disabled', source, adwordsData);
	    }
	};
	
	module.exports = trackGoogleAdwords;

/***/ },
/* 463 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	 * URI.js - Mutating URLs
	 *
	 * Version: 1.16.1
	 *
	 * Author: Rodney Rehm
	 * Web: http://medialize.github.io/URI.js/
	 *
	 * Licensed under
	 *   MIT License http://www.opensource.org/licenses/mit-license
	 *   GPL v3 http://opensource.org/licenses/GPL-3.0
	 *
	 */
	(function (root, factory) {
	  'use strict';
	  // https://github.com/umdjs/umd/blob/master/returnExports.js
	  if (true) {
	    // Node
	    module.exports = factory(__webpack_require__(464), __webpack_require__(465), __webpack_require__(466));
	  } else if (typeof define === 'function' && define.amd) {
	    // AMD. Register as an anonymous module.
	    define(['./punycode', './IPv6', './SecondLevelDomains'], factory);
	  } else {
	    // Browser globals (root is window)
	    root.URI = factory(root.punycode, root.IPv6, root.SecondLevelDomains, root);
	  }
	}(this, function (punycode, IPv6, SLD, root) {
	  'use strict';
	  /*global location, escape, unescape */
	  // FIXME: v2.0.0 renamce non-camelCase properties to uppercase
	  /*jshint camelcase: false */
	
	  // save current URI variable, if any
	  var _URI = root && root.URI;
	
	  function URI(url, base) {
	    var _urlSupplied = arguments.length >= 1;
	    var _baseSupplied = arguments.length >= 2;
	
	    // Allow instantiation without the 'new' keyword
	    if (!(this instanceof URI)) {
	      if (_urlSupplied) {
	        if (_baseSupplied) {
	          return new URI(url, base);
	        }
	
	        return new URI(url);
	      }
	
	      return new URI();
	    }
	
	    if (url === undefined) {
	      if (_urlSupplied) {
	        throw new TypeError('undefined is not a valid argument for URI');
	      }
	
	      if (typeof location !== 'undefined') {
	        url = location.href + '';
	      } else {
	        url = '';
	      }
	    }
	
	    this.href(url);
	
	    // resolve to base according to http://dvcs.w3.org/hg/url/raw-file/tip/Overview.html#constructor
	    if (base !== undefined) {
	      return this.absoluteTo(base);
	    }
	
	    return this;
	  }
	
	  URI.version = '1.16.1';
	
	  var p = URI.prototype;
	  var hasOwn = Object.prototype.hasOwnProperty;
	
	  function escapeRegEx(string) {
	    // https://github.com/medialize/URI.js/commit/85ac21783c11f8ccab06106dba9735a31a86924d#commitcomment-821963
	    return string.replace(/([.*+?^=!:${}()|[\]\/\\])/g, '\\$1');
	  }
	
	  function getType(value) {
	    // IE8 doesn't return [Object Undefined] but [Object Object] for undefined value
	    if (value === undefined) {
	      return 'Undefined';
	    }
	
	    return String(Object.prototype.toString.call(value)).slice(8, -1);
	  }
	
	  function isArray(obj) {
	    return getType(obj) === 'Array';
	  }
	
	  function filterArrayValues(data, value) {
	    var lookup = {};
	    var i, length;
	
	    if (getType(value) === 'RegExp') {
	      lookup = null;
	    } else if (isArray(value)) {
	      for (i = 0, length = value.length; i < length; i++) {
	        lookup[value[i]] = true;
	      }
	    } else {
	      lookup[value] = true;
	    }
	
	    for (i = 0, length = data.length; i < length; i++) {
	      /*jshint laxbreak: true */
	      var _match = lookup && lookup[data[i]] !== undefined
	        || !lookup && value.test(data[i]);
	      /*jshint laxbreak: false */
	      if (_match) {
	        data.splice(i, 1);
	        length--;
	        i--;
	      }
	    }
	
	    return data;
	  }
	
	  function arrayContains(list, value) {
	    var i, length;
	
	    // value may be string, number, array, regexp
	    if (isArray(value)) {
	      // Note: this can be optimized to O(n) (instead of current O(m * n))
	      for (i = 0, length = value.length; i < length; i++) {
	        if (!arrayContains(list, value[i])) {
	          return false;
	        }
	      }
	
	      return true;
	    }
	
	    var _type = getType(value);
	    for (i = 0, length = list.length; i < length; i++) {
	      if (_type === 'RegExp') {
	        if (typeof list[i] === 'string' && list[i].match(value)) {
	          return true;
	        }
	      } else if (list[i] === value) {
	        return true;
	      }
	    }
	
	    return false;
	  }
	
	  function arraysEqual(one, two) {
	    if (!isArray(one) || !isArray(two)) {
	      return false;
	    }
	
	    // arrays can't be equal if they have different amount of content
	    if (one.length !== two.length) {
	      return false;
	    }
	
	    one.sort();
	    two.sort();
	
	    for (var i = 0, l = one.length; i < l; i++) {
	      if (one[i] !== two[i]) {
	        return false;
	      }
	    }
	
	    return true;
	  }
	
	  URI._parts = function() {
	    return {
	      protocol: null,
	      username: null,
	      password: null,
	      hostname: null,
	      urn: null,
	      port: null,
	      path: null,
	      query: null,
	      fragment: null,
	      // state
	      duplicateQueryParameters: URI.duplicateQueryParameters,
	      escapeQuerySpace: URI.escapeQuerySpace
	    };
	  };
	  // state: allow duplicate query parameters (a=1&a=1)
	  URI.duplicateQueryParameters = false;
	  // state: replaces + with %20 (space in query strings)
	  URI.escapeQuerySpace = true;
	  // static properties
	  URI.protocol_expression = /^[a-z][a-z0-9.+-]*$/i;
	  URI.idn_expression = /[^a-z0-9\.-]/i;
	  URI.punycode_expression = /(xn--)/i;
	  // well, 333.444.555.666 matches, but it sure ain't no IPv4 - do we care?
	  URI.ip4_expression = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/;
	  // credits to Rich Brown
	  // source: http://forums.intermapper.com/viewtopic.php?p=1096#1096
	  // specification: http://www.ietf.org/rfc/rfc4291.txt
	  URI.ip6_expression = /^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$/;
	  // expression used is "gruber revised" (@gruber v2) determined to be the
	  // best solution in a regex-golf we did a couple of ages ago at
	  // * http://mathiasbynens.be/demo/url-regex
	  // * http://rodneyrehm.de/t/url-regex.html
	  URI.find_uri_expression = /\b((?:[a-z][\w-]+:(?:\/{1,3}|[a-z0-9%])|www\d{0,3}[.]|[a-z0-9.\-]+[.][a-z]{2,4}\/)(?:[^\s()<>]+|\(([^\s()<>]+|(\([^\s()<>]+\)))*\))+(?:\(([^\s()<>]+|(\([^\s()<>]+\)))*\)|[^\s`!()\[\]{};:'".,<>?«»“”‘’]))/ig;
	  URI.findUri = {
	    // valid "scheme://" or "www."
	    start: /\b(?:([a-z][a-z0-9.+-]*:\/\/)|www\.)/gi,
	    // everything up to the next whitespace
	    end: /[\s\r\n]|$/,
	    // trim trailing punctuation captured by end RegExp
	    trim: /[`!()\[\]{};:'".,<>?«»“”„‘’]+$/
	  };
	  // http://www.iana.org/assignments/uri-schemes.html
	  // http://en.wikipedia.org/wiki/List_of_TCP_and_UDP_port_numbers#Well-known_ports
	  URI.defaultPorts = {
	    http: '80',
	    https: '443',
	    ftp: '21',
	    gopher: '70',
	    ws: '80',
	    wss: '443'
	  };
	  // allowed hostname characters according to RFC 3986
	  // ALPHA DIGIT "-" "." "_" "~" "!" "$" "&" "'" "(" ")" "*" "+" "," ";" "=" %encoded
	  // I've never seen a (non-IDN) hostname other than: ALPHA DIGIT . -
	  URI.invalid_hostname_characters = /[^a-zA-Z0-9\.-]/;
	  // map DOM Elements to their URI attribute
	  URI.domAttributes = {
	    'a': 'href',
	    'blockquote': 'cite',
	    'link': 'href',
	    'base': 'href',
	    'script': 'src',
	    'form': 'action',
	    'img': 'src',
	    'area': 'href',
	    'iframe': 'src',
	    'embed': 'src',
	    'source': 'src',
	    'track': 'src',
	    'input': 'src', // but only if type="image"
	    'audio': 'src',
	    'video': 'src'
	  };
	  URI.getDomAttribute = function(node) {
	    if (!node || !node.nodeName) {
	      return undefined;
	    }
	
	    var nodeName = node.nodeName.toLowerCase();
	    // <input> should only expose src for type="image"
	    if (nodeName === 'input' && node.type !== 'image') {
	      return undefined;
	    }
	
	    return URI.domAttributes[nodeName];
	  };
	
	  function escapeForDumbFirefox36(value) {
	    // https://github.com/medialize/URI.js/issues/91
	    return escape(value);
	  }
	
	  // encoding / decoding according to RFC3986
	  function strictEncodeURIComponent(string) {
	    // see https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Global_Objects/encodeURIComponent
	    return encodeURIComponent(string)
	      .replace(/[!'()*]/g, escapeForDumbFirefox36)
	      .replace(/\*/g, '%2A');
	  }
	  URI.encode = strictEncodeURIComponent;
	  URI.decode = decodeURIComponent;
	  URI.iso8859 = function() {
	    URI.encode = escape;
	    URI.decode = unescape;
	  };
	  URI.unicode = function() {
	    URI.encode = strictEncodeURIComponent;
	    URI.decode = decodeURIComponent;
	  };
	  URI.characters = {
	    pathname: {
	      encode: {
	        // RFC3986 2.1: For consistency, URI producers and normalizers should
	        // use uppercase hexadecimal digits for all percent-encodings.
	        expression: /%(24|26|2B|2C|3B|3D|3A|40)/ig,
	        map: {
	          // -._~!'()*
	          '%24': '$',
	          '%26': '&',
	          '%2B': '+',
	          '%2C': ',',
	          '%3B': ';',
	          '%3D': '=',
	          '%3A': ':',
	          '%40': '@'
	        }
	      },
	      decode: {
	        expression: /[\/\?#]/g,
	        map: {
	          '/': '%2F',
	          '?': '%3F',
	          '#': '%23'
	        }
	      }
	    },
	    reserved: {
	      encode: {
	        // RFC3986 2.1: For consistency, URI producers and normalizers should
	        // use uppercase hexadecimal digits for all percent-encodings.
	        expression: /%(21|23|24|26|27|28|29|2A|2B|2C|2F|3A|3B|3D|3F|40|5B|5D)/ig,
	        map: {
	          // gen-delims
	          '%3A': ':',
	          '%2F': '/',
	          '%3F': '?',
	          '%23': '#',
	          '%5B': '[',
	          '%5D': ']',
	          '%40': '@',
	          // sub-delims
	          '%21': '!',
	          '%24': '$',
	          '%26': '&',
	          '%27': '\'',
	          '%28': '(',
	          '%29': ')',
	          '%2A': '*',
	          '%2B': '+',
	          '%2C': ',',
	          '%3B': ';',
	          '%3D': '='
	        }
	      }
	    },
	    urnpath: {
	      // The characters under `encode` are the characters called out by RFC 2141 as being acceptable
	      // for usage in a URN. RFC2141 also calls out "-", ".", and "_" as acceptable characters, but
	      // these aren't encoded by encodeURIComponent, so we don't have to call them out here. Also
	      // note that the colon character is not featured in the encoding map; this is because URI.js
	      // gives the colons in URNs semantic meaning as the delimiters of path segements, and so it
	      // should not appear unencoded in a segment itself.
	      // See also the note above about RFC3986 and capitalalized hex digits.
	      encode: {
	        expression: /%(21|24|27|28|29|2A|2B|2C|3B|3D|40)/ig,
	        map: {
	          '%21': '!',
	          '%24': '$',
	          '%27': '\'',
	          '%28': '(',
	          '%29': ')',
	          '%2A': '*',
	          '%2B': '+',
	          '%2C': ',',
	          '%3B': ';',
	          '%3D': '=',
	          '%40': '@'
	        }
	      },
	      // These characters are the characters called out by RFC2141 as "reserved" characters that
	      // should never appear in a URN, plus the colon character (see note above).
	      decode: {
	        expression: /[\/\?#:]/g,
	        map: {
	          '/': '%2F',
	          '?': '%3F',
	          '#': '%23',
	          ':': '%3A'
	        }
	      }
	    }
	  };
	  URI.encodeQuery = function(string, escapeQuerySpace) {
	    var escaped = URI.encode(string + '');
	    if (escapeQuerySpace === undefined) {
	      escapeQuerySpace = URI.escapeQuerySpace;
	    }
	
	    return escapeQuerySpace ? escaped.replace(/%20/g, '+') : escaped;
	  };
	  URI.decodeQuery = function(string, escapeQuerySpace) {
	    string += '';
	    if (escapeQuerySpace === undefined) {
	      escapeQuerySpace = URI.escapeQuerySpace;
	    }
	
	    try {
	      return URI.decode(escapeQuerySpace ? string.replace(/\+/g, '%20') : string);
	    } catch(e) {
	      // we're not going to mess with weird encodings,
	      // give up and return the undecoded original string
	      // see https://github.com/medialize/URI.js/issues/87
	      // see https://github.com/medialize/URI.js/issues/92
	      return string;
	    }
	  };
	  // generate encode/decode path functions
	  var _parts = {'encode':'encode', 'decode':'decode'};
	  var _part;
	  var generateAccessor = function(_group, _part) {
	    return function(string) {
	      try {
	        return URI[_part](string + '').replace(URI.characters[_group][_part].expression, function(c) {
	          return URI.characters[_group][_part].map[c];
	        });
	      } catch (e) {
	        // we're not going to mess with weird encodings,
	        // give up and return the undecoded original string
	        // see https://github.com/medialize/URI.js/issues/87
	        // see https://github.com/medialize/URI.js/issues/92
	        return string;
	      }
	    };
	  };
	
	  for (_part in _parts) {
	    URI[_part + 'PathSegment'] = generateAccessor('pathname', _parts[_part]);
	    URI[_part + 'UrnPathSegment'] = generateAccessor('urnpath', _parts[_part]);
	  }
	
	  var generateSegmentedPathFunction = function(_sep, _codingFuncName, _innerCodingFuncName) {
	    return function(string) {
	      // Why pass in names of functions, rather than the function objects themselves? The
	      // definitions of some functions (but in particular, URI.decode) will occasionally change due
	      // to URI.js having ISO8859 and Unicode modes. Passing in the name and getting it will ensure
	      // that the functions we use here are "fresh".
	      var actualCodingFunc;
	      if (!_innerCodingFuncName) {
	        actualCodingFunc = URI[_codingFuncName];
	      } else {
	        actualCodingFunc = function(string) {
	          return URI[_codingFuncName](URI[_innerCodingFuncName](string));
	        };
	      }
	
	      var segments = (string + '').split(_sep);
	
	      for (var i = 0, length = segments.length; i < length; i++) {
	        segments[i] = actualCodingFunc(segments[i]);
	      }
	
	      return segments.join(_sep);
	    };
	  };
	
	  // This takes place outside the above loop because we don't want, e.g., encodeUrnPath functions.
	  URI.decodePath = generateSegmentedPathFunction('/', 'decodePathSegment');
	  URI.decodeUrnPath = generateSegmentedPathFunction(':', 'decodeUrnPathSegment');
	  URI.recodePath = generateSegmentedPathFunction('/', 'encodePathSegment', 'decode');
	  URI.recodeUrnPath = generateSegmentedPathFunction(':', 'encodeUrnPathSegment', 'decode');
	
	  URI.encodeReserved = generateAccessor('reserved', 'encode');
	
	  URI.parse = function(string, parts) {
	    var pos;
	    if (!parts) {
	      parts = {};
	    }
	    // [protocol"://"[username[":"password]"@"]hostname[":"port]"/"?][path]["?"querystring]["#"fragment]
	
	    // extract fragment
	    pos = string.indexOf('#');
	    if (pos > -1) {
	      // escaping?
	      parts.fragment = string.substring(pos + 1) || null;
	      string = string.substring(0, pos);
	    }
	
	    // extract query
	    pos = string.indexOf('?');
	    if (pos > -1) {
	      // escaping?
	      parts.query = string.substring(pos + 1) || null;
	      string = string.substring(0, pos);
	    }
	
	    // extract protocol
	    if (string.substring(0, 2) === '//') {
	      // relative-scheme
	      parts.protocol = null;
	      string = string.substring(2);
	      // extract "user:pass@host:port"
	      string = URI.parseAuthority(string, parts);
	    } else {
	      pos = string.indexOf(':');
	      if (pos > -1) {
	        parts.protocol = string.substring(0, pos) || null;
	        if (parts.protocol && !parts.protocol.match(URI.protocol_expression)) {
	          // : may be within the path
	          parts.protocol = undefined;
	        } else if (string.substring(pos + 1, pos + 3) === '//') {
	          string = string.substring(pos + 3);
	
	          // extract "user:pass@host:port"
	          string = URI.parseAuthority(string, parts);
	        } else {
	          string = string.substring(pos + 1);
	          parts.urn = true;
	        }
	      }
	    }
	
	    // what's left must be the path
	    parts.path = string;
	
	    // and we're done
	    return parts;
	  };
	  URI.parseHost = function(string, parts) {
	    // Copy chrome, IE, opera backslash-handling behavior.
	    // Back slashes before the query string get converted to forward slashes
	    // See: https://github.com/joyent/node/blob/386fd24f49b0e9d1a8a076592a404168faeecc34/lib/url.js#L115-L124
	    // See: https://code.google.com/p/chromium/issues/detail?id=25916
	    // https://github.com/medialize/URI.js/pull/233
	    string = string.replace(/\\/g, '/');
	
	    // extract host:port
	    var pos = string.indexOf('/');
	    var bracketPos;
	    var t;
	
	    if (pos === -1) {
	      pos = string.length;
	    }
	
	    if (string.charAt(0) === '[') {
	      // IPv6 host - http://tools.ietf.org/html/draft-ietf-6man-text-addr-representation-04#section-6
	      // I claim most client software breaks on IPv6 anyways. To simplify things, URI only accepts
	      // IPv6+port in the format [2001:db8::1]:80 (for the time being)
	      bracketPos = string.indexOf(']');
	      parts.hostname = string.substring(1, bracketPos) || null;
	      parts.port = string.substring(bracketPos + 2, pos) || null;
	      if (parts.port === '/') {
	        parts.port = null;
	      }
	    } else {
	      var firstColon = string.indexOf(':');
	      var firstSlash = string.indexOf('/');
	      var nextColon = string.indexOf(':', firstColon + 1);
	      if (nextColon !== -1 && (firstSlash === -1 || nextColon < firstSlash)) {
	        // IPv6 host contains multiple colons - but no port
	        // this notation is actually not allowed by RFC 3986, but we're a liberal parser
	        parts.hostname = string.substring(0, pos) || null;
	        parts.port = null;
	      } else {
	        t = string.substring(0, pos).split(':');
	        parts.hostname = t[0] || null;
	        parts.port = t[1] || null;
	      }
	    }
	
	    if (parts.hostname && string.substring(pos).charAt(0) !== '/') {
	      pos++;
	      string = '/' + string;
	    }
	
	    return string.substring(pos) || '/';
	  };
	  URI.parseAuthority = function(string, parts) {
	    string = URI.parseUserinfo(string, parts);
	    return URI.parseHost(string, parts);
	  };
	  URI.parseUserinfo = function(string, parts) {
	    // extract username:password
	    var firstSlash = string.indexOf('/');
	    var pos = string.lastIndexOf('@', firstSlash > -1 ? firstSlash : string.length - 1);
	    var t;
	
	    // authority@ must come before /path
	    if (pos > -1 && (firstSlash === -1 || pos < firstSlash)) {
	      t = string.substring(0, pos).split(':');
	      parts.username = t[0] ? URI.decode(t[0]) : null;
	      t.shift();
	      parts.password = t[0] ? URI.decode(t.join(':')) : null;
	      string = string.substring(pos + 1);
	    } else {
	      parts.username = null;
	      parts.password = null;
	    }
	
	    return string;
	  };
	  URI.parseQuery = function(string, escapeQuerySpace) {
	    if (!string) {
	      return {};
	    }
	
	    // throw out the funky business - "?"[name"="value"&"]+
	    string = string.replace(/&+/g, '&').replace(/^\?*&*|&+$/g, '');
	
	    if (!string) {
	      return {};
	    }
	
	    var items = {};
	    var splits = string.split('&');
	    var length = splits.length;
	    var v, name, value;
	
	    for (var i = 0; i < length; i++) {
	      v = splits[i].split('=');
	      name = URI.decodeQuery(v.shift(), escapeQuerySpace);
	      // no "=" is null according to http://dvcs.w3.org/hg/url/raw-file/tip/Overview.html#collect-url-parameters
	      value = v.length ? URI.decodeQuery(v.join('='), escapeQuerySpace) : null;
	
	      if (hasOwn.call(items, name)) {
	        if (typeof items[name] === 'string' || items[name] === null) {
	          items[name] = [items[name]];
	        }
	
	        items[name].push(value);
	      } else {
	        items[name] = value;
	      }
	    }
	
	    return items;
	  };
	
	  URI.build = function(parts) {
	    var t = '';
	
	    if (parts.protocol) {
	      t += parts.protocol + ':';
	    }
	
	    if (!parts.urn && (t || parts.hostname)) {
	      t += '//';
	    }
	
	    t += (URI.buildAuthority(parts) || '');
	
	    if (typeof parts.path === 'string') {
	      if (parts.path.charAt(0) !== '/' && typeof parts.hostname === 'string') {
	        t += '/';
	      }
	
	      t += parts.path;
	    }
	
	    if (typeof parts.query === 'string' && parts.query) {
	      t += '?' + parts.query;
	    }
	
	    if (typeof parts.fragment === 'string' && parts.fragment) {
	      t += '#' + parts.fragment;
	    }
	    return t;
	  };
	  URI.buildHost = function(parts) {
	    var t = '';
	
	    if (!parts.hostname) {
	      return '';
	    } else if (URI.ip6_expression.test(parts.hostname)) {
	      t += '[' + parts.hostname + ']';
	    } else {
	      t += parts.hostname;
	    }
	
	    if (parts.port) {
	      t += ':' + parts.port;
	    }
	
	    return t;
	  };
	  URI.buildAuthority = function(parts) {
	    return URI.buildUserinfo(parts) + URI.buildHost(parts);
	  };
	  URI.buildUserinfo = function(parts) {
	    var t = '';
	
	    if (parts.username) {
	      t += URI.encode(parts.username);
	
	      if (parts.password) {
	        t += ':' + URI.encode(parts.password);
	      }
	
	      t += '@';
	    }
	
	    return t;
	  };
	  URI.buildQuery = function(data, duplicateQueryParameters, escapeQuerySpace) {
	    // according to http://tools.ietf.org/html/rfc3986 or http://labs.apache.org/webarch/uri/rfc/rfc3986.html
	    // being »-._~!$&'()*+,;=:@/?« %HEX and alnum are allowed
	    // the RFC explicitly states ?/foo being a valid use case, no mention of parameter syntax!
	    // URI.js treats the query string as being application/x-www-form-urlencoded
	    // see http://www.w3.org/TR/REC-html40/interact/forms.html#form-content-type
	
	    var t = '';
	    var unique, key, i, length;
	    for (key in data) {
	      if (hasOwn.call(data, key) && key) {
	        if (isArray(data[key])) {
	          unique = {};
	          for (i = 0, length = data[key].length; i < length; i++) {
	            if (data[key][i] !== undefined && unique[data[key][i] + ''] === undefined) {
	              t += '&' + URI.buildQueryParameter(key, data[key][i], escapeQuerySpace);
	              if (duplicateQueryParameters !== true) {
	                unique[data[key][i] + ''] = true;
	              }
	            }
	          }
	        } else if (data[key] !== undefined) {
	          t += '&' + URI.buildQueryParameter(key, data[key], escapeQuerySpace);
	        }
	      }
	    }
	
	    return t.substring(1);
	  };
	  URI.buildQueryParameter = function(name, value, escapeQuerySpace) {
	    // http://www.w3.org/TR/REC-html40/interact/forms.html#form-content-type -- application/x-www-form-urlencoded
	    // don't append "=" for null values, according to http://dvcs.w3.org/hg/url/raw-file/tip/Overview.html#url-parameter-serialization
	    return URI.encodeQuery(name, escapeQuerySpace) + (value !== null ? '=' + URI.encodeQuery(value, escapeQuerySpace) : '');
	  };
	
	  URI.addQuery = function(data, name, value) {
	    if (typeof name === 'object') {
	      for (var key in name) {
	        if (hasOwn.call(name, key)) {
	          URI.addQuery(data, key, name[key]);
	        }
	      }
	    } else if (typeof name === 'string') {
	      if (data[name] === undefined) {
	        data[name] = value;
	        return;
	      } else if (typeof data[name] === 'string') {
	        data[name] = [data[name]];
	      }
	
	      if (!isArray(value)) {
	        value = [value];
	      }
	
	      data[name] = (data[name] || []).concat(value);
	    } else {
	      throw new TypeError('URI.addQuery() accepts an object, string as the name parameter');
	    }
	  };
	  URI.removeQuery = function(data, name, value) {
	    var i, length, key;
	
	    if (isArray(name)) {
	      for (i = 0, length = name.length; i < length; i++) {
	        data[name[i]] = undefined;
	      }
	    } else if (getType(name) === 'RegExp') {
	      for (key in data) {
	        if (name.test(key)) {
	          data[key] = undefined;
	        }
	      }
	    } else if (typeof name === 'object') {
	      for (key in name) {
	        if (hasOwn.call(name, key)) {
	          URI.removeQuery(data, key, name[key]);
	        }
	      }
	    } else if (typeof name === 'string') {
	      if (value !== undefined) {
	        if (getType(value) === 'RegExp') {
	          if (!isArray(data[name]) && value.test(data[name])) {
	            data[name] = undefined;
	          } else {
	            data[name] = filterArrayValues(data[name], value);
	          }
	        } else if (data[name] === value) {
	          data[name] = undefined;
	        } else if (isArray(data[name])) {
	          data[name] = filterArrayValues(data[name], value);
	        }
	      } else {
	        data[name] = undefined;
	      }
	    } else {
	      throw new TypeError('URI.removeQuery() accepts an object, string, RegExp as the first parameter');
	    }
	  };
	  URI.hasQuery = function(data, name, value, withinArray) {
	    if (typeof name === 'object') {
	      for (var key in name) {
	        if (hasOwn.call(name, key)) {
	          if (!URI.hasQuery(data, key, name[key])) {
	            return false;
	          }
	        }
	      }
	
	      return true;
	    } else if (typeof name !== 'string') {
	      throw new TypeError('URI.hasQuery() accepts an object, string as the name parameter');
	    }
	
	    switch (getType(value)) {
	      case 'Undefined':
	        // true if exists (but may be empty)
	        return name in data; // data[name] !== undefined;
	
	      case 'Boolean':
	        // true if exists and non-empty
	        var _booly = Boolean(isArray(data[name]) ? data[name].length : data[name]);
	        return value === _booly;
	
	      case 'Function':
	        // allow complex comparison
	        return !!value(data[name], name, data);
	
	      case 'Array':
	        if (!isArray(data[name])) {
	          return false;
	        }
	
	        var op = withinArray ? arrayContains : arraysEqual;
	        return op(data[name], value);
	
	      case 'RegExp':
	        if (!isArray(data[name])) {
	          return Boolean(data[name] && data[name].match(value));
	        }
	
	        if (!withinArray) {
	          return false;
	        }
	
	        return arrayContains(data[name], value);
	
	      case 'Number':
	        value = String(value);
	        /* falls through */
	      case 'String':
	        if (!isArray(data[name])) {
	          return data[name] === value;
	        }
	
	        if (!withinArray) {
	          return false;
	        }
	
	        return arrayContains(data[name], value);
	
	      default:
	        throw new TypeError('URI.hasQuery() accepts undefined, boolean, string, number, RegExp, Function as the value parameter');
	    }
	  };
	
	
	  URI.commonPath = function(one, two) {
	    var length = Math.min(one.length, two.length);
	    var pos;
	
	    // find first non-matching character
	    for (pos = 0; pos < length; pos++) {
	      if (one.charAt(pos) !== two.charAt(pos)) {
	        pos--;
	        break;
	      }
	    }
	
	    if (pos < 1) {
	      return one.charAt(0) === two.charAt(0) && one.charAt(0) === '/' ? '/' : '';
	    }
	
	    // revert to last /
	    if (one.charAt(pos) !== '/' || two.charAt(pos) !== '/') {
	      pos = one.substring(0, pos).lastIndexOf('/');
	    }
	
	    return one.substring(0, pos + 1);
	  };
	
	  URI.withinString = function(string, callback, options) {
	    options || (options = {});
	    var _start = options.start || URI.findUri.start;
	    var _end = options.end || URI.findUri.end;
	    var _trim = options.trim || URI.findUri.trim;
	    var _attributeOpen = /[a-z0-9-]=["']?$/i;
	
	    _start.lastIndex = 0;
	    while (true) {
	      var match = _start.exec(string);
	      if (!match) {
	        break;
	      }
	
	      var start = match.index;
	      if (options.ignoreHtml) {
	        // attribut(e=["']?$)
	        var attributeOpen = string.slice(Math.max(start - 3, 0), start);
	        if (attributeOpen && _attributeOpen.test(attributeOpen)) {
	          continue;
	        }
	      }
	
	      var end = start + string.slice(start).search(_end);
	      var slice = string.slice(start, end).replace(_trim, '');
	      if (options.ignore && options.ignore.test(slice)) {
	        continue;
	      }
	
	      end = start + slice.length;
	      var result = callback(slice, start, end, string);
	      string = string.slice(0, start) + result + string.slice(end);
	      _start.lastIndex = start + result.length;
	    }
	
	    _start.lastIndex = 0;
	    return string;
	  };
	
	  URI.ensureValidHostname = function(v) {
	    // Theoretically URIs allow percent-encoding in Hostnames (according to RFC 3986)
	    // they are not part of DNS and therefore ignored by URI.js
	
	    if (v.match(URI.invalid_hostname_characters)) {
	      // test punycode
	      if (!punycode) {
	        throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-] and Punycode.js is not available');
	      }
	
	      if (punycode.toASCII(v).match(URI.invalid_hostname_characters)) {
	        throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-]');
	      }
	    }
	  };
	
	  // noConflict
	  URI.noConflict = function(removeAll) {
	    if (removeAll) {
	      var unconflicted = {
	        URI: this.noConflict()
	      };
	
	      if (root.URITemplate && typeof root.URITemplate.noConflict === 'function') {
	        unconflicted.URITemplate = root.URITemplate.noConflict();
	      }
	
	      if (root.IPv6 && typeof root.IPv6.noConflict === 'function') {
	        unconflicted.IPv6 = root.IPv6.noConflict();
	      }
	
	      if (root.SecondLevelDomains && typeof root.SecondLevelDomains.noConflict === 'function') {
	        unconflicted.SecondLevelDomains = root.SecondLevelDomains.noConflict();
	      }
	
	      return unconflicted;
	    } else if (root.URI === this) {
	      root.URI = _URI;
	    }
	
	    return this;
	  };
	
	  p.build = function(deferBuild) {
	    if (deferBuild === true) {
	      this._deferred_build = true;
	    } else if (deferBuild === undefined || this._deferred_build) {
	      this._string = URI.build(this._parts);
	      this._deferred_build = false;
	    }
	
	    return this;
	  };
	
	  p.clone = function() {
	    return new URI(this);
	  };
	
	  p.valueOf = p.toString = function() {
	    return this.build(false)._string;
	  };
	
	
	  function generateSimpleAccessor(_part){
	    return function(v, build) {
	      if (v === undefined) {
	        return this._parts[_part] || '';
	      } else {
	        this._parts[_part] = v || null;
	        this.build(!build);
	        return this;
	      }
	    };
	  }
	
	  function generatePrefixAccessor(_part, _key){
	    return function(v, build) {
	      if (v === undefined) {
	        return this._parts[_part] || '';
	      } else {
	        if (v !== null) {
	          v = v + '';
	          if (v.charAt(0) === _key) {
	            v = v.substring(1);
	          }
	        }
	
	        this._parts[_part] = v;
	        this.build(!build);
	        return this;
	      }
	    };
	  }
	
	  p.protocol = generateSimpleAccessor('protocol');
	  p.username = generateSimpleAccessor('username');
	  p.password = generateSimpleAccessor('password');
	  p.hostname = generateSimpleAccessor('hostname');
	  p.port = generateSimpleAccessor('port');
	  p.query = generatePrefixAccessor('query', '?');
	  p.fragment = generatePrefixAccessor('fragment', '#');
	
	  p.search = function(v, build) {
	    var t = this.query(v, build);
	    return typeof t === 'string' && t.length ? ('?' + t) : t;
	  };
	  p.hash = function(v, build) {
	    var t = this.fragment(v, build);
	    return typeof t === 'string' && t.length ? ('#' + t) : t;
	  };
	
	  p.pathname = function(v, build) {
	    if (v === undefined || v === true) {
	      var res = this._parts.path || (this._parts.hostname ? '/' : '');
	      return v ? (this._parts.urn ? URI.decodeUrnPath : URI.decodePath)(res) : res;
	    } else {
	      if (this._parts.urn) {
	        this._parts.path = v ? URI.recodeUrnPath(v) : '';
	      } else {
	        this._parts.path = v ? URI.recodePath(v) : '/';
	      }
	      this.build(!build);
	      return this;
	    }
	  };
	  p.path = p.pathname;
	  p.href = function(href, build) {
	    var key;
	
	    if (href === undefined) {
	      return this.toString();
	    }
	
	    this._string = '';
	    this._parts = URI._parts();
	
	    var _URI = href instanceof URI;
	    var _object = typeof href === 'object' && (href.hostname || href.path || href.pathname);
	    if (href.nodeName) {
	      var attribute = URI.getDomAttribute(href);
	      href = href[attribute] || '';
	      _object = false;
	    }
	
	    // window.location is reported to be an object, but it's not the sort
	    // of object we're looking for:
	    // * location.protocol ends with a colon
	    // * location.query != object.search
	    // * location.hash != object.fragment
	    // simply serializing the unknown object should do the trick
	    // (for location, not for everything...)
	    if (!_URI && _object && href.pathname !== undefined) {
	      href = href.toString();
	    }
	
	    if (typeof href === 'string' || href instanceof String) {
	      this._parts = URI.parse(String(href), this._parts);
	    } else if (_URI || _object) {
	      var src = _URI ? href._parts : href;
	      for (key in src) {
	        if (hasOwn.call(this._parts, key)) {
	          this._parts[key] = src[key];
	        }
	      }
	    } else {
	      throw new TypeError('invalid input');
	    }
	
	    this.build(!build);
	    return this;
	  };
	
	  // identification accessors
	  p.is = function(what) {
	    var ip = false;
	    var ip4 = false;
	    var ip6 = false;
	    var name = false;
	    var sld = false;
	    var idn = false;
	    var punycode = false;
	    var relative = !this._parts.urn;
	
	    if (this._parts.hostname) {
	      relative = false;
	      ip4 = URI.ip4_expression.test(this._parts.hostname);
	      ip6 = URI.ip6_expression.test(this._parts.hostname);
	      ip = ip4 || ip6;
	      name = !ip;
	      sld = name && SLD && SLD.has(this._parts.hostname);
	      idn = name && URI.idn_expression.test(this._parts.hostname);
	      punycode = name && URI.punycode_expression.test(this._parts.hostname);
	    }
	
	    switch (what.toLowerCase()) {
	      case 'relative':
	        return relative;
	
	      case 'absolute':
	        return !relative;
	
	      // hostname identification
	      case 'domain':
	      case 'name':
	        return name;
	
	      case 'sld':
	        return sld;
	
	      case 'ip':
	        return ip;
	
	      case 'ip4':
	      case 'ipv4':
	      case 'inet4':
	        return ip4;
	
	      case 'ip6':
	      case 'ipv6':
	      case 'inet6':
	        return ip6;
	
	      case 'idn':
	        return idn;
	
	      case 'url':
	        return !this._parts.urn;
	
	      case 'urn':
	        return !!this._parts.urn;
	
	      case 'punycode':
	        return punycode;
	    }
	
	    return null;
	  };
	
	  // component specific input validation
	  var _protocol = p.protocol;
	  var _port = p.port;
	  var _hostname = p.hostname;
	
	  p.protocol = function(v, build) {
	    if (v !== undefined) {
	      if (v) {
	        // accept trailing ://
	        v = v.replace(/:(\/\/)?$/, '');
	
	        if (!v.match(URI.protocol_expression)) {
	          throw new TypeError('Protocol "' + v + '" contains characters other than [A-Z0-9.+-] or doesn\'t start with [A-Z]');
	        }
	      }
	    }
	    return _protocol.call(this, v, build);
	  };
	  p.scheme = p.protocol;
	  p.port = function(v, build) {
	    if (this._parts.urn) {
	      return v === undefined ? '' : this;
	    }
	
	    if (v !== undefined) {
	      if (v === 0) {
	        v = null;
	      }
	
	      if (v) {
	        v += '';
	        if (v.charAt(0) === ':') {
	          v = v.substring(1);
	        }
	
	        if (v.match(/[^0-9]/)) {
	          throw new TypeError('Port "' + v + '" contains characters other than [0-9]');
	        }
	      }
	    }
	    return _port.call(this, v, build);
	  };
	  p.hostname = function(v, build) {
	    if (this._parts.urn) {
	      return v === undefined ? '' : this;
	    }
	
	    if (v !== undefined) {
	      var x = {};
	      var res = URI.parseHost(v, x);
	      if (res !== '/') {
	        throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-]');
	      }
	
	      v = x.hostname;
	    }
	    return _hostname.call(this, v, build);
	  };
	
	  // compound accessors
	  p.host = function(v, build) {
	    if (this._parts.urn) {
	      return v === undefined ? '' : this;
	    }
	
	    if (v === undefined) {
	      return this._parts.hostname ? URI.buildHost(this._parts) : '';
	    } else {
	      var res = URI.parseHost(v, this._parts);
	      if (res !== '/') {
	        throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-]');
	      }
	
	      this.build(!build);
	      return this;
	    }
	  };
	  p.authority = function(v, build) {
	    if (this._parts.urn) {
	      return v === undefined ? '' : this;
	    }
	
	    if (v === undefined) {
	      return this._parts.hostname ? URI.buildAuthority(this._parts) : '';
	    } else {
	      var res = URI.parseAuthority(v, this._parts);
	      if (res !== '/') {
	        throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-]');
	      }
	
	      this.build(!build);
	      return this;
	    }
	  };
	  p.userinfo = function(v, build) {
	    if (this._parts.urn) {
	      return v === undefined ? '' : this;
	    }
	
	    if (v === undefined) {
	      if (!this._parts.username) {
	        return '';
	      }
	
	      var t = URI.buildUserinfo(this._parts);
	      return t.substring(0, t.length -1);
	    } else {
	      if (v[v.length-1] !== '@') {
	        v += '@';
	      }
	
	      URI.parseUserinfo(v, this._parts);
	      this.build(!build);
	      return this;
	    }
	  };
	  p.resource = function(v, build) {
	    var parts;
	
	    if (v === undefined) {
	      return this.path() + this.search() + this.hash();
	    }
	
	    parts = URI.parse(v);
	    this._parts.path = parts.path;
	    this._parts.query = parts.query;
	    this._parts.fragment = parts.fragment;
	    this.build(!build);
	    return this;
	  };
	
	  // fraction accessors
	  p.subdomain = function(v, build) {
	    if (this._parts.urn) {
	      return v === undefined ? '' : this;
	    }
	
	    // convenience, return "www" from "www.example.org"
	    if (v === undefined) {
	      if (!this._parts.hostname || this.is('IP')) {
	        return '';
	      }
	
	      // grab domain and add another segment
	      var end = this._parts.hostname.length - this.domain().length - 1;
	      return this._parts.hostname.substring(0, end) || '';
	    } else {
	      var e = this._parts.hostname.length - this.domain().length;
	      var sub = this._parts.hostname.substring(0, e);
	      var replace = new RegExp('^' + escapeRegEx(sub));
	
	      if (v && v.charAt(v.length - 1) !== '.') {
	        v += '.';
	      }
	
	      if (v) {
	        URI.ensureValidHostname(v);
	      }
	
	      this._parts.hostname = this._parts.hostname.replace(replace, v);
	      this.build(!build);
	      return this;
	    }
	  };
	  p.domain = function(v, build) {
	    if (this._parts.urn) {
	      return v === undefined ? '' : this;
	    }
	
	    if (typeof v === 'boolean') {
	      build = v;
	      v = undefined;
	    }
	
	    // convenience, return "example.org" from "www.example.org"
	    if (v === undefined) {
	      if (!this._parts.hostname || this.is('IP')) {
	        return '';
	      }
	
	      // if hostname consists of 1 or 2 segments, it must be the domain
	      var t = this._parts.hostname.match(/\./g);
	      if (t && t.length < 2) {
	        return this._parts.hostname;
	      }
	
	      // grab tld and add another segment
	      var end = this._parts.hostname.length - this.tld(build).length - 1;
	      end = this._parts.hostname.lastIndexOf('.', end -1) + 1;
	      return this._parts.hostname.substring(end) || '';
	    } else {
	      if (!v) {
	        throw new TypeError('cannot set domain empty');
	      }
	
	      URI.ensureValidHostname(v);
	
	      if (!this._parts.hostname || this.is('IP')) {
	        this._parts.hostname = v;
	      } else {
	        var replace = new RegExp(escapeRegEx(this.domain()) + '$');
	        this._parts.hostname = this._parts.hostname.replace(replace, v);
	      }
	
	      this.build(!build);
	      return this;
	    }
	  };
	  p.tld = function(v, build) {
	    if (this._parts.urn) {
	      return v === undefined ? '' : this;
	    }
	
	    if (typeof v === 'boolean') {
	      build = v;
	      v = undefined;
	    }
	
	    // return "org" from "www.example.org"
	    if (v === undefined) {
	      if (!this._parts.hostname || this.is('IP')) {
	        return '';
	      }
	
	      var pos = this._parts.hostname.lastIndexOf('.');
	      var tld = this._parts.hostname.substring(pos + 1);
	
	      if (build !== true && SLD && SLD.list[tld.toLowerCase()]) {
	        return SLD.get(this._parts.hostname) || tld;
	      }
	
	      return tld;
	    } else {
	      var replace;
	
	      if (!v) {
	        throw new TypeError('cannot set TLD empty');
	      } else if (v.match(/[^a-zA-Z0-9-]/)) {
	        if (SLD && SLD.is(v)) {
	          replace = new RegExp(escapeRegEx(this.tld()) + '$');
	          this._parts.hostname = this._parts.hostname.replace(replace, v);
	        } else {
	          throw new TypeError('TLD "' + v + '" contains characters other than [A-Z0-9]');
	        }
	      } else if (!this._parts.hostname || this.is('IP')) {
	        throw new ReferenceError('cannot set TLD on non-domain host');
	      } else {
	        replace = new RegExp(escapeRegEx(this.tld()) + '$');
	        this._parts.hostname = this._parts.hostname.replace(replace, v);
	      }
	
	      this.build(!build);
	      return this;
	    }
	  };
	  p.directory = function(v, build) {
	    if (this._parts.urn) {
	      return v === undefined ? '' : this;
	    }
	
	    if (v === undefined || v === true) {
	      if (!this._parts.path && !this._parts.hostname) {
	        return '';
	      }
	
	      if (this._parts.path === '/') {
	        return '/';
	      }
	
	      var end = this._parts.path.length - this.filename().length - 1;
	      var res = this._parts.path.substring(0, end) || (this._parts.hostname ? '/' : '');
	
	      return v ? URI.decodePath(res) : res;
	
	    } else {
	      var e = this._parts.path.length - this.filename().length;
	      var directory = this._parts.path.substring(0, e);
	      var replace = new RegExp('^' + escapeRegEx(directory));
	
	      // fully qualifier directories begin with a slash
	      if (!this.is('relative')) {
	        if (!v) {
	          v = '/';
	        }
	
	        if (v.charAt(0) !== '/') {
	          v = '/' + v;
	        }
	      }
	
	      // directories always end with a slash
	      if (v && v.charAt(v.length - 1) !== '/') {
	        v += '/';
	      }
	
	      v = URI.recodePath(v);
	      this._parts.path = this._parts.path.replace(replace, v);
	      this.build(!build);
	      return this;
	    }
	  };
	  p.filename = function(v, build) {
	    if (this._parts.urn) {
	      return v === undefined ? '' : this;
	    }
	
	    if (v === undefined || v === true) {
	      if (!this._parts.path || this._parts.path === '/') {
	        return '';
	      }
	
	      var pos = this._parts.path.lastIndexOf('/');
	      var res = this._parts.path.substring(pos+1);
	
	      return v ? URI.decodePathSegment(res) : res;
	    } else {
	      var mutatedDirectory = false;
	
	      if (v.charAt(0) === '/') {
	        v = v.substring(1);
	      }
	
	      if (v.match(/\.?\//)) {
	        mutatedDirectory = true;
	      }
	
	      var replace = new RegExp(escapeRegEx(this.filename()) + '$');
	      v = URI.recodePath(v);
	      this._parts.path = this._parts.path.replace(replace, v);
	
	      if (mutatedDirectory) {
	        this.normalizePath(build);
	      } else {
	        this.build(!build);
	      }
	
	      return this;
	    }
	  };
	  p.suffix = function(v, build) {
	    if (this._parts.urn) {
	      return v === undefined ? '' : this;
	    }
	
	    if (v === undefined || v === true) {
	      if (!this._parts.path || this._parts.path === '/') {
	        return '';
	      }
	
	      var filename = this.filename();
	      var pos = filename.lastIndexOf('.');
	      var s, res;
	
	      if (pos === -1) {
	        return '';
	      }
	
	      // suffix may only contain alnum characters (yup, I made this up.)
	      s = filename.substring(pos+1);
	      res = (/^[a-z0-9%]+$/i).test(s) ? s : '';
	      return v ? URI.decodePathSegment(res) : res;
	    } else {
	      if (v.charAt(0) === '.') {
	        v = v.substring(1);
	      }
	
	      var suffix = this.suffix();
	      var replace;
	
	      if (!suffix) {
	        if (!v) {
	          return this;
	        }
	
	        this._parts.path += '.' + URI.recodePath(v);
	      } else if (!v) {
	        replace = new RegExp(escapeRegEx('.' + suffix) + '$');
	      } else {
	        replace = new RegExp(escapeRegEx(suffix) + '$');
	      }
	
	      if (replace) {
	        v = URI.recodePath(v);
	        this._parts.path = this._parts.path.replace(replace, v);
	      }
	
	      this.build(!build);
	      return this;
	    }
	  };
	  p.segment = function(segment, v, build) {
	    var separator = this._parts.urn ? ':' : '/';
	    var path = this.path();
	    var absolute = path.substring(0, 1) === '/';
	    var segments = path.split(separator);
	
	    if (segment !== undefined && typeof segment !== 'number') {
	      build = v;
	      v = segment;
	      segment = undefined;
	    }
	
	    if (segment !== undefined && typeof segment !== 'number') {
	      throw new Error('Bad segment "' + segment + '", must be 0-based integer');
	    }
	
	    if (absolute) {
	      segments.shift();
	    }
	
	    if (segment < 0) {
	      // allow negative indexes to address from the end
	      segment = Math.max(segments.length + segment, 0);
	    }
	
	    if (v === undefined) {
	      /*jshint laxbreak: true */
	      return segment === undefined
	        ? segments
	        : segments[segment];
	      /*jshint laxbreak: false */
	    } else if (segment === null || segments[segment] === undefined) {
	      if (isArray(v)) {
	        segments = [];
	        // collapse empty elements within array
	        for (var i=0, l=v.length; i < l; i++) {
	          if (!v[i].length && (!segments.length || !segments[segments.length -1].length)) {
	            continue;
	          }
	
	          if (segments.length && !segments[segments.length -1].length) {
	            segments.pop();
	          }
	
	          segments.push(v[i]);
	        }
	      } else if (v || typeof v === 'string') {
	        if (segments[segments.length -1] === '') {
	          // empty trailing elements have to be overwritten
	          // to prevent results such as /foo//bar
	          segments[segments.length -1] = v;
	        } else {
	          segments.push(v);
	        }
	      }
	    } else {
	      if (v) {
	        segments[segment] = v;
	      } else {
	        segments.splice(segment, 1);
	      }
	    }
	
	    if (absolute) {
	      segments.unshift('');
	    }
	
	    return this.path(segments.join(separator), build);
	  };
	  p.segmentCoded = function(segment, v, build) {
	    var segments, i, l;
	
	    if (typeof segment !== 'number') {
	      build = v;
	      v = segment;
	      segment = undefined;
	    }
	
	    if (v === undefined) {
	      segments = this.segment(segment, v, build);
	      if (!isArray(segments)) {
	        segments = segments !== undefined ? URI.decode(segments) : undefined;
	      } else {
	        for (i = 0, l = segments.length; i < l; i++) {
	          segments[i] = URI.decode(segments[i]);
	        }
	      }
	
	      return segments;
	    }
	
	    if (!isArray(v)) {
	      v = (typeof v === 'string' || v instanceof String) ? URI.encode(v) : v;
	    } else {
	      for (i = 0, l = v.length; i < l; i++) {
	        v[i] = URI.encode(v[i]);
	      }
	    }
	
	    return this.segment(segment, v, build);
	  };
	
	  // mutating query string
	  var q = p.query;
	  p.query = function(v, build) {
	    if (v === true) {
	      return URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
	    } else if (typeof v === 'function') {
	      var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
	      var result = v.call(this, data);
	      this._parts.query = URI.buildQuery(result || data, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
	      this.build(!build);
	      return this;
	    } else if (v !== undefined && typeof v !== 'string') {
	      this._parts.query = URI.buildQuery(v, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
	      this.build(!build);
	      return this;
	    } else {
	      return q.call(this, v, build);
	    }
	  };
	  p.setQuery = function(name, value, build) {
	    var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
	
	    if (typeof name === 'string' || name instanceof String) {
	      data[name] = value !== undefined ? value : null;
	    } else if (typeof name === 'object') {
	      for (var key in name) {
	        if (hasOwn.call(name, key)) {
	          data[key] = name[key];
	        }
	      }
	    } else {
	      throw new TypeError('URI.addQuery() accepts an object, string as the name parameter');
	    }
	
	    this._parts.query = URI.buildQuery(data, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
	    if (typeof name !== 'string') {
	      build = value;
	    }
	
	    this.build(!build);
	    return this;
	  };
	  p.addQuery = function(name, value, build) {
	    var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
	    URI.addQuery(data, name, value === undefined ? null : value);
	    this._parts.query = URI.buildQuery(data, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
	    if (typeof name !== 'string') {
	      build = value;
	    }
	
	    this.build(!build);
	    return this;
	  };
	  p.removeQuery = function(name, value, build) {
	    var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
	    URI.removeQuery(data, name, value);
	    this._parts.query = URI.buildQuery(data, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
	    if (typeof name !== 'string') {
	      build = value;
	    }
	
	    this.build(!build);
	    return this;
	  };
	  p.hasQuery = function(name, value, withinArray) {
	    var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
	    return URI.hasQuery(data, name, value, withinArray);
	  };
	  p.setSearch = p.setQuery;
	  p.addSearch = p.addQuery;
	  p.removeSearch = p.removeQuery;
	  p.hasSearch = p.hasQuery;
	
	  // sanitizing URLs
	  p.normalize = function() {
	    if (this._parts.urn) {
	      return this
	        .normalizeProtocol(false)
	        .normalizePath(false)
	        .normalizeQuery(false)
	        .normalizeFragment(false)
	        .build();
	    }
	
	    return this
	      .normalizeProtocol(false)
	      .normalizeHostname(false)
	      .normalizePort(false)
	      .normalizePath(false)
	      .normalizeQuery(false)
	      .normalizeFragment(false)
	      .build();
	  };
	  p.normalizeProtocol = function(build) {
	    if (typeof this._parts.protocol === 'string') {
	      this._parts.protocol = this._parts.protocol.toLowerCase();
	      this.build(!build);
	    }
	
	    return this;
	  };
	  p.normalizeHostname = function(build) {
	    if (this._parts.hostname) {
	      if (this.is('IDN') && punycode) {
	        this._parts.hostname = punycode.toASCII(this._parts.hostname);
	      } else if (this.is('IPv6') && IPv6) {
	        this._parts.hostname = IPv6.best(this._parts.hostname);
	      }
	
	      this._parts.hostname = this._parts.hostname.toLowerCase();
	      this.build(!build);
	    }
	
	    return this;
	  };
	  p.normalizePort = function(build) {
	    // remove port of it's the protocol's default
	    if (typeof this._parts.protocol === 'string' && this._parts.port === URI.defaultPorts[this._parts.protocol]) {
	      this._parts.port = null;
	      this.build(!build);
	    }
	
	    return this;
	  };
	  p.normalizePath = function(build) {
	    var _path = this._parts.path;
	    if (!_path) {
	      return this;
	    }
	
	    if (this._parts.urn) {
	      this._parts.path = URI.recodeUrnPath(this._parts.path);
	      this.build(!build);
	      return this;
	    }
	
	    if (this._parts.path === '/') {
	      return this;
	    }
	
	    var _was_relative;
	    var _leadingParents = '';
	    var _parent, _pos;
	
	    // handle relative paths
	    if (_path.charAt(0) !== '/') {
	      _was_relative = true;
	      _path = '/' + _path;
	    }
	
	    // handle relative files (as opposed to directories)
	    if (_path.slice(-3) === '/..' || _path.slice(-2) === '/.') {
	      _path += '/';
	    }
	
	    // resolve simples
	    _path = _path
	      .replace(/(\/(\.\/)+)|(\/\.$)/g, '/')
	      .replace(/\/{2,}/g, '/');
	
	    // remember leading parents
	    if (_was_relative) {
	      _leadingParents = _path.substring(1).match(/^(\.\.\/)+/) || '';
	      if (_leadingParents) {
	        _leadingParents = _leadingParents[0];
	      }
	    }
	
	    // resolve parents
	    while (true) {
	      _parent = _path.indexOf('/..');
	      if (_parent === -1) {
	        // no more ../ to resolve
	        break;
	      } else if (_parent === 0) {
	        // top level cannot be relative, skip it
	        _path = _path.substring(3);
	        continue;
	      }
	
	      _pos = _path.substring(0, _parent).lastIndexOf('/');
	      if (_pos === -1) {
	        _pos = _parent;
	      }
	      _path = _path.substring(0, _pos) + _path.substring(_parent + 3);
	    }
	
	    // revert to relative
	    if (_was_relative && this.is('relative')) {
	      _path = _leadingParents + _path.substring(1);
	    }
	
	    _path = URI.recodePath(_path);
	    this._parts.path = _path;
	    this.build(!build);
	    return this;
	  };
	  p.normalizePathname = p.normalizePath;
	  p.normalizeQuery = function(build) {
	    if (typeof this._parts.query === 'string') {
	      if (!this._parts.query.length) {
	        this._parts.query = null;
	      } else {
	        this.query(URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace));
	      }
	
	      this.build(!build);
	    }
	
	    return this;
	  };
	  p.normalizeFragment = function(build) {
	    if (!this._parts.fragment) {
	      this._parts.fragment = null;
	      this.build(!build);
	    }
	
	    return this;
	  };
	  p.normalizeSearch = p.normalizeQuery;
	  p.normalizeHash = p.normalizeFragment;
	
	  p.iso8859 = function() {
	    // expect unicode input, iso8859 output
	    var e = URI.encode;
	    var d = URI.decode;
	
	    URI.encode = escape;
	    URI.decode = decodeURIComponent;
	    try {
	      this.normalize();
	    } finally {
	      URI.encode = e;
	      URI.decode = d;
	    }
	    return this;
	  };
	
	  p.unicode = function() {
	    // expect iso8859 input, unicode output
	    var e = URI.encode;
	    var d = URI.decode;
	
	    URI.encode = strictEncodeURIComponent;
	    URI.decode = unescape;
	    try {
	      this.normalize();
	    } finally {
	      URI.encode = e;
	      URI.decode = d;
	    }
	    return this;
	  };
	
	  p.readable = function() {
	    var uri = this.clone();
	    // removing username, password, because they shouldn't be displayed according to RFC 3986
	    uri.username('').password('').normalize();
	    var t = '';
	    if (uri._parts.protocol) {
	      t += uri._parts.protocol + '://';
	    }
	
	    if (uri._parts.hostname) {
	      if (uri.is('punycode') && punycode) {
	        t += punycode.toUnicode(uri._parts.hostname);
	        if (uri._parts.port) {
	          t += ':' + uri._parts.port;
	        }
	      } else {
	        t += uri.host();
	      }
	    }
	
	    if (uri._parts.hostname && uri._parts.path && uri._parts.path.charAt(0) !== '/') {
	      t += '/';
	    }
	
	    t += uri.path(true);
	    if (uri._parts.query) {
	      var q = '';
	      for (var i = 0, qp = uri._parts.query.split('&'), l = qp.length; i < l; i++) {
	        var kv = (qp[i] || '').split('=');
	        q += '&' + URI.decodeQuery(kv[0], this._parts.escapeQuerySpace)
	          .replace(/&/g, '%26');
	
	        if (kv[1] !== undefined) {
	          q += '=' + URI.decodeQuery(kv[1], this._parts.escapeQuerySpace)
	            .replace(/&/g, '%26');
	        }
	      }
	      t += '?' + q.substring(1);
	    }
	
	    t += URI.decodeQuery(uri.hash(), true);
	    return t;
	  };
	
	  // resolving relative and absolute URLs
	  p.absoluteTo = function(base) {
	    var resolved = this.clone();
	    var properties = ['protocol', 'username', 'password', 'hostname', 'port'];
	    var basedir, i, p;
	
	    if (this._parts.urn) {
	      throw new Error('URNs do not have any generally defined hierarchical components');
	    }
	
	    if (!(base instanceof URI)) {
	      base = new URI(base);
	    }
	
	    if (!resolved._parts.protocol) {
	      resolved._parts.protocol = base._parts.protocol;
	    }
	
	    if (this._parts.hostname) {
	      return resolved;
	    }
	
	    for (i = 0; (p = properties[i]); i++) {
	      resolved._parts[p] = base._parts[p];
	    }
	
	    if (!resolved._parts.path) {
	      resolved._parts.path = base._parts.path;
	      if (!resolved._parts.query) {
	        resolved._parts.query = base._parts.query;
	      }
	    } else if (resolved._parts.path.substring(-2) === '..') {
	      resolved._parts.path += '/';
	    }
	
	    if (resolved.path().charAt(0) !== '/') {
	      basedir = base.directory();
	      basedir = basedir ? basedir : base.path().indexOf('/') === 0 ? '/' : '';
	      resolved._parts.path = (basedir ? (basedir + '/') : '') + resolved._parts.path;
	      resolved.normalizePath();
	    }
	
	    resolved.build();
	    return resolved;
	  };
	  p.relativeTo = function(base) {
	    var relative = this.clone().normalize();
	    var relativeParts, baseParts, common, relativePath, basePath;
	
	    if (relative._parts.urn) {
	      throw new Error('URNs do not have any generally defined hierarchical components');
	    }
	
	    base = new URI(base).normalize();
	    relativeParts = relative._parts;
	    baseParts = base._parts;
	    relativePath = relative.path();
	    basePath = base.path();
	
	    if (relativePath.charAt(0) !== '/') {
	      throw new Error('URI is already relative');
	    }
	
	    if (basePath.charAt(0) !== '/') {
	      throw new Error('Cannot calculate a URI relative to another relative URI');
	    }
	
	    if (relativeParts.protocol === baseParts.protocol) {
	      relativeParts.protocol = null;
	    }
	
	    if (relativeParts.username !== baseParts.username || relativeParts.password !== baseParts.password) {
	      return relative.build();
	    }
	
	    if (relativeParts.protocol !== null || relativeParts.username !== null || relativeParts.password !== null) {
	      return relative.build();
	    }
	
	    if (relativeParts.hostname === baseParts.hostname && relativeParts.port === baseParts.port) {
	      relativeParts.hostname = null;
	      relativeParts.port = null;
	    } else {
	      return relative.build();
	    }
	
	    if (relativePath === basePath) {
	      relativeParts.path = '';
	      return relative.build();
	    }
	
	    // determine common sub path
	    common = URI.commonPath(relativePath, basePath);
	
	    // If the paths have nothing in common, return a relative URL with the absolute path.
	    if (!common) {
	      return relative.build();
	    }
	
	    var parents = baseParts.path
	      .substring(common.length)
	      .replace(/[^\/]*$/, '')
	      .replace(/.*?\//g, '../');
	
	    relativeParts.path = (parents + relativeParts.path.substring(common.length)) || './';
	
	    return relative.build();
	  };
	
	  // comparing URIs
	  p.equals = function(uri) {
	    var one = this.clone();
	    var two = new URI(uri);
	    var one_map = {};
	    var two_map = {};
	    var checked = {};
	    var one_query, two_query, key;
	
	    one.normalize();
	    two.normalize();
	
	    // exact match
	    if (one.toString() === two.toString()) {
	      return true;
	    }
	
	    // extract query string
	    one_query = one.query();
	    two_query = two.query();
	    one.query('');
	    two.query('');
	
	    // definitely not equal if not even non-query parts match
	    if (one.toString() !== two.toString()) {
	      return false;
	    }
	
	    // query parameters have the same length, even if they're permuted
	    if (one_query.length !== two_query.length) {
	      return false;
	    }
	
	    one_map = URI.parseQuery(one_query, this._parts.escapeQuerySpace);
	    two_map = URI.parseQuery(two_query, this._parts.escapeQuerySpace);
	
	    for (key in one_map) {
	      if (hasOwn.call(one_map, key)) {
	        if (!isArray(one_map[key])) {
	          if (one_map[key] !== two_map[key]) {
	            return false;
	          }
	        } else if (!arraysEqual(one_map[key], two_map[key])) {
	          return false;
	        }
	
	        checked[key] = true;
	      }
	    }
	
	    for (key in two_map) {
	      if (hasOwn.call(two_map, key)) {
	        if (!checked[key]) {
	          // two contains a parameter not present in one
	          return false;
	        }
	      }
	    }
	
	    return true;
	  };
	
	  // state
	  p.duplicateQueryParameters = function(v) {
	    this._parts.duplicateQueryParameters = !!v;
	    return this;
	  };
	
	  p.escapeQuerySpace = function(v) {
	    this._parts.escapeQuerySpace = !!v;
	    return this;
	  };
	
	  return URI;
	}));


/***/ },
/* 464 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/*! http://mths.be/punycode v1.2.3 by @mathias */
	;(function(root) {
	
		/** Detect free variables */
		var freeExports = typeof exports == 'object' && exports;
		var freeModule = typeof module == 'object' && module &&
			module.exports == freeExports && module;
		var freeGlobal = typeof global == 'object' && global;
		if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) {
			root = freeGlobal;
		}
	
		/**
		 * The `punycode` object.
		 * @name punycode
		 * @type Object
		 */
		var punycode,
	
		/** Highest positive signed 32-bit float value */
		maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1
	
		/** Bootstring parameters */
		base = 36,
		tMin = 1,
		tMax = 26,
		skew = 38,
		damp = 700,
		initialBias = 72,
		initialN = 128, // 0x80
		delimiter = '-', // '\x2D'
	
		/** Regular expressions */
		regexPunycode = /^xn--/,
		regexNonASCII = /[^ -~]/, // unprintable ASCII chars + non-ASCII chars
		regexSeparators = /\x2E|\u3002|\uFF0E|\uFF61/g, // RFC 3490 separators
	
		/** Error messages */
		errors = {
			'overflow': 'Overflow: input needs wider integers to process',
			'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
			'invalid-input': 'Invalid input'
		},
	
		/** Convenience shortcuts */
		baseMinusTMin = base - tMin,
		floor = Math.floor,
		stringFromCharCode = String.fromCharCode,
	
		/** Temporary variable */
		key;
	
		/*--------------------------------------------------------------------------*/
	
		/**
		 * A generic error utility function.
		 * @private
		 * @param {String} type The error type.
		 * @returns {Error} Throws a `RangeError` with the applicable error message.
		 */
		function error(type) {
			throw RangeError(errors[type]);
		}
	
		/**
		 * A generic `Array#map` utility function.
		 * @private
		 * @param {Array} array The array to iterate over.
		 * @param {Function} callback The function that gets called for every array
		 * item.
		 * @returns {Array} A new array of values returned by the callback function.
		 */
		function map(array, fn) {
			var length = array.length;
			while (length--) {
				array[length] = fn(array[length]);
			}
			return array;
		}
	
		/**
		 * A simple `Array#map`-like wrapper to work with domain name strings.
		 * @private
		 * @param {String} domain The domain name.
		 * @param {Function} callback The function that gets called for every
		 * character.
		 * @returns {Array} A new string of characters returned by the callback
		 * function.
		 */
		function mapDomain(string, fn) {
			return map(string.split(regexSeparators), fn).join('.');
		}
	
		/**
		 * Creates an array containing the numeric code points of each Unicode
		 * character in the string. While JavaScript uses UCS-2 internally,
		 * this function will convert a pair of surrogate halves (each of which
		 * UCS-2 exposes as separate characters) into a single code point,
		 * matching UTF-16.
		 * @see `punycode.ucs2.encode`
		 * @see <http://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode.ucs2
		 * @name decode
		 * @param {String} string The Unicode input string (UCS-2).
		 * @returns {Array} The new array of code points.
		 */
		function ucs2decode(string) {
			var output = [],
			    counter = 0,
			    length = string.length,
			    value,
			    extra;
			while (counter < length) {
				value = string.charCodeAt(counter++);
				if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
					// high surrogate, and there is a next character
					extra = string.charCodeAt(counter++);
					if ((extra & 0xFC00) == 0xDC00) { // low surrogate
						output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
					} else {
						// unmatched surrogate; only append this code unit, in case the next
						// code unit is the high surrogate of a surrogate pair
						output.push(value);
						counter--;
					}
				} else {
					output.push(value);
				}
			}
			return output;
		}
	
		/**
		 * Creates a string based on an array of numeric code points.
		 * @see `punycode.ucs2.decode`
		 * @memberOf punycode.ucs2
		 * @name encode
		 * @param {Array} codePoints The array of numeric code points.
		 * @returns {String} The new Unicode string (UCS-2).
		 */
		function ucs2encode(array) {
			return map(array, function(value) {
				var output = '';
				if (value > 0xFFFF) {
					value -= 0x10000;
					output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
					value = 0xDC00 | value & 0x3FF;
				}
				output += stringFromCharCode(value);
				return output;
			}).join('');
		}
	
		/**
		 * Converts a basic code point into a digit/integer.
		 * @see `digitToBasic()`
		 * @private
		 * @param {Number} codePoint The basic numeric code point value.
		 * @returns {Number} The numeric value of a basic code point (for use in
		 * representing integers) in the range `0` to `base - 1`, or `base` if
		 * the code point does not represent a value.
		 */
		function basicToDigit(codePoint) {
			if (codePoint - 48 < 10) {
				return codePoint - 22;
			}
			if (codePoint - 65 < 26) {
				return codePoint - 65;
			}
			if (codePoint - 97 < 26) {
				return codePoint - 97;
			}
			return base;
		}
	
		/**
		 * Converts a digit/integer into a basic code point.
		 * @see `basicToDigit()`
		 * @private
		 * @param {Number} digit The numeric value of a basic code point.
		 * @returns {Number} The basic code point whose value (when used for
		 * representing integers) is `digit`, which needs to be in the range
		 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
		 * used; else, the lowercase form is used. The behavior is undefined
		 * if `flag` is non-zero and `digit` has no uppercase form.
		 */
		function digitToBasic(digit, flag) {
			//  0..25 map to ASCII a..z or A..Z
			// 26..35 map to ASCII 0..9
			return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
		}
	
		/**
		 * Bias adaptation function as per section 3.4 of RFC 3492.
		 * http://tools.ietf.org/html/rfc3492#section-3.4
		 * @private
		 */
		function adapt(delta, numPoints, firstTime) {
			var k = 0;
			delta = firstTime ? floor(delta / damp) : delta >> 1;
			delta += floor(delta / numPoints);
			for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
				delta = floor(delta / baseMinusTMin);
			}
			return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
		}
	
		/**
		 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
		 * symbols.
		 * @memberOf punycode
		 * @param {String} input The Punycode string of ASCII-only symbols.
		 * @returns {String} The resulting string of Unicode symbols.
		 */
		function decode(input) {
			// Don't use UCS-2
			var output = [],
			    inputLength = input.length,
			    out,
			    i = 0,
			    n = initialN,
			    bias = initialBias,
			    basic,
			    j,
			    index,
			    oldi,
			    w,
			    k,
			    digit,
			    t,
			    length,
			    /** Cached calculation results */
			    baseMinusT;
	
			// Handle the basic code points: let `basic` be the number of input code
			// points before the last delimiter, or `0` if there is none, then copy
			// the first basic code points to the output.
	
			basic = input.lastIndexOf(delimiter);
			if (basic < 0) {
				basic = 0;
			}
	
			for (j = 0; j < basic; ++j) {
				// if it's not a basic code point
				if (input.charCodeAt(j) >= 0x80) {
					error('not-basic');
				}
				output.push(input.charCodeAt(j));
			}
	
			// Main decoding loop: start just after the last delimiter if any basic code
			// points were copied; start at the beginning otherwise.
	
			for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {
	
				// `index` is the index of the next character to be consumed.
				// Decode a generalized variable-length integer into `delta`,
				// which gets added to `i`. The overflow checking is easier
				// if we increase `i` as we go, then subtract off its starting
				// value at the end to obtain `delta`.
				for (oldi = i, w = 1, k = base; /* no condition */; k += base) {
	
					if (index >= inputLength) {
						error('invalid-input');
					}
	
					digit = basicToDigit(input.charCodeAt(index++));
	
					if (digit >= base || digit > floor((maxInt - i) / w)) {
						error('overflow');
					}
	
					i += digit * w;
					t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
	
					if (digit < t) {
						break;
					}
	
					baseMinusT = base - t;
					if (w > floor(maxInt / baseMinusT)) {
						error('overflow');
					}
	
					w *= baseMinusT;
	
				}
	
				out = output.length + 1;
				bias = adapt(i - oldi, out, oldi == 0);
	
				// `i` was supposed to wrap around from `out` to `0`,
				// incrementing `n` each time, so we'll fix that now:
				if (floor(i / out) > maxInt - n) {
					error('overflow');
				}
	
				n += floor(i / out);
				i %= out;
	
				// Insert `n` at position `i` of the output
				output.splice(i++, 0, n);
	
			}
	
			return ucs2encode(output);
		}
	
		/**
		 * Converts a string of Unicode symbols to a Punycode string of ASCII-only
		 * symbols.
		 * @memberOf punycode
		 * @param {String} input The string of Unicode symbols.
		 * @returns {String} The resulting Punycode string of ASCII-only symbols.
		 */
		function encode(input) {
			var n,
			    delta,
			    handledCPCount,
			    basicLength,
			    bias,
			    j,
			    m,
			    q,
			    k,
			    t,
			    currentValue,
			    output = [],
			    /** `inputLength` will hold the number of code points in `input`. */
			    inputLength,
			    /** Cached calculation results */
			    handledCPCountPlusOne,
			    baseMinusT,
			    qMinusT;
	
			// Convert the input in UCS-2 to Unicode
			input = ucs2decode(input);
	
			// Cache the length
			inputLength = input.length;
	
			// Initialize the state
			n = initialN;
			delta = 0;
			bias = initialBias;
	
			// Handle the basic code points
			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue < 0x80) {
					output.push(stringFromCharCode(currentValue));
				}
			}
	
			handledCPCount = basicLength = output.length;
	
			// `handledCPCount` is the number of code points that have been handled;
			// `basicLength` is the number of basic code points.
	
			// Finish the basic string - if it is not empty - with a delimiter
			if (basicLength) {
				output.push(delimiter);
			}
	
			// Main encoding loop:
			while (handledCPCount < inputLength) {
	
				// All non-basic code points < n have been handled already. Find the next
				// larger one:
				for (m = maxInt, j = 0; j < inputLength; ++j) {
					currentValue = input[j];
					if (currentValue >= n && currentValue < m) {
						m = currentValue;
					}
				}
	
				// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
				// but guard against overflow
				handledCPCountPlusOne = handledCPCount + 1;
				if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
					error('overflow');
				}
	
				delta += (m - n) * handledCPCountPlusOne;
				n = m;
	
				for (j = 0; j < inputLength; ++j) {
					currentValue = input[j];
	
					if (currentValue < n && ++delta > maxInt) {
						error('overflow');
					}
	
					if (currentValue == n) {
						// Represent delta as a generalized variable-length integer
						for (q = delta, k = base; /* no condition */; k += base) {
							t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
							if (q < t) {
								break;
							}
							qMinusT = q - t;
							baseMinusT = base - t;
							output.push(
								stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
							);
							q = floor(qMinusT / baseMinusT);
						}
	
						output.push(stringFromCharCode(digitToBasic(q, 0)));
						bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
						delta = 0;
						++handledCPCount;
					}
				}
	
				++delta;
				++n;
	
			}
			return output.join('');
		}
	
		/**
		 * Converts a Punycode string representing a domain name to Unicode. Only the
		 * Punycoded parts of the domain name will be converted, i.e. it doesn't
		 * matter if you call it on a string that has already been converted to
		 * Unicode.
		 * @memberOf punycode
		 * @param {String} domain The Punycode domain name to convert to Unicode.
		 * @returns {String} The Unicode representation of the given Punycode
		 * string.
		 */
		function toUnicode(domain) {
			return mapDomain(domain, function(string) {
				return regexPunycode.test(string)
					? decode(string.slice(4).toLowerCase())
					: string;
			});
		}
	
		/**
		 * Converts a Unicode string representing a domain name to Punycode. Only the
		 * non-ASCII parts of the domain name will be converted, i.e. it doesn't
		 * matter if you call it with a domain that's already in ASCII.
		 * @memberOf punycode
		 * @param {String} domain The domain name to convert, as a Unicode string.
		 * @returns {String} The Punycode representation of the given domain name.
		 */
		function toASCII(domain) {
			return mapDomain(domain, function(string) {
				return regexNonASCII.test(string)
					? 'xn--' + encode(string)
					: string;
			});
		}
	
		/*--------------------------------------------------------------------------*/
	
		/** Define the public API */
		punycode = {
			/**
			 * A string representing the current Punycode.js version number.
			 * @memberOf punycode
			 * @type String
			 */
			'version': '1.2.3',
			/**
			 * An object of methods to convert from JavaScript's internal character
			 * representation (UCS-2) to Unicode code points, and back.
			 * @see <http://mathiasbynens.be/notes/javascript-encoding>
			 * @memberOf punycode
			 * @type Object
			 */
			'ucs2': {
				'decode': ucs2decode,
				'encode': ucs2encode
			},
			'decode': decode,
			'encode': encode,
			'toASCII': toASCII,
			'toUnicode': toUnicode
		};
	
		/** Expose `punycode` */
		// Some AMD build optimizers, like r.js, check for specific condition patterns
		// like the following:
		if (
			true
		) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
				return punycode;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		}	else if (freeExports && !freeExports.nodeType) {
			if (freeModule) { // in Node.js or RingoJS v0.8.0+
				freeModule.exports = punycode;
			} else { // in Narwhal or RingoJS v0.7.0-
				for (key in punycode) {
					punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
				}
			}
		} else { // in Rhino or a web browser
			root.punycode = punycode;
		}
	
	}(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59)(module), (function() { return this; }())))

/***/ },
/* 465 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	 * URI.js - Mutating URLs
	 * IPv6 Support
	 *
	 * Version: 1.16.1
	 *
	 * Author: Rodney Rehm
	 * Web: http://medialize.github.io/URI.js/
	 *
	 * Licensed under
	 *   MIT License http://www.opensource.org/licenses/mit-license
	 *   GPL v3 http://opensource.org/licenses/GPL-3.0
	 *
	 */
	
	(function (root, factory) {
	  'use strict';
	  // https://github.com/umdjs/umd/blob/master/returnExports.js
	  if (true) {
	    // Node
	    module.exports = factory();
	  } else if (typeof define === 'function' && define.amd) {
	    // AMD. Register as an anonymous module.
	    define(factory);
	  } else {
	    // Browser globals (root is window)
	    root.IPv6 = factory(root);
	  }
	}(this, function (root) {
	  'use strict';
	
	  /*
	  var _in = "fe80:0000:0000:0000:0204:61ff:fe9d:f156";
	  var _out = IPv6.best(_in);
	  var _expected = "fe80::204:61ff:fe9d:f156";
	
	  console.log(_in, _out, _expected, _out === _expected);
	  */
	
	  // save current IPv6 variable, if any
	  var _IPv6 = root && root.IPv6;
	
	  function bestPresentation(address) {
	    // based on:
	    // Javascript to test an IPv6 address for proper format, and to
	    // present the "best text representation" according to IETF Draft RFC at
	    // http://tools.ietf.org/html/draft-ietf-6man-text-addr-representation-04
	    // 8 Feb 2010 Rich Brown, Dartware, LLC
	    // Please feel free to use this code as long as you provide a link to
	    // http://www.intermapper.com
	    // http://intermapper.com/support/tools/IPV6-Validator.aspx
	    // http://download.dartware.com/thirdparty/ipv6validator.js
	
	    var _address = address.toLowerCase();
	    var segments = _address.split(':');
	    var length = segments.length;
	    var total = 8;
	
	    // trim colons (:: or ::a:b:c… or …a:b:c::)
	    if (segments[0] === '' && segments[1] === '' && segments[2] === '') {
	      // must have been ::
	      // remove first two items
	      segments.shift();
	      segments.shift();
	    } else if (segments[0] === '' && segments[1] === '') {
	      // must have been ::xxxx
	      // remove the first item
	      segments.shift();
	    } else if (segments[length - 1] === '' && segments[length - 2] === '') {
	      // must have been xxxx::
	      segments.pop();
	    }
	
	    length = segments.length;
	
	    // adjust total segments for IPv4 trailer
	    if (segments[length - 1].indexOf('.') !== -1) {
	      // found a "." which means IPv4
	      total = 7;
	    }
	
	    // fill empty segments them with "0000"
	    var pos;
	    for (pos = 0; pos < length; pos++) {
	      if (segments[pos] === '') {
	        break;
	      }
	    }
	
	    if (pos < total) {
	      segments.splice(pos, 1, '0000');
	      while (segments.length < total) {
	        segments.splice(pos, 0, '0000');
	      }
	
	      length = segments.length;
	    }
	
	    // strip leading zeros
	    var _segments;
	    for (var i = 0; i < total; i++) {
	      _segments = segments[i].split('');
	      for (var j = 0; j < 3 ; j++) {
	        if (_segments[0] === '0' && _segments.length > 1) {
	          _segments.splice(0,1);
	        } else {
	          break;
	        }
	      }
	
	      segments[i] = _segments.join('');
	    }
	
	    // find longest sequence of zeroes and coalesce them into one segment
	    var best = -1;
	    var _best = 0;
	    var _current = 0;
	    var current = -1;
	    var inzeroes = false;
	    // i; already declared
	
	    for (i = 0; i < total; i++) {
	      if (inzeroes) {
	        if (segments[i] === '0') {
	          _current += 1;
	        } else {
	          inzeroes = false;
	          if (_current > _best) {
	            best = current;
	            _best = _current;
	          }
	        }
	      } else {
	        if (segments[i] === '0') {
	          inzeroes = true;
	          current = i;
	          _current = 1;
	        }
	      }
	    }
	
	    if (_current > _best) {
	      best = current;
	      _best = _current;
	    }
	
	    if (_best > 1) {
	      segments.splice(best, _best, '');
	    }
	
	    length = segments.length;
	
	    // assemble remaining segments
	    var result = '';
	    if (segments[0] === '')  {
	      result = ':';
	    }
	
	    for (i = 0; i < length; i++) {
	      result += segments[i];
	      if (i === length - 1) {
	        break;
	      }
	
	      result += ':';
	    }
	
	    if (segments[length - 1] === '') {
	      result += ':';
	    }
	
	    return result;
	  }
	
	  function noConflict() {
	    /*jshint validthis: true */
	    if (root.IPv6 === this) {
	      root.IPv6 = _IPv6;
	    }
	  
	    return this;
	  }
	
	  return {
	    best: bestPresentation,
	    noConflict: noConflict
	  };
	}));


/***/ },
/* 466 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	 * URI.js - Mutating URLs
	 * Second Level Domain (SLD) Support
	 *
	 * Version: 1.16.1
	 *
	 * Author: Rodney Rehm
	 * Web: http://medialize.github.io/URI.js/
	 *
	 * Licensed under
	 *   MIT License http://www.opensource.org/licenses/mit-license
	 *   GPL v3 http://opensource.org/licenses/GPL-3.0
	 *
	 */
	
	(function (root, factory) {
	  'use strict';
	  // https://github.com/umdjs/umd/blob/master/returnExports.js
	  if (true) {
	    // Node
	    module.exports = factory();
	  } else if (typeof define === 'function' && define.amd) {
	    // AMD. Register as an anonymous module.
	    define(factory);
	  } else {
	    // Browser globals (root is window)
	    root.SecondLevelDomains = factory(root);
	  }
	}(this, function (root) {
	  'use strict';
	
	  // save current SecondLevelDomains variable, if any
	  var _SecondLevelDomains = root && root.SecondLevelDomains;
	
	  var SLD = {
	    // list of known Second Level Domains
	    // converted list of SLDs from https://github.com/gavingmiller/second-level-domains
	    // ----
	    // publicsuffix.org is more current and actually used by a couple of browsers internally.
	    // downside is it also contains domains like "dyndns.org" - which is fine for the security
	    // issues browser have to deal with (SOP for cookies, etc) - but is way overboard for URI.js
	    // ----
	    list: {
	      'ac':' com gov mil net org ',
	      'ae':' ac co gov mil name net org pro sch ',
	      'af':' com edu gov net org ',
	      'al':' com edu gov mil net org ',
	      'ao':' co ed gv it og pb ',
	      'ar':' com edu gob gov int mil net org tur ',
	      'at':' ac co gv or ',
	      'au':' asn com csiro edu gov id net org ',
	      'ba':' co com edu gov mil net org rs unbi unmo unsa untz unze ',
	      'bb':' biz co com edu gov info net org store tv ',
	      'bh':' biz cc com edu gov info net org ',
	      'bn':' com edu gov net org ',
	      'bo':' com edu gob gov int mil net org tv ',
	      'br':' adm adv agr am arq art ato b bio blog bmd cim cng cnt com coop ecn edu eng esp etc eti far flog fm fnd fot fst g12 ggf gov imb ind inf jor jus lel mat med mil mus net nom not ntr odo org ppg pro psc psi qsl rec slg srv tmp trd tur tv vet vlog wiki zlg ',
	      'bs':' com edu gov net org ',
	      'bz':' du et om ov rg ',
	      'ca':' ab bc mb nb nf nl ns nt nu on pe qc sk yk ',
	      'ck':' biz co edu gen gov info net org ',
	      'cn':' ac ah bj com cq edu fj gd gov gs gx gz ha hb he hi hl hn jl js jx ln mil net nm nx org qh sc sd sh sn sx tj tw xj xz yn zj ',
	      'co':' com edu gov mil net nom org ',
	      'cr':' ac c co ed fi go or sa ',
	      'cy':' ac biz com ekloges gov ltd name net org parliament press pro tm ',
	      'do':' art com edu gob gov mil net org sld web ',
	      'dz':' art asso com edu gov net org pol ',
	      'ec':' com edu fin gov info med mil net org pro ',
	      'eg':' com edu eun gov mil name net org sci ',
	      'er':' com edu gov ind mil net org rochest w ',
	      'es':' com edu gob nom org ',
	      'et':' biz com edu gov info name net org ',
	      'fj':' ac biz com info mil name net org pro ',
	      'fk':' ac co gov net nom org ',
	      'fr':' asso com f gouv nom prd presse tm ',
	      'gg':' co net org ',
	      'gh':' com edu gov mil org ',
	      'gn':' ac com gov net org ',
	      'gr':' com edu gov mil net org ',
	      'gt':' com edu gob ind mil net org ',
	      'gu':' com edu gov net org ',
	      'hk':' com edu gov idv net org ',
	      'hu':' 2000 agrar bolt casino city co erotica erotika film forum games hotel info ingatlan jogasz konyvelo lakas media news org priv reklam sex shop sport suli szex tm tozsde utazas video ',
	      'id':' ac co go mil net or sch web ',
	      'il':' ac co gov idf k12 muni net org ',
	      'in':' ac co edu ernet firm gen gov i ind mil net nic org res ',
	      'iq':' com edu gov i mil net org ',
	      'ir':' ac co dnssec gov i id net org sch ',
	      'it':' edu gov ',
	      'je':' co net org ',
	      'jo':' com edu gov mil name net org sch ',
	      'jp':' ac ad co ed go gr lg ne or ',
	      'ke':' ac co go info me mobi ne or sc ',
	      'kh':' com edu gov mil net org per ',
	      'ki':' biz com de edu gov info mob net org tel ',
	      'km':' asso com coop edu gouv k medecin mil nom notaires pharmaciens presse tm veterinaire ',
	      'kn':' edu gov net org ',
	      'kr':' ac busan chungbuk chungnam co daegu daejeon es gangwon go gwangju gyeongbuk gyeonggi gyeongnam hs incheon jeju jeonbuk jeonnam k kg mil ms ne or pe re sc seoul ulsan ',
	      'kw':' com edu gov net org ',
	      'ky':' com edu gov net org ',
	      'kz':' com edu gov mil net org ',
	      'lb':' com edu gov net org ',
	      'lk':' assn com edu gov grp hotel int ltd net ngo org sch soc web ',
	      'lr':' com edu gov net org ',
	      'lv':' asn com conf edu gov id mil net org ',
	      'ly':' com edu gov id med net org plc sch ',
	      'ma':' ac co gov m net org press ',
	      'mc':' asso tm ',
	      'me':' ac co edu gov its net org priv ',
	      'mg':' com edu gov mil nom org prd tm ',
	      'mk':' com edu gov inf name net org pro ',
	      'ml':' com edu gov net org presse ',
	      'mn':' edu gov org ',
	      'mo':' com edu gov net org ',
	      'mt':' com edu gov net org ',
	      'mv':' aero biz com coop edu gov info int mil museum name net org pro ',
	      'mw':' ac co com coop edu gov int museum net org ',
	      'mx':' com edu gob net org ',
	      'my':' com edu gov mil name net org sch ',
	      'nf':' arts com firm info net other per rec store web ',
	      'ng':' biz com edu gov mil mobi name net org sch ',
	      'ni':' ac co com edu gob mil net nom org ',
	      'np':' com edu gov mil net org ',
	      'nr':' biz com edu gov info net org ',
	      'om':' ac biz co com edu gov med mil museum net org pro sch ',
	      'pe':' com edu gob mil net nom org sld ',
	      'ph':' com edu gov i mil net ngo org ',
	      'pk':' biz com edu fam gob gok gon gop gos gov net org web ',
	      'pl':' art bialystok biz com edu gda gdansk gorzow gov info katowice krakow lodz lublin mil net ngo olsztyn org poznan pwr radom slupsk szczecin torun warszawa waw wroc wroclaw zgora ',
	      'pr':' ac biz com edu est gov info isla name net org pro prof ',
	      'ps':' com edu gov net org plo sec ',
	      'pw':' belau co ed go ne or ',
	      'ro':' arts com firm info nom nt org rec store tm www ',
	      'rs':' ac co edu gov in org ',
	      'sb':' com edu gov net org ',
	      'sc':' com edu gov net org ',
	      'sh':' co com edu gov net nom org ',
	      'sl':' com edu gov net org ',
	      'st':' co com consulado edu embaixada gov mil net org principe saotome store ',
	      'sv':' com edu gob org red ',
	      'sz':' ac co org ',
	      'tr':' av bbs bel biz com dr edu gen gov info k12 name net org pol tel tsk tv web ',
	      'tt':' aero biz cat co com coop edu gov info int jobs mil mobi museum name net org pro tel travel ',
	      'tw':' club com ebiz edu game gov idv mil net org ',
	      'mu':' ac co com gov net or org ',
	      'mz':' ac co edu gov org ',
	      'na':' co com ',
	      'nz':' ac co cri geek gen govt health iwi maori mil net org parliament school ',
	      'pa':' abo ac com edu gob ing med net nom org sld ',
	      'pt':' com edu gov int net nome org publ ',
	      'py':' com edu gov mil net org ',
	      'qa':' com edu gov mil net org ',
	      're':' asso com nom ',
	      'ru':' ac adygeya altai amur arkhangelsk astrakhan bashkiria belgorod bir bryansk buryatia cbg chel chelyabinsk chita chukotka chuvashia com dagestan e-burg edu gov grozny int irkutsk ivanovo izhevsk jar joshkar-ola kalmykia kaluga kamchatka karelia kazan kchr kemerovo khabarovsk khakassia khv kirov koenig komi kostroma kranoyarsk kuban kurgan kursk lipetsk magadan mari mari-el marine mil mordovia mosreg msk murmansk nalchik net nnov nov novosibirsk nsk omsk orenburg org oryol penza perm pp pskov ptz rnd ryazan sakhalin samara saratov simbirsk smolensk spb stavropol stv surgut tambov tatarstan tom tomsk tsaritsyn tsk tula tuva tver tyumen udm udmurtia ulan-ude vladikavkaz vladimir vladivostok volgograd vologda voronezh vrn vyatka yakutia yamal yekaterinburg yuzhno-sakhalinsk ',
	      'rw':' ac co com edu gouv gov int mil net ',
	      'sa':' com edu gov med net org pub sch ',
	      'sd':' com edu gov info med net org tv ',
	      'se':' a ac b bd c d e f g h i k l m n o org p parti pp press r s t tm u w x y z ',
	      'sg':' com edu gov idn net org per ',
	      'sn':' art com edu gouv org perso univ ',
	      'sy':' com edu gov mil net news org ',
	      'th':' ac co go in mi net or ',
	      'tj':' ac biz co com edu go gov info int mil name net nic org test web ',
	      'tn':' agrinet com defense edunet ens fin gov ind info intl mincom nat net org perso rnrt rns rnu tourism ',
	      'tz':' ac co go ne or ',
	      'ua':' biz cherkassy chernigov chernovtsy ck cn co com crimea cv dn dnepropetrovsk donetsk dp edu gov if in ivano-frankivsk kh kharkov kherson khmelnitskiy kiev kirovograd km kr ks kv lg lugansk lutsk lviv me mk net nikolaev od odessa org pl poltava pp rovno rv sebastopol sumy te ternopil uzhgorod vinnica vn zaporizhzhe zhitomir zp zt ',
	      'ug':' ac co go ne or org sc ',
	      'uk':' ac bl british-library co cym gov govt icnet jet lea ltd me mil mod national-library-scotland nel net nhs nic nls org orgn parliament plc police sch scot soc ',
	      'us':' dni fed isa kids nsn ',
	      'uy':' com edu gub mil net org ',
	      've':' co com edu gob info mil net org web ',
	      'vi':' co com k12 net org ',
	      'vn':' ac biz com edu gov health info int name net org pro ',
	      'ye':' co com gov ltd me net org plc ',
	      'yu':' ac co edu gov org ',
	      'za':' ac agric alt bourse city co cybernet db edu gov grondar iaccess imt inca landesign law mil net ngo nis nom olivetti org pix school tm web ',
	      'zm':' ac co com edu gov net org sch '
	    },
	    // gorhill 2013-10-25: Using indexOf() instead Regexp(). Significant boost
	    // in both performance and memory footprint. No initialization required.
	    // http://jsperf.com/uri-js-sld-regex-vs-binary-search/4
	    // Following methods use lastIndexOf() rather than array.split() in order
	    // to avoid any memory allocations.
	    has: function(domain) {
	      var tldOffset = domain.lastIndexOf('.');
	      if (tldOffset <= 0 || tldOffset >= (domain.length-1)) {
	        return false;
	      }
	      var sldOffset = domain.lastIndexOf('.', tldOffset-1);
	      if (sldOffset <= 0 || sldOffset >= (tldOffset-1)) {
	        return false;
	      }
	      var sldList = SLD.list[domain.slice(tldOffset+1)];
	      if (!sldList) {
	        return false;
	      }
	      return sldList.indexOf(' ' + domain.slice(sldOffset+1, tldOffset) + ' ') >= 0;
	    },
	    is: function(domain) {
	      var tldOffset = domain.lastIndexOf('.');
	      if (tldOffset <= 0 || tldOffset >= (domain.length-1)) {
	        return false;
	      }
	      var sldOffset = domain.lastIndexOf('.', tldOffset-1);
	      if (sldOffset >= 0) {
	        return false;
	      }
	      var sldList = SLD.list[domain.slice(tldOffset+1)];
	      if (!sldList) {
	        return false;
	      }
	      return sldList.indexOf(' ' + domain.slice(0, tldOffset) + ' ') >= 0;
	    },
	    get: function(domain) {
	      var tldOffset = domain.lastIndexOf('.');
	      if (tldOffset <= 0 || tldOffset >= (domain.length-1)) {
	        return null;
	      }
	      var sldOffset = domain.lastIndexOf('.', tldOffset-1);
	      if (sldOffset <= 0 || sldOffset >= (tldOffset-1)) {
	        return null;
	      }
	      var sldList = SLD.list[domain.slice(tldOffset+1)];
	      if (!sldList) {
	        return null;
	      }
	      if (sldList.indexOf(' ' + domain.slice(sldOffset+1, tldOffset) + ' ') < 0) {
	        return null;
	      }
	      return domain.slice(sldOffset+1);
	    },
	    noConflict: function(){
	      if (root.SecondLevelDomains === this) {
	        root.SecondLevelDomains = _SecondLevelDomains;
	      }
	      return this;
	    }
	  };
	
	  return SLD;
	}));


/***/ },
/* 467 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var settings = __webpack_require__(62);
	
	var trackBing16 = function trackBing16(event, action, label, value) {
	  if (settings.tracking.gactive && settings.tracking.bingTracking) {
	
	    var uetqGoal16 = window.uetqGoal16 || [];
	    uetqGoal16.push({
	      'ec': event,
	      'ea': action,
	      'el': label || '',
	      'ev': value || 1
	    });
	  } else {
	    console.log('Bing tracking (goal 16) disabled', event, action, label, value);
	  }
	};
	
	module.exports = trackBing16;

/***/ },
/* 468 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var settings = __webpack_require__(62);
	
	var trackFacebook = function trackFacebook(tag_id, value, currency) {
	  if (settings.tracking.gactive && settings.tracking.facebookTracking) {
	
	    var _fbq = window._fbq || [];
	    _fbq.push(['track', tag_id, { 'value': value, 'currency': currency }]);
	  } else {
	    console.log('Facebook tracking disabled (tag_id:' + tag_id + ')');
	  }
	};
	
	module.exports = trackFacebook;

/***/ },
/* 469 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var React = __webpack_require__(40);
	var Fluxxor = __webpack_require__(69);
	var _ = __webpack_require__(66);
	
	var LanguageStore = Fluxxor.createStore({
	  actions: {
	    ACCEPT_LANGUAGE_WARNING: 'onAcceptLanguageWarning',
	    SET_LANGUAGE: 'onSetLanguage'
	  },
	
	  initialize: function initialize(options) {
	    this.setMaxListeners(0);
	    this.state = _.clone(options);
	  },
	
	  onAcceptLanguageWarning: function onAcceptLanguageWarning() {
	    this.state = React.addons.update(this.state, {
	      acceptedWarning: { $set: true }
	    });
	    document.cookie = 'accepted_language_warning=true; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/';
	    this.emit('change');
	  },
	
	  onSetLanguage: function onSetLanguage(payload) {
	    document.cookie = 'language=en; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/';
	    window.location.reload();
	  },
	
	  getState: function getState() {
	    return this.state;
	  }
	
	});
	
	module.exports = LanguageStore;

/***/ },
/* 470 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = init;
	
	var _jquery = __webpack_require__(39);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactAddons = __webpack_require__(40);
	
	var _reactAddons2 = _interopRequireDefault(_reactAddons);
	
	var _ofsComponentsSimpleChoiceSimpleChoice = __webpack_require__(47);
	
	var _ofsComponentsDatePickerNext = __webpack_require__(471);
	
	var _ofsComponentsDatePickerNext2 = _interopRequireDefault(_ofsComponentsDatePickerNext);
	
	function hideDrawer($drawer) {
	  $drawer.removeClass('ofs-NavigationDrawer--is-visible').data('open', false);
	
	  return $drawer;
	}
	
	function openDrawer($drawer) {
	  $drawer.addClass('ofs-NavigationDrawer--is-visible').data('open', true);
	
	  return $drawer;
	}
	
	// headerSearch should always show on the homepage
	function safeHideHeaderSearch($headerSearch) {
	  if (!$headerSearch.data('always-visible')) {
	    $headerSearch.removeClass('ofs-HeaderSearch--is-visible').data('open', false);
	  }
	}
	
	function initDrawers() {
	  // WARNING: jQuery soup ahead
	  var $headerSearch = (0, _jquery2['default'])('.ofs-HeaderSearch').data('open', false);
	  var $searchDrawer = (0, _jquery2['default'])('#search-navigation-drawer').data('open', false);
	  var $serviceDrawer = (0, _jquery2['default'])('#service-navigation-drawer').data('open', false);
	  var $accountDrawer = (0, _jquery2['default'])('#account-navigation-drawer').data('open', false);
	  var $contactDrawer = (0, _jquery2['default'])('#contact-navigation-drawer').data('open', false);
	
	  (0, _jquery2['default'])('#search-toggle').on('click', function (event) {
	    event.preventDefault();
	    (0, _jquery2['default'])('.ofs-GlobalHeader__MenuItem').removeClass('ofs-GlobalHeader__MenuItem--active');
	    if ($searchDrawer.data('open')) {
	      hideDrawer($searchDrawer);
	      safeHideHeaderSearch($headerSearch);
	    } else {
	      (0, _jquery2['default'])(this).addClass('ofs-GlobalHeader__MenuItem--active');
	      openDrawer($searchDrawer);
	      hideDrawer($serviceDrawer);
	      hideDrawer($accountDrawer);
	      $headerSearch.addClass('ofs-HeaderSearch--is-visible').data('open', true);
	    }
	  });
	
	  (0, _jquery2['default'])('#service-toggle').on('click', function (event) {
	    event.preventDefault();
	    (0, _jquery2['default'])('.ofs-GlobalHeader__MenuItem').removeClass('ofs-GlobalHeader__MenuItem--active');
	    if ($serviceDrawer.data('open')) {
	      hideDrawer($serviceDrawer);
	    } else {
	      (0, _jquery2['default'])(this).addClass('ofs-GlobalHeader__MenuItem--active');
	      openDrawer($serviceDrawer);
	      hideDrawer($searchDrawer);
	      hideDrawer($accountDrawer);
	      safeHideHeaderSearch($headerSearch);
	    }
	  });
	
	  (0, _jquery2['default'])('#account-toggle').on('click', function (event) {
	    event.preventDefault();
	    (0, _jquery2['default'])('.ofs-GlobalHeader__MenuItem').removeClass('ofs-GlobalHeader__MenuItem--active');
	    if ($accountDrawer.data('open')) {
	      hideDrawer($accountDrawer);
	    } else {
	      (0, _jquery2['default'])(this).addClass('ofs-GlobalHeader__MenuItem--active');
	      openDrawer($accountDrawer);
	      hideDrawer($searchDrawer);
	      hideDrawer($serviceDrawer);
	      safeHideHeaderSearch($headerSearch);
	    }
	  });
	
	  (0, _jquery2['default'])('#mobile-search-toggle').on('click', function (event) {
	    event.preventDefault();
	    $headerSearch.toggleClass('ofs-HeaderSearch--is-visible');
	    hideDrawer($contactDrawer);
	  });
	
	  (0, _jquery2['default'])('#mobile-contact-toggle').on('click', function (event) {
	    event.preventDefault();
	
	    if ($contactDrawer.data('open')) {
	      hideDrawer($contactDrawer);
	    } else {
	      openDrawer($contactDrawer);
	      hideDrawer($searchDrawer);
	      hideDrawer($accountDrawer);
	      $headerSearch.removeClass('ofs-HeaderSearch--is-visible').data('open', false);
	    }
	  });
	}
	
	function init() {
	  initDrawers();
	
	  // init search form
	  var region = (0, _ofsComponentsSimpleChoiceSimpleChoice.init)((0, _jquery2['default'])('#header-quicksearch_region'));
	  var sleeps = (0, _ofsComponentsSimpleChoiceSimpleChoice.init)((0, _jquery2['default'])('#header-quicksearch_sleeps'));
	  region.classList.add('bdd-quicksearch-field-region');
	  sleeps.classList.add('bdd-quicksearch-field-sleeps');
	
	  // init datepickers
	  var startDate = (0, _jquery2['default'])('#header-quicksearch_start_date').val();
	  var endDate = (0, _jquery2['default'])('#header-quicksearch_end_date').val();
	
	  if (startDate && endDate) {
	    startDate = new Date(startDate);
	    endDate = new Date(endDate);
	  } else {
	    startDate = null;
	    endDate = null;
	  }
	
	  var datePickerEl = document.getElementById('header-quicksearch_date_picker');
	
	  if (datePickerEl) {
	    _reactAddons2['default'].render(_reactAddons2['default'].createElement(_ofsComponentsDatePickerNext2['default'], { startValue: startDate, endValue: endDate }), datePickerEl);
	  }
	}
	
	module.exports = exports['default'];

/***/ },
/* 471 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequire = __webpack_require__(472)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _DatePicker = __webpack_require__(473);
	
	exports['default'] = _interopRequire(_DatePicker);
	module.exports = exports['default'];

/***/ },
/* 472 */
/***/ function(module, exports) {

	"use strict";
	
	exports["default"] = function (obj) {
	  return obj && obj.__esModule ? obj["default"] : obj;
	};
	
	exports.__esModule = true;

/***/ },
/* 473 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _reactAddons = __webpack_require__(40);
	
	var _reactAddons2 = _interopRequireDefault(_reactAddons);
	
	var _classnames = __webpack_require__(49);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _jquery = __webpack_require__(39);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactRespondTo = __webpack_require__(474);
	
	var _ofsMoment = __webpack_require__(57);
	
	var _ofsMoment2 = _interopRequireDefault(_ofsMoment);
	
	var _ofsComponentsCommonIcon = __webpack_require__(51);
	
	var _ofsComponentsCommonIcon2 = _interopRequireDefault(_ofsComponentsCommonIcon);
	
	var _ofsComponentsCalendar = __webpack_require__(477);
	
	var _ofsComponentsLayersModalNext = __webpack_require__(486);
	
	var _ofsComponentsLayersModalNext2 = _interopRequireDefault(_ofsComponentsLayersModalNext);
	
	var _ofsComponentsLayersPopoverNext = __webpack_require__(490);
	
	var _ofsComponentsLayersPopoverNext2 = _interopRequireDefault(_ofsComponentsLayersPopoverNext);
	
	var _ofsUtilsOnMount = __webpack_require__(491);
	
	var _ofsUtilsOnMount2 = _interopRequireDefault(_ofsUtilsOnMount);
	
	var _ofsUtilsDatesAreSame = __webpack_require__(482);
	
	var _ofsUtilsDatesAreSame2 = _interopRequireDefault(_ofsUtilsDatesAreSame);
	
	var _ofsI18n = __webpack_require__(61);
	
	// Return iso format for date if defined
	function getISOFormat(date) {
	  return date ? (0, _ofsMoment2['default'])(date).isoDateFormat() : null;
	}
	
	// Return display format for date if defined
	function getDisplay(date) {
	  return date ? (0, _ofsMoment2['default'])(date).longDateFormat() : null;
	}
	
	var MESSAGES = {
	  ARRIVAL_DATE: (0, _ofsI18n.gettext)('Arrival date'),
	  DEPARTURE_DATE: (0, _ofsI18n.gettext)('Departure date'),
	  SELECT_DATE: (0, _ofsI18n.gettext)('Select date')
	};
	
	var MODAL_DELAY = 200;
	var POPUP_DELAY = 150;
	
	var DatePicker = _reactAddons2['default'].createClass({
	  displayName: 'DatePicker',
	
	  propTypes: {
	    startValue: _reactAddons.PropTypes.instanceOf(Date),
	    endValue: _reactAddons.PropTypes.instanceOf(Date),
	
	    startFieldName: _reactAddons.PropTypes.string,
	    endFieldName: _reactAddons.PropTypes.string,
	    showLabels: _reactAddons.PropTypes.bool,
	
	    onChange: _reactAddons.PropTypes.func,
	    renderDate: _reactAddons.PropTypes.func,
	    renderCalendarFooter: _reactAddons.PropTypes.func
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      showLabels: true,
	      startFieldName: 'start_date',
	      endFieldName: 'end_date',
	      onChange: function onChange() {}
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      startValue: undefined,
	      endValue: undefined,
	
	      transitioning: false,
	
	      startSelected: false,
	      endSelected: false
	    };
	  },
	
	  getStart: function getStart() {
	    return typeof this.state.startValue === 'undefined' ? this.props.startValue : this.state.startValue;
	  },
	
	  getEnd: function getEnd() {
	    return typeof this.state.endValue === 'undefined' ? this.props.endValue : this.state.endValue;
	  },
	
	  handleStartClick: function handleStartClick(event) {
	    event.preventDefault();
	    this.setState({
	      'startSelected': true
	    });
	  },
	
	  handleEndClick: function handleEndClick(event) {
	    event.preventDefault();
	
	    var start = this.getStart();
	
	    // Open start if not arrival value
	    if (!start) {
	      this.setState({
	        'startSelected': true
	      });
	    } else {
	      this.setState({
	        'endSelected': true
	      });
	    }
	  },
	
	  handleStartClose: function handleStartClose(event) {
	    event.preventDefault();
	    event.stopPropagation();
	
	    if (!_jquery2['default'].contains(this.refs.startField.getDOMNode(), event.target)) {
	      this.setState({
	        'startSelected': false,
	        'transitioning': false
	      });
	    }
	  },
	
	  handleEndClose: function handleEndClose(event) {
	    event.preventDefault();
	    event.stopPropagation();
	
	    var onChange = this.props.onChange;
	
	    if (_jquery2['default'].contains(this.refs.endField.getDOMNode(), event.target)) {
	      return;
	    }
	
	    var start = this.getStart();
	    var end = this.getEnd();
	
	    if (!end && start) {
	      var momentVal = (0, _ofsMoment2['default'])(start);
	      momentVal.add(3, 'days');
	      end = momentVal.toDate();
	
	      onChange(start, end);
	    }
	
	    this.setState({
	      'endSelected': false,
	      'endValue': end,
	      'transitioning': false
	    });
	  },
	
	  handleModalClose: function handleModalClose(event) {
	    event.preventDefault();
	    event.stopPropagation();
	
	    var onChange = this.props.onChange;
	
	    var start = this.getStart();
	    var end = this.getEnd();
	
	    if (!end && start) {
	      var momentVal = (0, _ofsMoment2['default'])(start);
	      momentVal.add(3, 'days');
	      end = momentVal.toDate();
	
	      onChange(start, end);
	    }
	
	    this.setState({
	      'startSelected': false,
	      'endSelected': false,
	      'endValue': end,
	      'transitioning': false
	    });
	  },
	
	  handleStartSelect: function handleStartSelect(selectedDate) {
	    var _this = this;
	
	    var onChange = this.props.onChange;
	
	    var end = this.getEnd();
	
	    // clear end value if there is no end value or selectedDate is after end
	    var openEndPopover = !end || end && selectedDate > end;
	    var endValue = openEndPopover ? null : end;
	
	    this.setState({
	      startValue: selectedDate,
	      startSelected: false,
	      transitioning: openEndPopover ? true : false
	    }, function () {
	      _this.setState({
	        endValue: endValue,
	        endSelected: openEndPopover ? true : false
	      });
	    });
	
	    if (endValue) {
	      onChange(selectedDate, endValue);
	    }
	  },
	
	  handleEndSelect: function handleEndSelect(selectedDate) {
	    var onChange = this.props.onChange;
	
	    var start = this.getStart();
	
	    this.setState({
	      endValue: selectedDate,
	      endSelected: false,
	      transitioning: false
	    });
	
	    onChange(start, selectedDate);
	  },
	
	  // Determine whether date should be selected for the end date picker
	  selectedDates: function selectedDates(date) {
	    var start = this.getStart();
	    var end = this.getEnd();
	
	    if (start && (0, _ofsUtilsDatesAreSame2['default'])(start, date)) {
	      return true;
	    }
	
	    if (end && (0, _ofsUtilsDatesAreSame2['default'])(end, date)) {
	      return true;
	    }
	    return false;
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (!(0, _ofsUtilsDatesAreSame2['default'])(this.props.startValue, nextProps.startValue) || !(0, _ofsUtilsDatesAreSame2['default'])(this.props.endValue, nextProps.endValue)) {
	      this.replaceState({
	        startSelected: false,
	        endSelected: false
	      });
	    }
	  },
	
	  renderCalendarFooter: function renderCalendarFooter() {
	    var renderCalendarFooter = this.props.renderCalendarFooter;
	
	    if (typeof renderCalendarFooter === 'function') {
	      return renderCalendarFooter();
	    }
	
	    return null;
	  },
	
	  render: function render() {
	    var _this2 = this;
	
	    var _props = this.props;
	    var startFieldName = _props.startFieldName;
	    var endFieldName = _props.endFieldName;
	    var showLabels = _props.showLabels;
	    var renderDate = _props.renderDate;
	    var _state = this.state;
	    var startSelected = _state.startSelected;
	    var endSelected = _state.endSelected;
	    var transitioning = _state.transitioning;
	
	    var start = this.getStart();
	    var end = this.getEnd();
	
	    var inputClasses = (0, _classnames2['default'])({
	      'ofs-Input': true,
	      'ofs-Input--date': true,
	      'u-pointer': true,
	      'u-no-select': true
	    });
	
	    var initialDate = start ? start : null;
	    if (!initialDate && end) {
	      initialDate = end;
	    }
	
	    var startCalendar = _reactAddons2['default'].createElement(_ofsComponentsCalendar.Calendar, {
	      minimumDate: new Date(),
	      weekStarts: 1,
	      value: start,
	      initialDate: initialDate,
	      onSelect: this.handleStartSelect,
	      isSelected: this.selectedDates,
	      renderDate: renderDate
	    });
	
	    var endCalendar = _reactAddons2['default'].createElement(_ofsComponentsCalendar.Calendar, {
	      minimumDate: start ? start : new Date(),
	      weekStarts: 1,
	      value: end,
	      onSelect: this.handleEndSelect,
	      initialDate: initialDate,
	      isSelected: this.selectedDates,
	      renderDate: renderDate
	    });
	
	    var modalHeading = _reactAddons2['default'].createElement(
	      'div',
	      { className: 'ofs-Modal__Heading' },
	      _reactAddons2['default'].createElement(
	        'div',
	        { className: 'ofs-DatePicker__Header' },
	        _reactAddons2['default'].createElement(
	          'div',
	          { className: 'ofs-DatePicker__HeaderText', style: { 'opacity': startSelected ? 1 : 0 } },
	          MESSAGES['ARRIVAL_DATE']
	        ),
	        _reactAddons2['default'].createElement(
	          'div',
	          { className: 'ofs-DatePicker__HeaderText', style: { 'opacity': endSelected ? 1 : 0 } },
	          MESSAGES['DEPARTURE_DATE']
	        )
	      )
	    );
	
	    return _reactAddons2['default'].createElement(
	      'div',
	      null,
	      _reactAddons2['default'].createElement(
	        'div',
	        { className: 'ofs-Form__Field', ref: 'startField' },
	        showLabels && _reactAddons2['default'].createElement(
	          'label',
	          { className: 'ofs-Form__Label', onClick: this.handleStartClick },
	          MESSAGES['ARRIVAL_DATE']
	        ),
	        _reactAddons2['default'].createElement('input', { type: 'hidden',
	          name: startFieldName,
	          value: getISOFormat(start) }),
	        _reactAddons2['default'].createElement(
	          'div',
	          { className: 'ofs-Input__Wrapper', ref: 'startInput' },
	          _reactAddons2['default'].createElement(
	            'div',
	            { className: inputClasses + ' bdd-quicksearch-field-start-date', onClick: this.handleStartClick },
	            start ? _reactAddons2['default'].createElement(
	              'span',
	              { className: 'value' },
	              getDisplay(start)
	            ) : _reactAddons2['default'].createElement(
	              'span',
	              { className: 'ofs-Input__Placeholder' },
	              MESSAGES['SELECT_DATE']
	            )
	          ),
	          _reactAddons2['default'].createElement(
	            'div',
	            { className: 'ofs-Input__Icon', onClick: this.handleStartClick },
	            _reactAddons2['default'].createElement(_ofsComponentsCommonIcon2['default'], { glyph: 'calendar', size: 'small' })
	          )
	        )
	      ),
	      _reactAddons2['default'].createElement(
	        _ofsUtilsOnMount2['default'],
	        null,
	        function () {
	          return _reactAddons2['default'].createElement(
	            _reactRespondTo.Respond,
	            { to: 'min-width' },
	            _reactAddons2['default'].createElement(
	              _reactRespondTo.At,
	              { value: '640px' },
	              _reactAddons2['default'].createElement(
	                _ofsComponentsLayersPopoverNext2['default'],
	                {
	                  isOpen: startSelected,
	                  closeTimeoutMS: POPUP_DELAY,
	                  onRequestClose: _this2.handleStartClose,
	                  attachTo: _this2.refs.startInput
	                },
	                startCalendar,
	                _this2.renderCalendarFooter()
	              )
	            )
	          );
	        }
	      ),
	      _reactAddons2['default'].createElement(
	        'div',
	        { className: 'ofs-Form__Field', ref: 'endField' },
	        showLabels && _reactAddons2['default'].createElement(
	          'label',
	          { className: 'ofs-Form__Label', onClick: this.handleEndClick },
	          MESSAGES['DEPARTURE_DATE']
	        ),
	        _reactAddons2['default'].createElement('input', { type: 'hidden',
	          name: endFieldName,
	          value: getISOFormat(end) }),
	        _reactAddons2['default'].createElement(
	          'div',
	          { className: 'ofs-Input__Wrapper', ref: 'endInput' },
	          _reactAddons2['default'].createElement(
	            'div',
	            { className: inputClasses + ' bdd-quicksearch-field-end-date', onClick: this.handleEndClick },
	            end ? _reactAddons2['default'].createElement(
	              'span',
	              { className: 'value' },
	              getDisplay(end)
	            ) : _reactAddons2['default'].createElement(
	              'span',
	              { className: 'ofs-Input__Placeholder' },
	              MESSAGES['SELECT_DATE']
	            )
	          ),
	          _reactAddons2['default'].createElement(
	            'div',
	            { className: 'ofs-Input__Icon', onClick: this.handleEndClick },
	            _reactAddons2['default'].createElement(_ofsComponentsCommonIcon2['default'], { glyph: 'calendar', size: 'small' })
	          )
	        )
	      ),
	      _reactAddons2['default'].createElement(
	        _ofsUtilsOnMount2['default'],
	        null,
	        function () {
	          return _reactAddons2['default'].createElement(
	            _reactRespondTo.Respond,
	            { to: 'min-width' },
	            _reactAddons2['default'].createElement(
	              _reactRespondTo.At,
	              { value: '640px' },
	              _reactAddons2['default'].createElement(
	                _ofsComponentsLayersPopoverNext2['default'],
	                {
	                  isOpen: endSelected,
	                  closeTimeoutMS: POPUP_DELAY,
	                  onRequestClose: _this2.handleEndClose,
	                  attachTo: _this2.refs.endInput
	                },
	                endCalendar,
	                _this2.renderCalendarFooter()
	              )
	            )
	          );
	        }
	      ),
	      _reactAddons2['default'].createElement(
	        _ofsUtilsOnMount2['default'],
	        null,
	        function () {
	          return _reactAddons2['default'].createElement(
	            _reactRespondTo.Respond,
	            { to: 'max-width' },
	            _reactAddons2['default'].createElement(
	              _reactRespondTo.At,
	              { value: '639px' },
	              _reactAddons2['default'].createElement(
	                _ofsComponentsLayersModalNext2['default'],
	                {
	                  isOpen: startSelected || endSelected || transitioning,
	                  closeTimeoutMS: MODAL_DELAY,
	                  onRequestClose: _this2.handleModalClose,
	                  className: 'ofs-Modal--centered',
	                  modalStyle: {
	                    'marginTop': startSelected ? '-25px' : '25px'
	                  }
	                },
	                modalHeading,
	                startSelected ? startCalendar : endCalendar,
	                _this2.renderCalendarFooter()
	              )
	            )
	          );
	        }
	      )
	    );
	  }
	});
	
	exports['default'] = DatePicker;
	module.exports = exports['default'];

/***/ },
/* 474 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _At = __webpack_require__(475);
	
	var _At2 = _interopRequireDefault(_At);
	
	var _Respond = __webpack_require__(476);
	
	var _Respond2 = _interopRequireDefault(_Respond);
	
	exports.At = _At2['default'];
	exports.Respond = _Respond2['default'];

/***/ },
/* 475 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(40);
	
	var _react2 = _interopRequireDefault(_react);
	
	var At = _react2['default'].createClass({
	  displayName: 'At',
	
	  propTypes: {
	    'default': function _default(props, propName) {
	      if (props.value || props[propName]) {
	        return null;
	      }
	      return new Error('Must have either a \'value\' or \'default\' prop');
	    },
	    value: _react2['default'].PropTypes.any
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      initial: false,
	      'default': false,
	      value: null
	    };
	  },
	
	  render: function render() {
	    var result = this.props.children;
	
	    if (typeof result === 'string') {
	      result = _react2['default'].createElement(
	        'span',
	        null,
	        result
	      );
	    }
	
	    return result;
	  }
	});
	
	exports['default'] = At;
	module.exports = exports['default'];

/***/ },
/* 476 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(40);
	
	var _react2 = _interopRequireDefault(_react);
	
	// Convert a value that potentially isn't an array into one
	// If it is already an array just return it
	function valueToArray(value) {
	  if (Array.isArray(value)) {
	    return value;
	  }
	  return [value];
	}
	
	var Respond = _react2['default'].createClass({
	  displayName: 'Respond',
	
	  propTypes: {
	    to: _react2['default'].PropTypes.string.isRequired,
	    children: _react2['default'].PropTypes.any.isRequired,
	    at: _react2['default'].PropTypes.any,
	    initial: _react2['default'].PropTypes.bool
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      mounted: false
	    };
	  },
	
	  componentWillMount: function componentWillMount() {
	    this.updateQueries(this.props);
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(props) {
	    this.updateQueries(props);
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.setState({ mounted: true });
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    var _this = this;
	
	    this.queries.forEach(function (q) {
	      return q[0].removeListener(_this.onMatch);
	    });
	  },
	
	  onMatch: function onMatch() {
	    this.forceUpdate();
	  },
	
	  updateQueries: function updateQueries(props) {
	    var _this2 = this;
	
	    var to = props.to;
	    var children = props.children;
	    var at = props.at;
	
	    if (this.queries) {
	      this.queries.forEach(function (q) {
	        return q[0].removeListener(_this2.onMatch);
	      });
	    }
	
	    if (at) {
	      var queryString = '(' + to + ': ' + at + ')';
	
	      var q = matchMedia(queryString);
	      q.addListener(this.onMatch);
	
	      this.queries = [[q, at]];
	    } else {
	      this.queries = valueToArray(children).filter(function (c) {
	        return !c.props['default'];
	      }).map(function (c) {
	        var v = c.props.value;
	        var queryString = '(' + to + ': ' + c.props.value + ')';
	
	        var q = matchMedia(queryString);
	        q.addListener(_this2.onMatch);
	        return [q, v];
	      });
	    }
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var children = _props.children;
	    var at = _props.at;
	    var initial = _props.initial;
	    var mounted = this.state.mounted;
	
	    var matches = this.queries.filter(function (q) {
	      return q[0].matches;
	    });
	
	    if (at) {
	      // Shortcut case
	      if (!mounted && initial || mounted && matches.length) {
	        var result = children;
	
	        if (typeof result === 'string') {
	          result = _react2['default'].createElement(
	            'span',
	            null,
	            result
	          );
	        }
	
	        return result;
	      }
	    } else {
	      var defaultChild = valueToArray(children).find(function (c) {
	        return c.props['default'];
	      });
	
	      if (matches.length) {
	        var _ret = (function () {
	          var val = matches[matches.length - 1][1];
	          var child = valueToArray(children).find(function (c) {
	            return c.props.value === val;
	          });
	
	          if (!mounted && child.props.initial || mounted) {
	            return {
	              v: child
	            };
	          }
	        })();
	
	        if (typeof _ret === 'object') return _ret.v;
	      } else if (defaultChild) {
	        if (!mounted && defaultChild.props.initial || mounted) {
	          return defaultChild;
	        }
	      }
	    }
	
	    return null;
	  }
	});
	
	exports['default'] = Respond;
	module.exports = exports['default'];


/***/ },
/* 477 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequire = __webpack_require__(472)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _Month = __webpack_require__(478);
	
	exports.Month = _interopRequire(_Month);
	
	var _Calendar = __webpack_require__(479);
	
	exports.Calendar = _interopRequire(_Calendar);

/***/ },
/* 478 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _reactAddons = __webpack_require__(40);
	
	var _reactAddons2 = _interopRequireDefault(_reactAddons);
	
	var _calendar = __webpack_require__(203);
	
	var Month = _reactAddons2['default'].createClass({
	  displayName: 'Month',
	
	  propTypes: {
	    weekStarts: _reactAddons.PropTypes.number.isRequired,
	    dateView: _reactAddons.PropTypes.instanceOf(Date),
	    children: _reactAddons.PropTypes.func.isRequired
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var weekStarts = _props.weekStarts;
	    var dateView = _props.dateView;
	    var children = _props.children;
	
	    var calendar = new _calendar.Calendar(weekStarts);
	    var weeks = calendar.monthDates(dateView.getFullYear(), dateView.getMonth());
	
	    return _reactAddons2['default'].createElement(
	      'tbody',
	      null,
	      weeks.map(function (week, index) {
	        return _reactAddons2['default'].createElement(
	          'tr',
	          { className: 'ofs-Calendar__Week', key: index },
	          week.map(function (date) {
	            return children(date);
	          })
	        );
	      })
	    );
	  }
	});
	
	exports['default'] = Month;
	module.exports = exports['default'];

/***/ },
/* 479 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(54)['default'];
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _reactAddons = __webpack_require__(40);
	
	var _reactAddons2 = _interopRequireDefault(_reactAddons);
	
	var _reactLibShallowEqual = __webpack_require__(480);
	
	var _reactLibShallowEqual2 = _interopRequireDefault(_reactLibShallowEqual);
	
	var _ofsMoment = __webpack_require__(57);
	
	var _ofsMoment2 = _interopRequireDefault(_ofsMoment);
	
	var _ofsUtilsRange = __webpack_require__(481);
	
	var _ofsUtilsRange2 = _interopRequireDefault(_ofsUtilsRange);
	
	var _ofsUtilsDatesAreSame = __webpack_require__(482);
	
	var _ofsUtilsDatesAreSame2 = _interopRequireDefault(_ofsUtilsDatesAreSame);
	
	var _Month = __webpack_require__(478);
	
	var _Month2 = _interopRequireDefault(_Month);
	
	var _Arrow = __webpack_require__(483);
	
	var _Arrow2 = _interopRequireDefault(_Arrow);
	
	var _DayHeaders = __webpack_require__(484);
	
	var _DayHeaders2 = _interopRequireDefault(_DayHeaders);
	
	var _DateComponent = __webpack_require__(485);
	
	var _DateComponent2 = _interopRequireDefault(_DateComponent);
	
	var lang = (0, _ofsMoment2['default'])().localeData();
	
	function previousMonth(date) {
	  if (date.getMonth() === 0) {
	    // return previous year
	    return new Date(date.getFullYear() - 1, 11, 1);
	  }
	  return new Date(date.getFullYear(), date.getMonth() - 1, 1);
	}
	
	function nextMonth(date) {
	  if (date.getMonth() === 11) {
	    // return next year
	    return new Date(date.getFullYear() + 1, 0, 1);
	  }
	  return new Date(date.getFullYear(), date.getMonth() + 1, 1);
	}
	
	function isWeekend(date) {
	  if (date.getDay() === 0 || date.getDay() === 6) {
	    return true;
	  }
	  return false;
	}
	
	var Calendar = _reactAddons2['default'].createClass({
	  displayName: 'Calendar',
	
	  propTypes: {
	    minimumDate: _reactAddons.PropTypes.instanceOf(Date),
	    weekStarts: _reactAddons.PropTypes.number,
	    initialDate: _reactAddons.PropTypes.instanceOf(Date), // initial date to view
	
	    value: _reactAddons.PropTypes.instanceOf(Date),
	    onSelect: _reactAddons.PropTypes.func,
	
	    isSelected: _reactAddons.PropTypes.func, // override is selected logic
	    renderDate: _reactAddons.PropTypes.func },
	
	  // override date render
	  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
	    return !(0, _reactLibShallowEqual2['default'])(this.props, nextProps) || !(0, _reactLibShallowEqual2['default'])(this.state, nextState);
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      weekStarts: 1, // Monday
	      onSelect: function onSelect() {}
	    };
	  },
	
	  getValue: function getValue() {
	    return this.props.value ? this.props.value : this.props.initialDate;
	  },
	
	  getInitialState: function getInitialState() {
	    var value = this.getValue();
	    var today = new Date();
	
	    return {
	      dateView: value ? value : today
	    };
	  },
	
	  isSelectable: function isSelectable(date) {
	    var minimumDate = this.props.minimumDate;
	
	    minimumDate.setHours(0, 0, 0, 0);
	
	    if (minimumDate && date < minimumDate) {
	      return false;
	    }
	    return true;
	  },
	
	  isSelected: function isSelected(date) {
	    var _props = this.props;
	    var value = _props.value;
	    var isSelected = _props.isSelected;
	
	    if (typeof isSelected === 'function') {
	      return isSelected(date);
	    }
	
	    if (value && (0, _ofsUtilsDatesAreSame2['default'])(value, date)) {
	      return true;
	    }
	    return false;
	  },
	
	  canMoveBackwards: function canMoveBackwards() {
	    var minimumDate = this.props.minimumDate;
	
	    if (!minimumDate) {
	      return true;
	    }
	
	    var dateView = this.state.dateView;
	
	    var monthCheck = new Date(dateView.getTime());
	    // set to the end of the previous month
	    monthCheck.setDate(0);
	
	    if (monthCheck < minimumDate) {
	      return false;
	    }
	
	    return true;
	  },
	
	  canMoveForwards: function canMoveForwards() {
	    // TODO
	    return true;
	  },
	
	  handlePreviousClick: function handlePreviousClick() {
	    if (!this.canMoveBackwards()) {
	      return false;
	    }
	
	    var dateView = this.state.dateView;
	
	    var newMonth = previousMonth(dateView);
	
	    this.setState({
	      dateView: newMonth
	    });
	  },
	
	  handleNextClick: function handleNextClick() {
	    if (!this.canMoveForwards()) {
	      return false;
	    }
	
	    var dateView = this.state.dateView;
	
	    var newMonth = nextMonth(dateView);
	
	    this.setState({
	      dateView: newMonth
	    });
	  },
	
	  handleMonthChange: function handleMonthChange(event) {
	    var dateView = this.state.dateView;
	
	    var newMonth = new Date(dateView.getFullYear(), event.target.value, 1);
	
	    this.setState({
	      dateView: newMonth
	    });
	  },
	
	  handleYearChange: function handleYearChange(event) {
	    var dateView = this.state.dateView;
	
	    var newYear = new Date(event.target.value, dateView.getMonth(), 1);
	
	    this.setState({
	      dateView: newYear
	    });
	  },
	
	  renderDay: function renderDay(date) {
	    var _props2 = this.props;
	    var onSelect = _props2.onSelect;
	    var renderDate = _props2.renderDate;
	    var dateView = this.state.dateView;
	
	    var state = {
	      enabled: this.isSelectable(date),
	      selected: this.isSelected(date),
	      notInMonth: date.getMonth() !== dateView.getMonth(),
	      isWeekend: isWeekend(date)
	    };
	
	    if (typeof renderDate === 'function') {
	      var dateComponent = renderDate(date, state);
	      return _reactAddons2['default'].cloneElement(dateComponent, {
	        date: date,
	        onClick: dateComponent.props.enabled && onSelect.bind(null, date)
	      });
	    }
	
	    return _reactAddons2['default'].createElement(_DateComponent2['default'], _extends({}, state, {
	      date: date,
	      key: date.getTime(),
	      onClick: state.enabled && onSelect.bind(null, date)
	    }));
	  },
	
	  renderHeaderMonth: function renderHeaderMonth() {
	    var minimumDate = this.props.minimumDate;
	    var dateView = this.state.dateView;
	
	    return _reactAddons2['default'].createElement(
	      'span',
	      { className: 'ofs-Calendar__MonthHeaderLabel' },
	      lang._months[dateView.getMonth()],
	      _reactAddons2['default'].createElement(
	        'select',
	        { className: 'ofs-Calendar__MonthHeaderSelect',
	          value: dateView.getMonth(),
	          onChange: this.handleMonthChange
	        },
	        (0, _ofsUtilsRange2['default'])(0, 12).map(function (index) {
	          return _reactAddons2['default'].createElement(
	            'option',
	            {
	              key: index,
	              value: index,
	              disabled: minimumDate && minimumDate.getFullYear() >= dateView.getFullYear() && index < minimumDate.getMonth()
	            },
	            lang._months[index]
	          );
	        })
	      )
	    );
	  },
	
	  renderHeaderYear: function renderHeaderYear() {
	    var minimumDate = this.props.minimumDate;
	    var dateView = this.state.dateView;
	
	    var today = new Date();
	
	    var currentYear = today.getFullYear();
	    var yearList = (0, _ofsUtilsRange2['default'])(currentYear - 5, currentYear).concat((0, _ofsUtilsRange2['default'])(currentYear, currentYear + 10));
	
	    return _reactAddons2['default'].createElement(
	      'span',
	      { className: 'ofs-Calendar__MonthHeaderLabel' },
	      dateView.getFullYear(),
	      _reactAddons2['default'].createElement(
	        'select',
	        {
	          className: 'ofs-Calendar__MonthHeaderSelect',
	          value: dateView.getFullYear(),
	          onChange: this.handleYearChange
	        },
	        yearList.map(function (year) {
	          return _reactAddons2['default'].createElement(
	            'option',
	            {
	              key: year,
	              value: year,
	              disabled: minimumDate && year < minimumDate.getFullYear()
	            },
	            year
	          );
	        })
	      )
	    );
	  },
	
	  render: function render() {
	    var weekStarts = this.props.weekStarts;
	    var dateView = this.state.dateView;
	
	    return _reactAddons2['default'].createElement(
	      'div',
	      { className: 'ofs-Calendar' },
	      _reactAddons2['default'].createElement(_Arrow2['default'], { direction: 'previous', disabled: !this.canMoveBackwards(), onClick: this.handlePreviousClick }),
	      _reactAddons2['default'].createElement(
	        'div',
	        { className: 'ofs-Calendar__MonthHeader' },
	        this.renderHeaderMonth(),
	        ' ',
	        this.renderHeaderYear()
	      ),
	      _reactAddons2['default'].createElement(
	        'div',
	        { className: 'ofs-Calendar__MonthWrapper' },
	        _reactAddons2['default'].createElement(
	          'table',
	          { className: 'ofs-Calendar__Month' },
	          _reactAddons2['default'].createElement(
	            _DayHeaders2['default'],
	            { weekStarts: weekStarts },
	            function (dayIndex) {
	              return _reactAddons2['default'].createElement(
	                'abbr',
	                { title: lang._weekdays[dayIndex] },
	                lang._weekdaysShort[dayIndex]
	              );
	            }
	          ),
	          _reactAddons2['default'].createElement(
	            _Month2['default'],
	            { dateView: dateView, weekStarts: weekStarts },
	            this.renderDay
	          )
	        )
	      ),
	      _reactAddons2['default'].createElement(_Arrow2['default'], { direction: 'next', disabled: !this.canMoveForwards(), onClick: this.handleNextClick })
	    );
	  }
	});
	
	exports['default'] = Calendar;
	module.exports = exports['default'];

/***/ },
/* 480 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule shallowEqual
	 */
	
	'use strict';
	
	/**
	 * Performs equality by iterating through keys on an object and returning
	 * false when any key has values which are not strictly equal between
	 * objA and objB. Returns true when the values of all keys are strictly equal.
	 *
	 * @return {boolean}
	 */
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	  var key;
	  // Test for A's keys different from B.
	  for (key in objA) {
	    if (objA.hasOwnProperty(key) &&
	        (!objB.hasOwnProperty(key) || objA[key] !== objB[key])) {
	      return false;
	    }
	  }
	  // Test for B's keys missing from A.
	  for (key in objB) {
	    if (objB.hasOwnProperty(key) && !objA.hasOwnProperty(key)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = shallowEqual;


/***/ },
/* 481 */
/***/ function(module, exports) {

	"use strict";
	
	// Range utility function
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = range;
	
	function range(start, end) {
	  var list = [];
	  for (var i = start; i < end; i++) {
	    list.push(i);
	  }
	  return list;
	}
	
	;
	module.exports = exports["default"];

/***/ },
/* 482 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = datesAreSame;
	
	function datesAreSame(date1, date2) {
	  if (!(date1 instanceof Date) || !(date2 instanceof Date)) {
	    return false;
	  }
	
	  return "" + date1.getFullYear() + date1.getMonth() + date1.getDate() === "" + date2.getFullYear() + date2.getMonth() + date2.getDate();
	}
	
	module.exports = exports["default"];

/***/ },
/* 483 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _reactAddons = __webpack_require__(40);
	
	var _reactAddons2 = _interopRequireDefault(_reactAddons);
	
	var _classnames = __webpack_require__(49);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ofsComponentsCommonIcon = __webpack_require__(51);
	
	var _ofsComponentsCommonIcon2 = _interopRequireDefault(_ofsComponentsCommonIcon);
	
	var Arrow = _reactAddons2['default'].createClass({
	  displayName: 'Arrow',
	
	  propTypes: {
	    disabled: _reactAddons2['default'].PropTypes.bool,
	    direction: _reactAddons.PropTypes.oneOf(['next', 'previous']),
	    onClick: _reactAddons.PropTypes.func
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var disabled = _props.disabled;
	    var direction = _props.direction;
	    var onClick = _props.onClick;
	
	    var arrowClasses = (0, _classnames2['default'])({
	      'ofs-Calendar__Arrow': true,
	      'ofs-Calendar__Arrow--previous': direction === 'previous',
	      'ofs-Calendar__Arrow--next': direction === 'next',
	      'ofs-Calendar__Arrow--is-disabled': disabled
	    });
	
	    var arrowIconClasses = (0, _classnames2['default'])({
	      'ofs-Calendar__ArrowIcon': true,
	      'ofs-Calendar__ArrowIcon--is-disabled': disabled
	    });
	
	    return _reactAddons2['default'].createElement(
	      'div',
	      { className: arrowClasses, onClick: onClick },
	      _reactAddons2['default'].createElement(
	        'div',
	        { className: arrowIconClasses },
	        _reactAddons2['default'].createElement(_ofsComponentsCommonIcon2['default'], { glyph: 'arrow', size: 'small', variant: direction === 'previous' ? 'left' : 'right' })
	      )
	    );
	  }
	});
	
	exports['default'] = Arrow;
	module.exports = exports['default'];

/***/ },
/* 484 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _reactAddons = __webpack_require__(40);
	
	var _reactAddons2 = _interopRequireDefault(_reactAddons);
	
	var _ofsUtilsRange = __webpack_require__(481);
	
	var _ofsUtilsRange2 = _interopRequireDefault(_ofsUtilsRange);
	
	var DayHeaders = _reactAddons2['default'].createClass({
	  displayName: 'DayHeaders',
	
	  propTypes: {
	    weekStarts: _reactAddons.PropTypes.number.isRequired,
	    children: _reactAddons.PropTypes.func.isRequired
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var weekStarts = _props.weekStarts;
	    var children = _props.children;
	
	    var days = (0, _ofsUtilsRange2['default'])(weekStarts, 7).concat((0, _ofsUtilsRange2['default'])(0, weekStarts));
	
	    return _reactAddons2['default'].createElement(
	      'thead',
	      null,
	      _reactAddons2['default'].createElement(
	        'tr',
	        null,
	        days.map(function (dayIndex) {
	          return _reactAddons2['default'].createElement(
	            'th',
	            { className: 'ofs-Calendar__WeekdayHeading', key: dayIndex },
	            children(dayIndex)
	          );
	        })
	      )
	    );
	  }
	});
	
	exports['default'] = DayHeaders;
	module.exports = exports['default'];

/***/ },
/* 485 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(54)['default'];
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _reactAddons = __webpack_require__(40);
	
	var _reactAddons2 = _interopRequireDefault(_reactAddons);
	
	var _classnames = __webpack_require__(49);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var DateComponent = _reactAddons2['default'].createClass({
	  displayName: 'DateComponent',
	
	  propTypes: {
	    date: _reactAddons.PropTypes.instanceOf(Date),
	    enabled: _reactAddons.PropTypes.bool,
	    selected: _reactAddons.PropTypes.bool,
	    notInMonth: _reactAddons.PropTypes.bool,
	    isWeekend: _reactAddons.PropTypes.bool
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var date = _props.date;
	    var enabled = _props.enabled;
	    var selected = _props.selected;
	    var notInMonth = _props.notInMonth;
	    var isWeekend = _props.isWeekend;
	
	    var classes = (0, _classnames2['default'])({
	      'ofs-Calendar__Date': true,
	      'ofs-Calendar__Date--is-enabled': enabled,
	      'ofs-Calendar__Date--is-disabled': !enabled,
	      'ofs-Calendar__Date--not-in-month': notInMonth,
	      'ofs-Calendar__Date--is-selected': selected,
	      'ofs-Calendar__Date--is-weekend': isWeekend
	    });
	
	    return _reactAddons2['default'].createElement(
	      'td',
	      _extends({ className: classes }, this.props),
	      _reactAddons2['default'].createElement('div', { className: 'ofs-Calendar__DateHighlight' }),
	      _reactAddons2['default'].createElement(
	        'div',
	        { className: 'ofs-Calendar__DateSelected' },
	        date.getDate()
	      ),
	      _reactAddons2['default'].createElement(
	        'div',
	        { className: 'ofs-Calendar__DateValue' },
	        date.getDate()
	      )
	    );
	  }
	});
	
	exports['default'] = DateComponent;
	module.exports = exports['default'];

/***/ },
/* 486 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _objectWithoutProperties = __webpack_require__(53)['default'];
	
	var _extends = __webpack_require__(54)['default'];
	
	var _Object$assign = __webpack_require__(32)['default'];
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _reactAddons = __webpack_require__(40);
	
	var _reactAddons2 = _interopRequireDefault(_reactAddons);
	
	var _classnames = __webpack_require__(49);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _jquery = __webpack_require__(39);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _createPortal = __webpack_require__(487);
	
	var _createPortal2 = _interopRequireDefault(_createPortal);
	
	var Modal = _reactAddons2['default'].createClass({
	  displayName: 'Modal',
	
	  propTypes: {
	    closing: _reactAddons.PropTypes.bool,
	    noAnimation: _reactAddons.PropTypes.bool,
	
	    className: _reactAddons.PropTypes.string,
	    modalStyle: _reactAddons.PropTypes.object,
	
	    children: _reactAddons.PropTypes.any.isRequired,
	
	    onRequestClose: _reactAddons.PropTypes.func.isRequired
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      opened: false,
	      modalStyle: {}
	    };
	  },
	
	  /* eslint-disable react/no-did-mount-set-state */
	  componentDidMount: function componentDidMount() {
	    // Make sure the initial state is applied.
	    /* eslint-disable no-unused-expressions */
	    window.getComputedStyle(this.getDOMNode()).opacity;
	    /* eslint-enable no-unused-expressions */
	
	    this.setState({
	      opened: true
	    });
	    (0, _jquery2['default'])('html, body').addClass('has-open-modal');
	  },
	  /* eslint-enable react/no-did-mount-set-state */
	
	  componentWillUnmount: function componentWillUnmount() {
	    (0, _jquery2['default'])('html, body').removeClass('has-open-modal');
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var children = _props.children;
	    var closing = _props.closing;
	    var noAnimation = _props.noAnimation;
	    var className = _props.className;
	    var modalStyle = _props.modalStyle;
	    var onRequestClose = _props.onRequestClose;
	
	    var rest = _objectWithoutProperties(_props, ['children', 'closing', 'noAnimation', 'className', 'modalStyle', 'onRequestClose']);
	
	    var opened = this.state.opened;
	
	    var modalWrapperClasses = {
	      'ofs-Modal__Wrapper': true,
	      'u-no-transition': noAnimation
	    };
	
	    var modalOverlayClasses = {
	      'ofs-ModalOverlay': true,
	      'u-no-transition': noAnimation
	    };
	
	    var modalClasses = {
	      'ofs-Modal': true,
	      'u-no-transition': noAnimation
	    };
	    if (className) {
	      modalClasses[className] = true;
	    }
	
	    var opacity = noAnimation || opened && !closing ? 1 : 0;
	
	    return _reactAddons2['default'].createElement(
	      'div',
	      { className: (0, _classnames2['default'])(modalWrapperClasses), style: { opacity: opacity }, onClick: onRequestClose },
	      _reactAddons2['default'].createElement('div', { className: (0, _classnames2['default'])(modalOverlayClasses), style: { opacity: opacity } }),
	      _reactAddons2['default'].createElement(
	        'div',
	        _extends({ ref: 'modal', role: 'dialog', style: _Object$assign({}, { opacity: opacity }, modalStyle),
	          className: (0, _classnames2['default'])(modalClasses),
	          onClick: function (event) {
	            return event.stopPropagation();
	          } }, rest),
	        children
	      )
	    );
	  }
	});
	
	exports['default'] = (0, _createPortal2['default'])(Modal);
	module.exports = exports['default'];

/***/ },
/* 487 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(54)['default'];
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = createPortal;
	
	var _reactAddons = __webpack_require__(40);
	
	var _reactAddons2 = _interopRequireDefault(_reactAddons);
	
	var _createOnClickOutside = __webpack_require__(488);
	
	var _createOnClickOutside2 = _interopRequireDefault(_createOnClickOutside);
	
	function createPortal(Component) {
	  var WrappedComponent = (0, _createOnClickOutside2['default'])(Component);
	
	  var Portal = _reactAddons2['default'].createClass({
	    displayName: 'Portal',
	
	    propTypes: {
	      isOpen: _reactAddons.PropTypes.bool.isRequired,
	      closeTimeoutMS: _reactAddons.PropTypes.number
	    },
	
	    getDefaultProps: function getDefaultProps() {
	      return {
	        isOpen: false,
	        closeTimeoutMS: 0
	      };
	    },
	
	    getInitialState: function getInitialState() {
	      return {
	        closing: false
	      };
	    },
	
	    componentDidUpdate: function componentDidUpdate() {
	      this._renderLayer();
	    },
	
	    componentWillUnmount: function componentWillUnmount() {
	      this._unrenderLayer();
	      this._clearTimeout();
	      document.body.removeChild(this._target);
	    },
	
	    componentDidMount: function componentDidMount() {
	      // Appending to the body is easier than managing the z-index of everything on the page.
	      // It's also better for accessibility and makes stacking a snap (since components will stack
	      // in mount order).
	      this._target = document.createElement('div');
	      document.body.appendChild(this._target);
	      this._renderLayer();
	    },
	
	    componentWillReceiveProps: function componentWillReceiveProps(newProps) {
	      if (this.props.isOpen && !newProps.isOpen) {
	        this.close();
	      }
	    },
	
	    close: function close() {
	      if (this.props.closeTimeoutMS > 0) {
	        this.closeWithTimeout();
	      } else {
	        this.closeWithoutTimeout();
	      }
	    },
	
	    closeWithTimeout: function closeWithTimeout() {
	      var _this = this;
	
	      this.setState({ closing: true }, function () {
	        _this._closeTimeout = setTimeout(_this.closeWithoutTimeout, _this.props.closeTimeoutMS);
	      });
	    },
	
	    closeWithoutTimeout: function closeWithoutTimeout() {
	      if (this.isMounted()) {
	        this.setState({
	          closing: false
	        });
	      }
	    },
	
	    _clearTimeout: function _clearTimeout() {
	      if (this._closeTimeout) {
	        clearTimeout(this._closeTimeout);
	      }
	    },
	
	    _renderLayer: function _renderLayer() {
	      // By calling this method in componentDidMount() and componentDidUpdate(), you're effectively
	      // creating a "wormhole" that funnels React's hierarchical updates through to a DOM node on an
	      // entirely different part of the page.
	      this._portal = _reactAddons2['default'].render(this.renderLayer(), this._target);
	    },
	
	    _unrenderLayer: function _unrenderLayer() {
	      _reactAddons2['default'].unmountComponentAtNode(this._target);
	    },
	
	    shouldBeClosed: function shouldBeClosed() {
	      return !this.props.isOpen && !this.state.closing;
	    },
	
	    renderLayer: function renderLayer() {
	      if (this.shouldBeClosed()) {
	        return _reactAddons2['default'].createElement('div', null);
	      }
	
	      return _reactAddons2['default'].createElement(WrappedComponent, _extends({}, this.props, {
	        closing: this.state.closing
	      }));
	    },
	
	    render: function render() {
	      return null;
	    }
	  });
	
	  return Portal;
	}
	
	module.exports = exports['default'];

/***/ },
/* 488 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(3)['default'];
	
	var _inherits = __webpack_require__(17)['default'];
	
	var _createClass = __webpack_require__(28)['default'];
	
	var _classCallCheck = __webpack_require__(31)['default'];
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = createOnClickOutside;
	
	var _react = __webpack_require__(40);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactPureRenderShallowEqual = __webpack_require__(489);
	
	var _reactPureRenderShallowEqual2 = _interopRequireDefault(_reactPureRenderShallowEqual);
	
	var IGNORE_CLASS = 'ignore-react-onclickoutside';
	
	function isSourceFound(source, localNode) {
	  if (source === localNode) {
	    return true;
	  }
	  // SVG <use/> elements do not technically reside in the rendered DOM, so
	  // they do not have classList directly, but they offer a link to their
	  // corresponding element, which can have classList. This extra check is for
	  // that case.
	  // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
	  // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17
	  if (source.correspondingElement) {
	    return source.correspondingElement.classList.contains(IGNORE_CLASS);
	  }
	  return source.classList.contains(IGNORE_CLASS);
	}
	
	// Higher order component to trigger a callback when user clicks outside of the
	// component
	
	function createOnClickOutside(Component) {
	  var OnClickOutside = (function (_React$Component) {
	    _inherits(OnClickOutside, _React$Component);
	
	    function OnClickOutside(props) {
	      _classCallCheck(this, OnClickOutside);
	
	      _get(Object.getPrototypeOf(OnClickOutside.prototype), 'constructor', this).call(this, props);
	      this.handleClick = this.handleClick.bind(this);
	    }
	
	    _createClass(OnClickOutside, [{
	      key: 'handleClick',
	      value: function handleClick(event) {
	        var source = event.target;
	        var found = false;
	        // If source=local then this event came from "somewhere"
	        // inside and should be ignored. We could handle this with
	        // a layered approach, too, but that requires going back to
	        // thinking in terms of Dom node nesting, running counter
	        // to React's "you shouldn't care about the DOM" philosophy.
	        // Credit: react-onclickoutside
	        while (source.parentNode) {
	          found = isSourceFound(source, this._localNode);
	          if (found) {
	            return;
	          }
	          source = source.parentNode;
	        }
	        this.props.onRequestClose(event);
	      }
	    }, {
	      key: 'shouldComponentUpdate',
	      value: function shouldComponentUpdate(nextProps) {
	        return !(0, _reactPureRenderShallowEqual2['default'])(this.props, nextProps);
	      }
	    }, {
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        // add event listeners
	        document.addEventListener("click", this.handleClick);
	
	        this._localNode = _react2['default'].findDOMNode(this);
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        // remove event listeners
	        document.removeEventListener("click", this.handleClick);
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        return _react2['default'].createElement(Component, this.props);
	      }
	    }]);
	
	    return OnClickOutside;
	  })(_react2['default'].Component);
	
	  OnClickOutside.propTypes = {
	    onRequestClose: _react.PropTypes.func.isRequired
	  };
	
	  OnClickOutside.defaultProps = {
	    onRequestClose: function onRequestClose() {}
	  };
	
	  return OnClickOutside;
	}
	
	module.exports = exports['default'];

/***/ },
/* 489 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = shallowEqual;
	
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	  for (var i = 0; i < keysA.length; i++) {
	    if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = exports['default'];

/***/ },
/* 490 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _reactAddons = __webpack_require__(40);
	
	var _reactAddons2 = _interopRequireDefault(_reactAddons);
	
	var _classnames = __webpack_require__(49);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ofsReactRawTether = __webpack_require__(341);
	
	var _ofsReactRawTether2 = _interopRequireDefault(_ofsReactRawTether);
	
	var _createPortal = __webpack_require__(487);
	
	var _createPortal2 = _interopRequireDefault(_createPortal);
	
	var Popover = _reactAddons2['default'].createClass({
	  displayName: 'Popover',
	
	  propTypes: {
	    closing: _reactAddons.PropTypes.bool,
	
	    children: _reactAddons.PropTypes.node.isRequired,
	    attachTo: _reactAddons.PropTypes.object.isRequired },
	
	  // TODO validated dom element
	  getInitialState: function getInitialState() {
	    return {
	      panelClasses: [],
	      anchorClasses: [],
	      opened: false
	    };
	  },
	
	  getAnchorOptions: function getAnchorOptions() {
	    return {
	      element: this.refs.anchor.getDOMNode(),
	      target: this.props.attachTo.getDOMNode(),
	      attachment: 'top center',
	      onPosition: this.onAnchorPosition,
	      targetAttachment: 'bottom center',
	      offset: '5px 0'
	    };
	  },
	
	  getPanelOptions: function getPanelOptions() {
	    var attachTo = this.props.attachTo;
	
	    var panel = this.refs.panel.getDOMNode();
	    var target = attachTo.getDOMNode();
	
	    var panelRect = panel.getBoundingClientRect();
	    var targetRect = target.getBoundingClientRect();
	
	    var panelAttachment = 'top center';
	    var targetAttachment = 'bottom center';
	
	    // if there is no space to fit popover in window change attachment
	    if (targetRect.left + targetRect.width / 2 - panelRect.width / 2 < 0) {
	      panelAttachment = 'top left';
	      targetAttachment = 'bottom left';
	    }
	
	    // if panel is bigger than window then always center attachment
	    if (panelRect.width > window.innerWidth) {
	      panelAttachment = 'top center';
	      targetAttachment = 'bottom center';
	    }
	
	    return {
	      element: panel,
	      target: target,
	      onPosition: this.onPanelPosition,
	      offset: '-10px 0',
	      attachment: panelAttachment,
	      targetAttachment: targetAttachment
	    };
	  },
	
	  onAnchorPosition: function onAnchorPosition(position, elementClasses) {
	    var anchorStyle = {
	      top: position.page.top,
	      left: position.page.left
	    };
	    this.setState({ anchorStyle: anchorStyle, anchorClasses: elementClasses });
	  },
	
	  onPanelPosition: function onPanelPosition(position, elementClasses) {
	    var panelStyle = {
	      top: position.page.top,
	      left: position.page.left
	    };
	    this.setState({ panelStyle: panelStyle, panelClasses: elementClasses });
	  },
	
	  componentDidMount: function componentDidMount() {
	    // Make sure that the input element is mounted correctly in the dom
	    this._panelTether = new _ofsReactRawTether2['default'](this.getPanelOptions());
	    this._anchorTether = new _ofsReactRawTether2['default'](this.getAnchorOptions());
	
	    this._panelTether.enable();
	    this._anchorTether.enable();
	    /* eslint-disable react/no-did-mount-set-state */
	    this.setState({
	      opened: true
	    });
	    /* eslint-enable react/no-did-mount-set-state */
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._panelTether) {
	      this._panelTether.disable();
	    }
	    if (this._anchorTether) {
	      this._anchorTether.disable();
	    }
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var children = _props.children;
	    var closing = _props.closing;
	    var _state = this.state;
	    var opened = _state.opened;
	    var panelClasses = _state.panelClasses;
	    var anchorClasses = _state.anchorClasses;
	    var panelStyle = _state.panelStyle;
	    var anchorStyle = _state.anchorStyle;
	
	    var _panelClasses = panelClasses.map(function (c) {
	      return 'ofs-Popover__Panel--' + c;
	    });
	    var _anchorClasses = anchorClasses.map(function (c) {
	      return 'ofs-Popover__Anchor--' + c;
	    });
	    _panelClasses.unshift('ofs-Popover__Panel');
	    _anchorClasses.unshift('ofs-Popover__Anchor');
	
	    if (closing) {
	      _panelClasses.unshift('ofs-Popover__Panel--closing');
	      _anchorClasses.unshift('ofs-Popover__Anchor--closing');
	    }
	
	    if (opened) {
	      _panelClasses.unshift('ofs-Popover__Panel--opened');
	      _anchorClasses.unshift('ofs-Popover__Anchor--opened');
	    }
	
	    return _reactAddons2['default'].createElement(
	      'div',
	      { className: 'ofs-Popover' },
	      _reactAddons2['default'].createElement(
	        'div',
	        { ref: 'panel', className: _classnames2['default'].apply(null, _panelClasses),
	          style: panelStyle },
	        children
	      ),
	      _reactAddons2['default'].createElement('div', { ref: 'anchor', className: _classnames2['default'].apply(null, _anchorClasses),
	        style: anchorStyle })
	    );
	  }
	});
	
	exports['default'] = (0, _createPortal2['default'])(Popover);
	module.exports = exports['default'];

/***/ },
/* 491 */
/***/ function(module, exports, __webpack_require__) {

	/* eslint-disable react/no-did-mount-set-state */
	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _reactAddons = __webpack_require__(40);
	
	var _reactAddons2 = _interopRequireDefault(_reactAddons);
	
	var OnMount = _reactAddons2['default'].createClass({
	  displayName: 'OnMount',
	
	  propTypes: {
	    placeholder: _reactAddons2['default'].PropTypes.element,
	    children: _reactAddons2['default'].PropTypes.func.isRequired
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      placeholder: null
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      mounted: false
	    };
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.setState({ mounted: true });
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var children = _props.children;
	    var placeholder = _props.placeholder;
	
	    if (this.state.mounted) {
	      return children();
	    }
	
	    return placeholder;
	  }
	});
	
	exports['default'] = OnMount;
	module.exports = exports['default'];

/***/ },
/* 492 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _reactAddons = __webpack_require__(40);
	
	var _reactAddons2 = _interopRequireDefault(_reactAddons);
	
	var _ofsComponentsSimpleChoiceSimpleChoice = __webpack_require__(47);
	
	var _ofsComponentsSimpleChoiceSimpleChoice2 = _interopRequireDefault(_ofsComponentsSimpleChoiceSimpleChoice);
	
	var _ofsI18n = __webpack_require__(61);
	
	var _ofsI18n2 = _interopRequireDefault(_ofsI18n);
	
	var _ofsSettings = __webpack_require__(62);
	
	var _ofsPayload = __webpack_require__(355);
	
	var gettext = _ofsI18n2['default'].gettext;
	
	var MESSAGES = {
	  LABEL: gettext('Set your currency'),
	  DISCLAIMER: gettext('Prices shown are approximate conversions from local currency')
	};
	
	var CurrencySelector = _reactAddons2['default'].createClass({
	  displayName: 'CurrencySelector',
	
	  handleChange: function handleChange() {
	    this.getDOMNode().submit();
	  },
	
	  render: function render() {
	    var options = _ofsSettings.currencies.map(function (currency) {
	      return _reactAddons2['default'].createElement(
	        'div',
	        { value: currency['id'], key: currency['id'] },
	        currency['label']
	      );
	    });
	
	    return _reactAddons2['default'].createElement(
	      'form',
	      { action: _ofsPayload.currencySelector.url, method: 'POST', className: 'ofs-CurrencySelector' },
	      _reactAddons2['default'].createElement(
	        'div',
	        { className: 'ofs-CurrencySelector__InputContainer' },
	        _reactAddons2['default'].createElement(
	          'label',
	          { className: 'ofs-CurrencySelector__Label' },
	          MESSAGES.LABEL
	        ),
	        _reactAddons2['default'].createElement(
	          _ofsComponentsSimpleChoiceSimpleChoice2['default'],
	          { name: 'currency', inverse: true,
	            className: 'ofs-SimpleChoice--inline ofs-CurrencySelector__Select',
	            defaultValue: _ofsSettings.user.currencyId, onChange: this.handleChange },
	          options
	        )
	      ),
	      _reactAddons2['default'].createElement(
	        'div',
	        { className: 'ofs-CurrencySelector__Disclaimer' },
	        MESSAGES.DISCLAIMER
	      )
	    );
	  }
	});
	
	exports['default'] = CurrencySelector;
	module.exports = exports['default'];

/***/ },
/* 493 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _reactAddons = __webpack_require__(40);
	
	var _reactAddons2 = _interopRequireDefault(_reactAddons);
	
	var _fluxxor = __webpack_require__(69);
	
	var _fluxxor2 = _interopRequireDefault(_fluxxor);
	
	var _ofsComponentsSimpleChoiceSimpleChoice = __webpack_require__(47);
	
	var _ofsComponentsSimpleChoiceSimpleChoice2 = _interopRequireDefault(_ofsComponentsSimpleChoiceSimpleChoice);
	
	var _ofsI18n = __webpack_require__(61);
	
	var _ofsI18n2 = _interopRequireDefault(_ofsI18n);
	
	var _ofsSettings = __webpack_require__(62);
	
	var _ofsPayload = __webpack_require__(355);
	
	var FluxMixin = _fluxxor2['default'].FluxMixin(_reactAddons2['default']);
	
	var gettext = _ofsI18n2['default'].gettext;
	
	var MESSAGES = {
	  LABEL: gettext('Set your language')
	};
	
	var LanguageSelector = _reactAddons2['default'].createClass({
	  displayName: 'LanguageSelector',
	
	  mixins: [FluxMixin],
	
	  handleChange: function handleChange(event) {
	    var option = event.option;
	
	    this.getFlux().actions.tracking.sendGenericEvent({
	      category: 'setLanguage',
	      action: option.props['value']
	    });
	    this.getDOMNode().submit();
	  },
	
	  render: function render() {
	    var options = _ofsSettings.languages.map(function (language) {
	      return _reactAddons2['default'].createElement(
	        'div',
	        { value: language['id'], key: language['id'] },
	        language['label']
	      );
	    });
	
	    return _reactAddons2['default'].createElement(
	      'form',
	      { action: _ofsPayload.languageSelector.url, method: 'POST', className: 'ofs-LanguageSelector' },
	      _reactAddons2['default'].createElement(
	        'div',
	        { className: 'ofs-LanguageSelector__InputContainer' },
	        _reactAddons2['default'].createElement(
	          'label',
	          { className: 'ofs-LanguageSelector__Label' },
	          MESSAGES.LABEL
	        ),
	        _reactAddons2['default'].createElement(
	          _ofsComponentsSimpleChoiceSimpleChoice2['default'],
	          { name: 'language', inverse: true,
	            className: 'ofs-SimpleChoice--inline ofs-LanguageSelector__Select',
	            defaultValue: _ofsSettings.user.languageCode, onChange: this.handleChange },
	          options
	        )
	      )
	    );
	  }
	});
	
	exports['default'] = LanguageSelector;
	module.exports = exports['default'];

/***/ },
/* 494 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _reactAddons = __webpack_require__(40);
	
	var _reactAddons2 = _interopRequireDefault(_reactAddons);
	
	var _jquery = __webpack_require__(39);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _classnames = __webpack_require__(49);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ofsPayload = __webpack_require__(355);
	
	var _ofsI18n = __webpack_require__(61);
	
	var _ofsI18n2 = _interopRequireDefault(_ofsI18n);
	
	var _ofsUtilsClassNameMixin = __webpack_require__(50);
	
	var _ofsUtilsClassNameMixin2 = _interopRequireDefault(_ofsUtilsClassNameMixin);
	
	var _ofsFormsValidatorsEmail = __webpack_require__(495);
	
	var _ofsFormsValidatorsEmail2 = _interopRequireDefault(_ofsFormsValidatorsEmail);
	
	var _ofsComponentsCommonProgressButton = __webpack_require__(496);
	
	var _ofsComponentsCommonProgressButton2 = _interopRequireDefault(_ofsComponentsCommonProgressButton);
	
	var gettext = _ofsI18n2['default'].gettext;
	
	var PureRenderMixin = _reactAddons2['default'].addons.PureRenderMixin;
	
	var MESSAGES = {
	  INPUT_PLACEHOLDER: gettext('Sign-up for email updates'),
	  SUBMIT_BUTTON: gettext('Sign-up'),
	  SUCCESS_MESSAGE: gettext('Email address submitted. Thanks!')
	};
	
	var NewsletterSignUp = _reactAddons2['default'].createClass({
	  displayName: 'NewsletterSignUp',
	
	  mixins: [PureRenderMixin, _ofsUtilsClassNameMixin2['default']],
	
	  propTypes: {
	    source: _reactAddons2['default'].PropTypes.string
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      errors: null,
	      saving: false,
	      saved: false
	    };
	  },
	
	  handleSubmit: function handleSubmit(event) {
	    var _this = this;
	
	    event.preventDefault();
	
	    // validate email
	    var email = this.refs.input.getDOMNode().value;
	    var emailCheck = (0, _ofsFormsValidatorsEmail2['default'])(null, email);
	
	    if (emailCheck instanceof Error) {
	      this.setState({
	        'errors': [emailCheck.message]
	      });
	      this.refs.input.getDOMNode().focus();
	      return false;
	    } else {
	      this.setState({
	        'errors': null,
	        'saving': true
	      });
	    }
	
	    var data = (0, _jquery2['default'])(this.refs['form'].getDOMNode()).serialize();
	
	    _jquery2['default'].ajax({
	      url: _ofsPayload.mailingForm.url,
	      type: 'POST',
	      data: data,
	      dataType: 'json',
	      cache: false,
	      success: function success() {
	        _this.setState({
	          'saved': true,
	          'errors': null,
	          'saving': false
	        });
	      },
	      error: function error(xhr) {
	        _this.setState({
	          'errors': xhr.responseJSON.errors,
	          'saving': false
	        });
	      }
	    });
	  },
	
	  render: function render() {
	
	    var inputClasses = {
	      "ofs-Input": true,
	      "ofs-NewsletterSignUp__Input": true,
	      "ofs-Input--error": this.state.errors ? true : false
	    };
	
	    var buttonClasses = {
	      "ofs-Button": true,
	      "ofs-Button--secondary": this.props.lightBackground ? false : true
	    };
	
	    var successClasses = {
	      'ofs-NewsletterSignUp__Success': true,
	      'ofs-NewsletterSignUp__Success--is-visible': this.state.saved,
	      'ofs-NewsletterSignUp__Success--dark': this.props.lightBackground
	    };
	
	    var formClasses = {
	      '-form--inline': true,
	      'ofs-NewsletterSignUp__Form': true,
	      'ofs-NewsletterSignUp__Form--is-hidden': this.state.saved
	    };
	
	    var errors = [];
	    if (this.state.errors) {
	      errors = this.state.errors.map(function (error) {
	        return _reactAddons2['default'].createElement(
	          'div',
	          { className: 'ofs-NewsletterSignUp__Error' },
	          error
	        );
	      });
	    }
	
	    return _reactAddons2['default'].createElement(
	      'div',
	      { className: this.getClassSet({ "ofs-NewsletterSignUp": true }) },
	      _reactAddons2['default'].createElement(
	        'div',
	        { className: (0, _classnames2['default'])(successClasses) },
	        MESSAGES.SUCCESS_MESSAGE
	      ),
	      _reactAddons2['default'].createElement(
	        'form',
	        { action: _ofsPayload.mailingForm.url, method: 'POST', acceptCharset: 'utf-8',
	          className: (0, _classnames2['default'])(formClasses),
	          onSubmit: this.handleSubmit, ref: 'form' },
	        _reactAddons2['default'].createElement(
	          'div',
	          { className: 'ofs-Form__Field' },
	          _reactAddons2['default'].createElement(
	            'div',
	            { className: 'ofs-NewsletterSignUp__InputWrapper' },
	            _reactAddons2['default'].createElement('input', { name: 'email',
	              type: 'text',
	              ref: 'input',
	              className: (0, _classnames2['default'])(inputClasses),
	              placeholder: MESSAGES.INPUT_PLACEHOLDER }),
	            errors
	          ),
	          _reactAddons2['default'].createElement(
	            _ofsComponentsCommonProgressButton2['default'],
	            { size: 'small', className: (0, _classnames2['default'])(buttonClasses),
	              saving: this.state.saving, finished: this.state.saved, disabled: this.state.saving },
	            this.props.submitCopy || MESSAGES.SUBMIT_BUTTON
	          ),
	          _reactAddons2['default'].createElement(
	            'div',
	            { className: 'ofs-Form__HiddenFields' },
	            _reactAddons2['default'].createElement('input', { defaultChecked: 'checked', name: 'do_not_tick', type: 'checkbox' }),
	            _reactAddons2['default'].createElement('input', { name: 'required', type: 'text' }),
	            _reactAddons2['default'].createElement('input', { defaultChecked: 'checked', name: 'guest', type: 'checkbox' }),
	            _reactAddons2['default'].createElement('input', { defaultChecked: 'checked', name: 'host', type: 'checkbox' }),
	            _reactAddons2['default'].createElement('input', { defaultChecked: 'checked', name: 'industry', type: 'checkbox' }),
	            _reactAddons2['default'].createElement('input', { name: 'source', type: 'hidden', value: this.props.source })
	          )
	        )
	      )
	    );
	  }
	});
	
	exports['default'] = NewsletterSignUp;
	module.exports = exports['default'];

/***/ },
/* 495 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var email = __webpack_require__(230);
	
	var i18n = __webpack_require__(61);
	var gettext = i18n.gettext;
	
	var messages = {
	  EMAIL_ERROR: gettext('Must be a valid email address')
	};
	
	module.exports = function (schema, value) {
	  if (!email.valid(value)) {
	    return new Error(messages.EMAIL_ERROR);
	  }
	};

/***/ },
/* 496 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _reactAddons = __webpack_require__(40);
	
	var _reactAddons2 = _interopRequireDefault(_reactAddons);
	
	var _ofsUtilsClassNameMixin = __webpack_require__(50);
	
	var _ofsUtilsClassNameMixin2 = _interopRequireDefault(_ofsUtilsClassNameMixin);
	
	var _ofsUtilsSetIntervalMixin = __webpack_require__(497);
	
	var _ofsUtilsSetIntervalMixin2 = _interopRequireDefault(_ofsUtilsSetIntervalMixin);
	
	var PureRenderMixin = _reactAddons2['default'].addons.PureRenderMixin;
	
	function noop() {}
	
	var ProgressButton = _reactAddons2['default'].createClass({
	  displayName: 'ProgressButton',
	
	  mixins: [PureRenderMixin, _ofsUtilsClassNameMixin2['default'], _ofsUtilsSetIntervalMixin2['default']],
	
	  propTypes: {
	    'children': _reactAddons2['default'].PropTypes.string.isRequired,
	    'saving': _reactAddons2['default'].PropTypes.bool.isRequired,
	    'finished': _reactAddons2['default'].PropTypes.bool.isRequired,
	    'size': _reactAddons2['default'].PropTypes.string,
	    'onClick': _reactAddons2['default'].PropTypes.func
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      'onClick': noop
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      'progress': 0
	    };
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (nextProps.finished === true && this.props.finished === false) {
	      // finished loading
	      this.clearIntervals();
	      this.setState({
	        'progress': 1
	      });
	    }
	
	    if (nextProps.saving === true && this.props.saving === false) {
	      // start progress bar
	      this.setInterval(this.progressTick, 200);
	    }
	  },
	
	  progressTick: function progressTick() {
	    var progress = this.state.progress;
	
	    var newProgress = Math.min(progress + Math.random() * 0.1, 1);
	
	    // don't ever reach 1
	    if (newProgress < 1) {
	      this.setState({
	        'progress': newProgress
	      });
	    }
	  },
	
	  render: function render() {
	    var buttonClasses = {
	      'ofs-Button': true,
	      'ofs-ProgressButton': true,
	      'ofs-ProgressButton--saving': this.state.saving
	    };
	
	    if (this.props.size) {
	      buttonClasses['ofs-Button--' + this.props.size] = true;
	    }
	
	    var progressBarWidth = this.state.progress * 100 + '%';
	
	    return _reactAddons2['default'].createElement(
	      'button',
	      { className: this.getClassSet(buttonClasses),
	        onClick: this.props.onClick,
	        disabled: this.props.disabled
	      },
	      _reactAddons2['default'].createElement(
	        'span',
	        { className: 'ofs-ProgressButton__Content' },
	        this.props.children
	      ),
	      _reactAddons2['default'].createElement('span', { className: 'ofs-ProgressButton__ProgressBar', style: { 'width': progressBarWidth } })
	    );
	  }
	});
	
	exports['default'] = ProgressButton;
	module.exports = exports['default'];

/***/ },
/* 497 */
/***/ function(module, exports) {

	"use strict";
	
	/* This mixin provides a simple setInterval method.
	 *
	 * Example:
	 *
	 *     var Component = React.createClass({
	 *         ...
	 *         componentDidMount: function() {
	 *             this.setInterval(this.doSomething, 1000);
	 *             this.setInterval(this.doSomethingElse, 5000);
	 *         }
	 *         ...
	 *     });
	 *
	 * doSomething is called every second and doSomethingElse is called every five
	 * seconds. Their intervals will be canceled automatically when the component
	 * unmounts.
	 */
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var SetIntervalMixin = {
	  componentWillMount: function componentWillMount() {
	    this.intervals = [];
	  },
	  setInterval: (function (_setInterval) {
	    function setInterval(_x, _x2) {
	      return _setInterval.apply(this, arguments);
	    }
	
	    setInterval.toString = function () {
	      return _setInterval.toString();
	    };
	
	    return setInterval;
	  })(function (fn, ms) {
	    this.intervals.push(setInterval(fn, ms));
	  }),
	  clearIntervals: function clearIntervals() {
	    this.intervals.forEach(clearInterval);
	    this.intervals = [];
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    this.clearIntervals();
	  }
	};
	
	exports["default"] = SetIntervalMixin;
	module.exports = exports["default"];

/***/ },
/* 498 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _reactAddons = __webpack_require__(40);
	
	var _reactAddons2 = _interopRequireDefault(_reactAddons);
	
	var _ofsI18n = __webpack_require__(61);
	
	var _ofsComponentsMailingNewsletterSignUp = __webpack_require__(494);
	
	var _ofsComponentsMailingNewsletterSignUp2 = _interopRequireDefault(_ofsComponentsMailingNewsletterSignUp);
	
	var MESSAGES = {
	  TITLE: (0, _ofsI18n.gettext)("£20 off your first onefinestay booking"),
	  BODY_COPY: (0, _ofsI18n.gettext)('Sign up to our newsletter and get £20 toward your first booking.  We\'ll send you a weekly dose of travel inspiration, keeping you up-to-date with onefinestay\'s finest homes.'),
	  PLACEHOLDER: (0, _ofsI18n.gettext)("Sign-up for email updates"),
	  SUBMIT: (0, _ofsI18n.gettext)("Go")
	};
	
	var WelcomeVoucher = _reactAddons2['default'].createClass({
	  displayName: 'WelcomeVoucher',
	
	  render: function render() {
	    return _reactAddons2['default'].createElement(
	      'div',
	      { className: 'ofs-WelcomeVoucher' },
	      _reactAddons2['default'].createElement(
	        'div',
	        { className: 'ofs-WelcomeVoucher__Wrapper' },
	        _reactAddons2['default'].createElement(
	          'h1',
	          { className: 'ofs-WelcomeVoucher__Title' },
	          MESSAGES.TITLE
	        ),
	        _reactAddons2['default'].createElement(
	          'div',
	          { className: 'ofs-WelcomeVoucher__Body' },
	          _reactAddons2['default'].createElement(
	            'span',
	            { className: 'ofs-WelcomeVoucher__Copy' },
	            MESSAGES.BODY_COPY
	          ),
	          _reactAddons2['default'].createElement(_ofsComponentsMailingNewsletterSignUp2['default'], { lightBackground: true, submitCopy: MESSAGES.SUBMIT, source: 'popup' })
	        )
	      )
	    );
	  }
	});
	
	exports['default'] = WelcomeVoucher;
	module.exports = exports['default'];

/***/ },
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(3)['default'];
	
	var _inherits = __webpack_require__(17)['default'];
	
	var _createClass = __webpack_require__(28)['default'];
	
	var _classCallCheck = __webpack_require__(31)['default'];
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	var _reactAddons = __webpack_require__(40);
	
	var _reactAddons2 = _interopRequireDefault(_reactAddons);
	
	var _ofsMoment = __webpack_require__(57);
	
	var _ofsMoment2 = _interopRequireDefault(_ofsMoment);
	
	var _ofsAppsCoreEntry = __webpack_require__(450);
	
	var _ofsAppsCoreEntry2 = _interopRequireDefault(_ofsAppsCoreEntry);
	
	var _views = __webpack_require__(511);
	
	var _views2 = _interopRequireDefault(_views);
	
	var _modelsPagemodel = __webpack_require__(527);
	
	var _modelsPagemodel2 = _interopRequireDefault(_modelsPagemodel);
	
	var _viewsResponsiveBreadbar = __webpack_require__(530);
	
	var _viewsResponsiveBreadbar2 = _interopRequireDefault(_viewsResponsiveBreadbar);
	
	var ArrivalEntryPoint = (function (_EntryPoint) {
	  _inherits(ArrivalEntryPoint, _EntryPoint);
	
	  function ArrivalEntryPoint() {
	    _classCallCheck(this, ArrivalEntryPoint);
	
	    _get(Object.getPrototypeOf(ArrivalEntryPoint.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(ArrivalEntryPoint, [{
	    key: 'renderToDocument',
	    value: function renderToDocument(document) {
	      var options = this.options;
	
	      if (!options.standalone) {
	        _get(Object.getPrototypeOf(ArrivalEntryPoint.prototype), 'renderToDocument', this).call(this, document);
	      }
	
	      var _options$prestay = options.prestay;
	      var formOptions = _options$prestay.formOptions;
	      var formData = _options$prestay.formData;
	      var contact = _options$prestay.contact;
	      var bookingRef = _options$prestay.bookingRef;
	
	      var model = new _modelsPagemodel2['default']();
	
	      var views = (0, _views2['default'])(formOptions);
	
	      if (formData) {
	        var eta = formData['eta'];
	        var arrivalPhone = formData['arrival_phone'];
	
	        delete formData['eta'];
	        delete formData['arrival_phone'];
	
	        formData['bookable_transfers'] = formOptions['bookable_transfers'];
	        formData['num_guests'] = formOptions['num_guests'];
	        model.travel.set(formData);
	        model.set('arrival_phone', arrivalPhone);
	        model.set('eta', eta);
	
	        var arrival = (0, _ofsMoment2['default'])(formData['arrival_time'], "YYYY-MM-DDTHH:mm");
	        model.set('arrival_time', arrival.format("HH:mm:ss"), { silent: true });
	        model.set('arrival_date', arrival.format("YYYY-MM-DD"), { silent: true });
	
	        if (formData['appointment_type'] && formData['appointment_time']) {
	          model.appointment.set('selected_appointment', {
	            type: formData['appointment_type'],
	            time: formData['appointment_time']
	          });
	          model.appointment.set({
	            'appointment_place_type': formData['appointment_place_type'],
	            'external_location': formData['external_location'],
	            'external_address': formData['external_address'],
	            'external_map_link': formData['external_map_link'],
	            'price_override': formData['price_override']
	          });
	        }
	
	        model.appointment.set('appointments', formOptions['suggested_appointments']);
	
	        if (formOptions['journey_details']) {
	          model.set('journey', formOptions['journey_details'].legs);
	        }
	      }
	      var Arrivals = views.Arrivals;
	      _reactAddons2['default'].withContext({ flux: this.flux }, function () {
	        _reactAddons2['default'].render(_reactAddons2['default'].createElement(Arrivals, { model: model, contact: contact }), document.getElementById('arrivals-form'));
	      });
	
	      var breadbar = document.getElementById('breadbar');
	      if (breadbar) {
	        _reactAddons2['default'].render(_reactAddons2['default'].createElement(_viewsResponsiveBreadbar2['default'], { bookingRef: bookingRef, currentPage: 'book-capture-arrival' }), breadbar);
	      }
	    }
	  }]);
	
	  return ArrivalEntryPoint;
	})(_ofsAppsCoreEntry2['default']);
	
	module.exports = ArrivalEntryPoint;

/***/ },
/* 511 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	var _reactAddons = __webpack_require__(40);
	
	var _reactAddons2 = _interopRequireDefault(_reactAddons);
	
	var _underscore = __webpack_require__(66);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _jquery = __webpack_require__(39);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _moment = __webpack_require__(58);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _ofsI18n = __webpack_require__(61);
	
	var _ofsSettings = __webpack_require__(62);
	
	var _ofsSettings2 = _interopRequireDefault(_ofsSettings);
	
	var _ofsComponentsCommonIcon = __webpack_require__(51);
	
	var _ofsComponentsCommonIcon2 = _interopRequireDefault(_ofsComponentsCommonIcon);
	
	var _ofsAppsBookingsPrestayViewsPrestayContentSection = __webpack_require__(512);
	
	var _ofsAppsBookingsPrestayViewsPrestayContentSection2 = _interopRequireDefault(_ofsAppsBookingsPrestayViewsPrestayContentSection);
	
	var _viewsAppointments = __webpack_require__(513);
	
	var _viewsAppointments2 = _interopRequireDefault(_viewsAppointments);
	
	var _viewsSaveButton = __webpack_require__(522);
	
	var _viewsSaveButton2 = _interopRequireDefault(_viewsSaveButton);
	
	var _ofsFormsLayoutRow = __webpack_require__(226);
	
	var _ofsFormsLayoutRow2 = _interopRequireDefault(_ofsFormsLayoutRow);
	
	var _ofsFormsLayoutColumn = __webpack_require__(227);
	
	var _ofsFormsLayoutColumn2 = _interopRequireDefault(_ofsFormsLayoutColumn);
	
	var _ofsReactFieldsFieldcontainer = __webpack_require__(519);
	
	var _ofsReactFieldsFieldcontainer2 = _interopRequireDefault(_ofsReactFieldsFieldcontainer);
	
	var _ofsReactFieldsField = __webpack_require__(516);
	
	var _ofsReactFieldsField2 = _interopRequireDefault(_ofsReactFieldsField);
	
	var _ofsReactFieldsRadiofield = __webpack_require__(523);
	
	var _ofsReactFieldsRadiofield2 = _interopRequireDefault(_ofsReactFieldsRadiofield);
	
	var _ofsReactComponentsDatepicker = __webpack_require__(524);
	
	var _ofsReactComponentsDatepicker2 = _interopRequireDefault(_ofsReactComponentsDatepicker);
	
	var _ofsReactFieldsTimefield = __webpack_require__(525);
	
	var _ofsReactFieldsTimefield2 = _interopRequireDefault(_ofsReactFieldsTimefield);
	
	var _ofsReactFieldsTextfield = __webpack_require__(514);
	
	var _ofsReactFieldsTextfield2 = _interopRequireDefault(_ofsReactFieldsTextfield);
	
	var _ofsReactFieldsSelectfield = __webpack_require__(518);
	
	var _ofsReactFieldsSelectfield2 = _interopRequireDefault(_ofsReactFieldsSelectfield);
	
	var _ofsReactFieldsPhonenumberfield = __webpack_require__(526);
	
	var _ofsReactFieldsPhonenumberfield2 = _interopRequireDefault(_ofsReactFieldsPhonenumberfield);
	
	var messages = {
	  ADD_TO_BILL: (0, _ofsI18n.gettext)("Yes please add %(currency)s%(amount)s to my bill"),
	  AIRPORT: (0, _ofsI18n.gettext)("Airport"),
	  ARRANGE_PICKUP: (0, _ofsI18n.gettext)("Would you like us to arrange a pick up?"),
	  ARRIVAL_AT_THE_HOME: (0, _ofsI18n.gettext)("Arrival at the home"),
	  ARRIVAL_MOBILE_NUMBER: (0, _ofsI18n.gettext)("What is your mobile number for arrival?"),
	  ANOTHER_METHOD: (0, _ofsI18n.gettext)("Another method"),
	  BY_TRAIN: (0, _ofsI18n.gettext)("By train"),
	  CAR_TAXI: (0, _ofsI18n.gettext)("Car/Taxi"),
	  CALCULATE_ARRIVAL: (0, _ofsI18n.gettext)("Calculate arrival time"),
	  CHECK: (0, _ofsI18n.gettext)("Check"),
	  CHECKING: (0, _ofsI18n.gettext)("Checking"),
	  DIFFERENT_ARRIVAL_TIME_AT_HOME: (0, _ofsI18n.gettext)("Getting to the home at a different time?"),
	  DRIVING: (0, _ofsI18n.gettext)("Driving"),
	  ENTER_MANUALLY: (0, _ofsI18n.gettext)("Please enter your details manually"),
	  ESTIMATE: (0, _ofsI18n.gettext)('We know estimating is tricky. Please take a shot and keep us updated on the day – so someone can meet you.'),
	  ESTIMATE_YOUR_ARRIVAL_TIME: (0, _ofsI18n.gettext)("Please estimate your arrival time below to get your appointment."),
	  ESTIMATED_ARRIVAL: (0, _ofsI18n.gettext)("Estimated arrival time at the home"),
	  FIND_APPOINTMENTS: (0, _ofsI18n.gettext)("Find available appointments"),
	  FLIGHT_ARRIVAL_TIME: (0, _ofsI18n.gettext)("Flight arrival time"),
	  FLIGHT_NUMBER: (0, _ofsI18n.gettext)("Flight number"),
	  FLYING_IN: (0, _ofsI18n.gettext)("Flying in"),
	  GET_TO_CITY: (0, _ofsI18n.gettext)("How will you be getting to %(city)s?"),
	  GET_TO_HOME: (0, _ofsI18n.gettext)("How will you get to the home"),
	  GREETERS_WILL_MEET: (0, _ofsI18n.gettext)("One of our friendly Meet & Greeters will welcome you and introduce you to the home."),
	  JOURNEY_ERROR: (0, _ofsI18n.gettext)("Sorry, something went wrong trying to get your journey details."),
	  HOW: (0, _ofsI18n.gettext)("We'd love to know how"),
	  NO_THANKS: (0, _ofsI18n.gettext)("No thanks, I'm all set"),
	  OOPS: (0, _ofsI18n.gettext)("Oops-a-daisy, we can't find that flight number."),
	  PUBLIC_TRANSPORT: (0, _ofsI18n.gettext)("Public Transport"),
	  SELECT_AIRPORT: (0, _ofsI18n.gettext)("Select an airport"),
	  SELECT_STATION: (0, _ofsI18n.gettext)("Select a station"),
	  TRAIN_ARRIVAL_TIME: (0, _ofsI18n.gettext)("Train arrival time"),
	  TRAIN_STATION: (0, _ofsI18n.gettext)("Train station"),
	  TRAVEL_ARRANGEMENTS: (0, _ofsI18n.gettext)("Travel arrangements"),
	  WHICH_STATION: (0, _ofsI18n.gettext)("Which station"),
	  VEHICLE_LIMIT_WARNING: (0, _ofsI18n.gettext)("Please be aware that our airport transfer partner can take up to four passengers per vehicle. If you need a bigger taxi, drop us a line at")
	};
	
	module.exports = function (config) {
	
	  // transfer options
	  var TransferField = _reactAddons2['default'].createClass({
	    displayName: 'TransferField',
	
	    render: function render() {
	      var model = this.props.model;
	
	      var typeChoices = [['public', messages.PUBLIC_TRANSPORT], ['private', messages.CAR_TAXI]];
	      var bookChoices = [['yes', (0, _ofsI18n.interpolate)(messages.ADD_TO_BILL, { currency: config.currency_symbol, amount: model.transferAmount() }, true)], ['no', messages.NO_THANKS]];
	
	      var transferOptions = undefined;
	
	      if (!model.hasTransferAmount()) {
	        transferOptions = null;
	      } else if (model.canOrganiseTransfer()) {
	        transferOptions = _reactAddons2['default'].createElement(_ofsReactFieldsRadiofield2['default'], { label: messages.ARRANGE_PICKUP, model: model, field: 'booked_transfer', choices: bookChoices, name: 'booked_  ' });
	      } else {
	        transferOptions = _reactAddons2['default'].createElement(
	          'p',
	          null,
	          messages.VEHICLE_LIMIT_WARNING,
	          ' ',
	          _reactAddons2['default'].createElement(
	            'a',
	            { href: "mailto:" + _ofsSettings2['default'].cities[config.city_code].contact.guests.email },
	            _ofsSettings2['default'].cities[config.city_code].contact.guests.email
	          ),
	          '.'
	        );
	      }
	
	      return _reactAddons2['default'].createElement(
	        'div',
	        null,
	        _reactAddons2['default'].createElement(_ofsReactFieldsRadiofield2['default'], { label: messages.GET_TO_HOME, model: model, field: 'transfer_type', choices: typeChoices, name: 'transfer_type', disabled: this.props.disabled }),
	        transferOptions
	      );
	    }
	  });
	
	  // Text shown on successful flight lookup
	  var FlightText = _reactAddons2['default'].createClass({
	    displayName: 'FlightText',
	
	    render: function render() {
	      var model = this.props.model;
	
	      return _reactAddons2['default'].createElement(
	        'div',
	        { className: 'flight-details' },
	        model.get('flight_airline'),
	        ' flight ',
	        model.get('flight_number'),
	        ', departing ',
	        model.get('flight_departure_airport'),
	        ' ',
	        ' ',
	        ' ',
	        model.get('flight_departure_time'),
	        ', arriving ',
	        model.get('airport'),
	        ' ',
	        model.get('flight_eta')
	      );
	    }
	  });
	
	  var FlightCodeField = _reactAddons2['default'].createClass({
	    displayName: 'FlightCodeField',
	
	    getInitialState: function getInitialState() {
	      return {
	        flightNumber: this.props.model.get('flight_number') || null,
	        loading: false,
	        manual: false,
	        invalid: false
	      };
	    },
	
	    lookup: _underscore2['default'].debounce(function () {
	      _jquery2['default'].ajax(config.flight_endpoint, {
	        data: { flight_number: this.state.flightNumber },
	        success: _underscore2['default'].bind(function (data) {
	          this.props.model.set(data);
	          this.setState({
	            loading: false,
	            invalid: false
	          });
	        }, this),
	        error: _underscore2['default'].bind(function () {
	          this.props.model.set({
	            flight_airline: null,
	            flight_number: null,
	            flight_arrival_airport: null,
	            flight_departure_airport: null,
	            flight_departure_time: null
	          });
	          this.setState({
	            loading: false,
	            invalid: true
	          });
	        }, this)
	      });
	    }, 1000),
	
	    handleChange: function handleChange(event) {
	      var value = event.target.value;
	
	      this.setState({ flightNumber: value });
	    },
	
	    handleClick: function handleClick() {
	      this.setState({ loading: true });
	      this.lookup();
	    },
	
	    render: function render() {
	      var _props = this.props;
	      var model = _props.model;
	      var name = _props.name;
	      var onManualFlightClick = _props.onManualFlightClick;
	      var _state = this.state;
	      var flightNumber = _state.flightNumber;
	      var loading = _state.loading;
	      var invalid = _state.invalid;
	
	      return _reactAddons2['default'].createElement(
	        _ofsReactFieldsFieldcontainer2['default'],
	        { label: messages.FLIGHT_NUMBER },
	        _reactAddons2['default'].createElement(
	          _ofsFormsLayoutRow2['default'],
	          null,
	          _reactAddons2['default'].createElement(
	            _ofsFormsLayoutColumn2['default'],
	            { size: 'three-quarters' },
	            _reactAddons2['default'].createElement('input', { className: 'flight-number', type: 'text', value: flightNumber, onChange: this.handleChange, id: name })
	          ),
	          _reactAddons2['default'].createElement(
	            _ofsFormsLayoutColumn2['default'],
	            { size: 'quarter' },
	            _reactAddons2['default'].createElement(
	              'div',
	              { className: 'ofs-PrestayArrival__CheckingStatus' },
	              loading ? _reactAddons2['default'].createElement(
	                'span',
	                null,
	                messages.CHECKING
	              ) : _reactAddons2['default'].createElement(
	                'button',
	                { className: 'ofs-Button ofs-Button--small ofs-Button--full-width', onClick: this.handleClick, disabled: flightNumber ? null : 'disabled' },
	                messages.CHECK
	              )
	            )
	          )
	        ),
	        _reactAddons2['default'].createElement(
	          'div',
	          { className: 'ofs-PrestayArrival__InputMessage' },
	          !invalid && model.get('flight_number') ? _reactAddons2['default'].createElement(FlightText, { model: model }) : null,
	          invalid ? _reactAddons2['default'].createElement(
	            'span',
	            null,
	            messages.OOPS,
	            ' ',
	            _reactAddons2['default'].createElement(
	              'a',
	              { href: 'javascript:void(0)', onClick: onManualFlightClick },
	              messages.ENTER_MANUALLY
	            ),
	            '.'
	          ) : null
	        )
	      );
	    }
	  });
	
	  var ManualFlightDetails = _reactAddons2['default'].createClass({
	    displayName: 'ManualFlightDetails',
	
	    render: function render() {
	      var model = this.props.model;
	
	      var choices = config.airport_choices.slice(0).map(function (choice) {
	        return {
	          value: choice[0],
	          name: choice[1]
	        };
	      });
	
	      var airport = model.travel.get('airport');
	
	      return _reactAddons2['default'].createElement(
	        'div',
	        { className: 'manual-flight' },
	        _reactAddons2['default'].createElement(_ofsReactFieldsSelectfield2['default'], { placeholder: messages.SELECT_AIRPORT, key: 'airport', label: messages.AIRPORT, name: 'airport', model: model.travel, field: 'airport', defaultValue: airport, options: choices }),
	        _reactAddons2['default'].createElement(_ofsReactFieldsTimefield2['default'], { label: messages.FLIGHT_ARRIVAL_TIME, name: 'flight_eta', model: model.travel, field: 'flight_eta' }),
	        _reactAddons2['default'].createElement(TransferField, { model: model.travel })
	      );
	    }
	  });
	
	  var CalculatedFlightDetails = _reactAddons2['default'].createClass({
	    displayName: 'CalculatedFlightDetails',
	
	    render: function render() {
	      var model = this.props.model;
	
	      return _reactAddons2['default'].createElement(
	        'div',
	        { className: 'calculated-flight' },
	        _reactAddons2['default'].createElement(FlightCodeField, { model: model.travel, field: 'flight_number', name: 'flight_number', onManualFlightClick: this.props.onManualFlightClick }),
	        _reactAddons2['default'].createElement(TransferField, { model: model.travel })
	      );
	    }
	  });
	
	  var FlightOptions = _reactAddons2['default'].createClass({
	    displayName: 'FlightOptions',
	
	    getInitialState: function getInitialState() {
	      var model = this.props.model;
	
	      return {
	        manual: model.travel.get('airport') && !model.travel.get('flight_number') ? true : false
	      };
	    },
	
	    handleManualFlightClick: function handleManualFlightClick() {
	      this.props.model.travel.unset('flight_number');
	      this.setState({
	        manual: true
	      });
	    },
	
	    render: function render() {
	      var model = this.props.model;
	
	      return _reactAddons2['default'].createElement(
	        'div',
	        { className: 'flight-options' },
	        !this.state.manual ? _reactAddons2['default'].createElement(CalculatedFlightDetails, { model: model, onManualFlightClick: this.handleManualFlightClick }) : null,
	        this.state.manual ? _reactAddons2['default'].createElement(ManualFlightDetails, { model: model }) : null
	      );
	    }
	  });
	
	  var TrainOptions = _reactAddons2['default'].createClass({
	    displayName: 'TrainOptions',
	
	    render: function render() {
	      var model = this.props.model;
	
	      var choices = config.station_choices.slice(0).map(function (choice) {
	        return {
	          value: choice[0],
	          name: choice[1]
	        };
	      });
	
	      var trainStation = model.travel.get('train_station');
	      return _reactAddons2['default'].createElement(
	        'div',
	        { className: 'train-options' },
	        _reactAddons2['default'].createElement(_ofsReactFieldsSelectfield2['default'], { placeholder: messages.SELECT_STATION, key: 'train_station', label: messages.TRAIN_STATION, name: 'train_station', model: model.travel, field: 'train_station', options: choices, defaultValue: trainStation }),
	        trainStation && trainStation !== 'N/A' ? _reactAddons2['default'].createElement(
	          'div',
	          null,
	          _reactAddons2['default'].createElement(_ofsReactFieldsTimefield2['default'], { label: messages.TRAIN_ARRIVAL_TIME, name: 'train_eta', model: model.travel, field: 'train_eta' }),
	          _reactAddons2['default'].createElement(TransferField, { model: model.travel, disabled: !model.travel.get('train_station') ? 'disabled' : null })
	        ) : null,
	        trainStation === 'N/A' ? _reactAddons2['default'].createElement(
	          'div',
	          null,
	          _reactAddons2['default'].createElement(_ofsReactFieldsTextfield2['default'], { label: messages.WHICH_STATION, name: 'other_station', model: model.travel, field: 'other_station' })
	        ) : null
	      );
	    }
	  });
	
	  var OtherTransportOptions = _reactAddons2['default'].createClass({
	    displayName: 'OtherTransportOptions',
	
	    render: function render() {
	      var model = this.props.model;
	
	      return _reactAddons2['default'].createElement(
	        'div',
	        { className: 'other-transport-options' },
	        _reactAddons2['default'].createElement(_ofsReactFieldsTextfield2['default'], { label: messages.HOW, name: 'other_method', model: model.travel, field: 'other_method' })
	      );
	    }
	  });
	  var JourneySummary = _reactAddons2['default'].createClass({
	    displayName: 'JourneySummary',
	
	    handleDateChange: function handleDateChange(value) {
	      this.props.model.set('arrival_date', value.format("YYYY-MM-DD"));
	    },
	    render: function render() {
	      var model = this.props.model;
	
	      var journeyLegs = undefined;
	
	      if (Array.isArray(model.get('journey'))) {
	        journeyLegs = model.get('journey').map(function (leg) {
	          if (leg.delta === '0:00:00') {
	            // End
	            if (leg.leg === 'Arrival at home') {
	              return _reactAddons2['default'].createElement(
	                'li',
	                { key: leg.leg, className: 'ofs-TravelTime__Item' },
	                _reactAddons2['default'].createElement(_ofsComponentsCommonIcon2['default'], { glyph: 'arrow', size: 'large', variant: 'right' }),
	                _reactAddons2['default'].createElement(
	                  'div',
	                  { className: 'ofs-TravelTime__InfoWrapper' },
	                  _reactAddons2['default'].createElement(
	                    'span',
	                    { className: 'ofs-TravelTime__Label' },
	                    leg.leg
	                  ),
	                  _reactAddons2['default'].createElement(
	                    'span',
	                    { className: 'ofs-TravelTime__Info' },
	                    (0, _moment2['default'])(leg.end_time, "YYYY-MM-DDTHH:mm").format('HH:mm')
	                  ),
	                  _reactAddons2['default'].createElement('span', { className: 'ofs-TravelTime__Label u-text-italic' })
	                )
	              );
	            } else {
	              return _reactAddons2['default'].createElement(
	                'li',
	                { key: leg.leg, className: 'ofs-TravelTime__Item' },
	                _reactAddons2['default'].createElement(
	                  'span',
	                  { className: 'ofs-TravelTime__Label' },
	                  leg.leg
	                ),
	                _reactAddons2['default'].createElement(
	                  'span',
	                  { className: 'ofs-TravelTime__Info' },
	                  (0, _moment2['default'])(leg.end_time, "YYYY-MM-DDTHH:mm").format('HH:mm')
	                ),
	                _reactAddons2['default'].createElement('span', { className: 'ofs-TravelTime__Label u-text-italic' })
	              );
	            }
	          } else {
	            // It's an intermediate step
	            var hour = (0, _moment2['default'])(leg.delta, "YYYY-MM-DDTHH:mm").hours();
	            var minute = (0, _moment2['default'])(leg.delta, "YYYY-MM-DDTHH:mm").minutes();
	
	            return _reactAddons2['default'].createElement(
	              'li',
	              { key: leg.leg, className: 'ofs-TravelTime__Item' },
	              _reactAddons2['default'].createElement(_ofsComponentsCommonIcon2['default'], { glyph: 'arrow', size: 'large', variant: 'right' }),
	              _reactAddons2['default'].createElement(
	                'div',
	                { className: 'ofs-TravelTime__InfoWrapper' },
	                _reactAddons2['default'].createElement(
	                  'span',
	                  { className: 'ofs-TravelTime__Label' },
	                  leg.leg
	                ),
	                _reactAddons2['default'].createElement(
	                  'span',
	                  { className: 'ofs-TravelTime__Info' },
	                  '+',
	                  hour ? hour + 'h ' : null,
	                  minute,
	                  'min'
	                ),
	                _reactAddons2['default'].createElement(
	                  'span',
	                  { className: 'ofs-TravelTime__Label u-text-italic' },
	                  'Estimate'
	                )
	              )
	            );
	          }
	        });
	      }
	
	      var currentDate = (0, _moment2['default'])(model.travel.get('appointment_time'), "YYYY-MM-DDTHH:mm").format("YYYY-MM-DD");
	      return _reactAddons2['default'].createElement(
	        'div',
	        { className: 'ofs-PrestayArrival__JourneySummary ' },
	        _reactAddons2['default'].createElement(
	          'h3',
	          null,
	          messages.ARRIVAL_AT_THE_HOME
	        ),
	        _reactAddons2['default'].createElement(
	          'ul',
	          { className: 'ofs-TravelTime' },
	          journeyLegs
	        ),
	        _reactAddons2['default'].createElement(_ofsReactFieldsTimefield2['default'], { key: 'journey_eta',
	          label: messages.DIFFERENT_ARRIVAL_TIME_AT_HOME,
	          name: 'arrival_time',
	          model: model, field: 'arrival_time' }),
	        config.admin ? _reactAddons2['default'].createElement(
	          _ofsReactFieldsField2['default'],
	          { label: 'Getting to the home on a different date? (admin)', adminOnly: true },
	          _reactAddons2['default'].createElement(_ofsReactComponentsDatepicker2['default'], { value: currentDate, name: 'arrival_appointment_date', handleSelect: this.handleDateChange, flux: window.ofsFlux })
	        ) : null
	      );
	    }
	  });
	
	  var CalculatedJourney = _reactAddons2['default'].createClass({
	    displayName: 'CalculatedJourney',
	
	    getInitialState: function getInitialState() {
	      return {
	        loading: false,
	        error: false
	      };
	    },
	
	    handleDateChange: function handleDateChange(value) {
	      this.props.model.set('arrival_date', value.format("YYYY-MM-DD"));
	    },
	
	    handleClick: function handleClick(event) {
	      var _this = this;
	
	      var model = this.props.model;
	
	      event.preventDefault();
	      this.setState({ loading: true });
	
	      var payload = JSON.stringify(model.travel.toJSON());
	
	      _jquery2['default'].post(config.journey_endpoint, { payload: payload }).done(function (data) {
	        model.set('arrival_time', data.eta);
	        model.set('journey', data.journey);
	        model.appointment.set('appointments', data.appointments);
	        _this.setState({ loading: false });
	      }).fail(function () {
	        model.set('journey', true);
	        _this.setState({
	          loading: false,
	          error: true
	        });
	      });
	    },
	
	    render: function render() {
	      var model = this.props.model;
	
	      if (this.state.error) {
	        var currentDate = (0, _moment2['default'])(this.props.model.travel.get('appointment_time'), "YYYY-MM-DDTHH:mm").format("YYYY-MM-DD");
	        return _reactAddons2['default'].createElement(
	          'div',
	          { className: 'calculated-journey' },
	          _reactAddons2['default'].createElement(
	            'div',
	            { className: 'ofs-Prestay__PlaceholderBox' },
	            _reactAddons2['default'].createElement(
	              'p',
	              null,
	              messages.JOURNEY_ERROR,
	              _reactAddons2['default'].createElement('br', null),
	              messages.ESTIMATE_YOUR_ARRIVAL_TIME
	            )
	          ),
	          _reactAddons2['default'].createElement(_ofsReactFieldsTimefield2['default'], { key: 'journey_eta', label: messages.ESTIMATED_ARRIVAL, name: 'arrival_time', model: model, field: 'arrival_time' }),
	          config.admin ? _reactAddons2['default'].createElement(
	            _ofsReactFieldsField2['default'],
	            { label: 'Getting to the home on a different date? (admin)', adminOnly: true },
	            _reactAddons2['default'].createElement(_ofsReactComponentsDatepicker2['default'], { value: currentDate, name: 'arrival_appointment_date', handleSelect: this.handleDateChange, flux: window.ofsFlux })
	          ) : null
	        );
	      }
	      return _reactAddons2['default'].createElement(
	        'div',
	        { className: 'calculated-journey' },
	        model.get('journey') ? _reactAddons2['default'].createElement(JourneySummary, { model: model }) : _reactAddons2['default'].createElement(
	          'div',
	          { className: 'ofs-Prestay__PlaceholderBox' },
	          this.state.loading ? 'Loading' : _reactAddons2['default'].createElement(
	            'button',
	            { disabled: model.travel.canCalculateJourney() ? null : 'disabled', className: 'ofs-Button small', onClick: this.handleClick },
	            messages.CALCULATE_ARRIVAL
	          )
	        )
	      );
	    }
	  });
	
	  var ManualJourney = _reactAddons2['default'].createClass({
	    displayName: 'ManualJourney',
	
	    handleDateChange: function handleDateChange(value) {
	      this.props.model.set('arrival_date', value.format("YYYY-MM-DD"));
	    },
	    render: function render() {
	      var model = this.props.model;
	
	      var currentDate = (0, _moment2['default'])(model.travel.get('appointment_time'), "YYYY-MM-DDTHH:mm").format("YYYY-MM-DD");
	      return _reactAddons2['default'].createElement(
	        'div',
	        { className: 'manual-journey' },
	        _reactAddons2['default'].createElement(_ofsReactFieldsTimefield2['default'], { label: messages.ESTIMATED_ARRIVAL, name: 'arrival_time', model: model, field: 'arrival_time' }),
	        config.admin ? _reactAddons2['default'].createElement(
	          _ofsReactFieldsField2['default'],
	          { label: 'Getting to the home on a different date? (admin)', adminOnly: true },
	          _reactAddons2['default'].createElement(_ofsReactComponentsDatepicker2['default'], { value: currentDate, name: 'arrival_appointment_date', handleSelect: this.handleDateChange, flux: window.ofsFlux })
	        ) : null,
	        _reactAddons2['default'].createElement(
	          'p',
	          null,
	          messages.ESTIMATE
	        )
	      );
	    }
	  });
	
	  var TransportOptions = _reactAddons2['default'].createClass({
	    displayName: 'TransportOptions',
	
	    render: function render() {
	      var model = this.props.model;
	
	      var choices = [{ value: 'plane', name: messages.FLYING_IN }, { value: 'train', name: messages.BY_TRAIN }, { value: 'car', name: messages.DRIVING }, { value: 'other', name: messages.ANOTHER_METHOD }];
	
	      var choice = model.travel.get('transport_type');
	      var label = (0, _ofsI18n.interpolate)(messages.GET_TO_CITY, { city: config.city }, true);
	
	      return _reactAddons2['default'].createElement(
	        'div',
	        { className: 'transport-options' },
	        _reactAddons2['default'].createElement(
	          'div',
	          { className: 'ofs-EditorialGrid' },
	          _reactAddons2['default'].createElement(
	            'div',
	            { className: 'ofs-EditorialGrid__Column ofs-EditorialGrid__Column--big' },
	            _reactAddons2['default'].createElement(_ofsReactFieldsPhonenumberfield2['default'], { label: messages.ARRIVAL_MOBILE_NUMBER, name: 'arrival_phone', model: model, field: 'arrival_phone' }),
	            _reactAddons2['default'].createElement(_ofsReactFieldsSelectfield2['default'], { key: 'transport_type', model: model.travel, field: 'transport_type', name: 'transport_type', label: label, options: choices, defaultValue: choice }),
	            !choice || choice === 'plane' ? _reactAddons2['default'].createElement(FlightOptions, { model: model }) : null,
	            choice === 'train' ? _reactAddons2['default'].createElement(TrainOptions, { model: model }) : null,
	            choice === 'other' ? _reactAddons2['default'].createElement(OtherTransportOptions, { model: model }) : null,
	            !model.travel.shouldCalculateJourney() ? _reactAddons2['default'].createElement(ManualJourney, { model: model }) : null
	          )
	        ),
	        model.travel.shouldCalculateJourney() ? _reactAddons2['default'].createElement(CalculatedJourney, { model: model }) : null
	      );
	    }
	  });
	
	  var AppointmentWrapper = _reactAddons2['default'].createClass({
	    displayName: 'AppointmentWrapper',
	
	    getInitialState: function getInitialState() {
	      return {
	        loading: false
	      };
	    },
	
	    modelChanged: function modelChanged() {
	      if (_underscore2['default'].size(this.props.model.appointment.get('appointments')) > 0) {
	        this.setState({
	          loading: false
	        });
	      }
	    },
	
	    componentDidMount: function componentDidMount() {
	      this.props.model.on("change", _underscore2['default'].bind(this.modelChanged, this));
	    },
	
	    componentWillUnmount: function componentWillUnmount() {
	      this.props.model.off(null, null, this);
	    },
	
	    handleClick: function handleClick() {
	      var _this2 = this;
	
	      this.setState({ loading: true });
	
	      var eta = this.props.model.get('eta');
	      _jquery2['default'].post(config.appointments_endpoint, { eta: eta }, function (data) {
	        _this2.props.model.appointment.set('appointments', data.appointments);
	        _this2.setState({ loading: false });
	      });
	    },
	
	    render: function render() {
	      var model = this.props.model;
	
	      var disabled = model.canFindAppointments() && model.get('eta') ? null : 'disabled';
	      var appointments;
	
	      if (model.appointment.get('appointments')) {
	        appointments = _reactAddons2['default'].createElement(_viewsAppointments2['default'], { model: model, config: config });
	      } else {
	        appointments = _reactAddons2['default'].createElement(
	          'div',
	          { className: 'ofs-Prestay__PlaceholderBox' },
	          this.state.loading ? 'Loading' : _reactAddons2['default'].createElement(
	            'button',
	            { className: 'ofs-Button ofs-Button--small', disabled: disabled, onClick: this.handleClick },
	            messages.FIND_APPOINTMENTS
	          )
	        );
	      }
	
	      return _reactAddons2['default'].createElement(
	        _ofsAppsBookingsPrestayViewsPrestayContentSection2['default'],
	        { title: 'Your appointment' },
	        _reactAddons2['default'].createElement(
	          'p',
	          { className: 'ofs-Prestay__ContentIntro' },
	          messages.GREETERS_WILL_MEET
	        ),
	        _reactAddons2['default'].createElement(
	          'div',
	          { className: 'appointments' },
	          appointments
	        )
	      );
	    }
	  });
	
	  var Arrivals = _reactAddons2['default'].createClass({
	    displayName: 'Arrivals',
	
	    componentDidMount: function componentDidMount() {
	      this.props.model.on("change", this.forceUpdate.bind(this, null), this);
	      this.props.model.travel.on("change", this.forceUpdate.bind(this, null), this);
	      this.props.model.appointment.on("change", this.forceUpdate.bind(this, null), this);
	    },
	
	    componentWillUnmount: function componentWillUnmount() {
	      this.props.model.off(null, null, this);
	      this.props.model.travel.off(null, null, this);
	      this.props.model.appointment.off(null, null, this);
	    },
	
	    render: function render() {
	      var _props2 = this.props;
	      var model = _props2.model;
	      var contact = _props2.contact;
	
	      var appointment = model.appointment.get('selected_appointment');
	      var isValid = model.travel.isValid() && model.appointment.isValid();
	      var payload = model.travel.toJSON();
	
	      payload['eta'] = model.get('eta');
	      payload['arrival_phone'] = model.get('arrival_phone');
	
	      if (appointment) {
	        payload['appointment_type'] = appointment.type;
	        payload['appointment_time'] = appointment.time;
	
	        if (config.admin) {
	          payload['appointment_place_type'] = model.appointment.get('appointment_place_type');
	          if (model.appointment.get('appointment_place_type') === 'external') {
	            payload['external_location'] = model.appointment.get('external_location');
	            payload['external_address'] = model.appointment.get('external_address');
	            payload['external_map_link'] = model.appointment.get('external_map_link');
	          } else {
	            payload['external_location'] = null;
	            payload['external_address'] = null;
	            payload['external_map_link'] = null;
	          }
	          payload['price_override'] = model.appointment.get('price_override');
	        }
	      }
	      return _reactAddons2['default'].createElement(
	        'form',
	        { className: 'arrivals-form', method: 'post', action: '.' },
	        _reactAddons2['default'].createElement(
	          _ofsAppsBookingsPrestayViewsPrestayContentSection2['default'],
	          { title: messages.TRAVEL_ARRANGEMENTS },
	          _reactAddons2['default'].createElement('input', { type: 'hidden', name: 'payload', value: JSON.stringify(payload) }),
	          _reactAddons2['default'].createElement(TransportOptions, { model: model })
	        ),
	        model.canFindAppointments() || !model.travel.shouldCalculateJourney() ? _reactAddons2['default'].createElement(AppointmentWrapper, { model: model }) : null,
	        config.admin ? _reactAddons2['default'].createElement(
	          'button',
	          { className: 'ofs-Button admin-only button small', disabled: !isValid },
	          'Save and continue'
	        ) : _reactAddons2['default'].createElement(_viewsSaveButton2['default'], { models: [model.travel, model.appointment], email: contact.guestServicesEmail, phone: contact.guestServicesPhone })
	      );
	    }
	  });
	
	  return {
	    Arrivals: Arrivals
	  };
	};

/***/ },
/* 512 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _reactAddons = __webpack_require__(40);
	
	var _reactAddons2 = _interopRequireDefault(_reactAddons);
	
	var PrestayContentSection = _reactAddons2['default'].createClass({
	  displayName: 'PrestayContentSection',
	
	  mixins: [_reactAddons.PureRenderMixin],
	
	  render: function render() {
	    var _props = this.props;
	    var children = _props.children;
	    var title = _props.title;
	
	    return _reactAddons2['default'].createElement(
	      'div',
	      { className: 'ofs-ContentSection' },
	      _reactAddons2['default'].createElement(
	        'div',
	        { className: 'ofs-ContentSection__Wrapper ofs-ContentSection__Wrapper--narrow' },
	        _reactAddons2['default'].createElement(
	          'h2',
	          { className: 'ofs-ContentSection__Title' },
	          title
	        ),
	        _reactAddons2['default'].createElement(
	          'div',
	          { className: 'ofs-ContentSection__Content' },
	          children
	        )
	      )
	    );
	  }
	});
	
	exports['default'] = PrestayContentSection;
	module.exports = exports['default'];

/***/ },
/* 513 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _reactAddons = __webpack_require__(40);
	
	var _reactAddons2 = _interopRequireDefault(_reactAddons);
	
	var _ofsI18n = __webpack_require__(61);
	
	var _ofsReactFieldsTextfield = __webpack_require__(514);
	
	var _ofsReactFieldsTextfield2 = _interopRequireDefault(_ofsReactFieldsTextfield);
	
	var _ExternalAppointment = __webpack_require__(517);
	
	var _ExternalAppointment2 = _interopRequireDefault(_ExternalAppointment);
	
	var _AppointmentChoice = __webpack_require__(520);
	
	var _AppointmentChoice2 = _interopRequireDefault(_AppointmentChoice);
	
	var messages = {
	  APPOINTMENTS_AVAILABLE: (0, _ofsI18n.gettext)('Appointments available')
	};
	
	// appointment table
	var Appointments = _reactAddons2['default'].createClass({
	  displayName: 'Appointments',
	
	  render: function render() {
	    var model = this.props.model.appointment || this.props.model;
	    var config = this.props.config;
	
	    var appointmentOptions = model.get('appointments').map(function (appointment) {
	      return _reactAddons2['default'].createElement(_AppointmentChoice2['default'], { config: config,
	        key: [appointment.time, appointment.appointment_type.key].join(','),
	        model: model,
	        appointment: appointment });
	    });
	
	    return _reactAddons2['default'].createElement(
	      'div',
	      { className: 'appointment-options' },
	      _reactAddons2['default'].createElement(
	        'h5',
	        null,
	        messages.APPOINTMENTS_AVAILABLE
	      ),
	      _reactAddons2['default'].createElement(
	        'table',
	        { className: 'ofs-Appointments' },
	        appointmentOptions
	      ),
	      config.admin ? _reactAddons2['default'].createElement(_ExternalAppointment2['default'], { model: model }) : null,
	      config.admin ? _reactAddons2['default'].createElement(_ofsReactFieldsTextfield2['default'], { label: 'Override appointment price (admin)', name: 'price_override', model: model, field: 'price_override', adminOnly: true }) : null
	    );
	  }
	});
	
	exports['default'] = Appointments;
	module.exports = exports['default'];

/***/ },
/* 514 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var React = __webpack_require__(40);
	var mixins = __webpack_require__(515);
	var Field = __webpack_require__(516);
	
	module.exports = React.createClass({
	  displayName: 'exports',
	
	  mixins: [mixins.BackboneBindingMixin],
	
	  render: function render() {
	    return React.createElement(
	      Field,
	      { label: this.props.label, model: this.props.model, field: this.props.field, name: this.props.name, error: this.props.error, adminOnly: this.props.adminOnly },
	      React.createElement('input', { ref: 'input', type: 'text', valueLink: this.bindTo(this.props.model, this.props.field), id: this.props.name, onBlur: this.props.onBlur ? this.props.onBlur : null, placeholder: this.props.placeholder })
	    );
	  }
	});

/***/ },
/* 515 */
/***/ function(module, exports) {

	"use strict";
	
	var BackboneChangeMixin = {
	  componentDidMount: function componentDidMount() {
	    if (this.props.collection) {
	      this.props.collection.on("add remove change sort", this.forceUpdate.bind(this, null), this);
	    }
	    if (this.props.model) {
	      this.props.model.on("change", this.forceUpdate.bind(this, null), this);
	    }
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    if (this.props.collection) {
	      this.props.collection.off(null, null, this);
	    }
	    if (this.props.model) {
	      this.props.model.off(null, null, this);
	    }
	  }
	};
	
	var BackboneBindingMixin = {
	  bindTo: function bindTo(model, key) {
	    return {
	      value: model.get(key),
	      requestChange: (function (value) {
	        model.set(key, value);
	        var validateFunc = "validate_" + key;
	        if (!_.isUndefined(model[validateFunc])) {
	          model[validateFunc]();
	        }
	      }).bind(this)
	    };
	  }
	};
	
	module.exports = {
	  BackboneChangeMixin: BackboneChangeMixin,
	  BackboneBindingMixin: BackboneBindingMixin
	};

/***/ },
/* 516 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(40);
	var cx = __webpack_require__(49);
	
	module.exports = React.createClass({
	  displayName: 'exports',
	
	  render: function render() {
	    var field = this.props.field;
	    var model = this.props.model;
	    var adminOnly = this.props.adminOnly;
	    var placeholder = this.props.placeholder;
	    var error = this.props.error;
	
	    var classes = cx({
	      "field": true,
	      "ofs-Form__Field": true,
	      "error": error ? true : false,
	      "admin-only": adminOnly
	    });
	
	    return React.createElement(
	      'div',
	      { className: classes },
	      this.props.label ? React.createElement(
	        'label',
	        { className: 'ofs-Form__Label', htmlFor: this.props.name },
	        this.props.label
	      ) : null,
	      React.createElement(
	        'div',
	        { className: 'widget' },
	        this.props.children,
	        error ? React.createElement(
	          'p',
	          { className: 'ofs-Input__ErrorMessage' },
	          error
	        ) : null
	      )
	    );
	  }
	});

/***/ },
/* 517 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _reactAddons = __webpack_require__(40);
	
	var _reactAddons2 = _interopRequireDefault(_reactAddons);
	
	var _ofsI18n = __webpack_require__(61);
	
	var _ofsReactFieldsTextfield = __webpack_require__(514);
	
	var _ofsReactFieldsTextfield2 = _interopRequireDefault(_ofsReactFieldsTextfield);
	
	var _ofsReactFieldsSelectfield = __webpack_require__(518);
	
	var _ofsReactFieldsSelectfield2 = _interopRequireDefault(_ofsReactFieldsSelectfield);
	
	var messages = {
	  NAME_OF_PLACE: (0, _ofsI18n.gettext)('Name of place'),
	  ADDRESS_OF_PLACE: (0, _ofsI18n.gettext)('Address of place'),
	  GOOGLE_MAPS: (0, _ofsI18n.gettext)('Google Maps link'),
	  AT_THE_HOME: (0, _ofsI18n.gettext)('At the home'),
	  OTHER: (0, _ofsI18n.gettext)('Other')
	};
	
	var ExternalAppointment = _reactAddons2['default'].createClass({
	  displayName: 'ExternalAppointment',
	
	  render: function render() {
	    var model = this.props.model.appointment || this.props.model;
	
	    var placeTypeChoices = [{ value: 'home', name: messages.AT_THE_HOME }, { value: 'external', name: messages.OTHER }];
	
	    var isExternal = model.get('appointment_place_type') === 'external';
	
	    return _reactAddons2['default'].createElement(
	      'div',
	      { className: 'external-appointment admin-only' },
	      _reactAddons2['default'].createElement(_ofsReactFieldsSelectfield2['default'], { options: placeTypeChoices, label: 'Place of appointment (admin)', name: 'appointment_place_type', model: model, field: 'appointment_place_type' }),
	      isExternal ? _reactAddons2['default'].createElement(_ofsReactFieldsTextfield2['default'], { label: messages.NAME_OF_PLACE, name: 'external_location', model: model, field: 'external_location' }) : null,
	      isExternal ? _reactAddons2['default'].createElement(_ofsReactFieldsTextfield2['default'], { label: messages.ADDRESS_OF_PLACE, name: 'external_address', model: model, field: 'external_address' }) : null,
	      isExternal ? _reactAddons2['default'].createElement(_ofsReactFieldsTextfield2['default'], { label: messages.GOOGLE_MAPS, name: 'external_map_link', model: model, field: 'external_map_link' }) : null
	    );
	  }
	});
	
	exports['default'] = ExternalAppointment;
	module.exports = exports['default'];

/***/ },
/* 518 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	var _reactAddons = __webpack_require__(40);
	
	var _reactAddons2 = _interopRequireDefault(_reactAddons);
	
	var _ofsFormsInputsSimpleChoice = __webpack_require__(270);
	
	var _ofsFormsInputsSimpleChoice2 = _interopRequireDefault(_ofsFormsInputsSimpleChoice);
	
	var _ofsReactFieldsFieldcontainer = __webpack_require__(519);
	
	var _ofsReactFieldsFieldcontainer2 = _interopRequireDefault(_ofsReactFieldsFieldcontainer);
	
	module.exports = _reactAddons2['default'].createClass({
	  displayName: 'exports',
	
	  handleSelect: function handleSelect(event) {
	    var _props = this.props;
	    var field = _props.field;
	    var model = _props.model;
	
	    model.set(field, event.target.value);
	  },
	
	  render: function render() {
	    var _props2 = this.props;
	    var label = _props2.label;
	    var options = _props2.options;
	    var name = _props2.name;
	    var defaultValue = _props2.defaultValue;
	    var error = _props2.error;
	    var placeholder = _props2.placeholder;
	
	    return _reactAddons2['default'].createElement(
	      _ofsReactFieldsFieldcontainer2['default'],
	      { label: label },
	      _reactAddons2['default'].createElement(_ofsFormsInputsSimpleChoice2['default'], { allowEmpty: false,
	        onChange: this.handleSelect,
	        options: options,
	        name: name,
	        defaultValue: defaultValue,
	        placeholder: placeholder || '--' }),
	      error ? _reactAddons2['default'].createElement(
	        'p',
	        { className: 'ofs-Input__ErrorMessage' },
	        error
	      ) : null
	    );
	  }
	});

/***/ },
/* 519 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1)["default"];
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactAddons = __webpack_require__(40);
	
	var _reactAddons2 = _interopRequireDefault(_reactAddons);
	
	var FieldContainer = _reactAddons2["default"].createClass({
	  displayName: "FieldContainer",
	
	  propTypes: {
	    label: _reactAddons2["default"].PropTypes.string
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var label = _props.label;
	    var children = _props.children;
	
	    return _reactAddons2["default"].createElement(
	      "div",
	      { className: "ofs-Form__Field" },
	      label ? _reactAddons2["default"].createElement(
	        "label",
	        { className: "ofs-Form__Label" },
	        label
	      ) : null,
	      children
	    );
	  }
	});
	
	exports["default"] = FieldContainer;
	module.exports = exports["default"];

/***/ },
/* 520 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _reactAddons = __webpack_require__(40);
	
	var _reactAddons2 = _interopRequireDefault(_reactAddons);
	
	var _classnames = __webpack_require__(49);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _underscore = __webpack_require__(66);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _moment = __webpack_require__(58);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _ofsI18n = __webpack_require__(61);
	
	var _ofsComponentsCommonInfoTip = __webpack_require__(521);
	
	var _ofsComponentsCommonInfoTip2 = _interopRequireDefault(_ofsComponentsCommonInfoTip);
	
	var messages = {
	  FREE: (0, _ofsI18n.gettext)('Free')
	};
	
	var AppointmentChoice = _reactAddons2['default'].createClass({
	  displayName: 'AppointmentChoice',
	
	  contextTypes: {
	    flux: _reactAddons2['default'].PropTypes.object
	  },
	
	  handleSelect: function handleSelect() {
	    var model = this.props.model.appointment || this.props.model;
	    var appointment = this.props.appointment;
	
	    var value = {
	      time: appointment.appointment_time,
	      type: appointment.appointment_type.key
	    };
	
	    model.set({
	      selected_appointment: value
	    });
	  },
	
	  preventBubbling: function preventBubbling(event) {
	    event.stopPropagation();
	    return;
	  },
	
	  render: function render() {
	    var model = this.props.model.appointment || this.props.model;
	    var appointment = this.props.appointment;
	    var config = this.props.config;
	
	    var value = {
	      time: appointment.appointment_time,
	      type: appointment.appointment_type.key
	    };
	
	    var selected = _underscore2['default'].isEqual(value, model.get('selected_appointment'));
	    var rowClasses = (0, _classnames2['default'])({
	      'ofs-Appointments__Row': true,
	      'ofs-Appointments__Row--selected': selected
	    });
	
	    var price = undefined;
	    var selectedAndDescription = appointment.appointment_type.description && selected;
	    var notSelectedAndDescription = appointment.appointment_type.description && !selected;
	
	    if (appointment.amount !== '0.00') {
	      price = _reactAddons2['default'].createElement(
	        'div',
	        { className: 'ofs-Appointments__Price' },
	        _reactAddons2['default'].createElement(
	          'span',
	          { className: 'ofs-InfoTip__Label ofs-InfoTip__Label--left' },
	          _reactAddons2['default'].createElement('span', { className: 'currency', dangerouslySetInnerHTML: { __html: config.currency_symbol } }),
	          appointment.amount
	        ),
	        notSelectedAndDescription ? _reactAddons2['default'].createElement(
	          'span',
	          { onClick: this.preventBubbling },
	          _reactAddons2['default'].createElement(
	            _ofsComponentsCommonInfoTip2['default'],
	            { flux: this.context.flux, small: true },
	            appointment.appointment_type.description
	          )
	        ) : null
	      );
	    } else {
	      price = _reactAddons2['default'].createElement(
	        'div',
	        { className: 'ofs-Appointments__Price' },
	        _reactAddons2['default'].createElement(
	          'span',
	          { className: 'ofs-InfoTip__Label ofs-InfoTip__Label--left' },
	          messages.FREE
	        ),
	        notSelectedAndDescription ? _reactAddons2['default'].createElement(
	          'span',
	          { onClick: this.preventBubbling },
	          _reactAddons2['default'].createElement(
	            _ofsComponentsCommonInfoTip2['default'],
	            { flux: this.context.flux, small: true },
	            appointment.appointment_type.description
	          )
	        ) : null
	      );
	    }
	
	    return _reactAddons2['default'].createElement(
	      'tr',
	      { className: rowClasses, onClick: this.handleSelect },
	      _reactAddons2['default'].createElement(
	        'td',
	        { className: 'ofs-Appointments__Cell ofs-Appointments__Cell--time' },
	        _reactAddons2['default'].createElement('input', { className: 'u-hide', type: 'radio', checked: selected, name: 'selected_appointment', onChange: this.handleSelect }),
	        _reactAddons2['default'].createElement(
	          'span',
	          { className: 'ofs-TravelTime__Info' },
	          (0, _moment2['default'])(appointment.appointment_time, "YYYY-MM-DDTHH:mm").format('HH:mm')
	        )
	      ),
	      _reactAddons2['default'].createElement(
	        'td',
	        { className: 'ofs-Appointments__Cell ofs-Appointments__Cell--body' },
	        _reactAddons2['default'].createElement(
	          'span',
	          { className: 'u-text-bold' },
	          appointment.appointment_type.label
	        ),
	        selectedAndDescription ? _reactAddons2['default'].createElement(
	          'div',
	          { className: 'ofs-Appointments__Description' },
	          appointment.appointment_type.description
	        ) : null
	      ),
	      _reactAddons2['default'].createElement(
	        'td',
	        { className: 'ofs-Appointments__Cell ofs-Appointments__Cell--price' },
	        price
	      )
	    );
	  }
	});
	
	exports['default'] = AppointmentChoice;
	module.exports = exports['default'];

/***/ },
/* 521 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _reactAddons = __webpack_require__(40);
	
	var _reactAddons2 = _interopRequireDefault(_reactAddons);
	
	var _fluxxor = __webpack_require__(69);
	
	var _ofsComponentsCommonIcon = __webpack_require__(51);
	
	var _ofsComponentsCommonIcon2 = _interopRequireDefault(_ofsComponentsCommonIcon);
	
	var InfoTip = _reactAddons2['default'].createClass({
	  displayName: 'InfoTip',
	
	  mixins: [(0, _fluxxor.FluxMixin)(_reactAddons2['default'])],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      icon: 'question',
	      size: 'small'
	    };
	  },
	
	  handleSelect: function handleSelect(value, states) {
	    this.props.onChange(value, states);
	  },
	
	  handleClick: function handleClick(event) {
	    var trigger = this.getDOMNode();
	    event.preventDefault();
	    this.getFlux().actions.layers.addTooltip(_reactAddons2['default'].createElement(
	      'div',
	      {
	        trigger: trigger,
	        panelAttachment: 'top middle',
	        targetAttachment: 'bottom middle',
	        value: this.props.value },
	      this.props.children
	    ));
	  },
	
	  render: function render() {
	    var size = this.props.size;
	
	    return _reactAddons2['default'].createElement(
	      'div',
	      { className: 'ofs-InfoTip', onClick: this.handleClick },
	      _reactAddons2['default'].createElement(_ofsComponentsCommonIcon2['default'], { glyph: this.props.icon, size: size })
	    );
	  }
	});
	
	exports['default'] = InfoTip;
	module.exports = exports['default'];

/***/ },
/* 522 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	var _reactAddons = __webpack_require__(40);
	
	var _reactAddons2 = _interopRequireDefault(_reactAddons);
	
	var _classnames = __webpack_require__(49);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ofsReactMixins = __webpack_require__(515);
	
	var _ofsI18n = __webpack_require__(61);
	
	var _ofsFormsLayoutRow = __webpack_require__(226);
	
	var _ofsFormsLayoutRow2 = _interopRequireDefault(_ofsFormsLayoutRow);
	
	var _ofsFormsLayoutColumn = __webpack_require__(227);
	
	var _ofsFormsLayoutColumn2 = _interopRequireDefault(_ofsFormsLayoutColumn);
	
	var messages = {
	  HELP: (0, _ofsI18n.gettext)('Can we help? Call %(guest_services_phone)s or email <a href="mailto:%(guest_services_email)s">%(guest_services_email)s</a>'),
	  SAVE: (0, _ofsI18n.gettext)('Save and continue')
	};
	
	module.exports = _reactAddons2['default'].createClass({
	  displayName: 'exports',
	
	  mixins: [_ofsReactMixins.BackboneChangeMixin],
	
	  isValid: function isValid(models) {
	    return models.every(function (model) {
	      return model.isValid();
	    });
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var collection = _props.collection;
	    var model = _props.model;
	    var models = _props.models;
	    var email = _props.email;
	    var phone = _props.phone;
	
	    // two different components use this component. This was part of a quick refactor to keep similar components together.
	    var modelValid = model ? model.isValid() : this.isValid(models);
	    var collectionValid = collection ? this.isValid(collection) : true;
	
	    var allValid = collectionValid && modelValid;
	
	    var classes = (0, _classnames2['default'])({
	      'ofs-Button': true,
	      'ofs-Button--full-width': true,
	      'disabled': !allValid
	    });
	
	    return _reactAddons2['default'].createElement(
	      'div',
	      { className: 'ofs-Container' },
	      _reactAddons2['default'].createElement(
	        'div',
	        { className: 'ofs-Container__Content' },
	        _reactAddons2['default'].createElement(
	          'div',
	          { className: 'ofs-InfoPanel u-no-margin' },
	          _reactAddons2['default'].createElement('div', { className: 'ofs-Prestay__SaveButtonText', dangerouslySetInnerHTML: { __html: (0, _ofsI18n.interpolate)(messages.HELP, { guest_services_phone: phone, guest_services_email: email }, true) } }),
	          _reactAddons2['default'].createElement(
	            'div',
	            { className: 'ofs-Prestay__SaveButton' },
	            _reactAddons2['default'].createElement(
	              'button',
	              { type: 'submit', className: classes, disabled: !allValid },
	              messages.SAVE
	            )
	          )
	        )
	      )
	    );
	  }
	});

/***/ },
/* 523 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	var _ofsReactFieldsFieldcontainer = __webpack_require__(519);
	
	var _ofsReactFieldsFieldcontainer2 = _interopRequireDefault(_ofsReactFieldsFieldcontainer);
	
	var React = __webpack_require__(40);
	var mixins = __webpack_require__(515);
	
	module.exports = React.createClass({
	  displayName: 'exports',
	
	  mixins: [mixins.BackboneBindingMixin],
	
	  handleChange: function handleChange(event) {
	    this.props.model.set(this.props.field, event.target.value);
	  },
	
	  render: function render() {
	    var _this = this;
	
	    var _props = this.props;
	    var field = _props.field;
	    var model = _props.model;
	    var error = _props.error;
	    var label = _props.label;
	
	    var options = this.props.choices.map(function (choice) {
	      var checked = model.get(field) === choice[0];
	
	      return React.createElement(
	        'div',
	        { className: 'ofs-PreStayArrival__RadioOptions' },
	        React.createElement(
	          'label',
	          { className: 'ofs-Form__Label ofs-Form__Label--no-bold' },
	          React.createElement('input', { name: _this.props.name, className: 'ofs-Input--radio', type: 'radio', value: choice[0], checked: checked ? 'checked' : null, disabled: _this.props.disabled, onChange: _this.handleChange }),
	          React.createElement(
	            'div',
	            { className: 'ofs-Input__OptionLabel' },
	            choice[1]
	          )
	        )
	      );
	    });
	
	    return React.createElement(
	      _ofsReactFieldsFieldcontainer2['default'],
	      { label: label },
	      React.createElement(
	        'div',
	        null,
	        options
	      ),
	      error ? React.createElement(
	        'p',
	        { className: 'ofs-Input__ErrorMessage' },
	        error
	      ) : null
	    );
	  }
	});

/***/ },
/* 524 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(40);
	var cx = __webpack_require__(49);
	var RangePicker = __webpack_require__(202);
	var moment = __webpack_require__(57);
	var Fluxxor = __webpack_require__(69);
	
	var FluxMixin = Fluxxor.FluxMixin(React);
	
	var CalendarPopover = React.createClass({
	  displayName: 'CalendarPopover',
	
	  mixins: [FluxMixin],
	
	  getInitialState: function getInitialState() {
	    return {
	      value: this.props.value
	    };
	  },
	
	  handleSelect: function handleSelect(value) {
	    this.setState({ value: value });
	    this.props.handleSelect(value);
	    this.getFlux().actions.layers.remove();
	  },
	
	  render: function render(trigger) {
	    var value = this.state.value;
	    var yesterday = new Date();
	    yesterday.setDate(yesterday.getDate() - 1);
	
	    return React.createElement(
	      'div',
	      { className: 'datepicker' },
	      React.createElement(RangePicker, {
	        bemNamespace: 'ofs',
	        bemBlock: 'DatePicker',
	        selectionType: 'single',
	        value: value,
	        numberOfCalendars: 1,
	        firstOfWeek: 1,
	        onSelect: this.handleSelect,
	        earliestDate: yesterday })
	    );
	  }
	});
	
	var Datepicker = React.createClass({
	  displayName: 'Datepicker',
	
	  mixins: [FluxMixin],
	
	  getInitialState: function getInitialState() {
	    var value;
	
	    if (this.props.value) {
	      value = moment(this.props.value);
	    }
	    return {
	      value: value
	    };
	  },
	
	  showPicker: function showPicker(event) {
	    var trigger = $(this.getDOMNode()).find('.faux-input');
	    this.getFlux().actions.layers.addPopover(React.createElement(CalendarPopover, {
	      trigger: trigger,
	      handleSelect: this.handleSelect,
	      value: this.state.value }));
	  },
	
	  handleSelect: function handleSelect(value) {
	    this.setState({
	      value: value
	    });
	    if (this.props.handleSelect && typeof this.props.handleSelect === "function") {
	      this.props.handleSelect(value);
	    }
	  },
	
	  render: function render() {
	    var value = this.state.value;
	
	    var displayValue = null;
	    var formValue = null;
	
	    if (value) {
	      displayValue = moment(value).longDateFormat();
	      formValue = moment(value).isoDateFormat();
	    }
	
	    var inputClasses = cx({
	      'ofs-Input faux-input': true,
	      'focused': this.state.shown
	    });
	
	    return React.createElement(
	      'div',
	      { className: 'react-datepicker' },
	      React.createElement('input', { name: this.props.name, type: 'hidden', value: formValue }),
	      React.createElement(
	        'div',
	        { onClick: this.showPicker, className: inputClasses },
	        displayValue ? React.createElement(
	          'span',
	          { className: 'value' },
	          displayValue
	        ) : React.createElement(
	          'span',
	          { className: 'placeholder' },
	          'Select date'
	        )
	      )
	    );
	  }
	});
	
	module.exports = Datepicker;

/***/ },
/* 525 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	var _reactAddons = __webpack_require__(40);
	
	var _reactAddons2 = _interopRequireDefault(_reactAddons);
	
	var _classnames = __webpack_require__(49);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _pad = __webpack_require__(269);
	
	var _pad2 = _interopRequireDefault(_pad);
	
	var _underscore = __webpack_require__(66);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _ofsFormsInputsSimpleChoice = __webpack_require__(270);
	
	var _ofsFormsInputsSimpleChoice2 = _interopRequireDefault(_ofsFormsInputsSimpleChoice);
	
	var _ofsReactFieldsFieldcontainer = __webpack_require__(519);
	
	var _ofsReactFieldsFieldcontainer2 = _interopRequireDefault(_ofsReactFieldsFieldcontainer);
	
	module.exports = _reactAddons2['default'].createClass({
	  displayName: 'exports',
	
	  getInitialState: function getInitialState() {
	    /*
	     * Here we're using state to hold onto temporary
	     * values when one select change causes us to
	     * have a temporary unusable value for the time.
	     * eg 'HH:null:null' or 'null:MM:SS'
	     */
	    return {
	      tempMinute: null,
	      tempHour: null,
	      tempSecond: null
	    };
	  },
	
	  propTypes: {
	    useSeconds: _reactAddons2['default'].PropTypes.bool,
	    minuteStep: _reactAddons2['default'].PropTypes.number,
	    secondStep: _reactAddons2['default'].PropTypes.number
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      useSeconds: false,
	      minuteStep: 5,
	      secondStep: 5
	    };
	  },
	
	  stringValue: function stringValue(hour, minute, second) {
	    return (0, _pad2['default'])(2, hour, '0') + ':' + (0, _pad2['default'])(2, minute, '0') + ':' + (0, _pad2['default'])(2, second, '0');
	  },
	
	  handleHourChange: function handleHourChange(event) {
	    var value = event.target.value;
	    var _props = this.props;
	    var model = _props.model;
	    var field = _props.field;
	
	    var currentValue;
	    var newValue;
	
	    if (model && field) {
	      currentValue = model.get(field);
	    } else {
	      currentValue = this.props.value;
	    }
	
	    var minuteValue = currentValue ? currentValue.split(':')[1] : null;
	    var secondValue;
	
	    if (this.props.useSeconds) {
	      secondValue = currentValue ? currentValue.split(':')[2] : null;
	    } else {
	      secondValue = '00';
	    }
	
	    if ((this.state.tempMinute || minuteValue) && (this.state.tempSecond || secondValue)) {
	      newValue = this.stringValue(value, this.state.tempMinute || minuteValue, this.state.tempSecond || secondValue);
	      if (model && field) {
	        model.set(field, newValue);
	      } else if (this.props.onChange) {
	        this.props.onChange(newValue);
	      }
	      this.setState({
	        tempHour: null,
	        tempMinute: null,
	        tempSecond: null
	      });
	    } else {
	      this.setState({
	        tempHour: value
	      });
	    }
	  },
	
	  handleMinuteChange: function handleMinuteChange(event) {
	    var value = event.target.value;
	    var _props2 = this.props;
	    var model = _props2.model;
	    var field = _props2.field;
	
	    var currentValue;
	    var newValue;
	
	    if (model && field) {
	      currentValue = model.get(field);
	    } else {
	      currentValue = this.props.value;
	    }
	
	    var hourValue = currentValue ? currentValue.split(':')[0] : null;
	    var secondValue;
	
	    if (this.props.useSeconds) {
	      secondValue = currentValue ? currentValue.split(':')[2] : null;
	    } else {
	      secondValue = '00';
	    }
	    if ((this.state.tempHour || hourValue) && (this.state.tempSecond || secondValue)) {
	      newValue = this.stringValue(this.state.tempHour || hourValue, value, this.state.tempSecond || secondValue);
	
	      if (model && field) {
	        model.set(field, newValue);
	      } else if (this.props.onChange) {
	        this.props.onChange(newValue);
	      }
	      this.setState({
	        tempHour: null,
	        tempMinute: null,
	        tempSecond: null
	      });
	    } else {
	      this.setState({
	        tempMinute: value
	      });
	    }
	  },
	
	  handleSecondChange: function handleSecondChange(event) {
	    var value = event.target.value;
	    var _props3 = this.props;
	    var model = _props3.model;
	    var field = _props3.field;
	
	    var currentValue;
	    var newValue;
	
	    if (model && field) {
	      currentValue = model.get(field);
	    } else {
	      currentValue = this.props.value;
	    }
	
	    var hourValue = currentValue ? currentValue.split(':')[0] : null;
	    var minuteValue = currentValue ? currentValue.split(':')[1] : null;
	
	    if ((this.state.tempHour || hourValue) && (this.state.tempMinute || minuteValue)) {
	      newValue = this.stringValue(this.state.tempHour || hourValue, this.state.tempMinute || minuteValue, value);
	
	      if (model && field) {
	        model.set(field, newValue);
	      } else if (this.props.onChange) {
	        this.props.onChange(newValue);
	      }
	      this.setState({
	        tempHour: null,
	        tempMinute: null,
	        tempSecond: null
	      });
	    } else {
	      this.setState({
	        tempMinute: value
	      });
	    }
	  },
	
	  render: function render() {
	    var model = this.props.model;
	    var field = this.props.field;
	    var error;
	    var value;
	    var hourValue = null;
	    var minuteValue = null;
	    var secondValue = null;
	
	    var classes = (0, _classnames2['default'])({
	      'field': true
	    });
	
	    var hourChoices = _underscore2['default'].map(_underscore2['default'].range(0, 24), function (i) {
	      return { value: i, name: (0, _pad2['default'])(2, i, '0') };
	    });
	    var minuteChoices = _underscore2['default'].map(_underscore2['default'].range(0, 60, this.props.minuteStep), function (i) {
	      return { value: i, name: (0, _pad2['default'])(2, i, '0') };
	    });
	    var secondChoices = _underscore2['default'].map(_underscore2['default'].range(0, 60, this.props.secondStep), function (i) {
	      return { value: i, name: (0, _pad2['default'])(2, i, '0') };
	    });
	
	    if (model && field) {
	      value = model.get(field);
	    } else {
	      value = this.props.value;
	    }
	
	    var parts = value ? value.split(':') : null;
	
	    if (parts) {
	      hourValue = parseInt(parts[0], 10);
	      minuteValue = parseInt(parts[1], 10);
	      if (parts.length === 3) {
	        secondValue = parseInt(parts[2], 10);
	      } else {
	        secondValue = 0;
	      }
	    }
	
	    return _reactAddons2['default'].createElement(
	      'div',
	      { className: classes },
	      _reactAddons2['default'].createElement(
	        _ofsReactFieldsFieldcontainer2['default'],
	        { label: this.props.label },
	        _reactAddons2['default'].createElement(
	          'div',
	          { className: 'ofs-TimeSelect ofs-TimeSelect--inline' },
	          _reactAddons2['default'].createElement(_ofsFormsInputsSimpleChoice2['default'], { className: 'ofs-SimpleChoice--inline ofs-TimeSelect__Field', ref: 'hourField', allowEmpty: false, defaultValue: hourValue, options: hourChoices, onChange: this.handleHourChange, placeholder: '--' }),
	          _reactAddons2['default'].createElement(_ofsFormsInputsSimpleChoice2['default'], { className: 'ofs-SimpleChoice--inline ofs-TimeSelect__Field', ref: 'minuteField', allowEmpty: false, defaultValue: minuteValue, options: minuteChoices, onChange: this.handleMinuteChange, placeholder: '--' }),
	          this.props.useSeconds ? _reactAddons2['default'].createElement(_ofsFormsInputsSimpleChoice2['default'], { className: 'ofs-SimpleChoice--inline ofs-TimeSelect__Field', ref: 'secondField', allowEmpty: false, defaultValue: secondValue, options: secondChoices, onChange: this.handleSecondChange, placeholder: '--' }) : null
	        ),
	        error ? _reactAddons2['default'].createElement(
	          'p',
	          { className: 'warning' },
	          error
	        ) : null
	      )
	    );
	  }
	});

/***/ },
/* 526 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	var _ofsReactFieldsFieldcontainer = __webpack_require__(519);
	
	var _ofsReactFieldsFieldcontainer2 = _interopRequireDefault(_ofsReactFieldsFieldcontainer);
	
	var React = __webpack_require__(40);
	var mixins = __webpack_require__(515);
	var _ = __webpack_require__(66);
	
	module.exports = React.createClass({
	  displayName: 'exports',
	
	  bindTo: function bindTo(model, key) {
	    return {
	      value: model.get(key),
	      requestChange: (function (value) {
	        value = value.replace(/[^0-9\-\+\(\)\s]/, "");
	        model.set(key, value);
	        var validateFunc = "validate_" + key;
	        if (!_.isUndefined(model[validateFunc])) {
	          model[validateFunc]();
	        }
	      }).bind(this)
	    };
	  },
	
	  render: function render() {
	    return React.createElement(
	      _ofsReactFieldsFieldcontainer2['default'],
	      { label: this.props.label },
	      React.createElement('input', { ref: 'input', type: 'text', className: 'ofs-Input', valueLink: this.bindTo(this.props.model, this.props.field), id: this.props.name, onBlur: this.props.onBlur ? this.props.onBlur : null })
	    );
	  }
	});

/***/ },
/* 527 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	var _backbone = __webpack_require__(348);
	
	var _backbone2 = _interopRequireDefault(_backbone);
	
	var _underscore = __webpack_require__(66);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _moment = __webpack_require__(58);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _travelmodel = __webpack_require__(528);
	
	var _travelmodel2 = _interopRequireDefault(_travelmodel);
	
	var _appointmentmodel = __webpack_require__(529);
	
	var _appointmentmodel2 = _interopRequireDefault(_appointmentmodel);
	
	var PageModel = _backbone2['default'].Model.extend({
	  canFindAppointments: function canFindAppointments() {
	    if (this.travel.isValid()) {
	      if (!this.travel.shouldCalculateJourney()) {
	        if (this.get('eta')) return true;
	      } else {
	        if (this.get('journey')) return true;
	      }
	    }
	    return false;
	  },
	
	  travelChanged: function travelChanged(model, options) {
	    if (this.travel.shouldCalculateJourney()) {
	      this.unset('eta');
	      this.unset('journey');
	    }
	    this.appointment.clear();
	  },
	
	  etaChanged: function etaChanged(model, options) {
	    this.appointment.clear();
	  },
	
	  arrivalDateTimeChanged: function arrivalDateTimeChanged(model, options) {
	    var value = (0, _moment2['default'])([this.get('arrival_date'), this.get('arrival_time')].join('T')).format('YYYY-MM-DDTHH:mm');
	    this.set({ 'eta': value });
	  },
	
	  initialize: function initialize() {
	    this.travel = new _travelmodel2['default']();
	    this.appointment = new _appointmentmodel2['default']();
	    this.listenTo(this.travel, 'change', _underscore2['default'].bind(this.travelChanged, this));
	    this.listenTo(this, 'change:eta', _underscore2['default'].bind(this.etaChanged, this));
	    this.listenTo(this, 'change:arrival_time', _underscore2['default'].bind(this.arrivalDateTimeChanged, this));
	    this.listenTo(this, 'change:arrival_date', _underscore2['default'].bind(this.arrivalDateTimeChanged, this));
	  }
	});
	
	module.exports = PageModel;

/***/ },
/* 528 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var Backbone = __webpack_require__(348);
	
	var TravelModel = Backbone.Model.extend({
	  /*
	   * Holds the travel information, excluding eta.
	   */
	
	  defaults: {
	    transport_type: 'plane'
	  },
	
	  shouldCalculateJourney: function shouldCalculateJourney() {
	    /*
	     * Has the user selected transport options that allow
	     * us to query the platform to get an estimated
	     * arrival time?
	     */
	    var transport_type = this.get('transport_type');
	
	    if (transport_type) {
	      if (transport_type === 'plane') {
	        return true;
	      }
	      if (transport_type === 'train' && this.get('train_station') !== 'N/A') {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  canCalculateJourney: function canCalculateJourney() {
	    /*
	     * Similar to `shouldCalculateJourney`. The difference
	     * is that it tells us if we have enough data to
	     * actually query the platform for the journey plan.
	     */
	    var transport_type = this.get('transport_type');
	
	    if (transport_type && this.get('transfer_type')) {
	      if (transport_type === 'plane') {
	        if (this.get('flight_number')) return true;
	        if (this.get('airport') && this.get('flight_eta')) return true;
	      }
	      if (transport_type === 'train' && this.get('train_station') !== 'N/A' && this.get('train_eta')) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  hub: function hub() {
	    if (this.get("transport_type") == "plane") {
	      return this.get("airport");
	    } else if (this.get("transport_type") == "train") {
	      return this.get("train_station");
	    }
	  },
	
	  transferAmount: function transferAmount() {
	    return this.get("bookable_transfers")[this.hub()];
	  },
	
	  hasTransferAmount: function hasTransferAmount() {
	    var privateCar = this.get("transfer_type") === "private";
	
	    if (!privateCar) return false;
	
	    var transferAmount = this.transferAmount();
	
	    return !_.isUndefined(transferAmount);
	  },
	
	  canOrganiseTransfer: function canOrganiseTransfer() {
	    return this.hasTransferAmount() && this.get("num_guests") <= 4;
	  },
	
	  validate: function validate() {
	    var transport_type = this.get('transport_type');
	
	    if (transport_type) {
	      if (transport_type === 'plane') {
	        if (this.get('flight_number') && this.get('transfer_type')) return;
	        if (this.get('airport') && this.get('flight_eta') && this.get('transfer_type')) return;
	      } else if (transport_type === 'train') {
	        var transferType = this.get('transfer_type');
	        var station = this.get('train_station');
	
	        if (station) {
	          if (station !== 'N/A' && transferType) {
	            if (this.get('train_eta')) return;
	          }
	          if (this.get('other_station')) return;
	        }
	      } else if (transport_type === 'car') {
	        return;
	      } else if (transport_type === 'other') {
	        if (this.get('other_method')) return;
	      }
	    }
	    return 'invalid';
	  }
	});
	
	module.exports = TravelModel;

/***/ },
/* 529 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var Backbone = __webpack_require__(348);
	
	var AppointmentModel = Backbone.Model.extend({
	  /*
	   * Holds the appointment information, ie the
	   * array of appointment choices, and the value
	   * of the selected appointment
	   */
	  validate: function validate() {
	    if (this.get('selected_appointment')) return;
	    return 'invalid';
	  }
	});
	
	module.exports = AppointmentModel;

/***/ },
/* 530 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _reactAddons = __webpack_require__(40);
	
	var _reactAddons2 = _interopRequireDefault(_reactAddons);
	
	var _reactRespondTo = __webpack_require__(474);
	
	var _ofsUrls = __webpack_require__(531);
	
	var _DesktopBreadbar = __webpack_require__(532);
	
	var _DesktopBreadbar2 = _interopRequireDefault(_DesktopBreadbar);
	
	var _MobileBreadbar = __webpack_require__(533);
	
	var _MobileBreadbar2 = _interopRequireDefault(_MobileBreadbar);
	
	var _ofsI18n = __webpack_require__(61);
	
	var slugs = ['book-capture-details', 'book-capture-guests', 'book-capture-arrival', 'book-capture-departure', 'book-capture-stay-details'];
	
	var messages = {
	  'book-capture-details': (0, _ofsI18n.gettext)("Your details"),
	  'book-capture-guests': (0, _ofsI18n.gettext)("Additional guests"),
	  'book-capture-arrival': (0, _ofsI18n.gettext)("Arriving"),
	  'book-capture-departure': (0, _ofsI18n.gettext)("Departing"),
	  'book-capture-stay-details': (0, _ofsI18n.gettext)("Stay details")
	};
	
	var ResponsiveBreadbar = _reactAddons2['default'].createClass({
	  displayName: 'ResponsiveBreadbar',
	
	  render: function render() {
	    var _this = this;
	
	    var links = {};
	    slugs.forEach(function (slug) {
	      links[slug] = {
	        url: (0, _ofsUrls.reverse)(slug, { 'code': _this.props.bookingRef }),
	        title: messages[slug]
	      };
	    });
	
	    return _reactAddons2['default'].createElement(
	      'div',
	      null,
	      _reactAddons2['default'].createElement(
	        _reactRespondTo.Respond,
	        { to: 'min-width' },
	        _reactAddons2['default'].createElement(
	          _reactRespondTo.At,
	          { 'default': true },
	          _reactAddons2['default'].createElement(_MobileBreadbar2['default'], { links: links, currentPage: this.props.currentPage })
	        ),
	        _reactAddons2['default'].createElement(
	          _reactRespondTo.At,
	          { value: '641px' },
	          _reactAddons2['default'].createElement(_DesktopBreadbar2['default'], { links: links, currentPage: this.props.currentPage })
	        )
	      )
	    );
	  }
	});
	
	exports['default'] = ResponsiveBreadbar;
	module.exports = exports['default'];

/***/ },
/* 531 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.reverse = reverse;
	
	var _ofsUtilsGetPayload = __webpack_require__(356);
	
	var _ofsUtilsGetPayload2 = _interopRequireDefault(_ofsUtilsGetPayload);
	
	function reverse(name, values) {
	  var _getPayload = (0, _ofsUtilsGetPayload2['default'])();
	
	  var urls = _getPayload.urls;
	
	  if (typeof urls[name] === 'undefined') {
	    throw new Error('No url called ' + name);
	  }
	
	  var pattern = urls[name];
	  return pattern.replace(/%\((.*?)\)s/g, function (match, namedMatch) {
	    if (typeof values[namedMatch] === 'undefined') {
	      throw new Error('Url ' + name + ' requires kwarg ' + namedMatch);
	    }
	    return values[namedMatch];
	  });
	}

/***/ },
/* 532 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _Object$keys = __webpack_require__(171)['default'];
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _reactAddons = __webpack_require__(40);
	
	var _reactAddons2 = _interopRequireDefault(_reactAddons);
	
	var _classnames = __webpack_require__(49);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var DesktopBreadbar = _reactAddons2['default'].createClass({
	  displayName: 'DesktopBreadbar',
	
	  propTypes: {
	    currentPage: _reactAddons2['default'].PropTypes.string.isRequired,
	    links: _reactAddons2['default'].PropTypes.object.isRequired
	  },
	
	  /**
	  * EXAMPLE SHAPE FOR 'LINKS'
	  * links = {
	  *   'book-capture-details': {
	  *     url: '/book/B42FYW/pre-stay/details',
	  *     title: 'Your details',
	  *   },
	  * };
	  **/
	  renderLink: function renderLink(slug) {
	    var _props = this.props;
	    var currentPage = _props.currentPage;
	    var links = _props.links;
	
	    var linkClasses = (0, _classnames2['default'])({
	      "ofs-Prestay__BreadbarLink": true,
	      "ofs-Prestay__BreadbarLink--is-selected": currentPage === slug
	    });
	
	    return _reactAddons2['default'].createElement(
	      'li',
	      { key: slug, className: 'ofs-List__Item ofs-List__Item--horizontal-inline' },
	      _reactAddons2['default'].createElement(
	        'a',
	        { className: linkClasses, href: links[slug].url },
	        links[slug].title
	      )
	    );
	  },
	
	  render: function render() {
	    var _this = this;
	
	    var links = this.props.links;
	
	    var breadbarLinks = _Object$keys(links).map(function (slug) {
	      return _this.renderLink(slug);
	    });
	    return _reactAddons2['default'].createElement(
	      'ul',
	      { className: 'ofs-List' },
	      breadbarLinks
	    );
	  }
	});
	
	exports['default'] = DesktopBreadbar;
	module.exports = exports['default'];

/***/ },
/* 533 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _Object$keys = __webpack_require__(171)['default'];
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _reactAddons = __webpack_require__(40);
	
	var _reactAddons2 = _interopRequireDefault(_reactAddons);
	
	var _classnames = __webpack_require__(49);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ofsComponentsSimpleChoiceSimpleChoice = __webpack_require__(47);
	
	var _ofsComponentsSimpleChoiceSimpleChoice2 = _interopRequireDefault(_ofsComponentsSimpleChoiceSimpleChoice);
	
	var MobileBreadbar = _reactAddons2['default'].createClass({
	  displayName: 'MobileBreadbar',
	
	  propTypes: {
	    currentPage: _reactAddons2['default'].PropTypes.string.isRequired,
	    links: _reactAddons2['default'].PropTypes.object.isRequired
	  },
	
	  handleChange: function handleChange(event) {
	    var links = this.props.links;
	    var value = event.target.value;
	
	    window.location.assign(links[value].url);
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var links = _props.links;
	    var currentPage = _props.currentPage;
	
	    var options = _Object$keys(links).map(function (slug) {
	      return _reactAddons2['default'].createElement(
	        'div',
	        { value: slug, key: slug },
	        links[slug].title
	      );
	    });
	
	    return _reactAddons2['default'].createElement(
	      'div',
	      null,
	      _reactAddons2['default'].createElement(
	        'label',
	        { className: 'ofs-Form__Label' },
	        'Navigate to:'
	      ),
	      _reactAddons2['default'].createElement(
	        _ofsComponentsSimpleChoiceSimpleChoice2['default'],
	        { className: 'ofs-SimpleChoice', defaultValue: currentPage, onChange: this.handleChange },
	        options
	      )
	    );
	  }
	});
	
	exports['default'] = MobileBreadbar;
	module.exports = exports['default'];

/***/ },
/* 534 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(3)['default'];
	
	var _inherits = __webpack_require__(17)['default'];
	
	var _createClass = __webpack_require__(28)['default'];
	
	var _classCallCheck = __webpack_require__(31)['default'];
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	var _reactAddons = __webpack_require__(40);
	
	var _reactAddons2 = _interopRequireDefault(_reactAddons);
	
	var _ofsAppsCoreEntry = __webpack_require__(450);
	
	var _ofsAppsCoreEntry2 = _interopRequireDefault(_ofsAppsCoreEntry);
	
	var _models = __webpack_require__(535);
	
	var _models2 = _interopRequireDefault(_models);
	
	var _views = __webpack_require__(536);
	
	var _views2 = _interopRequireDefault(_views);
	
	var _viewsResponsiveBreadbar = __webpack_require__(530);
	
	var _viewsResponsiveBreadbar2 = _interopRequireDefault(_viewsResponsiveBreadbar);
	
	var DepartureEntryPoint = (function (_EntryPoint) {
	  _inherits(DepartureEntryPoint, _EntryPoint);
	
	  function DepartureEntryPoint() {
	    _classCallCheck(this, DepartureEntryPoint);
	
	    _get(Object.getPrototypeOf(DepartureEntryPoint.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(DepartureEntryPoint, [{
	    key: 'renderToDocument',
	    value: function renderToDocument(document) {
	      var options = this.options;
	
	      if (!options.standalone) {
	        _get(Object.getPrototypeOf(DepartureEntryPoint.prototype), 'renderToDocument', this).call(this, document);
	      }
	
	      var _options$prestay = options.prestay;
	      var formOptions = _options$prestay.formOptions;
	      var formData = _options$prestay.formData;
	      var bookingRef = _options$prestay.bookingRef;
	      var contact = _options$prestay.contact;
	
	      var model = new _models2['default'].AppointmentModel();
	      var views = (0, _views2['default'])(formOptions);
	
	      if (formData) {
	        if (formData['etd']) {
	          model.set('etd', formData['etd']);
	        }
	
	        if (formData['appointment_type'] && formData['appointment_time']) {
	          model.set('selected_appointment', {
	            type: formData['appointment_type'],
	            time: formData['appointment_time']
	          });
	        } else {
	          model.set('selected_appointment', {
	            type: formOptions['default_appointment']['type'],
	            time: formOptions['default_appointment']['time']
	          });
	        }
	
	        model.set('appointments', formOptions['suggested_appointments']);
	      }
	      var Departure = views.Departure;
	      _reactAddons2['default'].withContext({ flux: this.flux }, function () {
	        _reactAddons2['default'].render(_reactAddons2['default'].createElement(Departure, { model: model, contact: contact }), document.getElementById('departure-form'));
	      });
	
	      var breadbar = document.getElementById('breadbar');
	      if (breadbar) {
	        _reactAddons2['default'].render(_reactAddons2['default'].createElement(_viewsResponsiveBreadbar2['default'], { bookingRef: bookingRef, currentPage: 'book-capture-departure' }), breadbar);
	      }
	    }
	  }]);
	
	  return DepartureEntryPoint;
	})(_ofsAppsCoreEntry2['default']);
	
	module.exports = DepartureEntryPoint;

/***/ },
/* 535 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var Backbone = __webpack_require__(348);
	
	var AppointmentModel = Backbone.Model.extend({
	  /*
	   * Holds the appointment information, ie the
	   * array of appointment choices, and the value
	   * of the selected appointment
	   */
	  validate: function validate() {
	    if (this.get('selected_appointment')) return;
	    return 'invalid';
	  },
	
	  etdChanged: function etdChanged(model, options) {
	    this.unset('appointments');
	    this.unset('selected_appointment');
	  },
	
	  initialize: function initialize() {
	    this.on('change:etd', this.etdChanged);
	  }
	});
	
	module.exports = {
	  AppointmentModel: AppointmentModel
	};

/***/ },
/* 536 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	var _reactAddons = __webpack_require__(40);
	
	var _reactAddons2 = _interopRequireDefault(_reactAddons);
	
	var _underscore = __webpack_require__(66);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _ofsI18n = __webpack_require__(61);
	
	var _jquery = __webpack_require__(39);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _ofsMoment = __webpack_require__(57);
	
	var _ofsMoment2 = _interopRequireDefault(_ofsMoment);
	
	var _ofsAppsBookingsPrestayViewsPrestayContentSection = __webpack_require__(512);
	
	var _ofsAppsBookingsPrestayViewsPrestayContentSection2 = _interopRequireDefault(_ofsAppsBookingsPrestayViewsPrestayContentSection);
	
	var _ofsReactFieldsTimefield = __webpack_require__(525);
	
	var _ofsReactFieldsTimefield2 = _interopRequireDefault(_ofsReactFieldsTimefield);
	
	var _ofsFormsLayoutRow = __webpack_require__(226);
	
	var _ofsFormsLayoutRow2 = _interopRequireDefault(_ofsFormsLayoutRow);
	
	var _ofsFormsLayoutColumn = __webpack_require__(227);
	
	var _ofsFormsLayoutColumn2 = _interopRequireDefault(_ofsFormsLayoutColumn);
	
	var _ofsAppsBookingsPrestayViewsAppointments = __webpack_require__(513);
	
	var _ofsAppsBookingsPrestayViewsAppointments2 = _interopRequireDefault(_ofsAppsBookingsPrestayViewsAppointments);
	
	var _viewsSaveButton = __webpack_require__(522);
	
	var _viewsSaveButton2 = _interopRequireDefault(_viewsSaveButton);
	
	var messages = {
	  SAVE_CONTINUE: (0, _ofsI18n.gettext)("Save and continue"),
	  DEPARTURE: (0, _ofsI18n.gettext)("Departure"),
	  STANDARD_DEPARTURE: (0, _ofsI18n.gettext)("Standard departure is any time before"),
	  LEAVE_LATER: (0, _ofsI18n.gettext)("Want to leave later?"),
	  CLICK_HERE: (0, _ofsI18n.gettext)("Click here"),
	  WHAT_TIME_LEAVE: (0, _ofsI18n.gettext)("What time would you want to leave?"),
	  FIND_AVAILABLE: (0, _ofsI18n.gettext)("Find available appointments")
	};
	
	module.exports = function (config) {
	
	  var AppointmentWrapper = _reactAddons2['default'].createClass({
	    displayName: 'AppointmentWrapper',
	
	    getInitialState: function getInitialState() {
	      return {
	        loading: false
	      };
	    },
	
	    modelChanged: function modelChanged() {
	      if (_underscore2['default'].size(this.props.model.get('appointments')) > 0) {
	        this.setState({ loading: false });
	      }
	    },
	
	    componentDidMount: function componentDidMount() {
	      this.props.model.on("change", _underscore2['default'].bind(this.modelChanged, this));
	    },
	
	    componentWillUnmount: function componentWillUnmount() {
	      this.props.model.off(null, null, this);
	    },
	
	    handleClick: function handleClick() {
	      var _this = this;
	
	      this.setState({ loading: true });
	      _jquery2['default'].post(config.appointments_endpoint, { etd: this.props.model.get('etd') }, function (data) {
	        _this.props.model.set('appointments', data.appointments);
	        _this.setState({ loading: false });
	      });
	    },
	
	    render: function render() {
	      var model = this.props.model;
	
	      var disabled = model.get('etd') ? false : true;
	
	      return _reactAddons2['default'].createElement(
	        'div',
	        { className: 'appointments' },
	        _reactAddons2['default'].createElement(
	          _ofsFormsLayoutRow2['default'],
	          null,
	          _reactAddons2['default'].createElement(
	            _ofsFormsLayoutColumn2['default'],
	            { size: 'half' },
	            _reactAddons2['default'].createElement(
	              'p',
	              null,
	              messages.WHAT_TIME_LEAVE
	            )
	          ),
	          _reactAddons2['default'].createElement(
	            _ofsFormsLayoutColumn2['default'],
	            { size: 'half' },
	            _reactAddons2['default'].createElement(_ofsReactFieldsTimefield2['default'], { name: 'etd', model: model, field: 'etd' })
	          )
	        ),
	        model.get('appointments') ? _reactAddons2['default'].createElement(_ofsAppsBookingsPrestayViewsAppointments2['default'], { config: config, model: model }) : _reactAddons2['default'].createElement(
	          'div',
	          { className: 'ofs-Prestay__PlaceholderBox' },
	          this.state.loading ? 'Loading' : _reactAddons2['default'].createElement(
	            'button',
	            { className: 'ofs-Button ofs-Button--small', disabled: disabled, onClick: this.handleClick },
	            messages.FIND_AVAILABLE
	          )
	        )
	      );
	    }
	  });
	
	  var DefaultDeparture = _reactAddons2['default'].createClass({
	    displayName: 'DefaultDeparture',
	
	    render: function render() {
	      return _reactAddons2['default'].createElement(
	        'div',
	        { className: 'ofs-Prestay__ContentIntro' },
	        _reactAddons2['default'].createElement(
	          'p',
	          null,
	          messages.STANDARD_DEPARTURE,
	          ' ',
	          _reactAddons2['default'].createElement(
	            'strong',
	            null,
	            (0, _ofsMoment2['default'])(config.default_appointment.time, "YYYY-MM-DDTHH:mm").format('h:mm')
	          )
	        ),
	        _reactAddons2['default'].createElement(
	          'p',
	          null,
	          messages.LEAVE_LATER,
	          ' ',
	          _reactAddons2['default'].createElement(
	            'a',
	            { onClick: this.props.handleClick },
	            messages.CLICK_HERE
	          )
	        )
	      );
	    }
	  });
	
	  var CustomDeparture = _reactAddons2['default'].createClass({
	    displayName: 'CustomDeparture',
	
	    render: function render() {
	      return _reactAddons2['default'].createElement(
	        'div',
	        { className: 'custom-appointment' },
	        _reactAddons2['default'].createElement(AppointmentWrapper, { model: this.props.model })
	      );
	    }
	  });
	
	  var Departure = _reactAddons2['default'].createClass({
	    displayName: 'Departure',
	
	    getInitialState: function getInitialState() {
	      return {
	        custom: this.props.model.get('etd') ? true : false
	      };
	    },
	
	    componentDidMount: function componentDidMount() {
	      this.props.model.on("change", this.forceUpdate.bind(this, null), this);
	    },
	
	    componentWillUnmount: function componentWillUnmount() {
	      this.props.model.off(null, null, this);
	    },
	
	    switchToCustom: function switchToCustom() {
	      this.props.model.unset('selected_appointment');
	      this.setState({ custom: true });
	    },
	
	    render: function render() {
	      var _props = this.props;
	      var model = _props.model;
	      var contact = _props.contact;
	
	      var isValid = model.isValid();
	
	      var payload = model.toJSON();
	
	      delete payload.appointments;
	      delete payload.selected_appointment;
	
	      var appointment = model.get('selected_appointment');
	
	      if (appointment) {
	        payload['appointment_type'] = appointment.type;
	        payload['appointment_time'] = appointment.time;
	
	        if (config.admin) {
	          payload['price_override'] = model.get('price_override');
	        }
	      }
	
	      return _reactAddons2['default'].createElement(
	        'form',
	        { className: 'departure-form', method: 'post', action: '.' },
	        _reactAddons2['default'].createElement(
	          _ofsAppsBookingsPrestayViewsPrestayContentSection2['default'],
	          { title: messages.DEPARTURE },
	          _reactAddons2['default'].createElement('input', { type: 'hidden', name: 'payload', value: JSON.stringify(payload) }),
	          this.state.custom ? _reactAddons2['default'].createElement(CustomDeparture, { model: model }) : _reactAddons2['default'].createElement(DefaultDeparture, { handleClick: this.switchToCustom })
	        ),
	        config.admin ? _reactAddons2['default'].createElement(
	          'button',
	          { className: 'ofs-Button admin-only button small', disabled: !isValid },
	          messages.SAVE_CONTINUE
	        ) : _reactAddons2['default'].createElement(_viewsSaveButton2['default'], { model: model, email: contact.guestServicesEmail, phone: contact.guestServicesPhone })
	      );
	    }
	  });
	
	  return {
	    Departure: Departure
	  };
	};

/***/ },
/* 537 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(3)['default'];
	
	var _inherits = __webpack_require__(17)['default'];
	
	var _createClass = __webpack_require__(28)['default'];
	
	var _classCallCheck = __webpack_require__(31)['default'];
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	var _reactAddons = __webpack_require__(40);
	
	var _reactAddons2 = _interopRequireDefault(_reactAddons);
	
	var _jquery = __webpack_require__(39);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _ofsAppsCoreEntry = __webpack_require__(450);
	
	var _ofsAppsCoreEntry2 = _interopRequireDefault(_ofsAppsCoreEntry);
	
	var _modelsGuestList = __webpack_require__(538);
	
	var _modelsGuestList2 = _interopRequireDefault(_modelsGuestList);
	
	var _modelsBedConfiguration = __webpack_require__(540);
	
	var _modelsBedConfiguration2 = _interopRequireDefault(_modelsBedConfiguration);
	
	var _ofsAppsBookingsPrestayViewsSaveButton = __webpack_require__(522);
	
	var _ofsAppsBookingsPrestayViewsSaveButton2 = _interopRequireDefault(_ofsAppsBookingsPrestayViewsSaveButton);
	
	var _ofsGoogleMapsMarkers = __webpack_require__(544);
	
	var _ofsGoogleMapsMarkers2 = _interopRequireDefault(_ofsGoogleMapsMarkers);
	
	var _viewsRequestChangeForm = __webpack_require__(545);
	
	var _viewsRequestChangeForm2 = _interopRequireDefault(_viewsRequestChangeForm);
	
	var _viewsResponsiveBreadbar = __webpack_require__(530);
	
	var _viewsResponsiveBreadbar2 = _interopRequireDefault(_viewsResponsiveBreadbar);
	
	var GuestsEntryPoint = (function (_EntryPoint) {
	  _inherits(GuestsEntryPoint, _EntryPoint);
	
	  function GuestsEntryPoint() {
	    _classCallCheck(this, GuestsEntryPoint);
	
	    _get(Object.getPrototypeOf(GuestsEntryPoint.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(GuestsEntryPoint, [{
	    key: 'renderToDocument',
	    value: function renderToDocument(document) {
	      var _this = this;
	
	      if (!standalone) {
	        _get(Object.getPrototypeOf(GuestsEntryPoint.prototype), 'renderToDocument', this).call(this, document);
	      }
	
	      var _options = this.options;
	      var prestay = _options.prestay;
	      var standalone = _options.standalone;
	      var unit = _options.unit;
	      var form = _options.form;
	      var config = prestay.config;
	      var bookingRef = prestay.bookingRef;
	
	      var BedConfigurationView = undefined,
	          bedConfigurationModel = undefined;
	      var AdditionalGuestsView = undefined,
	          additionalGuestsModel = undefined;
	
	      var $bedConfigForm = (0, _jquery2['default'])('.bed-configuration-form').get(0);
	      var $saveButton = (0, _jquery2['default'])('.save-button').get(0);
	
	      if (config.bedConfigOnly && config.haveBedsBeenConfigured) {
	        BedConfigurationView = __webpack_require__(546)(config);
	        bedConfigurationModel = new _modelsBedConfiguration2['default']();
	
	        if (prestay.bedBillables) {
	          bedConfigurationModel.set('bed_billables', config.bedBillables);
	        }
	
	        if (config.bedConfiguration && config.bedConfiguration.bedDescriptions) {
	          bedConfigurationModel.set('bed_descriptions', config.bedConfiguration.bedDescriptions);
	        }
	
	        bedConfigurationModel.setTotalGuestsCount(config.totalGuests);
	        bedConfigurationModel.parse(prestay.bedConfiguration, true);
	
	        if ($bedConfigForm) {
	          _reactAddons2['default'].withContext({ flux: this.flux }, function () {
	            _reactAddons2['default'].render(_reactAddons2['default'].createElement(BedConfigurationView, { model: bedConfigurationModel, active: true }), $bedConfigForm);
	          });
	        }
	      }
	
	      if (!config.bedConfigOnly) {
	        // TODO
	        AdditionalGuestsView = __webpack_require__(564)(config.additionalGuests);
	        additionalGuestsModel = new _modelsGuestList2['default'](prestay.additionalGuests);
	
	        _reactAddons2['default'].render(_reactAddons2['default'].createElement(AdditionalGuestsView, { collection: additionalGuestsModel }), (0, _jquery2['default'])('.additional-guests-form').get(0));
	
	        BedConfigurationView = __webpack_require__(546)(config.bedConfiguration);
	        bedConfigurationModel = new _modelsBedConfiguration2['default']();
	
	        bedConfigurationModel.setAdditionalGuestsModel(additionalGuestsModel);
	        bedConfigurationModel.set('bed_descriptions', config.bedConfiguration.bedDescriptions);
	        bedConfigurationModel.set('bed_billables', config.bedConfiguration.bedBillables);
	
	        bedConfigurationModel.setInitalData(prestay.bedConfiguration);
	        bedConfigurationModel.parse(prestay.bedConfiguration, true);
	
	        if ($bedConfigForm) {
	          _reactAddons2['default'].withContext({ flux: this.flux }, function () {
	            _reactAddons2['default'].render(_reactAddons2['default'].createElement(BedConfigurationView, { model: bedConfigurationModel, active: bedConfigurationModel.hasSelection() }), $bedConfigForm);
	          });
	        }
	
	        if ($saveButton) _reactAddons2['default'].render(_reactAddons2['default'].createElement(_ofsAppsBookingsPrestayViewsSaveButton2['default'], { model: bedConfigurationModel, collection: additionalGuestsModel, email: config.additionalGuests.guestServicesEmail, phone: config.additionalGuests.guestServicesPhone }), $saveButton);
	      }
	
	      // for the Request Change popup when booking is confirmed
	      (0, _jquery2['default'])('#request-change').on('click', function (event) {
	        event.preventDefault();
	        _this.flux.actions.layers.addModal(_reactAddons2['default'].createElement(_viewsRequestChangeForm2['default'], { formData: form }));
	      });
	
	      // expand accordions
	      (0, _jquery2['default'])('.ofs-BookingCard__Wrapper--accordion').on('click', function (event) {
	        var $panel = (0, _jquery2['default'])(event.target).parent();
	        $panel.find('.ofs-BookingCard__Content--collapsed').slideToggle();
	        $panel.find('.ofs-Icon--arrow').toggleClass('ofs-Icon--arrow-right', 'ofs-Icon--arrow-down');
	      });
	
	      // embed google maps to home when booking is confirmed
	      if (document.getElementById('map-block')) {
	        var position = new google.maps.LatLng(unit.latitude, unit.longitude);
	        var map = new google.maps.Map(document.getElementById('map-block'), {
	          center: position,
	          zoom: 15
	        });
	        new google.maps.Marker({
	          position: position,
	          map: map,
	          icon: _ofsGoogleMapsMarkers2['default'].home,
	          optimized: false
	        });
	      }
	
	      var breadbar = document.getElementById('breadbar');
	      if (breadbar) {
	        _reactAddons2['default'].render(_reactAddons2['default'].createElement(_viewsResponsiveBreadbar2['default'], { bookingRef: bookingRef, currentPage: 'book-capture-guests' }), breadbar);
	      }
	    }
	  }]);
	
	  return GuestsEntryPoint;
	})(_ofsAppsCoreEntry2['default']);
	
	module.exports = GuestsEntryPoint;

/***/ },
/* 538 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	var _backbone = __webpack_require__(348);
	
	var _backbone2 = _interopRequireDefault(_backbone);
	
	var _underscore = __webpack_require__(66);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _guest = __webpack_require__(539);
	
	var _guest2 = _interopRequireDefault(_guest);
	
	var GuestList = _backbone2['default'].Collection.extend({
	  model: _guest2['default'],
	
	  validate: function validate() {
	    return _underscore2['default'].every(this.models, function (model) {
	      return !model.validate();
	    });
	  }
	});
	
	module.exports = GuestList;

/***/ },
/* 539 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var Backbone = __webpack_require__(348);
	var _ = __webpack_require__(66);
	
	var i18n = __webpack_require__(61);
	var gettext = i18n.gettext;
	
	var messages = {
	  valueRequired: gettext("This field is required")
	};
	
	var Guest = Backbone.Model.extend({
	  validate: function validate(attributes, options) {
	    var errors = {};
	    var self = this;
	
	    ["first_name", "last_name", "life_stage"].forEach(function (attrName) {
	      var attr = self.get(attrName);
	      var valid = _.isString(attr) && !_.isEmpty(attr);
	
	      if (!valid) {
	        errors[attrName] = messages.valueRequired;
	      }
	    });
	
	    if (!_.isEmpty(errors)) {
	      return errors;
	    }
	  }
	});
	
	module.exports = Guest;

/***/ },
/* 540 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var Backbone = __webpack_require__(348);
	var _ = __webpack_require__(66);
	var Room = __webpack_require__(541);
	var Bed = __webpack_require__(542);
	
	var BedConfiguration = Backbone.Model.extend({
	  parse: function parse(data, restoreSelections) {
	    // create sub room and bed elements.
	    // Make sure they all have a reference to the bedConfig to pass events upstream
	    var self = this;
	    var rooms = _(data.rooms).map(function (roomData) {
	      var beds = _(roomData.beds).chain().sortBy('label').map(function (bedData) {
	        var bed = new Bed(bedData);
	        bed.set('bedConfiguration', self);
	
	        return bed;
	      }).value();
	
	      var room = new Room(_.defaults({ beds: beds }, roomData));
	      room.set('bedConfiguration', self);
	
	      // beds must also know in which room they are in
	      room.get('beds').forEach(function (bed) {
	        bed.set('room', room);
	      });
	
	      // restore previously generated state
	      if (restoreSelections && !_.isEmpty(roomData.selected)) {
	        var selected = roomData.selected;
	        var CRIB = 0,
	            SINGLE_AIRBED = 1,
	            DOUBLE_AIRBED = 2;
	
	        // restore crib
	        if (selected['num_cribs'] > 0) {
	          room.addExtra(CRIB);
	        }
	
	        // restore airbeds
	        selected.airbeds.forEach(function (airBed) {
	          if (airBed.size === "SINGLE") {
	            room.addExtra(SINGLE_AIRBED);
	          } else {
	            // DOUBLE
	            room.addExtra(DOUBLE_AIRBED, airBed['num_guests']);
	          }
	        });
	
	        // restore beds selections
	        _(selected.beds).keys().forEach(function (id) {
	          var selectedBed = selected.beds[id];
	          var bedModel = _(beds).find(function (bed) {
	            return bed.get('id') === id;
	          });
	
	          bedModel.set('state', selectedBed.state);
	          bedModel.set('selected', selectedBed['num_guests']);
	        });
	      }
	
	      return room;
	    });
	
	    this.set('rooms', rooms, { silent: true });
	  },
	  isValid: function isValid() {
	    return this.getSelectedCount() === this.getTotalGuestsCount();
	  },
	  setInitalData: function setInitalData(initalData) {
	    this.set('initalData', JSON.stringify(initalData), { silent: true });
	  },
	  reset: function reset() {
	    var initalData = JSON.parse(this.get('initalData'));
	
	    this.parse(initalData, false);
	    this.trigger("reset");
	  },
	  hasSelection: function hasSelection() {
	    return this.getSelection().length > 0;
	  },
	  getSelection: function getSelection() {
	    var rooms = this.get('rooms');
	
	    rooms = rooms.map(function (room) {
	      var id = room.get('id');
	      var wasCribAdded = room.wasCribAdded();
	
	      var airBeds = room.getAirbeds().map(function (airBed) {
	        return {
	          'size': airBed.get('size'),
	          'num_guests': airBed.getSelectedCount()
	        };
	      });
	
	      var normalBeds = room.getNormalBeds().map(function (bed) {
	        var selected = bed.getSelectedCount();
	        var id = bed.get('id');
	        var state = bed.getState();
	
	        if (selected === 0) {
	          return null; // this bed is unoccupied
	        }
	
	        var result = {
	          'id': id,
	          'num_guests': selected
	        };
	
	        if (state) {
	          result.state = state;
	        }
	
	        return result;
	      }).filter(Boolean); // filter out unoccupied beds
	
	      if (normalBeds.length === 0 && airBeds.length === 0 && wasCribAdded === false) {
	        return null; // this room is unoccupied
	      }
	
	      var result = {
	        'room_id': id,
	        'num_cribs': wasCribAdded ? 1 : 0
	      };
	
	      if (airBeds.length > 0) {
	        result.airbeds = airBeds;
	      }
	      if (normalBeds.length > 0) {
	        result.beds = normalBeds;
	      }
	
	      return result;
	    }).filter(Boolean); // filter out unoccupied rooms
	
	    return rooms;
	  },
	  getSelectedCount: function getSelectedCount() {
	    var sum = 0;
	
	    this.get('rooms').forEach(function (room) {
	      room.get('beds').forEach(function (bed) {
	        sum += bed.getSelectedCount();
	      });
	    });
	
	    return sum;
	  },
	  getSleepsLeft: function getSleepsLeft() {
	    return this.getTotalGuestsCount() - this.getSelectedCount();
	  },
	  getTotalGuestsCount: function getTotalGuestsCount() {
	    var additionalGuestsModel = this.get('additionalGuestsModel');
	    var totalGuestsCount = this.get('totalGuestsCount');
	
	    if (additionalGuestsModel) {
	      return additionalGuestsModel.length + 1;
	    } else {
	      return totalGuestsCount;
	    }
	  },
	  setAdditionalGuestsModel: function setAdditionalGuestsModel(additionalGuestsModel) {
	    this.set('additionalGuestsModel', additionalGuestsModel);
	    this.listenTo(additionalGuestsModel, "add remove change", this.reset.bind(this));
	  },
	  isAdditonalGuestsModelValid: function isAdditonalGuestsModelValid() {
	    return this.get('additionalGuestsModel').every(function (model) {
	      return model.isValid();
	    });
	  },
	  setTotalGuestsCount: function setTotalGuestsCount(count) {
	    this.set('totalGuestsCount', count);
	  },
	  _sortFloorElements: function _sortFloorElements(floors) {
	    var self = this;
	    var floorArray = _(floors).keys().sort().map(function (key) {
	      var rooms = floors[key];
	      rooms = _(rooms).sortBy(function (room) {
	        return room.get('label');
	      });
	
	      var label = self._getLabelForFloorNumber(key);
	
	      return {
	        rooms: rooms,
	        label: label
	      };
	    });
	
	    return floorArray;
	  },
	  _getLabelForFloorNumber: function _getLabelForFloorNumber(floorNumber) {
	    if (floorNumber === "unkown") {
	      return null;
	    } else {
	      return "Floor " + floorNumber;
	    }
	  },
	  _groupRoomsByFloor: function _groupRoomsByFloor(rooms) {
	    var floors = {};
	
	    rooms.forEach(function (room) {
	      var numericFloor = room.get('numeric_floor');
	      var index;
	      if (numericFloor === null || numericFloor === undefined) {
	        index = "unkown";
	      } else {
	        index = numericFloor;
	      }
	
	      floors[index] = floors[index] || [];
	      floors[index].push(room);
	    });
	
	    return floors;
	  },
	
	  getFloors: function getFloors() {
	    var rooms = this.get('rooms');
	    var floors = this._groupRoomsByFloor(rooms);
	    floors = this._sortFloorElements(floors);
	
	    return floors;
	  },
	
	  sumBillables: function sumBillables() {
	    var rooms = this.get('rooms');
	    var sum = 0;
	
	    _(rooms).each(function (room) {
	      _(room.get('beds')).each(function (bed) {
	        var price = bed.get('price');
	
	        if (price) {
	          sum += price;
	        }
	      });
	    });
	
	    return sum;
	  }
	});
	
	module.exports = BedConfiguration;

/***/ },
/* 541 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var Backbone = __webpack_require__(348);
	var _ = __webpack_require__(66);
	var Bed = __webpack_require__(542);
	
	var CRIB = 0,
	    SINGLE_AIRBED = 1,
	    DOUBLE_AIRBED = 2;
	
	var Room = Backbone.Model.extend({
	  _isBedroom: function _isBedroom() {
	    var beds = this.get('beds');
	
	    // if there is any permanent bed in the room, we consider it a bedroom
	    return _(beds).any(function (bed) {
	      return bed.get('category') === "permanent";
	    });
	  },
	
	  _getAirbedSpacesLeft: function _getAirbedSpacesLeft() {
	    var beds = this.get('beds');
	    var count = 0;
	
	    _(beds).each(function (bed) {
	      if (bed.get('extra_id') === SINGLE_AIRBED || bed.get('extra_id') === DOUBLE_AIRBED) {
	        count += bed.getSelectedCount();
	      }
	    });
	
	    return this.get('airbed_sleeps') - count;
	  },
	
	  _getSleepsLeft: function _getSleepsLeft() {
	    return this.get('bedConfiguration').getSleepsLeft();
	  },
	
	  wasCribAdded: function wasCribAdded() {
	    var beds = this.get('beds');
	    return _(beds).any(function (bed) {
	      return bed.get('extra_id') === CRIB;
	    });
	  },
	
	  getAirbeds: function getAirbeds() {
	    var beds = this.get('beds');
	    return beds.filter(function (bed) {
	      return bed.get('bed_type') === 'AirBed';
	    });
	  },
	
	  getNormalBeds: function getNormalBeds() {
	    var beds = this.get('beds');
	    return beds.filter(function (bed) {
	      return bed.get('bed_type') !== 'AirBed' && bed.get('bed_type') !== 'Crib';
	    });
	  },
	
	  _isCribAvailable: function _isCribAvailable() {
	    if (this.wasCribAdded()) {
	      return false;
	    }
	
	    if (this._getSleepsLeft() < 1) {
	      return false;
	    }
	
	    return true;
	  },
	
	  _isAirbedAvailable: function _isAirbedAvailable(spacesNeeded) {
	    return this._getAirbedSpacesLeft() >= spacesNeeded && this._getSleepsLeft() >= 1;
	  },
	
	  _getPriceFor: function _getPriceFor(extra_id) {
	    var bedBillables = this.get('bedConfiguration').get('bed_billables');
	
	    if (!bedBillables) {
	      return null;
	    }
	
	    switch (extra_id) {
	      case CRIB:
	        return bedBillables['crib'];
	      case SINGLE_AIRBED:
	        return bedBillables['airbed (single)'];
	      case DOUBLE_AIRBED:
	        return bedBillables['airbed (double)'];
	    }
	  },
	
	  addExtra: function addExtra(extra_id, selected) {
	    var newBed;
	
	    switch (extra_id) {
	      case CRIB:
	        newBed = {
	          bed_type: "Crib",
	          category: "temporary",
	          label: "Crib",
	          size: "CHILD",
	          sleeps: 1,
	          selected: 1,
	          extra_id: CRIB,
	          isExtra: true
	        };
	        break;
	      case SINGLE_AIRBED:
	        newBed = {
	          bed_type: "AirBed",
	          category: "temporary",
	          label: "Single airbed",
	          size: "SINGLE",
	          sleeps: 1,
	          selected: 1,
	          extra_id: SINGLE_AIRBED,
	          isExtra: true
	        };
	        break;
	      case DOUBLE_AIRBED:
	        newBed = {
	          bed_type: "AirBed",
	          category: "temporary",
	          label: "Double airbed",
	          size: "DOUBLE",
	          sleeps: 2,
	          // if a selected value is given, use it (only ever happens when server data is parsed back)
	          selected: selected || (this._getSleepsLeft() > 1 ? 2 : 1),
	          extra_id: DOUBLE_AIRBED,
	          isExtra: true
	        };
	    }
	
	    newBed.bedConfiguration = this.get('bedConfiguration');
	    newBed.price = this._getPriceFor(extra_id);
	    newBed.room = this;
	
	    this.get('beds').push(new Bed(newBed));
	
	    this.get('bedConfiguration').trigger('change');
	  },
	
	  getAvailableExtras: function getAvailableExtras() {
	    var extras = [];
	    var isBedroom = this._isBedroom();
	    var airbedSleeps = this.get('airbed_sleeps');
	
	    if (isBedroom) {
	      extras.push({
	        name: "crib",
	        price: this._getPriceFor(CRIB),
	        extra_id: CRIB,
	        active: this._isCribAvailable()
	      });
	    }
	
	    if (airbedSleeps >= 1) {
	      extras.push({
	        name: "single airbed",
	        price: this._getPriceFor(SINGLE_AIRBED),
	        extra_id: SINGLE_AIRBED,
	        active: this._isAirbedAvailable(1)
	      });
	    }
	
	    if (airbedSleeps >= 2) {
	      extras.push({
	        name: "double airbed",
	        price: this._getPriceFor(DOUBLE_AIRBED),
	        extra_id: DOUBLE_AIRBED,
	        active: this._isAirbedAvailable(2)
	      });
	    }
	
	    return extras;
	  }
	});
	
	module.exports = Room;

/***/ },
/* 542 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var Backbone = __webpack_require__(348);
	var _ = __webpack_require__(66);
	
	var constants = __webpack_require__(543);
	
	var Bed = Backbone.Model.extend({
	  getSleeps: function getSleeps() {
	    if (this.isExtended()) {
	      return 2;
	    }
	    if (this.isRetracted()) {
	      return 1;
	    }
	
	    return this.get('sleeps');
	  },
	
	  getSelectedCount: function getSelectedCount() {
	    return this.get('selected') || 0;
	  },
	
	  getMaxSelectedCount: function getMaxSelectedCount() {
	    var left = this.get('bedConfiguration').getSleepsLeft();
	    var selected = this.getSelectedCount();
	    var max = selected + left;
	
	    return max;
	  },
	
	  isExtra: function isExtra() {
	    return !!this.get('isExtra');
	  },
	
	  remove: function remove() {
	    var beds = this.get('room').get('beds');
	
	    var pos = beds.indexOf(this);
	    beds = beds.splice(pos, 1);
	
	    this._triggerBedConfigChange();
	  },
	
	  setSelectedCount: function setSelectedCount(count) {
	    this.set('selected', count);
	
	    this._triggerBedConfigChange();
	  },
	
	  _triggerBedConfigChange: function _triggerBedConfigChange() {
	    this.get('bedConfiguration').trigger("change");
	  },
	
	  getDescription: function getDescription() {
	    var descriptions = this.get('bedConfiguration').get('bed_descriptions');
	    var bedType = this.get('bed_type');
	    var description = _(descriptions).find(function (description) {
	      return description.type_id === bedType;
	    });
	
	    description = description ? description.description : null;
	
	    return description;
	  },
	
	  getBedIconClass: function getBedIconClass() {
	    return constants.BED_TYPE_ICON_CLASSES[this.get('bed_type')];
	  },
	
	  _isCategoryExtendable: function _isCategoryExtendable() {
	    return this.get("category") === "extendable";
	  },
	
	  _isCategoryJoinable: function _isCategoryJoinable() {
	    return this.get("category") === "joinable";
	  },
	
	  getState: function getState() {
	    if (this.get('state')) {
	      return this.get('state');
	    }
	
	    if (this._isCategoryExtendable()) {
	      return "retracted";
	    }
	    if (this._isCategoryJoinable()) {
	      return "joined";
	    }
	
	    return null;
	  },
	
	  isExtendable: function isExtendable() {
	    return this.getState() === "retracted";
	  },
	
	  isCurrentlyExtendable: function isCurrentlyExtendable() {
	    return this.isExtendable();
	  },
	
	  isExtended: function isExtended() {
	    return this.getState() === "extended";
	  },
	
	  extend: function extend() {
	    this.set("state", "extended");
	    this._triggerBedConfigChange();
	  },
	
	  isRetractable: function isRetractable() {
	    return this.getState() === "extended";
	  },
	
	  isCurrentlyRetractable: function isCurrentlyRetractable() {
	    return this.isRetractable();
	  },
	
	  isRetracted: function isRetracted() {
	    return this.getState() === "retracted";
	  },
	
	  retract: function retract() {
	    this.set("state", "retracted");
	
	    if (this.getSelectedCount() > 1) {
	      this.set('selected', 1);
	    }
	
	    this._triggerBedConfigChange();
	  },
	
	  isJoinable: function isJoinable() {
	    return this.getState() === "separated";
	  },
	
	  isCurrentlyJoinable: function isCurrentlyJoinable() {
	    return this.isJoinable() && this.getMaxSelectedCount() >= 2;
	  },
	
	  isJoined: function isJoined() {
	    return this.getState() === "joined";
	  },
	
	  join: function join() {
	    this.set("state", "joined");
	    this.set('selected', 2);
	    this._triggerBedConfigChange();
	  },
	
	  isSeparable: function isSeparable() {
	    return this.getState() === "joined";
	  },
	
	  isCurrentlySeparable: function isCurrentlySeparable() {
	    return this.isSeparable && this.getMaxSelectedCount() >= 2;
	  },
	
	  isSeparated: function isSeparated() {
	    return this.getState() === "separated";
	  },
	
	  separate: function separate() {
	    this.set("state", "separated");
	    this.set('selected', 2);
	    this._triggerBedConfigChange();
	  }
	});
	
	module.exports = Bed;

/***/ },
/* 543 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
	  BED_TYPE_ICON_CLASSES: {
	    AirBed: 'icon-bed-size-airbed',
	    Crib: 'icon-bed-size-crib',
	    DayBed: 'icon-bed-size-daybed',
	    ExtendableBed: 'icon-bed-size-pullout',
	    Futon: 'icon-bed-size-futon',
	    LowerBunkBed: 'icon-bed-size-bunk',
	    MurphyBed: 'icon-bed-size-murphy',
	    SofaBed: 'icon-bed-size-sofabed',
	    Trundle: 'icon-bed-size-trundle',
	    UpperBunkBed: 'icon-bed-size-bunk'
	  }
	};

/***/ },
/* 544 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var markers = {};
	
	var scaleFactor = 0.5;
	var spriteWidth = 412;
	var spriteHeight = 226;
	
	var normalOffset = 0;
	var activeOffset = 150;
	
	var offsets = {
	  'teacoffee-shops': 0,
	  'places-to-drink': 54,
	  'places-to-eat': 108,
	  'things-to-do': 162,
	  'for-kids': 216,
	  'shops-and-delis': 270
	};
	
	for (var key in offsets) {
	  var offset = offsets[key];
	  markers[key] = {};
	  markers[key].normal = new google.maps.MarkerImage(ofs['static']("images/maps/markers.png"), new google.maps.Size(54 * scaleFactor, 74 * scaleFactor), // desired size
	  new google.maps.Point(offset * scaleFactor, normalOffset * scaleFactor), // offset within the scaled sprite
	  null, new google.maps.Size(spriteWidth * scaleFactor, spriteHeight * scaleFactor) // scaled size of the entire sprite
	  );
	
	  markers[key].active = new google.maps.MarkerImage(ofs['static']("images/maps/markers.png"), new google.maps.Size(54 * scaleFactor, 74 * scaleFactor), // desired size
	  new google.maps.Point(offset * scaleFactor, activeOffset * scaleFactor), // offset within the scaled sprite
	  null, new google.maps.Size(spriteWidth * scaleFactor, spriteHeight * scaleFactor) // scaled size of the entire sprite
	  );
	}
	
	markers.home = new google.maps.MarkerImage(ofs['static']("images/maps/markers.png"), new google.maps.Size(52 * scaleFactor, 74 * scaleFactor), // desired size
	new google.maps.Point(360 * scaleFactor, 0 * scaleFactor), // offset within the scaled sprite
	null, new google.maps.Size(spriteWidth * scaleFactor, spriteHeight * scaleFactor) // scaled size of the entire sprite
	);
	
	markers.shadow = new google.maps.MarkerImage(ofs['static']("images/maps/markers.png"), new google.maps.Size(50 * scaleFactor, 20 * scaleFactor), // desired size
	new google.maps.Point(361 * scaleFactor, 80 * scaleFactor), // offset within the scaled sprite
	new google.maps.Point(25 * scaleFactor, 10 * scaleFactor), new google.maps.Size(spriteWidth * scaleFactor, spriteHeight * scaleFactor) // scaled size of the entire sprite
	);
	
	exports['default'] = markers;
	module.exports = exports['default'];

/***/ },
/* 545 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _reactAddons = __webpack_require__(40);
	
	var _reactAddons2 = _interopRequireDefault(_reactAddons);
	
	var _classnames = __webpack_require__(49);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ofsFormsInputsSimpleChoice = __webpack_require__(270);
	
	var _ofsFormsInputsSimpleChoice2 = _interopRequireDefault(_ofsFormsInputsSimpleChoice);
	
	var _ofsI18n = __webpack_require__(61);
	
	var _http = __webpack_require__(275);
	
	var _http2 = _interopRequireDefault(_http);
	
	_http2['default'].post = __webpack_require__(307);
	
	var messages = {
	  HEADING: (0, _ofsI18n.gettext)('Request a change'),
	  CATEGORY_LABEL: (0, _ofsI18n.gettext)('I\'d like to change:'),
	  DETAILS_LABEL: (0, _ofsI18n.gettext)('Please let us know which details need to be updated:'),
	  DETAILS_PLACEHOLDER: (0, _ofsI18n.gettext)('Enter your request here'),
	  SUBMITTING: (0, _ofsI18n.gettext)('Submitting...'),
	  SUCCESS_HEADING: (0, _ofsI18n.gettext)('Thank you for your enquiry'),
	  SUCCESS_MESSAGE: (0, _ofsI18n.gettext)('We\'ll get back to you soon.'),
	  SUBMIT: (0, _ofsI18n.gettext)('Submit'),
	  ERROR_HEADING: (0, _ofsI18n.gettext)('Something went wrong'),
	  ERROR_DEFAULT_MESSAGE: (0, _ofsI18n.gettext)('There was a problem with your request. Call us on %(guest_services_phone)s to speak with our Front Desk.'),
	  REQUIRED: (0, _ofsI18n.gettext)('This field is required')
	};
	
	var RequestChangeForm = _reactAddons2['default'].createClass({
	  displayName: 'RequestChangeForm',
	
	  getInitialState: function getInitialState() {
	    return {
	      status: 'default',
	      isValid: true
	    };
	  },
	
	  isValid: function isValid(data) {
	    if (data['change_reasons'].length) {
	      return true;
	    } else {
	      this.setState({ isValid: false });
	      return false;
	    }
	  },
	
	  onSubmit: function onSubmit(event) {
	    var _this = this;
	
	    event.preventDefault();
	    var reasons = this.refs.changeReasons.getDOMNode();
	
	    // category is the input node in SelectOne with
	    // the name 'change_category'
	    var category = Array.prototype.slice.call(this.refs.changeCategory.getDOMNode().children).find(function (child) {
	      return child.name === 'change_category';
	    });
	
	    var data = {
	      'change_reasons': reasons.value,
	      'change_category': category.value || 'other'
	    };
	
	    if (this.isValid(data)) {
	      _http2['default'].post(this.props.formData.url, data, function (response) {
	        if (response.statusCode !== 200) {
	          _this.setState({
	            status: 'error',
	            error: null
	          });
	        } else {
	          _this.setState({ status: 'success' });
	        }
	      }).on('error', function () {
	        _this.setState({
	          status: 'error'
	        });
	      });
	      this.setState({ status: 'submitting' });
	    }
	  },
	
	  render: function render() {
	    var validationClasses = (0, _classnames2['default'])({
	      'ofs-Input__ErrorMessage': true,
	      'u-hide': this.state.isValid
	    });
	    var errorMessage = (0, _ofsI18n.interpolate)(messages.ERROR_DEFAULT_MESSAGE, {
	      guest_services_phone: this.props.formData.guestServicesPhone
	    }, true);
	
	    var status = this.state.status;
	    var changeFormFields = this.props.formData.changeFormFields;
	
	    changeFormFields = changeFormFields.map(function (field) {
	      return { value: field[0], name: field[1] };
	    });
	
	    return _reactAddons2['default'].createElement(
	      'section',
	      { className: 'ofs-EnquiryForm' },
	      _reactAddons2['default'].createElement(
	        'h2',
	        { className: 'ofs-EnquiryForm__Title' },
	        messages.HEADING
	      ),
	      status === 'default' && _reactAddons2['default'].createElement(
	        'form',
	        { className: 'ofs-Form -form--condensed', onSubmit: this.onSubmit },
	        _reactAddons2['default'].createElement(
	          'div',
	          { className: 'ofs-Form__Field' },
	          _reactAddons2['default'].createElement(
	            'label',
	            { className: 'ofs-Form__Label' },
	            messages.CATEGORY_LABEL
	          ),
	          _reactAddons2['default'].createElement(_ofsFormsInputsSimpleChoice2['default'], { options: changeFormFields, name: 'change_category', ref: 'changeCategory' })
	        ),
	        _reactAddons2['default'].createElement(
	          'div',
	          { className: 'ofs-Form__Field' },
	          _reactAddons2['default'].createElement(
	            'label',
	            { className: 'ofs-Form__Label' },
	            messages.DETAILS_LABEL
	          ),
	          _reactAddons2['default'].createElement('textarea', { className: 'ofs-Input ofs-Input--textarea', defaultValue: messages.PLACEHOLDER, ref: 'changeReasons' }),
	          _reactAddons2['default'].createElement(
	            'label',
	            { className: validationClasses },
	            messages.REQUIRED
	          )
	        ),
	        _reactAddons2['default'].createElement(
	          'div',
	          { className: 'ofs-Form__Field' },
	          _reactAddons2['default'].createElement(
	            'button',
	            { className: 'ofs-Button' },
	            messages.SUBMIT
	          )
	        )
	      ),
	      status === 'submitting' && _reactAddons2['default'].createElement(
	        'div',
	        { className: 'ofs-EnquiryForm__Message' },
	        _reactAddons2['default'].createElement(
	          'h3',
	          null,
	          messages.SUBMITTING
	        )
	      ),
	      status === 'success' && _reactAddons2['default'].createElement(
	        'div',
	        { className: 'ofs-EnquiryForm__Message' },
	        _reactAddons2['default'].createElement(
	          'h3',
	          null,
	          messages.SUCCESS_HEADING
	        ),
	        _reactAddons2['default'].createElement(
	          'p',
	          null,
	          messages.SUCCESS_MESSAGE
	        )
	      ),
	      status === 'error' && _reactAddons2['default'].createElement(
	        'div',
	        { className: 'ofs-EnquiryForm__Message' },
	        _reactAddons2['default'].createElement(
	          'h3',
	          null,
	          messages.ERROR_HEADING
	        ),
	        _reactAddons2['default'].createElement(
	          'p',
	          null,
	          errorMessage
	        )
	      )
	    );
	  }
	});
	
	exports['default'] = RequestChangeForm;
	module.exports = exports['default'];

/***/ },
/* 546 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	var _reactAddons = __webpack_require__(40);
	
	var _reactAddons2 = _interopRequireDefault(_reactAddons);
	
	var _classnames = __webpack_require__(49);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _underscore = __webpack_require__(66);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _ofsI18n = __webpack_require__(61);
	
	var _ofsComponentsCommonInfoTip = __webpack_require__(521);
	
	var _ofsComponentsCommonInfoTip2 = _interopRequireDefault(_ofsComponentsCommonInfoTip);
	
	var _ofsUtilsBedSizeChartJsx = __webpack_require__(547);
	
	var _ofsUtilsBedSizeChartJsx2 = _interopRequireDefault(_ofsUtilsBedSizeChartJsx);
	
	var _ofsAppsBookingsPrestayViewsPrestayContentSection = __webpack_require__(512);
	
	var _ofsAppsBookingsPrestayViewsPrestayContentSection2 = _interopRequireDefault(_ofsAppsBookingsPrestayViewsPrestayContentSection);
	
	var _ofsFormsLayoutRow = __webpack_require__(226);
	
	var _ofsFormsLayoutRow2 = _interopRequireDefault(_ofsFormsLayoutRow);
	
	var _ofsFormsLayoutColumn = __webpack_require__(227);
	
	var _ofsFormsLayoutColumn2 = _interopRequireDefault(_ofsFormsLayoutColumn);
	
	var messages = {
	  SHOW_CHART: (0, _ofsI18n.gettext)('Show bed size chart'),
	  CHART_TITLE: (0, _ofsI18n.gettext)('Bed size naming chart'),
	  ADD_GUEST_PROMPT: (0, _ofsI18n.gettext)('So we can prepare the home, please let us know which beds should be set up by selecting the number of people in each bed. Missing someone? Please return to the ‘Additional guests’ form above and provide their details – you can then assign any further beds.'),
	  BED_CONFIGURATION_INACTIVE_PROMPT: (0, _ofsI18n.gettext)('Fill in the information of each additional guest above in order to proceed'),
	  BED_CONFIGURATION_BUTTON: (0, _ofsI18n.gettext)('Choose beds to be made'),
	  NONE: (0, _ofsI18n.gettext)('None'),
	  AVAILABLE_EXTRAS: (0, _ofsI18n.gettext)('Available extras'),
	  ADD_EXTRA: (0, _ofsI18n.gettext)('Add a %(extra)s'),
	  BILLABLES: (0, _ofsI18n.gettext)('Your chosen extras totalling <strong>%(currency)s%(sum)s</strong> will be added to your bill.')
	};
	
	module.exports = function (config) {
	  var BedConfiguration = _reactAddons2['default'].createClass({
	    displayName: 'BedConfiguration',
	
	    contextTypes: {
	      flux: _reactAddons2['default'].PropTypes.object
	    },
	
	    getInitialState: function getInitialState() {
	      return {
	        isActive: this.props.active || false
	      };
	    },
	
	    onReset: function onReset() {
	      this.setState({
	        isActive: false
	      });
	    },
	
	    showBedSizeChart: function showBedSizeChart() {
	      this.context.flux.actions.layers.addModal(_reactAddons2['default'].createElement(BedSizeChartModal, null));
	    },
	
	    renderReadOnly: function renderReadOnly() {
	      var floors = (0, _underscore2['default'])(this.props.model.getFloors()).map(function (floor) {
	        return _reactAddons2['default'].createElement(Floor, { model: floor });
	      });
	
	      return _reactAddons2['default'].createElement(
	        'div',
	        { className: 'bed-configuration' },
	        config.readOnlyWithStatus ? this.renderStatus() : null,
	        _reactAddons2['default'].createElement(
	          'div',
	          { className: 'active' },
	          floors
	        )
	      );
	    },
	
	    renderStatus: function renderStatus() {
	      var total = this.props.model.getTotalGuestsCount();
	      var selected = this.props.model.getSelectedCount();
	
	      return _reactAddons2['default'].createElement(
	        'div',
	        { className: 'ofs-BedConfiguration__StatusBar' },
	        _reactAddons2['default'].createElement(
	          _ofsFormsLayoutRow2['default'],
	          null,
	          _reactAddons2['default'].createElement(
	            _ofsFormsLayoutColumn2['default'],
	            { size: 'two-thirds' },
	            _reactAddons2['default'].createElement(
	              'div',
	              { className: 'ofs-BedConfiguration__StatusBarItem u-text-bold' },
	              'Guests assigned: ',
	              selected,
	              '/',
	              total
	            ),
	            _reactAddons2['default'].createElement(
	              'div',
	              { className: 'ofs-BedConfiguration__SleepsSelector' },
	              _reactAddons2['default'].createElement(SleepsSelector, { total: total, selected: selected, readOnly: true })
	            )
	          ),
	          _reactAddons2['default'].createElement(
	            _ofsFormsLayoutColumn2['default'],
	            { size: 'third' },
	            _reactAddons2['default'].createElement(
	              'div',
	              { className: 'ofs-BedConfiguration__StatusBarItem ofs-BedConfiguration__StatusBarItem--right u-no-margin' },
	              _reactAddons2['default'].createElement(
	                'a',
	                { onClick: this.showBedSizeChart },
	                messages.SHOW_CHART
	              )
	            )
	          )
	        )
	      );
	    },
	
	    renderActive: function renderActive() {
	      var floors = (0, _underscore2['default'])(this.props.model.getFloors()).map(function (floor) {
	        return _reactAddons2['default'].createElement(Floor, { model: floor });
	      });
	
	      var sum = this.props.model.sumBillables();
	      var selection = JSON.stringify(this.props.model.getSelection());
	
	      return _reactAddons2['default'].createElement(
	        _ofsAppsBookingsPrestayViewsPrestayContentSection2['default'],
	        { title: 'Sleeping arrangements' },
	        _reactAddons2['default'].createElement(
	          'p',
	          { className: 'ofs-Prestay__ContentIntro' },
	          messages.ADD_GUEST_PROMPT
	        ),
	        this.renderStatus(),
	        _reactAddons2['default'].createElement(
	          'div',
	          { className: 'active multi-stage-container' },
	          floors,
	          sum > 0 ? _reactAddons2['default'].createElement(BillablesSummary, { sum: sum }) : null
	        ),
	        _reactAddons2['default'].createElement('input', { type: 'hidden', name: 'bed_configuration', value: selection })
	      );
	    },
	
	    onActivateClick: function onActivateClick(event) {
	      event.preventDefault();
	      this.setState({
	        isActive: true
	      });
	    },
	
	    renderInactive: function renderInactive() {
	      var isDisabled = !this.props.model.isAdditonalGuestsModelValid();
	
	      var buttonClasses = (0, _classnames2['default'])({
	        'ofs-Button': true,
	        'disabled': isDisabled
	      });
	
	      return _reactAddons2['default'].createElement(
	        _ofsAppsBookingsPrestayViewsPrestayContentSection2['default'],
	        { title: 'Sleeping arrangements' },
	        _reactAddons2['default'].createElement(
	          'div',
	          { className: 'ofs-Prestay__PlaceholderBox' },
	          isDisabled ? _reactAddons2['default'].createElement(
	            'p',
	            null,
	            messages.BED_CONFIGURATION_INACTIVE_PROMPT
	          ) : null,
	          _reactAddons2['default'].createElement(
	            'button',
	            { className: buttonClasses, disabled: isDisabled, onClick: isDisabled ? null : this.onActivateClick },
	            messages.BED_CONFIGURATION_BUTTON
	          )
	        )
	      );
	    },
	
	    render: function render() {
	      if (config.readOnly) {
	        return this.renderReadOnly();
	      } else {
	        if (this.state.isActive) {
	          return this.renderActive();
	        } else {
	          return this.renderInactive();
	        }
	      }
	    },
	
	    componentDidMount: function componentDidMount() {
	      this.props.model.on("change", this.forceUpdate.bind(this));
	      this.props.model.on("reset", this.onReset);
	    },
	
	    componentWillUnmount: function componentWillUnmount() {
	      this.props.model.off(null, null, this);
	    }
	  });
	
	  var Floor = _reactAddons2['default'].createClass({
	    displayName: 'Floor',
	
	    render: function render() {
	      var rooms = this.props.model.rooms.map(function (roomModel) {
	        return _reactAddons2['default'].createElement(Room, { model: roomModel });
	      });
	
	      var label = this.props.model.label;
	
	      return _reactAddons2['default'].createElement(
	        'div',
	        { className: 'ofs-BedConfiguration__Bedroom' },
	        label ? _reactAddons2['default'].createElement(
	          'h3',
	          null,
	          label
	        ) : null,
	        _reactAddons2['default'].createElement(
	          'ul',
	          { className: 'ofs-List ofs-List--padded' },
	          rooms
	        )
	      );
	    }
	  });
	
	  var Room = _reactAddons2['default'].createClass({
	    displayName: 'Room',
	
	    addExtra: function addExtra(extra) {
	      this.props.model.addExtra(extra.extra_id);
	    },
	
	    renderAvailableExtras: function renderAvailableExtras() {
	      var availableExtrasData;
	      var availableExtras = null;
	
	      availableExtrasData = this.props.model.getAvailableExtras();
	
	      availableExtras = availableExtrasData.map(function (extra, i) {
	        var isNotLast = i < availableExtrasData.length - 1;
	        var isActive = extra.active && !config.readOnly;
	        var onClick = isActive ? this.addExtra.bind(null, extra) : null;
	
	        var classes = (0, _classnames2['default'])({
	          extra: true,
	          active: isActive,
	          inactive: !isActive
	        });
	
	        return _reactAddons2['default'].createElement(
	          'span',
	          { key: i },
	          _reactAddons2['default'].createElement(
	            'a',
	            { className: classes, onClick: onClick },
	            (0, _ofsI18n.interpolate)(messages.ADD_EXTRA, { extra: extra.name }, true),
	            extra.price ? _reactAddons2['default'].createElement(
	              'span',
	              null,
	              ' (',
	              config.bedBillablesCurrencySymbol,
	              extra.price,
	              ')'
	            ) : null
	          ),
	          isNotLast ? _reactAddons2['default'].createElement(
	            'span',
	            { className: 'seperator' },
	            ' | '
	          ) : null
	        );
	      }, this);
	
	      if (availableExtras.length === 0) {
	        availableExtras = _reactAddons2['default'].createElement(
	          'span',
	          { className: 'u-text-italic' },
	          messages.NONE
	        );
	      }
	
	      return _reactAddons2['default'].createElement(
	        'p',
	        null,
	        messages.AVAILABLE_EXTRAS,
	        ': ',
	        availableExtras,
	        ' '
	      );
	    },
	
	    render: function render() {
	      var label = this.props.model.get('label');
	      var bedsModel = this.props.model.get('beds');
	
	      var beds = bedsModel.map(function (bedModel, i) {
	        return _reactAddons2['default'].createElement(MetaBed, { key: i, model: bedModel });
	      });
	
	      return _reactAddons2['default'].createElement(
	        'li',
	        { className: 'ofs-List__Item' },
	        _reactAddons2['default'].createElement(
	          'h3',
	          null,
	          label
	        ),
	        _reactAddons2['default'].createElement(
	          'div',
	          { className: 'ofs-BedConfiguration__BedsGroup' },
	          _reactAddons2['default'].createElement(
	            'ul',
	            { className: 'ofs-List ofs-List--with-borders' },
	            beds
	          )
	        ),
	        !config.readOnly ? this.renderAvailableExtras() : null
	      );
	    }
	  });
	
	  var MetaBed = _reactAddons2['default'].createClass({
	    displayName: 'MetaBed',
	
	    onSelect: function onSelect(count) {
	      var model = this.props.model;
	
	      if (model.isSeparated()) {
	        model.join();
	        model.setSelectedCount(1);
	      } else if (model.isExtra() && count === 0) {
	        model.remove();
	      } else {
	        model.setSelectedCount(count);
	      }
	    },
	
	    _getBedSize: function _getBedSize() {
	      var bedSize = this.props.model.get('size');
	      bedSize = bedSize.toLowerCase().replace(/_/g, '-');
	      bedSize = bedSize.substr(0, 1).toUpperCase() + bedSize.substr(1);
	
	      return bedSize;
	    },
	
	    render: function render() {
	      var model = this.props.model;
	      var action, actionText, actionMethod, actionActive, actionClasses, actionIcons;
	      var beds, label, sleeps, selected, max, description, price;
	
	      if (!config.readOnly) {
	        if (model.isJoinable()) {
	          actionIcons = ["icon-double-bed"];
	          actionMethod = model.join.bind(model);
	          actionText = "Join to 1 " + this._getBedSize();
	          actionActive = model.isCurrentlyJoinable();
	        } else if (model.isSeparable()) {
	          actionIcons = ["icon-single-bed", "icon-single-bed"];
	          actionMethod = model.separate.bind(model);
	          actionText = "Split to 2 singles";
	          actionActive = model.isCurrentlySeparable();
	        } else if (model.isExtendable()) {
	          actionIcons = ["icon-double-bed"];
	          actionMethod = model.extend.bind(model);
	          actionText = "Extend to " + this._getBedSize();
	          actionActive = model.isCurrentlyExtendable();
	        } else if (model.isRetractable()) {
	          actionIcons = ["icon-single-bed"];
	          actionMethod = model.retract.bind(model);
	          actionText = "Retract to single";
	          actionActive = model.isCurrentlyRetractable();
	        } else if (model.isExtra()) {
	          actionIcons = ["icon-trash"];
	          actionMethod = model.remove.bind(model);
	          actionText = "Remove extra";
	          actionActive = true;
	        }
	      }
	
	      if (actionMethod) {
	        if (!actionActive) {
	          actionMethod = null;
	        }
	
	        actionClasses = (0, _classnames2['default'])({
	          'disabled': !actionActive
	        });
	
	        actionIcons = actionIcons.map(function (symbol, i) {
	          return _reactAddons2['default'].createElement('span', { key: i, className: "action-icon " + symbol });
	        });
	
	        action = _reactAddons2['default'].createElement(
	          'a',
	          { onClick: actionMethod, className: actionClasses, disabled: !actionActive },
	          actionText
	        );
	      }
	
	      if (model.isSeparated()) {
	        beds = [_reactAddons2['default'].createElement(Bed, { key: 1, label: 'Single Bed', sleeps: 1, selected: 1, max: 1, onSelect: this.onSelect }), _reactAddons2['default'].createElement(Bed, { key: 2, label: 'Single Bed', sleeps: 1, selected: 1, max: 1, onSelect: this.onSelect, action: action })];
	      } else {
	        label = model.get('label');
	        sleeps = model.getSleeps();
	        selected = model.getSelectedCount();
	        max = model.getMaxSelectedCount();
	        description = model.getDescription();
	        price = model.get('price');
	        var iconClass = model.getBedIconClass();
	
	        if (model.isExtended()) {
	          label = this._getBedSize() + " bed";
	        }
	
	        beds = [_reactAddons2['default'].createElement(Bed, {
	          key: 3,
	          label: label,
	          price: price,
	          sleeps: sleeps,
	          selected: selected,
	          max: max,
	          onSelect: this.onSelect,
	          action: action,
	          description: description,
	          iconClass: iconClass
	        })];
	      }
	
	      return _reactAddons2['default'].createElement(
	        'li',
	        { className: 'ofs-List__Item' },
	        beds
	      );
	    }
	  });
	
	  var Bed = _reactAddons2['default'].createClass({
	    displayName: 'Bed',
	
	    contextTypes: {
	      flux: _reactAddons2['default'].PropTypes.object
	    },
	
	    render: function render() {
	      var _props = this.props;
	      var label = _props.label;
	      var sleeps = _props.sleeps;
	      var selected = _props.selected;
	      var max = _props.max;
	      var description = _props.description;
	      var price = _props.price;
	      var action = _props.action;
	
	      return _reactAddons2['default'].createElement(
	        'div',
	        { className: 'ofs-BedConfiguration__Bed' },
	        _reactAddons2['default'].createElement(
	          'div',
	          { className: 'ofs-BedConfiguration__SleepsSelector' },
	          _reactAddons2['default'].createElement(SleepsSelector, { selected: selected, total: sleeps, onSelect: this.props.onSelect, readOnly: config.readOnly, max: max })
	        ),
	        _reactAddons2['default'].createElement(
	          'span',
	          { className: 'ofs-BedConfiguration__ExtrasItem' },
	          _reactAddons2['default'].createElement(
	            'span',
	            { className: 'ofs-InfoTip__Label ofs-InfoTip__Label--left' },
	            label,
	            price ? _reactAddons2['default'].createElement(
	              'span',
	              null,
	              ' (',
	              config.bedBillablesCurrencySymbol + price,
	              ')'
	            ) : null
	          ),
	          description ? _reactAddons2['default'].createElement(
	            _ofsComponentsCommonInfoTip2['default'],
	            { flux: this.context.flux, small: true },
	            description
	          ) : null
	        ),
	        _reactAddons2['default'].createElement(
	          'div',
	          { className: 'u-pull-right' },
	          action
	        )
	      );
	    }
	  });
	
	  var BillablesSummary = _reactAddons2['default'].createClass({
	    displayName: 'BillablesSummary',
	
	    render: function render() {
	      var sum = this.props.sum;
	
	      return _reactAddons2['default'].createElement('div', { className: 'ofs-BedConfiguration__Billables', dangerouslySetInnerHTML: { __html: (0, _ofsI18n.interpolate)(messages.BILLABLES, { currency: config.bedBillablesCurrencySymbol, sum: sum }, true) } });
	    }
	  });
	
	  var BedSizeChartModal = _reactAddons2['default'].createClass({
	    displayName: 'BedSizeChartModal',
	
	    render: function render() {
	      return _reactAddons2['default'].createElement(
	        'div',
	        { className: 'bed-size-chart' },
	        _reactAddons2['default'].createElement(
	          'h2',
	          null,
	          messages.CHART_TITLE
	        ),
	        _reactAddons2['default'].createElement(_ofsUtilsBedSizeChartJsx2['default'], null)
	      );
	    }
	  });
	
	  var SleepsSelector = _reactAddons2['default'].createClass({
	    displayName: 'SleepsSelector',
	
	    getInitialState: function getInitialState() {
	      return {
	        hoverIndex: -1
	      };
	    },
	
	    onClick: function onClick(count) {
	      count = this._correctNewSelectedValue(count);
	      this.props.onSelect(count);
	
	      this.onMouseLeave();
	    },
	
	    _correctNewSelectedValue: function _correctNewSelectedValue(selected) {
	      if (selected <= this.props.selected) {
	        selected--;
	      }
	
	      var max = this.props.max;
	      return Math.min(max, selected);
	    },
	
	    onMouseEnter: function onMouseEnter(count) {
	      this.setState({
	        hoverIndex: Math.min(count, this.props.max)
	      });
	    },
	
	    onMouseLeave: function onMouseLeave() {
	      this.setState({
	        hoverIndex: -1
	      });
	    },
	
	    render: function render() {
	      var heads = [];
	      var total = this.props.total;
	      var selected = this.props.selected;
	
	      var readOnly = !!this.props.readOnly;
	      var max = this.props.max || selected;
	
	      if (this.state.hoverIndex > -1 && !readOnly) {
	        selected = this._correctNewSelectedValue(this.state.hoverIndex);
	      }
	
	      (0, _underscore2['default'])(total).times(function (i) {
	        var isSelected = i < selected;
	        var isSelectedable = !readOnly && !isSelected && i < max;
	        var isUnselectable = !isSelected && !isSelectedable;
	
	        var classes = {
	          'ofs-BedConfiguration__Head': true,
	          'font-icon': true
	        };
	
	        if (isSelected) {
	          classes['selected'] = true;
	          classes['icon-profile'] = true;
	        } else if (isSelectedable) {
	          classes['selectable'] = true;
	          classes['icon-profile-outline'] = true;
	        } else {
	          //unselectable
	          classes['ofs-BedConfiguration__Head--unselectable'] = true;
	          classes['icon-profile'] = true;
	        }
	
	        classes = (0, _classnames2['default'])(classes);
	
	        var listeners = {};
	        ['onClick', 'onMouseEnter', 'onMouseLeave'].forEach(function (eventName) {
	          if (isUnselectable || readOnly) {
	            listeners[eventName] = null;
	          } else {
	            listeners[eventName] = this[eventName].bind(null, i + 1);
	          }
	        }, this);
	
	        heads.push(_reactAddons2['default'].createElement('span', { className: classes, key: i + 1, onClick: listeners.onClick,
	          onMouseEnter: listeners.onMouseEnter, onMouseLeave: listeners.onMouseLeave }));
	      }, this);
	
	      return _reactAddons2['default'].createElement(
	        'div',
	        null,
	        heads
	      );
	    }
	  });
	
	  return BedConfiguration;
	};

/***/ },
/* 547 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(3)['default'];
	
	var _inherits = __webpack_require__(17)['default'];
	
	var _createClass = __webpack_require__(28)['default'];
	
	var _classCallCheck = __webpack_require__(31)['default'];
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _reactAddons = __webpack_require__(40);
	
	var _reactAddons2 = _interopRequireDefault(_reactAddons);
	
	var _radium = __webpack_require__(548);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _ofsI18n = __webpack_require__(61);
	
	var _ofsAppsHomesDetailViewsStyles = __webpack_require__(563);
	
	var baseTypeUnit = 0.5;
	var baseLineHeight = 3 * baseTypeUnit;
	var verticalSpacing = baseLineHeight;
	var smallVerticalSpacing = baseLineHeight / 2;
	var smallHorizontalSpacing = smallVerticalSpacing * _ofsAppsHomesDetailViewsStyles.magicNumbers.constants.phi;
	
	var styles = {
	  table: {
	    background: '#fff',
	    margin: '0px auto',
	    width: '100%',
	    "@media (max-width: 769px)": {
	      fontSize: '0.9em',
	      height: '100%',
	      position: 'absolute',
	      left: '0',
	      top: '0'
	    }
	  },
	  td: {
	    padding: smallVerticalSpacing + 'rem ' + smallHorizontalSpacing + 'rem',
	    borderLeft: '1px solid ' + _ofsAppsHomesDetailViewsStyles.colors.vLightGreyColour
	  },
	  tr: {
	    borderTop: '1px solid ' + _ofsAppsHomesDetailViewsStyles.colors.vLightGreyColour
	  },
	  titleRow: {
	    borderTop: '0'
	  },
	  iconColumn: {
	    borderLeft: '0',
	    fontSize: '2.3125rem'
	  },
	  middle: {
	    backgroundColor: _ofsAppsHomesDetailViewsStyles.colors.vLightGreyColour,
	    textAlign: 'center'
	  }
	};
	
	var messages = {
	  US_HOMES: (0, _ofsI18n.gettext)("In US homes"),
	  EUROPEAN_HOMES: (0, _ofsI18n.gettext)("In European<br />homes"),
	  BED_WIDTH: (0, _ofsI18n.gettext)("Bed width"),
	  APPROX_SIZE: (0, _ofsI18n.gettext)("Approx size"),
	  SMALL_SINGLE: (0, _ofsI18n.gettext)("Small single/child"),
	  SMALLER_THAN: (0, _ofsI18n.gettext)("Smaller than"),
	  SINGLE: (0, _ofsI18n.gettext)("Single"),
	  SMALL_DOUBLE: (0, _ofsI18n.gettext)("Small double"),
	  DOUBLE: (0, _ofsI18n.gettext)("Double"),
	  QUEEN: (0, _ofsI18n.gettext)("Queen"),
	  KING: (0, _ofsI18n.gettext)("King"),
	  SUPER_KING: (0, _ofsI18n.gettext)("Super king")
	};
	
	var BedSizeChart = (function (_React$Component) {
	  _inherits(BedSizeChart, _React$Component);
	
	  function BedSizeChart(props) {
	    _classCallCheck(this, _BedSizeChart);
	
	    _get(Object.getPrototypeOf(_BedSizeChart.prototype), 'constructor', this).call(this, props);
	    this.state = {};
	  }
	
	  _createClass(BedSizeChart, [{
	    key: 'render',
	    value: function render() {
	      return _reactAddons2['default'].createElement(
	        'div',
	        { className: 'bed-size-chart' },
	        _reactAddons2['default'].createElement(
	          'table',
	          { style: styles.table },
	          _reactAddons2['default'].createElement(
	            'tbody',
	            null,
	            _reactAddons2['default'].createElement(
	              'tr',
	              { style: styles.titleRow },
	              _reactAddons2['default'].createElement(
	                'td',
	                { style: [styles.td, styles.iconColumn] },
	                ' '
	              ),
	              _reactAddons2['default'].createElement(
	                'td',
	                { style: styles.td },
	                messages.US_HOMES
	              ),
	              _reactAddons2['default'].createElement('td', { style: styles.td, dangerouslySetInnerHTML: { __html: messages.EUROPEAN_HOMES } }),
	              _reactAddons2['default'].createElement(
	                'td',
	                { style: styles.td },
	                messages.BED_WIDTH
	              )
	            ),
	            _reactAddons2['default'].createElement(
	              'tr',
	              { style: styles.tr },
	              _reactAddons2['default'].createElement(
	                'td',
	                { style: [styles.td, styles.iconColumn] },
	                _reactAddons2['default'].createElement('span', { className: 'icon-bed-size-small-single-notext' })
	              ),
	              _reactAddons2['default'].createElement(
	                'td',
	                { ref: 'middle', style: [styles.td, styles.middle], colSpan: '2' },
	                messages.SMALL_SINGLE
	              ),
	              _reactAddons2['default'].createElement(
	                'td',
	                { style: styles.td },
	                messages.SMALLER_THAN,
	                ' 80cm',
	                _reactAddons2['default'].createElement('br', null),
	                _reactAddons2['default'].createElement('br', null),
	                '31in'
	              )
	            ),
	            _reactAddons2['default'].createElement(
	              'tr',
	              { style: styles.tr },
	              _reactAddons2['default'].createElement(
	                'td',
	                { style: [styles.td, styles.iconColumn] },
	                _reactAddons2['default'].createElement('span', { className: 'icon-bed-size-single-notext' })
	              ),
	              _reactAddons2['default'].createElement(
	                'td',
	                { ref: 'middle2', style: styles.middle, colSpan: '2' },
	                messages.SINGLE
	              ),
	              _reactAddons2['default'].createElement(
	                'td',
	                { style: styles.td },
	                '80 – 110cm',
	                _reactAddons2['default'].createElement('br', null),
	                _reactAddons2['default'].createElement('br', null),
	                '31 – 43in'
	              )
	            ),
	            _reactAddons2['default'].createElement(
	              'tr',
	              { style: styles.tr },
	              _reactAddons2['default'].createElement(
	                'td',
	                { style: [styles.td, styles.iconColumn] },
	                _reactAddons2['default'].createElement('span', { className: 'icon-bed-size-small-double-notext' })
	              ),
	              _reactAddons2['default'].createElement(
	                'td',
	                { ref: 'middle3', style: styles.middle, colSpan: '2' },
	                messages.SMALL_DOUBLE
	              ),
	              _reactAddons2['default'].createElement(
	                'td',
	                { style: styles.td },
	                '110 – 125cm',
	                _reactAddons2['default'].createElement('br', null),
	                _reactAddons2['default'].createElement('br', null),
	                '43 – 49in'
	              )
	            ),
	            _reactAddons2['default'].createElement(
	              'tr',
	              { style: styles.tr },
	              _reactAddons2['default'].createElement(
	                'td',
	                { style: [styles.td, styles.iconColumn] },
	                _reactAddons2['default'].createElement('span', { className: 'icon-bed-size-double-notext' })
	              ),
	              _reactAddons2['default'].createElement(
	                'td',
	                { ref: 'middle4', style: styles.middle, colSpan: '2' },
	                messages.DOUBLE
	              ),
	              _reactAddons2['default'].createElement(
	                'td',
	                { style: styles.td },
	                '125 – 150cm',
	                _reactAddons2['default'].createElement('br', null),
	                _reactAddons2['default'].createElement('br', null),
	                '49 – 59in'
	              )
	            ),
	            _reactAddons2['default'].createElement(
	              'tr',
	              { style: styles.tr },
	              _reactAddons2['default'].createElement(
	                'td',
	                { style: [styles.td, styles.iconColumn] },
	                _reactAddons2['default'].createElement('span', { className: 'icon-bed-size-queen-notext' })
	              ),
	              _reactAddons2['default'].createElement(
	                'td',
	                { style: styles.td },
	                messages.QUEEN
	              ),
	              _reactAddons2['default'].createElement(
	                'td',
	                { style: styles.td },
	                messages.KING
	              ),
	              _reactAddons2['default'].createElement(
	                'td',
	                { style: styles.td },
	                '150 – 170cm',
	                _reactAddons2['default'].createElement('br', null),
	                _reactAddons2['default'].createElement('br', null),
	                '59 – 67in'
	              )
	            ),
	            _reactAddons2['default'].createElement(
	              'tr',
	              { style: styles.tr },
	              _reactAddons2['default'].createElement(
	                'td',
	                { style: [styles.td, styles.iconColumn] },
	                _reactAddons2['default'].createElement('span', { className: 'icon-bed-size-king-super-notext' })
	              ),
	              _reactAddons2['default'].createElement(
	                'td',
	                { style: styles.td },
	                messages.KING
	              ),
	              _reactAddons2['default'].createElement(
	                'td',
	                { style: styles.td },
	                messages.SUPER_KING
	              ),
	              _reactAddons2['default'].createElement(
	                'td',
	                { style: styles.td },
	                '170 – 190cm',
	                _reactAddons2['default'].createElement('br', null),
	                _reactAddons2['default'].createElement('br', null),
	                '67 – 75in'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  var _BedSizeChart = BedSizeChart;
	  BedSizeChart = (0, _radium2['default'])(BedSizeChart) || BedSizeChart;
	  return BedSizeChart;
	})(_reactAddons2['default'].Component);
	
	exports['default'] = BedSizeChart;
	;
	module.exports = exports['default'];

/***/ },
/* 548 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Enhancer = __webpack_require__(549);
	
	module.exports = function (ComposedComponent) {
	  return Enhancer(ComposedComponent);
	};
	module.exports.Style = __webpack_require__(559);
	module.exports.PrintStyleSheet = __webpack_require__(561);
	module.exports.getState = __webpack_require__(552);
	module.exports.keyframes = __webpack_require__(562);
	module.exports.Config = __webpack_require__(557);

/***/ },
/* 549 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; desc = parent = getter = undefined; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var resolveStyles = __webpack_require__(550);
	var printStyles = __webpack_require__(558);
	
	var enhanceWithRadium = function enhanceWithRadium(ComposedComponent) {
	  var RadiumEnhancer = (function (_ComposedComponent) {
	    _inherits(RadiumEnhancer, _ComposedComponent);
	
	    function RadiumEnhancer() {
	      _classCallCheck(this, RadiumEnhancer);
	
	      _get(Object.getPrototypeOf(RadiumEnhancer.prototype), 'constructor', this).apply(this, arguments);
	
	      this.state = this.state || {};
	      this.state._radiumStyleState = {};
	
	      if (RadiumEnhancer.printStyleClass) {
	        this.printStyleClass = RadiumEnhancer.printStyleClass;
	      }
	    }
	
	    // Class inheritance uses Object.create and because of __proto__ issues
	    // with IE <10 any static properties of the superclass aren't inherited and
	    // so need to be manually populated
	    // See http://babeljs.io/docs/advanced/caveats/#classes-10-and-below-
	    // This also fixes React Hot Loader by exposing the original components top level
	    // prototype methods on the Radium enhanced prototype as discussed in #219.
	
	    _createClass(RadiumEnhancer, [{
	      key: 'render',
	      value: function render() {
	        var renderedElement = _get(Object.getPrototypeOf(RadiumEnhancer.prototype), 'render', this).call(this);
	        return resolveStyles(this, renderedElement);
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        if (_get(Object.getPrototypeOf(RadiumEnhancer.prototype), 'componentWillUnmount', this)) {
	          _get(Object.getPrototypeOf(RadiumEnhancer.prototype), 'componentWillUnmount', this).call(this);
	        }
	
	        if (this._radiumMouseUpListener) {
	          this._radiumMouseUpListener.remove();
	        }
	
	        if (this._radiumMediaQueryListenersByQuery) {
	          Object.keys(this._radiumMediaQueryListenersByQuery).forEach(function (query) {
	            this._radiumMediaQueryListenersByQuery[query].remove();
	          }, this);
	        }
	      }
	    }]);
	
	    return RadiumEnhancer;
	  })(ComposedComponent);
	
	  Object.getOwnPropertyNames(ComposedComponent.prototype).forEach(function (key) {
	    if (!RadiumEnhancer.prototype.hasOwnProperty(key)) {
	      var descriptor = Object.getOwnPropertyDescriptor(ComposedComponent.prototype, key);
	      Object.defineProperty(RadiumEnhancer.prototype, key, descriptor);
	    }
	  });
	
	  RadiumEnhancer.displayName = ComposedComponent.displayName || ComposedComponent.name || 'Component';
	
	  RadiumEnhancer.printStyleClass = printStyles.addPrintStyles(RadiumEnhancer);
	
	  return RadiumEnhancer;
	};
	
	module.exports = enhanceWithRadium;

/***/ },
/* 550 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var MouseUpListener = __webpack_require__(551);
	var getState = __webpack_require__(552);
	var getStateKey = __webpack_require__(553);
	var Prefixer = __webpack_require__(554);
	var Config = __webpack_require__(557);
	
	var ExecutionEnvironment = __webpack_require__(555);
	var React = __webpack_require__(40);
	
	// babel-eslint 3.1.7 fails here for some reason, error:
	//   0:0  error  Cannot call method 'isSequenceExpression' of undefined
	//
	// declare class RadiumComponent extends ReactComponent {
	//   _lastMouseDown: number,
	//   _radiumMediaQueryListenersByQuery: Object<string, {remove: () => void}>,
	//   _radiumMouseUpListener: {remove: () => void},
	// }
	
	var mediaQueryListByQueryString = {};
	
	var _isSpecialKey = function _isSpecialKey(key) {
	  return key[0] === ':' || key[0] === '@';
	};
	
	var _getStyleState = function _getStyleState(component, key, value) {
	  return getState(component.state, key, value);
	};
	
	var _setStyleState = function _setStyleState(component, key, newState) {
	  var existing = component._lastRadiumState || component.state && component.state._radiumStyleState || {};
	
	  var state = { _radiumStyleState: _extends({}, existing) };
	  state._radiumStyleState[key] = _extends({}, state._radiumStyleState[key], newState);
	
	  component._lastRadiumState = state._radiumStyleState;
	  component.setState(state);
	};
	
	// Merge style objects. Special casing for props starting with ';'; the values
	// should be objects, and are merged with others of the same name (instead of
	// overwriting).
	var _mergeStyles = function _mergeStyles(styles) {
	  var result = {};
	
	  styles.forEach(function (style) {
	    if (!style || typeof style !== 'object' || Array.isArray(style)) {
	      return;
	    }
	
	    Object.keys(style).forEach(function (key) {
	      if (_isSpecialKey(key) && result[key]) {
	        result[key] = _mergeStyles([result[key], style[key]]);
	      } else {
	        result[key] = style[key];
	      }
	    });
	  });
	
	  return result;
	};
	
	var _mouseUp = function _mouseUp(component) {
	  Object.keys(component.state._radiumStyleState).forEach(function (key) {
	    if (_getStyleState(component, key, ':active')) {
	      _setStyleState(component, key, { ':active': false });
	    }
	  });
	};
	
	var _onMediaQueryChange = function _onMediaQueryChange(component, query, mediaQueryList) {
	  var state = {};
	  state[query] = mediaQueryList.matches;
	  _setStyleState(component, '_all', state);
	};
	
	var _resolveMediaQueryStyles = function _resolveMediaQueryStyles(component, style) {
	  if (!Config.canMatchMedia()) {
	    return style;
	  }
	
	  Object.keys(style).filter(function (name) {
	    return name[0] === '@';
	  }).map(function (query) {
	    var mediaQueryStyles = style[query];
	    query = query.replace('@media ', '');
	
	    // Create a global MediaQueryList if one doesn't already exist
	    var mql = mediaQueryListByQueryString[query];
	    if (!mql) {
	      mediaQueryListByQueryString[query] = mql = Config.matchMedia(query);
	    }
	
	    // Keep track of which keys already have listeners
	    if (!component._radiumMediaQueryListenersByQuery) {
	      component._radiumMediaQueryListenersByQuery = {};
	    }
	
	    if (!component._radiumMediaQueryListenersByQuery[query]) {
	      var listener = _onMediaQueryChange.bind(null, component, query);
	      mql.addListener(listener);
	      component._radiumMediaQueryListenersByQuery[query] = {
	        remove: function remove() {
	          mql.removeListener(listener);
	        }
	      };
	    }
	
	    // Apply media query states
	    if (mql.matches) {
	      style = _mergeStyles([style, mediaQueryStyles]);
	    }
	  });
	
	  return style;
	};
	
	// Wrapper around React.cloneElement. To avoid processing the same element
	// twice, whenever we clone an element add a special non-enumerable prop to
	// make sure we don't process this element again.
	var _cloneElement = function _cloneElement(renderedElement, newProps, newChildren) {
	  // Only add flag if this is a normal DOM element
	  if (typeof renderedElement.type === 'string') {
	    newProps = _extends({}, newProps, { _radiumDidResolveStyles: true });
	  }
	
	  return React.cloneElement(renderedElement, newProps, newChildren);
	};
	
	//
	// The nucleus of Radium. resolveStyles is called on the rendered elements
	// before they are returned in render. It iterates over the elements and
	// children, rewriting props to add event handlers required to capture user
	// interactions (e.g. mouse over). It also replaces the style prop because it
	// adds in the various interaction styles (e.g. :hover).
	//
	var resolveStyles = function resolveStyles(component, // ReactComponent, flow+eslint complaining
	renderedElement, // ReactElement
	existingKeyMap) {
	  // ReactElement
	  existingKeyMap = existingKeyMap || {};
	
	  if (!renderedElement ||
	  // Bail if we've already processed this element. This ensures that only the
	  // owner of an element processes that element, since the owner's render
	  // function will be called first (which will always be the case, since you
	  // can't know what else to render until you render the parent component).
	  renderedElement.props && renderedElement.props._radiumDidResolveStyles) {
	    return renderedElement;
	  }
	
	  // Recurse over children first in case we bail early. Note that children only
	  // include those rendered in `this` component. Child nodes in other components
	  // will not be here, so each component needs to use Radium.
	  var oldChildren = renderedElement.props.children;
	  var newChildren = oldChildren;
	  if (oldChildren) {
	    var childrenType = typeof oldChildren;
	    if (childrenType === 'string' || childrenType === 'number') {
	      // Don't do anything with a single primitive child
	      newChildren = oldChildren;
	    } else if (childrenType === 'function') {
	      // Wrap the function, resolving styles on the result
	      newChildren = function () {
	        var result = oldChildren.apply(this, arguments);
	        if (React.isValidElement(result)) {
	          return resolveStyles(component, result, existingKeyMap);
	        }
	        return result;
	      };
	    } else if (React.Children.count(oldChildren) === 1 && oldChildren.type) {
	      // If a React Element is an only child, don't wrap it in an array for
	      // React.Children.map() for React.Children.only() compatibility.
	      var onlyChild = React.Children.only(oldChildren);
	      newChildren = resolveStyles(component, onlyChild, existingKeyMap);
	    } else {
	      newChildren = React.Children.map(oldChildren, function (child) {
	        if (React.isValidElement(child)) {
	          return resolveStyles(component, child, existingKeyMap);
	        }
	
	        return child;
	      });
	    }
	  }
	
	  var props = renderedElement.props;
	  var newProps = {};
	
	  // Recurse over props, just like children
	  Object.keys(props).forEach(function (prop) {
	    // We already recurse over children above
	    if (prop === 'children') {
	      return;
	    }
	
	    var propValue = props[prop];
	    if (React.isValidElement(propValue)) {
	      newProps[prop] = resolveStyles(component, propValue, existingKeyMap);
	    }
	  });
	
	  var hasResolvedProps = Object.keys(newProps).length > 0;
	
	  // Bail early if element is not a simple ReactDOMElement.
	  if (!React.isValidElement(renderedElement) || typeof renderedElement.type !== 'string') {
	    if (oldChildren === newChildren && !hasResolvedProps) {
	      return renderedElement;
	    }
	
	    return _cloneElement(renderedElement, hasResolvedProps ? newProps : {}, newChildren);
	  }
	
	  var style = props.style;
	
	  // Convenient syntax for multiple styles: `style={[style1, style2, etc]}`
	  // Ignores non-objects, so you can do `this.state.isCool && styles.cool`.
	  if (Array.isArray(style)) {
	    style = _mergeStyles(style);
	  }
	
	  if (false) {
	    // Warn if you use longhand and shorthand properties in the same style
	    // object.
	    // https://developer.mozilla.org/en-US/docs/Web/CSS/Shorthand_properties
	
	    var shorthandPropertyExpansions = {
	      'background': ['backgroundAttachment', 'backgroundBlendMode', 'backgroundClip', 'backgroundColor', 'backgroundImage', 'backgroundOrigin', 'backgroundPosition', 'backgroundPositionX', 'backgroundPositionY', 'backgroundRepeat', 'backgroundRepeatX', 'backgroundRepeatY', 'backgroundSize'],
	      'border': ['borderBottom', 'borderBottomColor', 'borderBottomStyle', 'borderBottomWidth', 'borderColor', 'borderLeft', 'borderLeftColor', 'borderLeftStyle', 'borderLeftWidth', 'borderRight', 'borderRightColor', 'borderRightStyle', 'borderRightWidth', 'borderStyle', 'borderTop', 'borderTopColor', 'borderTopStyle', 'borderTopWidth', 'borderWidth'],
	      'borderImage': ['borderImageOutset', 'borderImageRepeat', 'borderImageSlice', 'borderImageSource', 'borderImageWidth'],
	      'borderRadius': ['borderBottomLeftRadius', 'borderBottomRightRadius', 'borderTopLeftRadius', 'borderTopRightRadius'],
	      'font': ['fontFamily', 'fontKerning', 'fontSize', 'fontStretch', 'fontStyle', 'fontVariant', 'fontVariantLigatures', 'fontWeight', 'lineHeight'],
	      'listStyle': ['listStyleImage', 'listStylePosition', 'listStyleType'],
	      'margin': ['marginBottom', 'marginLeft', 'marginRight', 'marginTop'],
	      'padding': ['paddingBottom', 'paddingLeft', 'paddingRight', 'paddingTop'],
	      'transition': ['transitionDelay', 'transitionDuration', 'transitionProperty', 'transitionTimingFunction']
	    };
	
	    var checkProps = function checkProps(s) {
	      if (typeof s !== 'object' || !s) {
	        return;
	      }
	
	      var styleKeys = Object.keys(s);
	      styleKeys.forEach(function (styleKey) {
	        if (shorthandPropertyExpansions[styleKey] && shorthandPropertyExpansions[styleKey].some(function (sp) {
	          return styleKeys.indexOf(sp) !== -1;
	        })) {
	          if (process.env.NODE_ENV !== 'production') {
	            /* eslint-disable no-console */
	            console.warn('Radium: property "' + styleKey + '" in style object', style, ': do not mix longhand and ' + 'shorthand properties in the same style object. Check the render ' + 'method of ' + component.constructor.displayName + '.', 'See https://github.com/FormidableLabs/radium/issues/95 for more ' + 'information.');
	            /* eslint-enable no-console */
	          }
	        }
	      });
	
	      styleKeys.forEach(function (k) {
	        return checkProps(s[k]);
	      });
	    };
	    checkProps(style);
	  }
	
	  // Bail early if no interactive styles.
	  if (!style || !Object.keys(style).some(_isSpecialKey)) {
	    if (style) {
	      // Still perform vendor prefixing, though.
	      newProps.style = Prefixer.getPrefixedStyle(component, style);
	      return _cloneElement(renderedElement, newProps, newChildren);
	    } else if (newChildren || hasResolvedProps) {
	      return _cloneElement(renderedElement, newProps, newChildren);
	    }
	
	    return renderedElement;
	  }
	
	  // We need a unique key to correlate state changes due to user interaction
	  // with the rendered element, so we know to apply the proper interactive
	  // styles.
	  var originalKey = renderedElement.ref || renderedElement.key;
	  var key = getStateKey(originalKey);
	
	  if (existingKeyMap[key]) {
	    throw new Error('Radium requires each element with interactive styles to have a unique ' + 'key, set using either the ref or key prop. ' + (originalKey ? 'Key "' + originalKey + '" is a duplicate.' : 'Multiple elements have no key specified.'));
	  }
	
	  existingKeyMap[key] = true;
	
	  // Media queries can contain pseudo styles, like :hover
	  style = _resolveMediaQueryStyles(component, style);
	
	  var newStyle = {};
	  Object.keys(style).forEach(function (styleKey) {
	    if (!_isSpecialKey(styleKey)) {
	      newStyle[styleKey] = style[styleKey];
	    }
	  });
	
	  // Only add handlers if necessary
	  if (style[':hover'] || style[':active']) {
	    // Always call the existing handler if one is already defined.
	    // This code, and the very similar ones below, could be abstracted a bit
	    // more, but it hurts readability IMO.
	    var existingOnMouseEnter = props.onMouseEnter;
	    newProps.onMouseEnter = function (e) {
	      existingOnMouseEnter && existingOnMouseEnter(e);
	      _setStyleState(component, key, { ':hover': true });
	    };
	
	    var existingOnMouseLeave = props.onMouseLeave;
	    newProps.onMouseLeave = function (e) {
	      existingOnMouseLeave && existingOnMouseLeave(e);
	      _setStyleState(component, key, { ':hover': false });
	    };
	  }
	
	  if (style[':active']) {
	    var existingOnMouseDown = props.onMouseDown;
	    newProps.onMouseDown = function (e) {
	      existingOnMouseDown && existingOnMouseDown(e);
	      component._lastMouseDown = Date.now();
	      _setStyleState(component, key, { ':active': true });
	    };
	  }
	
	  if (style[':focus']) {
	    var existingOnFocus = props.onFocus;
	    newProps.onFocus = function (e) {
	      existingOnFocus && existingOnFocus(e);
	      _setStyleState(component, key, { ':focus': true });
	    };
	
	    var existingOnBlur = props.onBlur;
	    newProps.onBlur = function (e) {
	      existingOnBlur && existingOnBlur(e);
	      _setStyleState(component, key, { ':focus': false });
	    };
	  }
	
	  // Merge the styles in the order they were defined
	  var interactionStyles = Object.keys(style).filter(function (name) {
	    return name === ':active' && _getStyleState(component, key, ':active') || name === ':hover' && _getStyleState(component, key, ':hover') || name === ':focus' && _getStyleState(component, key, ':focus');
	  }).map(function (name) {
	    return style[name];
	  });
	
	  if (interactionStyles.length) {
	    newStyle = _mergeStyles([newStyle].concat(interactionStyles));
	  }
	
	  if (style[':active'] && !component._radiumMouseUpListener && ExecutionEnvironment.canUseEventListeners) {
	    component._radiumMouseUpListener = MouseUpListener.subscribe(_mouseUp.bind(null, component));
	  }
	
	  newProps.style = Prefixer.getPrefixedStyle(component, newStyle);
	
	  return _cloneElement(renderedElement, newProps, newChildren);
	};
	
	// Exposing methods for tests is ugly, but the alternative, re-requiring the
	// module each time, is too slow
	resolveStyles.__clearStateForTests = function () {
	  mediaQueryListByQueryString = {};
	};
	
	module.exports = resolveStyles;

/***/ },
/* 551 */
/***/ function(module, exports) {

	'use strict';
	
	var _callbacks = [];
	var _mouseUpListenerIsActive = false;
	
	var _handleMouseUp = function _handleMouseUp(ev) {
	  _callbacks.forEach(function (callback) {
	    callback(ev);
	  });
	};
	
	var subscribe = function subscribe(callback) {
	  if (_callbacks.indexOf(callback) === -1) {
	    _callbacks.push(callback);
	  }
	
	  if (!_mouseUpListenerIsActive) {
	    window.addEventListener('mouseup', _handleMouseUp);
	    _mouseUpListenerIsActive = true;
	  }
	
	  return {
	    remove: function remove() {
	      var index = _callbacks.indexOf(callback);
	      _callbacks.splice(index, 1);
	
	      if (_callbacks.length === 0 && _mouseUpListenerIsActive) {
	        window.removeEventListener('mouseup', _handleMouseUp);
	        _mouseUpListenerIsActive = false;
	      }
	    }
	  };
	};
	
	module.exports = {
	  subscribe: subscribe
	};

/***/ },
/* 552 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var getStateKey = __webpack_require__(553);
	
	var VALID_KEYS = [':active', ':focus', ':hover'];
	
	var getState = function getState(state, elementKey, value) {
	  if (VALID_KEYS.indexOf(value) === -1) {
	    throw new Error('Radium.getState invalid value param: `' + value + '`');
	  }
	
	  var key = getStateKey(elementKey);
	
	  return !!(state && state._radiumStyleState && state._radiumStyleState[key] && state._radiumStyleState[key][value]);
	};
	
	module.exports = getState;

/***/ },
/* 553 */
/***/ function(module, exports) {

	'use strict';
	
	var getStateKey = function getStateKey(elementKey) {
	  return elementKey === null || elementKey === undefined ? 'main' : elementKey.toString();
	};
	
	module.exports = getStateKey;

/***/ },
/* 554 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Based on https://github.com/jsstyles/css-vendor, but without having to
	 * convert between different cases all the time.
	 *
	 * 
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(555);
	var arrayFind = __webpack_require__(556);
	
	var VENDOR_PREFIX_REGEX = /-(moz|webkit|ms|o)-/;
	
	var vendorPrefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	var infoByCssPrefix = {
	  '-moz-': {
	    cssPrefix: '-moz-',
	    jsPrefix: 'Moz',
	    alternativeProperties: {
	      // OLD - Firefox 19-
	      alignItems: [{ css: '-moz-box-align', js: 'MozBoxAlign' }],
	      flex: [{ css: '-moz-box-flex', js: 'MozBoxFlex' }],
	      flexDirection: [{ css: '-moz-box-orient', js: 'MozBoxOrient' }],
	      justifyContent: [{ css: '-moz-box-pack', js: 'MozBoxPack' }],
	      order: [{ css: '-moz-box-ordinal-group', js: 'MozBoxOrdinalGroup' }]
	    },
	    alternativeValues: {
	      // OLD - Firefox 19-
	      alignItems: {
	        'flex-start': ['start'],
	        'flex-end': ['end']
	      },
	      display: {
	        flex: ['-moz-box']
	      },
	      flexDirection: {
	        column: ['vertical'],
	        row: ['horizontal']
	      },
	      justifyContent: {
	        'flex-start': ['start'],
	        'flex-end': ['end'],
	        'space-between': ['justify']
	      }
	    }
	  },
	  '-ms-': {
	    cssPrefix: '-ms-',
	    jsPrefix: 'ms',
	    alternativeProperties: {
	      // TWEENER - IE 10
	      alignContent: [{ css: '-ms-flex-line-pack', js: 'msFlexLinePack' }],
	      alignItems: [{ css: '-ms-flex-align', js: 'msFlexAlign' }],
	      alignSelf: [{ css: '-ms-flex-align-item', js: 'msFlexAlignItem' }],
	      justifyContent: [{ css: '-ms-flex-pack', js: 'msFlexPack' }],
	      order: [{ css: '-ms-flex-order', js: 'msFlexOrder' }]
	    },
	    alternativeValues: {
	      // TWEENER - IE 10
	      alignContent: {
	        'flex-start': ['start'],
	        'flex-end': ['end'],
	        'space-between': ['justify'],
	        'space-around': ['distribute']
	      },
	      alignItems: {
	        'flex-start': ['start'],
	        'flex-end': ['end']
	      },
	      alignSelf: {
	        'flex-start': ['start'],
	        'flex-end': ['end']
	      },
	      display: {
	        flex: ['-ms-flexbox'],
	        'inline-flex': ['-ms-inline-flexbox']
	      },
	      justifyContent: {
	        'flex-start': ['start'],
	        'flex-end': ['end'],
	        'space-between': ['justify'],
	        'space-around': ['distribute']
	      }
	    }
	  },
	  '-o-': {
	    cssPrefix: '-o-',
	    jsPrefix: 'O'
	  },
	  '-webkit-': {
	    cssPrefix: '-webkit-',
	    jsPrefix: 'Webkit',
	    alternativeProperties: {
	      // OLD - iOS 6-, Safari 3.1-6
	      alignItems: [{ css: '-webkit-box-align', js: 'WebkitBoxAlign' }],
	      flex: [{ css: '-webkit-box-flex', js: 'MozBoxFlex' }],
	      flexDirection: [{ css: '-webkit-box-orient', js: 'WebkitBoxOrient' }],
	      justifyContent: [{ css: '-webkit-box-pack', js: 'WebkitBoxPack' }],
	      order: [{ css: '-webkit-box-ordinal-group', js: 'WebkitBoxOrdinalGroup' }]
	    },
	    alternativeValues: {
	      // OLD - iOS 6-, Safari 3.1-6
	      alignItems: {
	        'flex-start': ['start'],
	        'flex-end': ['end']
	      },
	      display: {
	        flex: ['-webkit-box']
	      },
	      flexDirection: {
	        row: ['horizontal'],
	        column: ['vertical']
	      },
	      justifyContent: {
	        'flex-start': ['start'],
	        'flex-end': ['end'],
	        'space-between': ['justify']
	      }
	    }
	  }
	};
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 * Copied from React core June 22, 2015.
	 * https://github.com/facebook/react/blob/
	 * ba81b60ad8e93b747be42a03b797065932c49c96/
	 * src/renderers/dom/shared/CSSProperty.js
	 */
	var isUnitlessNumber = {
	  boxFlex: true,
	  boxFlexGroup: true,
	  columnCount: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  strokeDashoffset: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	var domStyle = {};
	var prefixedPropertyCache = {};
	var prefixedValueCache = {};
	var prefixInfo = {
	  cssPrefix: '',
	  jsPrefix: ''
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  domStyle = document.createElement('p').style;
	
	  // older Firefox versions may have no float property in style object
	  // so we need to add it manually
	  if (domStyle.float === undefined) {
	    domStyle.float = '';
	  }
	
	  // Based on http://davidwalsh.name/vendor-prefix
	  var prefixMatch;
	  var windowStyles = window.getComputedStyle(document.documentElement, '');
	
	  // Array.prototype.slice.call(windowStyles) fails with
	  // "Uncaught TypeError: undefined is not a function"
	  // in older versions Android (KitKat) web views
	  for (var i = 0; i < windowStyles.length; i++) {
	    prefixMatch = windowStyles[i].match(VENDOR_PREFIX_REGEX);
	
	    if (prefixMatch) {
	      break;
	    }
	  }
	
	  var cssVendorPrefix = prefixMatch && prefixMatch[0];
	
	  prefixInfo = cssVendorPrefix && infoByCssPrefix[cssVendorPrefix] ? infoByCssPrefix[cssVendorPrefix] : prefixInfo;
	}
	
	var _camelCaseRegex = /([a-z])?([A-Z])/g;
	var _camelCaseReplacer = function _camelCaseReplacer(match, p1, p2) {
	  return p1 + '-' + p2.toLowerCase();
	};
	var _camelCaseToDashCase = function _camelCaseToDashCase(s) {
	  return s.replace(_camelCaseRegex, _camelCaseReplacer);
	};
	
	var getPrefixedPropertyName = function getPrefixedPropertyName(property) {
	  if (prefixedPropertyCache.hasOwnProperty(property)) {
	    return prefixedPropertyCache[property];
	  }
	
	  var unprefixed = {
	    css: _camelCaseToDashCase(property),
	    js: property,
	    isDefaultForServer: true
	  };
	
	  // Try the prefixed version first. Chrome in particular has the `filter` and
	  // `webkitFilter` properties availalbe on the style object, but only the
	  // prefixed version actually works.
	  var possiblePropertyNames = [
	  // Prefixed
	  {
	    css: prefixInfo.cssPrefix + _camelCaseToDashCase(property),
	    js: prefixInfo.jsPrefix + property[0].toUpperCase() + property.slice(1)
	  }, unprefixed];
	
	  // Alternative property names
	  if (prefixInfo.alternativeProperties && prefixInfo.alternativeProperties[property]) {
	    possiblePropertyNames = possiblePropertyNames.concat(prefixInfo.alternativeProperties[property]);
	  }
	
	  var workingProperty = arrayFind(possiblePropertyNames, function (possiblePropertyName) {
	    if (possiblePropertyName.js in domStyle) {
	      return possiblePropertyName;
	    }
	  }) || false;
	
	  return prefixedPropertyCache[property] = workingProperty;
	};
	
	// We are un-prefixing values before checking for isUnitlessNumber,
	// otherwise we are at risk of being in a situation where someone
	// explicitly passes something like `MozBoxFlex: 1` and that will
	// in turn get transformed into `MozBoxFlex: 1px`.
	var _getUnprefixedProperty = function _getUnprefixedProperty(property) {
	  var noPrefixProperty = property;
	
	  vendorPrefixes.some(function (prefix) {
	    // Let's check if the property starts with a vendor prefix
	    if (property.indexOf(prefix) === 0) {
	      noPrefixProperty = noPrefixProperty.replace(prefix, '');
	
	      // We have removed the vendor prefix, however the first
	      // character is going to be uppercase hence won't match
	      // any of the `isUnitlessNumber` keys as they all start
	      // with lower case. Let's ensure that the first char is
	      // lower case.
	      noPrefixProperty = noPrefixProperty.charAt(0).toLowerCase() + noPrefixProperty.slice(1);
	
	      return true;
	    }
	  });
	
	  return noPrefixProperty;
	};
	
	// React is planning to deprecate adding px automatically
	// (https://github.com/facebook/react/issues/1873), and if they do, this
	// should change to a warning or be removed in favor of React's warning.
	// Same goes for below.
	var _addPixelSuffixToValueIfNeeded = function _addPixelSuffixToValueIfNeeded(originalProperty, value) {
	  var unPrefixedProperty = _getUnprefixedProperty(originalProperty);
	
	  if (value !== 0 && !isNaN(value) && !isUnitlessNumber[unPrefixedProperty]) {
	    return value + 'px';
	  }
	  return value;
	};
	
	var _getPrefixedValue = function _getPrefixedValue(component, property, value, originalProperty) {
	  if (!Array.isArray(value)) {
	    // don't test numbers (pure or stringy), but do add 'px' prefix if needed
	    if (!isNaN(value) && value !== null) {
	      return _addPixelSuffixToValueIfNeeded(originalProperty, value);
	    }
	
	    if (typeof value !== 'string') {
	      if (value !== null && value !== undefined) {
	        value = value.toString();
	      } else {
	        return value;
	      }
	    }
	
	    // don't test numbers with units (e.g. 10em)
	    if (!isNaN(parseInt(value, 10))) {
	      return value;
	    }
	  }
	
	  var cacheKey = Array.isArray(value) ? value.join(' || ') : property + value;
	
	  if (prefixedValueCache.hasOwnProperty(cacheKey)) {
	    return prefixedValueCache[cacheKey];
	  }
	
	  var possibleValues;
	  if (Array.isArray(value)) {
	    // Add px for the same values React would, otherwise the testing below will
	    // fail and it will try to fallback.
	    possibleValues = value.map(function (v) {
	      return _addPixelSuffixToValueIfNeeded(originalProperty, v);
	    });
	
	    // Add prefixed versions
	    possibleValues = possibleValues.concat(value.filter(function (v) {
	      return !isNaN(v);
	    }) // Don't prefix numbers
	    .map(function (v) {
	      return prefixInfo.cssPrefix + v;
	    }));
	  } else {
	    possibleValues = [
	    // Unprefixed
	    value,
	    // Prefixed
	    prefixInfo.cssPrefix + value];
	  }
	
	  // Alternative values
	  if (prefixInfo.alternativeValues && prefixInfo.alternativeValues[originalProperty] && prefixInfo.alternativeValues[originalProperty][value]) {
	    possibleValues = possibleValues.concat(prefixInfo.alternativeValues[originalProperty][value]);
	  }
	
	  // Test possible value in order
	  var workingValue = arrayFind(possibleValues, function (possibleValue) {
	    domStyle[property] = '';
	    domStyle[property] = possibleValue;
	
	    // Note that we just make sure it is not an empty string. Browsers will
	    // sometimes rewrite values, but still accept them. They will set the value
	    // to an empty string if not supported.
	    // E.g. for border, "solid 1px black" becomes "1px solid black"
	    //      but "foobar" becomes "", since it is not supported.
	    return !!domStyle[property];
	  });
	
	  if (workingValue) {
	    prefixedValueCache[cacheKey] = workingValue;
	  } else {
	    // Unsupported, assume unprefixed works, but warn
	    prefixedValueCache[cacheKey] = value;
	
	    if (false) {
	      /* eslint-disable no-console */
	      if (console && console.warn) {
	        var componentContext = component ? ' in component "' + component.constructor.displayName + '"' : '';
	
	        console.warn('Unsupported CSS value "' + value + '" for property "' + property + '$"' + componentContext);
	      }
	      /* eslint-enable no-console */
	    }
	  }
	
	  return prefixedValueCache[cacheKey];
	};
	
	// Returns a new style object with vendor prefixes added to property names
	// and values.
	var getPrefixedStyle = function getPrefixedStyle(component, // ReactComponent
	style) {
	  var mode = arguments.length <= 2 || arguments[2] === undefined ? 'js' : arguments[2];
	
	  if (!ExecutionEnvironment.canUseDOM) {
	    return Object.keys(style).reduce(function (newStyle, key) {
	      var value = style[key];
	      var newKey = mode === 'css' ? _camelCaseToDashCase(key) : key;
	      var newValue = Array.isArray(value) ? value[0] : value;
	      newStyle[newKey] = newValue;
	      return newStyle;
	    }, {});
	  }
	
	  var prefixedStyle = {};
	  Object.keys(style).forEach(function (property) {
	    var value = style[property];
	
	    var newProperty = getPrefixedPropertyName(property);
	    if (newProperty === false) {
	      // Ignore unsupported properties
	      if (false) {
	        /* eslint-disable no-console */
	        if (console && console.warn) {
	          var componentContext = component ? ' in component "' + component.constructor.displayName + '"' : '';
	
	          console.warn('Unsupported CSS property "' + property + '$"' + componentContext);
	        }
	        /* eslint-enable no-console */
	        return;
	      }
	    }
	
	    var newValue = _getPrefixedValue(component, newProperty.js, value, property);
	
	    prefixedStyle[newProperty[mode]] = newValue;
	  });
	  return prefixedStyle;
	};
	
	module.exports = {
	  getPrefixedPropertyName: getPrefixedPropertyName,
	  getPrefixedStyle: getPrefixedStyle,
	  cssPrefix: prefixInfo.cssPrefix,
	  jsPrefix: prefixInfo.jsPrefix
	};

/***/ },
/* 555 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ },
/* 556 */
/***/ function(module, exports) {

	'use strict';
	
	function find(array, predicate, context) {
	  if (typeof Array.prototype.find === 'function') {
	    return array.find(predicate, context);
	  }
	
	  context = context || this;
	  var length = array.length;
	  var i;
	
	  if (typeof predicate !== 'function') {
	    throw new TypeError(predicate + ' is not a function');
	  }
	
	  for (i = 0; i < length; i++) {
	    if (predicate.call(context, array[i], i, array)) {
	      return array[i];
	    }
	  }
	}
	
	module.exports = find;


/***/ },
/* 557 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(555);
	
	var _matchMediaFunction = ExecutionEnvironment.canUseDOM && window && window.matchMedia && function (mediaQueryString) {
	  return window.matchMedia(mediaQueryString);
	};
	
	module.exports = {
	  canMatchMedia: function canMatchMedia() {
	    return typeof _matchMediaFunction === 'function';
	  },
	
	  matchMedia: function matchMedia(query) {
	    return _matchMediaFunction(query);
	  },
	
	  setMatchMedia: function setMatchMedia(nextMatchMediaFunction) {
	    _matchMediaFunction = nextMatchMediaFunction;
	  }
	};

/***/ },
/* 558 */
/***/ function(module, exports) {

	"use strict";
	
	var allPrintStyles = {};
	var listeners = [];
	
	var subscribe = function subscribe(listener) {
	  if (listeners.indexOf(listener) === -1) {
	    listeners.push(listener);
	  }
	
	  return {
	    remove: function remove() {
	      var listenerIndex = listeners.indexOf(listener);
	
	      if (listenerIndex > -1) {
	        listeners.splice(listenerIndex, 1);
	      }
	    }
	  };
	};
	
	var _emitChange = function _emitChange() {
	  listeners.forEach(function (listener) {
	    return listener();
	  });
	};
	
	var _appendImportantToEachValue = function _appendImportantToEachValue(styleObj) {
	  var importantStyleObj = {};
	
	  Object.keys(styleObj).forEach(function (key) {
	    var value = styleObj[key];
	
	    // This breaks unitless values but they'll be deprecated soon anyway
	    // https://github.com/facebook/react/issues/1873
	    value = value + " !important";
	    importantStyleObj[key] = value;
	  });
	
	  return importantStyleObj;
	};
	
	var addPrintStyles = function addPrintStyles(Component) {
	  if (!Component.printStyles) {
	    return;
	  }
	
	  var printStyleClass = {};
	
	  Object.keys(Component.printStyles).forEach(function (key) {
	    var styles = Component.printStyles[key];
	    var className = "Radium-" + Component.displayName + "-" + key;
	    allPrintStyles["." + className] = _appendImportantToEachValue(styles);
	    printStyleClass[key] = className;
	  });
	
	  // Allows for lazy loading of JS that then calls Radium to update the
	  // print styles
	  _emitChange();
	  return printStyleClass;
	};
	
	var getPrintStyles = function getPrintStyles() {
	  return allPrintStyles;
	};
	
	module.exports = {
	  addPrintStyles: addPrintStyles,
	  getPrintStyles: getPrintStyles,
	  subscribe: subscribe
	};

/***/ },
/* 559 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var createMarkupForStyles = __webpack_require__(560);
	var Prefixer = __webpack_require__(554);
	
	var React = __webpack_require__(40);
	
	var buildCssString = function buildCssString(component, selector, rules) {
	  if (!selector || !rules) {
	    return;
	  }
	
	  var prefixedRules = Prefixer.getPrefixedStyle(component, rules, 'css');
	  var serializedRules = createMarkupForStyles(prefixedRules);
	
	  return selector + '{' + serializedRules + '}';
	};
	
	var Style = React.createClass({
	  displayName: 'Style',
	
	  propTypes: {
	    rules: React.PropTypes.object,
	    scopeSelector: React.PropTypes.string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      scopeSelector: ''
	    };
	  },
	
	  _buildStyles: function _buildStyles(styles) {
	    var _this = this;
	
	    return Object.keys(styles).reduce(function (accumulator, selector) {
	      var rules = styles[selector];
	
	      if (selector === 'mediaQueries') {
	        accumulator += _this._buildMediaQueryString(rules);
	      } else {
	        var completeSelector = (_this.props.scopeSelector ? _this.props.scopeSelector + ' ' : '') + selector;
	        accumulator += buildCssString(_this, completeSelector, rules);
	      }
	
	      return accumulator;
	    }, '');
	  },
	
	  _buildMediaQueryString: function _buildMediaQueryString(mediaQueryObj) {
	    var _this2 = this;
	
	    var contextMediaQueries = this._getContextMediaQueries();
	    var mediaQueryString = '';
	
	    Object.keys(mediaQueryObj).forEach(function (query) {
	      var completeQuery = contextMediaQueries[query] ? contextMediaQueries[query] : query;
	      mediaQueryString += '@media ' + completeQuery + '{' + _this2._buildStyles(mediaQueryObj[query]) + '}';
	    });
	
	    return mediaQueryString;
	  },
	
	  _getContextMediaQueries: function _getContextMediaQueries() {
	    var contextMediaQueries = {};
	    if (this.context && this.context.mediaQueries) {
	      Object.keys(this.context.mediaQueries).forEach((function (query) {
	        contextMediaQueries[query] = this.context.mediaQueries[query].media;
	      }).bind(this));
	    }
	
	    return contextMediaQueries;
	  },
	
	  render: function render() {
	    if (!this.props.rules) {
	      return null;
	    }
	
	    var styles = this._buildStyles(this.props.rules);
	
	    return React.createElement('style', { dangerouslySetInnerHTML: { __html: styles } });
	  }
	});
	
	module.exports = Style;

/***/ },
/* 560 */
/***/ function(module, exports) {

	'use strict';
	
	var createMarkupForStyles = function createMarkupForStyles(style, spaces) {
	  spaces = spaces || '';
	  return Object.keys(style).map(function (property) {
	    return spaces + property + ': ' + style[property] + ';';
	  }).join('\n');
	};
	
	module.exports = createMarkupForStyles;

/***/ },
/* 561 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(40);
	
	var Style = __webpack_require__(559);
	var printStyles = __webpack_require__(558);
	
	var PrintStyle = React.createClass({
	  displayName: 'PrintStyle',
	
	  getInitialState: function getInitialState() {
	    return this._getStylesState();
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.subscription = printStyles.subscribe(this._onChange);
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    this.subscription.remove();
	  },
	
	  _onChange: function _onChange() {
	    this.setState(this._getStylesState());
	  },
	
	  _getStylesState: function _getStylesState() {
	    return {
	      styles: printStyles.getPrintStyles()
	    };
	  },
	
	  render: function render() {
	    return React.createElement(Style, { rules: {
	        mediaQueries: {
	          print: this.state.styles
	        }
	      } });
	  }
	});
	
	module.exports = PrintStyle;

/***/ },
/* 562 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var createMarkupForStyles = __webpack_require__(560);
	var Prefixer = __webpack_require__(554);
	
	var ExecutionEnvironment = __webpack_require__(555);
	
	var isAnimationSupported = ExecutionEnvironment.canUseDOM && Prefixer.getPrefixedPropertyName('animation') !== false;
	
	var animationIndex = 1;
	var animationStyleSheet = null;
	var keyframesPrefixed = 'keyframes';
	
	if (isAnimationSupported) {
	  animationStyleSheet = document.createElement('style');
	  document.head.appendChild(animationStyleSheet);
	
	  // Test if prefix needed for keyframes (copied from PrefixFree)
	  animationStyleSheet.textContent = '@keyframes {}';
	  if (!animationStyleSheet.sheet.cssRules.length) {
	    keyframesPrefixed = Prefixer.cssPrefix + 'keyframes';
	  }
	}
	
	// Simple animation helper that injects CSS into a style object containing the
	// keyframes, and returns a string with the generated animation name.
	var keyframes = function keyframes(keyframeRules, component) {
	  var name = 'Animation' + animationIndex;
	  animationIndex += 1;
	
	  if (!isAnimationSupported) {
	    return name;
	  }
	
	  var rule = '@' + keyframesPrefixed + ' ' + name + ' {\n' + Object.keys(keyframeRules).map(function (percentage) {
	    var props = keyframeRules[percentage];
	    var prefixedProps = Prefixer.getPrefixedStyle(component, props, 'css');
	    var serializedProps = createMarkupForStyles(prefixedProps, '  ');
	    return '  ' + percentage + ' {\n  ' + serializedProps + '\n  }';
	  }).join('\n') + '\n}\n';
	
	  // for flow
	  /* istanbul ignore next */
	  if (!animationStyleSheet) {
	    throw new Error('keyframes not initialized properly');
	  }
	
	  animationStyleSheet.sheet.insertRule(rule, animationStyleSheet.sheet.cssRules.length);
	  return name;
	};
	
	module.exports = keyframes;

/***/ },
/* 563 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var colors = {
	  whiteColour: "#ffffff",
	  offWhiteColour: "#f6f7f9",
	  darkOffWhiteColour: "#d8d8d8",
	  orangeColour: "#ed5434",
	  lightOrangeColour: "#ff6f51",
	  slateColour: "#2a2730",
	  lightSlateColour: "#3e3f48",
	  darkGreyColour: "#50575f",
	  lightGreyColour: "#9aa2ab",
	  vLightGreyColour: "#cdcdd1",
	  errorColour: "#d80033",
	  greenBackgroundColour: "#daebea",
	  goldBackgroundColour: "#f8f6f1"
	};
	
	exports.colors = colors;
	var fonts = {
	  tiempos: '"Tiempos-Text", "Times", serif',
	  akkurat: '"Akkurat", "Arial", sans-serif'
	};
	
	exports.fonts = fonts;
	var typography = {
	  constants: {
	    baseLineHeight: 24,
	    smallVerticalSpacing: 12,
	    smallHorizontalSpacing: 19.4,
	    baseTypeUnit: 8
	  },
	  h1: {
	    fontFamily: fonts.tiempos,
	    fontSize: 37,
	    lineHeight: 42 / 37
	  },
	  h2: {
	    fontFamily: fonts.tiempos,
	    fontSize: 26,
	    lineHeight: 34 / 26
	  },
	  h3: {
	    fontFamily: fonts.tiempos,
	    fontSize: 20,
	    lineHeight: 27 / 20
	  },
	  h4: {
	    fontFamily: fonts.tiempos,
	    fontSize: 17,
	    lineHeight: 22 / 17
	  },
	  h5: {
	    fontFamily: fonts.akkurat,
	    fontSize: 14,
	    fontWieght: 'bold'
	  },
	  body: {
	    fontFamily: fonts.akkurat,
	    fontSize: 14,
	    lineHeight: 21 / 14
	  },
	  small: {
	    fontFamily: fonts.akkurat,
	    fontSize: 14,
	    lineHeight: 21 / 14
	  },
	  prompt: {
	    fontFamily: fonts.akkurat,
	    fontSize: 13,
	    lineHeight: 18 / 13
	  },
	
	  xSmall: {
	    fontFamily: fonts.akkurat,
	    fontSize: 12,
	    lineHeight: 16 / 12
	  }
	};
	
	exports.typography = typography;
	var magicNumbers = {
	  constants: {
	    phi: 1.61803398874989
	  },
	  homeListings: {
	    gutterWidth: 48,
	    columnWidth: 38
	  }
	};
	
	exports.magicNumbers = magicNumbers;
	var layout = {
	  constants: {
	    baseLineHeight: 24,
	    smallVerticalSpacing: 12
	  },
	  homeListings: {
	    content: {
	      marginRight: 'calc((100% / 3) + (100% * 0.025))'
	    }
	  }
	};
	exports.layout = layout;

/***/ },
/* 564 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	var _reactAddons = __webpack_require__(40);
	
	var _reactAddons2 = _interopRequireDefault(_reactAddons);
	
	var _ofsReactMixins = __webpack_require__(515);
	
	var _ofsReactMixins2 = _interopRequireDefault(_ofsReactMixins);
	
	var _ofsI18n = __webpack_require__(61);
	
	var _ofsReactFieldsTextfield = __webpack_require__(514);
	
	var _ofsReactFieldsTextfield2 = _interopRequireDefault(_ofsReactFieldsTextfield);
	
	var _modelsGuest = __webpack_require__(539);
	
	var _modelsGuest2 = _interopRequireDefault(_modelsGuest);
	
	var _ofsReactFieldsSelectfield = __webpack_require__(518);
	
	var _ofsReactFieldsSelectfield2 = _interopRequireDefault(_ofsReactFieldsSelectfield);
	
	var _ofsFormsLayoutRow = __webpack_require__(226);
	
	var _ofsFormsLayoutRow2 = _interopRequireDefault(_ofsFormsLayoutRow);
	
	var _ofsFormsLayoutColumn = __webpack_require__(227);
	
	var _ofsFormsLayoutColumn2 = _interopRequireDefault(_ofsFormsLayoutColumn);
	
	var _ofsAppsBookingsPrestayViewsPrestayContentSection = __webpack_require__(512);
	
	var _ofsAppsBookingsPrestayViewsPrestayContentSection2 = _interopRequireDefault(_ofsAppsBookingsPrestayViewsPrestayContentSection);
	
	var messages = {
	  CHANGE: (0, _ofsI18n.gettext)('Change'),
	  SAVE: (0, _ofsI18n.gettext)('Submit'),
	  REMOVE_GUEST: (0, _ofsI18n.gettext)('Remove guest'),
	  LEAD_GUEST: (0, _ofsI18n.gettext)('Lead Guest'),
	  ADULT: (0, _ofsI18n.gettext)('Adult'),
	  ADD_GUEST: (0, _ofsI18n.gettext)('Add another guest'),
	  GUEST_N: (0, _ofsI18n.gettext)('Guest %s'),
	  FIRST_NAME: (0, _ofsI18n.gettext)('First name'),
	  LAST_NAME: (0, _ofsI18n.gettext)('Last name'),
	  AGE: (0, _ofsI18n.gettext)('Age'),
	  SLEEPS_ONLY: (0, _ofsI18n.gettext)('This home only sleeps %s people. Please contact our reservations team on %s or %s if you want to add more.'),
	  HEADING: (0, _ofsI18n.gettext)('Additional guests'),
	  ADDITONAL_GUEST_PROMPT: (0, _ofsI18n.gettext)("To help us get things shipshape for your arrival, please fill in the names and ages of everyone who'll be staying.")
	};
	
	module.exports = function (config) {
	  var AdditionalGuests = _reactAddons2['default'].createClass({
	    displayName: 'AdditionalGuests',
	
	    mixins: [_ofsReactMixins2['default'].BackboneChangeMixin],
	
	    getInitialState: function getInitialState() {
	      return {
	        isValid: false
	      };
	    },
	
	    handleClick: function handleClick() {
	      // Add new guest
	      this.props.collection.add(new _modelsGuest2['default']());
	    },
	
	    render: function render() {
	      var guests = this.props.collection;
	      var payload = JSON.stringify(guests.toJSON());
	
	      var guestNodes = guests.map(function (model, index) {
	        return _reactAddons2['default'].createElement(Guest, { model: model, collection: guests, index: index + 2, key: model.cid });
	      });
	
	      var maximum = guests.length + 1 >= config.sleepsMax;
	
	      return _reactAddons2['default'].createElement(
	        _ofsAppsBookingsPrestayViewsPrestayContentSection2['default'],
	        { title: messages.HEADING },
	        _reactAddons2['default'].createElement(
	          'p',
	          { className: 'ofs-Prestay__ContentIntro' },
	          messages.ADDITONAL_GUEST_PROMPT
	        ),
	        _reactAddons2['default'].createElement(
	          'table',
	          { className: 'ofs-AdditionalGuests' },
	          _reactAddons2['default'].createElement(
	            'tbody',
	            null,
	            guestNodes
	          )
	        ),
	        maximum ? _reactAddons2['default'].createElement(MaximumGuests, { number: config.sleepsMax }) : _reactAddons2['default'].createElement(
	          'p',
	          { className: 'u-no-margin' },
	          _reactAddons2['default'].createElement(
	            'a',
	            { onClick: this.handleClick },
	            messages.ADD_GUEST
	          )
	        ),
	        _reactAddons2['default'].createElement('input', { type: 'hidden', value: payload, name: 'additional_guests' })
	      );
	    }
	  });
	
	  var Guest = _reactAddons2['default'].createClass({
	    displayName: 'Guest',
	
	    getInitialState: function getInitialState() {
	      var errors = this.props.model.validate() || {};
	      return {
	        errors: errors,
	        editedFields: {}
	      };
	    },
	
	    handleRemoveClick: function handleRemoveClick() {
	      // remove guest
	      this.props.collection.remove(this.props.model);
	    },
	
	    handleFormChange: function handleFormChange(fieldName) {
	      this.state.editedFields[fieldName] = true;
	      this.setState({ editedFields: this.state.editedFields });
	
	      this.validate();
	    },
	
	    validate: function validate() {
	      this.setState({
	        errors: this.props.model.validate() || {}
	      });
	    },
	
	    handleLifeStageChange: function handleLifeStageChange(event) {
	      this.props.model.set('life_stage', event.target.value);
	    },
	
	    render: function render() {
	      var model = this.props.model;
	
	      var changeListener = {};
	      var errors = model.validate() || {};
	      var self = this;
	      ["first_name", "last_name", "life_stage"].forEach(function (fieldName) {
	        changeListener[fieldName] = self.handleFormChange.bind(null, fieldName);
	        errors[fieldName] = self.state.editedFields[fieldName] && self.state.errors[fieldName];
	      });
	
	      var lifeStagesOptions = config.lifeStages.map(function (stage) {
	        return { value: stage[0], name: stage[1] };
	      });
	
	      return _reactAddons2['default'].createElement(
	        'tr',
	        { className: 'ofs-AdditionalGuests__GuestRow' },
	        _reactAddons2['default'].createElement(
	          'td',
	          { className: 'ofs-AdditionalGuests__Cell ofs-AdditionalGuests__Cell--icon' },
	          _reactAddons2['default'].createElement('span', { className: 'icon-profile ofs-Prestay__HeadIcon ofs-Prestay__HeadIcon--unselectable' })
	        ),
	        _reactAddons2['default'].createElement(
	          'td',
	          { className: 'ofs-AdditionalGuests__Cell' },
	          _reactAddons2['default'].createElement(
	            _ofsFormsLayoutRow2['default'],
	            null,
	            _reactAddons2['default'].createElement(
	              _ofsFormsLayoutColumn2['default'],
	              { size: 'third' },
	              _reactAddons2['default'].createElement(
	                'div',
	                { className: 'ofs-Form__Field' },
	                _reactAddons2['default'].createElement(
	                  'label',
	                  { className: 'ofs-Form__Label' },
	                  messages.FIRST_NAME
	                ),
	                _reactAddons2['default'].createElement(_ofsReactFieldsTextfield2['default'], { type: 'text', field: 'first_name', placeholder: messages.FIRST_NAME, model: model, onChange: changeListener["first_name"], onBlur: changeListener["first_name"], error: errors["first_name"] })
	              )
	            ),
	            _reactAddons2['default'].createElement(
	              _ofsFormsLayoutColumn2['default'],
	              { size: 'third' },
	              _reactAddons2['default'].createElement(
	                'div',
	                { className: 'ofs-Form__Field' },
	                _reactAddons2['default'].createElement(
	                  'label',
	                  { className: 'ofs-Form__Label' },
	                  messages.LAST_NAME
	                ),
	                _reactAddons2['default'].createElement(_ofsReactFieldsTextfield2['default'], { type: 'text', field: 'last_name', placeholder: messages.LAST_NAME, model: model, onChange: changeListener["last_name"], onBlur: changeListener["last_name"], error: errors["last_name"] })
	              )
	            ),
	            _reactAddons2['default'].createElement(
	              _ofsFormsLayoutColumn2['default'],
	              { size: 'third' },
	              _reactAddons2['default'].createElement(_ofsReactFieldsSelectfield2['default'], { label: messages.AGE, options: lifeStagesOptions, model: model, field: 'life_stage', onChange: this.handleLifeStageChange, onBlur: changeListener["life_stage"], error: errors["life_stage"], defaultValue: model.get("life_stage") || null, placeholder: 'Select age' })
	            )
	          )
	        ),
	        _reactAddons2['default'].createElement(
	          'td',
	          { className: 'ofs-AdditionalGuests__Cell ofs-AdditionalGuests__Cell--removeLink' },
	          _reactAddons2['default'].createElement(
	            'a',
	            { onClick: this.handleRemoveClick, title: 'Remove guest' },
	            messages.REMOVE_GUEST
	          )
	        )
	      );
	    }
	  });
	
	  var MaximumGuests = _reactAddons2['default'].createClass({
	    displayName: 'MaximumGuests',
	
	    render: function render() {
	      return _reactAddons2['default'].createElement(
	        'p',
	        null,
	        (0, _ofsI18n.interpolate)(messages.SLEEPS_ONLY, [this.props.number, config.guestServicesEmail, config.guestServicesPhone])
	      );
	    }
	  });
	
	  return AdditionalGuests;
	};

/***/ },
/* 565 */,
/* 566 */,
/* 567 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(40);
	
	var _react2 = _interopRequireDefault(_react);
	
	var CheckoutTerms = _react2['default'].createClass({
	  displayName: 'CheckoutTerms',
	
	  render: function render() {
	    return _react2['default'].createElement('div', { className: 'terms-content', dangerouslySetInnerHTML: { __html: this.props.children } });
	  }
	});
	
	exports['default'] = CheckoutTerms;
	module.exports = exports['default'];

/***/ },
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */
/***/ function(module, exports, __webpack_require__) {

	/* jshint camelcase:false */
	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = navigation;
	
	var _jquery = __webpack_require__(39);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function checkNavScroll(navbar, navtop) {
	  if ((0, _jquery2['default'])(window).scrollTop() > navtop) {
	    navbar.addClass('ofs-PageNav--is-floating');
	  } else {
	    navbar.removeClass('ofs-PageNav--is-floating');
	  }
	}
	
	function setNavSpacerHeight(pagenav, pagenavspace) {
	  pagenavspace.css('height', pagenav.height() + 'px');
	}
	
	function navigation() {
	  // Set the container or the navbar to be same height as navbar as when
	  // we make it static we don't want the page size to change as it will
	  // mess up smooth scrolling
	  var $pageNav = (0, _jquery2['default'])('#page_navigation');
	  var $pageNavSpace = (0, _jquery2['default'])('#page_navigation_spacer');
	
	  setNavSpacerHeight($pageNav, $pageNavSpace);
	  (0, _jquery2['default'])(window).resize(function () {
	    setNavSpacerHeight($pageNav, $pageNavSpace);
	  });
	
	  // When window scrolls (or page loads) decide whether to make the
	  // navbar fixed or static
	  var navbar = (0, _jquery2['default'])('#page_navigation_container');
	  var navtop = navbar.offset().top;
	
	  checkNavScroll(navbar, navtop);
	  (0, _jquery2['default'])(window).scroll(function () {
	    checkNavScroll(navbar, navtop);
	  });
	
	  // Set correct background for selected element in navbar
	  (0, _jquery2['default'])('#page_navigation li a').click(function (e) {
	    var el = (0, _jquery2['default'])(e.target);
	    window.setTimeout(function () {
	      el.parent().parent().find('a').removeClass('ofs-PageNav__Link--selected');
	      el.addClass('ofs-PageNav__Link--selected');
	    }, 600);
	  });
	
	  // Smooth scroll to the internal links, leaving 50px space above header so the
	  // navbar doesn't cover the titles or other content
	  (0, _jquery2['default'])('#page_navigation a[href^="#"]').click(function (event) {
	    event.preventDefault();
	    var dest = 0;
	    if ((0, _jquery2['default'])(this.hash).offset().top > (0, _jquery2['default'])(document).height() - (0, _jquery2['default'])(window).height()) {
	      dest = (0, _jquery2['default'])(document).height() - (0, _jquery2['default'])(window).height();
	    } else {
	      dest = (0, _jquery2['default'])(this.hash).offset().top - $pageNav.height() - 50;
	    }
	    (0, _jquery2['default'])('html, body').animate({ scrollTop: dest }, 500, 'swing');
	  });
	
	  (0, _jquery2['default'])('#page_navigation li a[href^="#"]').each(function () {
	    var link = this.href;
	    link = link.split('#')[1];
	    (0, _jquery2['default'])('#' + link).waypoint(function () {
	      (0, _jquery2['default'])('#page_navigation').find('a').removeClass('ofs-PageNav__Link--selected');
	      (0, _jquery2['default'])('#page_navigation').find('a[href^="#' + link + '"]').addClass('ofs-PageNav__Link--selected');
	    }, { offset: 70 });
	  });
	}
	
	module.exports = exports['default'];

/***/ },
/* 582 */,
/* 583 */
/***/ function(module, exports, __webpack_require__) {

	/* eslint-disable react/no-did-mount-set-state */
	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _reactAddons = __webpack_require__(40);
	
	var _reactAddons2 = _interopRequireDefault(_reactAddons);
	
	var _classnames = __webpack_require__(49);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ofsI18n = __webpack_require__(61);
	
	var _ofsI18n2 = _interopRequireDefault(_ofsI18n);
	
	function noop() {}
	
	var gettext = _ofsI18n2['default'].gettext;
	
	var MESSAGES = {
	  PRICE_PER_NIGHT: gettext('Price per night'),
	  CHOOSE_LOCATION: gettext('Choose a location to enable filtering by price')
	};
	
	/**
	 * get {clientX, clientY} positions of control
	 * Credit: https://github.com/mzabriskie/react-draggable/blob/fcef772698cc7198fc345cea3c5c52deb1544188/lib/draggable.js#L88-L97
	 */
	function getControlPosition(event) {
	  var position = event.touches && event.touches[0] || event;
	  return {
	    clientX: position.clientX,
	    clientY: position.clientY
	  };
	}
	
	var RangeHandle = _reactAddons2['default'].createClass({
	  displayName: 'RangeHandle',
	
	  propTypes: {
	    value: _reactAddons2['default'].PropTypes.number.isRequired, // percent
	    rangeWidth: _reactAddons2['default'].PropTypes.number.isRequired, // size of progress bar
	    disabled: _reactAddons2['default'].PropTypes.bool,
	    onMove: _reactAddons2['default'].PropTypes.func.isRequired,
	    onMoveFinish: _reactAddons2['default'].PropTypes.func.isRequired
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      isDragging: false,
	      dragInitialValue: null,
	      dragOrigin: null
	    };
	  },
	
	  onHandleStart: function onHandleStart(event) {
	    if (this.props.disabled) {
	      return false;
	    }
	
	    var dragPoint = getControlPosition(event);
	
	    this.setState({
	      isDragging: true,
	      dragInitialValue: this.props.value,
	      dragOrigin: dragPoint.clientX
	    });
	
	    document.addEventListener('mousemove', this.onHandleMove);
	    document.addEventListener('mouseup', this.onHandleEnd);
	
	    // touch events
	    document.addEventListener('touchmove', this.onHandleMove);
	    document.addEventListener('touchend', this.onHandleEnd);
	  },
	
	  onHandleMove: function onHandleMove(event) {
	    var rangeWidth = this.props.rangeWidth;
	    var _state = this.state;
	    var dragInitialValue = _state.dragInitialValue;
	    var dragOrigin = _state.dragOrigin;
	
	    var dragPoint = getControlPosition(event);
	
	    var delta = dragPoint.clientX - dragOrigin;
	    var dx = 100 * delta / rangeWidth;
	    var nextValue = dragInitialValue + dx;
	
	    this.props.onMove(nextValue);
	  },
	
	  onHandleEnd: function onHandleEnd(event) {
	    event.preventDefault();
	    event.stopPropagation();
	
	    this.setState({
	      isDragging: false,
	      dragInitialValue: null,
	      dragOrigin: null
	    });
	
	    document.removeEventListener('mousemove', this.onHandleMove);
	    document.removeEventListener('mouseup', this.onHandleEnd);
	
	    // touch events
	    document.removeEventListener('touchmove', this.onHandleMove);
	    document.removeEventListener('touchend', this.onHandleEnd);
	
	    this.props.onMoveFinish(event);
	  },
	
	  render: function render() {
	    var value = this.props.value;
	    var isDragging = this.state.isDragging;
	
	    var handleStyles = {
	      left: value + '%'
	    };
	
	    var handleClasses = {
	      'ofs-RangeSlider__Handle': true,
	      'ofs-RangeSlider__Handle--is-selected': isDragging
	    };
	
	    return _reactAddons2['default'].createElement(
	      'div',
	      { className: 'ofs-RangeSlider__HandleWrapper',
	        style: handleStyles,
	        onClick: this.stopPropagation,
	        onMouseDown: this.onHandleStart,
	        onTouchStart: this.onHandleStart },
	      _reactAddons2['default'].createElement('div', { className: (0, _classnames2['default'])(handleClasses) })
	    );
	  }
	});
	
	var PriceSlider = _reactAddons2['default'].createClass({
	  displayName: 'PriceSlider',
	
	  propTypes: {
	    limits: _reactAddons2['default'].PropTypes.array.isRequired, // array of 2 values
	    values: _reactAddons2['default'].PropTypes.array.isRequired,
	    inputNames: _reactAddons2['default'].PropTypes.array.isRequired,
	    currencyCode: _reactAddons2['default'].PropTypes.string.isRequired,
	    disabled: _reactAddons2['default'].PropTypes.bool,
	    step: _reactAddons2['default'].PropTypes.number, // amount to step each change by
	    onChange: _reactAddons2['default'].PropTypes.func
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      step: 1,
	      onChange: noop
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      dragging: false,
	      selectedValues: [],
	      rangeWidth: 0
	    };
	  },
	
	  getMinValue: function getMinValue() {
	    var values = this.props.values;
	    var _state2 = this.state;
	    var dragging = _state2.dragging;
	    var selectedValues = _state2.selectedValues;
	
	    if (dragging) {
	      return selectedValues[0] || values[0];
	    }
	    return values[0];
	  },
	
	  getMaxValue: function getMaxValue() {
	    var values = this.props.values;
	    var _state3 = this.state;
	    var dragging = _state3.dragging;
	    var selectedValues = _state3.selectedValues;
	
	    if (dragging) {
	      return selectedValues[1] || values[1];
	    }
	    return values[1];
	  },
	
	  // nextValue is a normalized value
	  handleMinValueChange: function handleMinValueChange(nextValue) {
	    var _props = this.props;
	    var limits = _props.limits;
	    var values = _props.values;
	    var step = _props.step;
	
	    // un normalize value
	    var actualValue = Math.round(nextValue / 100 * limits[1] + limits[0]);
	
	    var nextActualValue = Math.round(actualValue / step) * step;
	
	    var selectedValues = this.state.selectedValues.slice(0);
	
	    var maxValue = selectedValues[1] || values[1];
	    if (actualValue < maxValue) {
	      selectedValues[0] = nextActualValue;
	      this.setState({ dragging: true, selectedValues: selectedValues });
	    }
	  },
	
	  handleMaxValueChange: function handleMaxValueChange(nextValue) {
	    var _props2 = this.props;
	    var limits = _props2.limits;
	    var values = _props2.values;
	    var step = _props2.step;
	    var selectedValues = this.state.selectedValues;
	
	    // un normalize value
	    var actualValue = Math.round(nextValue / 100 * limits[1]);
	
	    var nextActualValue = Math.round(actualValue / step) * step;
	
	    // copy selectedValues
	    selectedValues = selectedValues.slice(0);
	
	    var minValue = selectedValues[0] || values[0];
	
	    if (actualValue > minValue) {
	      selectedValues[1] = nextActualValue;
	      this.setState({ dragging: true, selectedValues: selectedValues });
	    }
	  },
	
	  handleChange: function handleChange() {
	    var _props3 = this.props;
	    var values = _props3.values;
	    var inputNames = _props3.inputNames;
	    var limits = _props3.limits;
	    var selectedValues = this.state.selectedValues;
	
	    var minValue = Math.max(selectedValues[0] || values[0], limits[0]);
	    var maxValue = Math.min(selectedValues[1] || values[1], limits[1]);
	
	    var newValues = {};
	    newValues[inputNames[0]] = minValue;
	    newValues[inputNames[1]] = maxValue;
	
	    this.setState({
	      dragging: true
	    });
	
	    this.props.onChange(newValues);
	  },
	
	  componentDidMount: function componentDidMount() {
	    var el = this.refs['range-line'].getDOMNode();
	    var rect = el.getBoundingClientRect();
	
	    this.setState({
	      'rangeWidth': rect.width
	    });
	  },
	
	  render: function render() {
	    var _props4 = this.props;
	    var limits = _props4.limits;
	    var inputNames = _props4.inputNames;
	    var currencyCode = _props4.currencyCode;
	    var disabled = _props4.disabled;
	    var rangeWidth = this.state.rangeWidth;
	
	    var minValue = Math.max(this.getMinValue(), limits[0]);
	    var maxValue = Math.min(this.getMaxValue(), limits[1]);
	
	    var normalizedMin = (minValue - limits[0]) / limits[1] * 100;
	    var normalizedMax = maxValue / limits[1] * 100;
	
	    return _reactAddons2['default'].createElement(
	      'div',
	      { className: 'ofs-Form__Field' },
	      disabled ? _reactAddons2['default'].createElement(
	        'p',
	        { className: 'ofs-Form__HelpText ofs-Form__HelpText--above' },
	        MESSAGES['CHOOSE_LOCATION']
	      ) : null,
	      _reactAddons2['default'].createElement(
	        'div',
	        { className: 'ofs-PriceSlider' },
	        disabled ? _reactAddons2['default'].createElement('div', { className: 'ofs-PriceSlider__DisableCover' }) : null,
	        _reactAddons2['default'].createElement(
	          'label',
	          { className: 'ofs-Form__Label' },
	          MESSAGES['PRICE_PER_NIGHT'],
	          _reactAddons2['default'].createElement(
	            'div',
	            { className: 'ofs-Form__Label--right' },
	            currencyCode,
	            minValue,
	            ' – ',
	            currencyCode,
	            maxValue,
	            maxValue === limits[1] ? "+" : null
	          )
	        ),
	        _reactAddons2['default'].createElement(
	          'div',
	          { className: 'ofs-RangeSlider', onClick: this.onProgressBarClick },
	          _reactAddons2['default'].createElement(
	            'div',
	            { className: 'ofs-RangeSlider__RangeLine', ref: 'range-line' },
	            _reactAddons2['default'].createElement('div', { className: 'ofs-RangeSlider__RangeFill', style: {
	                left: normalizedMin + '%',
	                right: 100 - normalizedMax + '%'
	              } })
	          ),
	          _reactAddons2['default'].createElement(RangeHandle, { value: normalizedMin, rangeWidth: rangeWidth,
	            disabled: disabled, onMove: this.handleMinValueChange,
	            onMoveFinish: this.handleChange }),
	          _reactAddons2['default'].createElement(RangeHandle, { value: normalizedMax, rangeWidth: rangeWidth,
	            disabled: disabled, onMove: this.handleMaxValueChange,
	            onMoveFinish: this.handleChange })
	        ),
	        _reactAddons2['default'].createElement(
	          'div',
	          { className: 'ofs-RangeSlider__Labels' },
	          _reactAddons2['default'].createElement(
	            'div',
	            { className: 'u-pull-left' },
	            currencyCode,
	            limits[0]
	          ),
	          _reactAddons2['default'].createElement(
	            'div',
	            { className: 'u-pull-right' },
	            currencyCode,
	            limits[1],
	            '+'
	          )
	        ),
	        _reactAddons2['default'].createElement('input', { type: 'hidden', name: inputNames[0], value: minValue }),
	        _reactAddons2['default'].createElement('input', { type: 'hidden', name: inputNames[1], value: maxValue })
	      )
	    );
	  }
	});
	
	exports['default'] = PriceSlider;
	module.exports = exports['default'];

/***/ },
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _underscore = __webpack_require__(66);
	
	var React = __webpack_require__(40);
	var Constants = __webpack_require__(336);
	var Fluxxor = __webpack_require__(69);
	
	var $ = __webpack_require__(39);
	
	var SimilarHomesStore = Fluxxor.createStore({
	  actions: {
	    SIMILAR_HOMES_LOAD: 'loadHomes',
	    SIMILAR_HOMES_UPDATE: 'updateHomes'
	  },
	
	  memoizedAjax: (0, _underscore.memoize)($.ajax, JSON.stringify),
	
	  initialize: function initialize(options) {
	    this.setMaxListeners(0);
	    this.state = (0, _underscore.clone)(options);
	    this.state.loaded = false;
	    this.state.homes = [];
	  },
	
	  updateHomes: function updateHomes(payload) {
	    var json = payload.json;
	
	    this.state = React.addons.update(this.state, {
	      homes: { $set: json.units },
	      loaded: { $set: true }
	    });
	    this.emit('change');
	  },
	
	  loadHomes: function loadHomes() {
	    // Memoizing the request factory to workaround behaviour of "HomesList.jsx"
	    // which calls `loadHomes` on mount (fires on resize). Eventually will move
	    // "loadHomes" call out mount but not yet because 3 legacy components also
	    // use "HomesList.jsx". To fix once the legacy components are deleted.
	    this.memoizedAjax({
	      type: 'GET',
	      dataType: 'json',
	      url: this.state.url,
	      cache: false,
	      success: this.flux.actions.similarHomes.update
	    });
	  },
	
	  getState: function getState() {
	    return this.state;
	  }
	});
	
	module.exports = SimilarHomesStore;

/***/ },
/* 588 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	var _reactAddons = __webpack_require__(40);
	
	var _reactAddons2 = _interopRequireDefault(_reactAddons);
	
	var _fluxxor = __webpack_require__(69);
	
	var _ofsComponentsCommonIcon = __webpack_require__(51);
	
	var _ofsComponentsCommonIcon2 = _interopRequireDefault(_ofsComponentsCommonIcon);
	
	var _ofsI18n = __webpack_require__(61);
	
	var _ofsI18n2 = _interopRequireDefault(_ofsI18n);
	
	var _HomesListItem = __webpack_require__(589);
	
	var _HomesListItem2 = _interopRequireDefault(_HomesListItem);
	
	var gettext = _ofsI18n2['default'].gettext;
	var interpolate = _ofsI18n2['default'].interpolate;
	
	var messages = {
	  LOADING: gettext("Loading ..."),
	  SHOW_FEWER: gettext("Show fewer homes"),
	  SHOW_MORE: gettext('Show %(count)s more homes')
	};
	
	var HomesList = _reactAddons2['default'].createClass({
	  displayName: 'HomesList',
	
	  messages: messages,
	
	  mixins: [_reactAddons2['default'].addons.PureRenderMixin, (0, _fluxxor.FluxMixin)(_reactAddons2['default']), (0, _fluxxor.StoreWatchMixin)('SimilarHomes')],
	
	  getStateFromFlux: function getStateFromFlux() {
	    return this.getFlux().store('SimilarHomes').getState();
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      expanded: false,
	      rowSize: 4
	    };
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.getFlux().actions.similarHomes.load();
	    window.addEventListener('resize', this.updateRowSize);
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    this.updateRowSize();
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    window.removeEventListener('resize', this.updateRowSize);
	  },
	
	  handleClick: function handleClick(event) {
	    event.preventDefault();
	    this.setState({
	      expanded: !this.state.expanded
	    });
	  },
	
	  updateRowSize: function updateRowSize() {
	    var component = _reactAddons2['default'].findDOMNode(this);
	    var width = component.offsetWidth;
	    var liWidth = component.getElementsByTagName('li')[0].offsetWidth;
	    this.setState({
	      rowSize: Math.floor(width / liWidth)
	    });
	  },
	
	  render: function render() {
	    var _state = this.state;
	    var homes = _state.homes;
	    var rowSize = _state.rowSize;
	    var expanded = _state.expanded;
	    var loaded = _state.loaded;
	
	    var label;
	    var icon;
	    var homesSlice = homes;
	    var loadingLabel = messages.LOADING;
	
	    if (!expanded) {
	      homesSlice = homes.slice(0, rowSize);
	    }
	
	    var remainder = homes.length - homesSlice.length;
	    var visibleHomes = homesSlice.map(function (home) {
	      home.key = home.url;
	      return _reactAddons2['default'].createElement(_HomesListItem2['default'], home);
	    });
	
	    if (expanded) {
	      icon = _reactAddons2['default'].createElement(_ofsComponentsCommonIcon2['default'], { glyph: 'arrow', size: 'small', variant: 'up' });
	      label = messages.SHOW_FEWER;
	    } else {
	      icon = _reactAddons2['default'].createElement(_ofsComponentsCommonIcon2['default'], { glyph: 'arrow', size: 'small', variant: 'right' });
	      label = interpolate(messages.SHOW_MORE, { count: remainder }, true);
	    }
	
	    return _reactAddons2['default'].createElement(
	      'div',
	      { className: 'ofs-HomesList' },
	      loaded ? _reactAddons2['default'].createElement(
	        'ul',
	        { className: 'ofs-List ofs-List--horizontal' },
	        visibleHomes
	      ) : { loadingLabel: loadingLabel },
	      loaded && (expanded || remainder > 0) ? _reactAddons2['default'].createElement(
	        'div',
	        { className: 'ofs-HomesList__Toggler' },
	        _reactAddons2['default'].createElement(
	          'a',
	          { ref: 'callToAction', onClick: this.handleClick, href: '#', className: 'ofs-Link' },
	          icon,
	          ' ',
	          label
	        )
	      ) : null
	    );
	  }
	});
	
	module.exports = HomesList;

/***/ },
/* 589 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(54)['default'];
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _reactAddons = __webpack_require__(40);
	
	var _reactAddons2 = _interopRequireDefault(_reactAddons);
	
	var _ofsI18n = __webpack_require__(61);
	
	var _ofsI18n2 = _interopRequireDefault(_ofsI18n);
	
	var _ofsComponentsCommonImage = __webpack_require__(590);
	
	var _ofsComponentsCommonImage2 = _interopRequireDefault(_ofsComponentsCommonImage);
	
	var _ofsComponentsResponsiveImage = __webpack_require__(591);
	
	var _ofsComponentsResponsiveImage2 = _interopRequireDefault(_ofsComponentsResponsiveImage);
	
	var gettext = _ofsI18n2['default'].gettext;
	var interpolate = _ofsI18n2['default'].interpolate;
	
	var messages = {
	  PER_NIGHT: gettext('from %(price)s/night')
	};
	
	var HomeListItem = _reactAddons2['default'].createClass({
	  displayName: 'HomeListItem',
	
	  render: function render() {
	    var _props = this.props;
	    var url = _props.url;
	    var image = _props.image;
	    var price = _props.price;
	    var title = _props.title;
	
	    var priceLabel = interpolate(messages.PER_NIGHT, { price: price }, true);
	
	    return _reactAddons2['default'].createElement(
	      'li',
	      { className: 'ofs-HomesList__Item' },
	      _reactAddons2['default'].createElement(
	        'a',
	        { href: url },
	        _reactAddons2['default'].createElement(_ofsComponentsResponsiveImage2['default'], _extends({ defaultWidth: 240 }, image))
	      ),
	      _reactAddons2['default'].createElement(
	        'h5',
	        { className: 'ofs-HomesList__Title' },
	        _reactAddons2['default'].createElement(
	          'a',
	          { href: url },
	          title
	        )
	      ),
	      _reactAddons2['default'].createElement(
	        'span',
	        { className: 'ofs-HomesList__Price' },
	        _reactAddons2['default'].createElement('span', { dangerouslySetInnerHTML: { __html: priceLabel } })
	      )
	    );
	  }
	});
	
	exports['default'] = HomeListItem;
	module.exports = exports['default'];

/***/ },
/* 590 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _objectWithoutProperties = __webpack_require__(53)['default'];
	
	var _extends = __webpack_require__(54)['default'];
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(40);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(49);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var PureRenderMixin = _react2['default'].addons.PureRenderMixin;
	
	var Image = _react2['default'].createClass({
	  displayName: 'Image',
	
	  mixins: [PureRenderMixin],
	
	  propTypes: {
	    width: _react2['default'].PropTypes.number.isRequired,
	    height: _react2['default'].PropTypes.number.isRequired,
	    url: _react2['default'].PropTypes.string.isRequired
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      loaded: false,
	      loadingImage: null,
	      alreadyLoaded: false
	    };
	  },
	
	  handleImageLoad: function handleImageLoad() {
	    if (this.state.loadingImage) {
	      this.state.loadingImage.removeEventListener('load', this.handleImageLoad);
	      this.state.loadingImage.remove();
	
	      this.setState({
	        loaded: true,
	        loadingImage: null
	      });
	    }
	  },
	
	  componentDidMount: function componentDidMount() {
	    var el = this.getDOMNode();
	    var width = el.getBoundingClientRect().width;
	    var scale = width / this.props.width;
	
	    var img = document.createElement('img');
	    img.addEventListener('load', this.handleImageLoad);
	
	    img.src = this.props.url;
	
	    this.setState({
	      'alreadyLoaded': img.complete,
	      'loadingImage': img,
	      'scale': scale
	    });
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    if (this.state.loadingImage) {
	      this.state.loadingImage.removeEventListener('load', this.handleImageLoad);
	      this.state.loadingImage.remove();
	    }
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var url = _props.url;
	    var width = _props.width;
	    var height = _props.height;
	
	    var props = _objectWithoutProperties(_props, ['url', 'width', 'height']);
	
	    var _state = this.state;
	    var scale = _state.scale;
	    var loaded = _state.loaded;
	
	    var ratio = width / height;
	
	    var classes = (0, _classnames2['default'])('ofs-Image', 'ofs-Image--' + (loaded ? 'loaded' : 'loading'));
	
	    return _react2['default'].createElement(
	      'div',
	      { className: classes },
	      _react2['default'].createElement(
	        'div',
	        { className: 'ofs-Image__Background' },
	        _react2['default'].createElement('img', _extends({ className: 'ofs-Image__Image', width: scale && Math.round(width * scale), height: scale && Math.round(height * scale), style: { opacity: loaded ? 100 : 0 }, src: url }, props))
	      )
	    );
	  }
	});
	
	exports['default'] = Image;
	module.exports = exports['default'];

/***/ },
/* 591 */
/***/ function(module, exports, __webpack_require__) {

	/* eslint-disable react/no-did-mount-set-state */
	'use strict';
	
	var _slicedToArray = __webpack_require__(241)['default'];
	
	var _objectWithoutProperties = __webpack_require__(53)['default'];
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.getImgixUrl = getImgixUrl;
	
	var _reactAddons = __webpack_require__(40);
	
	var _reactAddons2 = _interopRequireDefault(_reactAddons);
	
	var _underscore = __webpack_require__(66);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _classnames = __webpack_require__(49);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _pureRenderMixin = __webpack_require__(592);
	
	var _ofsUtilsImgix = __webpack_require__(595);
	
	var _ofsUtilsImgix2 = _interopRequireDefault(_ofsUtilsImgix);
	
	function getPixelRatio(context) {
	  return (context || window).devicePixelRatio || 1;
	}
	
	function getPageOffset() {
	  if (Object.prototype.hasOwnProperty.call(window, 'pageYOffset')) {
	    return window.pageYOffset;
	  }
	
	  return document.documentElement.scrollTop;
	}
	
	function getHeightAtWidth(width, ratio) {
	  return parseInt(Math.round(parseInt(width, 10) / ratio), 10);
	}
	
	function getImgixUrl(imageUrl, width, height, bounds) {
	  var imgixClient = new _ofsUtilsImgix2['default']("onefinestay.imgix.net", null, true);
	
	  var _bounds = _slicedToArray(bounds, 4);
	
	  var cropLeft = _bounds[0];
	  var cropTop = _bounds[1];
	  var cropRight = _bounds[2];
	  var cropBottom = _bounds[3];
	
	  var cropWidth = cropRight - cropLeft;
	  var cropHeight = cropBottom - cropTop;
	
	  /* eslint-disable comma-spacing */
	  var rect = cropLeft + ',' + cropTop + ',' + cropWidth + ',' + cropHeight;
	  /* eslint-enable comma-spacing */
	
	  return imgixClient.path(imageUrl, {
	    w: width,
	    h: height,
	    auto: 'format',
	    fit: 'crop',
	    rect: rect
	  }).toString();
	}
	
	var ResponsiveImage = _reactAddons2['default'].createClass({
	  displayName: 'ResponsiveImage',
	
	  propTypes: {
	    ratio: _reactAddons2['default'].PropTypes.number.isRequired,
	    url: _reactAddons2['default'].PropTypes.string.isRequired,
	    bounds: _reactAddons2['default'].PropTypes.arrayOf(_reactAddons2['default'].PropTypes.number).isRequired,
	    defaultWidth: _reactAddons2['default'].PropTypes.number.isRequired,
	    lazyloadOffset: _reactAddons2['default'].PropTypes.number,
	    scrollDelay: _reactAddons2['default'].PropTypes.number
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      lazyloadOffset: 0,
	      scrollDelay: 250
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      visible: false,
	      width: null,
	      loaded: false,
	      src: 'data:image/gif;base64,R0lGODlhEAAJAIAAAP///wAAACH5BAEAAAAALAAAAAAQAAkAAAIKhI+py+0Po5yUFQA7'
	    };
	  },
	
	  setImage: function setImage() {
	    var _this = this;
	
	    var _props = this.props;
	    var url = _props.url;
	    var ratio = _props.ratio;
	    var bounds = _props.bounds;
	
	    var devicePixelRatio = getPixelRatio();
	
	    var el = this.getDOMNode();
	    var width = el.clientWidth;
	
	    // generate url
	    var height = getHeightAtWidth(width * devicePixelRatio, ratio);
	    var src = getImgixUrl(url, Math.round(width * devicePixelRatio), height, bounds);
	
	    // check if the image is visible
	    var visible = this.isVisible();
	
	    this.setState({ width: width, src: src, visible: visible }, function () {
	      if (visible === true) {
	        _this.loadImage();
	      }
	    });
	  },
	
	  isVisible: function isVisible() {
	    // Credit: https://github.com/BBC-News/Imager.js/blob/13b471a10e7b15971e864a1d7f9ab98cd0a495fe/Imager.js#L286-L300
	    if (!this.isMounted()) {
	      return false;
	    }
	
	    var element = this.getDOMNode();
	
	    var elementOffsetTop = 0;
	    var offset = getPageOffset() + this.props.lazyloadOffset;
	
	    if (element.offsetParent) {
	      /* eslint-disable no-cond-assign */
	      do {
	        elementOffsetTop += element.offsetTop;
	      } while (element = element.offsetParent);
	      /* eslint-enable no-cond-assign */
	    }
	
	    return elementOffsetTop < document.documentElement.clientHeight + offset;
	  },
	
	  setVisible: function setVisible() {
	    var _this2 = this;
	
	    if (this.state.visible !== true && this.isVisible()) {
	      this.setState({
	        visible: true
	      }, function () {
	        _this2.loadImage();
	      });
	    }
	  },
	
	  loadImage: function loadImage() {
	    if (this.loadingImage) {
	      // remove existing loading image
	      this.removeLoadingImage();
	    }
	
	    // create image node and listen to when the image has finished loaded
	    var img = document.createElement('img');
	    img.addEventListener('load', this.handleImageLoaded);
	
	    img.src = this.state.src;
	
	    this.loadingImage = img;
	  },
	
	  handleImageLoaded: function handleImageLoaded() {
	    if (this.loadingImage) {
	      this.removeLoadingImage();
	
	      this.setState({
	        loaded: true
	      });
	    }
	  },
	
	  removeLoadingImage: function removeLoadingImage() {
	    this.loadingImage.removeEventListener('load', this.handleImageLoaded);
	    this.loadingImage.remove();
	    this.loadingImage = null;
	  },
	
	  onResize: function onResize() {
	    this.setImage();
	  },
	
	  onScroll: function onScroll() {
	    this.setVisible();
	  },
	
	  componentWillMount: function componentWillMount() {
	    this.onResize = _underscore2['default'].debounce(this.onResize, 250);
	    this.onScroll = _underscore2['default'].debounce(this.onScroll, this.props.scrollDelay);
	  },
	
	  componentDidMount: function componentDidMount() {
	    var _this3 = this;
	
	    // Setup image
	    // Wait until next tick to access the dom
	    this._timer = setTimeout(function () {
	      if (_this3.isMounted()) {
	        _this3.setImage();
	      }
	    }, 0);
	
	    window.addEventListener('resize', this.onResize);
	    window.addEventListener('scroll', this.onScroll);
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    window.removeEventListener('resize', this.onResize);
	    window.removeEventListener('scroll', this.onScroll);
	
	    if (this._timer) {
	      clearTimeout(this._timer);
	    }
	
	    if (this.loadingImage) {
	      this.removeLoadingImage();
	    }
	  },
	
	  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
	    if (!(0, _pureRenderMixin.shallowEqual)(this.state, nextState)) {
	      return true;
	    }
	
	    var nextBounds = nextProps.bounds;
	
	    var otherProps = _objectWithoutProperties(nextProps, ['bounds']);
	
	    var _props2 = this.props;
	    var bounds = _props2.bounds;
	
	    var props = _objectWithoutProperties(_props2, ['bounds']);
	
	    if (!(0, _pureRenderMixin.shallowEqual)(props, otherProps)) {
	      return true;
	    }
	
	    if (bounds.join() !== nextBounds.join()) {
	      return true;
	    }
	
	    return false;
	  },
	
	  renderFallback: function renderFallback() {
	    var _props3 = this.props;
	    var url = _props3.url;
	    var ratio = _props3.ratio;
	    var bounds = _props3.bounds;
	    var defaultWidth = _props3.defaultWidth;
	
	    // generate url
	    var height = getHeightAtWidth(defaultWidth, ratio);
	    var src = getImgixUrl(url, defaultWidth, height, bounds);
	
	    // have to set this statically due to https://github.com/facebook/react/issues/1252
	    return _reactAddons2['default'].createElement('noscript', { dangerouslySetInnerHTML: {
	        __html: '<img width=' + defaultWidth + ' src="' + src + '"></img>'
	      } });
	  },
	
	  render: function render() {
	    var ratio = this.props.ratio;
	    var _state = this.state;
	    var visible = _state.visible;
	    var src = _state.src;
	    var width = _state.width;
	    var loaded = _state.loaded;
	
	    var height = null;
	    var containerStyle = {};
	
	    if (width) {
	      height = getHeightAtWidth(width, ratio);
	      containerStyle = {
	        'minHeight': height
	      };
	    }
	
	    var classes = (0, _classnames2['default'])({
	      'ofs-ResponsiveImage': true,
	      'ofs-ResponsiveImage--is-visible': visible,
	      'ofs-ResponsiveImage--is-loaded': loaded
	    });
	
	    return _reactAddons2['default'].createElement(
	      'div',
	      { className: classes, style: containerStyle },
	      visible && _reactAddons2['default'].createElement('img', { src: src, className: 'ofs-ResponsiveImage__Image', style: { opacity: loaded ? 100 : 0 } }),
	      this.renderFallback()
	    );
	  }
	});
	
	exports['default'] = ResponsiveImage;

/***/ },
/* 592 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	* @providesModule ReactComponentWithPureRenderMixin
	*/
	
	'use strict';
	
	var shallowCompare = __webpack_require__(593);
	
	/**
	 * If your React component's render function is "pure", e.g. it will render the
	 * same result given the same props and state, provide this Mixin for a
	 * considerable performance boost.
	 *
	 * Most React components have pure render functions.
	 *
	 * Example:
	 *
	 *   var ReactComponentWithPureRenderMixin =
	 *     require('ReactComponentWithPureRenderMixin');
	 *   React.createClass({
	 *     mixins: [ReactComponentWithPureRenderMixin],
	 *
	 *     render: function() {
	 *       return <div className={this.props.className}>foo</div>;
	 *     }
	 *   });
	 *
	 * Note: This only checks shallow equality for props and state. If these contain
	 * complex data structures this mixin may have false-negatives for deeper
	 * differences. Only mixin to components which have simple props and state, or
	 * use `forceUpdate()` when you know deep data structures have changed.
	 */
	var ReactComponentWithPureRenderMixin = {
	  shouldComponentUpdate: function(nextProps, nextState) {
	    return shallowCompare(this, nextProps, nextState);
	  }
	};
	
	module.exports = {
	    PureRenderMixin: ReactComponentWithPureRenderMixin,
	
	    // For convenience also export shallowCompare and shallowEqual
	    shallowCompare: shallowCompare,
	    shallowEqual: __webpack_require__(594)
	};


/***/ },
/* 593 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	* @providesModule shallowCompare
	*/
	
	'use strict';
	
	var shallowEqual = __webpack_require__(594);
	
	/**
	 * Does a shallow comparison for props and state.
	 * See ReactComponentWithPureRenderMixin
	 */
	function shallowCompare(instance, nextProps, nextState) {
	  return (
	    !shallowEqual(instance.props, nextProps) ||
	    !shallowEqual(instance.state, nextState)
	  );
	}
	
	module.exports = shallowCompare;


/***/ },
/* 594 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule shallowEqual
	 */
	
	'use strict';
	
	/**
	 * Performs equality by iterating through keys on an object and returning
	 * false when any key has values which are not strictly equal between
	 * objA and objB. Returns true when the values of all keys are strictly equal.
	 *
	 * @return {boolean}
	 */
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null ||
	      typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	  for (var i = 0; i < keysA.length; i++) {
	    if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;


/***/ },
/* 595 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = __webpack_require__(28)["default"];
	
	var _classCallCheck = __webpack_require__(31)["default"];
	
	var _interopRequireDefault = __webpack_require__(1)["default"];
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _URIjs = __webpack_require__(463);
	
	var _URIjs2 = _interopRequireDefault(_URIjs);
	
	var Path = (function () {
	  function Path(path, host) {
	    var params = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];
	    var secure = arguments.length <= 3 || arguments[3] === undefined ? true : arguments[3];
	
	    _classCallCheck(this, Path);
	
	    this.path = path;
	    this.host = host;
	    this.secure = secure;
	    this.queryParams = params;
	
	    // We are dealing with a fully-qualified URL as a path, encode it
	    if (this.path.indexOf("http") === 0) {
	      this.path = _URIjs2["default"].encode(this.path);
	    }
	
	    if (this.path[0] !== "/") {
	      this.path = "/" + this.path;
	    }
	  }
	
	  _createClass(Path, [{
	    key: "toString",
	    value: function toString() {
	      var uri = new _URIjs2["default"]({
	        protocol: this.secure ? "https" : "http",
	        hostname: this.host,
	        path: this.path,
	        query: _URIjs2["default"].buildQuery(this.queryParams)
	      });
	      return uri.toString();
	    }
	  }]);
	
	  return Path;
	})();
	
	var Client = (function () {
	  function Client(host) {
	    var secure = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];
	
	    _classCallCheck(this, Client);
	
	    this.host = host;
	    this.secure = secure;
	  }
	
	  _createClass(Client, [{
	    key: "path",
	    value: function path(urlPath) {
	      var params = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	      return new Path(urlPath, this.host, params, this.secure);
	    }
	  }]);
	
	  return Client;
	})();
	
	exports["default"] = Client;
	module.exports = exports["default"];

/***/ },
/* 596 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _reactAddons = __webpack_require__(40);
	
	var _reactAddons2 = _interopRequireDefault(_reactAddons);
	
	var _immutable = __webpack_require__(68);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _pad = __webpack_require__(269);
	
	var _pad2 = _interopRequireDefault(_pad);
	
	var _rebound = __webpack_require__(597);
	
	var _rebound2 = _interopRequireDefault(_rebound);
	
	var _classnames = __webpack_require__(49);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _commonIcon = __webpack_require__(51);
	
	var _commonIcon2 = _interopRequireDefault(_commonIcon);
	
	var _CarouselItem = __webpack_require__(599);
	
	var _CarouselItem2 = _interopRequireDefault(_CarouselItem);
	
	_reactAddons2['default'].initializeTouchEvents(true);
	
	function stopPropagation(event) {
	  event.stopPropagation();
	}
	
	/*
	 * The following 3 functions are stolen from an example, but seem to work?
	 */
	function progressForValueInRange(value, startValue, endValue) {
	  return (value - startValue) / (endValue - startValue);
	}
	
	function transitionForProgressInRange(progress, startValue, endValue) {
	  return startValue + progress * (endValue - startValue);
	}
	
	function transitionForProgressInSteps(progress, numChildren) {
	  var transition = -1;
	  var steps = _immutable2['default'].Range(0, numChildren).toJS();
	  var normalizedProgress;
	
	  // Bail if there's fewer than two steps
	  if (steps.length < 2) {
	    return transition;
	  };
	
	  // If the progress is before the beginning of the range, extrapolate from the first and second steps.
	  if (progress < 0) {
	    transition = transitionForProgressInRange(progress, steps[0], steps[1]);
	  }
	
	  // If the progress is after the end of the range, extrapolate from the second last and last steps.
	  else if (progress > steps.length - 1) {
	      normalizedProgress = progressForValueInRange(progress, Math.floor(progress), Math.floor(progress) + 1);
	      normalizedProgress = normalizedProgress + 1;
	      transition = transitionForProgressInRange(normalizedProgress, steps[steps.length - 2], steps[steps.length - 1]);
	    }
	
	    // Supress potential NaNs
	    else if (progress === steps.length - 1 || progress === 0) {
	        transition = steps[progress];
	      }
	
	      // Otherwise interpolate between steps
	      else {
	          normalizedProgress = progressForValueInRange(progress, Math.floor(progress), Math.floor(progress) + 1);
	          transition = transitionForProgressInRange(normalizedProgress, steps[Math.floor(progress)], steps[Math.floor(progress) + 1]);
	        }
	
	  return transition;
	}
	
	var Carousel = _reactAddons2['default'].createClass({
	  displayName: 'Carousel',
	
	  getInitialState: function getInitialState() {
	    return {
	      offsetX: 0,
	      currentIndex: 0,
	      endValue: 0,
	      handleX: 0,
	      handleXOrigin: null
	    };
	  },
	
	  componentDidMount: function componentDidMount() {
	    var _this = this;
	
	    var springSystem = new _rebound2['default'].SpringSystem();
	    var spring = springSystem.createSpring(4.5, 5.7);
	    var timer;
	
	    spring.setCurrentValue(this.state.currentIndex);
	    spring.setEndValue(this.state.currentIndex);
	    spring.setAtRest();
	
	    spring.addListener({
	      onSpringUpdate: function onSpringUpdate(spring) {
	        var progress = spring.getCurrentValue();
	        var x = transitionForProgressInSteps(progress, _this.props.children.length);
	
	        _this.setState({ offsetX: x });
	      }
	    });
	
	    if (this.props.autoplay) {
	      timer = setTimeout(this.transitionForwards, this.props.autoplay);
	    }
	
	    this.spring = spring;
	    this.timer = timer;
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    if (this.props.autoplay) {
	      clearTimeout(this.timer);
	    }
	  },
	
	  transitionBackwards: function transitionBackwards() {
	    var numChildren = this.props.children.length;
	    var nextIndex = this.state.currentIndex - 1;
	
	    if (nextIndex < 0) {
	      nextIndex = numChildren - 1;
	    }
	
	    if (this.spring.isAtRest()) {
	      this.spring.setCurrentValue(this.state.currentIndex);
	    }
	
	    this.setIndex(nextIndex);
	  },
	
	  transitionForwards: function transitionForwards() {
	    var numChildren = this.props.children.length;
	    var nextIndex = this.state.currentIndex + 1;
	
	    if (nextIndex >= numChildren) {
	      nextIndex = 0;
	    }
	
	    if (this.spring.isAtRest()) {
	      this.spring.setCurrentValue(this.state.currentIndex);
	    }
	
	    this.setIndex(nextIndex);
	  },
	
	  onProgressBarClick: function onProgressBarClick(event) {
	    var handleSize = 100 / this.props.children.length;
	    var el;
	    var rect;
	    var x;
	    var handleLeft;
	    var nextIndex;
	
	    el = this.refs.progress.getDOMNode();
	    rect = el.getBoundingClientRect();
	
	    x = event.pageX - rect.left;
	
	    handleLeft = 100 * x / rect.width;
	
	    nextIndex = Math.floor(handleLeft / handleSize);
	
	    if (this.spring.isAtRest()) {
	      this.spring.setCurrentValue(this.state.currentIndex);
	    }
	
	    this.setIndex(nextIndex);
	  },
	
	  startDragging: function startDragging(x) {
	    this.spring.setAtRest();
	    this.setState({
	      lastX: x,
	      isDragging: true
	    });
	  },
	
	  continueDragging: function continueDragging(x, width, rubberBand) {
	    var panVelocity = x - this.state.lastX;
	    var lastX = x;
	
	    var progress = progressForValueInRange(panVelocity, 0, -width);
	    var currentValue = this.spring.getCurrentValue();
	
	    var minValue = 0;
	    var maxValue = this.props.children.length - 1;
	    var nextValue = currentValue + progress;
	
	    if (rubberBand) {
	      // Rubberband when beyond the scroll boundaries
	      if (nextValue < minValue) {
	        progress *= 0.5;
	      } else if (nextValue > maxValue) {
	        progress *= 0.5;
	      }
	    }
	
	    this.spring.setCurrentValue(currentValue + progress);
	    this.spring.setAtRest();
	
	    this.setState({ panVelocity: panVelocity, lastX: lastX });
	  },
	
	  endDragging: function endDragging(width) {
	    var currentPosition = this.spring.getCurrentValue();
	    var restPosition = this.state.currentIndex;
	
	    var passedVelocityTolerance = Math.abs(this.state.panVelocity) > 3;
	    var passedDistanceTolerance = Math.abs(currentPosition - restPosition) > 0.3;
	    var shouldAdvance = passedDistanceTolerance || passedVelocityTolerance;
	    var advanceForward = this.state.panVelocity <= 0;
	
	    if (shouldAdvance) {
	      var targetIndex = advanceForward ? restPosition + 1 : restPosition - 1;
	      this.setIndex(targetIndex, true);
	    } else {
	      this.setIndex(restPosition, true);
	    }
	
	    var normalizedVelocity = progressForValueInRange(this.state.panVelocity, 0, -width);
	
	    this.spring.setVelocity(normalizedVelocity * 30);
	
	    this.setState({
	      isDragging: false,
	      panVelocity: 0
	    });
	  },
	
	  springMouseDown: function springMouseDown(event) {
	    this.startDragging(event.clientX);
	    document.addEventListener('mousemove', this.springMouseMove);
	    document.addEventListener('mouseup', this.springMouseUp);
	  },
	
	  springTouchStart: function springTouchStart(event) {
	    var touch = event.touches[0];
	    this.startDragging(touch.clientX);
	
	    document.addEventListener('touchmove', this.springTouchMove);
	    document.addEventListener('touchend', this.springTouchEnd);
	    document.addEventListener('touchcancel', this.springTouchEnd);
	  },
	
	  springMouseMove: function springMouseMove(event) {
	    var width = this.refs.wrapper.getDOMNode().getBoundingClientRect().width;
	
	    if (this.state.isDragging) {
	      this.continueDragging(event.clientX, width, true);
	    }
	  },
	
	  springTouchMove: function springTouchMove(event) {
	    var width = this.refs.wrapper.getDOMNode().getBoundingClientRect().width;
	    var touch = event.touches[0];
	    this.continueDragging(touch.clientX, width, true);
	  },
	
	  springMouseUp: function springMouseUp(event) {
	    var width = this.refs.wrapper.getDOMNode().getBoundingClientRect().width;
	
	    this.endDragging(width);
	    document.removeEventListener('mousemove', this.springMouseMove);
	    document.removeEventListener('mouseup', this.springMouseUp);
	  },
	
	  springTouchEnd: function springTouchEnd(event) {
	    var width = this.refs.wrapper.getDOMNode().getBoundingClientRect().width;
	
	    this.endDragging(width);
	    document.removeEventListener('touchmove', this.springTouchMove);
	    document.removeEventListener('touchend', this.springTouchEnd);
	    document.removeEventListener('touchcancel', this.springTouchEnd);
	  },
	
	  onHandleMoveStart: function onHandleMoveStart(eventX) {
	    var bar = this.refs.progress.getDOMNode();
	
	    var _bar$getBoundingClientRect = bar.getBoundingClientRect();
	
	    var barWidth = _bar$getBoundingClientRect.width;
	    var barLeft = _bar$getBoundingClientRect.left;
	
	    var handle = this.refs.handle.getDOMNode();
	
	    var _handle$getBoundingClientRect = handle.getBoundingClientRect();
	
	    var handleWidth = _handle$getBoundingClientRect.width;
	    var handleLeft = _handle$getBoundingClientRect.left;
	
	    var offsetX = eventX - barLeft;
	    var handleOffsetX = eventX - handleLeft;
	
	    var proportion = (offsetX - handleOffsetX) / barWidth;
	
	    this.spring.setCurrentValue(this.state.currentIndex);
	    this.startDragging(-proportion);
	
	    this.setState({
	      dragHandleOffset: handleOffsetX
	    });
	  },
	
	  onHandleMoveContinue: function onHandleMoveContinue(eventX) {
	    var children = this.props.children;
	
	    var bar = this.refs.progress.getDOMNode();
	
	    var _bar$getBoundingClientRect2 = bar.getBoundingClientRect();
	
	    var barWidth = _bar$getBoundingClientRect2.width;
	    var barLeft = _bar$getBoundingClientRect2.left;
	
	    var offsetX = eventX - barLeft;
	    var proportion = (offsetX - this.state.dragHandleOffset) / barWidth;
	
	    var handleSize = 100 / this.props.children.length;
	    var rect = this.refs.progress.getDOMNode().getBoundingClientRect();
	
	    var x = eventX - rect.left;
	
	    var handleLeft = 100 * x / rect.width / handleSize - handleSize / 2 / handleSize;
	
	    if (handleLeft < 0) {
	      handleLeft = 0;
	    } else if (handleLeft > children.length - 1) {
	      handleLeft = children.length - 1;
	    }
	
	    this.setState({ handleX: handleLeft });
	
	    var maxPropotion = (children.length - 1) / children.length;
	
	    if (proportion > maxPropotion) {
	      proportion = maxPropotion;
	    } else if (proportion < 0) {
	      proportion = 0;
	    }
	
	    this.continueDragging(-proportion, 1 / children.length, false);
	  },
	
	  onHandleMoveEnd: function onHandleMoveEnd() {
	    var nextIndex = Math.round(this.state.handleX);
	
	    if (this.state.panVelocity > 0) {
	      nextIndex = Math.ceil(nextIndex);
	    } else {
	      nextIndex = Math.floor(nextIndex);
	    }
	
	    this.spring.setEndValue(nextIndex);
	
	    this.setState({
	      isDragging: false,
	      currentIndex: nextIndex,
	      panVelocity: 0
	    });
	  },
	
	  onHandleMouseDown: function onHandleMouseDown(event) {
	    this.onHandleMoveStart(event.clientX);
	    document.addEventListener('mousemove', this.onHandleMouseMove);
	    document.addEventListener('mouseup', this.onHandleMouseUp);
	  },
	
	  onHandleMouseMove: function onHandleMouseMove(event) {
	    this.onHandleMoveContinue(event.clientX);
	  },
	
	  onHandleMouseUp: function onHandleMouseUp(event) {
	    this.onHandleMoveEnd();
	    document.removeEventListener('mousemove', this.onHandleMouseMove);
	    document.removeEventListener('mouseup', this.onHandleMouseUp);
	  },
	
	  onHandleTouchStart: function onHandleTouchStart(event) {
	    var touch = event.touches[0];
	    this.onHandleMoveStart(touch.clientX);
	    document.addEventListener('touchmove', this.onHandleTouchMove);
	    document.addEventListener('touchend', this.onHandleTouchEnd);
	    document.addEventListener('touchcancel', this.onHandleTouchEnd);
	  },
	
	  onHandleTouchMove: function onHandleTouchMove(event) {
	    var touch = event.touches[0];
	    this.onHandleMoveContinue(touch.clientX);
	  },
	
	  onHandleTouchEnd: function onHandleTouchEnd(event) {
	    this.onHandleMoveEnd();
	    document.removeEventListener('touchmove', this.onHandleTouchMove);
	    document.removeEventListener('touchend', this.onHandleTouchEnd);
	    document.removeEventListener('touchcancel', this.onHandleTouchEnd);
	  },
	
	  setIndex: function setIndex(index) {
	    if (index < 0) {
	      index = 0;
	    } else if (index > this.props.children.length - 1) {
	      index = this.props.children.length - 1;
	    }
	    this.spring.setEndValue(index);
	    this.setState({ currentIndex: index, handleX: index });
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var children = _props.children;
	    var noOverflow = _props.noOverflow;
	    var ratio = _props.ratio;
	    var _state = this.state;
	    var offsetX = _state.offsetX;
	    var handleX = _state.handleX;
	
	    var numChildren = children.length;
	    var index;
	    var peekSize = 2;
	
	    var childrenWindow = _immutable2['default'].Range(-peekSize, numChildren + peekSize).map(function (i) {
	      var j = i;
	      if (i < 0) {
	        j = numChildren + i;
	      } else if (i >= numChildren) {
	        j = i - numChildren;
	      }
	      return children[j];
	    });
	
	    var items = childrenWindow.map(function (c, i) {
	      return _reactAddons2['default'].createElement(
	        _CarouselItem2['default'],
	        { baseOffset: 101 * i - 101 * peekSize },
	        c
	      );
	    });
	    var numDigits = numChildren.toString().length;
	
	    var handleScale = 100 / numChildren;
	
	    index = Math.floor(handleX);
	
	    var itemsStyle = {
	      left: 101 * -offsetX + '%'
	    };
	
	    var handleStyles = {
	      width: handleScale + '%',
	      left: handleScale * handleX + '%'
	    };
	
	    var wrapperClasses = {
	      'ofs-Carousel__ItemsWrapper': true,
	      'ofs-Carousel__ItemsWrapper--no-overflow': noOverflow
	    };
	
	    var paddingBottom = 100 / ratio + '%';
	
	    return _reactAddons2['default'].createElement(
	      'div',
	      { className: 'ofs-Carousel' },
	      _reactAddons2['default'].createElement(
	        'div',
	        { className: 'ofs-Carousel__Inner' },
	        _reactAddons2['default'].createElement(
	          'div',
	          {
	            className: (0, _classnames2['default'])(wrapperClasses),
	            style: { paddingBottom: paddingBottom },
	            ref: 'wrapper',
	            onMouseDown: this.springMouseDown,
	            onTouchStart: this.springTouchStart
	          },
	          _reactAddons2['default'].createElement(
	            'ul',
	            {
	              className: 'ofs-Carousel__Items',
	              ref: 'items',
	              style: itemsStyle
	            },
	            items.toJS()
	          ),
	          this.state.currentIndex > 0 && _reactAddons2['default'].createElement(
	            'div',
	            { className: 'ofs-Carousel__Arrow ofs-Carousel__Arrow--previous',
	              onMouseDown: stopPropagation,
	              onTouchStart: stopPropagation,
	              onClick: this.transitionBackwards },
	            _reactAddons2['default'].createElement(_commonIcon2['default'], { glyph: 'arrow', variant: 'left', size: 'medium' })
	          ),
	          this.state.currentIndex < numChildren - 1 && _reactAddons2['default'].createElement(
	            'div',
	            { className: 'ofs-Carousel__Arrow ofs-Carousel__Arrow--next',
	              onMouseDown: stopPropagation,
	              onTouchStart: stopPropagation,
	              onClick: this.transitionForwards },
	            _reactAddons2['default'].createElement(_commonIcon2['default'], { glyph: 'arrow', variant: 'right', size: 'medium' })
	          )
	        ),
	        _reactAddons2['default'].createElement(
	          'div',
	          { className: 'ofs-Carousel__Footer' },
	          _reactAddons2['default'].createElement(
	            'div',
	            { className: 'ofs-Carousel__ProgressBar', onClick: this.onProgressBarClick, ref: 'progress' },
	            _reactAddons2['default'].createElement('div', { className: 'ofs-Carousel__ProgressLine' }),
	            _reactAddons2['default'].createElement(
	              'div',
	              { className: 'ofs-Carousel__ProgressHandleWrapper',
	                style: handleStyles,
	                onMouseDown: this.onHandleMouseDown,
	                onTouchStart: this.onHandleTouchStart
	              },
	              _reactAddons2['default'].createElement('div', { className: 'ofs-Carousel__ProgressHandle', ref: 'handle' })
	            )
	          ),
	          _reactAddons2['default'].createElement(
	            'div',
	            { className: 'ofs-Carousel__Counter' },
	            (0, _pad2['default'])(numDigits, index + 1, '0'),
	            '/',
	            numChildren
	          )
	        )
	      )
	    );
	  }
	});
	
	exports['default'] = Carousel;
	module.exports = exports['default'];

/***/ },
/* 597 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, setImmediate) {// Rebound
	// =======
	// **Rebound** is a simple library that models Spring dynamics for the
	// purpose of driving physical animations.
	//
	// Origin
	// ------
	// [Rebound](http://facebook.github.io/rebound) was originally written
	// in Java to provide a lightweight physics system for
	// [Home](https://play.google.com/store/apps/details?id=com.facebook.home) and
	// [Chat Heads](https://play.google.com/store/apps/details?id=com.facebook.orca)
	// on Android. It's now been adopted by several other Android
	// applications. This JavaScript port was written to provide a quick
	// way to demonstrate Rebound animations on the web for a
	// [conference talk](https://www.youtube.com/watch?v=s5kNm-DgyjY). Since then
	// the JavaScript version has been used to build some really nice interfaces.
	// Check out [brandonwalkin.com](http://brandonwalkin.com) for an
	// example.
	//
	// Overview
	// --------
	// The Library provides a SpringSystem for maintaining a set of Spring
	// objects and iterating those Springs through a physics solver loop
	// until equilibrium is achieved. The Spring class is the basic
	// animation driver provided by Rebound. By attaching a listener to
	// a Spring, you can observe its motion. The observer function is
	// notified of position changes on the spring as it solves for
	// equilibrium. These position updates can be mapped to an animation
	// range to drive animated property updates on your user interface
	// elements (translation, rotation, scale, etc).
	//
	// Example
	// -------
	// Here's a simple example. Pressing and releasing on the logo below
	// will cause it to scale up and down with a springy animation.
	//
	// <div style="text-align:center; margin-bottom:50px; margin-top:50px">
	//   <img
	//     src="http://facebook.github.io/rebound/images/rebound.png"
	//     id="logo"
	//   />
	// </div>
	// <script src="../rebound.min.js"></script>
	// <script>
	//
	// function scale(el, val) {
	//   el.style.mozTransform =
	//   el.style.msTransform =
	//   el.style.webkitTransform =
	//   el.style.transform = 'scale3d(' + val + ', ' + val + ', 1)';
	// }
	// var el = document.getElementById('logo');
	//
	// var springSystem = new rebound.SpringSystem();
	// var spring = springSystem.createSpring(50, 3);
	// spring.addListener({
	//   onSpringUpdate: function(spring) {
	//     var val = spring.getCurrentValue();
	//     val = rebound.MathUtil.mapValueInRange(val, 0, 1, 1, 0.5);
	//     scale(el, val);
	//   }
	// });
	//
	// el.addEventListener('mousedown', function() {
	//   spring.setEndValue(1);
	// });
	//
	// el.addEventListener('mouseout', function() {
	//   spring.setEndValue(0);
	// });
	//
	// el.addEventListener('mouseup', function() {
	//   spring.setEndValue(0);
	// });
	//
	// </script>
	//
	// Here's how it works.
	//
	// ```
	// // Get a reference to the logo element.
	// var el = document.getElementById('logo');
	//
	// // create a SpringSystem and a Spring with a bouncy config.
	// var springSystem = new rebound.SpringSystem();
	// var spring = springSystem.createSpring(50, 3);
	//
	// // Add a listener to the spring. Every time the physics
	// // solver updates the Spring's value onSpringUpdate will
	// // be called.
	// spring.addListener({
	//   onSpringUpdate: function(spring) {
	//     var val = spring.getCurrentValue();
	//     val = rebound.MathUtil
	//                  .mapValueInRange(val, 0, 1, 1, 0.5);
	//     scale(el, val);
	//   }
	// });
	//
	// // Listen for mouse down/up/out and toggle the
	// //springs endValue from 0 to 1.
	// el.addEventListener('mousedown', function() {
	//   spring.setEndValue(1);
	// });
	//
	// el.addEventListener('mouseout', function() {
	//   spring.setEndValue(0);
	// });
	//
	// el.addEventListener('mouseup', function() {
	//   spring.setEndValue(0);
	// });
	//
	// // Helper for scaling an element with css transforms.
	// function scale(el, val) {
	//   el.style.mozTransform =
	//   el.style.msTransform =
	//   el.style.webkitTransform =
	//   el.style.transform = 'scale3d(' +
	//     val + ', ' + val + ', 1)';
	// }
	// ```
	
	(function() {
	  var rebound = {};
	  var util = rebound.util = {};
	  var concat = Array.prototype.concat;
	  var slice = Array.prototype.slice;
	
	  // Bind a function to a context object.
	  util.bind = function bind(func, context) {
	    var args = slice.call(arguments, 2);
	    return function() {
	      func.apply(context, concat.call(args, slice.call(arguments)));
	    };
	  };
	
	  // Add all the properties in the source to the target.
	  util.extend = function extend(target, source) {
	    for (var key in source) {
	      if (source.hasOwnProperty(key)) {
	        target[key] = source[key];
	      }
	    }
	  };
	
	  // SpringSystem
	  // ------------
	  // **SpringSystem** is a set of Springs that all run on the same physics
	  // timing loop. To get started with a Rebound animation you first
	  // create a new SpringSystem and then add springs to it.
	  var SpringSystem = rebound.SpringSystem = function SpringSystem(looper) {
	    this._springRegistry = {};
	    this._activeSprings = [];
	    this.listeners = [];
	    this._idleSpringIndices = [];
	    this.looper = looper || new AnimationLooper();
	    this.looper.springSystem = this;
	  };
	
	  util.extend(SpringSystem.prototype, {
	
	    _springRegistry: null,
	
	    _isIdle: true,
	
	    _lastTimeMillis: -1,
	
	    _activeSprings: null,
	
	    listeners: null,
	
	    _idleSpringIndices: null,
	
	    // A SpringSystem is iterated by a looper. The looper is responsible
	    // for executing each frame as the SpringSystem is resolved to idle.
	    // There are three types of Loopers described below AnimationLooper,
	    // SimulationLooper, and SteppingSimulationLooper. AnimationLooper is
	    // the default as it is the most useful for common UI animations.
	    setLooper: function(looper) {
	      this.looper = looper;
	      looper.springSystem = this;
	    },
	
	    // Add a new spring to this SpringSystem. This Spring will now be solved for
	    // during the physics iteration loop. By default the spring will use the
	    // default Origami spring config with 40 tension and 7 friction, but you can
	    // also provide your own values here.
	    createSpring: function(tension, friction) {
	      var springConfig;
	      if (tension === undefined || friction === undefined) {
	        springConfig = SpringConfig.DEFAULT_ORIGAMI_SPRING_CONFIG;
	      } else {
	        springConfig =
	          SpringConfig.fromOrigamiTensionAndFriction(tension, friction);
	      }
	      return this.createSpringWithConfig(springConfig);
	    },
	
	    // Add a spring with a specified bounciness and speed. To replicate Origami
	    // compositions based on PopAnimation patches, use this factory method to
	    // create matching springs.
	    createSpringWithBouncinessAndSpeed: function(bounciness, speed) {
	      var springConfig;
	      if (bounciness === undefined || speed === undefined) {
	        springConfig = SpringConfig.DEFAULT_ORIGAMI_SPRING_CONFIG;
	      } else {
	        springConfig =
	          SpringConfig.fromBouncinessAndSpeed(bounciness, speed);
	      }
	      return this.createSpringWithConfig(springConfig);
	    },
	
	    // Add a spring with the provided SpringConfig.
	    createSpringWithConfig: function(springConfig) {
	      var spring = new Spring(this);
	      this.registerSpring(spring);
	      spring.setSpringConfig(springConfig);
	      return spring;
	    },
	
	    // You can check if a SpringSystem is idle or active by calling
	    // getIsIdle. If all of the Springs in the SpringSystem are at rest,
	    // i.e. the physics forces have reached equilibrium, then this
	    // method will return true.
	    getIsIdle: function() {
	      return this._isIdle;
	    },
	
	    // Retrieve a specific Spring from the SpringSystem by id. This
	    // can be useful for inspecting the state of a spring before
	    // or after an integration loop in the SpringSystem executes.
	    getSpringById: function (id) {
	      return this._springRegistry[id];
	    },
	
	    // Get a listing of all the springs registered with this
	    // SpringSystem.
	    getAllSprings: function() {
	      var vals = [];
	      for (var id in this._springRegistry) {
	        if (this._springRegistry.hasOwnProperty(id)) {
	          vals.push(this._springRegistry[id]);
	        }
	      }
	      return vals;
	    },
	
	    // registerSpring is called automatically as soon as you create
	    // a Spring with SpringSystem#createSpring. This method sets the
	    // spring up in the registry so that it can be solved in the
	    // solver loop.
	    registerSpring: function(spring) {
	      this._springRegistry[spring.getId()] = spring;
	    },
	
	    // Deregister a spring with this SpringSystem. The SpringSystem will
	    // no longer consider this Spring during its integration loop once
	    // this is called. This is normally done automatically for you when
	    // you call Spring#destroy.
	    deregisterSpring: function(spring) {
	      removeFirst(this._activeSprings, spring);
	      delete this._springRegistry[spring.getId()];
	    },
	
	    advance: function(time, deltaTime) {
	      while(this._idleSpringIndices.length > 0) this._idleSpringIndices.pop();
	      for (var i = 0, len = this._activeSprings.length; i < len; i++) {
	        var spring = this._activeSprings[i];
	        if (spring.systemShouldAdvance()) {
	          spring.advance(time / 1000.0, deltaTime / 1000.0);
	        } else {
	          this._idleSpringIndices.push(this._activeSprings.indexOf(spring));
	        }
	      }
	      while(this._idleSpringIndices.length > 0) {
	        var idx = this._idleSpringIndices.pop();
	        idx >= 0 && this._activeSprings.splice(idx, 1);
	      }
	    },
	
	    // This is our main solver loop called to move the simulation
	    // forward through time. Before each pass in the solver loop
	    // onBeforeIntegrate is called on an any listeners that have
	    // registered themeselves with the SpringSystem. This gives you
	    // an opportunity to apply any constraints or adjustments to
	    // the springs that should be enforced before each iteration
	    // loop. Next the advance method is called to move each Spring in
	    // the systemShouldAdvance forward to the current time. After the
	    // integration step runs in advance, onAfterIntegrate is called
	    // on any listeners that have registered themselves with the
	    // SpringSystem. This gives you an opportunity to run any post
	    // integration constraints or adjustments on the Springs in the
	    // SpringSystem.
	    loop: function(currentTimeMillis) {
	      var listener;
	      if (this._lastTimeMillis === -1) {
	        this._lastTimeMillis = currentTimeMillis -1;
	      }
	      var ellapsedMillis = currentTimeMillis - this._lastTimeMillis;
	      this._lastTimeMillis = currentTimeMillis;
	
	      var i = 0, len = this.listeners.length;
	      for (i = 0; i < len; i++) {
	        listener = this.listeners[i];
	        listener.onBeforeIntegrate && listener.onBeforeIntegrate(this);
	      }
	
	      this.advance(currentTimeMillis, ellapsedMillis);
	      if (this._activeSprings.length === 0) {
	        this._isIdle = true;
	        this._lastTimeMillis = -1;
	      }
	
	      for (i = 0; i < len; i++) {
	        listener = this.listeners[i];
	        listener.onAfterIntegrate && listener.onAfterIntegrate(this);
	      }
	
	      if (!this._isIdle) {
	        this.looper.run();
	      }
	    },
	
	    // activateSpring is used to notify the SpringSystem that a Spring
	    // has become displaced. The system responds by starting its solver
	    // loop up if it is currently idle.
	    activateSpring: function(springId) {
	      var spring = this._springRegistry[springId];
	      if (this._activeSprings.indexOf(spring) == -1) {
	        this._activeSprings.push(spring);
	      }
	      if (this.getIsIdle()) {
	        this._isIdle = false;
	        this.looper.run();
	      }
	    },
	
	    // Add a listener to the SpringSystem so that you can receive
	    // before/after integration notifications allowing Springs to be
	    // constrained or adjusted.
	    addListener: function(listener) {
	      this.listeners.push(listener);
	    },
	
	    // Remove a previously added listener on the SpringSystem.
	    removeListener: function(listener) {
	      removeFirst(this.listeners, listener);
	    },
	
	    // Remove all previously added listeners on the SpringSystem.
	    removeAllListeners: function() {
	      this.listeners = [];
	    }
	
	  });
	
	  // Spring
	  // ------
	  // **Spring** provides a model of a classical spring acting to
	  // resolve a body to equilibrium. Springs have configurable
	  // tension which is a force multipler on the displacement of the
	  // spring from its rest point or `endValue` as defined by [Hooke's
	  // law](http://en.wikipedia.org/wiki/Hooke's_law). Springs also have
	  // configurable friction, which ensures that they do not oscillate
	  // infinitely. When a Spring is displaced by updating it's resting
	  // or `currentValue`, the SpringSystems that contain that Spring
	  // will automatically start looping to solve for equilibrium. As each
	  // timestep passes, `SpringListener` objects attached to the Spring
	  // will be notified of the updates providing a way to drive an
	  // animation off of the spring's resolution curve.
	  var Spring = rebound.Spring = function Spring(springSystem) {
	    this._id = 's' + Spring._ID++;
	    this._springSystem = springSystem;
	    this.listeners = [];
	    this._currentState = new PhysicsState();
	    this._previousState = new PhysicsState();
	    this._tempState = new PhysicsState();
	  };
	
	  util.extend(Spring, {
	    _ID: 0,
	
	    MAX_DELTA_TIME_SEC: 0.064,
	
	    SOLVER_TIMESTEP_SEC: 0.001
	
	  });
	
	  util.extend(Spring.prototype, {
	
	    _id: 0,
	
	    _springConfig: null,
	
	    _overshootClampingEnabled: false,
	
	    _currentState: null,
	
	    _previousState: null,
	
	    _tempState: null,
	
	    _startValue: 0,
	
	    _endValue: 0,
	
	    _wasAtRest: true,
	
	    _restSpeedThreshold: 0.001,
	
	    _displacementFromRestThreshold: 0.001,
	
	    listeners: null,
	
	    _timeAccumulator: 0,
	
	    _springSystem: null,
	
	    // Remove a Spring from simulation and clear its listeners.
	    destroy: function() {
	      this.listeners = [];
	      this.frames = [];
	      this._springSystem.deregisterSpring(this);
	    },
	
	    // Get the id of the spring, which can be used to retrieve it from
	    // the SpringSystems it participates in later.
	    getId: function() {
	      return this._id;
	    },
	
	    // Set the configuration values for this Spring. A SpringConfig
	    // contains the tension and friction values used to solve for the
	    // equilibrium of the Spring in the physics loop.
	    setSpringConfig: function(springConfig) {
	      this._springConfig = springConfig;
	      return this;
	    },
	
	    // Retrieve the SpringConfig used by this Spring.
	    getSpringConfig: function() {
	      return this._springConfig;
	    },
	
	    // Set the current position of this Spring. Listeners will be updated
	    // with this value immediately. If the rest or `endValue` is not
	    // updated to match this value, then the spring will be dispalced and
	    // the SpringSystem will start to loop to restore the spring to the
	    // `endValue`.
	    //
	    // A common pattern is to move a Spring around without animation by
	    // calling.
	    //
	    // ```
	    // spring.setCurrentValue(n).setAtRest();
	    // ```
	    //
	    // This moves the Spring to a new position `n`, sets the endValue
	    // to `n`, and removes any velocity from the `Spring`. By doing
	    // this you can allow the `SpringListener` to manage the position
	    // of UI elements attached to the spring even when moving without
	    // animation. For example, when dragging an element you can
	    // update the position of an attached view through a spring
	    // by calling `spring.setCurrentValue(x)`. When
	    // the gesture ends you can update the Springs
	    // velocity and endValue
	    // `spring.setVelocity(gestureEndVelocity).setEndValue(flingTarget)`
	    // to cause it to naturally animate the UI element to the resting
	    // position taking into account existing velocity. The codepaths for
	    // synchronous movement and spring driven animation can
	    // be unified using this technique.
	    setCurrentValue: function(currentValue, skipSetAtRest) {
	      this._startValue = currentValue;
	      this._currentState.position = currentValue;
	      if (!skipSetAtRest) {
	        this.setAtRest();
	      }
	      this.notifyPositionUpdated(false, false);
	      return this;
	    },
	
	    // Get the position that the most recent animation started at. This
	    // can be useful for determining the number off oscillations that
	    // have occurred.
	    getStartValue: function() {
	      return this._startValue;
	    },
	
	    // Retrieve the current value of the Spring.
	    getCurrentValue: function() {
	      return this._currentState.position;
	    },
	
	    // Get the absolute distance of the Spring from it's resting endValue
	    // position.
	    getCurrentDisplacementDistance: function() {
	      return this.getDisplacementDistanceForState(this._currentState);
	    },
	
	    getDisplacementDistanceForState: function(state) {
	      return Math.abs(this._endValue - state.position);
	    },
	
	    // Set the endValue or resting position of the spring. If this
	    // value is different than the current value, the SpringSystem will
	    // be notified and will begin running its solver loop to resolve
	    // the Spring to equilibrium. Any listeners that are registered
	    // for onSpringEndStateChange will also be notified of this update
	    // immediately.
	    setEndValue: function(endValue) {
	      if (this._endValue == endValue && this.isAtRest())  {
	        return this;
	      }
	      this._startValue = this.getCurrentValue();
	      this._endValue = endValue;
	      this._springSystem.activateSpring(this.getId());
	      for (var i = 0, len = this.listeners.length; i < len; i++) {
	        var listener = this.listeners[i];
	        var onChange = listener.onSpringEndStateChange;
	        onChange && onChange(this);
	      }
	      return this;
	    },
	
	    // Retrieve the endValue or resting position of this spring.
	    getEndValue: function() {
	      return this._endValue;
	    },
	
	    // Set the current velocity of the Spring. As previously mentioned,
	    // this can be useful when you are performing a direct manipulation
	    // gesture. When a UI element is released you may call setVelocity
	    // on its animation Spring so that the Spring continues with the
	    // same velocity as the gesture ended with. The friction, tension,
	    // and displacement of the Spring will then govern its motion to
	    // return to rest on a natural feeling curve.
	    setVelocity: function(velocity) {
	      if (velocity === this._currentState.velocity) {
	        return this;
	      }
	      this._currentState.velocity = velocity;
	      this._springSystem.activateSpring(this.getId());
	      return this;
	    },
	
	    // Get the current velocity of the Spring.
	    getVelocity: function() {
	      return this._currentState.velocity;
	    },
	
	    // Set a threshold value for the movement speed of the Spring below
	    // which it will be considered to be not moving or resting.
	    setRestSpeedThreshold: function(restSpeedThreshold) {
	      this._restSpeedThreshold = restSpeedThreshold;
	      return this;
	    },
	
	    // Retrieve the rest speed threshold for this Spring.
	    getRestSpeedThreshold: function() {
	      return this._restSpeedThreshold;
	    },
	
	    // Set a threshold value for displacement below which the Spring
	    // will be considered to be not displaced i.e. at its resting
	    // `endValue`.
	    setRestDisplacementThreshold: function(displacementFromRestThreshold) {
	      this._displacementFromRestThreshold = displacementFromRestThreshold;
	    },
	
	    // Retrieve the rest displacement threshold for this spring.
	    getRestDisplacementThreshold: function() {
	      return this._displacementFromRestThreshold;
	    },
	
	    // Enable overshoot clamping. This means that the Spring will stop
	    // immediately when it reaches its resting position regardless of
	    // any existing momentum it may have. This can be useful for certain
	    // types of animations that should not oscillate such as a scale
	    // down to 0 or alpha fade.
	    setOvershootClampingEnabled: function(enabled) {
	      this._overshootClampingEnabled = enabled;
	      return this;
	    },
	
	    // Check if overshoot clamping is enabled for this spring.
	    isOvershootClampingEnabled: function() {
	      return this._overshootClampingEnabled;
	    },
	
	    // Check if the Spring has gone past its end point by comparing
	    // the direction it was moving in when it started to the current
	    // position and end value.
	    isOvershooting: function() {
	      var start = this._startValue;
	      var end = this._endValue;
	      return this._springConfig.tension > 0 &&
	       ((start < end && this.getCurrentValue() > end) ||
	       (start > end && this.getCurrentValue() < end));
	    },
	
	    // Spring.advance is the main solver method for the Spring. It takes
	    // the current time and delta since the last time step and performs
	    // an RK4 integration to get the new position and velocity state
	    // for the Spring based on the tension, friction, velocity, and
	    // displacement of the Spring.
	    advance: function(time, realDeltaTime) {
	      var isAtRest = this.isAtRest();
	
	      if (isAtRest && this._wasAtRest) {
	        return;
	      }
	
	      var adjustedDeltaTime = realDeltaTime;
	      if (realDeltaTime > Spring.MAX_DELTA_TIME_SEC) {
	        adjustedDeltaTime = Spring.MAX_DELTA_TIME_SEC;
	      }
	
	      this._timeAccumulator += adjustedDeltaTime;
	
	      var tension = this._springConfig.tension,
	          friction = this._springConfig.friction,
	
	          position = this._currentState.position,
	          velocity = this._currentState.velocity,
	          tempPosition = this._tempState.position,
	          tempVelocity = this._tempState.velocity,
	
	          aVelocity, aAcceleration,
	          bVelocity, bAcceleration,
	          cVelocity, cAcceleration,
	          dVelocity, dAcceleration,
	
	          dxdt, dvdt;
	
	      while(this._timeAccumulator >= Spring.SOLVER_TIMESTEP_SEC) {
	
	        this._timeAccumulator -= Spring.SOLVER_TIMESTEP_SEC;
	
	        if (this._timeAccumulator < Spring.SOLVER_TIMESTEP_SEC) {
	          this._previousState.position = position;
	          this._previousState.velocity = velocity;
	        }
	
	        aVelocity = velocity;
	        aAcceleration =
	          (tension * (this._endValue - tempPosition)) - friction * velocity;
	
	        tempPosition = position + aVelocity * Spring.SOLVER_TIMESTEP_SEC * 0.5;
	        tempVelocity =
	          velocity + aAcceleration * Spring.SOLVER_TIMESTEP_SEC * 0.5;
	        bVelocity = tempVelocity;
	        bAcceleration =
	          (tension * (this._endValue - tempPosition)) - friction * tempVelocity;
	
	        tempPosition = position + bVelocity * Spring.SOLVER_TIMESTEP_SEC * 0.5;
	        tempVelocity =
	          velocity + bAcceleration * Spring.SOLVER_TIMESTEP_SEC * 0.5;
	        cVelocity = tempVelocity;
	        cAcceleration =
	          (tension * (this._endValue - tempPosition)) - friction * tempVelocity;
	
	        tempPosition = position + cVelocity * Spring.SOLVER_TIMESTEP_SEC * 0.5;
	        tempVelocity =
	          velocity + cAcceleration * Spring.SOLVER_TIMESTEP_SEC * 0.5;
	        dVelocity = tempVelocity;
	        dAcceleration =
	          (tension * (this._endValue - tempPosition)) - friction * tempVelocity;
	
	        dxdt =
	          1.0/6.0 * (aVelocity + 2.0 * (bVelocity + cVelocity) + dVelocity);
	        dvdt = 1.0/6.0 * (
	          aAcceleration + 2.0 * (bAcceleration + cAcceleration) + dAcceleration
	        );
	
	        position += dxdt * Spring.SOLVER_TIMESTEP_SEC;
	        velocity += dvdt * Spring.SOLVER_TIMESTEP_SEC;
	      }
	
	      this._tempState.position = tempPosition;
	      this._tempState.velocity = tempVelocity;
	
	      this._currentState.position = position;
	      this._currentState.velocity = velocity;
	
	      if (this._timeAccumulator > 0) {
	        this.interpolate(this._timeAccumulator / Spring.SOLVER_TIMESTEP_SEC);
	      }
	
	      if (this.isAtRest() ||
	          this._overshootClampingEnabled && this.isOvershooting()) {
	
	        if (this._springConfig.tension > 0) {
	          this._startValue = this._endValue;
	          this._currentState.position = this._endValue;
	        } else {
	          this._endValue = this._currentState.position;
	          this._startValue = this._endValue;
	        }
	        this.setVelocity(0);
	        isAtRest = true;
	      }
	
	      var notifyActivate = false;
	      if (this._wasAtRest) {
	        this._wasAtRest = false;
	        notifyActivate = true;
	      }
	
	      var notifyAtRest = false;
	      if (isAtRest) {
	        this._wasAtRest = true;
	        notifyAtRest = true;
	      }
	
	      this.notifyPositionUpdated(notifyActivate, notifyAtRest);
	    },
	
	    notifyPositionUpdated: function(notifyActivate, notifyAtRest) {
	      for (var i = 0, len = this.listeners.length; i < len; i++) {
	        var listener = this.listeners[i];
	        if (notifyActivate && listener.onSpringActivate) {
	          listener.onSpringActivate(this);
	        }
	
	        if (listener.onSpringUpdate) {
	          listener.onSpringUpdate(this);
	        }
	
	        if (notifyAtRest && listener.onSpringAtRest) {
	          listener.onSpringAtRest(this);
	        }
	      }
	    },
	
	
	    // Check if the SpringSystem should advance. Springs are advanced
	    // a final frame after they reach equilibrium to ensure that the
	    // currentValue is exactly the requested endValue regardless of the
	    // displacement threshold.
	    systemShouldAdvance: function() {
	      return !this.isAtRest() || !this.wasAtRest();
	    },
	
	    wasAtRest: function() {
	      return this._wasAtRest;
	    },
	
	    // Check if the Spring is atRest meaning that it's currentValue and
	    // endValue are the same and that it has no velocity. The previously
	    // described thresholds for speed and displacement define the bounds
	    // of this equivalence check. If the Spring has 0 tension, then it will
	    // be considered at rest whenever its absolute velocity drops below the
	    // restSpeedThreshold.
	    isAtRest: function() {
	      return Math.abs(this._currentState.velocity) < this._restSpeedThreshold &&
	        (this.getDisplacementDistanceForState(this._currentState) <=
	          this._displacementFromRestThreshold ||
	        this._springConfig.tension === 0);
	    },
	
	    // Force the spring to be at rest at its current position. As
	    // described in the documentation for setCurrentValue, this method
	    // makes it easy to do synchronous non-animated updates to ui
	    // elements that are attached to springs via SpringListeners.
	    setAtRest: function() {
	      this._endValue = this._currentState.position;
	      this._tempState.position = this._currentState.position;
	      this._currentState.velocity = 0;
	      return this;
	    },
	
	    interpolate: function(alpha) {
	      this._currentState.position = this._currentState.position *
	        alpha + this._previousState.position * (1 - alpha);
	      this._currentState.velocity = this._currentState.velocity *
	        alpha + this._previousState.velocity * (1 - alpha);
	    },
	
	    getListeners: function() {
	      return this.listeners;
	    },
	
	    addListener: function(newListener) {
	      this.listeners.push(newListener);
	      return this;
	    },
	
	    removeListener: function(listenerToRemove) {
	      removeFirst(this.listeners, listenerToRemove);
	      return this;
	    },
	
	    removeAllListeners: function() {
	      this.listeners = [];
	      return this;
	    },
	
	    currentValueIsApproximately: function(value) {
	      return Math.abs(this.getCurrentValue() - value) <=
	        this.getRestDisplacementThreshold();
	    }
	
	  });
	
	  // PhysicsState
	  // ------------
	  // **PhysicsState** consists of a position and velocity. A Spring uses
	  // this internally to keep track of its current and prior position and
	  // velocity values.
	  var PhysicsState = function PhysicsState() {};
	
	  util.extend(PhysicsState.prototype, {
	    position: 0,
	    velocity: 0
	  });
	
	  // SpringConfig
	  // ------------
	  // **SpringConfig** maintains a set of tension and friction constants
	  // for a Spring. You can use fromOrigamiTensionAndFriction to convert
	  // values from the [Origami](http://facebook.github.io/origami/)
	  // design tool directly to Rebound spring constants.
	  var SpringConfig = rebound.SpringConfig =
	    function SpringConfig(tension, friction) {
	      this.tension = tension;
	      this.friction = friction;
	    };
	
	  // Loopers
	  // -------
	  // **AnimationLooper** plays each frame of the SpringSystem on animation
	  // timing loop. This is the default type of looper for a new spring system
	  // as it is the most common when developing UI.
	  var AnimationLooper = rebound.AnimationLooper = function AnimationLooper() {
	    this.springSystem = null;
	    var _this = this;
	    var _run = function() {
	      _this.springSystem.loop(Date.now());
	    };
	
	    this.run = function() {
	      util.onFrame(_run);
	    };
	  };
	
	  // **SimulationLooper** resolves the SpringSystem to a resting state in a
	  // tight and blocking loop. This is useful for synchronously generating
	  // pre-recorded animations that can then be played on a timing loop later.
	  // Sometimes this lead to better performance to pre-record a single spring
	  // curve and use it to drive many animations; however, it can make dynamic
	  // response to user input a bit trickier to implement.
	  rebound.SimulationLooper = function SimulationLooper(timestep) {
	    this.springSystem = null;
	    var time = 0;
	    var running = false;
	    timestep=timestep || 16.667;
	
	    this.run = function() {
	      if (running) {
	        return;
	      }
	      running = true;
	      while(!this.springSystem.getIsIdle()) {
	        this.springSystem.loop(time+=timestep);
	      }
	      running = false;
	    };
	  };
	
	  // **SteppingSimulationLooper** resolves the SpringSystem one step at a
	  // time controlled by an outside loop. This is useful for testing and
	  // verifying the behavior of a SpringSystem or if you want to control your own
	  // timing loop for some reason e.g. slowing down or speeding up the
	  // simulation.
	  rebound.SteppingSimulationLooper = function(timestep) {
	    this.springSystem = null;
	    var time = 0;
	
	    // this.run is NOOP'd here to allow control from the outside using
	    // this.step.
	    this.run = function(){};
	
	    // Perform one step toward resolving the SpringSystem.
	    this.step = function(timestep) {
	      this.springSystem.loop(time+=timestep);
	    };
	  };
	
	  // Math for converting from
	  // [Origami](http://facebook.github.io/origami/) to
	  // [Rebound](http://facebook.github.io/rebound).
	  // You mostly don't need to worry about this, just use
	  // SpringConfig.fromOrigamiTensionAndFriction(v, v);
	  var OrigamiValueConverter = rebound.OrigamiValueConverter = {
	    tensionFromOrigamiValue: function(oValue) {
	      return (oValue - 30.0) * 3.62 + 194.0;
	    },
	
	    origamiValueFromTension: function(tension) {
	      return (tension - 194.0) / 3.62 + 30.0;
	    },
	
	    frictionFromOrigamiValue: function(oValue) {
	      return (oValue - 8.0) * 3.0 + 25.0;
	    },
	
	    origamiFromFriction: function(friction) {
	      return (friction - 25.0) / 3.0 + 8.0;
	    }
	  };
	
	  // BouncyConversion provides math for converting from Origami PopAnimation
	  // config values to regular Origami tension and friction values. If you are
	  // trying to replicate prototypes made with PopAnimation patches in Origami,
	  // then you should create your springs with
	  // SpringSystem.createSpringWithBouncinessAndSpeed, which uses this Math
	  // internally to create a spring to match the provided PopAnimation
	  // configuration from Origami.
	  var BouncyConversion = rebound.BouncyConversion = function(bounciness, speed){
	    this.bounciness = bounciness;
	    this.speed = speed;
	    var b = this.normalize(bounciness / 1.7, 0, 20.0);
	    b = this.projectNormal(b, 0.0, 0.8);
	    var s = this.normalize(speed / 1.7, 0, 20.0);
	    this.bouncyTension = this.projectNormal(s, 0.5, 200)
	    this.bouncyFriction = this.quadraticOutInterpolation(
	      b,
	      this.b3Nobounce(this.bouncyTension),
	      0.01);
	  }
	
	  util.extend(BouncyConversion.prototype, {
	
	    normalize: function(value, startValue, endValue) {
	      return (value - startValue) / (endValue - startValue);
	    },
	
	    projectNormal: function(n, start, end) {
	      return start + (n * (end - start));
	    },
	
	    linearInterpolation: function(t, start, end) {
	      return t * end + (1.0 - t) * start;
	    },
	
	    quadraticOutInterpolation: function(t, start, end) {
	      return this.linearInterpolation(2*t - t*t, start, end);
	    },
	
	    b3Friction1: function(x) {
	      return (0.0007 * Math.pow(x, 3)) -
	        (0.031 * Math.pow(x, 2)) + 0.64 * x + 1.28;
	    },
	
	    b3Friction2: function(x) {
	      return (0.000044 * Math.pow(x, 3)) -
	        (0.006 * Math.pow(x, 2)) + 0.36 * x + 2.;
	    },
	
	    b3Friction3: function(x) {
	      return (0.00000045 * Math.pow(x, 3)) -
	        (0.000332 * Math.pow(x, 2)) + 0.1078 * x + 5.84;
	    },
	
	    b3Nobounce: function(tension) {
	      var friction = 0;
	      if (tension <= 18) {
	        friction = this.b3Friction1(tension);
	      } else if (tension > 18 && tension <= 44) {
	        friction = this.b3Friction2(tension);
	      } else {
	        friction = this.b3Friction3(tension);
	      }
	      return friction;
	    }
	  });
	
	  util.extend(SpringConfig, {
	    // Convert an origami Spring tension and friction to Rebound spring
	    // constants. If you are prototyping a design with Origami, this
	    // makes it easy to make your springs behave exactly the same in
	    // Rebound.
	    fromOrigamiTensionAndFriction: function(tension, friction) {
	      return new SpringConfig(
	        OrigamiValueConverter.tensionFromOrigamiValue(tension),
	        OrigamiValueConverter.frictionFromOrigamiValue(friction));
	    },
	
	    // Convert an origami PopAnimation Spring bounciness and speed to Rebound
	    // spring constants. If you are using PopAnimation patches in Origami, this
	    // utility will provide springs that match your prototype.
	    fromBouncinessAndSpeed: function(bounciness, speed) {
	      var bouncyConversion = new rebound.BouncyConversion(bounciness, speed);
	      return this.fromOrigamiTensionAndFriction(
	        bouncyConversion.bouncyTension,
	        bouncyConversion.bouncyFriction);
	    },
	
	    // Create a SpringConfig with no tension or a coasting spring with some
	    // amount of Friction so that it does not coast infininitely.
	    coastingConfigWithOrigamiFriction: function(friction) {
	      return new SpringConfig(
	        0,
	        OrigamiValueConverter.frictionFromOrigamiValue(friction)
	      );
	    }
	  });
	
	  SpringConfig.DEFAULT_ORIGAMI_SPRING_CONFIG =
	    SpringConfig.fromOrigamiTensionAndFriction(40, 7);
	
	  util.extend(SpringConfig.prototype, {friction: 0, tension: 0});
	
	  // Here are a couple of function to convert colors between hex codes and RGB
	  // component values. These are handy when performing color
	  // tweening animations.
	  var colorCache = {};
	  util.hexToRGB = function(color) {
	    if (colorCache[color]) {
	      return colorCache[color];
	    }
	    color = color.replace('#', '');
	    if (color.length === 3) {
	      color = color[0] + color[0] + color[1] + color[1] + color[2] + color[2];
	    }
	    var parts = color.match(/.{2}/g);
	
	    var ret = {
	      r: parseInt(parts[0], 16),
	      g: parseInt(parts[1], 16),
	      b: parseInt(parts[2], 16)
	    };
	
	    colorCache[color] = ret;
	    return ret;
	  };
	
	  util.rgbToHex = function(r, g, b) {
	    r = r.toString(16);
	    g = g.toString(16);
	    b = b.toString(16);
	    r = r.length < 2 ? '0' + r : r;
	    g = g.length < 2 ? '0' + g : g;
	    b = b.length < 2 ? '0' + b : b;
	    return '#' + r + g + b;
	  };
	
	  var MathUtil = rebound.MathUtil = {
	    // This helper function does a linear interpolation of a value from
	    // one range to another. This can be very useful for converting the
	    // motion of a Spring to a range of UI property values. For example a
	    // spring moving from position 0 to 1 could be interpolated to move a
	    // view from pixel 300 to 350 and scale it from 0.5 to 1. The current
	    // position of the `Spring` just needs to be run through this method
	    // taking its input range in the _from_ parameters with the property
	    // animation range in the _to_ parameters.
	    mapValueInRange: function(value, fromLow, fromHigh, toLow, toHigh) {
	      var fromRangeSize = fromHigh - fromLow;
	      var toRangeSize = toHigh - toLow;
	      var valueScale = (value - fromLow) / fromRangeSize;
	      return toLow + (valueScale * toRangeSize);
	    },
	
	    // Interpolate two hex colors in a 0 - 1 range or optionally provide a
	    // custom range with fromLow,fromHight. The output will be in hex by default
	    // unless asRGB is true in which case it will be returned as an rgb string.
	    interpolateColor:
	      function(val, startColor, endColor, fromLow, fromHigh, asRGB) {
	      fromLow = fromLow === undefined ? 0 : fromLow;
	      fromHigh = fromHigh === undefined ? 1 : fromHigh;
	      startColor = util.hexToRGB(startColor);
	      endColor = util.hexToRGB(endColor);
	      var r = Math.floor(
	        util.mapValueInRange(val, fromLow, fromHigh, startColor.r, endColor.r)
	      );
	      var g = Math.floor(
	        util.mapValueInRange(val, fromLow, fromHigh, startColor.g, endColor.g)
	      );
	      var b = Math.floor(
	        util.mapValueInRange(val, fromLow, fromHigh, startColor.b, endColor.b)
	      );
	      if (asRGB) {
	        return 'rgb(' + r + ',' + g + ',' + b + ')';
	      } else {
	        return util.rgbToHex(r, g, b);
	      }
	    },
	
	    degreesToRadians: function(deg) {
	      return (deg * Math.PI) / 180;
	    },
	
	    radiansToDegrees: function(rad) {
	      return (rad * 180) / Math.PI;
	    }
	
	  }
	
	  util.extend(util, MathUtil);
	
	
	  // Utilities
	  // ---------
	  // Here are a few useful JavaScript utilities.
	
	  // Lop off the first occurence of the reference in the Array.
	  function removeFirst(array, item) {
	    var idx = array.indexOf(item);
	    idx != -1 && array.splice(idx, 1);
	  }
	
	  var _onFrame;
	  if (typeof window !== 'undefined') {
	    _onFrame = window.requestAnimationFrame ||
	      window.webkitRequestAnimationFrame ||
	      window.mozRequestAnimationFrame ||
	      window.msRequestAnimationFrame ||
	      window.oRequestAnimationFrame;
	  }
	  if (!_onFrame && typeof process !== 'undefined' && process.title === 'node') {
	    _onFrame = setImmediate;
	  }
	
	  // Cross browser/node timer functions.
	  util.onFrame = function onFrame(func) {
	    return _onFrame(func);
	  };
	
	  // Export the public api using exports for common js or the window for
	  // normal browser inclusion.
	  if (true) {
	    util.extend(exports, rebound);
	  } else if (typeof window != 'undefined') {
	    window.rebound = rebound;
	  }
	})();
	
	
	// Legal Stuff
	// -----------
	/**
	 *  Copyright (c) 2013, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(233), __webpack_require__(598).setImmediate))

/***/ },
/* 598 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(setImmediate, clearImmediate) {var nextTick = __webpack_require__(233).nextTick;
	var apply = Function.prototype.apply;
	var slice = Array.prototype.slice;
	var immediateIds = {};
	var nextImmediateId = 0;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) { timeout.close(); };
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(window, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// That's not how node.js implements it but the exposed api is the same.
	exports.setImmediate = typeof setImmediate === "function" ? setImmediate : function(fn) {
	  var id = nextImmediateId++;
	  var args = arguments.length < 2 ? false : slice.call(arguments, 1);
	
	  immediateIds[id] = true;
	
	  nextTick(function onNextTick() {
	    if (immediateIds[id]) {
	      // fn.call() is faster so we optimize for the common use-case
	      // @see http://jsperf.com/call-apply-segu
	      if (args) {
	        fn.apply(null, args);
	      } else {
	        fn.call(null);
	      }
	      // Prevent ids from leaking
	      exports.clearImmediate(id);
	    }
	  });
	
	  return id;
	};
	
	exports.clearImmediate = typeof clearImmediate === "function" ? clearImmediate : function(id) {
	  delete immediateIds[id];
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(598).setImmediate, __webpack_require__(598).clearImmediate))

/***/ },
/* 599 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1)["default"];
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactAddons = __webpack_require__(40);
	
	var _reactAddons2 = _interopRequireDefault(_reactAddons);
	
	var CarouselItem = _reactAddons2["default"].createClass({
	  displayName: "CarouselItem",
	
	  render: function render() {
	    var style = {
	      left: this.props.baseOffset + "%"
	    };
	
	    return _reactAddons2["default"].createElement(
	      "li",
	      { className: "ofs-Carousel__Item", style: style },
	      this.props.children
	    );
	  }
	});
	
	exports["default"] = CarouselItem;
	module.exports = exports["default"];

/***/ },
/* 600 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = trackEvent;
	var settings = __webpack_require__(62);
	
	function trackEvent(category, action, opt_label, opt_value, opt_noninteraction) {
	  try {
	    if (settings.tracking.gactive) {
	      if (opt_noninteraction) {
	        ga('send', 'event', category, action, opt_label, opt_value, { nonInteraction: 1 });
	      } else {
	        ga('send', 'event', category, action, opt_label, opt_value);
	      }
	    }
	  } catch (e) {
	    // Do we care?
	  }
	}
	
	module.exports = exports['default'];

/***/ },
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _get = __webpack_require__(3)['default'];
	
	var _inherits = __webpack_require__(17)['default'];
	
	var _createClass = __webpack_require__(28)['default'];
	
	var _classCallCheck = __webpack_require__(31)['default'];
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _backbone = __webpack_require__(348);
	
	var _backbone2 = _interopRequireDefault(_backbone);
	
	var _underscore = __webpack_require__(66);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var MapOverlayView = (function (_Backbone$View) {
	  _inherits(MapOverlayView, _Backbone$View);
	
	  function MapOverlayView() {
	    _classCallCheck(this, MapOverlayView);
	
	    _get(Object.getPrototypeOf(MapOverlayView.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(MapOverlayView, [{
	    key: 'initialize',
	    value: function initialize(options) {
	      // Ensure map and API loaded
	      if (!google || !google.maps) {
	        throw new Error("Google maps API is not loaded.");
	      }
	      if (!options.map && !this.map) {
	        throw new Error("A map must be specified.");
	      }
	      this.map = options.map;
	      this.gOverlay = new this.overlay(this.overlayOptions);
	    }
	  }, {
	    key: 'bindMapEvents',
	    value: function bindMapEvents() {
	      var mapEvents = this.mapEvents;
	
	      for (var key in mapEvents) {
	        var method = mapEvents[key];
	
	        if (!_underscore2['default'].isFunction(method)) {
	          method = this[mapEvents[key]];
	        }
	        if (!method) {
	          throw new Error('Method "' + mapEvents[key] + '" does not exist');
	        }
	        method = _underscore2['default'].bind(method, this);
	        google.maps.event.addListener(this.gOverlay, key, method);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      this.bindMapEvents();
	      return this;
	    }
	  }, {
	    key: 'remove',
	    value: function remove(args) {
	      google.maps.event.clearInstanceListeners(this.gOverlay);
	      this.gOverlay.setMap(null);
	      delete this.gOverlay;
	      _get(Object.getPrototypeOf(MapOverlayView.prototype), 'remove', this).call(this, args);
	      return this;
	    }
	  }, {
	    key: 'mapEvents',
	    get: function get() {
	      return {};
	    }
	  }, {
	    key: 'overlay',
	    get: function get() {
	      throw new Error('Overlay constructor not supplied');
	    }
	  }, {
	    key: 'overlayOptions',
	    get: function get() {
	      return {
	        map: this.map
	      };
	    }
	  }]);
	
	  return MapOverlayView;
	})(_backbone2['default'].View);
	
	exports['default'] = MapOverlayView;
	module.exports = exports['default'];

/***/ },
/* 624 */,
/* 625 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(3)['default'];
	
	var _inherits = __webpack_require__(17)['default'];
	
	var _createClass = __webpack_require__(28)['default'];
	
	var _classCallCheck = __webpack_require__(31)['default'];
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _MarkerView2 = __webpack_require__(626);
	
	var _MarkerView3 = _interopRequireDefault(_MarkerView2);
	
	var SelectableMarkerView = (function (_MarkerView) {
	  _inherits(SelectableMarkerView, _MarkerView);
	
	  function SelectableMarkerView() {
	    _classCallCheck(this, SelectableMarkerView);
	
	    _get(Object.getPrototypeOf(SelectableMarkerView.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(SelectableMarkerView, [{
	    key: 'initialize',
	    value: function initialize(options) {
	      _get(Object.getPrototypeOf(SelectableMarkerView.prototype), 'initialize', this).call(this, options);
	      this.listenTo(this.model, 'selected', this.openDetail);
	      this.listenTo(this.model, 'deselected', this.closeDetail);
	    }
	  }, {
	    key: 'markerClicked',
	    value: function markerClicked() {
	      this.model.addToNewSelection();
	    }
	  }, {
	    key: 'mapEvents',
	    get: function get() {
	      return {
	        'click': 'markerClicked'
	      };
	    }
	  }]);
	
	  return SelectableMarkerView;
	})(_MarkerView3['default']);
	
	exports['default'] = SelectableMarkerView;
	module.exports = exports['default'];

/***/ },
/* 626 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(3)['default'];
	
	var _inherits = __webpack_require__(17)['default'];
	
	var _createClass = __webpack_require__(28)['default'];
	
	var _classCallCheck = __webpack_require__(31)['default'];
	
	var _Object$assign = __webpack_require__(32)['default'];
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _MapOverlayView2 = __webpack_require__(623);
	
	var _MapOverlayView3 = _interopRequireDefault(_MapOverlayView2);
	
	var _InfoWindowView = __webpack_require__(627);
	
	var _InfoWindowView2 = _interopRequireDefault(_InfoWindowView);
	
	var _underscore = __webpack_require__(66);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var MarkerView = (function (_MapOverlayView) {
	  _inherits(MarkerView, _MapOverlayView);
	
	  function MarkerView() {
	    _classCallCheck(this, MarkerView);
	
	    _get(Object.getPrototypeOf(MarkerView.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(MarkerView, [{
	    key: 'initialize',
	    value: function initialize(options) {
	      if (!this.model) {
	        throw new Error("A model must be specified for a MarkerView");
	      }
	      _get(Object.getPrototypeOf(MarkerView.prototype), 'initialize', this).call(this, options);
	    }
	
	    // Show the google maps marker overlay
	  }, {
	    key: 'render',
	    value: function render() {
	      _get(Object.getPrototypeOf(MarkerView.prototype), 'render', this).call(this);
	      this.gOverlay.setVisible(true);
	      return this;
	    }
	  }, {
	    key: 'remove',
	    value: function remove() {
	      this.closeDetail();
	      _get(Object.getPrototypeOf(MarkerView.prototype), 'remove', this).call(this, arguments);
	      return this;
	    }
	  }, {
	    key: 'openDetail',
	    value: function openDetail() {
	      if (!this.infoWindowView) {
	        throw new Error("An InfoWindow must be specified for opening");
	      }
	      if (!this.detailView) {
	        this.detailView = new this.infoWindowView(this.openDetailOptions);
	      }
	      this.detailView.render();
	    }
	  }, {
	    key: 'closeDetail',
	    value: function closeDetail() {
	      if (this.detailView) {
	        this.detailView.remove();
	        delete this.detailView;
	      }
	    }
	  }, {
	    key: 'infoWindowView',
	    get: function get() {
	      return _InfoWindowView2['default'];
	    }
	  }, {
	    key: 'openDetailOptions',
	    get: function get() {
	      return {
	        model: this.model,
	        map: this.map,
	        marker: this.gOverlay
	      };
	    }
	  }, {
	    key: 'overlay',
	    get: function get() {
	      return google.maps.Marker;
	    }
	  }, {
	    key: 'overlayOptions',
	    get: function get() {
	      return _Object$assign(_get(Object.getPrototypeOf(MarkerView.prototype), 'overlayOptions', this), {
	        position: this.model.getLatLng(),
	        title: this.model.title,
	        visible: false
	      });
	    }
	  }]);
	
	  return MarkerView;
	})(_MapOverlayView3['default']);
	
	exports['default'] = MarkerView;
	module.exports = exports['default'];

/***/ },
/* 627 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(3)['default'];
	
	var _inherits = __webpack_require__(17)['default'];
	
	var _createClass = __webpack_require__(28)['default'];
	
	var _classCallCheck = __webpack_require__(31)['default'];
	
	var _Object$assign = __webpack_require__(32)['default'];
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _MapOverlayView2 = __webpack_require__(623);
	
	var _MapOverlayView3 = _interopRequireDefault(_MapOverlayView2);
	
	var _ofsGoogleMapsInfoWindow = __webpack_require__(628);
	
	var _ofsGoogleMapsInfoWindow2 = _interopRequireDefault(_ofsGoogleMapsInfoWindow);
	
	var InfoWindowView = (function (_MapOverlayView) {
	  _inherits(InfoWindowView, _MapOverlayView);
	
	  function InfoWindowView() {
	    _classCallCheck(this, InfoWindowView);
	
	    _get(Object.getPrototypeOf(InfoWindowView.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(InfoWindowView, [{
	    key: 'initialize',
	    value: function initialize(options) {
	      if (!options.marker) {
	        throw new Error("A marker must be specified for InfoWindow view.");
	      }
	      this.marker = options.marker;
	      _get(Object.getPrototypeOf(InfoWindowView.prototype), 'initialize', this).call(this, options);
	    }
	  }, {
	    key: 'renderTemplate',
	    value: function renderTemplate() {
	      this.$el.html(this.template({
	        model: this.model
	      }));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      _get(Object.getPrototypeOf(InfoWindowView.prototype), 'render', this).call(this, arguments);
	      this.renderTemplate();
	
	      // Display InfoWindow on map
	      this.gOverlay.open(this.map, this.marker);
	      return this;
	    }
	  }, {
	    key: 'tagName',
	    get: function get() {
	      return 'div';
	    }
	  }, {
	    key: 'className',
	    get: function get() {
	      return 'ofs-infowindow';
	    }
	  }, {
	    key: 'overlay',
	    get: function get() {
	      return _ofsGoogleMapsInfoWindow2['default'];
	    }
	  }, {
	    key: 'overlayOptions',
	    get: function get() {
	      return _Object$assign(_get(Object.getPrototypeOf(InfoWindowView.prototype), 'overlayOptions', this), {
	        margin: new google.maps.Size(40, 40),
	        maxHeight: 450,
	        offset: new google.maps.Size(0, -50),
	        closeOnMapClick: true,
	        marker: this.marker,
	        elem: this.$el
	      });
	    }
	  }]);
	
	  return InfoWindowView;
	})(_MapOverlayView3['default']);
	
	exports['default'] = InfoWindowView;
	module.exports = exports['default'];

/***/ },
/* 628 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(3)['default'];
	
	var _inherits = __webpack_require__(17)['default'];
	
	var _createClass = __webpack_require__(28)['default'];
	
	var _classCallCheck = __webpack_require__(31)['default'];
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _jquery = __webpack_require__(39);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _underscore = __webpack_require__(66);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var InfoWindow = (function (_google$maps$OverlayView) {
	  _inherits(InfoWindow, _google$maps$OverlayView);
	
	  function InfoWindow(opts) {
	    _classCallCheck(this, InfoWindow);
	
	    var defaults = {
	      map: null,
	      elem: null,
	      disableAutoPan: false,
	      position: new google.maps.LatLng(0, 0),
	      closeOnMapClick: true,
	      margin: new google.maps.Size(0, 0),
	      offset: new google.maps.Size(0, -10),
	      showDebugOverlays: false
	    };
	    var options = _jquery2['default'].extend({}, defaults, opts);
	
	    _get(Object.getPrototypeOf(InfoWindow.prototype), 'constructor', this).call(this, arguments);
	
	    this.options = options;
	
	    if (!_underscore2['default'].isArray(options.margin)) {
	      options.margin = [options.margin, options.margin];
	    }
	
	    this.elem = options.elem;
	    this.position = options.position;
	    this.opening = false;
	    this.eventListeners = [];
	    this.moveListener = null;
	
	    if (options.showDebugOverlays) {
	      this.rectangle = new google.maps.Rectangle();
	    }
	  }
	
	  _createClass(InfoWindow, [{
	    key: 'panBox',
	    value: function panBox() {
	      if (!this.options.disableAutoPan) {
	        var map = this.getMap();
	
	        if (map instanceof google.maps.Map) {
	          var $map = (0, _jquery2['default'])(map.getDiv());
	          var center = map.getCenter();
	          var mapWidth = $map.width();
	          var mapHeight = $map.height();
	          var iwWidth = this.elem.outerWidth();
	          var iwHeight = this.elem.outerHeight();
	
	          var pixPosition = this.getProjection().fromLatLngToContainerPixel(this.position);
	
	          var halfWidth = iwWidth / 2;
	
	          var markerEdges = {
	            top: pixPosition.y - iwHeight + this.options.offset.height - this.options.margin[0].height,
	            left: pixPosition.x - halfWidth + this.options.offset.width - this.options.margin[0].width,
	            bottom: pixPosition.y + this.options.margin[1].height / 2,
	            right: pixPosition.x + halfWidth + this.options.offset.width + this.options.margin[1].width
	          };
	
	          var ne = this.getProjection().fromContainerPixelToLatLng(new google.maps.Point(markerEdges.left, markerEdges.top), true);
	
	          var sw = this.getProjection().fromContainerPixelToLatLng(new google.maps.Point(markerEdges.right, markerEdges.bottom), true);
	
	          var bounds = new google.maps.LatLngBounds(ne, sw);
	
	          if (this.options.showDebugOverlays) {
	            var rectOptions = {
	              strokeColor: "#FF0000",
	              strokeOpacity: 0.8,
	              strokeWeight: 2,
	              fillColor: "#FF0000",
	              fillOpacity: 0.35,
	              map: map,
	              bounds: bounds
	            };
	            this.rectangle.setOptions(rectOptions);
	          }
	          map.panToBounds(bounds);
	        }
	      }
	    }
	  }, {
	    key: 'onAdd',
	    value: function onAdd() {
	      this.elem.hide();
	      this.div = this.elem[0];
	
	      var cancelHandler = function cancelHandler(e) {
	        e.cancelBubble = true;
	        if (e.stopPropagation) {
	          e.stopPropagation();
	        }
	      };
	
	      this.elem.on('mousewheel wheeldown wheel scrollwheel', function (event) {
	        event.stopPropagation();
	      });
	
	      var events = ["mousedown", "scrollwheel", "mouseover", "wheel", "mousewheel", "wheelup", "wheeldown", "mouseout", "mouseup", "click", "dblclick", "touchstart", "touchend", "touchmove"];
	
	      for (var i = 0; i < events.length; i++) {
	        this.eventListeners.push(google.maps.event.addDomListener(this.div, events[i], cancelHandler));
	      }
	
	      this.eventListeners.push(google.maps.event.addDomListener(this.div, "mouseover", function (e) {
	        this.style.cursor = "default";
	      }));
	
	      var panes = this.getPanes();
	      panes.floatPane.appendChild(this.div);
	    }
	  }, {
	    key: 'draw',
	    value: function draw() {
	      var me = this;
	
	      var pixPosition = this.getProjection().fromLatLngToDivPixel(this.position);
	
	      var offsetX = this.elem.outerWidth() / 2 + this.options.offset.width;
	      var offsetY = this.elem.outerHeight() - this.options.offset.height;
	
	      this.elem.css('left', pixPosition.x - offsetX + "px");
	      this.elem.css('top', pixPosition.y - offsetY + "px");
	
	      if (this.isHidden) {
	        this.elem.hide();
	      } else {
	        this.elem.show();
	        if (this.div && this.opening) {
	          this.panBox();
	          this.opening = false;
	        }
	      }
	    }
	  }, {
	    key: 'setHTML',
	    value: function setHTML(html) {
	      this.html = html;
	      this.updateHTML();
	    }
	  }, {
	    key: 'onRemove',
	    value: function onRemove() {
	      if (this.div) {
	        this.elem.remove();
	      }
	    }
	  }, {
	    key: 'setPosition',
	    value: function setPosition(latlng) {
	      this.position = latlng;
	
	      if (this.div) {
	        this.draw();
	      }
	      google.maps.event.trigger(this, "position_changed");
	    }
	  }, {
	    key: 'getPosition',
	    value: function getPosition() {
	      return this.position;
	    }
	  }, {
	    key: 'open',
	    value: function open(map, anchor) {
	      var me = this;
	      this.opening = true;
	
	      if (anchor) {
	        if (this.getPosition() !== anchor.getPosition()) {
	          this.position = anchor.getPosition();
	          this.moveListener = google.maps.event.addListener(anchor, "position_changed", function () {
	            me.setPosition(this.getPosition());
	          });
	        }
	      }
	      this.setMap(map);
	
	      if (this.options.closeOnMapClick) {
	        this.eventListeners.push(google.maps.event.addListener(map, 'click', function () {
	          me.close(map);
	        }));
	      }
	
	      this.elem.on('click', '.close', function () {
	        me.close(map);
	      });
	    }
	  }, {
	    key: 'close',
	    value: function close(map) {
	      if (this.moveListener) {
	        google.maps.event.removeListener(this.moveListener);
	        this.moveListener = null;
	      }
	
	      if (this.eventListeners) {
	        for (var i = 0; i < this.eventListeners.length; i++) {
	          google.maps.event.removeListener(this.eventListeners[i]);
	        }
	        this.eventListeners = [];
	      }
	      this.setMap(null);
	
	      if (this.options.showDebugOverlays) {
	        this.rectangle.setMap(null);
	        delete this.rectangle;
	      }
	    }
	  }]);
	
	  return InfoWindow;
	})(google.maps.OverlayView);
	
	exports['default'] = InfoWindow;
	module.exports = exports['default'];

/***/ },
/* 629 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(3)['default'];
	
	var _inherits = __webpack_require__(17)['default'];
	
	var _createClass = __webpack_require__(28)['default'];
	
	var _classCallCheck = __webpack_require__(31)['default'];
	
	var _Object$assign = __webpack_require__(32)['default'];
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _InfoWindowView2 = __webpack_require__(627);
	
	var _InfoWindowView3 = _interopRequireDefault(_InfoWindowView2);
	
	var _jquery = __webpack_require__(39);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _ofsTemplatesUnitDetail = __webpack_require__(630);
	
	var _ofsTemplatesUnitDetail2 = _interopRequireDefault(_ofsTemplatesUnitDetail);
	
	var UnitInfoWindowView = (function (_InfoWindowView) {
	  _inherits(UnitInfoWindowView, _InfoWindowView);
	
	  function UnitInfoWindowView() {
	    _classCallCheck(this, UnitInfoWindowView);
	
	    _get(Object.getPrototypeOf(UnitInfoWindowView.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(UnitInfoWindowView, [{
	    key: 'renderTemplate',
	    value: function renderTemplate() {
	      _get(Object.getPrototypeOf(UnitInfoWindowView.prototype), 'renderTemplate', this).call(this, arguments);
	      var color = '#333';
	      this.$el.find('.ofs-infowindow-footer').css('background-color', color);
	      this.$el.find('.ofs-infowindow-arrow span').css('border-top-color', color);
	    }
	  }, {
	    key: 'template',
	    get: function get() {
	      return _ofsTemplatesUnitDetail2['default'];
	    }
	  }, {
	    key: 'className',
	    get: function get() {
	      return 'ofs-infowindow ofs-unit-infowindow';
	    }
	  }, {
	    key: 'overlayOptions',
	    get: function get() {
	      return _Object$assign(_get(Object.getPrototypeOf(UnitInfoWindowView.prototype), 'overlayOptions', this), {
	        offset: new google.maps.Size(0, -35)
	      });
	    }
	  }]);
	
	  return UnitInfoWindowView;
	})(_InfoWindowView3['default']);
	
	exports['default'] = UnitInfoWindowView;
	module.exports = exports['default'];

/***/ },
/* 630 */
/***/ function(module, exports) {

	module.exports = function anonymous(locals, escape, include, rethrow) {
	escape = escape || function (markup) {
	  return markup == undefined
	    ? ''
	    : String(markup)
	        .replace(_MATCH_HTML, encode_char);
	};
	var _ENCODE_HTML_RULES = {
	      "&": "&amp;"
	    , "<": "&lt;"
	    , ">": "&gt;"
	    , '"': "&#34;"
	    , "'": "&#39;"
	    }
	  , _MATCH_HTML = /[&<>'"]/g;
	function encode_char(c) {
	  return _ENCODE_HTML_RULES[c] || c;
	};
	;
	  var __output = [], __append = __output.push.bind(__output);
	  with (locals || {}) {
	    ; __append("<div class=\"ofs-infowindow-arrow\"><span></span></div>\n<div class=\"ofs-infowindow-content\">\n  <div class=\"close\">&times;</div>\n  <div class=\"unit-detail-header\">\n    <a href=\"")
	    ; __append(escape(model.get('site_url')))
	    ; __append("\"><img src=\"")
	    ; __append(escape(model.get('image_url')))
	    ; __append("\" style=\"max-width: 100%;\" /></a>\n    <h2><a href=\"")
	    ; __append(escape(model.get('site_url')))
	    ; __append("\">")
	    ; __append(escape(model.get('name')))
	    ; __append("</a></h2>\n    ")
	    ;  if (model.get('location')) { 
	    ; __append("\n    <p class=\"location quiet\">")
	    ; __append(escape(model.get('location')))
	    ; __append("</p>\n    ")
	    ;  } 
	    ; __append("\n    <p><a href=\"")
	    ; __append(escape(model.get('site_url')))
	    ; __append("\">More details</a></p>\n  </div>\n</div>\n<div class=\"ofs-infowindow-footer\">\n  ")
	    ;  if (model.get('price')) { 
	    ; __append("<div class=\"price\">from <strong>")
	    ; __append(model.get('price'))
	    ; __append("</strong>/night</div>\n  ")
	    ;  } else if (model.get('currency_code') && model.get('marketing_price')) { 
	    ; __append("<div class=\"price\">from <strong>")
	    ; __append(escape(model.get('currency_code')))
	    ; __append(escape(model.get('marketing_price')))
	    ; __append("</strong>/night</div>\n  ")
	    ;  } 
	    ; __append("\n  <div class=\"footerbits\">\n    <span class=\"icon-sleeps-nocircle\"></span>")
	    ; __append(escape(model.get('sleeps')))
	    ;  if (model.get('sleeps_max') > model.get('sleeps')) { 
	    ; __append(" &ndash; ")
	    ; __append(escape(model.get('sleeps_max')))
	    ;  } 
	    ; __append("\n    <span class=\"icon-bedrooms-nocircle\"></span>")
	    ; __append(escape(model.get('bedrooms')))
	    ; __append("\n  </div>\n</div>\n")
	  }
	  return __output.join("");
	
	}

/***/ },
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _jquery = __webpack_require__(39);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _underscore = __webpack_require__(66);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _immutable = __webpack_require__(68);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _fluxxor = __webpack_require__(69);
	
	var _fluxxor2 = _interopRequireDefault(_fluxxor);
	
	var _ofsMoment = __webpack_require__(57);
	
	var _ofsMoment2 = _interopRequireDefault(_ofsMoment);
	
	var _ofsAppsCoreConstants = __webpack_require__(336);
	
	var _ofsAppsCoreConstants2 = _interopRequireDefault(_ofsAppsCoreConstants);
	
	var AvailabilityStore = _fluxxor2['default'].createStore({
	  actions: {
	    HIGHLIGHT_CALENDAR_DATE: 'onHighlightDate',
	    HIGHLIGHT_CALENDAR_RANGE: 'onHighlightRange',
	    UNHIGHLIGHT_CALENDAR_DATE: 'onUnHighlightDate',
	    START_CALENDAR_RANGE_SELECTION: 'onStartRangeSelection',
	    COMPLETE_CALENDAR_RANGE_SELECTION: 'onCompleteRangeSelection'
	  },
	
	  initialize: function initialize(options) {
	    var stateRanges;
	
	    this.setMaxListeners(0);
	    this.state = _immutable2['default'].fromJS(options);
	
	    stateRanges = this.state.get('stateRanges').map(function (r) {
	      return _immutable2['default'].Map({
	        range: (0, _ofsMoment2['default'])().range(r.get(0), r.get(1)),
	        state: r.get(2),
	        selectable: r.get(3)
	      });
	    });
	
	    this.state = this.state.set('stateRanges', stateRanges);
	    this.state = this.state.set('selectionType', 'range');
	
	    if (this.state.get('preSelectedStartDate') && this.state.get('preSelectedEndDate')) {
	      this.state = this.state.set('selectedRange', (0, _ofsMoment2['default'])().range(this.state.get('preSelectedStartDate'), this.state.get('preSelectedEndDate')));
	
	      this.state = this.state.set('selectedRangeStates', this.statesForRange(this.state.get('selectedRange')));
	    }
	  },
	
	  onStartRangeSelection: function onStartRangeSelection(payload) {
	    this.state = this.state.set('selectedStartDate', payload.date);
	    this.emit('change');
	  },
	
	  onCompleteRangeSelection: function onCompleteRangeSelection(payload) {
	    this.state = this.state.withMutations(function (s) {
	      s.set('selectedRange', payload.range).set('selectedRangeStates', _immutable2['default'].fromJS(payload.states)).set('selectedStartDate', null).set('highlightedRange', null).set('highlightedDate', null);
	    });
	    this.emit('change');
	  },
	
	  statesForRange: function statesForRange(range) {
	    if (range.start.isSame(range.end)) {
	      return this.state.get('stateRanges').filter(function (d) {
	        return range.start.within(d.get('range'));
	      }).map(function (d) {
	        return d.get('state');
	      });
	    }
	    return this.state.get('stateRanges').filter(function (d) {
	      return d.get('range').intersect(range);
	    }).map(function (d) {
	      return d.get('state');
	    });
	  },
	
	  onHighlightDate: function onHighlightDate(payload) {
	    this.state = this.state.set('highlightedDate', payload.date);
	    this.emit('change');
	  },
	
	  onHighlightRange: function onHighlightRange(payload) {
	    this.state = this.state.withMutations(function (s) {
	      s.set('highlightedRange', payload.range).set('highlightedDate', null);
	    });
	    this.emit('change');
	  },
	
	  onUnHighlightDate: function onUnHighlightDate(payload) {
	    this.state = this.state.set('highlightedDate', null);
	    this.emit('change');
	  }
	});
	
	exports['default'] = AvailabilityStore;
	module.exports = exports['default'];

/***/ },
/* 639 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _jquery = __webpack_require__(39);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _immutable = __webpack_require__(68);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _fluxxor = __webpack_require__(69);
	
	var _fluxxor2 = _interopRequireDefault(_fluxxor);
	
	var _ofsMoment = __webpack_require__(57);
	
	var _ofsMoment2 = _interopRequireDefault(_ofsMoment);
	
	var BookingQuoteStore = _fluxxor2['default'].createStore({
	  actions: {
	    COMPLETE_CALENDAR_RANGE_SELECTION: 'onRangeSelection',
	    BOOKING_QUOTE_UPDATE: 'onBookingQuoteUpdate',
	    BOOKING_QUOTE_ERROR: 'onBookingQuoteError'
	  },
	
	  initialize: function initialize(options) {
	    this.setMaxListeners(0);
	    this.state = _immutable2['default'].fromJS(options);
	
	    if (this.state.get('startDate')) {
	      this.state = this.state.set('startDate', (0, _ofsMoment2['default'])(this.state.get('startDate'), 'YYYY-MM-DD'));
	    }
	    if (this.state.get('endDate')) {
	      this.state = this.state.set('endDate', (0, _ofsMoment2['default'])(this.state.get('endDate'), 'YYYY-MM-DD'));
	    }
	
	    if (this.state.get('startDate') && this.state.get('endDate')) {
	      this.state = this.state.set('range', (0, _ofsMoment2['default'])().range(this.state.get('startDate'), this.state.get('endDate')));
	    } else {
	      this.state = this.state.set('range', null);
	    }
	  },
	
	  onRangeSelection: function onRangeSelection(payload) {
	    this.state = this.state.withMutations(function (s) {
	      s.set('range', payload.range).set('bookable', false).set('quoteData', null).set('loading', true);
	    });
	
	    this.emit('change');
	
	    this.updateQuote();
	  },
	
	  onBookingQuoteUpdate: function onBookingQuoteUpdate(payload) {
	    this.state = this.state.withMutations(function (s) {
	      s.set('quoteData', payload.data).set('bookable', !payload.data['error_msg']).set('loading', false);
	    });
	    this.emit('change');
	  },
	
	  onBookingQuoteError: function onBookingQuoteError() {
	    this.state = this.state.withMutations(function (s) {
	      s.set('quoteData', null).set('bookable', false).set('loading', false);
	    });
	    this.emit('change');
	  },
	
	  getFormattedStartDate: function getFormattedStartDate() {
	    if (this.state.get('range')) {
	      return this.state.get('range').start.format('D MMMM YYYY');
	    }
	    return null;
	  },
	
	  getFormattedEndDate: function getFormattedEndDate() {
	    if (this.state.get('range')) {
	      return this.state.get('range').end.format('D MMMM YYYY');
	    }
	    return null;
	  },
	
	  getISO8601StartDate: function getISO8601StartDate() {
	    if (this.state.get('range')) {
	      return this.state.get('range').start.format('YYYY-MM-DD');
	    }
	    return null;
	  },
	
	  getISO8601EndDate: function getISO8601EndDate() {
	    if (this.state.get('range')) {
	      return this.state.get('range').end.format('YYYY-MM-DD');
	    }
	    return null;
	  },
	
	  updateQuote: function updateQuote() {
	    var startDate = this.getISO8601StartDate();
	    var endDate = this.getISO8601EndDate();
	
	    if (startDate && endDate) {
	      _jquery2['default'].ajax({
	        url: this.state.get('quoteUrl'),
	        method: 'POST',
	        data: {
	          'start_date': startDate,
	          'end_date': endDate,
	          'page': 'summary'
	        },
	        success: this.flux.actions.quote.update,
	        error: this.flux.actions.quote.error
	      });
	    }
	  }
	});
	
	exports['default'] = BookingQuoteStore;
	module.exports = exports['default'];

/***/ },
/* 640 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _immutable = __webpack_require__(68);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _fluxxor = __webpack_require__(69);
	
	var _fluxxor2 = _interopRequireDefault(_fluxxor);
	
	var _ofsMoment = __webpack_require__(57);
	
	var _ofsMoment2 = _interopRequireDefault(_ofsMoment);
	
	var _ofsAppsCoreConstants = __webpack_require__(336);
	
	var _ofsAppsCoreConstants2 = _interopRequireDefault(_ofsAppsCoreConstants);
	
	var UnitStore = _fluxxor2['default'].createStore({
	  actions: {},
	
	  initialize: function initialize(options) {
	    this.setMaxListeners(0);
	    this.state = _immutable2['default'].fromJS(options);
	  }
	});
	
	exports['default'] = UnitStore;
	module.exports = exports['default'];

/***/ },
/* 641 */,
/* 642 */,
/* 643 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _fluxxor = __webpack_require__(69);
	
	var _fluxxor2 = _interopRequireDefault(_fluxxor);
	
	var _ofsAppsCoreConstants = __webpack_require__(336);
	
	var _ofsAppsCoreConstants2 = _interopRequireDefault(_ofsAppsCoreConstants);
	
	var _ofsAppsCoreUtilsEvent = __webpack_require__(644);
	
	var ScrollStore = _fluxxor2['default'].createStore({
	  initialize: function initialize() {
	    this.bindActions(_ofsAppsCoreConstants2['default'].DISABLE_SCROLL, this.disable, _ofsAppsCoreConstants2['default'].ENABLE_SCROLL, this.enable, _ofsAppsCoreConstants2['default'].SCROLL_TO, this.to);
	  },
	
	  disable: function disable() {
	    document.body.style['padding-bottom'] = '60px';
	    document.body.style.overflow = 'hidden';
	    window.ontouchmove = _ofsAppsCoreUtilsEvent.preventDefault;
	    this.emit('change');
	  },
	
	  enable: function enable() {
	    document.body.style['padding-bottom'] = '';
	    document.body.style.overflow = '';
	    window.ontouchmove = undefined;
	    this.emit('change');
	  },
	
	  to: function to(payload) {
	    window.scrollTo(payload.x, payload.y);
	  }
	
	});
	
	exports['default'] = ScrollStore;
	module.exports = exports['default'];

/***/ },
/* 644 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.preventDefault = preventDefault;
	
	function preventDefault(e) {
	  e = e || window.event;
	  if (e.preventDefault) {
	    e.preventDefault();
	  }
	  e.returnValue = false;
	}

/***/ },
/* 645 */,
/* 646 */,
/* 647 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * This is a straight rip-off of the React.js ReactPropTypes.js proptype validators,
	 * modified to make it possible to validate Immutable.js data.
	 *     ImmutableTypes.listOf is patterned after React.PropTypes.arrayOf, but for Immutable.List
	 *     ImmutableTypes.shape  is based on React.PropTypes.shape, but for any Immutable.Iterable
	 */
	"use strict";
	
	var Immutable = __webpack_require__(68);
	
	var ANONYMOUS = "<<anonymous>>";
	
	var ImmutablePropTypes = {
	  listOf: createListOfTypeChecker,
	  mapOf: createMapOfTypeChecker,
	  setOf: createSetOfTypeChecker,
	  iterableOf: createIterableOfTypeChecker,
	  shape: createShapeTypeChecker,
	  contains: createShapeTypeChecker,
	  // Primitive Types
	  list: createImmutableTypeChecker("List", Immutable.List.isList),
	  map: createImmutableTypeChecker("Map", Immutable.Map.isMap),
	  orderedMap: createImmutableTypeChecker("OrderedMap", Immutable.OrderedMap.isOrderedMap),
	  set: createImmutableTypeChecker("Set", Immutable.Set.isSet),
	  orderedSet: createImmutableTypeChecker("OrderedSet", Immutable.OrderedSet.isOrderedSet),
	  stack: createImmutableTypeChecker("Stack", Immutable.Stack.isStack),
	  seq: createImmutableTypeChecker("Seq", Immutable.Seq.isSeq),
	  iterable: createImmutableTypeChecker("Iterable", Immutable.Iterable.isIterable)
	};
	
	function getPropType(propValue) {
	  var propType = typeof propValue;
	  if (Array.isArray(propValue)) {
	    return "array";
	  }
	  if (propValue instanceof RegExp) {
	    // Old webkits (at least until Android 4.0) return 'function' rather than
	    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	    // passes PropTypes.object.
	    return "object";
	  }
	  return propType;
	}
	
	function createChainableTypeChecker(validate) {
	  function checkType(isRequired, props, propName, componentName, location) {
	    componentName = componentName || ANONYMOUS;
	    if (props[propName] == null) {
	      var locationName = location;
	      if (isRequired) {
	        return new Error("Required " + locationName + " `" + propName + "` was not specified in " + ("`" + componentName + "`."));
	      }
	    } else {
	      return validate(props, propName, componentName, location);
	    }
	  }
	
	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);
	
	  return chainedCheckType;
	}
	
	function createImmutableTypeChecker(immutableClassName, immutableClassTypeValidator) {
	  function validate(props, propName, componentName, location) {
	    var propValue = props[propName];
	    if (!immutableClassTypeValidator(propValue)) {
	      var propType = getPropType(propValue);
	      return new Error("Invalid " + location + " `" + propName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `" + immutableClassName + "`."));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createIterableTypeChecker(typeChecker, immutableClassName, immutableClassTypeValidator) {
	  function validate(props, propName, componentName, location) {
	    var propValue = props[propName];
	    if (!immutableClassTypeValidator(propValue)) {
	      var locationName = location;
	      var propType = getPropType(propValue);
	      return new Error("Invalid " + locationName + " `" + propName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an Immutable.js " + immutableClassName + "."));
	    }
	    var propValues = propValue.toArray();
	    for (var i = 0, len = propValues.length; i < len; i++) {
	      var error = typeChecker(propValues, i, componentName, location);
	      if (error instanceof Error) {
	        return error;
	      }
	    }
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createListOfTypeChecker(typeChecker) {
	  return createIterableTypeChecker(typeChecker, "List", Immutable.List.isList);
	}
	
	function createMapOfTypeChecker(typeChecker) {
	  return createIterableTypeChecker(typeChecker, "Map", Immutable.Map.isMap);
	}
	
	function createSetOfTypeChecker(typeChecker) {
	  return createIterableTypeChecker(typeChecker, "Set", Immutable.Set.isSet);
	}
	
	function createIterableOfTypeChecker(typeChecker) {
	  return createIterableTypeChecker(typeChecker, "Iterable", Immutable.Iterable.isIterable);
	}
	
	// there is some irony in the fact that shapeTypes is a standard hash and not an immutable collection
	function createShapeTypeChecker(shapeTypes) {
	  function validate(props, propName, componentName, location) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (!Immutable.Iterable.isIterable(propValue)) {
	      var locationName = location;
	      return new Error("Invalid " + locationName + " `" + propName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected an Immutable.js Iterable."));
	    }
	    for (var key in shapeTypes) {
	      var checker = shapeTypes[key];
	      if (!checker) {
	        continue;
	      }
	      var mutablePropValue = propValue.toObject();
	      var error = checker(mutablePropValue, key, componentName, location);
	      if (error) {
	        return error;
	      }
	    }
	  }
	  return createChainableTypeChecker(validate);
	}
	
	module.exports = ImmutablePropTypes;

/***/ },
/* 648 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _Object$assign = __webpack_require__(32)['default'];
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.createContainer = createContainer;
	
	var _reactAddons = __webpack_require__(40);
	
	var _reactAddons2 = _interopRequireDefault(_reactAddons);
	
	var _reactLibShallowEqual = __webpack_require__(480);
	
	var _reactLibShallowEqual2 = _interopRequireDefault(_reactLibShallowEqual);
	
	function createStoreListener(getter, store, flux) {
	  return function () {
	    if (this.isMounted()) {
	      var state = getter(store, this.props, flux);
	      this.setState(state);
	    }
	  };
	}
	
	function getStore(flux, name) {
	  var store = flux.store(name);
	  if (typeof store === 'undefined') {
	    throw new Error('createContainer(): Store with name \'' + name + '\' does not exist.');
	  }
	
	  return store;
	}
	
	/**
	 * `createContainer()`
	 *
	 * Create a container React component that listens to changes in stores and
	 * passes defined state as properties to a component.
	 *
	 * Example:
	 *
	 *   const HomeContainer = createContainer(Home, {
	 *     pure: true, // if container can be a pure component
	 *     stores: {
	 *       // the key corresponds to the store's name
	 *       'Homes': (store, props, flux) => {
	 *         // return props to be passed to the component
	 *         return {
	 *           home: store.state.get(props.homeId)
	 *         }
	 *       }
	 *     }
	 *   });
	 *
	 *   // render
	 *   <div>
	 *      <HomeContainer homeId={homeId} />
	 *   </div>
	 *
	 */
	
	function createContainer(Component, options) {
	  if (typeof options === 'undefined') {
	    options = {};
	  }
	
	  var Container = _reactAddons2['default'].createClass({
	    displayName: Component.displayName + "Container",
	    contextTypes: {
	      flux: _reactAddons2['default'].PropTypes.object
	    },
	
	    childContextTypes: {
	      flux: _reactAddons2['default'].PropTypes.object
	    },
	
	    getChildContext: function getChildContext() {
	      return {
	        flux: this.getFlux()
	      };
	    },
	
	    _fluxStateGetters: [],
	    _fluxListeners: {},
	
	    getFlux: function getFlux() {
	      return this.props.flux || this.context && this.context.flux;
	    },
	
	    getInitialState: function getInitialState() {
	      var flux = this.getFlux();
	
	      if (!flux) {
	        throw new Error(this.constructor.displayName + ': Could not find Flux instance. Ensure that your component has either `this.context.flux` or `this.props.flux`.');
	      }
	
	      var passthrough = function passthrough() {};
	
	      for (var storeName in options.stores) {
	        var store = getStore(flux, storeName);
	        var getter = options.stores[storeName];
	
	        if (typeof getter !== 'function') {
	          getter = passthrough; // return an empty object
	        }
	
	        this._fluxStateGetters.push({ store: store, getter: getter });
	        var listener = createStoreListener(getter, store, flux).bind(this);
	
	        store.on('change', listener);
	        this._fluxListeners[storeName] = listener;
	      }
	
	      var handlers = typeof options.handlers !== 'undefined' ? options.handlers(flux.actions, flux) : {};
	
	      return _Object$assign({}, this.getStoreState(this.props), handlers);
	    },
	
	    getStoreState: function getStoreState(props) {
	      var flux = this.getFlux();
	
	      return this._fluxStateGetters.reduce(function (result, stateGetter) {
	        var getter = stateGetter.getter;
	        var store = stateGetter.store;
	
	        var stateFromStores = getter(store, props, flux);
	        return _Object$assign(result, stateFromStores);
	      }, {});
	    },
	
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	      this.setState(this.getStoreState(nextProps));
	    },
	
	    componentWillUnmount: function componentWillUnmount() {
	      var flux = this.getFlux();
	
	      for (var storeName in options.stores) {
	        if (!this._fluxListeners.hasOwnProperty(storeName)) {
	          continue;
	        }
	
	        var store = flux.store(storeName);
	        if (typeof store === 'undefined') {
	          continue;
	        }
	
	        var listener = this._fluxListeners[storeName];
	        store.removeListener('change', listener);
	      }
	    },
	
	    shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
	      if (options.pure === true) {
	        return !(0, _reactLibShallowEqual2['default'])(this.props, nextProps) || !(0, _reactLibShallowEqual2['default'])(this.state, nextState);
	      }
	
	      // otherwise always return true
	      return true;
	    },
	
	    render: function render() {
	      return _reactAddons2['default'].createElement(Component, _Object$assign({ flux: this.getFlux() }, this.props, this.state, { ref: 'component' }));
	    }
	  });
	
	  return Container;
	}

/***/ },
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.generateMinMaxMessage = generateMinMaxMessage;
	
	var _react = __webpack_require__(40);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ofsI18n = __webpack_require__(61);
	
	var _ofsI18n2 = _interopRequireDefault(_ofsI18n);
	
	var gettext = _ofsI18n2['default'].gettext;
	var interpolate = _ofsI18n2['default'].interpolate;
	
	var messages = {
	  HAS_MIN_NO_MAX: gettext('This home has a minimum stay of %(minimum_stay)s nights.'),
	  HAS_MIN_AND_MAX: gettext('This home has a minimum stay of %(minimum_stay)s nights and a maximum of %(maximum_stay)s nights.'),
	  HAS_MAX_NO_MIN: gettext('This home has a maximum stay of %(maximum_stay)s nights.')
	};
	
	function generateMinMaxMessage(min, max) {
	  if (min > 1 && !max) {
	    return interpolate(messages.HAS_MIN_NO_MAX, { 'minimum_stay': min }, true);
	  } else if (min > 1 && max > 1) {
	    return interpolate(messages.HAS_MIN_AND_MAX, { 'minimum_stay': min, 'maximum_stay': max }, true);
	  } else if (!min && max > 1) {
	    return interpolate(messages.HAS_MAX_NO_MIN, { 'maximum_stay': max }, true);
	  }
	}
	
	;
	
	var MinMaxMessage = _react2['default'].createClass({
	  displayName: 'MinMaxMessage',
	
	  render: function render() {
	    var message = generateMinMaxMessage(this.props.min, this.props.max);
	
	    if (message) {
	      return _react2['default'].createElement(
	        'div',
	        { className: 'min-max-message' },
	        message
	      );
	    } else {
	      return null;
	    }
	  }
	});
	
	exports['default'] = MinMaxMessage;

/***/ },
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	var _reactAddons = __webpack_require__(40);
	
	var _reactAddons2 = _interopRequireDefault(_reactAddons);
	
	var _fluxxor = __webpack_require__(69);
	
	var _ofsI18n = __webpack_require__(61);
	
	var _RatesGuideModal = __webpack_require__(667);
	
	var _RatesGuideModal2 = _interopRequireDefault(_RatesGuideModal);
	
	var messages = {
	  RATES_QUESTION: (0, _ofsI18n.gettext)("Read about our rates.")
	};
	
	var RatesGuide = _reactAddons2['default'].createClass({
	  displayName: 'RatesGuide',
	
	  mixins: [(0, _fluxxor.FluxMixin)(_reactAddons2['default'])],
	
	  handleModalClick: function handleModalClick() {
	    this.getFlux().actions.layers.addModal(_reactAddons2['default'].createElement(_RatesGuideModal2['default'], null));
	  },
	
	  render: function render() {
	    return _reactAddons2['default'].createElement(
	      'div',
	      { className: 'ofs-InfoTip', onClick: this.handleModalClick },
	      _reactAddons2['default'].createElement(
	        'span',
	        { className: 'ofs-InfoTip__Label' },
	        messages.RATES_QUESTION
	      )
	    );
	  }
	});
	
	module.exports = RatesGuide;

/***/ },
/* 667 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _reactAddons = __webpack_require__(40);
	
	var _reactAddons2 = _interopRequireDefault(_reactAddons);
	
	var _ofsI18n = __webpack_require__(61);
	
	var messages = {
	  RATES_HEADER: (0, _ofsI18n.gettext)("About our rates"),
	  RATES_QUIBBLE: (0, _ofsI18n.gettext)("No-quibble cool-off period"),
	  RATES_QUIBBLE_DESCRIPTION: (0, _ofsI18n.gettext)("Provided you book more than seven days before the start of your stay, you can cancel your booking no questions asked within 24 hours of making it, and we will refund 100% of any charges."),
	  RATES_STANDARD: (0, _ofsI18n.gettext)("Standard Rate"),
	  RATES_STANDARD_DESCRIPTION: (0, _ofsI18n.gettext)("Our standard rate, best for those whose plans are unlikely to change. If you cancel up to 14 days before the start of your stay, we will refund 50% of your booking. If you cancel within two weeks of the start of your stay, we can't refund your booking. For our full cancellation policy,"),
	  RATES_FLEXIBLE: (0, _ofsI18n.gettext)("Flexible Rate"),
	  RATES_FLEXIBLE_DESCRIPTION: (0, _ofsI18n.gettext)("Our rate for those who'd like more flexibility. If you've selected the flexible rate you can cancel your booking at any point right up to 48 hours before the start of your stay and receive a full refund, less our flexibility fee. Once you're within 48 hours of the start of your stay, we can't refund your booking. For our full cancellation policy,"),
	  RATES_CLICK: (0, _ofsI18n.gettext)("click here")
	};
	
	var RatesGuideModal = _reactAddons2['default'].createClass({
	  displayName: 'RatesGuideModal',
	
	  render: function render() {
	    return _reactAddons2['default'].createElement(
	      'div',
	      { className: 'rates-guide' },
	      _reactAddons2['default'].createElement(
	        'h1',
	        null,
	        messages.RATES_HEADER
	      ),
	      _reactAddons2['default'].createElement(
	        'p',
	        null,
	        _reactAddons2['default'].createElement(
	          'b',
	          null,
	          messages.RATES_QUIBBLE
	        ),
	        '. ',
	        messages.RATES_QUIBBLE_DESCRIPTION
	      ),
	      _reactAddons2['default'].createElement(
	        'p',
	        null,
	        _reactAddons2['default'].createElement(
	          'b',
	          null,
	          messages.RATES_STANDARD
	        ),
	        '. ',
	        messages.RATES_STANDARD_DESCRIPTION,
	        ' ',
	        _reactAddons2['default'].createElement(
	          'a',
	          { href: '/cancellation-policy/' },
	          messages.RATES_CLICK
	        ),
	        '.'
	      ),
	      _reactAddons2['default'].createElement(
	        'p',
	        null,
	        _reactAddons2['default'].createElement(
	          'b',
	          null,
	          messages.RATES_FLEXIBLE
	        ),
	        '. ',
	        messages.RATES_FLEXIBLE_DESCRIPTION,
	        ' ',
	        _reactAddons2['default'].createElement(
	          'a',
	          { href: '/cancellation-policy/' },
	          messages.RATES_CLICK
	        ),
	        '.'
	      )
	    );
	  }
	});
	
	exports['default'] = RatesGuideModal;
	module.exports = exports['default'];

/***/ },
/* 668 */,
/* 669 */,
/* 670 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	 * accounting.js v0.4.1
	 * Copyright 2014 Open Exchange Rates
	 *
	 * Freely distributable under the MIT license.
	 * Portions of accounting.js are inspired or borrowed from underscore.js
	 *
	 * Full details and documentation:
	 * http://openexchangerates.github.io/accounting.js/
	 */
	
	(function(root, undefined) {
	
		/* --- Setup --- */
	
		// Create the local library object, to be exported or referenced globally later
		var lib = {};
	
		// Current version
		lib.version = '0.4.1';
	
	
		/* --- Exposed settings --- */
	
		// The library's settings configuration object. Contains default parameters for
		// currency and number formatting
		lib.settings = {
			currency: {
				symbol : "$",		// default currency symbol is '$'
				format : "%s%v",	// controls output: %s = symbol, %v = value (can be object, see docs)
				decimal : ".",		// decimal point separator
				thousand : ",",		// thousands separator
				precision : 2,		// decimal places
				grouping : 3		// digit grouping (not implemented yet)
			},
			number: {
				precision : 0,		// default precision on numbers is 0
				grouping : 3,		// digit grouping (not implemented yet)
				thousand : ",",
				decimal : "."
			}
		};
	
	
		/* --- Internal Helper Methods --- */
	
		// Store reference to possibly-available ECMAScript 5 methods for later
		var nativeMap = Array.prototype.map,
			nativeIsArray = Array.isArray,
			toString = Object.prototype.toString;
	
		/**
		 * Tests whether supplied parameter is a string
		 * from underscore.js
		 */
		function isString(obj) {
			return !!(obj === '' || (obj && obj.charCodeAt && obj.substr));
		}
	
		/**
		 * Tests whether supplied parameter is a string
		 * from underscore.js, delegates to ECMA5's native Array.isArray
		 */
		function isArray(obj) {
			return nativeIsArray ? nativeIsArray(obj) : toString.call(obj) === '[object Array]';
		}
	
		/**
		 * Tests whether supplied parameter is a true object
		 */
		function isObject(obj) {
			return obj && toString.call(obj) === '[object Object]';
		}
	
		/**
		 * Extends an object with a defaults object, similar to underscore's _.defaults
		 *
		 * Used for abstracting parameter handling from API methods
		 */
		function defaults(object, defs) {
			var key;
			object = object || {};
			defs = defs || {};
			// Iterate over object non-prototype properties:
			for (key in defs) {
				if (defs.hasOwnProperty(key)) {
					// Replace values with defaults only if undefined (allow empty/zero values):
					if (object[key] == null) object[key] = defs[key];
				}
			}
			return object;
		}
	
		/**
		 * Implementation of `Array.map()` for iteration loops
		 *
		 * Returns a new Array as a result of calling `iterator` on each array value.
		 * Defers to native Array.map if available
		 */
		function map(obj, iterator, context) {
			var results = [], i, j;
	
			if (!obj) return results;
	
			// Use native .map method if it exists:
			if (nativeMap && obj.map === nativeMap) return obj.map(iterator, context);
	
			// Fallback for native .map:
			for (i = 0, j = obj.length; i < j; i++ ) {
				results[i] = iterator.call(context, obj[i], i, obj);
			}
			return results;
		}
	
		/**
		 * Check and normalise the value of precision (must be positive integer)
		 */
		function checkPrecision(val, base) {
			val = Math.round(Math.abs(val));
			return isNaN(val)? base : val;
		}
	
	
		/**
		 * Parses a format string or object and returns format obj for use in rendering
		 *
		 * `format` is either a string with the default (positive) format, or object
		 * containing `pos` (required), `neg` and `zero` values (or a function returning
		 * either a string or object)
		 *
		 * Either string or format.pos must contain "%v" (value) to be valid
		 */
		function checkCurrencyFormat(format) {
			var defaults = lib.settings.currency.format;
	
			// Allow function as format parameter (should return string or object):
			if ( typeof format === "function" ) format = format();
	
			// Format can be a string, in which case `value` ("%v") must be present:
			if ( isString( format ) && format.match("%v") ) {
	
				// Create and return positive, negative and zero formats:
				return {
					pos : format,
					neg : format.replace("-", "").replace("%v", "-%v"),
					zero : format
				};
	
			// If no format, or object is missing valid positive value, use defaults:
			} else if ( !format || !format.pos || !format.pos.match("%v") ) {
	
				// If defaults is a string, casts it to an object for faster checking next time:
				return ( !isString( defaults ) ) ? defaults : lib.settings.currency.format = {
					pos : defaults,
					neg : defaults.replace("%v", "-%v"),
					zero : defaults
				};
	
			}
			// Otherwise, assume format was fine:
			return format;
		}
	
	
		/* --- API Methods --- */
	
		/**
		 * Takes a string/array of strings, removes all formatting/cruft and returns the raw float value
		 * Alias: `accounting.parse(string)`
		 *
		 * Decimal must be included in the regular expression to match floats (defaults to
		 * accounting.settings.number.decimal), so if the number uses a non-standard decimal 
		 * separator, provide it as the second argument.
		 *
		 * Also matches bracketed negatives (eg. "$ (1.99)" => -1.99)
		 *
		 * Doesn't throw any errors (`NaN`s become 0) but this may change in future
		 */
		var unformat = lib.unformat = lib.parse = function(value, decimal) {
			// Recursively unformat arrays:
			if (isArray(value)) {
				return map(value, function(val) {
					return unformat(val, decimal);
				});
			}
	
			// Fails silently (need decent errors):
			value = value || 0;
	
			// Return the value as-is if it's already a number:
			if (typeof value === "number") return value;
	
			// Default decimal point comes from settings, but could be set to eg. "," in opts:
			decimal = decimal || lib.settings.number.decimal;
	
			 // Build regex to strip out everything except digits, decimal point and minus sign:
			var regex = new RegExp("[^0-9-" + decimal + "]", ["g"]),
				unformatted = parseFloat(
					("" + value)
					.replace(/\((.*)\)/, "-$1") // replace bracketed values with negatives
					.replace(regex, '')         // strip out any cruft
					.replace(decimal, '.')      // make sure decimal point is standard
				);
	
			// This will fail silently which may cause trouble, let's wait and see:
			return !isNaN(unformatted) ? unformatted : 0;
		};
	
	
		/**
		 * Implementation of toFixed() that treats floats more like decimals
		 *
		 * Fixes binary rounding issues (eg. (0.615).toFixed(2) === "0.61") that present
		 * problems for accounting- and finance-related software.
		 */
		var toFixed = lib.toFixed = function(value, precision) {
			precision = checkPrecision(precision, lib.settings.number.precision);
			var power = Math.pow(10, precision);
	
			// Multiply up by precision, round accurately, then divide and use native toFixed():
			return (Math.round(lib.unformat(value) * power) / power).toFixed(precision);
		};
	
	
		/**
		 * Format a number, with comma-separated thousands and custom precision/decimal places
		 * Alias: `accounting.format()`
		 *
		 * Localise by overriding the precision and thousand / decimal separators
		 * 2nd parameter `precision` can be an object matching `settings.number`
		 */
		var formatNumber = lib.formatNumber = lib.format = function(number, precision, thousand, decimal) {
			// Resursively format arrays:
			if (isArray(number)) {
				return map(number, function(val) {
					return formatNumber(val, precision, thousand, decimal);
				});
			}
	
			// Clean up number:
			number = unformat(number);
	
			// Build options object from second param (if object) or all params, extending defaults:
			var opts = defaults(
					(isObject(precision) ? precision : {
						precision : precision,
						thousand : thousand,
						decimal : decimal
					}),
					lib.settings.number
				),
	
				// Clean up precision
				usePrecision = checkPrecision(opts.precision),
	
				// Do some calc:
				negative = number < 0 ? "-" : "",
				base = parseInt(toFixed(Math.abs(number || 0), usePrecision), 10) + "",
				mod = base.length > 3 ? base.length % 3 : 0;
	
			// Format the number:
			return negative + (mod ? base.substr(0, mod) + opts.thousand : "") + base.substr(mod).replace(/(\d{3})(?=\d)/g, "$1" + opts.thousand) + (usePrecision ? opts.decimal + toFixed(Math.abs(number), usePrecision).split('.')[1] : "");
		};
	
	
		/**
		 * Format a number into currency
		 *
		 * Usage: accounting.formatMoney(number, symbol, precision, thousandsSep, decimalSep, format)
		 * defaults: (0, "$", 2, ",", ".", "%s%v")
		 *
		 * Localise by overriding the symbol, precision, thousand / decimal separators and format
		 * Second param can be an object matching `settings.currency` which is the easiest way.
		 *
		 * To do: tidy up the parameters
		 */
		var formatMoney = lib.formatMoney = function(number, symbol, precision, thousand, decimal, format) {
			// Resursively format arrays:
			if (isArray(number)) {
				return map(number, function(val){
					return formatMoney(val, symbol, precision, thousand, decimal, format);
				});
			}
	
			// Clean up number:
			number = unformat(number);
	
			// Build options object from second param (if object) or all params, extending defaults:
			var opts = defaults(
					(isObject(symbol) ? symbol : {
						symbol : symbol,
						precision : precision,
						thousand : thousand,
						decimal : decimal,
						format : format
					}),
					lib.settings.currency
				),
	
				// Check format (returns object with pos, neg and zero):
				formats = checkCurrencyFormat(opts.format),
	
				// Choose which format to use for this value:
				useFormat = number > 0 ? formats.pos : number < 0 ? formats.neg : formats.zero;
	
			// Return with currency symbol added:
			return useFormat.replace('%s', opts.symbol).replace('%v', formatNumber(Math.abs(number), checkPrecision(opts.precision), opts.thousand, opts.decimal));
		};
	
	
		/**
		 * Format a list of numbers into an accounting column, padding with whitespace
		 * to line up currency symbols, thousand separators and decimals places
		 *
		 * List should be an array of numbers
		 * Second parameter can be an object containing keys that match the params
		 *
		 * Returns array of accouting-formatted number strings of same length
		 *
		 * NB: `white-space:pre` CSS rule is required on the list container to prevent
		 * browsers from collapsing the whitespace in the output strings.
		 */
		lib.formatColumn = function(list, symbol, precision, thousand, decimal, format) {
			if (!list) return [];
	
			// Build options object from second param (if object) or all params, extending defaults:
			var opts = defaults(
					(isObject(symbol) ? symbol : {
						symbol : symbol,
						precision : precision,
						thousand : thousand,
						decimal : decimal,
						format : format
					}),
					lib.settings.currency
				),
	
				// Check format (returns object with pos, neg and zero), only need pos for now:
				formats = checkCurrencyFormat(opts.format),
	
				// Whether to pad at start of string or after currency symbol:
				padAfterSymbol = formats.pos.indexOf("%s") < formats.pos.indexOf("%v") ? true : false,
	
				// Store value for the length of the longest string in the column:
				maxLength = 0,
	
				// Format the list according to options, store the length of the longest string:
				formatted = map(list, function(val, i) {
					if (isArray(val)) {
						// Recursively format columns if list is a multi-dimensional array:
						return lib.formatColumn(val, opts);
					} else {
						// Clean up the value
						val = unformat(val);
	
						// Choose which format to use for this value (pos, neg or zero):
						var useFormat = val > 0 ? formats.pos : val < 0 ? formats.neg : formats.zero,
	
							// Format this value, push into formatted list and save the length:
							fVal = useFormat.replace('%s', opts.symbol).replace('%v', formatNumber(Math.abs(val), checkPrecision(opts.precision), opts.thousand, opts.decimal));
	
						if (fVal.length > maxLength) maxLength = fVal.length;
						return fVal;
					}
				});
	
			// Pad each number in the list and send back the column of numbers:
			return map(formatted, function(val, i) {
				// Only if this is a string (not a nested array, which would have already been padded):
				if (isString(val) && val.length < maxLength) {
					// Depending on symbol position, pad after symbol or at index 0:
					return padAfterSymbol ? val.replace(opts.symbol, opts.symbol+(new Array(maxLength - val.length + 1).join(" "))) : (new Array(maxLength - val.length + 1).join(" ")) + val;
				}
				return val;
			});
		};
	
	
		/* --- Module Definition --- */
	
		// Export accounting for CommonJS. If being loaded as an AMD module, define it as such.
		// Otherwise, just add `accounting` to the global object
		if (true) {
			if (typeof module !== 'undefined' && module.exports) {
				exports = module.exports = lib;
			}
			exports.accounting = lib;
		} else if (typeof define === 'function' && define.amd) {
			// Return the library as an AMD module:
			define([], function() {
				return lib;
			});
		} else {
			// Use accounting.noConflict to restore `accounting` back to its original value.
			// Returns a reference to the library's `accounting` object;
			// e.g. `var numbers = accounting.noConflict();`
			lib.noConflict = (function(oldAccounting) {
				return function() {
					// Reset the value of the root's `accounting` variable:
					root.accounting = oldAccounting;
					// Delete the noConflict method:
					lib.noConflict = undefined;
					// Return reference to the library to re-assign it:
					return lib;
				};
			})(root.accounting);
	
			// Declare `fx` on the root (global/window) object:
			root['accounting'] = lib;
		}
	
		// Root will be `window` in browser or `global` on the server:
	}(this));


/***/ },
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = __webpack_require__(3)['default'];
	
	var _inherits = __webpack_require__(17)['default'];
	
	var _createClass = __webpack_require__(28)['default'];
	
	var _classCallCheck = __webpack_require__(31)['default'];
	
	var _Object$assign = __webpack_require__(32)['default'];
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _reactAddons = __webpack_require__(40);
	
	var _reactAddons2 = _interopRequireDefault(_reactAddons);
	
	var _jquery = __webpack_require__(39);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _ofsAppsCoreEntry = __webpack_require__(450);
	
	var _ofsAppsCoreEntry2 = _interopRequireDefault(_ofsAppsCoreEntry);
	
	var _ofsComponentsHomeslistHomesList = __webpack_require__(588);
	
	var _ofsComponentsHomeslistHomesList2 = _interopRequireDefault(_ofsComponentsHomeslistHomesList);
	
	var _storesAvailabilityStore = __webpack_require__(638);
	
	var _storesAvailabilityStore2 = _interopRequireDefault(_storesAvailabilityStore);
	
	var _storesBookingQuoteStore = __webpack_require__(639);
	
	var _storesBookingQuoteStore2 = _interopRequireDefault(_storesBookingQuoteStore);
	
	var _storesUnitStore = __webpack_require__(640);
	
	var _storesUnitStore2 = _interopRequireDefault(_storesUnitStore);
	
	var _ofsAppsHomesDetailStoresSimilarHomes = __webpack_require__(587);
	
	var _ofsAppsHomesDetailStoresSimilarHomes2 = _interopRequireDefault(_ofsAppsHomesDetailStoresSimilarHomes);
	
	var _viewsBookingForm = __webpack_require__(769);
	
	var _viewsBookingForm2 = _interopRequireDefault(_viewsBookingForm);
	
	var EntryPoint = (function (_BaseEntryPoint) {
	  _inherits(EntryPoint, _BaseEntryPoint);
	
	  function EntryPoint() {
	    _classCallCheck(this, EntryPoint);
	
	    _get(Object.getPrototypeOf(EntryPoint.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(EntryPoint, [{
	    key: 'getStores',
	    value: function getStores() {
	      return _Object$assign(_get(Object.getPrototypeOf(EntryPoint.prototype), 'getStores', this).call(this), {
	        AvailabilityStore: new _storesAvailabilityStore2['default'](this.options.availability),
	        BookingQuoteStore: new _storesBookingQuoteStore2['default'](this.options.quote),
	        UnitStore: new _storesUnitStore2['default'](this.options.unit),
	        SimilarHomes: new _ofsAppsHomesDetailStoresSimilarHomes2['default'](this.options.similar)
	      });
	    }
	  }, {
	    key: 'renderToDocument',
	    value: function renderToDocument(document) {
	      _get(Object.getPrototypeOf(EntryPoint.prototype), 'renderToDocument', this).call(this, document);
	
	      if (document.getElementById('similar-homes')) {
	        _reactAddons2['default'].render(_reactAddons2['default'].createElement(_ofsComponentsHomeslistHomesList2['default'], { flux: this.flux }), document.getElementById('similar-homes'));
	      }
	
	      if (document.getElementById('booking-form')) {
	        _reactAddons2['default'].render(_reactAddons2['default'].createElement(_viewsBookingForm2['default'], { flux: this.flux }), document.getElementById('booking-form'));
	      }
	    }
	  }]);
	
	  return EntryPoint;
	})(_ofsAppsCoreEntry2['default']);
	
	exports['default'] = EntryPoint;
	module.exports = exports['default'];

/***/ },
/* 769 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(40);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ofsMoment = __webpack_require__(57);
	
	var _ofsMoment2 = _interopRequireDefault(_ofsMoment);
	
	var _fluxxor = __webpack_require__(69);
	
	var _ofsI18n = __webpack_require__(61);
	
	var _ofsComponentsContactUnitComponent = __webpack_require__(67);
	
	var _ofsComponentsContactUnitComponent2 = _interopRequireDefault(_ofsComponentsContactUnitComponent);
	
	var _ofsComponentsMinMaxMessage = __webpack_require__(662);
	
	var _BookingQuote = __webpack_require__(770);
	
	var _BookingQuote2 = _interopRequireDefault(_BookingQuote);
	
	var _DateInputs = __webpack_require__(771);
	
	var _DateInputs2 = _interopRequireDefault(_DateInputs);
	
	var _ofsAppsCoreUtilsTrackingOptimizely = __webpack_require__(46);
	
	var messages = {
	  ENQUIRE: (0, _ofsI18n.gettext)("You'll need to enquire about this date range."),
	  LOADING: (0, _ofsI18n.gettext)("Loading ..."),
	  BOOK_NOW: (0, _ofsI18n.gettext)("Book now"),
	  ASK_A_QUESTION: (0, _ofsI18n.gettext)("Ask a question"),
	  APPROXIMATE: (0, _ofsI18n.gettext)("Approximate conversion"),
	  FINAL_AMOUNT: (0, _ofsI18n.gettext)("Final amount and payment will be in %(alternativeCurrencyISO)s. The conversion rate will be determined by your bank.")
	};
	
	var BookingForm = _react2['default'].createClass({
	  displayName: 'BookingForm',
	
	  /* eslint-disable new-cap */
	  mixins: [(0, _fluxxor.FluxMixin)(_react2['default']), (0, _fluxxor.StoreWatchMixin)("BookingQuoteStore", "AvailabilityStore", "UnitStore")],
	  /* eslint-enable new-cap */
	
	  getStateFromFlux: function getStateFromFlux() {
	    var flux = this.getFlux();
	
	    return {
	      availability: flux.store('AvailabilityStore').state,
	      quote: flux.store('BookingQuoteStore').state,
	      unit: flux.store('UnitStore').state
	    };
	  },
	
	  openContactForm: function openContactForm(source, enquireAvailability) {
	    var quoteStore = this.getFlux().store('BookingQuoteStore');
	    (0, _ofsAppsCoreUtilsTrackingOptimizely.trackOptimizelyOpen)(source);
	    this.getFlux().actions.layers.addModal(_react2['default'].createElement(_ofsComponentsContactUnitComponent2['default'], {
	      unit: this.state.unit.get('name'),
	      unitShortCode: this.state.unit.get('shortCode'),
	      city: this.state.unit.get('city'),
	      startDate: quoteStore.getFormattedStartDate(),
	      endDate: quoteStore.getFormattedEndDate(),
	      source: source,
	      enquireAvailability: enquireAvailability
	    }));
	  },
	
	  handleAskAQuestionClick: function handleAskAQuestionClick(event) {
	    event.preventDefault();
	    this.openContactForm('ask a question', false);
	  },
	
	  handleEnquireClick: function handleEnquireClick(event) {
	    event.preventDefault();
	    this.openContactForm('enquire home availability', true);
	  },
	
	  handleSelect: function handleSelect(startValue, endValue) {
	    var range = (0, _ofsMoment2['default'])().range(startValue, endValue);
	    var stayLength = _ofsMoment2['default'].duration(range.end.diff(range.start)).asDays();
	
	    var availability = this.state.availability;
	
	    var dateStates = availability.get('stateRanges');
	    var needsEnquire = dateStates.filter(function (state) {
	      return (state.get('range').contains(range.start) || state.get('range').contains(range.end)) && state.get('state') === 'enquire';
	    }).count() > 0;
	
	    needsEnquire = !needsEnquire && stayLength < this.state.availability.get('minimumStay');
	
	    this.getFlux().actions.calendar.completeRangeSelection(range, this.state.availability.get('stateRanges').toJS());
	
	    if (needsEnquire) {
	      this.openContactForm('enquire home availability', true);
	    }
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.getFlux().store('BookingQuoteStore').updateQuote();
	  },
	
	  render: function render() {
	    var _state = this.state;
	    var quote = _state.quote;
	    var availability = _state.availability;
	
	    var range = quote.get('range');
	    var hasDates = !!range;
	
	    var minimumStay = availability.get('minimumStay');
	    var maximumStay = availability.get('maximumStay');
	    var quoteData = quote.get('quoteData');
	    var loading = quote.get('loading');
	    var needsEnquire = !loading && quote.get('range') && !quote.get('bookable');
	    var alternativeCurrencyISO = quote.get('alternativeCurrencyISO');
	
	    var stateDefinitions = availability.get('stateDefinitions').toJS();
	    var dateStates = availability.get('stateRanges').toJS();
	
	    var startDate = null;
	    var endDate = null;
	    if (range) {
	      startDate = range.start.toDate();
	      endDate = range.end.toDate();
	    }
	
	    var helpMessage = (0, _ofsComponentsMinMaxMessage.generateMinMaxMessage)(minimumStay, maximumStay);
	
	    return _react2['default'].createElement(
	      'form',
	      { className: 'ofs-Form -form--large', method: 'post', action: this.state.quote.get('bookUrl') },
	      _react2['default'].createElement(
	        'div',
	        { className: 'ofs-Form__Fields' },
	        _react2['default'].createElement(_DateInputs2['default'], { initialStartValue: startDate, initialEndValue: endDate,
	          stateDefinitions: stateDefinitions,
	          dateStates: dateStates,
	          defaultState: 'available',
	          labels: false,
	          startField: 'start_date',
	          endField: 'end_date',
	          onSelect: this.handleSelect,
	          helpMessage: helpMessage })
	      ),
	      needsEnquire ? _react2['default'].createElement(
	        'p',
	        null,
	        _react2['default'].createElement(
	          'a',
	          { href: '#', onClick: this.handleEnquireClick },
	          messages.ENQUIRE
	        )
	      ) : null,
	      this.state.quote.get('range') && quoteData ? _react2['default'].createElement(_BookingQuote2['default'], { data: quoteData }) : null,
	      loading ? _react2['default'].createElement(
	        'p',
	        null,
	        messages.LOADING
	      ) : null,
	      _react2['default'].createElement(
	        'button',
	        { style: { marginBottom: 10 }, className: 'ofs-Button ofs-Button--full-width', disabled: !this.state.quote.get('bookable') },
	        messages.BOOK_NOW
	      ),
	      _react2['default'].createElement(
	        'a',
	        { style: { marginBottom: 10 }, className: 'ofs-Button ofs-Button--full-width ofs-Button--secondary', onClick: this.handleAskAQuestionClick },
	        messages.ASK_A_QUESTION
	      ),
	      quoteData && alternativeCurrencyISO ? _react2['default'].createElement(
	        'div',
	        { className: 'currency_disclaimer' },
	        _react2['default'].createElement(
	          'strong',
	          null,
	          messages.APPROXIMATE
	        ),
	        ' ',
	        (0, _ofsI18n.interpolate)(messages.FINAL_AMOUNT, { alternativeCurrencyISO: alternativeCurrencyISO }, true)
	      ) : null
	    );
	  }
	});
	
	exports['default'] = BookingForm;
	module.exports = exports['default'];

/***/ },
/* 770 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(40);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _accounting = __webpack_require__(670);
	
	var _accounting2 = _interopRequireDefault(_accounting);
	
	var _ofsI18n = __webpack_require__(61);
	
	var _ofsI18n2 = _interopRequireDefault(_ofsI18n);
	
	var _ofsReactComponentsRatesGuide = __webpack_require__(666);
	
	var _ofsReactComponentsRatesGuide2 = _interopRequireDefault(_ofsReactComponentsRatesGuide);
	
	//       <tr>
	//         <th scope="row">{% trans "Length of stay" %}</th>
	//         <td>{{ stay_length }}</td>
	//       </tr>
	//       <tr class="total">
	//         <th scope="row">{% trans "Standard Rate" %}</th>
	//         <td>{% currency total unit.currency quote=user.currency decimals=0 lang=LANGUAGE_CODE %}</td>
	//       </tr>
	//       {% if flexible_rate %}
	//       <tr class="flexible-rate">
	//         <th scope="row">{% trans "Flexible Rate" %}</th>
	//         <td>{% currency flexible_rate unit.currency quote=user.currency decimals=0 lang=LANGUAGE_CODE %}</td>
	//       </tr>
	//       {% endif %}
	//     </table>
	//   {% else %}
	//     <p class="error">
	//       {{ error_msg }}
	//     </p>
	//   {% endif %}
	// {% endif %}
	
	// discount: 0
	// end_date: "2015-04-09T11:00:00"
	// flexible_rate: "4232.75"
	// nightly_rate: "550.00"
	// page: "summary"
	// start_date: "2015-04-03T16:00:00"
	// stay_length: 6
	// total: "3807.75"
	
	var gettext = _ofsI18n2['default'].gettext;
	var messages = {
	  PRICE_PER_NIGHT: gettext("Price per night"),
	  LENGTH_OF_STAY: gettext("Length of stay"),
	  STANDARD_RATE: gettext("Standard rate"),
	  FLEXIBLE_RATE: gettext("Flexible rate")
	};
	
	var BookingQuote = _react2['default'].createClass({
	  displayName: 'BookingQuote',
	
	  render: function render() {
	    var data = this.props.data;
	
	    var moneyOptions = {
	      symbol: data.currency,
	      decimal: _ofsI18n2['default'].get_format('DECIMAL_SEPARATOR'),
	      thousand: _ofsI18n2['default'].get_format('THOUSAND_SEPARATOR'),
	      precision: 0
	    };
	
	    return _react2['default'].createElement(
	      'div',
	      { className: 'ofs-BookingQuote' },
	      _react2['default'].createElement(
	        'table',
	        { className: 'ofs-BookingQuote__Table' },
	        _react2['default'].createElement(
	          'tr',
	          { className: 'ofs-BookingQuote__Row' },
	          _react2['default'].createElement(
	            'th',
	            { className: 'ofs-BookingQuote__Label', scope: 'row' },
	            messages.PRICE_PER_NIGHT
	          ),
	          data.discounted_nightly_rate ? _react2['default'].createElement(
	            'td',
	            { className: 'ofs-BookingQuote__Value' },
	            _react2['default'].createElement(
	              's',
	              null,
	              _accounting2['default'].formatMoney(data.nightly_rate, moneyOptions)
	            ),
	            _react2['default'].createElement('br', null),
	            _accounting2['default'].formatMoney(data.discounted_nightly_rate, moneyOptions)
	          ) : _react2['default'].createElement(
	            'td',
	            { className: 'ofs-BookingQuote__Value' },
	            _accounting2['default'].formatMoney(data.nightly_rate, moneyOptions)
	          )
	        ),
	        _react2['default'].createElement(
	          'tr',
	          { className: 'ofs-BookingQuote__Row' },
	          _react2['default'].createElement(
	            'th',
	            { className: 'ofs-BookingQuote__Label', scope: 'row' },
	            messages.LENGTH_OF_STAY
	          ),
	          _react2['default'].createElement(
	            'td',
	            { className: 'ofs-BookingQuote__Value' },
	            data.stay_length
	          )
	        ),
	        _react2['default'].createElement(
	          'tr',
	          { className: 'ofs-BookingQuote__Row ofs-BookingQuote__Row--total' },
	          _react2['default'].createElement(
	            'th',
	            { className: 'ofs-BookingQuote__Label ofs-BookingQuote__Label--total', scope: 'row' },
	            messages.STANDARD_RATE
	          ),
	          _react2['default'].createElement(
	            'td',
	            { className: 'ofs-BookingQuote__Value ofs-BookingQuote__Value--total' },
	            _accounting2['default'].formatMoney(data.total, moneyOptions)
	          )
	        ),
	        data.flexible_rate ? _react2['default'].createElement(
	          'tr',
	          { className: 'ofs-BookingQuote__Row ofs-BookingQuote__Row--flexibleRateTotal' },
	          _react2['default'].createElement(
	            'th',
	            { className: 'ofs-BookingQuote__Label ofs-BookingQuote__Label--flexibleRateTotal', scope: 'row' },
	            messages.FLEXIBLE_RATE
	          ),
	          _react2['default'].createElement(
	            'td',
	            { className: 'ofs-BookingQuote__Value ofs-BookingQuote__Value--flexibleRateTotal' },
	            _accounting2['default'].formatMoney(data.flexible_rate, moneyOptions)
	          )
	        ) : null
	      ),
	      data.flexible_rate ? _react2['default'].createElement(_ofsReactComponentsRatesGuide2['default'], null) : null
	    );
	  }
	});
	
	exports['default'] = BookingQuote;
	module.exports = exports['default'];

/***/ },
/* 771 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _reactAddons = __webpack_require__(40);
	
	var _reactAddons2 = _interopRequireDefault(_reactAddons);
	
	var _fluxxor = __webpack_require__(69);
	
	var _fluxxor2 = _interopRequireDefault(_fluxxor);
	
	/* eslint-disable new-cap */
	
	/* eslint-enable new-cap */
	
	var _ofsComponentsDaterangeDatePicker = __webpack_require__(329);
	
	var _ofsComponentsDaterangeDatePicker2 = _interopRequireDefault(_ofsComponentsDaterangeDatePicker);
	
	var _ofsI18n = __webpack_require__(61);
	
	var FluxMixin = _fluxxor2['default'].FluxMixin(_reactAddons2['default']);
	
	function noop() {}
	
	var MESSAGES = {
	  ARRIVAL_DATE: (0, _ofsI18n.gettext)('Arrival date'),
	  DEPARTURE_DATE: (0, _ofsI18n.gettext)('Departure date'),
	  SELECT_DATE: (0, _ofsI18n.gettext)('Select date')
	};
	
	var DateInputs = _reactAddons2['default'].createClass({
	  displayName: 'DateInputs',
	
	  mixins: [FluxMixin],
	
	  propTypes: {
	    initialStartValue: _reactAddons2['default'].PropTypes.instanceOf(Date),
	    initialEndValue: _reactAddons2['default'].PropTypes.instanceOf(Date),
	    startField: _reactAddons2['default'].PropTypes.string.isRequired,
	    endField: _reactAddons2['default'].PropTypes.string.isRequired,
	    stateDefinitions: _reactAddons2['default'].PropTypes.object,
	    dateStates: _reactAddons2['default'].PropTypes.array,
	    defaultState: _reactAddons2['default'].PropTypes.string,
	    labels: _reactAddons2['default'].PropTypes.bool,
	    onSelect: _reactAddons2['default'].PropTypes.func
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onSelect: noop
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      startValue: this.props.initialStartValue,
	      endValue: this.props.initialEndValue
	    };
	  },
	
	  getDateState: function getDateState(startValue, endValue) {
	    var state = { startValue: startValue, endValue: endValue };
	
	    if (startValue && startValue > endValue) {
	      // if start value is after end value then reset end value
	      state.endValue = null;
	    }
	
	    return state;
	  },
	
	  handleStartSelect: function handleStartSelect(value) {
	    var state = this.getDateState(value.toDate(), this.state.endValue);
	    this.setState(state);
	
	    if (state.startValue && state.endValue) {
	      this.props.onSelect(state.startValue, state.endValue);
	    }
	  },
	
	  handleEndSelect: function handleEndSelect(value) {
	    var state = this.getDateState(this.state.startValue, value.toDate());
	    this.setState(state);
	
	    if (state.startValue && state.endValue) {
	      this.props.onSelect(state.startValue, state.endValue);
	    }
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var startField = _props.startField;
	    var endField = _props.endField;
	    var labels = _props.labels;
	    var stateDefinitions = _props.stateDefinitions;
	    var dateStates = _props.dateStates;
	    var defaultState = _props.defaultState;
	    var _state = this.state;
	    var startValue = _state.startValue;
	    var endValue = _state.endValue;
	
	    var initialEndDate;
	    if (startValue) {
	      initialEndDate = {
	        month: startValue.getMonth(),
	        year: startValue.getFullYear()
	      };
	    }
	
	    return _reactAddons2['default'].createElement(
	      'div',
	      null,
	      _reactAddons2['default'].createElement(_ofsComponentsDaterangeDatePicker2['default'], { value: startValue, name: startField,
	        stateDefinitions: stateDefinitions,
	        dateStates: dateStates,
	        defaultState: defaultState,
	        label: labels ? MESSAGES['ARRIVAL_DATE'] : null,
	        placeholder: MESSAGES['SELECT_DATE'],
	        onSelect: this.handleStartSelect }),
	      _reactAddons2['default'].createElement(_ofsComponentsDaterangeDatePicker2['default'], { value: endValue, name: endField,
	        stateDefinitions: stateDefinitions,
	        dateStates: dateStates,
	        defaultState: defaultState,
	        label: labels ? MESSAGES['DEPARTURE_DATE'] : null,
	        placeholder: MESSAGES['SELECT_DATE'],
	        initialDate: initialEndDate,
	        onSelect: this.handleEndSelect })
	    );
	  }
	});
	
	exports['default'] = DateInputs;
	module.exports = exports['default'];

/***/ },
/* 772 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(40);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ofsMoment = __webpack_require__(57);
	
	var _ofsMoment2 = _interopRequireDefault(_ofsMoment);
	
	var _fluxxor = __webpack_require__(69);
	
	var _ofsComponentsContactUnitComponent = __webpack_require__(67);
	
	var _ofsComponentsContactUnitComponent2 = _interopRequireDefault(_ofsComponentsContactUnitComponent);
	
	var _ofsComponentsDatepickerDatePickerJsx = __webpack_require__(201);
	
	var _ofsComponentsDatepickerDatePickerJsx2 = _interopRequireDefault(_ofsComponentsDatepickerDatePickerJsx);
	
	var _ofsComponentsMinMaxMessage = __webpack_require__(662);
	
	var _ofsComponentsMinMaxMessage2 = _interopRequireDefault(_ofsComponentsMinMaxMessage);
	
	var _QuoteModal = __webpack_require__(773);
	
	var _QuoteModal2 = _interopRequireDefault(_QuoteModal);
	
	var _ofsAppsCoreUtilsTrackingOptimizely = __webpack_require__(46);
	
	var AvailabilityCalendar = _react2['default'].createClass({
	  displayName: 'AvailabilityCalendar',
	
	  mixins: [(0, _fluxxor.FluxMixin)(_react2['default']), (0, _fluxxor.StoreWatchMixin)("BookingQuoteStore", "AvailabilityStore", "UnitStore")],
	
	  getStateFromFlux: function getStateFromFlux() {
	    var flux = this.getFlux();
	
	    return {
	      availability: flux.store('AvailabilityStore').state,
	      quote: flux.store('BookingQuoteStore').state,
	      unit: flux.store('UnitStore').state
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      enquireShown: false,
	      bookShown: false,
	      selection: null
	    };
	  },
	
	  handleSelect: function handleSelect(range, states) {
	    var source = this.props.source;
	    var quoteStore = this.getFlux().store('BookingQuoteStore');
	    var stayLength = _ofsMoment2['default'].duration(range.end.diff(range.start)).asDays();
	    this.getFlux().actions.calendar.completeRangeSelection(range, states.toJS());
	
	    if (states.contains('enquire') || stayLength < this.state.availability.get('minimumStay')) {
	      (0, _ofsAppsCoreUtilsTrackingOptimizely.trackOptimizelyOpen)(source);
	      this.getFlux().actions.layers.addModal(_react2['default'].createElement(_ofsComponentsContactUnitComponent2['default'], {
	        unit: this.state.unit.getIn(['summary', 'name']),
	        unitShortCode: this.state.unit.get('shortCode'),
	        city: this.state.unit.getIn(['city', 'code']),
	        startDate: quoteStore.getFormattedStartDate(),
	        endDate: quoteStore.getFormattedEndDate(),
	        source: source,
	        enquireAvailability: true
	      }));
	    } else {
	      this.getFlux().actions.layers.addModal(_react2['default'].createElement(_QuoteModal2['default'], null));
	    }
	  },
	
	  render: function render() {
	    var availabilityStore = this.getFlux().store('AvailabilityStore');
	    var stateDefinitions = availabilityStore.state.get('stateDefinitions').toJS();
	    var dateStates = availabilityStore.state.get('stateRanges').toJS();
	    var minimumStay = availabilityStore.state.get('minimumStay');
	    var maximumStay = availabilityStore.state.get('maximumStay');
	
	    return _react2['default'].createElement(
	      'div',
	      { className: 'availability-calendar' },
	      _react2['default'].createElement(_ofsComponentsMinMaxMessage2['default'], {
	        min: minimumStay,
	        max: maximumStay }),
	      _react2['default'].createElement(_ofsComponentsDatepickerDatePickerJsx2['default'], {
	        stateDefinitions: stateDefinitions,
	        dateStates: dateStates,
	        defaultState: 'available',
	        numberOfCalendars: this.props.numCalendars,
	        onSelect: this.handleSelect,
	        selectionType: 'range',
	        showLegend: true,
	        value: this.state.quote.get('range') })
	    );
	  }
	});
	
	exports['default'] = AvailabilityCalendar;
	module.exports = exports['default'];

/***/ },
/* 773 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _react = __webpack_require__(40);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fluxxor = __webpack_require__(69);
	
	var _ofsReactComponentsRatesGuide = __webpack_require__(666);
	
	var _ofsReactComponentsRatesGuide2 = _interopRequireDefault(_ofsReactComponentsRatesGuide);
	
	var _BookingQuote = __webpack_require__(770);
	
	var _BookingQuote2 = _interopRequireDefault(_BookingQuote);
	
	var _ofsI18n = __webpack_require__(61);
	
	var messages = {
	  BOOK_YOUR_STAY: (0, _ofsI18n.gettext)("Book your stay"),
	  LOADING: (0, _ofsI18n.gettext)("Loading"),
	  FROM_THE_EVENING: (0, _ofsI18n.gettext)('From the evening of'),
	  TO_THE_MORNING: (0, _ofsI18n.gettext)("To the morning of"),
	  BOOK_NOW: (0, _ofsI18n.gettext)("Book now")
	};
	
	var QuoteModal = _react2['default'].createClass({
	  displayName: 'QuoteModal',
	
	  mixins: [(0, _fluxxor.FluxMixin)(_react2['default']), (0, _fluxxor.StoreWatchMixin)("BookingQuoteStore", "UnitStore")],
	
	  getStateFromFlux: function getStateFromFlux() {
	    var flux = this.getFlux();
	
	    return {
	      quote: flux.store('BookingQuoteStore').state,
	      unit: flux.store('UnitStore').state
	    };
	  },
	
	  renderForm: function renderForm() {
	    var quoteStore = this.getFlux().store('BookingQuoteStore');
	    var quoteData = this.state.quote.get('quoteData');
	
	    return _react2['default'].createElement(
	      'form',
	      { className: 'booking-form', method: 'post', action: this.state.quote.get('bookUrl') },
	      _react2['default'].createElement('input', { type: 'hidden', name: 'start_date', value: quoteStore.getISO8601StartDate() }),
	      _react2['default'].createElement('input', { type: 'hidden', name: 'end_date', value: quoteStore.getISO8601EndDate() }),
	      _react2['default'].createElement(
	        'div',
	        { className: 'booking-dates' },
	        _react2['default'].createElement(
	          'p',
	          { className: 'label' },
	          messages.FROM_THE_EVENING
	        ),
	        _react2['default'].createElement(
	          'p',
	          { className: 'value' },
	          quoteStore.getFormattedStartDate()
	        ),
	        _react2['default'].createElement(
	          'p',
	          { className: 'label' },
	          messages.TO_THE_MORNING
	        ),
	        _react2['default'].createElement(
	          'p',
	          { className: 'value' },
	          quoteStore.getFormattedEndDate()
	        )
	      ),
	      this.state.quote.get('range') && quoteData ? _react2['default'].createElement(_BookingQuote2['default'], { data: quoteData }) : null,
	      _react2['default'].createElement(
	        'button',
	        { className: 'button', disabled: !this.state.quote.get('bookable') },
	        messages.BOOK_NOW
	      )
	    );
	  },
	
	  render: function render() {
	    var loading = this.state.quote.get('loading');
	
	    return _react2['default'].createElement(
	      'div',
	      null,
	      _react2['default'].createElement(
	        'h2',
	        null,
	        messages.BOOK_YOUR_STAY
	      ),
	      loading ? _react2['default'].createElement(
	        'p',
	        null,
	        messages.LOADING
	      ) : this.renderForm()
	    );
	  }
	});
	
	exports['default'] = QuoteModal;
	module.exports = exports['default'];

/***/ },
/* 774 */,
/* 775 */,
/* 776 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	var _reactAddons = __webpack_require__(40);
	
	var _reactAddons2 = _interopRequireDefault(_reactAddons);
	
	var _fluxxor = __webpack_require__(69);
	
	var _fluxxor2 = _interopRequireDefault(_fluxxor);
	
	var _ofsComponentsCommonIcon = __webpack_require__(51);
	
	var _ofsComponentsCommonIcon2 = _interopRequireDefault(_ofsComponentsCommonIcon);
	
	var _ofsI18n = __webpack_require__(61);
	
	var _ofsI18n2 = _interopRequireDefault(_ofsI18n);
	
	var _ofsUtilsBedSizeChartJsx = __webpack_require__(547);
	
	var _ofsUtilsBedSizeChartJsx2 = _interopRequireDefault(_ofsUtilsBedSizeChartJsx);
	
	var FluxMixin = _fluxxor2['default'].FluxMixin(_reactAddons2['default']);
	
	var gettext = _ofsI18n2['default'].gettext;
	
	var messages = {
	  BED_SIZE_LINK: gettext("Bed size chart"),
	  BED_SIZE_HEADER: gettext("Bed size chart")
	};
	
	var BedSizeChartModal = _reactAddons2['default'].createClass({
	  displayName: 'BedSizeChartModal',
	
	  mixins: [FluxMixin],
	
	  render: function render() {
	    return _reactAddons2['default'].createElement(
	      'div',
	      { className: 'bed-sizes-chart' },
	      _reactAddons2['default'].createElement(
	        'h1',
	        null,
	        messages.BED_SIZE_HEADER
	      ),
	      _reactAddons2['default'].createElement(
	        'div',
	        { className: 'bed-sizes-wrap' },
	        _reactAddons2['default'].createElement(_ofsUtilsBedSizeChartJsx2['default'], null)
	      )
	    );
	  }
	});
	
	var BedSizeChartLink = _reactAddons2['default'].createClass({
	  displayName: 'BedSizeChartLink',
	
	  mixins: [FluxMixin],
	
	  handleModalClick: function handleModalClick(event) {
	    this.getFlux().actions.layers.addModal(_reactAddons2['default'].createElement(BedSizeChartModal, null));
	  },
	
	  render: function render() {
	    return _reactAddons2['default'].createElement(
	      'div',
	      { className: 'mattress-sizes' },
	      _reactAddons2['default'].createElement(_ofsComponentsCommonIcon2['default'], { glyph: 'bedsize', size: 'small' }),
	      _reactAddons2['default'].createElement(
	        'a',
	        { href: 'javascript:;', onClick: this.handleModalClick },
	        _reactAddons2['default'].createElement(
	          'span',
	          { className: 'label' },
	          messages.BED_SIZE_LINK
	        )
	      )
	    );
	  }
	});
	
	module.exports = BedSizeChartLink;

/***/ },
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */
/***/ function(module, exports, __webpack_require__) {

	/* global ga */
	'use strict';
	
	var _interopRequireDefault = __webpack_require__(1)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.filtersToParams = filtersToParams;
	
	var _immutable = __webpack_require__(68);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _fluxxor = __webpack_require__(69);
	
	var _fluxxor2 = _interopRequireDefault(_fluxxor);
	
	var _URIjs = __webpack_require__(463);
	
	var _URIjs2 = _interopRequireDefault(_URIjs);
	
	var _ofsMoment = __webpack_require__(57);
	
	var _ofsMoment2 = _interopRequireDefault(_ofsMoment);
	
	function pushWithLimit(array, value) {
	  var limit = arguments.length <= 2 || arguments[2] === undefined ? 10 : arguments[2];
	
	  array.push(value);
	
	  if (array.length > limit) {
	    var diff = array.length - limit;
	    array.splice(0, diff);
	  }
	
	  return array;
	}
	
	function filtersToParams(filters) {
	  var filterMap = {
	    'city': function city(_city) {
	      return _city.get('region_id');
	    },
	    'currency': function currency(_currency) {
	      return _currency.get('iso_4217');
	    },
	    'region': function region(_region) {
	      return _region.get('id');
	    },
	    'folio': function folio(_folio) {
	      return _folio.get('slug');
	    },
	    'sleeps': function sleeps(_sleeps) {
	      return _sleeps === 0 ? null : _sleeps;
	    },
	    'bedrooms': function bedrooms(_bedrooms) {
	      return _bedrooms === 0 ? null : _bedrooms;
	    },
	    'promotion': function promotion(_promotion) {
	      return _promotion.get('slug');
	    },
	    'tags': function tags(_tags) {
	      return _tags.toArray();
	    }
	  };
	
	  var params = filters.reduce(function (result, value, filter) {
	    if (value !== null) {
	      if (typeof filterMap[filter] !== 'undefined') {
	        value = filterMap[filter](value);
	      }
	
	      // check again that the value is not null
	      if (value !== null) {
	        result = result.set(filter, value);
	      }
	    }
	    return result;
	  }, _immutable2['default'].Map());
	
	  return params;
	}
	
	var SearchStore = _fluxxor2['default'].createStore({
	  initialize: function initialize(options) {
	    this.bindActions('SEARCH_UPDATE_FILTERS', this.onUpdateFilters, 'SEARCH_UPDATE_FILTERS_SUCCESS', this.onUpdateFiltersSuccess, 'SEARCH_UPDATE_FILTERS_FAIL', this.onUpdateFiltersFail, 'SEARCH_CANCEL_HOME_SEARCH', this.onCancelHomeSearch, 'SEARCH_ADD_TAG', this.onAddTag, 'SEARCH_REMOVE_TAG', this.onRemoveTag);
	    this.state = _immutable2['default'].fromJS(options);
	
	    this.history = [];
	  },
	
	  getState: function getState() {
	    return this.state;
	  },
	
	  getContext: function getContext() {
	    return this.state.get('context');
	  },
	
	  onUpdateFilters: function onUpdateFilters(payload) {
	    var filters = this.getContext().get('filters').merge(_immutable2['default'].fromJS(payload));
	
	    // keep track of search history
	    pushWithLimit(this.history, this.state);
	
	    this.state = this.state.setIn(['context', 'filters'], filters).set('loading', true);
	
	    this.emit('change');
	  },
	
	  onUpdateFiltersSuccess: function onUpdateFiltersSuccess(payload) {
	    this.state = this.state.set('context', _immutable2['default'].fromJS(payload)).set('loading', false);
	
	    this.emit('change');
	
	    // send google search event
	    this.sendGoogleSearchEvent();
	  },
	
	  onUpdateFiltersFail: function onUpdateFiltersFail(error) {
	    throw error;
	  },
	
	  onCancelHomeSearch: function onCancelHomeSearch() {
	    // TODO check if previous search
	    this.state = this.state.setIn(['context', 'filters', 'title'], null).set('loading', 'true');
	
	    this.emit('change');
	  },
	
	  onAddTag: function onAddTag(tagId) {
	    var filters = this.state.getIn(['context', 'filters']);
	
	    var tags = filters.get('tags');
	    filters = filters.set('tags', tags.push(tagId)).merge(_immutable2['default'].Map({
	      'page': 1
	    }));
	
	    this.state = this.state.setIn(['context', 'filters'], filters).set('loading', true);
	
	    this.emit('change');
	  },
	
	  onRemoveTag: function onRemoveTag(tagId) {
	    var filters = this.state.getIn(['context', 'filters']);
	
	    var tags = filters.get('tags');
	    var tagIndex = tags.indexOf(tagId);
	    if (tagIndex > -1) {
	      tags = tags.remove(tagIndex);
	    }
	
	    filters = filters.set('tags', tags).merge(_immutable2['default'].Map({
	      'page': 1
	    }));
	
	    this.state = this.state.setIn(['context', 'filters'], filters).set('loading', true);
	
	    this.emit('change');
	  },
	
	  getParams: function getParams() {
	    var filters = this.getContext().get('filters');
	    return filtersToParams(filters).toJS();
	  },
	
	  sendGoogleSearchEvent: function sendGoogleSearchEvent() {
	    if (true) {
	      var params = this.getParams();
	      var filters = this.getContext().get('filters');
	      var results = this.getContext().get('results');
	      var today = (0, _ofsMoment2['default'])().format("DD/MM/YY");
	
	      var url = new _URIjs2['default'](window.location.origin + window.location.pathname).addQuery(params).addQuery({
	        'searched_at': today
	      });
	
	      if (filters.get('start_date') && filters.get('end_date')) {
	        var start = (0, _ofsMoment2['default'])(filters.get('start_date')).startOf('day');
	        var end = (0, _ofsMoment2['default'])(filters.get('end_date')).startOf('day');
	        var difference = Math.abs(start.diff(end, 'days'));
	        url.addQuery({ 'stay_length': difference });
	      }
	
	      /* eslint-disable no-empty */
	      try {
	        ga('set', 'dimension5', results.get('total').toString());
	        ga('send', 'event', 'Search', 'Performed', url.toString(), results.get('total'));
	      } catch (err) {}
	      /* eslint-enable no-empty */
	    }
	  }
	});
	
	exports['default'] = SearchStore;

/***/ },
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	
	exports.decode = exports.parse = __webpack_require__(__webpack_module_template_argument_0__);
	exports.encode = exports.stringify = __webpack_require__(__webpack_module_template_argument_1__);


/***/ }
/******/ ])));


/** WEBPACK FOOTER **
 ** common.js
 **/